var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};
var _clientConstructor, _http, _bus, _identity, _ls, _client, _twilioInitialized, _twilioConnectionState, _fcmToken, _typing, _me, _roster, _conversations, _fetchingParticipantDisplayName, _participantDisplayNamesCache, _rosterUpdateAbortController, _fetchAndCacheParticipantDisplayName, fetchAndCacheParticipantDisplayName_fn, _saveParticipantDisplayNameCache, saveParticipantDisplayNameCache_fn, _loadParticipantDisplayNameCache, loadParticipantDisplayNameCache_fn, _onIdentityLoggedIn, onIdentityLoggedIn_fn, _onIdentityLoggedOut, onIdentityLoggedOut_fn, _onServiceWorkerPush, onServiceWorkerPush_fn, _onRosterUpdated, onRosterUpdated_fn, _onTwilioInitialized, onTwilioInitialized_fn, _onTwilioInitFailed, onTwilioInitFailed_fn, _onTwilioConnectionError, onTwilioConnectionError_fn, _onTwilioConnectionStateChanged, onTwilioConnectionStateChanged_fn, _onTwilioConversationAdded, onTwilioConversationAdded_fn, _onTwilioConversationJoined, onTwilioConversationJoined_fn, _onTwilioConversationLeft, onTwilioConversationLeft_fn, _onTwilioConversationRemoved, onTwilioConversationRemoved_fn, _onTwilioConversationUpdated, onTwilioConversationUpdated_fn, _onTwilioMessageAdded, onTwilioMessageAdded_fn, _onTwilioMessageRemoved, onTwilioMessageRemoved_fn, _onTwilioMessageUpdated, onTwilioMessageUpdated_fn, _onTwilioParticipantJoined, onTwilioParticipantJoined_fn, _onTwilioParticipantLeft, onTwilioParticipantLeft_fn, _onTwilioParticipantUpdated, onTwilioParticipantUpdated_fn, _onTwilioPushNotification, onTwilioPushNotification_fn, _onTwilioTokenAboutToExpire, onTwilioTokenAboutToExpire_fn, _onTwilioTokenExpired, onTwilioTokenExpired_fn, _onTwilioTypingEnded, onTwilioTypingEnded_fn, _onTwilioTypingStarted, onTwilioTypingStarted_fn, _onTwilioUserSubscribed, onTwilioUserSubscribed_fn, _onTwilioUserUnsubscribed, onTwilioUserUnsubscribed_fn, _onTwilioUserUpdated, onTwilioUserUpdated_fn, _getCacheStorage, getCacheStorage_fn, _getRosterFromCache, getRosterFromCache_fn, _saveRosterToCache, saveRosterToCache_fn, _getRosterFromApi, getRosterFromApi_fn, _getConversationsFromSdk, getConversationsFromSdk_fn, _addConversation, addConversation_fn, _removeConversation, removeConversation_fn, _updateConversation, updateConversation_fn, _conversationToChecksum, conversationToChecksum_fn, _onPushFirebaseMessage, onPushFirebaseMessage_fn, _onAfterConversationsListUpdated, onAfterConversationsListUpdated_fn;
import { B as Buffer2 } from "./index-13be80af.mjs";
import { c as commonjsGlobal, a as getAugmentedNamespace } from "./_commonjsHelpers-ca272635.mjs";
import { shallowRef, computed, ref, watch, triggerRef, nextTick } from "vue";
import { g as getDebugger, d as debug } from "./_debug-8b5c3032.mjs";
import Joi from "joi";
import { D as DateTime, a as toChecksum, s as stringOr, t as toSubjectListString } from "./helpers-674591c1.mjs";
var browser$a = {};
var check = function(it) {
  return it && it.Math === Math && it;
};
var global$D = (
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == "object" && globalThis) || check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == "object" && self) || check(typeof commonjsGlobal == "object" && commonjsGlobal) || check(typeof commonjsGlobal == "object" && commonjsGlobal) || // eslint-disable-next-line no-new-func -- fallback
  function() {
    return this;
  }() || Function("return this")()
);
var objectGetOwnPropertyDescriptor = {};
var fails$M = function(exec2) {
  try {
    return !!exec2();
  } catch (error2) {
    return true;
  }
};
var fails$L = fails$M;
var descriptors = !fails$L(function() {
  return Object.defineProperty({}, 1, { get: function() {
    return 7;
  } })[1] !== 7;
});
var fails$K = fails$M;
var functionBindNative = !fails$K(function() {
  var test2 = (function() {
  }).bind();
  return typeof test2 != "function" || test2.hasOwnProperty("prototype");
});
var NATIVE_BIND$4 = functionBindNative;
var call$v = Function.prototype.call;
var functionCall = NATIVE_BIND$4 ? call$v.bind(call$v) : function() {
  return call$v.apply(call$v, arguments);
};
var objectPropertyIsEnumerable = {};
var $propertyIsEnumerable$2 = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor$5 = Object.getOwnPropertyDescriptor;
var NASHORN_BUG = getOwnPropertyDescriptor$5 && !$propertyIsEnumerable$2.call({ 1: 2 }, 1);
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$5(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable$2;
var createPropertyDescriptor$7 = function(bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value
  };
};
var NATIVE_BIND$3 = functionBindNative;
var FunctionPrototype$3 = Function.prototype;
var call$u = FunctionPrototype$3.call;
var uncurryThisWithBind = NATIVE_BIND$3 && FunctionPrototype$3.bind.bind(call$u, call$u);
var functionUncurryThis = NATIVE_BIND$3 ? uncurryThisWithBind : function(fn) {
  return function() {
    return call$u.apply(fn, arguments);
  };
};
var uncurryThis$L = functionUncurryThis;
var toString$i = uncurryThis$L({}.toString);
var stringSlice$b = uncurryThis$L("".slice);
var classofRaw$2 = function(it) {
  return stringSlice$b(toString$i(it), 8, -1);
};
var uncurryThis$K = functionUncurryThis;
var fails$J = fails$M;
var classof$h = classofRaw$2;
var $Object$4 = Object;
var split$3 = uncurryThis$K("".split);
var indexedObject = fails$J(function() {
  return !$Object$4("z").propertyIsEnumerable(0);
}) ? function(it) {
  return classof$h(it) === "String" ? split$3(it, "") : $Object$4(it);
} : $Object$4;
var isNullOrUndefined$b = function(it) {
  return it === null || it === void 0;
};
var isNullOrUndefined$a = isNullOrUndefined$b;
var $TypeError$j = TypeError;
var requireObjectCoercible$b = function(it) {
  if (isNullOrUndefined$a(it))
    throw new $TypeError$j("Can't call method on " + it);
  return it;
};
var IndexedObject$4 = indexedObject;
var requireObjectCoercible$a = requireObjectCoercible$b;
var toIndexedObject$e = function(it) {
  return IndexedObject$4(requireObjectCoercible$a(it));
};
var documentAll = typeof document == "object" && document.all;
var isCallable$t = typeof documentAll == "undefined" && documentAll !== void 0 ? function(argument) {
  return typeof argument == "function" || argument === documentAll;
} : function(argument) {
  return typeof argument == "function";
};
var isCallable$s = isCallable$t;
var isObject$q = function(it) {
  return typeof it == "object" ? it !== null : isCallable$s(it);
};
var global$C = global$D;
var isCallable$r = isCallable$t;
var aFunction = function(argument) {
  return isCallable$r(argument) ? argument : void 0;
};
var getBuiltIn$b = function(namespace, method) {
  return arguments.length < 2 ? aFunction(global$C[namespace]) : global$C[namespace] && global$C[namespace][method];
};
var uncurryThis$J = functionUncurryThis;
var objectIsPrototypeOf = uncurryThis$J({}.isPrototypeOf);
var engineUserAgent = typeof navigator != "undefined" && String(navigator.userAgent) || "";
var global$B = global$D;
var userAgent$5 = engineUserAgent;
var process$3 = global$B.process;
var Deno$1 = global$B.Deno;
var versions = process$3 && process$3.versions || Deno$1 && Deno$1.version;
var v8 = versions && versions.v8;
var match, version$1;
if (v8) {
  match = v8.split(".");
  version$1 = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}
if (!version$1 && userAgent$5) {
  match = userAgent$5.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent$5.match(/Chrome\/(\d+)/);
    if (match)
      version$1 = +match[1];
  }
}
var engineV8Version = version$1;
var V8_VERSION$3 = engineV8Version;
var fails$I = fails$M;
var global$A = global$D;
var $String$6 = global$A.String;
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$I(function() {
  var symbol = Symbol("symbol detection");
  return !$String$6(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && V8_VERSION$3 && V8_VERSION$3 < 41;
});
var NATIVE_SYMBOL$6 = symbolConstructorDetection;
var useSymbolAsUid = NATIVE_SYMBOL$6 && !Symbol.sham && typeof Symbol.iterator == "symbol";
var getBuiltIn$a = getBuiltIn$b;
var isCallable$q = isCallable$t;
var isPrototypeOf$8 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;
var $Object$3 = Object;
var isSymbol$6 = USE_SYMBOL_AS_UID$1 ? function(it) {
  return typeof it == "symbol";
} : function(it) {
  var $Symbol2 = getBuiltIn$a("Symbol");
  return isCallable$q($Symbol2) && isPrototypeOf$8($Symbol2.prototype, $Object$3(it));
};
var $String$5 = String;
var tryToString$7 = function(argument) {
  try {
    return $String$5(argument);
  } catch (error2) {
    return "Object";
  }
};
var isCallable$p = isCallable$t;
var tryToString$6 = tryToString$7;
var $TypeError$i = TypeError;
var aCallable$c = function(argument) {
  if (isCallable$p(argument))
    return argument;
  throw new $TypeError$i(tryToString$6(argument) + " is not a function");
};
var aCallable$b = aCallable$c;
var isNullOrUndefined$9 = isNullOrUndefined$b;
var getMethod$7 = function(V, P) {
  var func = V[P];
  return isNullOrUndefined$9(func) ? void 0 : aCallable$b(func);
};
var call$t = functionCall;
var isCallable$o = isCallable$t;
var isObject$p = isObject$q;
var $TypeError$h = TypeError;
var ordinaryToPrimitive$1 = function(input, pref) {
  var fn, val;
  if (pref === "string" && isCallable$o(fn = input.toString) && !isObject$p(val = call$t(fn, input)))
    return val;
  if (isCallable$o(fn = input.valueOf) && !isObject$p(val = call$t(fn, input)))
    return val;
  if (pref !== "string" && isCallable$o(fn = input.toString) && !isObject$p(val = call$t(fn, input)))
    return val;
  throw new $TypeError$h("Can't convert object to primitive value");
};
var sharedStore = { exports: {} };
var isPure = false;
var global$z = global$D;
var defineProperty$a = Object.defineProperty;
var defineGlobalProperty$3 = function(key, value) {
  try {
    defineProperty$a(global$z, key, { value, configurable: true, writable: true });
  } catch (error2) {
    global$z[key] = value;
  }
  return value;
};
sharedStore.exports;
var IS_PURE$b = isPure;
var globalThis$1 = global$D;
var defineGlobalProperty$2 = defineGlobalProperty$3;
var SHARED = "__core-js_shared__";
var store$3 = sharedStore.exports = globalThis$1[SHARED] || defineGlobalProperty$2(SHARED, {});
(store$3.versions || (store$3.versions = [])).push({
  version: "3.37.1",
  mode: IS_PURE$b ? "pure" : "global",
  copyright: "© 2014-2024 Denis Pushkarev (zloirock.ru)",
  license: "https://github.com/zloirock/core-js/blob/v3.37.1/LICENSE",
  source: "https://github.com/zloirock/core-js"
});
var sharedStoreExports = sharedStore.exports;
var store$2 = sharedStoreExports;
var shared$7 = function(key, value) {
  return store$2[key] || (store$2[key] = value || {});
};
var requireObjectCoercible$9 = requireObjectCoercible$b;
var $Object$2 = Object;
var toObject$f = function(argument) {
  return $Object$2(requireObjectCoercible$9(argument));
};
var uncurryThis$I = functionUncurryThis;
var toObject$e = toObject$f;
var hasOwnProperty = uncurryThis$I({}.hasOwnProperty);
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$e(it), key);
};
var uncurryThis$H = functionUncurryThis;
var id$2 = 0;
var postfix = Math.random();
var toString$h = uncurryThis$H(1 .toString);
var uid$5 = function(key) {
  return "Symbol(" + (key === void 0 ? "" : key) + ")_" + toString$h(++id$2 + postfix, 36);
};
var global$y = global$D;
var shared$6 = shared$7;
var hasOwn$n = hasOwnProperty_1;
var uid$4 = uid$5;
var NATIVE_SYMBOL$5 = symbolConstructorDetection;
var USE_SYMBOL_AS_UID = useSymbolAsUid;
var Symbol$1 = global$y.Symbol;
var WellKnownSymbolsStore$1 = shared$6("wks");
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1["for"] || Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$4;
var wellKnownSymbol$t = function(name) {
  if (!hasOwn$n(WellKnownSymbolsStore$1, name)) {
    WellKnownSymbolsStore$1[name] = NATIVE_SYMBOL$5 && hasOwn$n(Symbol$1, name) ? Symbol$1[name] : createWellKnownSymbol("Symbol." + name);
  }
  return WellKnownSymbolsStore$1[name];
};
var call$s = functionCall;
var isObject$o = isObject$q;
var isSymbol$5 = isSymbol$6;
var getMethod$6 = getMethod$7;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$s = wellKnownSymbol$t;
var $TypeError$g = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$s("toPrimitive");
var toPrimitive$4 = function(input, pref) {
  if (!isObject$o(input) || isSymbol$5(input))
    return input;
  var exoticToPrim = getMethod$6(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === void 0)
      pref = "default";
    result = call$s(exoticToPrim, input, pref);
    if (!isObject$o(result) || isSymbol$5(result))
      return result;
    throw new $TypeError$g("Can't convert object to primitive value");
  }
  if (pref === void 0)
    pref = "number";
  return ordinaryToPrimitive(input, pref);
};
var toPrimitive$3 = toPrimitive$4;
var isSymbol$4 = isSymbol$6;
var toPropertyKey$5 = function(argument) {
  var key = toPrimitive$3(argument, "string");
  return isSymbol$4(key) ? key : key + "";
};
var global$x = global$D;
var isObject$n = isObject$q;
var document$3 = global$x.document;
var EXISTS$1 = isObject$n(document$3) && isObject$n(document$3.createElement);
var documentCreateElement$2 = function(it) {
  return EXISTS$1 ? document$3.createElement(it) : {};
};
var DESCRIPTORS$r = descriptors;
var fails$H = fails$M;
var createElement$1 = documentCreateElement$2;
var ie8DomDefine = !DESCRIPTORS$r && !fails$H(function() {
  return Object.defineProperty(createElement$1("div"), "a", {
    get: function() {
      return 7;
    }
  }).a !== 7;
});
var DESCRIPTORS$q = descriptors;
var call$r = functionCall;
var propertyIsEnumerableModule$2 = objectPropertyIsEnumerable;
var createPropertyDescriptor$6 = createPropertyDescriptor$7;
var toIndexedObject$d = toIndexedObject$e;
var toPropertyKey$4 = toPropertyKey$5;
var hasOwn$m = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;
var $getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$q ? $getOwnPropertyDescriptor$2 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$d(O);
  P = toPropertyKey$4(P);
  if (IE8_DOM_DEFINE$1)
    try {
      return $getOwnPropertyDescriptor$2(O, P);
    } catch (error2) {
    }
  if (hasOwn$m(O, P))
    return createPropertyDescriptor$6(!call$r(propertyIsEnumerableModule$2.f, O, P), O[P]);
};
var objectDefineProperty = {};
var DESCRIPTORS$p = descriptors;
var fails$G = fails$M;
var v8PrototypeDefineBug = DESCRIPTORS$p && fails$G(function() {
  return Object.defineProperty(function() {
  }, "prototype", {
    value: 42,
    writable: false
  }).prototype !== 42;
});
var isObject$m = isObject$q;
var $String$4 = String;
var $TypeError$f = TypeError;
var anObject$m = function(argument) {
  if (isObject$m(argument))
    return argument;
  throw new $TypeError$f($String$4(argument) + " is not an object");
};
var DESCRIPTORS$o = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$l = anObject$m;
var toPropertyKey$3 = toPropertyKey$5;
var $TypeError$e = TypeError;
var $defineProperty$1 = Object.defineProperty;
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
var ENUMERABLE = "enumerable";
var CONFIGURABLE$1 = "configurable";
var WRITABLE = "writable";
objectDefineProperty.f = DESCRIPTORS$o ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$l(O);
  P = toPropertyKey$3(P);
  anObject$l(Attributes);
  if (typeof O === "function" && P === "prototype" && "value" in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor$1(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  }
  return $defineProperty$1(O, P, Attributes);
} : $defineProperty$1 : function defineProperty2(O, P, Attributes) {
  anObject$l(O);
  P = toPropertyKey$3(P);
  anObject$l(Attributes);
  if (IE8_DOM_DEFINE)
    try {
      return $defineProperty$1(O, P, Attributes);
    } catch (error2) {
    }
  if ("get" in Attributes || "set" in Attributes)
    throw new $TypeError$e("Accessors not supported");
  if ("value" in Attributes)
    O[P] = Attributes.value;
  return O;
};
var DESCRIPTORS$n = descriptors;
var definePropertyModule$6 = objectDefineProperty;
var createPropertyDescriptor$5 = createPropertyDescriptor$7;
var createNonEnumerableProperty$9 = DESCRIPTORS$n ? function(object, key, value) {
  return definePropertyModule$6.f(object, key, createPropertyDescriptor$5(1, value));
} : function(object, key, value) {
  object[key] = value;
  return object;
};
var makeBuiltIn$3 = { exports: {} };
var DESCRIPTORS$m = descriptors;
var hasOwn$l = hasOwnProperty_1;
var FunctionPrototype$2 = Function.prototype;
var getDescriptor = DESCRIPTORS$m && Object.getOwnPropertyDescriptor;
var EXISTS = hasOwn$l(FunctionPrototype$2, "name");
var PROPER = EXISTS && (function something() {
}).name === "something";
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$m || DESCRIPTORS$m && getDescriptor(FunctionPrototype$2, "name").configurable);
var functionName = {
  EXISTS,
  PROPER,
  CONFIGURABLE
};
var uncurryThis$G = functionUncurryThis;
var isCallable$n = isCallable$t;
var store$1 = sharedStoreExports;
var functionToString$1 = uncurryThis$G(Function.toString);
if (!isCallable$n(store$1.inspectSource)) {
  store$1.inspectSource = function(it) {
    return functionToString$1(it);
  };
}
var inspectSource$3 = store$1.inspectSource;
var global$w = global$D;
var isCallable$m = isCallable$t;
var WeakMap$1 = global$w.WeakMap;
var weakMapBasicDetection = isCallable$m(WeakMap$1) && /native code/.test(String(WeakMap$1));
var shared$5 = shared$7;
var uid$3 = uid$5;
var keys = shared$5("keys");
var sharedKey$4 = function(key) {
  return keys[key] || (keys[key] = uid$3(key));
};
var hiddenKeys$6 = {};
var NATIVE_WEAK_MAP = weakMapBasicDetection;
var global$v = global$D;
var isObject$l = isObject$q;
var createNonEnumerableProperty$8 = createNonEnumerableProperty$9;
var hasOwn$k = hasOwnProperty_1;
var shared$4 = sharedStoreExports;
var sharedKey$3 = sharedKey$4;
var hiddenKeys$5 = hiddenKeys$6;
var OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var TypeError$7 = global$v.TypeError;
var WeakMap2 = global$v.WeakMap;
var set$2, get$2, has;
var enforce = function(it) {
  return has(it) ? get$2(it) : set$2(it, {});
};
var getterFor = function(TYPE) {
  return function(it) {
    var state;
    if (!isObject$l(it) || (state = get$2(it)).type !== TYPE) {
      throw new TypeError$7("Incompatible receiver, " + TYPE + " required");
    }
    return state;
  };
};
if (NATIVE_WEAK_MAP || shared$4.state) {
  var store = shared$4.state || (shared$4.state = new WeakMap2());
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  set$2 = function(it, metadata) {
    if (store.has(it))
      throw new TypeError$7(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get$2 = function(it) {
    return store.get(it) || {};
  };
  has = function(it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey$3("state");
  hiddenKeys$5[STATE] = true;
  set$2 = function(it, metadata) {
    if (hasOwn$k(it, STATE))
      throw new TypeError$7(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$8(it, STATE, metadata);
    return metadata;
  };
  get$2 = function(it) {
    return hasOwn$k(it, STATE) ? it[STATE] : {};
  };
  has = function(it) {
    return hasOwn$k(it, STATE);
  };
}
var internalState = {
  set: set$2,
  get: get$2,
  has,
  enforce,
  getterFor
};
makeBuiltIn$3.exports;
var uncurryThis$F = functionUncurryThis;
var fails$F = fails$M;
var isCallable$l = isCallable$t;
var hasOwn$j = hasOwnProperty_1;
var DESCRIPTORS$l = descriptors;
var CONFIGURABLE_FUNCTION_NAME$2 = functionName.CONFIGURABLE;
var inspectSource$2 = inspectSource$3;
var InternalStateModule$b = internalState;
var enforceInternalState$2 = InternalStateModule$b.enforce;
var getInternalState$6 = InternalStateModule$b.get;
var $String$3 = String;
var defineProperty$9 = Object.defineProperty;
var stringSlice$a = uncurryThis$F("".slice);
var replace$8 = uncurryThis$F("".replace);
var join$5 = uncurryThis$F([].join);
var CONFIGURABLE_LENGTH = DESCRIPTORS$l && !fails$F(function() {
  return defineProperty$9(function() {
  }, "length", { value: 8 }).length !== 8;
});
var TEMPLATE = String(String).split("String");
var makeBuiltIn$2 = makeBuiltIn$3.exports = function(value, name, options) {
  if (stringSlice$a($String$3(name), 0, 7) === "Symbol(") {
    name = "[" + replace$8($String$3(name), /^Symbol\(([^)]*)\).*$/, "$1") + "]";
  }
  if (options && options.getter)
    name = "get " + name;
  if (options && options.setter)
    name = "set " + name;
  if (!hasOwn$j(value, "name") || CONFIGURABLE_FUNCTION_NAME$2 && value.name !== name) {
    if (DESCRIPTORS$l)
      defineProperty$9(value, "name", { value: name, configurable: true });
    else
      value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$j(options, "arity") && value.length !== options.arity) {
    defineProperty$9(value, "length", { value: options.arity });
  }
  try {
    if (options && hasOwn$j(options, "constructor") && options.constructor) {
      if (DESCRIPTORS$l)
        defineProperty$9(value, "prototype", { writable: false });
    } else if (value.prototype)
      value.prototype = void 0;
  } catch (error2) {
  }
  var state = enforceInternalState$2(value);
  if (!hasOwn$j(state, "source")) {
    state.source = join$5(TEMPLATE, typeof name == "string" ? name : "");
  }
  return value;
};
Function.prototype.toString = makeBuiltIn$2(function toString() {
  return isCallable$l(this) && getInternalState$6(this).source || inspectSource$2(this);
}, "toString");
var makeBuiltInExports = makeBuiltIn$3.exports;
var isCallable$k = isCallable$t;
var definePropertyModule$5 = objectDefineProperty;
var makeBuiltIn$1 = makeBuiltInExports;
var defineGlobalProperty$1 = defineGlobalProperty$3;
var defineBuiltIn$f = function(O, key, value, options) {
  if (!options)
    options = {};
  var simple = options.enumerable;
  var name = options.name !== void 0 ? options.name : key;
  if (isCallable$k(value))
    makeBuiltIn$1(value, name, options);
  if (options.global) {
    if (simple)
      O[key] = value;
    else
      defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe)
        delete O[key];
      else if (O[key])
        simple = true;
    } catch (error2) {
    }
    if (simple)
      O[key] = value;
    else
      definePropertyModule$5.f(O, key, {
        value,
        enumerable: false,
        configurable: !options.nonConfigurable,
        writable: !options.nonWritable
      });
  }
  return O;
};
var objectGetOwnPropertyNames = {};
var ceil = Math.ceil;
var floor$7 = Math.floor;
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor$7 : ceil)(n);
};
var trunc2 = mathTrunc;
var toIntegerOrInfinity$a = function(argument) {
  var number = +argument;
  return number !== number || number === 0 ? 0 : trunc2(number);
};
var toIntegerOrInfinity$9 = toIntegerOrInfinity$a;
var max$3 = Math.max;
var min$7 = Math.min;
var toAbsoluteIndex$6 = function(index2, length) {
  var integer = toIntegerOrInfinity$9(index2);
  return integer < 0 ? max$3(integer + length, 0) : min$7(integer, length);
};
var toIntegerOrInfinity$8 = toIntegerOrInfinity$a;
var min$6 = Math.min;
var toLength$9 = function(argument) {
  var len = toIntegerOrInfinity$8(argument);
  return len > 0 ? min$6(len, 9007199254740991) : 0;
};
var toLength$8 = toLength$9;
var lengthOfArrayLike$g = function(obj) {
  return toLength$8(obj.length);
};
var toIndexedObject$c = toIndexedObject$e;
var toAbsoluteIndex$5 = toAbsoluteIndex$6;
var lengthOfArrayLike$f = lengthOfArrayLike$g;
var createMethod$5 = function(IS_INCLUDES) {
  return function($this, el, fromIndex) {
    var O = toIndexedObject$c($this);
    var length = lengthOfArrayLike$f(O);
    if (length === 0)
      return !IS_INCLUDES && -1;
    var index2 = toAbsoluteIndex$5(fromIndex, length);
    var value;
    if (IS_INCLUDES && el !== el)
      while (length > index2) {
        value = O[index2++];
        if (value !== value)
          return true;
      }
    else
      for (; length > index2; index2++) {
        if ((IS_INCLUDES || index2 in O) && O[index2] === el)
          return IS_INCLUDES || index2 || 0;
      }
    return !IS_INCLUDES && -1;
  };
};
var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$5(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$5(false)
};
var uncurryThis$E = functionUncurryThis;
var hasOwn$i = hasOwnProperty_1;
var toIndexedObject$b = toIndexedObject$e;
var indexOf$1 = arrayIncludes.indexOf;
var hiddenKeys$4 = hiddenKeys$6;
var push$b = uncurryThis$E([].push);
var objectKeysInternal = function(object, names) {
  var O = toIndexedObject$b(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O)
    !hasOwn$i(hiddenKeys$4, key) && hasOwn$i(O, key) && push$b(result, key);
  while (names.length > i)
    if (hasOwn$i(O, key = names[i++])) {
      ~indexOf$1(result, key) || push$b(result, key);
    }
  return result;
};
var enumBugKeys$3 = [
  "constructor",
  "hasOwnProperty",
  "isPrototypeOf",
  "propertyIsEnumerable",
  "toLocaleString",
  "toString",
  "valueOf"
];
var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;
var hiddenKeys$3 = enumBugKeys$2.concat("length", "prototype");
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$3);
};
var objectGetOwnPropertySymbols = {};
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;
var getBuiltIn$9 = getBuiltIn$b;
var uncurryThis$D = functionUncurryThis;
var getOwnPropertyNamesModule$2 = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$3 = objectGetOwnPropertySymbols;
var anObject$k = anObject$m;
var concat$3 = uncurryThis$D([].concat);
var ownKeys$3 = getBuiltIn$9("Reflect", "ownKeys") || function ownKeys(it) {
  var keys6 = getOwnPropertyNamesModule$2.f(anObject$k(it));
  var getOwnPropertySymbols2 = getOwnPropertySymbolsModule$3.f;
  return getOwnPropertySymbols2 ? concat$3(keys6, getOwnPropertySymbols2(it)) : keys6;
};
var hasOwn$h = hasOwnProperty_1;
var ownKeys$2 = ownKeys$3;
var getOwnPropertyDescriptorModule$3 = objectGetOwnPropertyDescriptor;
var definePropertyModule$4 = objectDefineProperty;
var copyConstructorProperties$4 = function(target, source, exceptions) {
  var keys6 = ownKeys$2(source);
  var defineProperty6 = definePropertyModule$4.f;
  var getOwnPropertyDescriptor6 = getOwnPropertyDescriptorModule$3.f;
  for (var i = 0; i < keys6.length; i++) {
    var key = keys6[i];
    if (!hasOwn$h(target, key) && !(exceptions && hasOwn$h(exceptions, key))) {
      defineProperty6(target, key, getOwnPropertyDescriptor6(source, key));
    }
  }
};
var fails$E = fails$M;
var isCallable$j = isCallable$t;
var replacement = /#|\.prototype\./;
var isForced$4 = function(feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true : value === NATIVE ? false : isCallable$j(detection) ? fails$E(detection) : !!detection;
};
var normalize = isForced$4.normalize = function(string) {
  return String(string).replace(replacement, ".").toLowerCase();
};
var data = isForced$4.data = {};
var NATIVE = isForced$4.NATIVE = "N";
var POLYFILL = isForced$4.POLYFILL = "P";
var isForced_1 = isForced$4;
var global$u = global$D;
var getOwnPropertyDescriptor$4 = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$7 = createNonEnumerableProperty$9;
var defineBuiltIn$e = defineBuiltIn$f;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties$3 = copyConstructorProperties$4;
var isForced$3 = isForced_1;
var _export = function(options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED2, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$u;
  } else if (STATIC) {
    target = global$u[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = global$u[TARGET] && global$u[TARGET].prototype;
  }
  if (target)
    for (key in source) {
      sourceProperty = source[key];
      if (options.dontCallGetSet) {
        descriptor = getOwnPropertyDescriptor$4(target, key);
        targetProperty = descriptor && descriptor.value;
      } else
        targetProperty = target[key];
      FORCED2 = isForced$3(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
      if (!FORCED2 && targetProperty !== void 0) {
        if (typeof sourceProperty == typeof targetProperty)
          continue;
        copyConstructorProperties$3(sourceProperty, targetProperty);
      }
      if (options.sham || targetProperty && targetProperty.sham) {
        createNonEnumerableProperty$7(sourceProperty, "sham", true);
      }
      defineBuiltIn$e(target, key, sourceProperty, options);
    }
};
var defineProperty$8 = objectDefineProperty.f;
var hasOwn$g = hasOwnProperty_1;
var wellKnownSymbol$r = wellKnownSymbol$t;
var TO_STRING_TAG$3 = wellKnownSymbol$r("toStringTag");
var setToStringTag$a = function(target, TAG, STATIC) {
  if (target && !STATIC)
    target = target.prototype;
  if (target && !hasOwn$g(target, TO_STRING_TAG$3)) {
    defineProperty$8(target, TO_STRING_TAG$3, { configurable: true, value: TAG });
  }
};
var $$G = _export;
var global$t = global$D;
var setToStringTag$9 = setToStringTag$a;
$$G({ global: true }, { Reflect: {} });
setToStringTag$9(global$t.Reflect, "Reflect", true);
var NATIVE_BIND$2 = functionBindNative;
var FunctionPrototype$1 = Function.prototype;
var apply$7 = FunctionPrototype$1.apply;
var call$q = FunctionPrototype$1.call;
var functionApply = typeof Reflect == "object" && Reflect.apply || (NATIVE_BIND$2 ? call$q.bind(apply$7) : function() {
  return call$q.apply(apply$7, arguments);
});
var uncurryThis$C = functionUncurryThis;
var arraySlice$9 = uncurryThis$C([].slice);
var uncurryThis$B = functionUncurryThis;
var aCallable$a = aCallable$c;
var isObject$k = isObject$q;
var hasOwn$f = hasOwnProperty_1;
var arraySlice$8 = arraySlice$9;
var NATIVE_BIND$1 = functionBindNative;
var $Function = Function;
var concat$2 = uncurryThis$B([].concat);
var join$4 = uncurryThis$B([].join);
var factories = {};
var construct$2 = function(C, argsLength, args) {
  if (!hasOwn$f(factories, argsLength)) {
    var list = [];
    var i = 0;
    for (; i < argsLength; i++)
      list[i] = "a[" + i + "]";
    factories[argsLength] = $Function("C,a", "return new C(" + join$4(list, ",") + ")");
  }
  return factories[argsLength](C, args);
};
var functionBind = NATIVE_BIND$1 ? $Function.bind : function bind(that) {
  var F = aCallable$a(this);
  var Prototype2 = F.prototype;
  var partArgs = arraySlice$8(arguments, 1);
  var boundFunction = function bound() {
    var args = concat$2(partArgs, arraySlice$8(arguments));
    return this instanceof boundFunction ? construct$2(F, args.length, args) : F.apply(that, args);
  };
  if (isObject$k(Prototype2))
    boundFunction.prototype = Prototype2;
  return boundFunction;
};
var wellKnownSymbol$q = wellKnownSymbol$t;
var TO_STRING_TAG$2 = wellKnownSymbol$q("toStringTag");
var test$1 = {};
test$1[TO_STRING_TAG$2] = "z";
var toStringTagSupport = String(test$1) === "[object z]";
var TO_STRING_TAG_SUPPORT$2 = toStringTagSupport;
var isCallable$i = isCallable$t;
var classofRaw$1 = classofRaw$2;
var wellKnownSymbol$p = wellKnownSymbol$t;
var TO_STRING_TAG$1 = wellKnownSymbol$p("toStringTag");
var $Object$1 = Object;
var CORRECT_ARGUMENTS = classofRaw$1(function() {
  return arguments;
}()) === "Arguments";
var tryGet = function(it, key) {
  try {
    return it[key];
  } catch (error2) {
  }
};
var classof$g = TO_STRING_TAG_SUPPORT$2 ? classofRaw$1 : function(it) {
  var O, tag, result;
  return it === void 0 ? "Undefined" : it === null ? "Null" : typeof (tag = tryGet(O = $Object$1(it), TO_STRING_TAG$1)) == "string" ? tag : CORRECT_ARGUMENTS ? classofRaw$1(O) : (result = classofRaw$1(O)) === "Object" && isCallable$i(O.callee) ? "Arguments" : result;
};
var uncurryThis$A = functionUncurryThis;
var fails$D = fails$M;
var isCallable$h = isCallable$t;
var classof$f = classof$g;
var getBuiltIn$8 = getBuiltIn$b;
var inspectSource$1 = inspectSource$3;
var noop = function() {
};
var construct$1 = getBuiltIn$8("Reflect", "construct");
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec$4 = uncurryThis$A(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.test(noop);
var isConstructorModern = function isConstructor(argument) {
  if (!isCallable$h(argument))
    return false;
  try {
    construct$1(noop, [], argument);
    return true;
  } catch (error2) {
    return false;
  }
};
var isConstructorLegacy = function isConstructor2(argument) {
  if (!isCallable$h(argument))
    return false;
  switch (classof$f(argument)) {
    case "AsyncFunction":
    case "GeneratorFunction":
    case "AsyncGeneratorFunction":
      return false;
  }
  try {
    return INCORRECT_TO_STRING || !!exec$4(constructorRegExp, inspectSource$1(argument));
  } catch (error2) {
    return true;
  }
};
isConstructorLegacy.sham = true;
var isConstructor$4 = !construct$1 || fails$D(function() {
  var called;
  return isConstructorModern(isConstructorModern.call) || !isConstructorModern(Object) || !isConstructorModern(function() {
    called = true;
  }) || called;
}) ? isConstructorLegacy : isConstructorModern;
var isConstructor$3 = isConstructor$4;
var tryToString$5 = tryToString$7;
var $TypeError$d = TypeError;
var aConstructor$3 = function(argument) {
  if (isConstructor$3(argument))
    return argument;
  throw new $TypeError$d(tryToString$5(argument) + " is not a constructor");
};
var objectDefineProperties = {};
var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;
var objectKeys$4 = Object.keys || function keys2(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};
var DESCRIPTORS$k = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule$3 = objectDefineProperty;
var anObject$j = anObject$m;
var toIndexedObject$a = toIndexedObject$e;
var objectKeys$3 = objectKeys$4;
objectDefineProperties.f = DESCRIPTORS$k && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$j(O);
  var props = toIndexedObject$a(Properties);
  var keys6 = objectKeys$3(Properties);
  var length = keys6.length;
  var index2 = 0;
  var key;
  while (length > index2)
    definePropertyModule$3.f(O, key = keys6[index2++], props[key]);
  return O;
};
var getBuiltIn$7 = getBuiltIn$b;
var html$2 = getBuiltIn$7("document", "documentElement");
var anObject$i = anObject$m;
var definePropertiesModule$1 = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys$2 = hiddenKeys$6;
var html$1 = html$2;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$2 = sharedKey$4;
var GT = ">";
var LT = "<";
var PROTOTYPE$2 = "prototype";
var SCRIPT = "script";
var IE_PROTO$1 = sharedKey$2("IE_PROTO");
var EmptyConstructor = function() {
};
var scriptTag = function(content) {
  return LT + SCRIPT + GT + content + LT + "/" + SCRIPT + GT;
};
var NullProtoObjectViaActiveX = function(activeXDocument2) {
  activeXDocument2.write(scriptTag(""));
  activeXDocument2.close();
  var temp = activeXDocument2.parentWindow.Object;
  activeXDocument2 = null;
  return temp;
};
var NullProtoObjectViaIFrame = function() {
  var iframe = documentCreateElement$1("iframe");
  var JS = "java" + SCRIPT + ":";
  var iframeDocument;
  iframe.style.display = "none";
  html$1.appendChild(iframe);
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag("document.F=Object"));
  iframeDocument.close();
  return iframeDocument.F;
};
var activeXDocument;
var NullProtoObject = function() {
  try {
    activeXDocument = new ActiveXObject("htmlfile");
  } catch (error2) {
  }
  NullProtoObject = typeof document != "undefined" ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame() : NullProtoObjectViaActiveX(activeXDocument);
  var length = enumBugKeys.length;
  while (length--)
    delete NullProtoObject[PROTOTYPE$2][enumBugKeys[length]];
  return NullProtoObject();
};
hiddenKeys$2[IE_PROTO$1] = true;
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE$2] = anObject$i(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE$2] = null;
    result[IE_PROTO$1] = O;
  } else
    result = NullProtoObject();
  return Properties === void 0 ? result : definePropertiesModule$1.f(result, Properties);
};
var $$F = _export;
var getBuiltIn$6 = getBuiltIn$b;
var apply$6 = functionApply;
var bind$b = functionBind;
var aConstructor$2 = aConstructor$3;
var anObject$h = anObject$m;
var isObject$j = isObject$q;
var create$7 = objectCreate;
var fails$C = fails$M;
var nativeConstruct = getBuiltIn$6("Reflect", "construct");
var ObjectPrototype$4 = Object.prototype;
var push$a = [].push;
var NEW_TARGET_BUG = fails$C(function() {
  function F() {
  }
  return !(nativeConstruct(function() {
  }, [], F) instanceof F);
});
var ARGS_BUG = !fails$C(function() {
  nativeConstruct(function() {
  });
});
var FORCED$9 = NEW_TARGET_BUG || ARGS_BUG;
$$F({ target: "Reflect", stat: true, forced: FORCED$9, sham: FORCED$9 }, {
  construct: function construct(Target, args) {
    aConstructor$2(Target);
    anObject$h(args);
    var newTarget = arguments.length < 3 ? Target : aConstructor$2(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG)
      return nativeConstruct(Target, args, newTarget);
    if (Target === newTarget) {
      switch (args.length) {
        case 0:
          return new Target();
        case 1:
          return new Target(args[0]);
        case 2:
          return new Target(args[0], args[1]);
        case 3:
          return new Target(args[0], args[1], args[2]);
        case 4:
          return new Target(args[0], args[1], args[2], args[3]);
      }
      var $args = [null];
      apply$6(push$a, $args, args);
      return new (apply$6(bind$b, Target, $args))();
    }
    var proto = newTarget.prototype;
    var instance2 = create$7(isObject$j(proto) ? proto : ObjectPrototype$4);
    var result = apply$6(Target, instance2, args);
    return isObject$j(result) ? result : instance2;
  }
});
var $$E = _export;
var toObject$d = toObject$f;
var nativeKeys = objectKeys$4;
var fails$B = fails$M;
var FAILS_ON_PRIMITIVES$2 = fails$B(function() {
  nativeKeys(1);
});
$$E({ target: "Object", stat: true, forced: FAILS_ON_PRIMITIVES$2 }, {
  keys: function keys3(it) {
    return nativeKeys(toObject$d(it));
  }
});
var classof$e = classof$g;
var $String$2 = String;
var toString$g = function(argument) {
  if (classof$e(argument) === "Symbol")
    throw new TypeError("Cannot convert a Symbol value to a string");
  return $String$2(argument);
};
var objectGetOwnPropertyNamesExternal = {};
var classof$d = classofRaw$2;
var toIndexedObject$9 = toIndexedObject$e;
var $getOwnPropertyNames$1 = objectGetOwnPropertyNames.f;
var arraySlice$7 = arraySlice$9;
var windowNames = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var getWindowNames = function(it) {
  try {
    return $getOwnPropertyNames$1(it);
  } catch (error2) {
    return arraySlice$7(windowNames);
  }
};
objectGetOwnPropertyNamesExternal.f = function getOwnPropertyNames2(it) {
  return windowNames && classof$d(it) === "Window" ? getWindowNames(it) : $getOwnPropertyNames$1(toIndexedObject$9(it));
};
var makeBuiltIn = makeBuiltInExports;
var defineProperty$7 = objectDefineProperty;
var defineBuiltInAccessor$a = function(target, name, descriptor) {
  if (descriptor.get)
    makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set)
    makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty$7.f(target, name, descriptor);
};
var wellKnownSymbolWrapped = {};
var wellKnownSymbol$o = wellKnownSymbol$t;
wellKnownSymbolWrapped.f = wellKnownSymbol$o;
var global$s = global$D;
var path$2 = global$s;
var path$1 = path$2;
var hasOwn$e = hasOwnProperty_1;
var wrappedWellKnownSymbolModule$1 = wellKnownSymbolWrapped;
var defineProperty$6 = objectDefineProperty.f;
var wellKnownSymbolDefine = function(NAME2) {
  var Symbol2 = path$1.Symbol || (path$1.Symbol = {});
  if (!hasOwn$e(Symbol2, NAME2))
    defineProperty$6(Symbol2, NAME2, {
      value: wrappedWellKnownSymbolModule$1.f(NAME2)
    });
};
var call$p = functionCall;
var getBuiltIn$5 = getBuiltIn$b;
var wellKnownSymbol$n = wellKnownSymbol$t;
var defineBuiltIn$d = defineBuiltIn$f;
var symbolDefineToPrimitive = function() {
  var Symbol2 = getBuiltIn$5("Symbol");
  var SymbolPrototype2 = Symbol2 && Symbol2.prototype;
  var valueOf = SymbolPrototype2 && SymbolPrototype2.valueOf;
  var TO_PRIMITIVE2 = wellKnownSymbol$n("toPrimitive");
  if (SymbolPrototype2 && !SymbolPrototype2[TO_PRIMITIVE2]) {
    defineBuiltIn$d(SymbolPrototype2, TO_PRIMITIVE2, function(hint) {
      return call$p(valueOf, this);
    }, { arity: 1 });
  }
};
var classofRaw = classofRaw$2;
var uncurryThis$z = functionUncurryThis;
var functionUncurryThisClause = function(fn) {
  if (classofRaw(fn) === "Function")
    return uncurryThis$z(fn);
};
var uncurryThis$y = functionUncurryThisClause;
var aCallable$9 = aCallable$c;
var NATIVE_BIND = functionBindNative;
var bind$a = uncurryThis$y(uncurryThis$y.bind);
var functionBindContext = function(fn, that) {
  aCallable$9(fn);
  return that === void 0 ? fn : NATIVE_BIND ? bind$a(fn, that) : function() {
    return fn.apply(that, arguments);
  };
};
var classof$c = classofRaw$2;
var isArray$5 = Array.isArray || function isArray(argument) {
  return classof$c(argument) === "Array";
};
var isArray$4 = isArray$5;
var isConstructor$2 = isConstructor$4;
var isObject$i = isObject$q;
var wellKnownSymbol$m = wellKnownSymbol$t;
var SPECIES$6 = wellKnownSymbol$m("species");
var $Array$3 = Array;
var arraySpeciesConstructor$1 = function(originalArray) {
  var C;
  if (isArray$4(originalArray)) {
    C = originalArray.constructor;
    if (isConstructor$2(C) && (C === $Array$3 || isArray$4(C.prototype)))
      C = void 0;
    else if (isObject$i(C)) {
      C = C[SPECIES$6];
      if (C === null)
        C = void 0;
    }
  }
  return C === void 0 ? $Array$3 : C;
};
var arraySpeciesConstructor = arraySpeciesConstructor$1;
var arraySpeciesCreate$3 = function(originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};
var bind$9 = functionBindContext;
var uncurryThis$x = functionUncurryThis;
var IndexedObject$3 = indexedObject;
var toObject$c = toObject$f;
var lengthOfArrayLike$e = lengthOfArrayLike$g;
var arraySpeciesCreate$2 = arraySpeciesCreate$3;
var push$9 = uncurryThis$x([].push);
var createMethod$4 = function(TYPE) {
  var IS_MAP = TYPE === 1;
  var IS_FILTER = TYPE === 2;
  var IS_SOME = TYPE === 3;
  var IS_EVERY = TYPE === 4;
  var IS_FIND_INDEX = TYPE === 6;
  var IS_FILTER_REJECT = TYPE === 7;
  var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
  return function($this, callbackfn, that, specificCreate) {
    var O = toObject$c($this);
    var self2 = IndexedObject$3(O);
    var length = lengthOfArrayLike$e(self2);
    var boundFunction = bind$9(callbackfn, that);
    var index2 = 0;
    var create4 = specificCreate || arraySpeciesCreate$2;
    var target = IS_MAP ? create4($this, length) : IS_FILTER || IS_FILTER_REJECT ? create4($this, 0) : void 0;
    var value, result;
    for (; length > index2; index2++)
      if (NO_HOLES || index2 in self2) {
        value = self2[index2];
        result = boundFunction(value, index2, O);
        if (TYPE) {
          if (IS_MAP)
            target[index2] = result;
          else if (result)
            switch (TYPE) {
              case 3:
                return true;
              case 5:
                return value;
              case 6:
                return index2;
              case 2:
                push$9(target, value);
            }
          else
            switch (TYPE) {
              case 4:
                return false;
              case 7:
                push$9(target, value);
            }
        }
      }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};
var arrayIteration = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod$4(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod$4(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod$4(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod$4(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod$4(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod$4(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod$4(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod$4(7)
};
var $$D = _export;
var global$r = global$D;
var call$o = functionCall;
var uncurryThis$w = functionUncurryThis;
var IS_PURE$a = isPure;
var DESCRIPTORS$j = descriptors;
var NATIVE_SYMBOL$4 = symbolConstructorDetection;
var fails$A = fails$M;
var hasOwn$d = hasOwnProperty_1;
var isPrototypeOf$7 = objectIsPrototypeOf;
var anObject$g = anObject$m;
var toIndexedObject$8 = toIndexedObject$e;
var toPropertyKey$2 = toPropertyKey$5;
var $toString$3 = toString$g;
var createPropertyDescriptor$4 = createPropertyDescriptor$7;
var nativeObjectCreate = objectCreate;
var objectKeys$2 = objectKeys$4;
var getOwnPropertyNamesModule$1 = objectGetOwnPropertyNames;
var getOwnPropertyNamesExternal = objectGetOwnPropertyNamesExternal;
var getOwnPropertySymbolsModule$2 = objectGetOwnPropertySymbols;
var getOwnPropertyDescriptorModule$2 = objectGetOwnPropertyDescriptor;
var definePropertyModule$2 = objectDefineProperty;
var definePropertiesModule = objectDefineProperties;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var defineBuiltIn$c = defineBuiltIn$f;
var defineBuiltInAccessor$9 = defineBuiltInAccessor$a;
var shared$3 = shared$7;
var sharedKey$1 = sharedKey$4;
var hiddenKeys$1 = hiddenKeys$6;
var uid$2 = uid$5;
var wellKnownSymbol$l = wellKnownSymbol$t;
var wrappedWellKnownSymbolModule = wellKnownSymbolWrapped;
var defineWellKnownSymbol$1 = wellKnownSymbolDefine;
var defineSymbolToPrimitive = symbolDefineToPrimitive;
var setToStringTag$8 = setToStringTag$a;
var InternalStateModule$a = internalState;
var $forEach$2 = arrayIteration.forEach;
var HIDDEN = sharedKey$1("hidden");
var SYMBOL = "Symbol";
var PROTOTYPE$1 = "prototype";
var setInternalState$9 = InternalStateModule$a.set;
var getInternalState$5 = InternalStateModule$a.getterFor(SYMBOL);
var ObjectPrototype$3 = Object[PROTOTYPE$1];
var $Symbol = global$r.Symbol;
var SymbolPrototype$1 = $Symbol && $Symbol[PROTOTYPE$1];
var RangeError$4 = global$r.RangeError;
var TypeError$6 = global$r.TypeError;
var QObject = global$r.QObject;
var nativeGetOwnPropertyDescriptor$2 = getOwnPropertyDescriptorModule$2.f;
var nativeDefineProperty$1 = definePropertyModule$2.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule$1.f;
var push$8 = uncurryThis$w([].push);
var AllSymbols = shared$3("symbols");
var ObjectPrototypeSymbols = shared$3("op-symbols");
var WellKnownSymbolsStore = shared$3("wks");
var USE_SETTER = !QObject || !QObject[PROTOTYPE$1] || !QObject[PROTOTYPE$1].findChild;
var fallbackDefineProperty = function(O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor$2(ObjectPrototype$3, P);
  if (ObjectPrototypeDescriptor)
    delete ObjectPrototype$3[P];
  nativeDefineProperty$1(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype$3) {
    nativeDefineProperty$1(ObjectPrototype$3, P, ObjectPrototypeDescriptor);
  }
};
var setSymbolDescriptor = DESCRIPTORS$j && fails$A(function() {
  return nativeObjectCreate(nativeDefineProperty$1({}, "a", {
    get: function() {
      return nativeDefineProperty$1(this, "a", { value: 7 }).a;
    }
  })).a !== 7;
}) ? fallbackDefineProperty : nativeDefineProperty$1;
var wrap = function(tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype$1);
  setInternalState$9(symbol, {
    type: SYMBOL,
    tag,
    description
  });
  if (!DESCRIPTORS$j)
    symbol.description = description;
  return symbol;
};
var $defineProperty = function defineProperty3(O, P, Attributes) {
  if (O === ObjectPrototype$3)
    $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject$g(O);
  var key = toPropertyKey$2(P);
  anObject$g(Attributes);
  if (hasOwn$d(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!hasOwn$d(O, HIDDEN))
        nativeDefineProperty$1(O, HIDDEN, createPropertyDescriptor$4(1, nativeObjectCreate(null)));
      O[HIDDEN][key] = true;
    } else {
      if (hasOwn$d(O, HIDDEN) && O[HIDDEN][key])
        O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor$4(0, false) });
    }
    return setSymbolDescriptor(O, key, Attributes);
  }
  return nativeDefineProperty$1(O, key, Attributes);
};
var $defineProperties = function defineProperties2(O, Properties) {
  anObject$g(O);
  var properties = toIndexedObject$8(Properties);
  var keys6 = objectKeys$2(properties).concat($getOwnPropertySymbols(properties));
  $forEach$2(keys6, function(key) {
    if (!DESCRIPTORS$j || call$o($propertyIsEnumerable$1, properties, key))
      $defineProperty(O, key, properties[key]);
  });
  return O;
};
var $create = function create2(O, Properties) {
  return Properties === void 0 ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};
var $propertyIsEnumerable$1 = function propertyIsEnumerable2(V) {
  var P = toPropertyKey$2(V);
  var enumerable = call$o(nativePropertyIsEnumerable, this, P);
  if (this === ObjectPrototype$3 && hasOwn$d(AllSymbols, P) && !hasOwn$d(ObjectPrototypeSymbols, P))
    return false;
  return enumerable || !hasOwn$d(this, P) || !hasOwn$d(AllSymbols, P) || hasOwn$d(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor2(O, P) {
  var it = toIndexedObject$8(O);
  var key = toPropertyKey$2(P);
  if (it === ObjectPrototype$3 && hasOwn$d(AllSymbols, key) && !hasOwn$d(ObjectPrototypeSymbols, key))
    return;
  var descriptor = nativeGetOwnPropertyDescriptor$2(it, key);
  if (descriptor && hasOwn$d(AllSymbols, key) && !(hasOwn$d(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};
var $getOwnPropertyNames = function getOwnPropertyNames3(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject$8(O));
  var result = [];
  $forEach$2(names, function(key) {
    if (!hasOwn$d(AllSymbols, key) && !hasOwn$d(hiddenKeys$1, key))
      push$8(result, key);
  });
  return result;
};
var $getOwnPropertySymbols = function(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype$3;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject$8(O));
  var result = [];
  $forEach$2(names, function(key) {
    if (hasOwn$d(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn$d(ObjectPrototype$3, key))) {
      push$8(result, AllSymbols[key]);
    }
  });
  return result;
};
if (!NATIVE_SYMBOL$4) {
  $Symbol = function Symbol2() {
    if (isPrototypeOf$7(SymbolPrototype$1, this))
      throw new TypeError$6("Symbol is not a constructor");
    var description = !arguments.length || arguments[0] === void 0 ? void 0 : $toString$3(arguments[0]);
    var tag = uid$2(description);
    var setter = function(value) {
      var $this = this === void 0 ? global$r : this;
      if ($this === ObjectPrototype$3)
        call$o(setter, ObjectPrototypeSymbols, value);
      if (hasOwn$d($this, HIDDEN) && hasOwn$d($this[HIDDEN], tag))
        $this[HIDDEN][tag] = false;
      var descriptor = createPropertyDescriptor$4(1, value);
      try {
        setSymbolDescriptor($this, tag, descriptor);
      } catch (error2) {
        if (!(error2 instanceof RangeError$4))
          throw error2;
        fallbackDefineProperty($this, tag, descriptor);
      }
    };
    if (DESCRIPTORS$j && USE_SETTER)
      setSymbolDescriptor(ObjectPrototype$3, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };
  SymbolPrototype$1 = $Symbol[PROTOTYPE$1];
  defineBuiltIn$c(SymbolPrototype$1, "toString", function toString6() {
    return getInternalState$5(this).tag;
  });
  defineBuiltIn$c($Symbol, "withoutSetter", function(description) {
    return wrap(uid$2(description), description);
  });
  propertyIsEnumerableModule$1.f = $propertyIsEnumerable$1;
  definePropertyModule$2.f = $defineProperty;
  definePropertiesModule.f = $defineProperties;
  getOwnPropertyDescriptorModule$2.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule$1.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule$2.f = $getOwnPropertySymbols;
  wrappedWellKnownSymbolModule.f = function(name) {
    return wrap(wellKnownSymbol$l(name), name);
  };
  if (DESCRIPTORS$j) {
    defineBuiltInAccessor$9(SymbolPrototype$1, "description", {
      configurable: true,
      get: function description() {
        return getInternalState$5(this).description;
      }
    });
    if (!IS_PURE$a) {
      defineBuiltIn$c(ObjectPrototype$3, "propertyIsEnumerable", $propertyIsEnumerable$1, { unsafe: true });
    }
  }
}
$$D({ global: true, constructor: true, wrap: true, forced: !NATIVE_SYMBOL$4, sham: !NATIVE_SYMBOL$4 }, {
  Symbol: $Symbol
});
$forEach$2(objectKeys$2(WellKnownSymbolsStore), function(name) {
  defineWellKnownSymbol$1(name);
});
$$D({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL$4 }, {
  useSetter: function() {
    USE_SETTER = true;
  },
  useSimple: function() {
    USE_SETTER = false;
  }
});
$$D({ target: "Object", stat: true, forced: !NATIVE_SYMBOL$4, sham: !DESCRIPTORS$j }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});
$$D({ target: "Object", stat: true, forced: !NATIVE_SYMBOL$4 }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames
});
defineSymbolToPrimitive();
setToStringTag$8($Symbol, SYMBOL);
hiddenKeys$1[HIDDEN] = true;
var NATIVE_SYMBOL$3 = symbolConstructorDetection;
var symbolRegistryDetection = NATIVE_SYMBOL$3 && !!Symbol["for"] && !!Symbol.keyFor;
var $$C = _export;
var getBuiltIn$4 = getBuiltIn$b;
var hasOwn$c = hasOwnProperty_1;
var toString$f = toString$g;
var shared$2 = shared$7;
var NATIVE_SYMBOL_REGISTRY$1 = symbolRegistryDetection;
var StringToSymbolRegistry = shared$2("string-to-symbol-registry");
var SymbolToStringRegistry$1 = shared$2("symbol-to-string-registry");
$$C({ target: "Symbol", stat: true, forced: !NATIVE_SYMBOL_REGISTRY$1 }, {
  "for": function(key) {
    var string = toString$f(key);
    if (hasOwn$c(StringToSymbolRegistry, string))
      return StringToSymbolRegistry[string];
    var symbol = getBuiltIn$4("Symbol")(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry$1[symbol] = string;
    return symbol;
  }
});
var $$B = _export;
var hasOwn$b = hasOwnProperty_1;
var isSymbol$3 = isSymbol$6;
var tryToString$4 = tryToString$7;
var shared$1 = shared$7;
var NATIVE_SYMBOL_REGISTRY = symbolRegistryDetection;
var SymbolToStringRegistry = shared$1("symbol-to-string-registry");
$$B({ target: "Symbol", stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  keyFor: function keyFor(sym) {
    if (!isSymbol$3(sym))
      throw new TypeError(tryToString$4(sym) + " is not a symbol");
    if (hasOwn$b(SymbolToStringRegistry, sym))
      return SymbolToStringRegistry[sym];
  }
});
var uncurryThis$v = functionUncurryThis;
var isArray$3 = isArray$5;
var isCallable$g = isCallable$t;
var classof$b = classofRaw$2;
var toString$e = toString$g;
var push$7 = uncurryThis$v([].push);
var getJsonReplacerFunction = function(replacer2) {
  if (isCallable$g(replacer2))
    return replacer2;
  if (!isArray$3(replacer2))
    return;
  var rawLength = replacer2.length;
  var keys6 = [];
  for (var i = 0; i < rawLength; i++) {
    var element = replacer2[i];
    if (typeof element == "string")
      push$7(keys6, element);
    else if (typeof element == "number" || classof$b(element) === "Number" || classof$b(element) === "String")
      push$7(keys6, toString$e(element));
  }
  var keysLength = keys6.length;
  var root = true;
  return function(key, value) {
    if (root) {
      root = false;
      return value;
    }
    if (isArray$3(this))
      return value;
    for (var j = 0; j < keysLength; j++)
      if (keys6[j] === key)
        return value;
  };
};
var $$A = _export;
var getBuiltIn$3 = getBuiltIn$b;
var apply$5 = functionApply;
var call$n = functionCall;
var uncurryThis$u = functionUncurryThis;
var fails$z = fails$M;
var isCallable$f = isCallable$t;
var isSymbol$2 = isSymbol$6;
var arraySlice$6 = arraySlice$9;
var getReplacerFunction = getJsonReplacerFunction;
var NATIVE_SYMBOL$2 = symbolConstructorDetection;
var $String$1 = String;
var $stringify = getBuiltIn$3("JSON", "stringify");
var exec$3 = uncurryThis$u(/./.exec);
var charAt$7 = uncurryThis$u("".charAt);
var charCodeAt$3 = uncurryThis$u("".charCodeAt);
var replace$7 = uncurryThis$u("".replace);
var numberToString$1 = uncurryThis$u(1 .toString);
var tester = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;
var WRONG_SYMBOLS_CONVERSION = !NATIVE_SYMBOL$2 || fails$z(function() {
  var symbol = getBuiltIn$3("Symbol")("stringify detection");
  return $stringify([symbol]) !== "[null]" || $stringify({ a: symbol }) !== "{}" || $stringify(Object(symbol)) !== "{}";
});
var ILL_FORMED_UNICODE = fails$z(function() {
  return $stringify("\uDF06\uD834") !== '"\\udf06\\ud834"' || $stringify("\uDEAD") !== '"\\udead"';
});
var stringifyWithSymbolsFix = function(it, replacer2) {
  var args = arraySlice$6(arguments);
  var $replacer = getReplacerFunction(replacer2);
  if (!isCallable$f($replacer) && (it === void 0 || isSymbol$2(it)))
    return;
  args[1] = function(key, value) {
    if (isCallable$f($replacer))
      value = call$n($replacer, this, $String$1(key), value);
    if (!isSymbol$2(value))
      return value;
  };
  return apply$5($stringify, null, args);
};
var fixIllFormed = function(match2, offset, string) {
  var prev = charAt$7(string, offset - 1);
  var next3 = charAt$7(string, offset + 1);
  if (exec$3(low, match2) && !exec$3(hi, next3) || exec$3(hi, match2) && !exec$3(low, prev)) {
    return "\\u" + numberToString$1(charCodeAt$3(match2, 0), 16);
  }
  return match2;
};
if ($stringify) {
  $$A({ target: "JSON", stat: true, arity: 3, forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer2, space) {
      var args = arraySlice$6(arguments);
      var result = apply$5(WRONG_SYMBOLS_CONVERSION ? stringifyWithSymbolsFix : $stringify, null, args);
      return ILL_FORMED_UNICODE && typeof result == "string" ? replace$7(result, tester, fixIllFormed) : result;
    }
  });
}
var $$z = _export;
var NATIVE_SYMBOL$1 = symbolConstructorDetection;
var fails$y = fails$M;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var toObject$b = toObject$f;
var FORCED$8 = !NATIVE_SYMBOL$1 || fails$y(function() {
  getOwnPropertySymbolsModule$1.f(1);
});
$$z({ target: "Object", stat: true, forced: FORCED$8 }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    var $getOwnPropertySymbols2 = getOwnPropertySymbolsModule$1.f;
    return $getOwnPropertySymbols2 ? $getOwnPropertySymbols2(toObject$b(it)) : [];
  }
});
var fails$x = fails$M;
var wellKnownSymbol$k = wellKnownSymbol$t;
var V8_VERSION$2 = engineV8Version;
var SPECIES$5 = wellKnownSymbol$k("species");
var arrayMethodHasSpeciesSupport$5 = function(METHOD_NAME) {
  return V8_VERSION$2 >= 51 || !fails$x(function() {
    var array5 = [];
    var constructor = array5.constructor = {};
    constructor[SPECIES$5] = function() {
      return { foo: 1 };
    };
    return array5[METHOD_NAME](Boolean).foo !== 1;
  });
};
var $$y = _export;
var $filter$1 = arrayIteration.filter;
var arrayMethodHasSpeciesSupport$4 = arrayMethodHasSpeciesSupport$5;
var HAS_SPECIES_SUPPORT$3 = arrayMethodHasSpeciesSupport$4("filter");
$$y({ target: "Array", proto: true, forced: !HAS_SPECIES_SUPPORT$3 }, {
  filter: function filter(callbackfn) {
    return $filter$1(this, callbackfn, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var $$x = _export;
var fails$w = fails$M;
var toIndexedObject$7 = toIndexedObject$e;
var nativeGetOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
var DESCRIPTORS$i = descriptors;
var FORCED$7 = !DESCRIPTORS$i || fails$w(function() {
  nativeGetOwnPropertyDescriptor$1(1);
});
$$x({ target: "Object", stat: true, forced: FORCED$7, sham: !DESCRIPTORS$i }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor3(it, key) {
    return nativeGetOwnPropertyDescriptor$1(toIndexedObject$7(it), key);
  }
});
var DESCRIPTORS$h = descriptors;
var definePropertyModule$1 = objectDefineProperty;
var createPropertyDescriptor$3 = createPropertyDescriptor$7;
var createProperty$5 = function(object, key, value) {
  if (DESCRIPTORS$h)
    definePropertyModule$1.f(object, key, createPropertyDescriptor$3(0, value));
  else
    object[key] = value;
};
var $$w = _export;
var DESCRIPTORS$g = descriptors;
var ownKeys$1 = ownKeys$3;
var toIndexedObject$6 = toIndexedObject$e;
var getOwnPropertyDescriptorModule$1 = objectGetOwnPropertyDescriptor;
var createProperty$4 = createProperty$5;
$$w({ target: "Object", stat: true, sham: !DESCRIPTORS$g }, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject$6(object);
    var getOwnPropertyDescriptor6 = getOwnPropertyDescriptorModule$1.f;
    var keys6 = ownKeys$1(O);
    var result = {};
    var index2 = 0;
    var key, descriptor;
    while (keys6.length > index2) {
      descriptor = getOwnPropertyDescriptor6(O, key = keys6[index2++]);
      if (descriptor !== void 0)
        createProperty$4(result, key, descriptor);
    }
    return result;
  }
});
var asyncToGenerator = { exports: {} };
asyncToGenerator.exports;
(function(module) {
  function asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
      var i = n[a](c), u = i.value;
    } catch (n2) {
      return void e(n2);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
  }
  function _asyncToGenerator2(n) {
    return function() {
      var t = this, e = arguments;
      return new Promise(function(r, o) {
        var a = n.apply(t, e);
        function _next(n2) {
          asyncGeneratorStep(a, r, o, _next, _throw, "next", n2);
        }
        function _throw(n2) {
          asyncGeneratorStep(a, r, o, _next, _throw, "throw", n2);
        }
        _next(void 0);
      });
    };
  }
  module.exports = _asyncToGenerator2, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(asyncToGenerator);
var asyncToGeneratorExports = asyncToGenerator.exports;
var assertThisInitialized = { exports: {} };
assertThisInitialized.exports;
(function(module) {
  function _assertThisInitialized2(e) {
    if (void 0 === e)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  module.exports = _assertThisInitialized2, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(assertThisInitialized);
var assertThisInitializedExports = assertThisInitialized.exports;
var inherits = { exports: {} };
var setPrototypeOf$6 = { exports: {} };
setPrototypeOf$6.exports;
(function(module) {
  function _setPrototypeOf(t, e) {
    return module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t2, e2) {
      return t2.__proto__ = e2, t2;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _setPrototypeOf(t, e);
  }
  module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(setPrototypeOf$6);
var setPrototypeOfExports = setPrototypeOf$6.exports;
inherits.exports;
(function(module) {
  var setPrototypeOf2 = setPrototypeOfExports;
  function _inherits2(t, e) {
    if ("function" != typeof e && null !== e)
      throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        writable: true,
        configurable: true
      }
    }), Object.defineProperty(t, "prototype", {
      writable: false
    }), e && setPrototypeOf2(t, e);
  }
  module.exports = _inherits2, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(inherits);
var inheritsExports = inherits.exports;
var possibleConstructorReturn = { exports: {} };
var _typeof$4 = { exports: {} };
_typeof$4.exports;
(function(module) {
  function _typeof2(o) {
    "@babel/helpers - typeof";
    return module.exports = _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
      return typeof o2;
    } : function(o2) {
      return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof2(o);
  }
  module.exports = _typeof2, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(_typeof$4);
var _typeofExports = _typeof$4.exports;
possibleConstructorReturn.exports;
(function(module) {
  var _typeof2 = _typeofExports["default"];
  var assertThisInitialized2 = assertThisInitializedExports;
  function _possibleConstructorReturn2(t, e) {
    if (e && ("object" == _typeof2(e) || "function" == typeof e))
      return e;
    if (void 0 !== e)
      throw new TypeError("Derived constructors may only return object or undefined");
    return assertThisInitialized2(t);
  }
  module.exports = _possibleConstructorReturn2, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(possibleConstructorReturn);
var possibleConstructorReturnExports = possibleConstructorReturn.exports;
var getPrototypeOf$4 = { exports: {} };
getPrototypeOf$4.exports;
(function(module) {
  function _getPrototypeOf2(t) {
    return module.exports = _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t2) {
      return t2.__proto__ || Object.getPrototypeOf(t2);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _getPrototypeOf2(t);
  }
  module.exports = _getPrototypeOf2, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(getPrototypeOf$4);
var getPrototypeOfExports = getPrototypeOf$4.exports;
var defineProperty$5 = { exports: {} };
var toPropertyKey$1 = { exports: {} };
var toPrimitive$2 = { exports: {} };
toPrimitive$2.exports;
(function(module) {
  var _typeof2 = _typeofExports["default"];
  function toPrimitive2(t, r) {
    if ("object" != _typeof2(t) || !t)
      return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r || "default");
      if ("object" != _typeof2(i))
        return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
  }
  module.exports = toPrimitive2, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(toPrimitive$2);
var toPrimitiveExports = toPrimitive$2.exports;
toPropertyKey$1.exports;
(function(module) {
  var _typeof2 = _typeofExports["default"];
  var toPrimitive2 = toPrimitiveExports;
  function toPropertyKey2(t) {
    var i = toPrimitive2(t, "string");
    return "symbol" == _typeof2(i) ? i : i + "";
  }
  module.exports = toPropertyKey2, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(toPropertyKey$1);
var toPropertyKeyExports = toPropertyKey$1.exports;
defineProperty$5.exports;
(function(module) {
  var toPropertyKey2 = toPropertyKeyExports;
  function _defineProperty2(e, r, t) {
    return (r = toPropertyKey2(r)) in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: true,
      configurable: true,
      writable: true
    }) : e[r] = t, e;
  }
  module.exports = _defineProperty2, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(defineProperty$5);
var definePropertyExports = defineProperty$5.exports;
var createClass = { exports: {} };
createClass.exports;
(function(module) {
  var toPropertyKey2 = toPropertyKeyExports;
  function _defineProperties(e, r) {
    for (var t = 0; t < r.length; t++) {
      var o = r[t];
      o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, toPropertyKey2(o.key), o);
    }
  }
  function _createClass2(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
      writable: false
    }), e;
  }
  module.exports = _createClass2, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(createClass);
var createClassExports = createClass.exports;
var classCallCheck = { exports: {} };
classCallCheck.exports;
(function(module) {
  function _classCallCheck2(a, n) {
    if (!(a instanceof n))
      throw new TypeError("Cannot call a class as a function");
  }
  module.exports = _classCallCheck2, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(classCallCheck);
var classCallCheckExports = classCallCheck.exports;
var TO_STRING_TAG_SUPPORT$1 = toStringTagSupport;
var classof$a = classof$g;
var objectToString = TO_STRING_TAG_SUPPORT$1 ? {}.toString : function toString2() {
  return "[object " + classof$a(this) + "]";
};
var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var defineBuiltIn$b = defineBuiltIn$f;
var toString$d = objectToString;
if (!TO_STRING_TAG_SUPPORT) {
  defineBuiltIn$b(Object.prototype, "toString", toString$d, { unsafe: true });
}
var global$q = global$D;
var classof$9 = classofRaw$2;
var engineIsNode = classof$9(global$q.process) === "process";
var uncurryThis$t = functionUncurryThis;
var aCallable$8 = aCallable$c;
var functionUncurryThisAccessor = function(object, key, method) {
  try {
    return uncurryThis$t(aCallable$8(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error2) {
  }
};
var isObject$h = isObject$q;
var isPossiblePrototype$1 = function(argument) {
  return isObject$h(argument) || argument === null;
};
var isPossiblePrototype = isPossiblePrototype$1;
var $String = String;
var $TypeError$c = TypeError;
var aPossiblePrototype$1 = function(argument) {
  if (isPossiblePrototype(argument))
    return argument;
  throw new $TypeError$c("Can't set " + $String(argument) + " as a prototype");
};
var uncurryThisAccessor = functionUncurryThisAccessor;
var isObject$g = isObject$q;
var requireObjectCoercible$8 = requireObjectCoercible$b;
var aPossiblePrototype = aPossiblePrototype$1;
var objectSetPrototypeOf = Object.setPrototypeOf || ("__proto__" in {} ? function() {
  var CORRECT_SETTER = false;
  var test2 = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, "__proto__", "set");
    setter(test2, []);
    CORRECT_SETTER = test2 instanceof Array;
  } catch (error2) {
  }
  return function setPrototypeOf2(O, proto) {
    requireObjectCoercible$8(O);
    aPossiblePrototype(proto);
    if (!isObject$g(O))
      return O;
    if (CORRECT_SETTER)
      setter(O, proto);
    else
      O.__proto__ = proto;
    return O;
  };
}() : void 0);
var getBuiltIn$2 = getBuiltIn$b;
var defineBuiltInAccessor$8 = defineBuiltInAccessor$a;
var wellKnownSymbol$j = wellKnownSymbol$t;
var DESCRIPTORS$f = descriptors;
var SPECIES$4 = wellKnownSymbol$j("species");
var setSpecies$4 = function(CONSTRUCTOR_NAME) {
  var Constructor2 = getBuiltIn$2(CONSTRUCTOR_NAME);
  if (DESCRIPTORS$f && Constructor2 && !Constructor2[SPECIES$4]) {
    defineBuiltInAccessor$8(Constructor2, SPECIES$4, {
      configurable: true,
      get: function() {
        return this;
      }
    });
  }
};
var isPrototypeOf$6 = objectIsPrototypeOf;
var $TypeError$b = TypeError;
var anInstance$8 = function(it, Prototype2) {
  if (isPrototypeOf$6(Prototype2, it))
    return it;
  throw new $TypeError$b("Incorrect invocation");
};
var anObject$f = anObject$m;
var aConstructor$1 = aConstructor$3;
var isNullOrUndefined$8 = isNullOrUndefined$b;
var wellKnownSymbol$i = wellKnownSymbol$t;
var SPECIES$3 = wellKnownSymbol$i("species");
var speciesConstructor$3 = function(O, defaultConstructor) {
  var C = anObject$f(O).constructor;
  var S;
  return C === void 0 || isNullOrUndefined$8(S = anObject$f(C)[SPECIES$3]) ? defaultConstructor : aConstructor$1(S);
};
var $TypeError$a = TypeError;
var validateArgumentsLength$3 = function(passed, required) {
  if (passed < required)
    throw new $TypeError$a("Not enough arguments");
  return passed;
};
var userAgent$4 = engineUserAgent;
var engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent$4);
var global$p = global$D;
var apply$4 = functionApply;
var bind$8 = functionBindContext;
var isCallable$e = isCallable$t;
var hasOwn$a = hasOwnProperty_1;
var fails$v = fails$M;
var html = html$2;
var arraySlice$5 = arraySlice$9;
var createElement = documentCreateElement$2;
var validateArgumentsLength$2 = validateArgumentsLength$3;
var IS_IOS$1 = engineIsIos;
var IS_NODE$3 = engineIsNode;
var set$1 = global$p.setImmediate;
var clear = global$p.clearImmediate;
var process$2 = global$p.process;
var Dispatch = global$p.Dispatch;
var Function$1 = global$p.Function;
var MessageChannel = global$p.MessageChannel;
var String$1 = global$p.String;
var counter = 0;
var queue$2 = {};
var ONREADYSTATECHANGE = "onreadystatechange";
var $location, defer, channel, port;
fails$v(function() {
  $location = global$p.location;
});
var run = function(id2) {
  if (hasOwn$a(queue$2, id2)) {
    var fn = queue$2[id2];
    delete queue$2[id2];
    fn();
  }
};
var runner = function(id2) {
  return function() {
    run(id2);
  };
};
var eventListener = function(event) {
  run(event.data);
};
var globalPostMessageDefer = function(id2) {
  global$p.postMessage(String$1(id2), $location.protocol + "//" + $location.host);
};
if (!set$1 || !clear) {
  set$1 = function setImmediate(handler) {
    validateArgumentsLength$2(arguments.length, 1);
    var fn = isCallable$e(handler) ? handler : Function$1(handler);
    var args = arraySlice$5(arguments, 1);
    queue$2[++counter] = function() {
      apply$4(fn, void 0, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id2) {
    delete queue$2[id2];
  };
  if (IS_NODE$3) {
    defer = function(id2) {
      process$2.nextTick(runner(id2));
    };
  } else if (Dispatch && Dispatch.now) {
    defer = function(id2) {
      Dispatch.now(runner(id2));
    };
  } else if (MessageChannel && !IS_IOS$1) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = eventListener;
    defer = bind$8(port.postMessage, port);
  } else if (global$p.addEventListener && isCallable$e(global$p.postMessage) && !global$p.importScripts && $location && $location.protocol !== "file:" && !fails$v(globalPostMessageDefer)) {
    defer = globalPostMessageDefer;
    global$p.addEventListener("message", eventListener, false);
  } else if (ONREADYSTATECHANGE in createElement("script")) {
    defer = function(id2) {
      html.appendChild(createElement("script"))[ONREADYSTATECHANGE] = function() {
        html.removeChild(this);
        run(id2);
      };
    };
  } else {
    defer = function(id2) {
      setTimeout(runner(id2), 0);
    };
  }
}
var task$1 = {
  set: set$1,
  clear
};
var global$o = global$D;
var DESCRIPTORS$e = descriptors;
var getOwnPropertyDescriptor$3 = Object.getOwnPropertyDescriptor;
var safeGetBuiltIn$2 = function(name) {
  if (!DESCRIPTORS$e)
    return global$o[name];
  var descriptor = getOwnPropertyDescriptor$3(global$o, name);
  return descriptor && descriptor.value;
};
var Queue$2 = function() {
  this.head = null;
  this.tail = null;
};
Queue$2.prototype = {
  add: function(item) {
    var entry = { item, next: null };
    var tail = this.tail;
    if (tail)
      tail.next = entry;
    else
      this.head = entry;
    this.tail = entry;
  },
  get: function() {
    var entry = this.head;
    if (entry) {
      var next3 = this.head = entry.next;
      if (next3 === null)
        this.tail = null;
      return entry.item;
    }
  }
};
var queue$1 = Queue$2;
var userAgent$3 = engineUserAgent;
var engineIsIosPebble = /ipad|iphone|ipod/i.test(userAgent$3) && typeof Pebble != "undefined";
var userAgent$2 = engineUserAgent;
var engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(userAgent$2);
var global$n = global$D;
var safeGetBuiltIn$1 = safeGetBuiltIn$2;
var bind$7 = functionBindContext;
var macrotask = task$1.set;
var Queue$1 = queue$1;
var IS_IOS = engineIsIos;
var IS_IOS_PEBBLE = engineIsIosPebble;
var IS_WEBOS_WEBKIT = engineIsWebosWebkit;
var IS_NODE$2 = engineIsNode;
var MutationObserver = global$n.MutationObserver || global$n.WebKitMutationObserver;
var document$2 = global$n.document;
var process$1 = global$n.process;
var Promise$1 = global$n.Promise;
var microtask$1 = safeGetBuiltIn$1("queueMicrotask");
var notify$1, toggle, node, promise, then;
if (!microtask$1) {
  var queue = new Queue$1();
  var flush = function() {
    var parent, fn;
    if (IS_NODE$2 && (parent = process$1.domain))
      parent.exit();
    while (fn = queue.get())
      try {
        fn();
      } catch (error2) {
        if (queue.head)
          notify$1();
        throw error2;
      }
    if (parent)
      parent.enter();
  };
  if (!IS_IOS && !IS_NODE$2 && !IS_WEBOS_WEBKIT && MutationObserver && document$2) {
    toggle = true;
    node = document$2.createTextNode("");
    new MutationObserver(flush).observe(node, { characterData: true });
    notify$1 = function() {
      node.data = toggle = !toggle;
    };
  } else if (!IS_IOS_PEBBLE && Promise$1 && Promise$1.resolve) {
    promise = Promise$1.resolve(void 0);
    promise.constructor = Promise$1;
    then = bind$7(promise.then, promise);
    notify$1 = function() {
      then(flush);
    };
  } else if (IS_NODE$2) {
    notify$1 = function() {
      process$1.nextTick(flush);
    };
  } else {
    macrotask = bind$7(macrotask, global$n);
    notify$1 = function() {
      macrotask(flush);
    };
  }
  microtask$1 = function(fn) {
    if (!queue.head)
      notify$1();
    queue.add(fn);
  };
}
var microtask_1 = microtask$1;
var hostReportErrors$1 = function(a, b) {
  try {
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  } catch (error2) {
  }
};
var perform$3 = function(exec2) {
  try {
    return { error: false, value: exec2() };
  } catch (error2) {
    return { error: true, value: error2 };
  }
};
var global$m = global$D;
var promiseNativeConstructor = global$m.Promise;
var engineIsDeno = typeof Deno == "object" && Deno && typeof Deno.version == "object";
var IS_DENO$1 = engineIsDeno;
var IS_NODE$1 = engineIsNode;
var engineIsBrowser = !IS_DENO$1 && !IS_NODE$1 && typeof window == "object" && typeof document == "object";
var global$l = global$D;
var NativePromiseConstructor$4 = promiseNativeConstructor;
var isCallable$d = isCallable$t;
var isForced$2 = isForced_1;
var inspectSource = inspectSource$3;
var wellKnownSymbol$h = wellKnownSymbol$t;
var IS_BROWSER = engineIsBrowser;
var IS_DENO = engineIsDeno;
var IS_PURE$9 = isPure;
var V8_VERSION$1 = engineV8Version;
var NativePromisePrototype$2 = NativePromiseConstructor$4 && NativePromiseConstructor$4.prototype;
var SPECIES$2 = wellKnownSymbol$h("species");
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT$1 = isCallable$d(global$l.PromiseRejectionEvent);
var FORCED_PROMISE_CONSTRUCTOR$5 = isForced$2("Promise", function() {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor$4);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor$4);
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION$1 === 66)
    return true;
  if (IS_PURE$9 && !(NativePromisePrototype$2["catch"] && NativePromisePrototype$2["finally"]))
    return true;
  if (!V8_VERSION$1 || V8_VERSION$1 < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    var promise2 = new NativePromiseConstructor$4(function(resolve2) {
      resolve2(1);
    });
    var FakePromise = function(exec2) {
      exec2(function() {
      }, function() {
      });
    };
    var constructor = promise2.constructor = {};
    constructor[SPECIES$2] = FakePromise;
    SUBCLASSING = promise2.then(function() {
    }) instanceof FakePromise;
    if (!SUBCLASSING)
      return true;
  }
  return !GLOBAL_CORE_JS_PROMISE && (IS_BROWSER || IS_DENO) && !NATIVE_PROMISE_REJECTION_EVENT$1;
});
var promiseConstructorDetection = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR$5,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT$1,
  SUBCLASSING
};
var newPromiseCapability$2 = {};
var aCallable$7 = aCallable$c;
var $TypeError$9 = TypeError;
var PromiseCapability = function(C) {
  var resolve2, reject2;
  this.promise = new C(function($$resolve, $$reject) {
    if (resolve2 !== void 0 || reject2 !== void 0)
      throw new $TypeError$9("Bad Promise constructor");
    resolve2 = $$resolve;
    reject2 = $$reject;
  });
  this.resolve = aCallable$7(resolve2);
  this.reject = aCallable$7(reject2);
};
newPromiseCapability$2.f = function(C) {
  return new PromiseCapability(C);
};
var $$v = _export;
var IS_PURE$8 = isPure;
var IS_NODE = engineIsNode;
var global$k = global$D;
var call$m = functionCall;
var defineBuiltIn$a = defineBuiltIn$f;
var setPrototypeOf$5 = objectSetPrototypeOf;
var setToStringTag$7 = setToStringTag$a;
var setSpecies$3 = setSpecies$4;
var aCallable$6 = aCallable$c;
var isCallable$c = isCallable$t;
var isObject$f = isObject$q;
var anInstance$7 = anInstance$8;
var speciesConstructor$2 = speciesConstructor$3;
var task = task$1.set;
var microtask = microtask_1;
var hostReportErrors = hostReportErrors$1;
var perform$2 = perform$3;
var Queue = queue$1;
var InternalStateModule$9 = internalState;
var NativePromiseConstructor$3 = promiseNativeConstructor;
var PromiseConstructorDetection = promiseConstructorDetection;
var newPromiseCapabilityModule$3 = newPromiseCapability$2;
var PROMISE = "Promise";
var FORCED_PROMISE_CONSTRUCTOR$4 = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule$9.getterFor(PROMISE);
var setInternalState$8 = InternalStateModule$9.set;
var NativePromisePrototype$1 = NativePromiseConstructor$3 && NativePromiseConstructor$3.prototype;
var PromiseConstructor = NativePromiseConstructor$3;
var PromisePrototype = NativePromisePrototype$1;
var TypeError$5 = global$k.TypeError;
var document$1 = global$k.document;
var process = global$k.process;
var newPromiseCapability$1 = newPromiseCapabilityModule$3.f;
var newGenericPromiseCapability = newPromiseCapability$1;
var DISPATCH_EVENT = !!(document$1 && document$1.createEvent && global$k.dispatchEvent);
var UNHANDLED_REJECTION = "unhandledrejection";
var REJECTION_HANDLED = "rejectionhandled";
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;
var isThenable = function(it) {
  var then2;
  return isObject$f(it) && isCallable$c(then2 = it.then) ? then2 : false;
};
var callReaction = function(reaction, state) {
  var value = state.value;
  var ok = state.state === FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve2 = reaction.resolve;
  var reject2 = reaction.reject;
  var domain2 = reaction.domain;
  var result, then2, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED)
          onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true)
        result = value;
      else {
        if (domain2)
          domain2.enter();
        result = handler(value);
        if (domain2) {
          domain2.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject2(new TypeError$5("Promise-chain cycle"));
      } else if (then2 = isThenable(result)) {
        call$m(then2, result, resolve2, reject2);
      } else
        resolve2(result);
    } else
      reject2(value);
  } catch (error2) {
    if (domain2 && !exited)
      domain2.exit();
    reject2(error2);
  }
};
var notify = function(state, isReject) {
  if (state.notified)
    return;
  state.notified = true;
  microtask(function() {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection)
      onUnhandled(state);
  });
};
var dispatchEvent = function(name, promise2, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$1.createEvent("Event");
    event.promise = promise2;
    event.reason = reason;
    event.initEvent(name, false, true);
    global$k.dispatchEvent(event);
  } else
    event = { promise: promise2, reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = global$k["on" + name]))
    handler(event);
  else if (name === UNHANDLED_REJECTION)
    hostReportErrors("Unhandled promise rejection", reason);
};
var onUnhandled = function(state) {
  call$m(task, global$k, function() {
    var promise2 = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform$2(function() {
        if (IS_NODE) {
          process.emit("unhandledRejection", value, promise2);
        } else
          dispatchEvent(UNHANDLED_REJECTION, promise2, value);
      });
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error)
        throw result.value;
    }
  });
};
var isUnhandled = function(state) {
  return state.rejection !== HANDLED && !state.parent;
};
var onHandleUnhandled = function(state) {
  call$m(task, global$k, function() {
    var promise2 = state.facade;
    if (IS_NODE) {
      process.emit("rejectionHandled", promise2);
    } else
      dispatchEvent(REJECTION_HANDLED, promise2, state.value);
  });
};
var bind$6 = function(fn, state, unwrap) {
  return function(value) {
    fn(state, value, unwrap);
  };
};
var internalReject = function(state, value, unwrap) {
  if (state.done)
    return;
  state.done = true;
  if (unwrap)
    state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};
var internalResolve = function(state, value, unwrap) {
  if (state.done)
    return;
  state.done = true;
  if (unwrap)
    state = unwrap;
  try {
    if (state.facade === value)
      throw new TypeError$5("Promise can't be resolved itself");
    var then2 = isThenable(value);
    if (then2) {
      microtask(function() {
        var wrapper = { done: false };
        try {
          call$m(
            then2,
            value,
            bind$6(internalResolve, wrapper, state),
            bind$6(internalReject, wrapper, state)
          );
        } catch (error2) {
          internalReject(wrapper, error2, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error2) {
    internalReject({ done: false }, error2, state);
  }
};
if (FORCED_PROMISE_CONSTRUCTOR$4) {
  PromiseConstructor = function Promise2(executor) {
    anInstance$7(this, PromisePrototype);
    aCallable$6(executor);
    call$m(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind$6(internalResolve, state), bind$6(internalReject, state));
    } catch (error2) {
      internalReject(state, error2);
    }
  };
  PromisePrototype = PromiseConstructor.prototype;
  Internal = function Promise2(executor) {
    setInternalState$8(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: void 0
    });
  };
  Internal.prototype = defineBuiltIn$a(PromisePrototype, "then", function then2(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability$1(speciesConstructor$2(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable$c(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable$c(onRejected) && onRejected;
    reaction.domain = IS_NODE ? process.domain : void 0;
    if (state.state === PENDING)
      state.reactions.add(reaction);
    else
      microtask(function() {
        callReaction(reaction, state);
      });
    return reaction.promise;
  });
  OwnPromiseCapability = function() {
    var promise2 = new Internal();
    var state = getInternalPromiseState(promise2);
    this.promise = promise2;
    this.resolve = bind$6(internalResolve, state);
    this.reject = bind$6(internalReject, state);
  };
  newPromiseCapabilityModule$3.f = newPromiseCapability$1 = function(C) {
    return C === PromiseConstructor || C === PromiseWrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
  };
  if (!IS_PURE$8 && isCallable$c(NativePromiseConstructor$3) && NativePromisePrototype$1 !== Object.prototype) {
    nativeThen = NativePromisePrototype$1.then;
    if (!NATIVE_PROMISE_SUBCLASSING) {
      defineBuiltIn$a(NativePromisePrototype$1, "then", function then2(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function(resolve2, reject2) {
          call$m(nativeThen, that, resolve2, reject2);
        }).then(onFulfilled, onRejected);
      }, { unsafe: true });
    }
    try {
      delete NativePromisePrototype$1.constructor;
    } catch (error2) {
    }
    if (setPrototypeOf$5) {
      setPrototypeOf$5(NativePromisePrototype$1, PromisePrototype);
    }
  }
}
$$v({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR$4 }, {
  Promise: PromiseConstructor
});
setToStringTag$7(PromiseConstructor, PROMISE, false, true);
setSpecies$3(PROMISE);
var iterators = {};
var wellKnownSymbol$g = wellKnownSymbol$t;
var Iterators$4 = iterators;
var ITERATOR$8 = wellKnownSymbol$g("iterator");
var ArrayPrototype$1 = Array.prototype;
var isArrayIteratorMethod$3 = function(it) {
  return it !== void 0 && (Iterators$4.Array === it || ArrayPrototype$1[ITERATOR$8] === it);
};
var classof$8 = classof$g;
var getMethod$5 = getMethod$7;
var isNullOrUndefined$7 = isNullOrUndefined$b;
var Iterators$3 = iterators;
var wellKnownSymbol$f = wellKnownSymbol$t;
var ITERATOR$7 = wellKnownSymbol$f("iterator");
var getIteratorMethod$5 = function(it) {
  if (!isNullOrUndefined$7(it))
    return getMethod$5(it, ITERATOR$7) || getMethod$5(it, "@@iterator") || Iterators$3[classof$8(it)];
};
var call$l = functionCall;
var aCallable$5 = aCallable$c;
var anObject$e = anObject$m;
var tryToString$3 = tryToString$7;
var getIteratorMethod$4 = getIteratorMethod$5;
var $TypeError$8 = TypeError;
var getIterator$4 = function(argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod$4(argument) : usingIterator;
  if (aCallable$5(iteratorMethod))
    return anObject$e(call$l(iteratorMethod, argument));
  throw new $TypeError$8(tryToString$3(argument) + " is not iterable");
};
var call$k = functionCall;
var anObject$d = anObject$m;
var getMethod$4 = getMethod$7;
var iteratorClose$2 = function(iterator, kind, value) {
  var innerResult, innerError;
  anObject$d(iterator);
  try {
    innerResult = getMethod$4(iterator, "return");
    if (!innerResult) {
      if (kind === "throw")
        throw value;
      return value;
    }
    innerResult = call$k(innerResult, iterator);
  } catch (error2) {
    innerError = true;
    innerResult = error2;
  }
  if (kind === "throw")
    throw value;
  if (innerError)
    throw innerResult;
  anObject$d(innerResult);
  return value;
};
var bind$5 = functionBindContext;
var call$j = functionCall;
var anObject$c = anObject$m;
var tryToString$2 = tryToString$7;
var isArrayIteratorMethod$2 = isArrayIteratorMethod$3;
var lengthOfArrayLike$d = lengthOfArrayLike$g;
var isPrototypeOf$5 = objectIsPrototypeOf;
var getIterator$3 = getIterator$4;
var getIteratorMethod$3 = getIteratorMethod$5;
var iteratorClose$1 = iteratorClose$2;
var $TypeError$7 = TypeError;
var Result = function(stopped, result) {
  this.stopped = stopped;
  this.result = result;
};
var ResultPrototype = Result.prototype;
var iterate$5 = function(iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind$5(unboundFunction, that);
  var iterator, iterFn, index2, length, result, next3, step;
  var stop = function(condition) {
    if (iterator)
      iteratorClose$1(iterator, "normal", condition);
    return new Result(true, condition);
  };
  var callFn = function(value) {
    if (AS_ENTRIES) {
      anObject$c(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    }
    return INTERRUPTED ? fn(value, stop) : fn(value);
  };
  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod$3(iterable);
    if (!iterFn)
      throw new $TypeError$7(tryToString$2(iterable) + " is not iterable");
    if (isArrayIteratorMethod$2(iterFn)) {
      for (index2 = 0, length = lengthOfArrayLike$d(iterable); length > index2; index2++) {
        result = callFn(iterable[index2]);
        if (result && isPrototypeOf$5(ResultPrototype, result))
          return result;
      }
      return new Result(false);
    }
    iterator = getIterator$3(iterable, iterFn);
  }
  next3 = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call$j(next3, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error2) {
      iteratorClose$1(iterator, "throw", error2);
    }
    if (typeof result == "object" && result && isPrototypeOf$5(ResultPrototype, result))
      return result;
  }
  return new Result(false);
};
var wellKnownSymbol$e = wellKnownSymbol$t;
var ITERATOR$6 = wellKnownSymbol$e("iterator");
var SAFE_CLOSING = false;
try {
  var called = 0;
  var iteratorWithReturn = {
    next: function() {
      return { done: !!called++ };
    },
    "return": function() {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR$6] = function() {
    return this;
  };
  Array.from(iteratorWithReturn, function() {
    throw 2;
  });
} catch (error2) {
}
var checkCorrectnessOfIteration$4 = function(exec2, SKIP_CLOSING) {
  try {
    if (!SKIP_CLOSING && !SAFE_CLOSING)
      return false;
  } catch (error2) {
    return false;
  }
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$6] = function() {
      return {
        next: function() {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec2(object);
  } catch (error2) {
  }
  return ITERATION_SUPPORT;
};
var NativePromiseConstructor$2 = promiseNativeConstructor;
var checkCorrectnessOfIteration$3 = checkCorrectnessOfIteration$4;
var FORCED_PROMISE_CONSTRUCTOR$3 = promiseConstructorDetection.CONSTRUCTOR;
var promiseStaticsIncorrectIteration = FORCED_PROMISE_CONSTRUCTOR$3 || !checkCorrectnessOfIteration$3(function(iterable) {
  NativePromiseConstructor$2.all(iterable).then(void 0, function() {
  });
});
var $$u = _export;
var call$i = functionCall;
var aCallable$4 = aCallable$c;
var newPromiseCapabilityModule$2 = newPromiseCapability$2;
var perform$1 = perform$3;
var iterate$4 = iterate$5;
var PROMISE_STATICS_INCORRECT_ITERATION$1 = promiseStaticsIncorrectIteration;
$$u({ target: "Promise", stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION$1 }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$2.f(C);
    var resolve2 = capability.resolve;
    var reject2 = capability.reject;
    var result = perform$1(function() {
      var $promiseResolve = aCallable$4(C.resolve);
      var values4 = [];
      var counter2 = 0;
      var remaining = 1;
      iterate$4(iterable, function(promise2) {
        var index2 = counter2++;
        var alreadyCalled = false;
        remaining++;
        call$i($promiseResolve, C, promise2).then(function(value) {
          if (alreadyCalled)
            return;
          alreadyCalled = true;
          values4[index2] = value;
          --remaining || resolve2(values4);
        }, reject2);
      });
      --remaining || resolve2(values4);
    });
    if (result.error)
      reject2(result.value);
    return capability.promise;
  }
});
var $$t = _export;
var IS_PURE$7 = isPure;
var FORCED_PROMISE_CONSTRUCTOR$2 = promiseConstructorDetection.CONSTRUCTOR;
var NativePromiseConstructor$1 = promiseNativeConstructor;
var getBuiltIn$1 = getBuiltIn$b;
var isCallable$b = isCallable$t;
var defineBuiltIn$9 = defineBuiltIn$f;
var NativePromisePrototype = NativePromiseConstructor$1 && NativePromiseConstructor$1.prototype;
$$t({ target: "Promise", proto: true, forced: FORCED_PROMISE_CONSTRUCTOR$2, real: true }, {
  "catch": function(onRejected) {
    return this.then(void 0, onRejected);
  }
});
if (!IS_PURE$7 && isCallable$b(NativePromiseConstructor$1)) {
  var method = getBuiltIn$1("Promise").prototype["catch"];
  if (NativePromisePrototype["catch"] !== method) {
    defineBuiltIn$9(NativePromisePrototype, "catch", method, { unsafe: true });
  }
}
var $$s = _export;
var call$h = functionCall;
var aCallable$3 = aCallable$c;
var newPromiseCapabilityModule$1 = newPromiseCapability$2;
var perform = perform$3;
var iterate$3 = iterate$5;
var PROMISE_STATICS_INCORRECT_ITERATION = promiseStaticsIncorrectIteration;
$$s({ target: "Promise", stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$1.f(C);
    var reject2 = capability.reject;
    var result = perform(function() {
      var $promiseResolve = aCallable$3(C.resolve);
      iterate$3(iterable, function(promise2) {
        call$h($promiseResolve, C, promise2).then(capability.resolve, reject2);
      });
    });
    if (result.error)
      reject2(result.value);
    return capability.promise;
  }
});
var $$r = _export;
var newPromiseCapabilityModule = newPromiseCapability$2;
var FORCED_PROMISE_CONSTRUCTOR$1 = promiseConstructorDetection.CONSTRUCTOR;
$$r({ target: "Promise", stat: true, forced: FORCED_PROMISE_CONSTRUCTOR$1 }, {
  reject: function reject(r) {
    var capability = newPromiseCapabilityModule.f(this);
    var capabilityReject = capability.reject;
    capabilityReject(r);
    return capability.promise;
  }
});
var anObject$b = anObject$m;
var isObject$e = isObject$q;
var newPromiseCapability = newPromiseCapability$2;
var promiseResolve$1 = function(C, x) {
  anObject$b(C);
  if (isObject$e(x) && x.constructor === C)
    return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve2 = promiseCapability.resolve;
  resolve2(x);
  return promiseCapability.promise;
};
var $$q = _export;
var getBuiltIn = getBuiltIn$b;
var IS_PURE$6 = isPure;
var NativePromiseConstructor = promiseNativeConstructor;
var FORCED_PROMISE_CONSTRUCTOR = promiseConstructorDetection.CONSTRUCTOR;
var promiseResolve = promiseResolve$1;
var PromiseConstructorWrapper = getBuiltIn("Promise");
var CHECK_WRAPPER = IS_PURE$6 && !FORCED_PROMISE_CONSTRUCTOR;
$$q({ target: "Promise", stat: true, forced: IS_PURE$6 || FORCED_PROMISE_CONSTRUCTOR }, {
  resolve: function resolve(x) {
    return promiseResolve(CHECK_WRAPPER && this === PromiseConstructorWrapper ? NativePromiseConstructor : this, x);
  }
});
var $$p = _export;
var $map$1 = arrayIteration.map;
var arrayMethodHasSpeciesSupport$3 = arrayMethodHasSpeciesSupport$5;
var HAS_SPECIES_SUPPORT$2 = arrayMethodHasSpeciesSupport$3("map");
$$p({ target: "Array", proto: true, forced: !HAS_SPECIES_SUPPORT$2 }, {
  map: function map(callbackfn) {
    return $map$1(this, callbackfn, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};
var documentCreateElement = documentCreateElement$2;
var classList = documentCreateElement("span").classList;
var DOMTokenListPrototype$2 = classList && classList.constructor && classList.constructor.prototype;
var domTokenListPrototype = DOMTokenListPrototype$2 === Object.prototype ? void 0 : DOMTokenListPrototype$2;
var fails$u = fails$M;
var arrayMethodIsStrict$4 = function(METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails$u(function() {
    method.call(null, argument || function() {
      return 1;
    }, 1);
  });
};
var $forEach$1 = arrayIteration.forEach;
var arrayMethodIsStrict$3 = arrayMethodIsStrict$4;
var STRICT_METHOD$2 = arrayMethodIsStrict$3("forEach");
var arrayForEach = !STRICT_METHOD$2 ? function forEach(callbackfn) {
  return $forEach$1(this, callbackfn, arguments.length > 1 ? arguments[1] : void 0);
} : [].forEach;
var global$j = global$D;
var DOMIterables$1 = domIterables;
var DOMTokenListPrototype$1 = domTokenListPrototype;
var forEach$1 = arrayForEach;
var createNonEnumerableProperty$6 = createNonEnumerableProperty$9;
var handlePrototype$1 = function(CollectionPrototype) {
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach$1)
    try {
      createNonEnumerableProperty$6(CollectionPrototype, "forEach", forEach$1);
    } catch (error2) {
      CollectionPrototype.forEach = forEach$1;
    }
};
for (var COLLECTION_NAME$1 in DOMIterables$1) {
  if (DOMIterables$1[COLLECTION_NAME$1]) {
    handlePrototype$1(global$j[COLLECTION_NAME$1] && global$j[COLLECTION_NAME$1].prototype);
  }
}
handlePrototype$1(DOMTokenListPrototype$1);
var regeneratorRuntime$1 = { exports: {} };
regeneratorRuntime$1.exports;
(function(module) {
  var _typeof2 = _typeofExports["default"];
  function _regeneratorRuntime2() {
    module.exports = _regeneratorRuntime2 = function _regeneratorRuntime3() {
      return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t2, e2, r2) {
      t2[e2] = r2.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t2, e2, r2) {
      return Object.defineProperty(t2, e2, {
        value: r2,
        enumerable: true,
        configurable: true,
        writable: true
      }), t2[e2];
    }
    try {
      define({}, "");
    } catch (t2) {
      define = function define2(t3, e2, r2) {
        return t3[e2] = r2;
      };
    }
    function wrap2(t2, e2, r2, n2) {
      var i2 = e2 && e2.prototype instanceof Generator ? e2 : Generator, a2 = Object.create(i2.prototype), c2 = new Context(n2 || []);
      return o(a2, "_invoke", {
        value: makeInvokeMethod(t2, r2, c2)
      }), a2;
    }
    function tryCatch(t2, e2, r2) {
      try {
        return {
          type: "normal",
          arg: t2.call(e2, r2)
        };
      } catch (t3) {
        return {
          type: "throw",
          arg: t3
        };
      }
    }
    e.wrap = wrap2;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {
    }
    function GeneratorFunction() {
    }
    function GeneratorFunctionPrototype() {
    }
    var p = {};
    define(p, a, function() {
      return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values4([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t2) {
      ["next", "throw", "return"].forEach(function(e2) {
        define(t2, e2, function(t3) {
          return this._invoke(e2, t3);
        });
      });
    }
    function AsyncIterator(t2, e2) {
      function invoke(r3, o2, i2, a2) {
        var c2 = tryCatch(t2[r3], t2, o2);
        if ("throw" !== c2.type) {
          var u2 = c2.arg, h2 = u2.value;
          return h2 && "object" == _typeof2(h2) && n.call(h2, "__await") ? e2.resolve(h2.__await).then(function(t3) {
            invoke("next", t3, i2, a2);
          }, function(t3) {
            invoke("throw", t3, i2, a2);
          }) : e2.resolve(h2).then(function(t3) {
            u2.value = t3, i2(u2);
          }, function(t3) {
            return invoke("throw", t3, i2, a2);
          });
        }
        a2(c2.arg);
      }
      var r2;
      o(this, "_invoke", {
        value: function value(t3, n2) {
          function callInvokeWithMethodAndArg() {
            return new e2(function(e3, r3) {
              invoke(t3, n2, e3, r3);
            });
          }
          return r2 = r2 ? r2.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
      });
    }
    function makeInvokeMethod(e2, r2, n2) {
      var o2 = h;
      return function(i2, a2) {
        if (o2 === f)
          throw Error("Generator is already running");
        if (o2 === s) {
          if ("throw" === i2)
            throw a2;
          return {
            value: t,
            done: true
          };
        }
        for (n2.method = i2, n2.arg = a2; ; ) {
          var c2 = n2.delegate;
          if (c2) {
            var u2 = maybeInvokeDelegate(c2, n2);
            if (u2) {
              if (u2 === y)
                continue;
              return u2;
            }
          }
          if ("next" === n2.method)
            n2.sent = n2._sent = n2.arg;
          else if ("throw" === n2.method) {
            if (o2 === h)
              throw o2 = s, n2.arg;
            n2.dispatchException(n2.arg);
          } else
            "return" === n2.method && n2.abrupt("return", n2.arg);
          o2 = f;
          var p2 = tryCatch(e2, r2, n2);
          if ("normal" === p2.type) {
            if (o2 = n2.done ? s : l, p2.arg === y)
              continue;
            return {
              value: p2.arg,
              done: n2.done
            };
          }
          "throw" === p2.type && (o2 = s, n2.method = "throw", n2.arg = p2.arg);
        }
      };
    }
    function maybeInvokeDelegate(e2, r2) {
      var n2 = r2.method, o2 = e2.iterator[n2];
      if (o2 === t)
        return r2.delegate = null, "throw" === n2 && e2.iterator["return"] && (r2.method = "return", r2.arg = t, maybeInvokeDelegate(e2, r2), "throw" === r2.method) || "return" !== n2 && (r2.method = "throw", r2.arg = new TypeError("The iterator does not provide a '" + n2 + "' method")), y;
      var i2 = tryCatch(o2, e2.iterator, r2.arg);
      if ("throw" === i2.type)
        return r2.method = "throw", r2.arg = i2.arg, r2.delegate = null, y;
      var a2 = i2.arg;
      return a2 ? a2.done ? (r2[e2.resultName] = a2.value, r2.next = e2.nextLoc, "return" !== r2.method && (r2.method = "next", r2.arg = t), r2.delegate = null, y) : a2 : (r2.method = "throw", r2.arg = new TypeError("iterator result is not an object"), r2.delegate = null, y);
    }
    function pushTryEntry(t2) {
      var e2 = {
        tryLoc: t2[0]
      };
      1 in t2 && (e2.catchLoc = t2[1]), 2 in t2 && (e2.finallyLoc = t2[2], e2.afterLoc = t2[3]), this.tryEntries.push(e2);
    }
    function resetTryEntry(t2) {
      var e2 = t2.completion || {};
      e2.type = "normal", delete e2.arg, t2.completion = e2;
    }
    function Context(t2) {
      this.tryEntries = [{
        tryLoc: "root"
      }], t2.forEach(pushTryEntry, this), this.reset(true);
    }
    function values4(e2) {
      if (e2 || "" === e2) {
        var r2 = e2[a];
        if (r2)
          return r2.call(e2);
        if ("function" == typeof e2.next)
          return e2;
        if (!isNaN(e2.length)) {
          var o2 = -1, i2 = function next3() {
            for (; ++o2 < e2.length; )
              if (n.call(e2, o2))
                return next3.value = e2[o2], next3.done = false, next3;
            return next3.value = t, next3.done = true, next3;
          };
          return i2.next = i2;
        }
      }
      throw new TypeError(_typeof2(e2) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
      value: GeneratorFunctionPrototype,
      configurable: true
    }), o(GeneratorFunctionPrototype, "constructor", {
      value: GeneratorFunction,
      configurable: true
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t2) {
      var e2 = "function" == typeof t2 && t2.constructor;
      return !!e2 && (e2 === GeneratorFunction || "GeneratorFunction" === (e2.displayName || e2.name));
    }, e.mark = function(t2) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(t2, GeneratorFunctionPrototype) : (t2.__proto__ = GeneratorFunctionPrototype, define(t2, u, "GeneratorFunction")), t2.prototype = Object.create(g), t2;
    }, e.awrap = function(t2) {
      return {
        __await: t2
      };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
      return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t2, r2, n2, o2, i2) {
      void 0 === i2 && (i2 = Promise);
      var a2 = new AsyncIterator(wrap2(t2, r2, n2, o2), i2);
      return e.isGeneratorFunction(r2) ? a2 : a2.next().then(function(t3) {
        return t3.done ? t3.value : a2.next();
      });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
      return this;
    }), define(g, "toString", function() {
      return "[object Generator]";
    }), e.keys = function(t2) {
      var e2 = Object(t2), r2 = [];
      for (var n2 in e2)
        r2.push(n2);
      return r2.reverse(), function next3() {
        for (; r2.length; ) {
          var t3 = r2.pop();
          if (t3 in e2)
            return next3.value = t3, next3.done = false, next3;
        }
        return next3.done = true, next3;
      };
    }, e.values = values4, Context.prototype = {
      constructor: Context,
      reset: function reset(e2) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = false, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e2)
          for (var r2 in this)
            "t" === r2.charAt(0) && n.call(this, r2) && !isNaN(+r2.slice(1)) && (this[r2] = t);
      },
      stop: function stop() {
        this.done = true;
        var t2 = this.tryEntries[0].completion;
        if ("throw" === t2.type)
          throw t2.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(e2) {
        if (this.done)
          throw e2;
        var r2 = this;
        function handle(n2, o3) {
          return a2.type = "throw", a2.arg = e2, r2.next = n2, o3 && (r2.method = "next", r2.arg = t), !!o3;
        }
        for (var o2 = this.tryEntries.length - 1; o2 >= 0; --o2) {
          var i2 = this.tryEntries[o2], a2 = i2.completion;
          if ("root" === i2.tryLoc)
            return handle("end");
          if (i2.tryLoc <= this.prev) {
            var c2 = n.call(i2, "catchLoc"), u2 = n.call(i2, "finallyLoc");
            if (c2 && u2) {
              if (this.prev < i2.catchLoc)
                return handle(i2.catchLoc, true);
              if (this.prev < i2.finallyLoc)
                return handle(i2.finallyLoc);
            } else if (c2) {
              if (this.prev < i2.catchLoc)
                return handle(i2.catchLoc, true);
            } else {
              if (!u2)
                throw Error("try statement without catch or finally");
              if (this.prev < i2.finallyLoc)
                return handle(i2.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(t2, e2) {
        for (var r2 = this.tryEntries.length - 1; r2 >= 0; --r2) {
          var o2 = this.tryEntries[r2];
          if (o2.tryLoc <= this.prev && n.call(o2, "finallyLoc") && this.prev < o2.finallyLoc) {
            var i2 = o2;
            break;
          }
        }
        i2 && ("break" === t2 || "continue" === t2) && i2.tryLoc <= e2 && e2 <= i2.finallyLoc && (i2 = null);
        var a2 = i2 ? i2.completion : {};
        return a2.type = t2, a2.arg = e2, i2 ? (this.method = "next", this.next = i2.finallyLoc, y) : this.complete(a2);
      },
      complete: function complete(t2, e2) {
        if ("throw" === t2.type)
          throw t2.arg;
        return "break" === t2.type || "continue" === t2.type ? this.next = t2.arg : "return" === t2.type ? (this.rval = this.arg = t2.arg, this.method = "return", this.next = "end") : "normal" === t2.type && e2 && (this.next = e2), y;
      },
      finish: function finish(t2) {
        for (var e2 = this.tryEntries.length - 1; e2 >= 0; --e2) {
          var r2 = this.tryEntries[e2];
          if (r2.finallyLoc === t2)
            return this.complete(r2.completion, r2.afterLoc), resetTryEntry(r2), y;
        }
      },
      "catch": function _catch(t2) {
        for (var e2 = this.tryEntries.length - 1; e2 >= 0; --e2) {
          var r2 = this.tryEntries[e2];
          if (r2.tryLoc === t2) {
            var n2 = r2.completion;
            if ("throw" === n2.type) {
              var o2 = n2.arg;
              resetTryEntry(r2);
            }
            return o2;
          }
        }
        throw Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(e2, r2, n2) {
        return this.delegate = {
          iterator: values4(e2),
          resultName: r2,
          nextLoc: n2
        }, "next" === this.method && (this.arg = t), y;
      }
    }, e;
  }
  module.exports = _regeneratorRuntime2, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(regeneratorRuntime$1);
var regeneratorRuntimeExports = regeneratorRuntime$1.exports;
var runtime = regeneratorRuntimeExports();
var regenerator = runtime;
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
var $TypeError$6 = TypeError;
var MAX_SAFE_INTEGER = 9007199254740991;
var doesNotExceedSafeInteger$2 = function(it) {
  if (it > MAX_SAFE_INTEGER)
    throw $TypeError$6("Maximum allowed index exceeded");
  return it;
};
var $$o = _export;
var fails$t = fails$M;
var isArray$2 = isArray$5;
var isObject$d = isObject$q;
var toObject$a = toObject$f;
var lengthOfArrayLike$c = lengthOfArrayLike$g;
var doesNotExceedSafeInteger$1 = doesNotExceedSafeInteger$2;
var createProperty$3 = createProperty$5;
var arraySpeciesCreate$1 = arraySpeciesCreate$3;
var arrayMethodHasSpeciesSupport$2 = arrayMethodHasSpeciesSupport$5;
var wellKnownSymbol$d = wellKnownSymbol$t;
var V8_VERSION = engineV8Version;
var IS_CONCAT_SPREADABLE = wellKnownSymbol$d("isConcatSpreadable");
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails$t(function() {
  var array5 = [];
  array5[IS_CONCAT_SPREADABLE] = false;
  return array5.concat()[0] !== array5;
});
var isConcatSpreadable = function(O) {
  if (!isObject$d(O))
    return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== void 0 ? !!spreadable : isArray$2(O);
};
var FORCED$6 = !IS_CONCAT_SPREADABLE_SUPPORT || !arrayMethodHasSpeciesSupport$2("concat");
$$o({ target: "Array", proto: true, arity: 1, forced: FORCED$6 }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject$a(this);
    var A = arraySpeciesCreate$1(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = lengthOfArrayLike$c(E);
        doesNotExceedSafeInteger$1(n + len);
        for (k = 0; k < len; k++, n++)
          if (k in E)
            createProperty$3(A, n, E[k]);
      } else {
        doesNotExceedSafeInteger$1(n + 1);
        createProperty$3(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});
var anObject$a = anObject$m;
var iteratorClose = iteratorClose$2;
var callWithSafeIterationClosing$1 = function(iterator, fn, value, ENTRIES2) {
  try {
    return ENTRIES2 ? fn(anObject$a(value)[0], value[1]) : fn(value);
  } catch (error2) {
    iteratorClose(iterator, "throw", error2);
  }
};
var bind$4 = functionBindContext;
var call$g = functionCall;
var toObject$9 = toObject$f;
var callWithSafeIterationClosing = callWithSafeIterationClosing$1;
var isArrayIteratorMethod$1 = isArrayIteratorMethod$3;
var isConstructor$1 = isConstructor$4;
var lengthOfArrayLike$b = lengthOfArrayLike$g;
var createProperty$2 = createProperty$5;
var getIterator$2 = getIterator$4;
var getIteratorMethod$2 = getIteratorMethod$5;
var $Array$2 = Array;
var arrayFrom$1 = function from(arrayLike) {
  var O = toObject$9(arrayLike);
  var IS_CONSTRUCTOR = isConstructor$1(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : void 0;
  var mapping = mapfn !== void 0;
  if (mapping)
    mapfn = bind$4(mapfn, argumentsLength > 2 ? arguments[2] : void 0);
  var iteratorMethod = getIteratorMethod$2(O);
  var index2 = 0;
  var length, result, step, iterator, next3, value;
  if (iteratorMethod && !(this === $Array$2 && isArrayIteratorMethod$1(iteratorMethod))) {
    result = IS_CONSTRUCTOR ? new this() : [];
    iterator = getIterator$2(O, iteratorMethod);
    next3 = iterator.next;
    for (; !(step = call$g(next3, iterator)).done; index2++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index2], true) : step.value;
      createProperty$2(result, index2, value);
    }
  } else {
    length = lengthOfArrayLike$b(O);
    result = IS_CONSTRUCTOR ? new this(length) : $Array$2(length);
    for (; length > index2; index2++) {
      value = mapping ? mapfn(O[index2], index2) : O[index2];
      createProperty$2(result, index2, value);
    }
  }
  result.length = index2;
  return result;
};
var $$n = _export;
var from2 = arrayFrom$1;
var checkCorrectnessOfIteration$2 = checkCorrectnessOfIteration$4;
var INCORRECT_ITERATION = !checkCorrectnessOfIteration$2(function(iterable) {
  Array.from(iterable);
});
$$n({ target: "Array", stat: true, forced: INCORRECT_ITERATION }, {
  from: from2
});
var uncurryThis$s = functionUncurryThis;
var toIntegerOrInfinity$7 = toIntegerOrInfinity$a;
var toString$c = toString$g;
var requireObjectCoercible$7 = requireObjectCoercible$b;
var charAt$6 = uncurryThis$s("".charAt);
var charCodeAt$2 = uncurryThis$s("".charCodeAt);
var stringSlice$9 = uncurryThis$s("".slice);
var createMethod$3 = function(CONVERT_TO_STRING) {
  return function($this, pos) {
    var S = toString$c(requireObjectCoercible$7($this));
    var position = toIntegerOrInfinity$7(pos);
    var size2 = S.length;
    var first, second;
    if (position < 0 || position >= size2)
      return CONVERT_TO_STRING ? "" : void 0;
    first = charCodeAt$2(S, position);
    return first < 55296 || first > 56319 || position + 1 === size2 || (second = charCodeAt$2(S, position + 1)) < 56320 || second > 57343 ? CONVERT_TO_STRING ? charAt$6(S, position) : first : CONVERT_TO_STRING ? stringSlice$9(S, position, position + 2) : (first - 55296 << 10) + (second - 56320) + 65536;
  };
};
var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$3(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$3(true)
};
var fails$s = fails$M;
var correctPrototypeGetter = !fails$s(function() {
  function F() {
  }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});
var hasOwn$9 = hasOwnProperty_1;
var isCallable$a = isCallable$t;
var toObject$8 = toObject$f;
var sharedKey = sharedKey$4;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;
var IE_PROTO = sharedKey("IE_PROTO");
var $Object = Object;
var ObjectPrototype$2 = $Object.prototype;
var objectGetPrototypeOf$1 = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function(O) {
  var object = toObject$8(O);
  if (hasOwn$9(object, IE_PROTO))
    return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$a(constructor) && object instanceof constructor) {
    return constructor.prototype;
  }
  return object instanceof $Object ? ObjectPrototype$2 : null;
};
var fails$r = fails$M;
var isCallable$9 = isCallable$t;
var isObject$c = isObject$q;
var create$6 = objectCreate;
var getPrototypeOf$3 = objectGetPrototypeOf$1;
var defineBuiltIn$8 = defineBuiltIn$f;
var wellKnownSymbol$c = wellKnownSymbol$t;
var IS_PURE$5 = isPure;
var ITERATOR$5 = wellKnownSymbol$c("iterator");
var BUGGY_SAFARI_ITERATORS$1 = false;
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;
if ([].keys) {
  arrayIterator = [].keys();
  if (!("next" in arrayIterator))
    BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$3(getPrototypeOf$3(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype)
      IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}
var NEW_ITERATOR_PROTOTYPE = !isObject$c(IteratorPrototype$2) || fails$r(function() {
  var test2 = {};
  return IteratorPrototype$2[ITERATOR$5].call(test2) !== test2;
});
if (NEW_ITERATOR_PROTOTYPE)
  IteratorPrototype$2 = {};
else if (IS_PURE$5)
  IteratorPrototype$2 = create$6(IteratorPrototype$2);
if (!isCallable$9(IteratorPrototype$2[ITERATOR$5])) {
  defineBuiltIn$8(IteratorPrototype$2, ITERATOR$5, function() {
    return this;
  });
}
var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};
var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create$5 = objectCreate;
var createPropertyDescriptor$2 = createPropertyDescriptor$7;
var setToStringTag$6 = setToStringTag$a;
var Iterators$2 = iterators;
var returnThis$1 = function() {
  return this;
};
var iteratorCreateConstructor = function(IteratorConstructor, NAME2, next3, ENUMERABLE_NEXT) {
  var TO_STRING_TAG2 = NAME2 + " Iterator";
  IteratorConstructor.prototype = create$5(IteratorPrototype$1, { next: createPropertyDescriptor$2(+!ENUMERABLE_NEXT, next3) });
  setToStringTag$6(IteratorConstructor, TO_STRING_TAG2, false, true);
  Iterators$2[TO_STRING_TAG2] = returnThis$1;
  return IteratorConstructor;
};
var $$m = _export;
var call$f = functionCall;
var IS_PURE$4 = isPure;
var FunctionName$1 = functionName;
var isCallable$8 = isCallable$t;
var createIteratorConstructor$1 = iteratorCreateConstructor;
var getPrototypeOf$2 = objectGetPrototypeOf$1;
var setPrototypeOf$4 = objectSetPrototypeOf;
var setToStringTag$5 = setToStringTag$a;
var createNonEnumerableProperty$5 = createNonEnumerableProperty$9;
var defineBuiltIn$7 = defineBuiltIn$f;
var wellKnownSymbol$b = wellKnownSymbol$t;
var Iterators$1 = iterators;
var IteratorsCore = iteratorsCore;
var PROPER_FUNCTION_NAME$2 = FunctionName$1.PROPER;
var CONFIGURABLE_FUNCTION_NAME$1 = FunctionName$1.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$4 = wellKnownSymbol$b("iterator");
var KEYS = "keys";
var VALUES = "values";
var ENTRIES = "entries";
var returnThis = function() {
  return this;
};
var iteratorDefine = function(Iterable, NAME2, IteratorConstructor, next3, DEFAULT, IS_SET, FORCED2) {
  createIteratorConstructor$1(IteratorConstructor, NAME2, next3);
  var getIterationMethod = function(KIND) {
    if (KIND === DEFAULT && defaultIterator)
      return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype)
      return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS:
        return function keys6() {
          return new IteratorConstructor(this, KIND);
        };
      case VALUES:
        return function values4() {
          return new IteratorConstructor(this, KIND);
        };
      case ENTRIES:
        return function entries4() {
          return new IteratorConstructor(this, KIND);
        };
    }
    return function() {
      return new IteratorConstructor(this);
    };
  };
  var TO_STRING_TAG2 = NAME2 + " Iterator";
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$4] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME2 === "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf$2(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE$4 && getPrototypeOf$2(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf$4) {
          setPrototypeOf$4(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable$8(CurrentIteratorPrototype[ITERATOR$4])) {
          defineBuiltIn$7(CurrentIteratorPrototype, ITERATOR$4, returnThis);
        }
      }
      setToStringTag$5(CurrentIteratorPrototype, TO_STRING_TAG2, true, true);
      if (IS_PURE$4)
        Iterators$1[TO_STRING_TAG2] = returnThis;
    }
  }
  if (PROPER_FUNCTION_NAME$2 && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (!IS_PURE$4 && CONFIGURABLE_FUNCTION_NAME$1) {
      createNonEnumerableProperty$5(IterablePrototype, "name", VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values4() {
        return call$f(nativeIterator, this);
      };
    }
  }
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED2)
      for (KEY in methods) {
        if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
          defineBuiltIn$7(IterablePrototype, KEY, methods[KEY]);
        }
      }
    else
      $$m({ target: NAME2, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }
  if ((!IS_PURE$4 || FORCED2) && IterablePrototype[ITERATOR$4] !== defaultIterator) {
    defineBuiltIn$7(IterablePrototype, ITERATOR$4, defaultIterator, { name: DEFAULT });
  }
  Iterators$1[NAME2] = defaultIterator;
  return methods;
};
var createIterResultObject$4 = function(value, done) {
  return { value, done };
};
var charAt$5 = stringMultibyte.charAt;
var toString$b = toString$g;
var InternalStateModule$8 = internalState;
var defineIterator$2 = iteratorDefine;
var createIterResultObject$3 = createIterResultObject$4;
var STRING_ITERATOR = "String Iterator";
var setInternalState$7 = InternalStateModule$8.set;
var getInternalState$4 = InternalStateModule$8.getterFor(STRING_ITERATOR);
defineIterator$2(String, "String", function(iterated) {
  setInternalState$7(this, {
    type: STRING_ITERATOR,
    string: toString$b(iterated),
    index: 0
  });
}, function next() {
  var state = getInternalState$4(this);
  var string = state.string;
  var index2 = state.index;
  var point;
  if (index2 >= string.length)
    return createIterResultObject$3(void 0, true);
  point = charAt$5(string, index2);
  state.index += point.length;
  return createIterResultObject$3(point, false);
});
var loglevel$1 = { exports: {} };
loglevel$1.exports;
(function(module) {
  (function(root, definition) {
    if (module.exports) {
      module.exports = definition();
    } else {
      root.log = definition();
    }
  })(commonjsGlobal, function() {
    var noop2 = function() {
    };
    var undefinedType = "undefined";
    var isIE = typeof window !== undefinedType && typeof window.navigator !== undefinedType && /Trident\/|MSIE /.test(window.navigator.userAgent);
    var logMethods = [
      "trace",
      "debug",
      "info",
      "warn",
      "error"
    ];
    var _loggersByName = {};
    var defaultLogger = null;
    function bindMethod(obj, methodName) {
      var method = obj[methodName];
      if (typeof method.bind === "function") {
        return method.bind(obj);
      } else {
        try {
          return Function.prototype.bind.call(method, obj);
        } catch (e) {
          return function() {
            return Function.prototype.apply.apply(method, [obj, arguments]);
          };
        }
      }
    }
    function traceForIE() {
      if (console.log) {
        if (console.log.apply) {
          console.log.apply(console, arguments);
        } else {
          Function.prototype.apply.apply(console.log, [console, arguments]);
        }
      }
      if (console.trace)
        console.trace();
    }
    function realMethod(methodName) {
      if (methodName === "debug") {
        methodName = "log";
      }
      if (typeof console === undefinedType) {
        return false;
      } else if (methodName === "trace" && isIE) {
        return traceForIE;
      } else if (console[methodName] !== void 0) {
        return bindMethod(console, methodName);
      } else if (console.log !== void 0) {
        return bindMethod(console, "log");
      } else {
        return noop2;
      }
    }
    function replaceLoggingMethods() {
      var level = this.getLevel();
      for (var i = 0; i < logMethods.length; i++) {
        var methodName = logMethods[i];
        this[methodName] = i < level ? noop2 : this.methodFactory(methodName, level, this.name);
      }
      this.log = this.debug;
      if (typeof console === undefinedType && level < this.levels.SILENT) {
        return "No console available for logging";
      }
    }
    function enableLoggingWhenConsoleArrives(methodName) {
      return function() {
        if (typeof console !== undefinedType) {
          replaceLoggingMethods.call(this);
          this[methodName].apply(this, arguments);
        }
      };
    }
    function defaultMethodFactory(methodName, _level, _loggerName) {
      return realMethod(methodName) || enableLoggingWhenConsoleArrives.apply(this, arguments);
    }
    function Logger(name, factory) {
      var self2 = this;
      var inheritedLevel;
      var defaultLevel;
      var userLevel;
      var storageKey = "loglevel";
      if (typeof name === "string") {
        storageKey += ":" + name;
      } else if (typeof name === "symbol") {
        storageKey = void 0;
      }
      function persistLevelIfPossible(levelNum) {
        var levelName = (logMethods[levelNum] || "silent").toUpperCase();
        if (typeof window === undefinedType || !storageKey)
          return;
        try {
          window.localStorage[storageKey] = levelName;
          return;
        } catch (ignore) {
        }
        try {
          window.document.cookie = encodeURIComponent(storageKey) + "=" + levelName + ";";
        } catch (ignore) {
        }
      }
      function getPersistedLevel() {
        var storedLevel;
        if (typeof window === undefinedType || !storageKey)
          return;
        try {
          storedLevel = window.localStorage[storageKey];
        } catch (ignore) {
        }
        if (typeof storedLevel === undefinedType) {
          try {
            var cookie = window.document.cookie;
            var cookieName = encodeURIComponent(storageKey);
            var location = cookie.indexOf(cookieName + "=");
            if (location !== -1) {
              storedLevel = /^([^;]+)/.exec(
                cookie.slice(location + cookieName.length + 1)
              )[1];
            }
          } catch (ignore) {
          }
        }
        if (self2.levels[storedLevel] === void 0) {
          storedLevel = void 0;
        }
        return storedLevel;
      }
      function clearPersistedLevel() {
        if (typeof window === undefinedType || !storageKey)
          return;
        try {
          window.localStorage.removeItem(storageKey);
        } catch (ignore) {
        }
        try {
          window.document.cookie = encodeURIComponent(storageKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
        } catch (ignore) {
        }
      }
      function normalizeLevel(input) {
        var level = input;
        if (typeof level === "string" && self2.levels[level.toUpperCase()] !== void 0) {
          level = self2.levels[level.toUpperCase()];
        }
        if (typeof level === "number" && level >= 0 && level <= self2.levels.SILENT) {
          return level;
        } else {
          throw new TypeError("log.setLevel() called with invalid level: " + input);
        }
      }
      self2.name = name;
      self2.levels = {
        "TRACE": 0,
        "DEBUG": 1,
        "INFO": 2,
        "WARN": 3,
        "ERROR": 4,
        "SILENT": 5
      };
      self2.methodFactory = factory || defaultMethodFactory;
      self2.getLevel = function() {
        if (userLevel != null) {
          return userLevel;
        } else if (defaultLevel != null) {
          return defaultLevel;
        } else {
          return inheritedLevel;
        }
      };
      self2.setLevel = function(level, persist) {
        userLevel = normalizeLevel(level);
        if (persist !== false) {
          persistLevelIfPossible(userLevel);
        }
        return replaceLoggingMethods.call(self2);
      };
      self2.setDefaultLevel = function(level) {
        defaultLevel = normalizeLevel(level);
        if (!getPersistedLevel()) {
          self2.setLevel(level, false);
        }
      };
      self2.resetLevel = function() {
        userLevel = null;
        clearPersistedLevel();
        replaceLoggingMethods.call(self2);
      };
      self2.enableAll = function(persist) {
        self2.setLevel(self2.levels.TRACE, persist);
      };
      self2.disableAll = function(persist) {
        self2.setLevel(self2.levels.SILENT, persist);
      };
      self2.rebuild = function() {
        if (defaultLogger !== self2) {
          inheritedLevel = normalizeLevel(defaultLogger.getLevel());
        }
        replaceLoggingMethods.call(self2);
        if (defaultLogger === self2) {
          for (var childName in _loggersByName) {
            _loggersByName[childName].rebuild();
          }
        }
      };
      inheritedLevel = normalizeLevel(
        defaultLogger ? defaultLogger.getLevel() : "WARN"
      );
      var initialLevel = getPersistedLevel();
      if (initialLevel != null) {
        userLevel = normalizeLevel(initialLevel);
      }
      replaceLoggingMethods.call(self2);
    }
    defaultLogger = new Logger();
    defaultLogger.getLogger = function getLogger(name) {
      if (typeof name !== "symbol" && typeof name !== "string" || name === "") {
        throw new TypeError("You must supply a name when creating a logger.");
      }
      var logger = _loggersByName[name];
      if (!logger) {
        logger = _loggersByName[name] = new Logger(
          name,
          defaultLogger.methodFactory
        );
      }
      return logger;
    };
    var _log = typeof window !== undefinedType ? window.log : void 0;
    defaultLogger.noConflict = function() {
      if (typeof window !== undefinedType && window.log === defaultLogger) {
        window.log = _log;
      }
      return defaultLogger;
    };
    defaultLogger.getLoggers = function getLoggers() {
      return _loggersByName;
    };
    defaultLogger["default"] = defaultLogger;
    return defaultLogger;
  });
})(loglevel$1);
var loglevelExports$1 = loglevel$1.exports;
const numbers = "\\d+(?:[\\.,]\\d+)?";
const weekPattern = `(${numbers}W)`;
const datePattern = `(${numbers}Y)?(${numbers}M)?(${numbers}D)?`;
const timePattern = `T(${numbers}H)?(${numbers}M)?(${numbers}S)?`;
const iso8601 = `P(?:${weekPattern}|${datePattern}(?:${timePattern})?)`;
const objMap = ["weeks", "years", "months", "days", "hours", "minutes", "seconds"];
const pattern = new RegExp(iso8601);
const parse = (durationString) => {
  return durationString.match(pattern).slice(1).reduce((prev, next3, idx) => {
    prev[objMap[idx]] = parseFloat(next3) || 0;
    return prev;
  }, {});
};
const end = (duration, startDate) => {
  const timestamp = startDate ? startDate.getTime() : Date.now();
  const then2 = new Date(timestamp);
  then2.setFullYear(then2.getFullYear() + duration.years);
  then2.setMonth(then2.getMonth() + duration.months);
  then2.setDate(then2.getDate() + duration.days);
  then2.setHours(then2.getHours() + duration.hours);
  then2.setMinutes(then2.getMinutes() + duration.minutes);
  then2.setMilliseconds(then2.getMilliseconds() + duration.seconds * 1e3);
  then2.setDate(then2.getDate() + duration.weeks * 7);
  return then2;
};
const toSeconds = (duration, startDate) => {
  const timestamp = startDate ? startDate.getTime() : Date.now();
  const now = new Date(timestamp);
  const then2 = end(duration, now);
  const seconds = (then2.getTime() - now.getTime()) / 1e3;
  return seconds;
};
const index = {
  end,
  toSeconds,
  pattern,
  parse
};
const src = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: index,
  end,
  parse,
  pattern,
  toSeconds
}, Symbol.toStringTag, { value: "Module" }));
const require$$25 = /* @__PURE__ */ getAugmentedNamespace(src);
var wellKnownSymbol$a = wellKnownSymbol$t;
var create$4 = objectCreate;
var defineProperty$4 = objectDefineProperty.f;
var UNSCOPABLES = wellKnownSymbol$a("unscopables");
var ArrayPrototype = Array.prototype;
if (ArrayPrototype[UNSCOPABLES] === void 0) {
  defineProperty$4(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create$4(null)
  });
}
var addToUnscopables$3 = function(key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};
var toIndexedObject$5 = toIndexedObject$e;
var addToUnscopables$2 = addToUnscopables$3;
var Iterators = iterators;
var InternalStateModule$7 = internalState;
var defineProperty$3 = objectDefineProperty.f;
var defineIterator$1 = iteratorDefine;
var createIterResultObject$2 = createIterResultObject$4;
var IS_PURE$3 = isPure;
var DESCRIPTORS$d = descriptors;
var ARRAY_ITERATOR = "Array Iterator";
var setInternalState$6 = InternalStateModule$7.set;
var getInternalState$3 = InternalStateModule$7.getterFor(ARRAY_ITERATOR);
var es_array_iterator = defineIterator$1(Array, "Array", function(iterated, kind) {
  setInternalState$6(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject$5(iterated),
    // target
    index: 0,
    // next index
    kind
    // kind
  });
}, function() {
  var state = getInternalState$3(this);
  var target = state.target;
  var index2 = state.index++;
  if (!target || index2 >= target.length) {
    state.target = void 0;
    return createIterResultObject$2(void 0, true);
  }
  switch (state.kind) {
    case "keys":
      return createIterResultObject$2(index2, false);
    case "values":
      return createIterResultObject$2(target[index2], false);
  }
  return createIterResultObject$2([index2, target[index2]], false);
}, "values");
var values = Iterators.Arguments = Iterators.Array;
addToUnscopables$2("keys");
addToUnscopables$2("values");
addToUnscopables$2("entries");
if (!IS_PURE$3 && DESCRIPTORS$d && values.name !== "values")
  try {
    defineProperty$3(values, "name", { value: "values" });
  } catch (error2) {
  }
var global$i = global$D;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$9;
var setToStringTag$4 = setToStringTag$a;
var wellKnownSymbol$9 = wellKnownSymbol$t;
var ITERATOR$3 = wellKnownSymbol$9("iterator");
var ArrayValues = ArrayIteratorMethods.values;
var handlePrototype = function(CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    if (CollectionPrototype[ITERATOR$3] !== ArrayValues)
      try {
        createNonEnumerableProperty$4(CollectionPrototype, ITERATOR$3, ArrayValues);
      } catch (error2) {
        CollectionPrototype[ITERATOR$3] = ArrayValues;
      }
    setToStringTag$4(CollectionPrototype, COLLECTION_NAME, true);
    if (DOMIterables[COLLECTION_NAME])
      for (var METHOD_NAME in ArrayIteratorMethods) {
        if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME])
          try {
            createNonEnumerableProperty$4(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
          } catch (error2) {
            CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
          }
      }
  }
};
for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global$i[COLLECTION_NAME] && global$i[COLLECTION_NAME].prototype, COLLECTION_NAME);
}
handlePrototype(DOMTokenListPrototype, "DOMTokenList");
var isCallable$7 = isCallable$t;
var isObject$b = isObject$q;
var setPrototypeOf$3 = objectSetPrototypeOf;
var inheritIfRequired$4 = function($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf$3 && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable$7(NewTarget = dummy.constructor) && NewTarget !== Wrapper && isObject$b(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype
  )
    setPrototypeOf$3($this, NewTargetPrototype);
  return $this;
};
var uncurryThis$r = functionUncurryThis;
var thisNumberValue$1 = uncurryThis$r(1 .valueOf);
var whitespaces$1 = "	\n\v\f\r                　\u2028\u2029\uFEFF";
var uncurryThis$q = functionUncurryThis;
var requireObjectCoercible$6 = requireObjectCoercible$b;
var toString$a = toString$g;
var whitespaces = whitespaces$1;
var replace$6 = uncurryThis$q("".replace);
var ltrim = RegExp("^[" + whitespaces + "]+");
var rtrim = RegExp("(^|[^" + whitespaces + "])[" + whitespaces + "]+$");
var createMethod$2 = function(TYPE) {
  return function($this) {
    var string = toString$a(requireObjectCoercible$6($this));
    if (TYPE & 1)
      string = replace$6(string, ltrim, "");
    if (TYPE & 2)
      string = replace$6(string, rtrim, "$1");
    return string;
  };
};
var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod$2(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod$2(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod$2(3)
};
var $$l = _export;
var IS_PURE$2 = isPure;
var DESCRIPTORS$c = descriptors;
var global$h = global$D;
var path = path$2;
var uncurryThis$p = functionUncurryThis;
var isForced$1 = isForced_1;
var hasOwn$8 = hasOwnProperty_1;
var inheritIfRequired$3 = inheritIfRequired$4;
var isPrototypeOf$4 = objectIsPrototypeOf;
var isSymbol$1 = isSymbol$6;
var toPrimitive$1 = toPrimitive$4;
var fails$q = fails$M;
var getOwnPropertyNames$1 = objectGetOwnPropertyNames.f;
var getOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor.f;
var defineProperty$2 = objectDefineProperty.f;
var thisNumberValue = thisNumberValue$1;
var trim = stringTrim.trim;
var NUMBER = "Number";
var NativeNumber = global$h[NUMBER];
var PureNumberNamespace = path[NUMBER];
var NumberPrototype = NativeNumber.prototype;
var TypeError$4 = global$h.TypeError;
var stringSlice$8 = uncurryThis$p("".slice);
var charCodeAt$1 = uncurryThis$p("".charCodeAt);
var toNumeric = function(value) {
  var primValue = toPrimitive$1(value, "number");
  return typeof primValue == "bigint" ? primValue : toNumber(primValue);
};
var toNumber = function(argument) {
  var it = toPrimitive$1(argument, "number");
  var first, third, radix, maxCode, digits, length, index2, code;
  if (isSymbol$1(it))
    throw new TypeError$4("Cannot convert a Symbol value to a number");
  if (typeof it == "string" && it.length > 2) {
    it = trim(it);
    first = charCodeAt$1(it, 0);
    if (first === 43 || first === 45) {
      third = charCodeAt$1(it, 2);
      if (third === 88 || third === 120)
        return NaN;
    } else if (first === 48) {
      switch (charCodeAt$1(it, 1)) {
        case 66:
        case 98:
          radix = 2;
          maxCode = 49;
          break;
        case 79:
        case 111:
          radix = 8;
          maxCode = 55;
          break;
        default:
          return +it;
      }
      digits = stringSlice$8(it, 2);
      length = digits.length;
      for (index2 = 0; index2 < length; index2++) {
        code = charCodeAt$1(digits, index2);
        if (code < 48 || code > maxCode)
          return NaN;
      }
      return parseInt(digits, radix);
    }
  }
  return +it;
};
var FORCED$5 = isForced$1(NUMBER, !NativeNumber(" 0o1") || !NativeNumber("0b1") || NativeNumber("+0x1"));
var calledWithNew = function(dummy) {
  return isPrototypeOf$4(NumberPrototype, dummy) && fails$q(function() {
    thisNumberValue(dummy);
  });
};
var NumberWrapper = function Number2(value) {
  var n = arguments.length < 1 ? 0 : NativeNumber(toNumeric(value));
  return calledWithNew(this) ? inheritIfRequired$3(Object(n), this, NumberWrapper) : n;
};
NumberWrapper.prototype = NumberPrototype;
if (FORCED$5 && !IS_PURE$2)
  NumberPrototype.constructor = NumberWrapper;
$$l({ global: true, constructor: true, wrap: true, forced: FORCED$5 }, {
  Number: NumberWrapper
});
var copyConstructorProperties$2 = function(target, source) {
  for (var keys6 = DESCRIPTORS$c ? getOwnPropertyNames$1(source) : (
    // ES3:
    "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,fromString,range".split(",")
  ), j = 0, key; keys6.length > j; j++) {
    if (hasOwn$8(source, key = keys6[j]) && !hasOwn$8(target, key)) {
      defineProperty$2(target, key, getOwnPropertyDescriptor$2(source, key));
    }
  }
};
if (IS_PURE$2 && PureNumberNamespace)
  copyConstructorProperties$2(path[NUMBER], PureNumberNamespace);
if (FORCED$5 || IS_PURE$2)
  copyConstructorProperties$2(path[NUMBER], NativeNumber);
var anObject$9 = anObject$m;
var regexpFlags$1 = function() {
  var that = anObject$9(this);
  var result = "";
  if (that.hasIndices)
    result += "d";
  if (that.global)
    result += "g";
  if (that.ignoreCase)
    result += "i";
  if (that.multiline)
    result += "m";
  if (that.dotAll)
    result += "s";
  if (that.unicode)
    result += "u";
  if (that.unicodeSets)
    result += "v";
  if (that.sticky)
    result += "y";
  return result;
};
var fails$p = fails$M;
var global$g = global$D;
var $RegExp$2 = global$g.RegExp;
var UNSUPPORTED_Y$2 = fails$p(function() {
  var re = $RegExp$2("a", "y");
  re.lastIndex = 2;
  return re.exec("abcd") !== null;
});
var MISSED_STICKY = UNSUPPORTED_Y$2 || fails$p(function() {
  return !$RegExp$2("a", "y").sticky;
});
var BROKEN_CARET = UNSUPPORTED_Y$2 || fails$p(function() {
  var re = $RegExp$2("^r", "gy");
  re.lastIndex = 2;
  return re.exec("str") !== null;
});
var regexpStickyHelpers = {
  BROKEN_CARET,
  MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y$2
};
var fails$o = fails$M;
var global$f = global$D;
var $RegExp$1 = global$f.RegExp;
var regexpUnsupportedDotAll = fails$o(function() {
  var re = $RegExp$1(".", "s");
  return !(re.dotAll && re.test("\n") && re.flags === "s");
});
var fails$n = fails$M;
var global$e = global$D;
var $RegExp = global$e.RegExp;
var regexpUnsupportedNcg = fails$n(function() {
  var re = $RegExp("(?<a>b)", "g");
  return re.exec("b").groups.a !== "b" || "b".replace(re, "$<a>c") !== "bc";
});
var call$e = functionCall;
var uncurryThis$o = functionUncurryThis;
var toString$9 = toString$g;
var regexpFlags = regexpFlags$1;
var stickyHelpers$1 = regexpStickyHelpers;
var shared = shared$7;
var create$3 = objectCreate;
var getInternalState$2 = internalState.get;
var UNSUPPORTED_DOT_ALL = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG = regexpUnsupportedNcg;
var nativeReplace = shared("native-string-replace", String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt$4 = uncurryThis$o("".charAt);
var indexOf = uncurryThis$o("".indexOf);
var replace$5 = uncurryThis$o("".replace);
var stringSlice$7 = uncurryThis$o("".slice);
var UPDATES_LAST_INDEX_WRONG = function() {
  var re1 = /a/;
  var re2 = /b*/g;
  call$e(nativeExec, re1, "a");
  call$e(nativeExec, re2, "a");
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
}();
var UNSUPPORTED_Y$1 = stickyHelpers$1.BROKEN_CARET;
var NPCG_INCLUDED = /()??/.exec("")[1] !== void 0;
var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y$1 || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;
if (PATCH) {
  patchedExec = function exec2(string) {
    var re = this;
    var state = getInternalState$2(re);
    var str = toString$9(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match2, i, object, group;
    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call$e(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }
    var groups = state.groups;
    var sticky = UNSUPPORTED_Y$1 && re.sticky;
    var flags = call$e(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;
    if (sticky) {
      flags = replace$5(flags, "y", "");
      if (indexOf(flags, "g") === -1) {
        flags += "g";
      }
      strCopy = stringSlice$7(str, re.lastIndex);
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt$4(str, re.lastIndex - 1) !== "\n")) {
        source = "(?: " + source + ")";
        strCopy = " " + strCopy;
        charsAdded++;
      }
      reCopy = new RegExp("^(?:" + source + ")", flags);
    }
    if (NPCG_INCLUDED) {
      reCopy = new RegExp("^" + source + "$(?!\\s)", flags);
    }
    if (UPDATES_LAST_INDEX_WRONG)
      lastIndex = re.lastIndex;
    match2 = call$e(nativeExec, sticky ? reCopy : re, strCopy);
    if (sticky) {
      if (match2) {
        match2.input = stringSlice$7(match2.input, charsAdded);
        match2[0] = stringSlice$7(match2[0], charsAdded);
        match2.index = re.lastIndex;
        re.lastIndex += match2[0].length;
      } else
        re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match2) {
      re.lastIndex = re.global ? match2.index + match2[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match2 && match2.length > 1) {
      call$e(nativeReplace, match2[0], reCopy, function() {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === void 0)
            match2[i] = void 0;
        }
      });
    }
    if (match2 && groups) {
      match2.groups = object = create$3(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match2[group[1]];
      }
    }
    return match2;
  };
}
var regexpExec$2 = patchedExec;
var $$k = _export;
var exec$2 = regexpExec$2;
$$k({ target: "RegExp", proto: true, forced: /./.exec !== exec$2 }, {
  exec: exec$2
});
var call$d = functionCall;
var defineBuiltIn$6 = defineBuiltIn$f;
var regexpExec$1 = regexpExec$2;
var fails$m = fails$M;
var wellKnownSymbol$8 = wellKnownSymbol$t;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$9;
var SPECIES$1 = wellKnownSymbol$8("species");
var RegExpPrototype$2 = RegExp.prototype;
var fixRegexpWellKnownSymbolLogic = function(KEY, exec2, FORCED2, SHAM) {
  var SYMBOL2 = wellKnownSymbol$8(KEY);
  var DELEGATES_TO_SYMBOL = !fails$m(function() {
    var O = {};
    O[SYMBOL2] = function() {
      return 7;
    };
    return ""[KEY](O) !== 7;
  });
  var DELEGATES_TO_EXEC2 = DELEGATES_TO_SYMBOL && !fails$m(function() {
    var execCalled = false;
    var re = /a/;
    if (KEY === "split") {
      re = {};
      re.constructor = {};
      re.constructor[SPECIES$1] = function() {
        return re;
      };
      re.flags = "";
      re[SYMBOL2] = /./[SYMBOL2];
    }
    re.exec = function() {
      execCalled = true;
      return null;
    };
    re[SYMBOL2]("");
    return !execCalled;
  });
  if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC2 || FORCED2) {
    var nativeRegExpMethod = /./[SYMBOL2];
    var methods = exec2(SYMBOL2, ""[KEY], function(nativeMethod, regexp, str, arg2, forceStringMethod) {
      var $exec = regexp.exec;
      if ($exec === regexpExec$1 || $exec === RegExpPrototype$2.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          return { done: true, value: call$d(nativeRegExpMethod, regexp, str, arg2) };
        }
        return { done: true, value: call$d(nativeMethod, str, regexp, arg2) };
      }
      return { done: false };
    });
    defineBuiltIn$6(String.prototype, KEY, methods[0]);
    defineBuiltIn$6(RegExpPrototype$2, SYMBOL2, methods[1]);
  }
  if (SHAM)
    createNonEnumerableProperty$3(RegExpPrototype$2[SYMBOL2], "sham", true);
};
var charAt$3 = stringMultibyte.charAt;
var advanceStringIndex$3 = function(S, index2, unicode) {
  return index2 + (unicode ? charAt$3(S, index2).length : 1);
};
var uncurryThis$n = functionUncurryThis;
var toObject$7 = toObject$f;
var floor$6 = Math.floor;
var charAt$2 = uncurryThis$n("".charAt);
var replace$4 = uncurryThis$n("".replace);
var stringSlice$6 = uncurryThis$n("".slice);
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;
var getSubstitution$1 = function(matched, str, position, captures, namedCaptures, replacement2) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== void 0) {
    namedCaptures = toObject$7(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace$4(replacement2, symbols, function(match2, ch) {
    var capture;
    switch (charAt$2(ch, 0)) {
      case "$":
        return "$";
      case "&":
        return matched;
      case "`":
        return stringSlice$6(str, 0, position);
      case "'":
        return stringSlice$6(str, tailPos);
      case "<":
        capture = namedCaptures[stringSlice$6(ch, 1, -1)];
        break;
      default:
        var n = +ch;
        if (n === 0)
          return match2;
        if (n > m) {
          var f = floor$6(n / 10);
          if (f === 0)
            return match2;
          if (f <= m)
            return captures[f - 1] === void 0 ? charAt$2(ch, 1) : captures[f - 1] + charAt$2(ch, 1);
          return match2;
        }
        capture = captures[n - 1];
    }
    return capture === void 0 ? "" : capture;
  });
};
var call$c = functionCall;
var anObject$8 = anObject$m;
var isCallable$6 = isCallable$t;
var classof$7 = classofRaw$2;
var regexpExec = regexpExec$2;
var $TypeError$5 = TypeError;
var regexpExecAbstract = function(R, S) {
  var exec2 = R.exec;
  if (isCallable$6(exec2)) {
    var result = call$c(exec2, R, S);
    if (result !== null)
      anObject$8(result);
    return result;
  }
  if (classof$7(R) === "RegExp")
    return call$c(regexpExec, R, S);
  throw new $TypeError$5("RegExp#exec called on incompatible receiver");
};
var apply$3 = functionApply;
var call$b = functionCall;
var uncurryThis$m = functionUncurryThis;
var fixRegExpWellKnownSymbolLogic$3 = fixRegexpWellKnownSymbolLogic;
var fails$l = fails$M;
var anObject$7 = anObject$m;
var isCallable$5 = isCallable$t;
var isNullOrUndefined$6 = isNullOrUndefined$b;
var toIntegerOrInfinity$6 = toIntegerOrInfinity$a;
var toLength$7 = toLength$9;
var toString$8 = toString$g;
var requireObjectCoercible$5 = requireObjectCoercible$b;
var advanceStringIndex$2 = advanceStringIndex$3;
var getMethod$3 = getMethod$7;
var getSubstitution = getSubstitution$1;
var regExpExec$4 = regexpExecAbstract;
var wellKnownSymbol$7 = wellKnownSymbol$t;
var REPLACE = wellKnownSymbol$7("replace");
var max$2 = Math.max;
var min$5 = Math.min;
var concat$1 = uncurryThis$m([].concat);
var push$6 = uncurryThis$m([].push);
var stringIndexOf$1 = uncurryThis$m("".indexOf);
var stringSlice$5 = uncurryThis$m("".slice);
var maybeToString = function(it) {
  return it === void 0 ? it : String(it);
};
var REPLACE_KEEPS_$0 = function() {
  return "a".replace(/./, "$0") === "$0";
}();
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function() {
  if (/./[REPLACE]) {
    return /./[REPLACE]("a", "$0") === "";
  }
  return false;
}();
var REPLACE_SUPPORTS_NAMED_GROUPS = !fails$l(function() {
  var re = /./;
  re.exec = function() {
    var result = [];
    result.groups = { a: "7" };
    return result;
  };
  return "".replace(re, "$<a>") !== "7";
});
fixRegExpWellKnownSymbolLogic$3("replace", function(_, nativeReplace2, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? "$" : "$0";
  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace2(searchValue, replaceValue) {
      var O = requireObjectCoercible$5(this);
      var replacer2 = isNullOrUndefined$6(searchValue) ? void 0 : getMethod$3(searchValue, REPLACE);
      return replacer2 ? call$b(replacer2, searchValue, O, replaceValue) : call$b(nativeReplace2, toString$8(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function(string, replaceValue) {
      var rx = anObject$7(this);
      var S = toString$8(string);
      if (typeof replaceValue == "string" && stringIndexOf$1(replaceValue, UNSAFE_SUBSTITUTE) === -1 && stringIndexOf$1(replaceValue, "$<") === -1) {
        var res = maybeCallNative(nativeReplace2, rx, S, replaceValue);
        if (res.done)
          return res.value;
      }
      var functionalReplace = isCallable$5(replaceValue);
      if (!functionalReplace)
        replaceValue = toString$8(replaceValue);
      var global2 = rx.global;
      var fullUnicode;
      if (global2) {
        fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      var result;
      while (true) {
        result = regExpExec$4(rx, S);
        if (result === null)
          break;
        push$6(results, result);
        if (!global2)
          break;
        var matchStr = toString$8(result[0]);
        if (matchStr === "")
          rx.lastIndex = advanceStringIndex$2(S, toLength$7(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = "";
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = toString$8(result[0]);
        var position = max$2(min$5(toIntegerOrInfinity$6(result.index), S.length), 0);
        var captures = [];
        var replacement2;
        for (var j = 1; j < result.length; j++)
          push$6(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat$1([matched], captures, position, S);
          if (namedCaptures !== void 0)
            push$6(replacerArgs, namedCaptures);
          replacement2 = toString$8(apply$3(replaceValue, void 0, replacerArgs));
        } else {
          replacement2 = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice$5(S, nextSourcePosition, position) + replacement2;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + stringSlice$5(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);
var $$j = _export;
var uncurryThis$l = functionUncurryThis;
var IndexedObject$2 = indexedObject;
var toIndexedObject$4 = toIndexedObject$e;
var arrayMethodIsStrict$2 = arrayMethodIsStrict$4;
var nativeJoin = uncurryThis$l([].join);
var ES3_STRINGS = IndexedObject$2 !== Object;
var FORCED$4 = ES3_STRINGS || !arrayMethodIsStrict$2("join", ",");
$$j({ target: "Array", proto: true, forced: FORCED$4 }, {
  join: function join(separator) {
    return nativeJoin(toIndexedObject$4(this), separator === void 0 ? "," : separator);
  }
});
var browser$9 = {};
var $$i = _export;
var isArray$1 = isArray$5;
var isConstructor3 = isConstructor$4;
var isObject$a = isObject$q;
var toAbsoluteIndex$4 = toAbsoluteIndex$6;
var lengthOfArrayLike$a = lengthOfArrayLike$g;
var toIndexedObject$3 = toIndexedObject$e;
var createProperty$1 = createProperty$5;
var wellKnownSymbol$6 = wellKnownSymbol$t;
var arrayMethodHasSpeciesSupport$1 = arrayMethodHasSpeciesSupport$5;
var nativeSlice = arraySlice$9;
var HAS_SPECIES_SUPPORT$1 = arrayMethodHasSpeciesSupport$1("slice");
var SPECIES = wellKnownSymbol$6("species");
var $Array$1 = Array;
var max$1 = Math.max;
$$i({ target: "Array", proto: true, forced: !HAS_SPECIES_SUPPORT$1 }, {
  slice: function slice(start, end2) {
    var O = toIndexedObject$3(this);
    var length = lengthOfArrayLike$a(O);
    var k = toAbsoluteIndex$4(start, length);
    var fin = toAbsoluteIndex$4(end2 === void 0 ? length : end2, length);
    var Constructor2, result, n;
    if (isArray$1(O)) {
      Constructor2 = O.constructor;
      if (isConstructor3(Constructor2) && (Constructor2 === $Array$1 || isArray$1(Constructor2.prototype))) {
        Constructor2 = void 0;
      } else if (isObject$a(Constructor2)) {
        Constructor2 = Constructor2[SPECIES];
        if (Constructor2 === null)
          Constructor2 = void 0;
      }
      if (Constructor2 === $Array$1 || Constructor2 === void 0) {
        return nativeSlice(O, k, fin);
      }
    }
    result = new (Constructor2 === void 0 ? $Array$1 : Constructor2)(max$1(fin - k, 0));
    for (n = 0; k < fin; k++, n++)
      if (k in O)
        createProperty$1(result, n, O[k]);
    result.length = n;
    return result;
  }
});
var $$h = _export;
var call$a = functionCall;
var isCallable$4 = isCallable$t;
var anObject$6 = anObject$m;
var toString$7 = toString$g;
var DELEGATES_TO_EXEC = function() {
  var execCalled = false;
  var re = /[ac]/;
  re.exec = function() {
    execCalled = true;
    return /./.exec.apply(this, arguments);
  };
  return re.test("abc") === true && execCalled;
}();
var nativeTest = /./.test;
$$h({ target: "RegExp", proto: true, forced: !DELEGATES_TO_EXEC }, {
  test: function(S) {
    var R = anObject$6(this);
    var string = toString$7(S);
    var exec2 = R.exec;
    if (!isCallable$4(exec2))
      return call$a(nativeTest, R, string);
    var result = call$a(exec2, R, string);
    if (result === null)
      return false;
    anObject$6(result);
    return true;
  }
});
var $$g = _export;
var DESCRIPTORS$b = descriptors;
var global$d = global$D;
var uncurryThis$k = functionUncurryThis;
var hasOwn$7 = hasOwnProperty_1;
var isCallable$3 = isCallable$t;
var isPrototypeOf$3 = objectIsPrototypeOf;
var toString$6 = toString$g;
var defineBuiltInAccessor$7 = defineBuiltInAccessor$a;
var copyConstructorProperties$1 = copyConstructorProperties$4;
var NativeSymbol = global$d.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;
if (DESCRIPTORS$b && isCallable$3(NativeSymbol) && (!("description" in SymbolPrototype) || // Safari 12 bug
NativeSymbol().description !== void 0)) {
  var EmptyStringDescriptionStore = {};
  var SymbolWrapper = function Symbol2() {
    var description = arguments.length < 1 || arguments[0] === void 0 ? void 0 : toString$6(arguments[0]);
    var result = isPrototypeOf$3(SymbolPrototype, this) ? new NativeSymbol(description) : description === void 0 ? NativeSymbol() : NativeSymbol(description);
    if (description === "")
      EmptyStringDescriptionStore[result] = true;
    return result;
  };
  copyConstructorProperties$1(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;
  var NATIVE_SYMBOL = String(NativeSymbol("description detection")) === "Symbol(description detection)";
  var thisSymbolValue = uncurryThis$k(SymbolPrototype.valueOf);
  var symbolDescriptiveString = uncurryThis$k(SymbolPrototype.toString);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace$3 = uncurryThis$k("".replace);
  var stringSlice$4 = uncurryThis$k("".slice);
  defineBuiltInAccessor$7(SymbolPrototype, "description", {
    configurable: true,
    get: function description() {
      var symbol = thisSymbolValue(this);
      if (hasOwn$7(EmptyStringDescriptionStore, symbol))
        return "";
      var string = symbolDescriptiveString(symbol);
      var desc = NATIVE_SYMBOL ? stringSlice$4(string, 7, -1) : replace$3(string, regexp, "$1");
      return desc === "" ? void 0 : desc;
    }
  });
  $$g({ global: true, constructor: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}
var defineWellKnownSymbol = wellKnownSymbolDefine;
defineWellKnownSymbol("iterator");
var DESCRIPTORS$a = descriptors;
var FUNCTION_NAME_EXISTS = functionName.EXISTS;
var uncurryThis$j = functionUncurryThis;
var defineBuiltInAccessor$6 = defineBuiltInAccessor$a;
var FunctionPrototype = Function.prototype;
var functionToString = uncurryThis$j(FunctionPrototype.toString);
var nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var regExpExec$3 = uncurryThis$j(nameRE.exec);
var NAME$1 = "name";
if (DESCRIPTORS$a && !FUNCTION_NAME_EXISTS) {
  defineBuiltInAccessor$6(FunctionPrototype, NAME$1, {
    configurable: true,
    get: function() {
      try {
        return regExpExec$3(nameRE, functionToString(this))[1];
      } catch (error2) {
        return "";
      }
    }
  });
}
var slicedToArray = { exports: {} };
var arrayWithHoles = { exports: {} };
arrayWithHoles.exports;
(function(module) {
  function _arrayWithHoles(r) {
    if (Array.isArray(r))
      return r;
  }
  module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(arrayWithHoles);
var arrayWithHolesExports = arrayWithHoles.exports;
var iterableToArrayLimit = { exports: {} };
iterableToArrayLimit.exports;
(function(module) {
  function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
      var e, n, i, u, a = [], f = true, o = false;
      try {
        if (i = (t = t.call(r)).next, 0 === l) {
          if (Object(t) !== t)
            return;
          f = false;
        } else
          for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
            ;
      } catch (r2) {
        o = true, n = r2;
      } finally {
        try {
          if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
            return;
        } finally {
          if (o)
            throw n;
        }
      }
      return a;
    }
  }
  module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(iterableToArrayLimit);
var iterableToArrayLimitExports = iterableToArrayLimit.exports;
var unsupportedIterableToArray = { exports: {} };
var arrayLikeToArray = { exports: {} };
arrayLikeToArray.exports;
(function(module) {
  function _arrayLikeToArray2(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for (var e = 0, n = Array(a); e < a; e++)
      n[e] = r[e];
    return n;
  }
  module.exports = _arrayLikeToArray2, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(arrayLikeToArray);
var arrayLikeToArrayExports = arrayLikeToArray.exports;
unsupportedIterableToArray.exports;
(function(module) {
  var arrayLikeToArray2 = arrayLikeToArrayExports;
  function _unsupportedIterableToArray2(r, a) {
    if (r) {
      if ("string" == typeof r)
        return arrayLikeToArray2(r, a);
      var t = {}.toString.call(r).slice(8, -1);
      return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? arrayLikeToArray2(r, a) : void 0;
    }
  }
  module.exports = _unsupportedIterableToArray2, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(unsupportedIterableToArray);
var unsupportedIterableToArrayExports = unsupportedIterableToArray.exports;
var nonIterableRest = { exports: {} };
nonIterableRest.exports;
(function(module) {
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(nonIterableRest);
var nonIterableRestExports = nonIterableRest.exports;
slicedToArray.exports;
(function(module) {
  var arrayWithHoles2 = arrayWithHolesExports;
  var iterableToArrayLimit2 = iterableToArrayLimitExports;
  var unsupportedIterableToArray2 = unsupportedIterableToArrayExports;
  var nonIterableRest2 = nonIterableRestExports;
  function _slicedToArray2(r, e) {
    return arrayWithHoles2(r) || iterableToArrayLimit2(r, e) || unsupportedIterableToArray2(r, e) || nonIterableRest2();
  }
  module.exports = _slicedToArray2, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(slicedToArray);
var slicedToArrayExports = slicedToArray.exports;
var toConsumableArray = { exports: {} };
var arrayWithoutHoles = { exports: {} };
arrayWithoutHoles.exports;
(function(module) {
  var arrayLikeToArray2 = arrayLikeToArrayExports;
  function _arrayWithoutHoles(r) {
    if (Array.isArray(r))
      return arrayLikeToArray2(r);
  }
  module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(arrayWithoutHoles);
var arrayWithoutHolesExports = arrayWithoutHoles.exports;
var iterableToArray = { exports: {} };
iterableToArray.exports;
(function(module) {
  function _iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"])
      return Array.from(r);
  }
  module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(iterableToArray);
var iterableToArrayExports = iterableToArray.exports;
var nonIterableSpread = { exports: {} };
nonIterableSpread.exports;
(function(module) {
  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(nonIterableSpread);
var nonIterableSpreadExports = nonIterableSpread.exports;
toConsumableArray.exports;
(function(module) {
  var arrayWithoutHoles2 = arrayWithoutHolesExports;
  var iterableToArray2 = iterableToArrayExports;
  var unsupportedIterableToArray2 = unsupportedIterableToArrayExports;
  var nonIterableSpread2 = nonIterableSpreadExports;
  function _toConsumableArray2(r) {
    return arrayWithoutHoles2(r) || iterableToArray2(r) || unsupportedIterableToArray2(r) || nonIterableSpread2();
  }
  module.exports = _toConsumableArray2, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(toConsumableArray);
var toConsumableArrayExports = toConsumableArray.exports;
var $$f = _export;
var $includes$1 = arrayIncludes.includes;
var fails$k = fails$M;
var addToUnscopables$1 = addToUnscopables$3;
var BROKEN_ON_SPARSE = fails$k(function() {
  return !Array(1).includes();
});
$$f({ target: "Array", proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el) {
    return $includes$1(this, el, arguments.length > 1 ? arguments[1] : void 0);
  }
});
addToUnscopables$1("includes");
var isObject$9 = isObject$q;
var floor$5 = Math.floor;
var isIntegralNumber$2 = Number.isInteger || function isInteger(it) {
  return !isObject$9(it) && isFinite(it) && floor$5(it) === it;
};
var $$e = _export;
var isIntegralNumber$1 = isIntegralNumber$2;
$$e({ target: "Number", stat: true }, {
  isInteger: isIntegralNumber$1
});
var DESCRIPTORS$9 = descriptors;
var fails$j = fails$M;
var uncurryThis$i = functionUncurryThis;
var objectGetPrototypeOf = objectGetPrototypeOf$1;
var objectKeys$1 = objectKeys$4;
var toIndexedObject$2 = toIndexedObject$e;
var $propertyIsEnumerable = objectPropertyIsEnumerable.f;
var propertyIsEnumerable3 = uncurryThis$i($propertyIsEnumerable);
var push$5 = uncurryThis$i([].push);
var IE_BUG = DESCRIPTORS$9 && fails$j(function() {
  var O = /* @__PURE__ */ Object.create(null);
  O[2] = 2;
  return !propertyIsEnumerable3(O, 2);
});
var createMethod$1 = function(TO_ENTRIES) {
  return function(it) {
    var O = toIndexedObject$2(it);
    var keys6 = objectKeys$1(O);
    var IE_WORKAROUND = IE_BUG && objectGetPrototypeOf(O) === null;
    var length = keys6.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys6[i++];
      if (!DESCRIPTORS$9 || (IE_WORKAROUND ? key in O : propertyIsEnumerable3(O, key))) {
        push$5(result, TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};
var objectToArray = {
  // `Object.entries` method
  // https://tc39.es/ecma262/#sec-object.entries
  entries: createMethod$1(true),
  // `Object.values` method
  // https://tc39.es/ecma262/#sec-object.values
  values: createMethod$1(false)
};
var $$d = _export;
var $entries = objectToArray.entries;
$$d({ target: "Object", stat: true }, {
  entries: function entries(O) {
    return $entries(O);
  }
});
/*
@license
Copyright (c) 2021 Twilio Inc.

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.


*/
Object.defineProperty(browser$9, "__esModule", { value: true });
var _typeof$3 = _typeofExports;
var _slicedToArray$3 = slicedToArrayExports;
var _toConsumableArray$3 = toConsumableArrayExports;
var _createClass$3 = createClassExports;
var _classCallCheck$5 = classCallCheckExports;
var _inherits$5 = inheritsExports;
var _possibleConstructorReturn$5 = possibleConstructorReturnExports;
var _getPrototypeOf$5 = getPrototypeOfExports;
function _interopDefaultLegacy$6(e) {
  return e && typeof e === "object" && "default" in e ? e : { "default": e };
}
var _typeof__default$3 = /* @__PURE__ */ _interopDefaultLegacy$6(_typeof$3);
var _slicedToArray__default$3 = /* @__PURE__ */ _interopDefaultLegacy$6(_slicedToArray$3);
var _toConsumableArray__default$3 = /* @__PURE__ */ _interopDefaultLegacy$6(_toConsumableArray$3);
var _createClass__default$3 = /* @__PURE__ */ _interopDefaultLegacy$6(_createClass$3);
var _classCallCheck__default$5 = /* @__PURE__ */ _interopDefaultLegacy$6(_classCallCheck$5);
var _inherits__default$5 = /* @__PURE__ */ _interopDefaultLegacy$6(_inherits$5);
var _possibleConstructorReturn__default$5 = /* @__PURE__ */ _interopDefaultLegacy$6(_possibleConstructorReturn$5);
var _getPrototypeOf__default$5 = /* @__PURE__ */ _interopDefaultLegacy$6(_getPrototypeOf$5);
var custom$2 = function custom() {
  for (var _len = arguments.length, checks = new Array(_len), _key = 0; _key < _len; _key++) {
    checks[_key] = arguments[_key];
  }
  return {
    checks
  };
};
function _createForOfIteratorHelper$4$1(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$4$1(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i = 0;
      var F = function F2() {
      };
      return { s: F, n: function n() {
        if (i >= o.length)
          return { done: true };
        return { done: false, value: o[i++] };
      }, e: function e(_e) {
        throw _e;
      }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return { s: function s() {
    it = it.call(o);
  }, n: function n() {
    var step = it.next();
    normalCompletion = step.done;
    return step;
  }, e: function e(_e2) {
    didErr = true;
    err = _e2;
  }, f: function f() {
    try {
      if (!normalCompletion && it.return != null)
        it.return();
    } finally {
      if (didErr)
        throw err;
    }
  } };
}
function _unsupportedIterableToArray$4$1(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$4$1(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$4$1(o, minLen);
}
function _arrayLikeToArray$4$1(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var type$2 = function type() {
  for (var _len = arguments.length, checks = new Array(_len), _key = 0; _key < _len; _key++) {
    checks[_key] = arguments[_key];
  }
  return custom$2(function(value) {
    var isValid = false;
    var expectedTypes = [];
    var _iterator = _createForOfIteratorHelper$4$1(checks), _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        var _type = _step.value;
        if (typeof _type === "string") {
          isValid = isValid || _typeof__default$3["default"](value) === _type;
          expectedTypes.push("of type ".concat(_type));
          continue;
        }
        isValid = isValid || value instanceof _type;
        expectedTypes.push("an instance of ".concat(_type.name));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return [isValid, expectedTypes];
  });
};
function _createForOfIteratorHelper$3$3(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$3$3(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i = 0;
      var F = function F2() {
      };
      return { s: F, n: function n() {
        if (i >= o.length)
          return { done: true };
        return { done: false, value: o[i++] };
      }, e: function e(_e) {
        throw _e;
      }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return { s: function s() {
    it = it.call(o);
  }, n: function n() {
    var step = it.next();
    normalCompletion = step.done;
    return step;
  }, e: function e(_e2) {
    didErr = true;
    err = _e2;
  }, f: function f() {
    try {
      if (!normalCompletion && it.return != null)
        it.return();
    } finally {
      if (didErr)
        throw err;
    }
  } };
}
function _unsupportedIterableToArray$3$3(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$3$3(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$3$3(o, minLen);
}
function _arrayLikeToArray$3$3(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var literal$2 = function literal() {
  for (var _len = arguments.length, checks = new Array(_len), _key = 0; _key < _len; _key++) {
    checks[_key] = arguments[_key];
  }
  return custom$2(function(value) {
    var isValid = false;
    var expectedTypes = [];
    var _iterator = _createForOfIteratorHelper$3$3(checks), _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        var type5 = _step.value;
        isValid = isValid || value === type5;
        expectedTypes.push(typeof type5 === "string" ? '"'.concat(type5, '"') : "".concat(type5));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return [isValid, expectedTypes];
  });
};
function _createSuper$c(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$c();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf__default$5["default"](Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf__default$5["default"](this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn__default$5["default"](this, result);
  };
}
function _isNativeReflectConstruct$c() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _createForOfIteratorHelper$2$3(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$2$3(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i = 0;
      var F = function F2() {
      };
      return { s: F, n: function n() {
        if (i >= o.length)
          return { done: true };
        return { done: false, value: o[i++] };
      }, e: function e(_e) {
        throw _e;
      }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return { s: function s() {
    it = it.call(o);
  }, n: function n() {
    var step = it.next();
    normalCompletion = step.done;
    return step;
  }, e: function e(_e2) {
    didErr = true;
    err = _e2;
  }, f: function f() {
    try {
      if (!normalCompletion && it.return != null)
        it.return();
    } finally {
      if (didErr)
        throw err;
    }
  } };
}
function _unsupportedIterableToArray$2$3(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$2$3(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$2$3(o, minLen);
}
function _arrayLikeToArray$2$3(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var runtimeTypeValidation$2 = function runtimeTypeValidation(rules, values4) {
  if (values4.length > rules.length) {
    throw new Error("Expected at most ".concat(rules.length, " argument(s), but got ").concat(values4.length));
  }
  while (values4.length < rules.length) {
    values4.push(void 0);
  }
  var _iterator = _createForOfIteratorHelper$2$3(values4.entries()), _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done; ) {
      var _step$value = _slicedToArray__default$3["default"](_step.value, 2), index2 = _step$value[0], value = _step$value[1];
      var _validateValue = validateValue$2(rules[index2], value), _validateValue2 = _slicedToArray__default$3["default"](_validateValue, 4), isValid = _validateValue2[0], received = _validateValue2[1], expected = _validateValue2[2], delimeter = _validateValue2[3];
      if (isValid) {
        continue;
      }
      var argumentIndex = index2 + 1;
      throw new Error("Argument ".concat(argumentIndex, " is expected to be ").concat(expected).concat(delimeter, " but got ").concat(received));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};
var stringifyReceivedType$2 = function stringifyReceivedType(value) {
  var _value$constructor;
  var receivedType;
  var types = ["undefined", "boolean", "number", "bigint", "string"];
  if (types.includes(_typeof__default$3["default"](value))) {
    receivedType = typeof value === "string" ? '"'.concat(value, '"') : "".concat(value);
  }
  if (_typeof__default$3["default"](value) === "object" && (value === null || value === void 0 ? void 0 : (_value$constructor = value.constructor) === null || _value$constructor === void 0 ? void 0 : _value$constructor.name) !== "Object") {
    var _value$constructor2;
    receivedType = value === null ? "null" : "instance of ".concat(value === null || value === void 0 ? void 0 : (_value$constructor2 = value.constructor) === null || _value$constructor2 === void 0 ? void 0 : _value$constructor2.name);
  }
  if (!receivedType) {
    receivedType = _typeof__default$3["default"](value);
  }
  return receivedType;
};
var validateConstructorTypes$2 = function validateConstructorTypes() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var finalRuleSet = convertRuleArguments$2(args);
  return function(ctor) {
    return /* @__PURE__ */ function(_ctor) {
      _inherits__default$5["default"](_class, _ctor);
      var _super = _createSuper$c(_class);
      function _class() {
        _classCallCheck__default$5["default"](this, _class);
        for (var _len2 = arguments.length, args2 = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args2[_key2] = arguments[_key2];
        }
        runtimeTypeValidation$2(finalRuleSet, args2);
        return _super.call.apply(_super, [this].concat(args2));
      }
      return _createClass__default$3["default"](_class);
    }(ctor);
  };
};
var validateTypes$2 = function validateTypes() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }
  var finalRuleSet = convertRuleArguments$2(args);
  return function(target, propertyKey, descriptor) {
    if (typeof descriptor.value !== "function") {
      throw new Error("The validateTypes decorator can only be applied to methods");
    }
    var originalMethod = descriptor.value;
    descriptor.value = function() {
      for (var _len4 = arguments.length, args2 = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args2[_key4] = arguments[_key4];
      }
      runtimeTypeValidation$2(finalRuleSet, args2);
      return originalMethod.apply(this, args2);
    };
  };
};
var validateTypesAsync$2 = function validateTypesAsync() {
  for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    args[_key5] = arguments[_key5];
  }
  var finalRuleSet = convertRuleArguments$2(args);
  return function(target, propertyKey, descriptor) {
    if (typeof descriptor.value !== "function") {
      throw new Error("The validateTypesAsync decorator can only be applied to methods");
    }
    var originalMethod = descriptor.value;
    descriptor.value = function() {
      for (var _len6 = arguments.length, args2 = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args2[_key6] = arguments[_key6];
      }
      try {
        runtimeTypeValidation$2(finalRuleSet, args2);
      } catch (e) {
        return Promise.reject(e);
      }
      return originalMethod.apply(this, args2);
    };
  };
};
var convertRuleArguments$2 = function convertRuleArguments(args) {
  var finalRuleDefinitionSet = [];
  var _iterator2 = _createForOfIteratorHelper$2$3(args), _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
      var arg = _step2.value;
      finalRuleDefinitionSet.push(convertRuleArgument$2(arg));
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return finalRuleDefinitionSet;
};
var convertRuleArgument$2 = function convertRuleArgument(arg) {
  var finalArgumentRuleDefinitions = [];
  var declaredRules = Array.isArray(arg) ? arg : [arg];
  var _iterator3 = _createForOfIteratorHelper$2$3(declaredRules), _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done; ) {
      var rule = _step3.value;
      if (typeof rule === "string" || typeof rule === "function") {
        finalArgumentRuleDefinitions.push(type$2(rule));
        continue;
      }
      finalArgumentRuleDefinitions.push(rule);
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return finalArgumentRuleDefinitions;
};
var validateValue$2 = function validateValue(ruleDefinitions, value) {
  var expectedTypes = [];
  var customReceivedType;
  var isValid = false;
  var _iterator4 = _createForOfIteratorHelper$2$3(ruleDefinitions), _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done; ) {
      var definition = _step4.value;
      var _iterator5 = _createForOfIteratorHelper$2$3(definition.checks), _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done; ) {
          var check2 = _step5.value;
          var _check = check2(value), _check2 = _slicedToArray__default$3["default"](_check, 3), checkPassed = _check2[0], typeDescription = _check2[1], _receivedType = _check2[2];
          isValid = isValid || checkPassed;
          if (!customReceivedType && _receivedType) {
            customReceivedType = _receivedType;
          }
          if (typeDescription) {
            expectedTypes = typeof typeDescription === "string" ? [].concat(_toConsumableArray__default$3["default"](expectedTypes), [typeDescription]) : [].concat(_toConsumableArray__default$3["default"](expectedTypes), _toConsumableArray__default$3["default"](typeDescription));
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  if (isValid) {
    return [true];
  }
  var receivedType = customReceivedType || stringifyReceivedType$2(value);
  var lastIndex = expectedTypes.length - 1;
  var expectedTypesString = lastIndex > 0 ? "".concat(expectedTypes.slice(0, lastIndex).join(", "), " or ").concat(expectedTypes[lastIndex]) : expectedTypes.join(", ");
  return [false, receivedType, expectedTypesString, lastIndex > 1 ? ";" : ","];
};
function _createForOfIteratorHelper$1$3(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$1$3(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i = 0;
      var F = function F2() {
      };
      return { s: F, n: function n() {
        if (i >= o.length)
          return { done: true };
        return { done: false, value: o[i++] };
      }, e: function e(_e) {
        throw _e;
      }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return { s: function s() {
    it = it.call(o);
  }, n: function n() {
    var step = it.next();
    normalCompletion = step.done;
    return step;
  }, e: function e(_e2) {
    didErr = true;
    err = _e2;
  }, f: function f() {
    try {
      if (!normalCompletion && it.return != null)
        it.return();
    } finally {
      if (didErr)
        throw err;
    }
  } };
}
function _unsupportedIterableToArray$1$3(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$1$3(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$1$3(o, minLen);
}
function _arrayLikeToArray$1$3(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var nonEmptyArray = function nonEmptyArray2(name, rules) {
  return custom$2(function(value) {
    if (!Array.isArray(value) || value.length < 1) {
      return [false, "a non-empty array of ".concat(name)];
    }
    var _iterator = _createForOfIteratorHelper$1$3(value.entries()), _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        var _step$value = _slicedToArray__default$3["default"](_step.value, 2), key = _step$value[0], valueOfKey = _step$value[1];
        var _validateValue = validateValue$2(convertRuleArgument$2(rules), valueOfKey), _validateValue2 = _slicedToArray__default$3["default"](_validateValue, 3), isValid = _validateValue2[0], received = _validateValue2[1], expected = _validateValue2[2];
        if (!isValid) {
          return [false, "a valid non-empty array of ".concat(name, " (index ").concat(key, " should be ").concat(expected, ")"), "malformed array of ".concat(name, " (index ").concat(key, " is ").concat(received, ")")];
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return [true];
  });
};
var nonEmptyString$2 = custom$2(function(value) {
  return [typeof value === "string" && value.length > 0, "a non-empty string"];
});
var nonNegativeInteger$2 = custom$2(function(value) {
  return [typeof value === "number" && Number.isInteger(value) && value >= 0, "a non-negative integer"];
});
var pureObject$2 = custom$2(function(value) {
  return [_typeof__default$3["default"](value) === "object" && value !== null && !Array.isArray(value), "a pure object (non-null and non-array)"];
});
var objectSchema$2 = function objectSchema(name, schema) {
  return custom$2(function(object) {
    if (_typeof__default$3["default"](object) !== "object" || object === null || Array.isArray(object)) {
      return [false, "valid ".concat(name, " (should be a pure object)")];
    }
    for (var _i = 0, _Object$entries = Object.entries(schema); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray__default$3["default"](_Object$entries[_i], 2), key = _Object$entries$_i[0], rules = _Object$entries$_i[1];
      var _validateValue = validateValue$2(convertRuleArgument$2(rules), object[key]), _validateValue2 = _slicedToArray__default$3["default"](_validateValue, 3), isValid = _validateValue2[0], received = _validateValue2[1], expected = _validateValue2[2];
      if (!isValid) {
        return [false, "valid ".concat(name, ' (key "').concat(key, '" should be ').concat(expected, ")"), "malformed ".concat(name, ' (key "').concat(key, '" is ').concat(received, ")")];
      }
    }
    return [true];
  });
};
function _createForOfIteratorHelper$6(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$6(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i = 0;
      var F = function F2() {
      };
      return { s: F, n: function n() {
        if (i >= o.length)
          return { done: true };
        return { done: false, value: o[i++] };
      }, e: function e(_e) {
        throw _e;
      }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return { s: function s() {
    it = it.call(o);
  }, n: function n() {
    var step = it.next();
    normalCompletion = step.done;
    return step;
  }, e: function e(_e2) {
    didErr = true;
    err = _e2;
  }, f: function f() {
    try {
      if (!normalCompletion && it.return != null)
        it.return();
    } finally {
      if (didErr)
        throw err;
    }
  } };
}
function _unsupportedIterableToArray$6(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$6(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$6(o, minLen);
}
function _arrayLikeToArray$6(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var array$2 = function array(name, rules) {
  return custom$2(function(value) {
    if (!Array.isArray(value)) {
      return [false, "an array of ".concat(name)];
    }
    var _iterator = _createForOfIteratorHelper$6(value.entries()), _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        var _step$value = _slicedToArray__default$3["default"](_step.value, 2), key = _step$value[0], valueOfKey = _step$value[1];
        var _validateValue = validateValue$2(convertRuleArgument$2(rules), valueOfKey), _validateValue2 = _slicedToArray__default$3["default"](_validateValue, 3), isValid = _validateValue2[0], received = _validateValue2[1], expected = _validateValue2[2];
        if (!isValid) {
          return [false, "a valid array of ".concat(name, " (index ").concat(key, " should be ").concat(expected, ")"), "malformed array of ".concat(name, " (index ").concat(key, " is ").concat(received, ")")];
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return [true];
  });
};
browser$9.array = array$2;
browser$9.custom = custom$2;
browser$9.literal = literal$2;
browser$9.nonEmptyArray = nonEmptyArray;
browser$9.nonEmptyString = nonEmptyString$2;
browser$9.nonNegativeInteger = nonNegativeInteger$2;
browser$9.objectSchema = objectSchema$2;
browser$9.pureObject = pureObject$2;
browser$9.runtimeTypeValidation = runtimeTypeValidation$2;
browser$9.stringifyReceivedType = stringifyReceivedType$2;
browser$9.type = type$2;
browser$9.validateConstructorTypes = validateConstructorTypes$2;
browser$9.validateTypes = validateTypes$2;
browser$9.validateTypesAsync = validateTypesAsync$2;
var browser$8 = {};
var get$1 = { exports: {} };
var superPropBase = { exports: {} };
superPropBase.exports;
(function(module) {
  var getPrototypeOf2 = getPrototypeOfExports;
  function _superPropBase(t, o) {
    for (; !{}.hasOwnProperty.call(t, o) && null !== (t = getPrototypeOf2(t)); )
      ;
    return t;
  }
  module.exports = _superPropBase, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(superPropBase);
var superPropBaseExports = superPropBase.exports;
get$1.exports;
(function(module) {
  var superPropBase2 = superPropBaseExports;
  function _get2() {
    return module.exports = _get2 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
      var p = superPropBase2(e, t);
      if (p) {
        var n = Object.getOwnPropertyDescriptor(p, t);
        return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
      }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _get2.apply(null, arguments);
  }
  module.exports = _get2, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(get$1);
var getExports = get$1.exports;
/*
@license
Copyright (c) 2021 Twilio Inc.

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/
Object.defineProperty(browser$8, "__esModule", { value: true });
var _toConsumableArray$2 = toConsumableArrayExports;
var _classCallCheck$4 = classCallCheckExports;
var _createClass$2 = createClassExports;
var _assertThisInitialized$2 = assertThisInitializedExports;
var _get$1 = getExports;
var _inherits$4 = inheritsExports;
var _possibleConstructorReturn$4 = possibleConstructorReturnExports;
var _getPrototypeOf$4 = getPrototypeOfExports;
var _defineProperty$2 = definePropertyExports;
function _interopDefaultLegacy$5(e) {
  return e && typeof e === "object" && "default" in e ? e : { "default": e };
}
var _toConsumableArray__default$2 = /* @__PURE__ */ _interopDefaultLegacy$5(_toConsumableArray$2);
var _classCallCheck__default$4 = /* @__PURE__ */ _interopDefaultLegacy$5(_classCallCheck$4);
var _createClass__default$2 = /* @__PURE__ */ _interopDefaultLegacy$5(_createClass$2);
var _assertThisInitialized__default$2 = /* @__PURE__ */ _interopDefaultLegacy$5(_assertThisInitialized$2);
var _get__default$1 = /* @__PURE__ */ _interopDefaultLegacy$5(_get$1);
var _inherits__default$4 = /* @__PURE__ */ _interopDefaultLegacy$5(_inherits$4);
var _possibleConstructorReturn__default$4 = /* @__PURE__ */ _interopDefaultLegacy$5(_possibleConstructorReturn$4);
var _getPrototypeOf__default$4 = /* @__PURE__ */ _interopDefaultLegacy$5(_getPrototypeOf$4);
var _defineProperty__default$2 = /* @__PURE__ */ _interopDefaultLegacy$5(_defineProperty$2);
var domain$2;
function EventHandlers$2() {
}
EventHandlers$2.prototype = /* @__PURE__ */ Object.create(null);
function EventEmitter$2() {
  EventEmitter$2.init.call(this);
}
EventEmitter$2.EventEmitter = EventEmitter$2;
EventEmitter$2.usingDomains = false;
EventEmitter$2.prototype.domain = void 0;
EventEmitter$2.prototype._events = void 0;
EventEmitter$2.prototype._maxListeners = void 0;
EventEmitter$2.defaultMaxListeners = 10;
EventEmitter$2.init = function() {
  this.domain = null;
  if (EventEmitter$2.usingDomains) {
    if (domain$2.active)
      ;
  }
  if (!this._events || this._events === Object.getPrototypeOf(this)._events) {
    this._events = new EventHandlers$2();
    this._eventsCount = 0;
  }
  this._maxListeners = this._maxListeners || void 0;
};
EventEmitter$2.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== "number" || n < 0 || isNaN(n))
    throw new TypeError('"n" argument must be a positive number');
  this._maxListeners = n;
  return this;
};
function $getMaxListeners$2(that) {
  if (that._maxListeners === void 0)
    return EventEmitter$2.defaultMaxListeners;
  return that._maxListeners;
}
EventEmitter$2.prototype.getMaxListeners = function getMaxListeners() {
  return $getMaxListeners$2(this);
};
function emitNone$2(handler, isFn, self2) {
  if (isFn)
    handler.call(self2);
  else {
    var len = handler.length;
    var listeners4 = arrayClone$2(handler, len);
    for (var i = 0; i < len; ++i)
      listeners4[i].call(self2);
  }
}
function emitOne$2(handler, isFn, self2, arg1) {
  if (isFn)
    handler.call(self2, arg1);
  else {
    var len = handler.length;
    var listeners4 = arrayClone$2(handler, len);
    for (var i = 0; i < len; ++i)
      listeners4[i].call(self2, arg1);
  }
}
function emitTwo$2(handler, isFn, self2, arg1, arg2) {
  if (isFn)
    handler.call(self2, arg1, arg2);
  else {
    var len = handler.length;
    var listeners4 = arrayClone$2(handler, len);
    for (var i = 0; i < len; ++i)
      listeners4[i].call(self2, arg1, arg2);
  }
}
function emitThree$2(handler, isFn, self2, arg1, arg2, arg3) {
  if (isFn)
    handler.call(self2, arg1, arg2, arg3);
  else {
    var len = handler.length;
    var listeners4 = arrayClone$2(handler, len);
    for (var i = 0; i < len; ++i)
      listeners4[i].call(self2, arg1, arg2, arg3);
  }
}
function emitMany$2(handler, isFn, self2, args) {
  if (isFn)
    handler.apply(self2, args);
  else {
    var len = handler.length;
    var listeners4 = arrayClone$2(handler, len);
    for (var i = 0; i < len; ++i)
      listeners4[i].apply(self2, args);
  }
}
EventEmitter$2.prototype.emit = function emit(type5) {
  var er, handler, len, args, i, events, domain2;
  var doError = type5 === "error";
  events = this._events;
  if (events)
    doError = doError && events.error == null;
  else if (!doError)
    return false;
  domain2 = this.domain;
  if (doError) {
    er = arguments[1];
    if (domain2) {
      if (!er)
        er = new Error('Uncaught, unspecified "error" event');
      er.domainEmitter = this;
      er.domain = domain2;
      er.domainThrown = false;
      domain2.emit("error", er);
    } else if (er instanceof Error) {
      throw er;
    } else {
      var err = new Error('Uncaught, unspecified "error" event. (' + er + ")");
      err.context = er;
      throw err;
    }
    return false;
  }
  handler = events[type5];
  if (!handler)
    return false;
  var isFn = typeof handler === "function";
  len = arguments.length;
  switch (len) {
    case 1:
      emitNone$2(handler, isFn, this);
      break;
    case 2:
      emitOne$2(handler, isFn, this, arguments[1]);
      break;
    case 3:
      emitTwo$2(handler, isFn, this, arguments[1], arguments[2]);
      break;
    case 4:
      emitThree$2(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
      break;
    default:
      args = new Array(len - 1);
      for (i = 1; i < len; i++)
        args[i - 1] = arguments[i];
      emitMany$2(handler, isFn, this, args);
  }
  return true;
};
function _addListener$2(target, type5, listener, prepend) {
  var m;
  var events;
  var existing;
  if (typeof listener !== "function")
    throw new TypeError('"listener" argument must be a function');
  events = target._events;
  if (!events) {
    events = target._events = new EventHandlers$2();
    target._eventsCount = 0;
  } else {
    if (events.newListener) {
      target.emit(
        "newListener",
        type5,
        listener.listener ? listener.listener : listener
      );
      events = target._events;
    }
    existing = events[type5];
  }
  if (!existing) {
    existing = events[type5] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === "function") {
      existing = events[type5] = prepend ? [listener, existing] : [existing, listener];
    } else {
      if (prepend) {
        existing.unshift(listener);
      } else {
        existing.push(listener);
      }
    }
    if (!existing.warned) {
      m = $getMaxListeners$2(target);
      if (m && m > 0 && existing.length > m) {
        existing.warned = true;
        var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + type5 + " listeners added. Use emitter.setMaxListeners() to increase limit");
        w.name = "MaxListenersExceededWarning";
        w.emitter = target;
        w.type = type5;
        w.count = existing.length;
        emitWarning$2(w);
      }
    }
  }
  return target;
}
function emitWarning$2(e) {
  typeof console.warn === "function" ? console.warn(e) : console.log(e);
}
EventEmitter$2.prototype.addListener = function addListener(type5, listener) {
  return _addListener$2(this, type5, listener, false);
};
EventEmitter$2.prototype.on = EventEmitter$2.prototype.addListener;
EventEmitter$2.prototype.prependListener = function prependListener(type5, listener) {
  return _addListener$2(this, type5, listener, true);
};
function _onceWrap$2(target, type5, listener) {
  var fired = false;
  function g() {
    target.removeListener(type5, g);
    if (!fired) {
      fired = true;
      listener.apply(target, arguments);
    }
  }
  g.listener = listener;
  return g;
}
EventEmitter$2.prototype.once = function once(type5, listener) {
  if (typeof listener !== "function")
    throw new TypeError('"listener" argument must be a function');
  this.on(type5, _onceWrap$2(this, type5, listener));
  return this;
};
EventEmitter$2.prototype.prependOnceListener = function prependOnceListener(type5, listener) {
  if (typeof listener !== "function")
    throw new TypeError('"listener" argument must be a function');
  this.prependListener(type5, _onceWrap$2(this, type5, listener));
  return this;
};
EventEmitter$2.prototype.removeListener = function removeListener(type5, listener) {
  var list, events, position, i, originalListener;
  if (typeof listener !== "function")
    throw new TypeError('"listener" argument must be a function');
  events = this._events;
  if (!events)
    return this;
  list = events[type5];
  if (!list)
    return this;
  if (list === listener || list.listener && list.listener === listener) {
    if (--this._eventsCount === 0)
      this._events = new EventHandlers$2();
    else {
      delete events[type5];
      if (events.removeListener)
        this.emit("removeListener", type5, list.listener || listener);
    }
  } else if (typeof list !== "function") {
    position = -1;
    for (i = list.length; i-- > 0; ) {
      if (list[i] === listener || list[i].listener && list[i].listener === listener) {
        originalListener = list[i].listener;
        position = i;
        break;
      }
    }
    if (position < 0)
      return this;
    if (list.length === 1) {
      list[0] = void 0;
      if (--this._eventsCount === 0) {
        this._events = new EventHandlers$2();
        return this;
      } else {
        delete events[type5];
      }
    } else {
      spliceOne$2(list, position);
    }
    if (events.removeListener)
      this.emit("removeListener", type5, originalListener || listener);
  }
  return this;
};
EventEmitter$2.prototype.off = function(type5, listener) {
  return this.removeListener(type5, listener);
};
EventEmitter$2.prototype.removeAllListeners = function removeAllListeners(type5) {
  var listeners4, events;
  events = this._events;
  if (!events)
    return this;
  if (!events.removeListener) {
    if (arguments.length === 0) {
      this._events = new EventHandlers$2();
      this._eventsCount = 0;
    } else if (events[type5]) {
      if (--this._eventsCount === 0)
        this._events = new EventHandlers$2();
      else
        delete events[type5];
    }
    return this;
  }
  if (arguments.length === 0) {
    var keys6 = Object.keys(events);
    for (var i = 0, key; i < keys6.length; ++i) {
      key = keys6[i];
      if (key === "removeListener")
        continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners("removeListener");
    this._events = new EventHandlers$2();
    this._eventsCount = 0;
    return this;
  }
  listeners4 = events[type5];
  if (typeof listeners4 === "function") {
    this.removeListener(type5, listeners4);
  } else if (listeners4) {
    do {
      this.removeListener(type5, listeners4[listeners4.length - 1]);
    } while (listeners4[0]);
  }
  return this;
};
EventEmitter$2.prototype.listeners = function listeners(type5) {
  var evlistener;
  var ret;
  var events = this._events;
  if (!events)
    ret = [];
  else {
    evlistener = events[type5];
    if (!evlistener)
      ret = [];
    else if (typeof evlistener === "function")
      ret = [evlistener.listener || evlistener];
    else
      ret = unwrapListeners$2(evlistener);
  }
  return ret;
};
EventEmitter$2.listenerCount = function(emitter, type5) {
  if (typeof emitter.listenerCount === "function") {
    return emitter.listenerCount(type5);
  } else {
    return listenerCount$2.call(emitter, type5);
  }
};
EventEmitter$2.prototype.listenerCount = listenerCount$2;
function listenerCount$2(type5) {
  var events = this._events;
  if (events) {
    var evlistener = events[type5];
    if (typeof evlistener === "function") {
      return 1;
    } else if (evlistener) {
      return evlistener.length;
    }
  }
  return 0;
}
EventEmitter$2.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
};
function spliceOne$2(list, index2) {
  for (var i = index2, k = i + 1, n = list.length; k < n; i += 1, k += 1)
    list[i] = list[k];
  list.pop();
}
function arrayClone$2(arr, i) {
  var copy = new Array(i);
  while (i--)
    copy[i] = arr[i];
  return copy;
}
function unwrapListeners$2(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}
function _createSuper$b(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$b();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf__default$4["default"](Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf__default$4["default"](this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn__default$4["default"](this, result);
  };
}
function _isNativeReflectConstruct$b() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var ReplayEventEmitter = /* @__PURE__ */ function(_EventEmitter) {
  _inherits__default$4["default"](ReplayEventEmitter2, _EventEmitter);
  var _super = _createSuper$b(ReplayEventEmitter2);
  function ReplayEventEmitter2() {
    var _this;
    _classCallCheck__default$4["default"](this, ReplayEventEmitter2);
    _this = _super.call(this);
    _defineProperty__default$2["default"](_assertThisInitialized__default$2["default"](_this), "eventHistory", /* @__PURE__ */ new Map());
    return _this;
  }
  _createClass__default$2["default"](ReplayEventEmitter2, [{
    key: "on",
    value: function on(event, listener) {
      return _get__default$1["default"](_getPrototypeOf__default$4["default"](ReplayEventEmitter2.prototype), "on", this).call(this, event, listener);
    }
  }, {
    key: "once",
    value: function once4(event, listener) {
      return _get__default$1["default"](_getPrototypeOf__default$4["default"](ReplayEventEmitter2.prototype), "once", this).call(this, event, listener);
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      return _get__default$1["default"](_getPrototypeOf__default$4["default"](ReplayEventEmitter2.prototype), "off", this).call(this, event, listener);
    }
  }, {
    key: "emit",
    value: function emit4(event) {
      var _get2;
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      this.eventHistory.set(event, args);
      return (_get2 = _get__default$1["default"](_getPrototypeOf__default$4["default"](ReplayEventEmitter2.prototype), "emit", this)).call.apply(_get2, [this, event].concat(args));
    }
  }, {
    key: "addListener",
    value: function addListener4(event, listener) {
      return _get__default$1["default"](_getPrototypeOf__default$4["default"](ReplayEventEmitter2.prototype), "addListener", this).call(this, event, listener);
    }
  }, {
    key: "removeListener",
    value: function removeListener4(event, listener) {
      return _get__default$1["default"](_getPrototypeOf__default$4["default"](ReplayEventEmitter2.prototype), "removeListener", this).call(this, event, listener);
    }
  }, {
    key: "addListenerWithReplay",
    value: function addListenerWithReplay(event, listener) {
      var historyEntry = this.eventHistory.get(event);
      if (historyEntry !== void 0) {
        listener.apply(void 0, _toConsumableArray__default$2["default"](historyEntry));
      }
      return this.addListener(event, listener);
    }
  }, {
    key: "onWithReplay",
    value: function onWithReplay(event, listener) {
      return this.addListenerWithReplay(event, listener);
    }
  }, {
    key: "onceWithReplay",
    value: function onceWithReplay(event, listener) {
      var historyEntry = this.eventHistory.get(event);
      if (historyEntry !== void 0) {
        listener.apply(void 0, _toConsumableArray__default$2["default"](historyEntry));
        return this;
      }
      return _get__default$1["default"](_getPrototypeOf__default$4["default"](ReplayEventEmitter2.prototype), "once", this).call(this, event, listener);
    }
  }]);
  return ReplayEventEmitter2;
}(EventEmitter$2);
browser$8.ReplayEventEmitter = ReplayEventEmitter;
var lodash_isequal = { exports: {} };
lodash_isequal.exports;
(function(module, exports) {
  var LARGE_ARRAY_SIZE = 200;
  var HASH_UNDEFINED = "__lodash_hash_undefined__";
  var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
  var MAX_SAFE_INTEGER2 = 9007199254740991;
  var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
  var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
  var reIsHostCtor = /^\[object .+?Constructor\]$/;
  var reIsUint = /^(?:0|[1-9]\d*)$/;
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
  var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
  var freeSelf = typeof self == "object" && self && self.Object === Object && self;
  var root = freeGlobal || freeSelf || Function("return this")();
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var freeProcess = moduleExports && freeGlobal.process;
  var nodeUtil = function() {
    try {
      return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {
    }
  }();
  var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
  function arrayFilter(array5, predicate) {
    var index2 = -1, length = array5 == null ? 0 : array5.length, resIndex = 0, result = [];
    while (++index2 < length) {
      var value = array5[index2];
      if (predicate(value, index2, array5)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }
  function arrayPush(array5, values4) {
    var index2 = -1, length = values4.length, offset = array5.length;
    while (++index2 < length) {
      array5[offset + index2] = values4[index2];
    }
    return array5;
  }
  function arraySome(array5, predicate) {
    var index2 = -1, length = array5 == null ? 0 : array5.length;
    while (++index2 < length) {
      if (predicate(array5[index2], index2, array5)) {
        return true;
      }
    }
    return false;
  }
  function baseTimes(n, iteratee) {
    var index2 = -1, result = Array(n);
    while (++index2 < n) {
      result[index2] = iteratee(index2);
    }
    return result;
  }
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }
  function cacheHas(cache, key) {
    return cache.has(key);
  }
  function getValue(object, key) {
    return object == null ? void 0 : object[key];
  }
  function mapToArray(map3) {
    var index2 = -1, result = Array(map3.size);
    map3.forEach(function(value, key) {
      result[++index2] = [key, value];
    });
    return result;
  }
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }
  function setToArray(set4) {
    var index2 = -1, result = Array(set4.size);
    set4.forEach(function(value) {
      result[++index2] = value;
    });
    return result;
  }
  var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
  var coreJsData = root["__core-js_shared__"];
  var funcToString = funcProto.toString;
  var hasOwnProperty2 = objectProto.hasOwnProperty;
  var maskSrcKey = function() {
    var uid2 = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid2 ? "Symbol(src)_1." + uid2 : "";
  }();
  var nativeObjectToString = objectProto.toString;
  var reIsNative = RegExp(
    "^" + funcToString.call(hasOwnProperty2).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  var Buffer3 = moduleExports ? root.Buffer : void 0, Symbol2 = root.Symbol, Uint8Array2 = root.Uint8Array, propertyIsEnumerable4 = objectProto.propertyIsEnumerable, splice3 = arrayProto.splice, symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
  var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer3 ? Buffer3.isBuffer : void 0, nativeKeys2 = overArg(Object.keys, Object);
  var DataView2 = getNative(root, "DataView"), Map2 = getNative(root, "Map"), Promise2 = getNative(root, "Promise"), Set2 = getNative(root, "Set"), WeakMap3 = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
  var dataViewCtorString = toSource(DataView2), mapCtorString = toSource(Map2), promiseCtorString = toSource(Promise2), setCtorString = toSource(Set2), weakMapCtorString = toSource(WeakMap3);
  var symbolProto = Symbol2 ? Symbol2.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
  function Hash(entries4) {
    var index2 = -1, length = entries4 == null ? 0 : entries4.length;
    this.clear();
    while (++index2 < length) {
      var entry = entries4[index2];
      this.set(entry[0], entry[1]);
    }
  }
  function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
  }
  function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
  }
  function hashGet(key) {
    var data2 = this.__data__;
    if (nativeCreate) {
      var result = data2[key];
      return result === HASH_UNDEFINED ? void 0 : result;
    }
    return hasOwnProperty2.call(data2, key) ? data2[key] : void 0;
  }
  function hashHas(key) {
    var data2 = this.__data__;
    return nativeCreate ? data2[key] !== void 0 : hasOwnProperty2.call(data2, key);
  }
  function hashSet(key, value) {
    var data2 = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data2[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED : value;
    return this;
  }
  Hash.prototype.clear = hashClear;
  Hash.prototype["delete"] = hashDelete;
  Hash.prototype.get = hashGet;
  Hash.prototype.has = hashHas;
  Hash.prototype.set = hashSet;
  function ListCache(entries4) {
    var index2 = -1, length = entries4 == null ? 0 : entries4.length;
    this.clear();
    while (++index2 < length) {
      var entry = entries4[index2];
      this.set(entry[0], entry[1]);
    }
  }
  function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
  }
  function listCacheDelete(key) {
    var data2 = this.__data__, index2 = assocIndexOf(data2, key);
    if (index2 < 0) {
      return false;
    }
    var lastIndex = data2.length - 1;
    if (index2 == lastIndex) {
      data2.pop();
    } else {
      splice3.call(data2, index2, 1);
    }
    --this.size;
    return true;
  }
  function listCacheGet(key) {
    var data2 = this.__data__, index2 = assocIndexOf(data2, key);
    return index2 < 0 ? void 0 : data2[index2][1];
  }
  function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
  }
  function listCacheSet(key, value) {
    var data2 = this.__data__, index2 = assocIndexOf(data2, key);
    if (index2 < 0) {
      ++this.size;
      data2.push([key, value]);
    } else {
      data2[index2][1] = value;
    }
    return this;
  }
  ListCache.prototype.clear = listCacheClear;
  ListCache.prototype["delete"] = listCacheDelete;
  ListCache.prototype.get = listCacheGet;
  ListCache.prototype.has = listCacheHas;
  ListCache.prototype.set = listCacheSet;
  function MapCache(entries4) {
    var index2 = -1, length = entries4 == null ? 0 : entries4.length;
    this.clear();
    while (++index2 < length) {
      var entry = entries4[index2];
      this.set(entry[0], entry[1]);
    }
  }
  function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
      "hash": new Hash(),
      "map": new (Map2 || ListCache)(),
      "string": new Hash()
    };
  }
  function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
  }
  function mapCacheGet(key) {
    return getMapData(this, key).get(key);
  }
  function mapCacheHas(key) {
    return getMapData(this, key).has(key);
  }
  function mapCacheSet(key, value) {
    var data2 = getMapData(this, key), size2 = data2.size;
    data2.set(key, value);
    this.size += data2.size == size2 ? 0 : 1;
    return this;
  }
  MapCache.prototype.clear = mapCacheClear;
  MapCache.prototype["delete"] = mapCacheDelete;
  MapCache.prototype.get = mapCacheGet;
  MapCache.prototype.has = mapCacheHas;
  MapCache.prototype.set = mapCacheSet;
  function SetCache(values4) {
    var index2 = -1, length = values4 == null ? 0 : values4.length;
    this.__data__ = new MapCache();
    while (++index2 < length) {
      this.add(values4[index2]);
    }
  }
  function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
  }
  function setCacheHas(value) {
    return this.__data__.has(value);
  }
  SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
  SetCache.prototype.has = setCacheHas;
  function Stack(entries4) {
    var data2 = this.__data__ = new ListCache(entries4);
    this.size = data2.size;
  }
  function stackClear() {
    this.__data__ = new ListCache();
    this.size = 0;
  }
  function stackDelete(key) {
    var data2 = this.__data__, result = data2["delete"](key);
    this.size = data2.size;
    return result;
  }
  function stackGet(key) {
    return this.__data__.get(key);
  }
  function stackHas(key) {
    return this.__data__.has(key);
  }
  function stackSet(key, value) {
    var data2 = this.__data__;
    if (data2 instanceof ListCache) {
      var pairs = data2.__data__;
      if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
        pairs.push([key, value]);
        this.size = ++data2.size;
        return this;
      }
      data2 = this.__data__ = new MapCache(pairs);
    }
    data2.set(key, value);
    this.size = data2.size;
    return this;
  }
  Stack.prototype.clear = stackClear;
  Stack.prototype["delete"] = stackDelete;
  Stack.prototype.get = stackGet;
  Stack.prototype.has = stackHas;
  Stack.prototype.set = stackSet;
  function arrayLikeKeys(value, inherited) {
    var isArr = isArray3(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray2(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for (var key in value) {
      if ((inherited || hasOwnProperty2.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
      (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
      isIndex(key, length)))) {
        result.push(key);
      }
    }
    return result;
  }
  function assocIndexOf(array5, key) {
    var length = array5.length;
    while (length--) {
      if (eq(array5[length][0], key)) {
        return length;
      }
    }
    return -1;
  }
  function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray3(object) ? result : arrayPush(result, symbolsFunc(object));
  }
  function baseGetTag(value) {
    if (value == null) {
      return value === void 0 ? undefinedTag : nullTag;
    }
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString2(value);
  }
  function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
  }
  function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) {
      return true;
    }
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
      return value !== value && other !== other;
    }
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
  }
  function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray3(object), othIsArr = isArray3(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
      if (!isBuffer(other)) {
        return false;
      }
      objIsArr = true;
      objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
      stack || (stack = new Stack());
      return objIsArr || isTypedArray2(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
      var objIsWrapped = objIsObj && hasOwnProperty2.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty2.call(other, "__wrapped__");
      if (objIsWrapped || othIsWrapped) {
        var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
        stack || (stack = new Stack());
        return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
      }
    }
    if (!isSameTag) {
      return false;
    }
    stack || (stack = new Stack());
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
  }
  function baseIsNative(value) {
    if (!isObject2(value) || isMasked(value)) {
      return false;
    }
    var pattern2 = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern2.test(toSource(value));
  }
  function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
  }
  function baseKeys(object) {
    if (!isPrototype(object)) {
      return nativeKeys2(object);
    }
    var result = [];
    for (var key in Object(object)) {
      if (hasOwnProperty2.call(object, key) && key != "constructor") {
        result.push(key);
      }
    }
    return result;
  }
  function equalArrays(array5, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array5.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
      return false;
    }
    var stacked = stack.get(array5);
    if (stacked && stack.get(other)) {
      return stacked == other;
    }
    var index2 = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : void 0;
    stack.set(array5, other);
    stack.set(other, array5);
    while (++index2 < arrLength) {
      var arrValue = array5[index2], othValue = other[index2];
      if (customizer) {
        var compared = isPartial ? customizer(othValue, arrValue, index2, other, array5, stack) : customizer(arrValue, othValue, index2, array5, other, stack);
      }
      if (compared !== void 0) {
        if (compared) {
          continue;
        }
        result = false;
        break;
      }
      if (seen) {
        if (!arraySome(other, function(othValue2, othIndex) {
          if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
            return seen.push(othIndex);
          }
        })) {
          result = false;
          break;
        }
      } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
        result = false;
        break;
      }
    }
    stack["delete"](array5);
    stack["delete"](other);
    return result;
  }
  function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch (tag) {
      case dataViewTag:
        if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
          return false;
        }
        object = object.buffer;
        other = other.buffer;
      case arrayBufferTag:
        if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object), new Uint8Array2(other))) {
          return false;
        }
        return true;
      case boolTag:
      case dateTag:
      case numberTag:
        return eq(+object, +other);
      case errorTag:
        return object.name == other.name && object.message == other.message;
      case regexpTag:
      case stringTag:
        return object == other + "";
      case mapTag:
        var convert = mapToArray;
      case setTag:
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
        convert || (convert = setToArray);
        if (object.size != other.size && !isPartial) {
          return false;
        }
        var stacked = stack.get(object);
        if (stacked) {
          return stacked == other;
        }
        bitmask |= COMPARE_UNORDERED_FLAG;
        stack.set(object, other);
        var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
        stack["delete"](object);
        return result;
      case symbolTag:
        if (symbolValueOf) {
          return symbolValueOf.call(object) == symbolValueOf.call(other);
        }
    }
    return false;
  }
  function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) {
      return false;
    }
    var index2 = objLength;
    while (index2--) {
      var key = objProps[index2];
      if (!(isPartial ? key in other : hasOwnProperty2.call(other, key))) {
        return false;
      }
    }
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) {
      return stacked == other;
    }
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while (++index2 < objLength) {
      key = objProps[index2];
      var objValue = object[key], othValue = other[key];
      if (customizer) {
        var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
      }
      if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
        result = false;
        break;
      }
      skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
      var objCtor = object.constructor, othCtor = other.constructor;
      if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
        result = false;
      }
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
  }
  function getAllKeys(object) {
    return baseGetAllKeys(object, keys6, getSymbols);
  }
  function getMapData(map3, key) {
    var data2 = map3.__data__;
    return isKeyable(key) ? data2[typeof key == "string" ? "string" : "hash"] : data2.map;
  }
  function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : void 0;
  }
  function getRawTag(value) {
    var isOwn = hasOwnProperty2.call(value, symToStringTag), tag = value[symToStringTag];
    try {
      value[symToStringTag] = void 0;
      var unmasked = true;
    } catch (e) {
    }
    var result = nativeObjectToString.call(value);
    if (unmasked) {
      if (isOwn) {
        value[symToStringTag] = tag;
      } else {
        delete value[symToStringTag];
      }
    }
    return result;
  }
  var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) {
      return [];
    }
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
      return propertyIsEnumerable4.call(object, symbol);
    });
  };
  var getTag = baseGetTag;
  if (DataView2 && getTag(new DataView2(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set2 && getTag(new Set2()) != setTag || WeakMap3 && getTag(new WeakMap3()) != weakMapTag) {
    getTag = function(value) {
      var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
      if (ctorString) {
        switch (ctorString) {
          case dataViewCtorString:
            return dataViewTag;
          case mapCtorString:
            return mapTag;
          case promiseCtorString:
            return promiseTag;
          case setCtorString:
            return setTag;
          case weakMapCtorString:
            return weakMapTag;
        }
      }
      return result;
    };
  }
  function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER2 : length;
    return !!length && (typeof value == "number" || reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
  }
  function isKeyable(value) {
    var type5 = typeof value;
    return type5 == "string" || type5 == "number" || type5 == "symbol" || type5 == "boolean" ? value !== "__proto__" : value === null;
  }
  function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
  }
  function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
  }
  function objectToString2(value) {
    return nativeObjectToString.call(value);
  }
  function toSource(func) {
    if (func != null) {
      try {
        return funcToString.call(func);
      } catch (e) {
      }
      try {
        return func + "";
      } catch (e) {
      }
    }
    return "";
  }
  function eq(value, other) {
    return value === other || value !== value && other !== other;
  }
  var isArguments = baseIsArguments(function() {
    return arguments;
  }()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty2.call(value, "callee") && !propertyIsEnumerable4.call(value, "callee");
  };
  var isArray3 = Array.isArray;
  function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
  }
  var isBuffer = nativeIsBuffer || stubFalse;
  function isEqual(value, other) {
    return baseIsEqual(value, other);
  }
  function isFunction(value) {
    if (!isObject2(value)) {
      return false;
    }
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
  }
  function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER2;
  }
  function isObject2(value) {
    var type5 = typeof value;
    return value != null && (type5 == "object" || type5 == "function");
  }
  function isObjectLike(value) {
    return value != null && typeof value == "object";
  }
  var isTypedArray2 = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
  function keys6(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
  }
  function stubArray() {
    return [];
  }
  function stubFalse() {
    return false;
  }
  module.exports = isEqual;
})(lodash_isequal, lodash_isequal.exports);
var lodash_isequalExports = lodash_isequal.exports;
var internalMetadata = { exports: {} };
var fails$i = fails$M;
var arrayBufferNonExtensible = fails$i(function() {
  if (typeof ArrayBuffer == "function") {
    var buffer = new ArrayBuffer(8);
    if (Object.isExtensible(buffer))
      Object.defineProperty(buffer, "a", { value: 8 });
  }
});
var fails$h = fails$M;
var isObject$8 = isObject$q;
var classof$6 = classofRaw$2;
var ARRAY_BUFFER_NON_EXTENSIBLE = arrayBufferNonExtensible;
var $isExtensible = Object.isExtensible;
var FAILS_ON_PRIMITIVES$1 = fails$h(function() {
  $isExtensible(1);
});
var objectIsExtensible = FAILS_ON_PRIMITIVES$1 || ARRAY_BUFFER_NON_EXTENSIBLE ? function isExtensible(it) {
  if (!isObject$8(it))
    return false;
  if (ARRAY_BUFFER_NON_EXTENSIBLE && classof$6(it) === "ArrayBuffer")
    return false;
  return $isExtensible ? $isExtensible(it) : true;
} : $isExtensible;
var fails$g = fails$M;
var freezing = !fails$g(function() {
  return Object.isExtensible(Object.preventExtensions({}));
});
internalMetadata.exports;
var $$c = _export;
var uncurryThis$h = functionUncurryThis;
var hiddenKeys = hiddenKeys$6;
var isObject$7 = isObject$q;
var hasOwn$6 = hasOwnProperty_1;
var defineProperty$1 = objectDefineProperty.f;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertyNamesExternalModule = objectGetOwnPropertyNamesExternal;
var isExtensible2 = objectIsExtensible;
var uid$1 = uid$5;
var FREEZING$1 = freezing;
var REQUIRED = false;
var METADATA = uid$1("meta");
var id$1 = 0;
var setMetadata = function(it) {
  defineProperty$1(it, METADATA, { value: {
    objectID: "O" + id$1++,
    // object ID
    weakData: {}
    // weak collections IDs
  } });
};
var fastKey$1 = function(it, create4) {
  if (!isObject$7(it))
    return typeof it == "symbol" ? it : (typeof it == "string" ? "S" : "P") + it;
  if (!hasOwn$6(it, METADATA)) {
    if (!isExtensible2(it))
      return "F";
    if (!create4)
      return "E";
    setMetadata(it);
  }
  return it[METADATA].objectID;
};
var getWeakData$1 = function(it, create4) {
  if (!hasOwn$6(it, METADATA)) {
    if (!isExtensible2(it))
      return true;
    if (!create4)
      return false;
    setMetadata(it);
  }
  return it[METADATA].weakData;
};
var onFreeze$1 = function(it) {
  if (FREEZING$1 && REQUIRED && isExtensible2(it) && !hasOwn$6(it, METADATA))
    setMetadata(it);
  return it;
};
var enable = function() {
  meta.enable = function() {
  };
  REQUIRED = true;
  var getOwnPropertyNames5 = getOwnPropertyNamesModule.f;
  var splice3 = uncurryThis$h([].splice);
  var test2 = {};
  test2[METADATA] = 1;
  if (getOwnPropertyNames5(test2).length) {
    getOwnPropertyNamesModule.f = function(it) {
      var result = getOwnPropertyNames5(it);
      for (var i = 0, length = result.length; i < length; i++) {
        if (result[i] === METADATA) {
          splice3(result, i, 1);
          break;
        }
      }
      return result;
    };
    $$c({ target: "Object", stat: true, forced: true }, {
      getOwnPropertyNames: getOwnPropertyNamesExternalModule.f
    });
  }
};
var meta = internalMetadata.exports = {
  enable,
  fastKey: fastKey$1,
  getWeakData: getWeakData$1,
  onFreeze: onFreeze$1
};
hiddenKeys[METADATA] = true;
var internalMetadataExports = internalMetadata.exports;
var $$b = _export;
var global$c = global$D;
var uncurryThis$g = functionUncurryThis;
var isForced = isForced_1;
var defineBuiltIn$5 = defineBuiltIn$f;
var InternalMetadataModule = internalMetadataExports;
var iterate$2 = iterate$5;
var anInstance$6 = anInstance$8;
var isCallable$2 = isCallable$t;
var isNullOrUndefined$5 = isNullOrUndefined$b;
var isObject$6 = isObject$q;
var fails$f = fails$M;
var checkCorrectnessOfIteration$1 = checkCorrectnessOfIteration$4;
var setToStringTag$3 = setToStringTag$a;
var inheritIfRequired$2 = inheritIfRequired$4;
var collection$3 = function(CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf("Map") !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf("Weak") !== -1;
  var ADDER = IS_MAP ? "set" : "add";
  var NativeConstructor = global$c[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor2 = NativeConstructor;
  var exported = {};
  var fixMethod = function(KEY) {
    var uncurriedNativeMethod = uncurryThis$g(NativePrototype[KEY]);
    defineBuiltIn$5(
      NativePrototype,
      KEY,
      KEY === "add" ? function add(value) {
        uncurriedNativeMethod(this, value === 0 ? 0 : value);
        return this;
      } : KEY === "delete" ? function(key) {
        return IS_WEAK && !isObject$6(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY === "get" ? function get3(key) {
        return IS_WEAK && !isObject$6(key) ? void 0 : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY === "has" ? function has3(key) {
        return IS_WEAK && !isObject$6(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : function set4(key, value) {
        uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
        return this;
      }
    );
  };
  var REPLACE2 = isForced(
    CONSTRUCTOR_NAME,
    !isCallable$2(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails$f(function() {
      new NativeConstructor().entries().next();
    }))
  );
  if (REPLACE2) {
    Constructor2 = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule.enable();
  } else if (isForced(CONSTRUCTOR_NAME, true)) {
    var instance2 = new Constructor2();
    var HASNT_CHAINING = instance2[ADDER](IS_WEAK ? {} : -0, 1) !== instance2;
    var THROWS_ON_PRIMITIVES = fails$f(function() {
      instance2.has(1);
    });
    var ACCEPT_ITERABLES = checkCorrectnessOfIteration$1(function(iterable) {
      new NativeConstructor(iterable);
    });
    var BUGGY_ZERO = !IS_WEAK && fails$f(function() {
      var $instance = new NativeConstructor();
      var index2 = 5;
      while (index2--)
        $instance[ADDER](index2, index2);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      Constructor2 = wrapper(function(dummy, iterable) {
        anInstance$6(dummy, NativePrototype);
        var that = inheritIfRequired$2(new NativeConstructor(), dummy, Constructor2);
        if (!isNullOrUndefined$5(iterable))
          iterate$2(iterable, that[ADDER], { that, AS_ENTRIES: IS_MAP });
        return that;
      });
      Constructor2.prototype = NativePrototype;
      NativePrototype.constructor = Constructor2;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod("delete");
      fixMethod("has");
      IS_MAP && fixMethod("get");
    }
    if (BUGGY_ZERO || HASNT_CHAINING)
      fixMethod(ADDER);
    if (IS_WEAK && NativePrototype.clear)
      delete NativePrototype.clear;
  }
  exported[CONSTRUCTOR_NAME] = Constructor2;
  $$b({ global: true, constructor: true, forced: Constructor2 !== NativeConstructor }, exported);
  setToStringTag$3(Constructor2, CONSTRUCTOR_NAME);
  if (!IS_WEAK)
    common.setStrong(Constructor2, CONSTRUCTOR_NAME, IS_MAP);
  return Constructor2;
};
var defineBuiltIn$4 = defineBuiltIn$f;
var defineBuiltIns$4 = function(target, src2, options) {
  for (var key in src2)
    defineBuiltIn$4(target, key, src2[key], options);
  return target;
};
var create$2 = objectCreate;
var defineBuiltInAccessor$5 = defineBuiltInAccessor$a;
var defineBuiltIns$3 = defineBuiltIns$4;
var bind$3 = functionBindContext;
var anInstance$5 = anInstance$8;
var isNullOrUndefined$4 = isNullOrUndefined$b;
var iterate$1 = iterate$5;
var defineIterator = iteratorDefine;
var createIterResultObject$1 = createIterResultObject$4;
var setSpecies$2 = setSpecies$4;
var DESCRIPTORS$8 = descriptors;
var fastKey = internalMetadataExports.fastKey;
var InternalStateModule$6 = internalState;
var setInternalState$5 = InternalStateModule$6.set;
var internalStateGetterFor$1 = InternalStateModule$6.getterFor;
var collectionStrong$2 = {
  getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var Constructor2 = wrapper(function(that, iterable) {
      anInstance$5(that, Prototype2);
      setInternalState$5(that, {
        type: CONSTRUCTOR_NAME,
        index: create$2(null),
        first: void 0,
        last: void 0,
        size: 0
      });
      if (!DESCRIPTORS$8)
        that.size = 0;
      if (!isNullOrUndefined$4(iterable))
        iterate$1(iterable, that[ADDER], { that, AS_ENTRIES: IS_MAP });
    });
    var Prototype2 = Constructor2.prototype;
    var getInternalState2 = internalStateGetterFor$1(CONSTRUCTOR_NAME);
    var define = function(that, key, value) {
      var state = getInternalState2(that);
      var entry = getEntry(that, key);
      var previous, index2;
      if (entry) {
        entry.value = value;
      } else {
        state.last = entry = {
          index: index2 = fastKey(key, true),
          key,
          value,
          previous: previous = state.last,
          next: void 0,
          removed: false
        };
        if (!state.first)
          state.first = entry;
        if (previous)
          previous.next = entry;
        if (DESCRIPTORS$8)
          state.size++;
        else
          that.size++;
        if (index2 !== "F")
          state.index[index2] = entry;
      }
      return that;
    };
    var getEntry = function(that, key) {
      var state = getInternalState2(that);
      var index2 = fastKey(key);
      var entry;
      if (index2 !== "F")
        return state.index[index2];
      for (entry = state.first; entry; entry = entry.next) {
        if (entry.key === key)
          return entry;
      }
    };
    defineBuiltIns$3(Prototype2, {
      // `{ Map, Set }.prototype.clear()` methods
      // https://tc39.es/ecma262/#sec-map.prototype.clear
      // https://tc39.es/ecma262/#sec-set.prototype.clear
      clear: function clear2() {
        var that = this;
        var state = getInternalState2(that);
        var entry = state.first;
        while (entry) {
          entry.removed = true;
          if (entry.previous)
            entry.previous = entry.previous.next = void 0;
          entry = entry.next;
        }
        state.first = state.last = void 0;
        state.index = create$2(null);
        if (DESCRIPTORS$8)
          state.size = 0;
        else
          that.size = 0;
      },
      // `{ Map, Set }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.delete
      // https://tc39.es/ecma262/#sec-set.prototype.delete
      "delete": function(key) {
        var that = this;
        var state = getInternalState2(that);
        var entry = getEntry(that, key);
        if (entry) {
          var next3 = entry.next;
          var prev = entry.previous;
          delete state.index[entry.index];
          entry.removed = true;
          if (prev)
            prev.next = next3;
          if (next3)
            next3.previous = prev;
          if (state.first === entry)
            state.first = next3;
          if (state.last === entry)
            state.last = prev;
          if (DESCRIPTORS$8)
            state.size--;
          else
            that.size--;
        }
        return !!entry;
      },
      // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.foreach
      // https://tc39.es/ecma262/#sec-set.prototype.foreach
      forEach: function forEach5(callbackfn) {
        var state = getInternalState2(this);
        var boundFunction = bind$3(callbackfn, arguments.length > 1 ? arguments[1] : void 0);
        var entry;
        while (entry = entry ? entry.next : state.first) {
          boundFunction(entry.value, entry.key, this);
          while (entry && entry.removed)
            entry = entry.previous;
        }
      },
      // `{ Map, Set}.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.has
      // https://tc39.es/ecma262/#sec-set.prototype.has
      has: function has3(key) {
        return !!getEntry(this, key);
      }
    });
    defineBuiltIns$3(Prototype2, IS_MAP ? {
      // `Map.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-map.prototype.get
      get: function get3(key) {
        var entry = getEntry(this, key);
        return entry && entry.value;
      },
      // `Map.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-map.prototype.set
      set: function set4(key, value) {
        return define(this, key === 0 ? 0 : key, value);
      }
    } : {
      // `Set.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-set.prototype.add
      add: function add(value) {
        return define(this, value = value === 0 ? 0 : value, value);
      }
    });
    if (DESCRIPTORS$8)
      defineBuiltInAccessor$5(Prototype2, "size", {
        configurable: true,
        get: function() {
          return getInternalState2(this).size;
        }
      });
    return Constructor2;
  },
  setStrong: function(Constructor2, CONSTRUCTOR_NAME, IS_MAP) {
    var ITERATOR_NAME = CONSTRUCTOR_NAME + " Iterator";
    var getInternalCollectionState = internalStateGetterFor$1(CONSTRUCTOR_NAME);
    var getInternalIteratorState2 = internalStateGetterFor$1(ITERATOR_NAME);
    defineIterator(Constructor2, CONSTRUCTOR_NAME, function(iterated, kind) {
      setInternalState$5(this, {
        type: ITERATOR_NAME,
        target: iterated,
        state: getInternalCollectionState(iterated),
        kind,
        last: void 0
      });
    }, function() {
      var state = getInternalIteratorState2(this);
      var kind = state.kind;
      var entry = state.last;
      while (entry && entry.removed)
        entry = entry.previous;
      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
        state.target = void 0;
        return createIterResultObject$1(void 0, true);
      }
      if (kind === "keys")
        return createIterResultObject$1(entry.key, false);
      if (kind === "values")
        return createIterResultObject$1(entry.value, false);
      return createIterResultObject$1([entry.key, entry.value], false);
    }, IS_MAP ? "entries" : "values", !IS_MAP, true);
    setSpecies$2(CONSTRUCTOR_NAME);
  }
};
var collection$2 = collection$3;
var collectionStrong$1 = collectionStrong$2;
collection$2("Map", function(init) {
  return function Map2() {
    return init(this, arguments.length ? arguments[0] : void 0);
  };
}, collectionStrong$1);
var browser$7 = {};
/*
@license
Copyright (c) 2016, Twilio, Inc.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY
SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION
OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN
CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.

*/
Object.defineProperty(browser$7, "__esModule", { value: true });
var _classCallCheck$3 = classCallCheckExports;
var _createClass$1 = createClassExports;
var _assertThisInitialized$1 = assertThisInitializedExports;
var _inherits$3 = inheritsExports;
var _possibleConstructorReturn$3 = possibleConstructorReturnExports;
var _getPrototypeOf$3 = getPrototypeOfExports;
var _defineProperty$1 = definePropertyExports;
function _interopDefaultLegacy$4(e) {
  return e && typeof e === "object" && "default" in e ? e : { "default": e };
}
var _classCallCheck__default$3 = /* @__PURE__ */ _interopDefaultLegacy$4(_classCallCheck$3);
var _createClass__default$1 = /* @__PURE__ */ _interopDefaultLegacy$4(_createClass$1);
var _assertThisInitialized__default$1 = /* @__PURE__ */ _interopDefaultLegacy$4(_assertThisInitialized$1);
var _inherits__default$3 = /* @__PURE__ */ _interopDefaultLegacy$4(_inherits$3);
var _possibleConstructorReturn__default$3 = /* @__PURE__ */ _interopDefaultLegacy$4(_possibleConstructorReturn$3);
var _getPrototypeOf__default$3 = /* @__PURE__ */ _interopDefaultLegacy$4(_getPrototypeOf$3);
var _defineProperty__default$1 = /* @__PURE__ */ _interopDefaultLegacy$4(_defineProperty$1);
var domain$1;
function EventHandlers$1() {
}
EventHandlers$1.prototype = /* @__PURE__ */ Object.create(null);
function EventEmitter$1() {
  EventEmitter$1.init.call(this);
}
EventEmitter$1.EventEmitter = EventEmitter$1;
EventEmitter$1.usingDomains = false;
EventEmitter$1.prototype.domain = void 0;
EventEmitter$1.prototype._events = void 0;
EventEmitter$1.prototype._maxListeners = void 0;
EventEmitter$1.defaultMaxListeners = 10;
EventEmitter$1.init = function() {
  this.domain = null;
  if (EventEmitter$1.usingDomains) {
    if (domain$1.active)
      ;
  }
  if (!this._events || this._events === Object.getPrototypeOf(this)._events) {
    this._events = new EventHandlers$1();
    this._eventsCount = 0;
  }
  this._maxListeners = this._maxListeners || void 0;
};
EventEmitter$1.prototype.setMaxListeners = function setMaxListeners2(n) {
  if (typeof n !== "number" || n < 0 || isNaN(n))
    throw new TypeError('"n" argument must be a positive number');
  this._maxListeners = n;
  return this;
};
function $getMaxListeners$1(that) {
  if (that._maxListeners === void 0)
    return EventEmitter$1.defaultMaxListeners;
  return that._maxListeners;
}
EventEmitter$1.prototype.getMaxListeners = function getMaxListeners2() {
  return $getMaxListeners$1(this);
};
function emitNone$1(handler, isFn, self2) {
  if (isFn)
    handler.call(self2);
  else {
    var len = handler.length;
    var listeners4 = arrayClone$1(handler, len);
    for (var i = 0; i < len; ++i)
      listeners4[i].call(self2);
  }
}
function emitOne$1(handler, isFn, self2, arg1) {
  if (isFn)
    handler.call(self2, arg1);
  else {
    var len = handler.length;
    var listeners4 = arrayClone$1(handler, len);
    for (var i = 0; i < len; ++i)
      listeners4[i].call(self2, arg1);
  }
}
function emitTwo$1(handler, isFn, self2, arg1, arg2) {
  if (isFn)
    handler.call(self2, arg1, arg2);
  else {
    var len = handler.length;
    var listeners4 = arrayClone$1(handler, len);
    for (var i = 0; i < len; ++i)
      listeners4[i].call(self2, arg1, arg2);
  }
}
function emitThree$1(handler, isFn, self2, arg1, arg2, arg3) {
  if (isFn)
    handler.call(self2, arg1, arg2, arg3);
  else {
    var len = handler.length;
    var listeners4 = arrayClone$1(handler, len);
    for (var i = 0; i < len; ++i)
      listeners4[i].call(self2, arg1, arg2, arg3);
  }
}
function emitMany$1(handler, isFn, self2, args) {
  if (isFn)
    handler.apply(self2, args);
  else {
    var len = handler.length;
    var listeners4 = arrayClone$1(handler, len);
    for (var i = 0; i < len; ++i)
      listeners4[i].apply(self2, args);
  }
}
EventEmitter$1.prototype.emit = function emit2(type5) {
  var er, handler, len, args, i, events, domain2;
  var doError = type5 === "error";
  events = this._events;
  if (events)
    doError = doError && events.error == null;
  else if (!doError)
    return false;
  domain2 = this.domain;
  if (doError) {
    er = arguments[1];
    if (domain2) {
      if (!er)
        er = new Error('Uncaught, unspecified "error" event');
      er.domainEmitter = this;
      er.domain = domain2;
      er.domainThrown = false;
      domain2.emit("error", er);
    } else if (er instanceof Error) {
      throw er;
    } else {
      var err = new Error('Uncaught, unspecified "error" event. (' + er + ")");
      err.context = er;
      throw err;
    }
    return false;
  }
  handler = events[type5];
  if (!handler)
    return false;
  var isFn = typeof handler === "function";
  len = arguments.length;
  switch (len) {
    case 1:
      emitNone$1(handler, isFn, this);
      break;
    case 2:
      emitOne$1(handler, isFn, this, arguments[1]);
      break;
    case 3:
      emitTwo$1(handler, isFn, this, arguments[1], arguments[2]);
      break;
    case 4:
      emitThree$1(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
      break;
    default:
      args = new Array(len - 1);
      for (i = 1; i < len; i++)
        args[i - 1] = arguments[i];
      emitMany$1(handler, isFn, this, args);
  }
  return true;
};
function _addListener$1(target, type5, listener, prepend) {
  var m;
  var events;
  var existing;
  if (typeof listener !== "function")
    throw new TypeError('"listener" argument must be a function');
  events = target._events;
  if (!events) {
    events = target._events = new EventHandlers$1();
    target._eventsCount = 0;
  } else {
    if (events.newListener) {
      target.emit(
        "newListener",
        type5,
        listener.listener ? listener.listener : listener
      );
      events = target._events;
    }
    existing = events[type5];
  }
  if (!existing) {
    existing = events[type5] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === "function") {
      existing = events[type5] = prepend ? [listener, existing] : [existing, listener];
    } else {
      if (prepend) {
        existing.unshift(listener);
      } else {
        existing.push(listener);
      }
    }
    if (!existing.warned) {
      m = $getMaxListeners$1(target);
      if (m && m > 0 && existing.length > m) {
        existing.warned = true;
        var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + type5 + " listeners added. Use emitter.setMaxListeners() to increase limit");
        w.name = "MaxListenersExceededWarning";
        w.emitter = target;
        w.type = type5;
        w.count = existing.length;
        emitWarning$1(w);
      }
    }
  }
  return target;
}
function emitWarning$1(e) {
  typeof console.warn === "function" ? console.warn(e) : console.log(e);
}
EventEmitter$1.prototype.addListener = function addListener2(type5, listener) {
  return _addListener$1(this, type5, listener, false);
};
EventEmitter$1.prototype.on = EventEmitter$1.prototype.addListener;
EventEmitter$1.prototype.prependListener = function prependListener2(type5, listener) {
  return _addListener$1(this, type5, listener, true);
};
function _onceWrap$1(target, type5, listener) {
  var fired = false;
  function g() {
    target.removeListener(type5, g);
    if (!fired) {
      fired = true;
      listener.apply(target, arguments);
    }
  }
  g.listener = listener;
  return g;
}
EventEmitter$1.prototype.once = function once2(type5, listener) {
  if (typeof listener !== "function")
    throw new TypeError('"listener" argument must be a function');
  this.on(type5, _onceWrap$1(this, type5, listener));
  return this;
};
EventEmitter$1.prototype.prependOnceListener = function prependOnceListener2(type5, listener) {
  if (typeof listener !== "function")
    throw new TypeError('"listener" argument must be a function');
  this.prependListener(type5, _onceWrap$1(this, type5, listener));
  return this;
};
EventEmitter$1.prototype.removeListener = function removeListener2(type5, listener) {
  var list, events, position, i, originalListener;
  if (typeof listener !== "function")
    throw new TypeError('"listener" argument must be a function');
  events = this._events;
  if (!events)
    return this;
  list = events[type5];
  if (!list)
    return this;
  if (list === listener || list.listener && list.listener === listener) {
    if (--this._eventsCount === 0)
      this._events = new EventHandlers$1();
    else {
      delete events[type5];
      if (events.removeListener)
        this.emit("removeListener", type5, list.listener || listener);
    }
  } else if (typeof list !== "function") {
    position = -1;
    for (i = list.length; i-- > 0; ) {
      if (list[i] === listener || list[i].listener && list[i].listener === listener) {
        originalListener = list[i].listener;
        position = i;
        break;
      }
    }
    if (position < 0)
      return this;
    if (list.length === 1) {
      list[0] = void 0;
      if (--this._eventsCount === 0) {
        this._events = new EventHandlers$1();
        return this;
      } else {
        delete events[type5];
      }
    } else {
      spliceOne$1(list, position);
    }
    if (events.removeListener)
      this.emit("removeListener", type5, originalListener || listener);
  }
  return this;
};
EventEmitter$1.prototype.off = function(type5, listener) {
  return this.removeListener(type5, listener);
};
EventEmitter$1.prototype.removeAllListeners = function removeAllListeners2(type5) {
  var listeners4, events;
  events = this._events;
  if (!events)
    return this;
  if (!events.removeListener) {
    if (arguments.length === 0) {
      this._events = new EventHandlers$1();
      this._eventsCount = 0;
    } else if (events[type5]) {
      if (--this._eventsCount === 0)
        this._events = new EventHandlers$1();
      else
        delete events[type5];
    }
    return this;
  }
  if (arguments.length === 0) {
    var keys6 = Object.keys(events);
    for (var i = 0, key; i < keys6.length; ++i) {
      key = keys6[i];
      if (key === "removeListener")
        continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners("removeListener");
    this._events = new EventHandlers$1();
    this._eventsCount = 0;
    return this;
  }
  listeners4 = events[type5];
  if (typeof listeners4 === "function") {
    this.removeListener(type5, listeners4);
  } else if (listeners4) {
    do {
      this.removeListener(type5, listeners4[listeners4.length - 1]);
    } while (listeners4[0]);
  }
  return this;
};
EventEmitter$1.prototype.listeners = function listeners2(type5) {
  var evlistener;
  var ret;
  var events = this._events;
  if (!events)
    ret = [];
  else {
    evlistener = events[type5];
    if (!evlistener)
      ret = [];
    else if (typeof evlistener === "function")
      ret = [evlistener.listener || evlistener];
    else
      ret = unwrapListeners$1(evlistener);
  }
  return ret;
};
EventEmitter$1.listenerCount = function(emitter, type5) {
  if (typeof emitter.listenerCount === "function") {
    return emitter.listenerCount(type5);
  } else {
    return listenerCount$1.call(emitter, type5);
  }
};
EventEmitter$1.prototype.listenerCount = listenerCount$1;
function listenerCount$1(type5) {
  var events = this._events;
  if (events) {
    var evlistener = events[type5];
    if (typeof evlistener === "function") {
      return 1;
    } else if (evlistener) {
      return evlistener.length;
    }
  }
  return 0;
}
EventEmitter$1.prototype.eventNames = function eventNames2() {
  return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
};
function spliceOne$1(list, index2) {
  for (var i = index2, k = i + 1, n = list.length; k < n; i += 1, k += 1)
    list[i] = list[k];
  list.pop();
}
function arrayClone$1(arr, i) {
  var copy = new Array(i);
  while (i--)
    copy[i] = arr[i];
  return copy;
}
function unwrapListeners$1(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}
function _createSuper$1$1(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1$1();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf__default$3["default"](Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf__default$3["default"](this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn__default$3["default"](this, result);
  };
}
function _isNativeReflectConstruct$1$1() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var Retrier = /* @__PURE__ */ function(_EventEmitter) {
  _inherits__default$3["default"](Retrier2, _EventEmitter);
  var _super = _createSuper$1$1(Retrier2);
  function Retrier2(options) {
    var _this;
    _classCallCheck__default$3["default"](this, Retrier2);
    _this = _super.call(this);
    _defineProperty__default$1["default"](_assertThisInitialized__default$1["default"](_this), "timeout", null);
    _defineProperty__default$1["default"](_assertThisInitialized__default$1["default"](_this), "startTimestamp", -1);
    _this.minDelay = options.min;
    _this.maxDelay = options.max;
    _this.initialDelay = options.initial || 0;
    _this.maxAttemptsCount = options.maxAttemptsCount || 0;
    _this.maxAttemptsTime = options.maxAttemptsTime || 0;
    _this.randomness = options.randomness || 0;
    _this.inProgress = false;
    _this.attemptNum = 0;
    _this.prevDelay = 0;
    _this.currDelay = 0;
    return _this;
  }
  _createClass__default$1["default"](Retrier2, [{
    key: "attempt",
    value: function attempt() {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
      this.attemptNum++;
      this.emit("attempt", this);
    }
  }, {
    key: "nextDelay",
    value: function nextDelay(delayOverride) {
      if (typeof delayOverride === "number") {
        this.prevDelay = 0;
        this.currDelay = delayOverride;
        return delayOverride;
      }
      if (this.attemptNum == 0) {
        return this.initialDelay;
      }
      if (this.attemptNum == 1) {
        this.currDelay = this.minDelay;
        return this.currDelay;
      }
      this.prevDelay = this.currDelay;
      var delay = this.currDelay + this.prevDelay;
      if (this.maxDelay && delay > this.maxDelay) {
        this.currDelay = this.maxDelay;
        delay = this.maxDelay;
      }
      this.currDelay = delay;
      return delay;
    }
  }, {
    key: "randomize",
    value: function randomize(delay) {
      var area = delay * this.randomness;
      var corr = Math.round(Math.random() * area * 2 - area);
      return Math.max(0, delay + corr);
    }
  }, {
    key: "scheduleAttempt",
    value: function scheduleAttempt(delayOverride) {
      var _this2 = this;
      if (this.maxAttemptsCount && this.attemptNum >= this.maxAttemptsCount) {
        this.cleanup();
        this.emit("failed", new Error("Maximum attempt count limit reached"));
        return;
      }
      var delay = this.nextDelay(delayOverride);
      delay = this.randomize(delay);
      if (this.maxAttemptsTime && this.startTimestamp + this.maxAttemptsTime < Date.now() + delay) {
        this.cleanup();
        this.emit("failed", new Error("Maximum attempt time limit reached"));
        return;
      }
      this.timeout = setTimeout(function() {
        return _this2.attempt();
      }, delay);
    }
  }, {
    key: "cleanup",
    value: function cleanup() {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
      this.inProgress = false;
      this.attemptNum = 0;
      this.prevDelay = 0;
      this.currDelay = 0;
    }
  }, {
    key: "start",
    value: function start() {
      if (this.inProgress) {
        throw new Error("Retrier is already in progress");
      }
      this.inProgress = true;
      this.startTimestamp = Date.now();
      this.scheduleAttempt(this.initialDelay);
    }
  }, {
    key: "cancel",
    value: function cancel() {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
        this.inProgress = false;
        this.emit("cancelled");
      }
    }
    // @todo Must be a T here, so the entire Retrier must be typed on this value type.
    // eslint-disable-next-line
  }, {
    key: "succeeded",
    value: function succeeded(arg) {
      this.emit("succeeded", arg);
    }
  }, {
    key: "failed",
    value: function failed(err, nextAttemptDelayOverride) {
      if (this.timeout) {
        throw new Error("Retrier attempt is already in progress");
      }
      this.scheduleAttempt(nextAttemptDelayOverride);
    }
  }]);
  return Retrier2;
}(EventEmitter$1);
var AsyncRetrier = /* @__PURE__ */ function(_EventEmitter2) {
  _inherits__default$3["default"](AsyncRetrier2, _EventEmitter2);
  var _super2 = _createSuper$1$1(AsyncRetrier2);
  function AsyncRetrier2(options) {
    var _this3;
    _classCallCheck__default$3["default"](this, AsyncRetrier2);
    _this3 = _super2.call(this);
    _defineProperty__default$1["default"](_assertThisInitialized__default$1["default"](_this3), "resolve", function() {
      return void 0;
    });
    _defineProperty__default$1["default"](_assertThisInitialized__default$1["default"](_this3), "reject", function() {
      return void 0;
    });
    _this3.retrier = new Retrier(options);
    return _this3;
  }
  _createClass__default$1["default"](AsyncRetrier2, [{
    key: "run",
    value: function run2(handler) {
      var _this4 = this;
      this.retrier.on("attempt", function() {
        handler().then(function(v) {
          return _this4.retrier.succeeded(v);
        }).catch(function(e) {
          return _this4.retrier.failed(e);
        });
      });
      this.retrier.on("succeeded", function(arg) {
        return _this4.resolve(arg);
      });
      this.retrier.on("cancelled", function() {
        return _this4.reject(new Error("Cancelled"));
      });
      this.retrier.on("failed", function(err) {
        return _this4.reject(err);
      });
      return new Promise(function(resolve2, reject2) {
        _this4.resolve = resolve2;
        _this4.reject = reject2;
        _this4.retrier.start();
      });
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.retrier.cancel();
    }
  }]);
  return AsyncRetrier2;
}(EventEmitter$1);
function _createSuper$a(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$a();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf__default$3["default"](Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf__default$3["default"](this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn__default$3["default"](this, result);
  };
}
function _isNativeReflectConstruct$a() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function isDef(value) {
  return value !== void 0 && value !== null;
}
var Backoff = /* @__PURE__ */ function(_EventEmitter) {
  _inherits__default$3["default"](Backoff2, _EventEmitter);
  var _super = _createSuper$a(Backoff2);
  function Backoff2(options) {
    var _this;
    _classCallCheck__default$3["default"](this, Backoff2);
    _this = _super.call(this);
    _defineProperty__default$1["default"](_assertThisInitialized__default$1["default"](_this), "backoffDelay", 0);
    _defineProperty__default$1["default"](_assertThisInitialized__default$1["default"](_this), "nextBackoffDelay", 0);
    _defineProperty__default$1["default"](_assertThisInitialized__default$1["default"](_this), "backoffNumber", 0);
    _defineProperty__default$1["default"](_assertThisInitialized__default$1["default"](_this), "timeoutID", null);
    _defineProperty__default$1["default"](_assertThisInitialized__default$1["default"](_this), "maxNumberOfRetry", -1);
    options = options || {};
    var _options = options, initialDelay = _options.initialDelay, maxDelay = _options.maxDelay, randomisationFactor = _options.randomisationFactor, factor = _options.factor;
    if (isDef(initialDelay) && initialDelay < 1) {
      throw new Error("The initial timeout must be equal to or greater than 1.");
    }
    if (isDef(maxDelay) && maxDelay <= 1) {
      throw new Error("The maximal timeout must be greater than 1.");
    }
    if (isDef(randomisationFactor) && (randomisationFactor < 0 || randomisationFactor > 1)) {
      throw new Error("The randomisation factor must be between 0 and 1.");
    }
    if (isDef(factor) && factor <= 1) {
      throw new Error("Exponential factor should be greater than 1.");
    }
    _this.initialDelay = initialDelay || 100;
    _this.maxDelay = maxDelay || 1e4;
    if (_this.maxDelay <= _this.initialDelay) {
      throw new Error("The maximal backoff delay must be greater than the initial backoff delay.");
    }
    _this.randomisationFactor = randomisationFactor || 0;
    _this.factor = factor || 2;
    _this.reset();
    return _this;
  }
  _createClass__default$1["default"](Backoff2, [{
    key: "backoff",
    value: function backoff(err) {
      if (this.timeoutID == null) {
        if (this.backoffNumber === this.maxNumberOfRetry) {
          this.emit("fail", err);
          this.reset();
        } else {
          this.backoffDelay = this.next();
          this.timeoutID = setTimeout(this.onBackoff.bind(this), this.backoffDelay);
          this.emit("backoff", this.backoffNumber, this.backoffDelay, err);
        }
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      this.backoffDelay = 0;
      this.nextBackoffDelay = this.initialDelay;
      this.backoffNumber = 0;
      if (this.timeoutID) {
        clearTimeout(this.timeoutID);
      }
      this.timeoutID = null;
    }
  }, {
    key: "failAfter",
    value: function failAfter(maxNumberOfRetry) {
      if (maxNumberOfRetry <= 0) {
        throw new Error("Expected a maximum number of retry greater than 0 but got ".concat(maxNumberOfRetry));
      }
      this.maxNumberOfRetry = maxNumberOfRetry;
    }
  }, {
    key: "next",
    value: function next3() {
      this.backoffDelay = Math.min(this.nextBackoffDelay, this.maxDelay);
      this.nextBackoffDelay = this.backoffDelay * this.factor;
      var randomisationMultiple = 1 + Math.random() * this.randomisationFactor;
      return Math.min(this.maxDelay, Math.round(this.backoffDelay * randomisationMultiple));
    }
  }, {
    key: "onBackoff",
    value: function onBackoff() {
      this.timeoutID = null;
      this.emit("ready", this.backoffNumber, this.backoffDelay);
      this.backoffNumber++;
    }
  }], [{
    key: "exponential",
    value: function exponential(options) {
      return new Backoff2(options);
    }
  }]);
  return Backoff2;
}(EventEmitter$1);
browser$7.AsyncRetrier = AsyncRetrier;
browser$7.Backoff = Backoff;
browser$7.Retrier = Retrier;
var browser$6 = {};
var call$9 = functionCall;
var hasOwn$5 = hasOwnProperty_1;
var isPrototypeOf$2 = objectIsPrototypeOf;
var regExpFlags = regexpFlags$1;
var RegExpPrototype$1 = RegExp.prototype;
var regexpGetFlags = function(R) {
  var flags = R.flags;
  return flags === void 0 && !("flags" in RegExpPrototype$1) && !hasOwn$5(R, "flags") && isPrototypeOf$2(RegExpPrototype$1, R) ? call$9(regExpFlags, R) : flags;
};
var PROPER_FUNCTION_NAME$1 = functionName.PROPER;
var defineBuiltIn$3 = defineBuiltIn$f;
var anObject$5 = anObject$m;
var $toString$2 = toString$g;
var fails$e = fails$M;
var getRegExpFlags = regexpGetFlags;
var TO_STRING = "toString";
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];
var NOT_GENERIC = fails$e(function() {
  return nativeToString.call({ source: "a", flags: "b" }) !== "/a/b";
});
var INCORRECT_NAME = PROPER_FUNCTION_NAME$1 && nativeToString.name !== TO_STRING;
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn$3(RegExpPrototype, TO_STRING, function toString6() {
    var R = anObject$5(this);
    var pattern2 = $toString$2(R.source);
    var flags = $toString$2(getRegExpFlags(R));
    return "/" + pattern2 + "/" + flags;
  }, { unsafe: true });
}
var browser$5 = {};
/*
@license
Copyright (c) 2021 Twilio Inc.

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.


*/
Object.defineProperty(browser$5, "__esModule", { value: true });
var _typeof$2 = _typeofExports;
var _slicedToArray$2 = slicedToArrayExports;
var _toConsumableArray$1 = toConsumableArrayExports;
var _classCallCheck$2 = classCallCheckExports;
var _inherits$2 = inheritsExports;
var _possibleConstructorReturn$2 = possibleConstructorReturnExports;
var _getPrototypeOf$2 = getPrototypeOfExports;
function _interopDefaultLegacy$3(e) {
  return e && typeof e === "object" && "default" in e ? e : { "default": e };
}
var _typeof__default$2 = /* @__PURE__ */ _interopDefaultLegacy$3(_typeof$2);
var _slicedToArray__default$2 = /* @__PURE__ */ _interopDefaultLegacy$3(_slicedToArray$2);
var _toConsumableArray__default$1 = /* @__PURE__ */ _interopDefaultLegacy$3(_toConsumableArray$1);
var _classCallCheck__default$2 = /* @__PURE__ */ _interopDefaultLegacy$3(_classCallCheck$2);
var _inherits__default$2 = /* @__PURE__ */ _interopDefaultLegacy$3(_inherits$2);
var _possibleConstructorReturn__default$2 = /* @__PURE__ */ _interopDefaultLegacy$3(_possibleConstructorReturn$2);
var _getPrototypeOf__default$2 = /* @__PURE__ */ _interopDefaultLegacy$3(_getPrototypeOf$2);
var custom$1 = function custom2() {
  for (var _len = arguments.length, checks = new Array(_len), _key = 0; _key < _len; _key++) {
    checks[_key] = arguments[_key];
  }
  return {
    checks
  };
};
function _createForOfIteratorHelper$3$2(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$3$2(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i = 0;
      var F = function F2() {
      };
      return { s: F, n: function n() {
        if (i >= o.length)
          return { done: true };
        return { done: false, value: o[i++] };
      }, e: function e(_e) {
        throw _e;
      }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return { s: function s() {
    it = it.call(o);
  }, n: function n() {
    var step = it.next();
    normalCompletion = step.done;
    return step;
  }, e: function e(_e2) {
    didErr = true;
    err = _e2;
  }, f: function f() {
    try {
      if (!normalCompletion && it.return != null)
        it.return();
    } finally {
      if (didErr)
        throw err;
    }
  } };
}
function _unsupportedIterableToArray$3$2(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$3$2(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$3$2(o, minLen);
}
function _arrayLikeToArray$3$2(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var type$1 = function type2() {
  for (var _len = arguments.length, checks = new Array(_len), _key = 0; _key < _len; _key++) {
    checks[_key] = arguments[_key];
  }
  return custom$1(function(value) {
    var isValid = false;
    var expectedTypes = [];
    var _iterator = _createForOfIteratorHelper$3$2(checks), _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        var _type = _step.value;
        if (typeof _type === "string") {
          isValid = isValid || _typeof__default$2["default"](value) === _type;
          expectedTypes.push("of type ".concat(_type));
          continue;
        }
        isValid = isValid || value instanceof _type;
        expectedTypes.push("an instance of ".concat(_type.name));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return [isValid, expectedTypes];
  });
};
function _createForOfIteratorHelper$2$2(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$2$2(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i = 0;
      var F = function F2() {
      };
      return { s: F, n: function n() {
        if (i >= o.length)
          return { done: true };
        return { done: false, value: o[i++] };
      }, e: function e(_e) {
        throw _e;
      }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return { s: function s() {
    it = it.call(o);
  }, n: function n() {
    var step = it.next();
    normalCompletion = step.done;
    return step;
  }, e: function e(_e2) {
    didErr = true;
    err = _e2;
  }, f: function f() {
    try {
      if (!normalCompletion && it.return != null)
        it.return();
    } finally {
      if (didErr)
        throw err;
    }
  } };
}
function _unsupportedIterableToArray$2$2(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$2$2(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$2$2(o, minLen);
}
function _arrayLikeToArray$2$2(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var literal$1 = function literal2() {
  for (var _len = arguments.length, checks = new Array(_len), _key = 0; _key < _len; _key++) {
    checks[_key] = arguments[_key];
  }
  return custom$1(function(value) {
    var isValid = false;
    var expectedTypes = [];
    var _iterator = _createForOfIteratorHelper$2$2(checks), _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        var type5 = _step.value;
        isValid = isValid || value === type5;
        expectedTypes.push(typeof type5 === "string" ? '"'.concat(type5, '"') : "".concat(type5));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return [isValid, expectedTypes];
  });
};
var nonEmptyString$1 = custom$1(function(value) {
  return [typeof value === "string" && value.length > 0, "a non-empty string"];
});
var nonNegativeInteger$1 = custom$1(function(value) {
  return [typeof value === "number" && Number.isInteger(value) && value >= 0, "a non-negative integer"];
});
var pureObject$1 = custom$1(function(value) {
  return [_typeof__default$2["default"](value) === "object" && value !== null && !Array.isArray(value), "a pure object (non-null and non-array)"];
});
function _createSuper$9(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$9();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf__default$2["default"](Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf__default$2["default"](this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn__default$2["default"](this, result);
  };
}
function _isNativeReflectConstruct$9() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _createForOfIteratorHelper$1$2(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$1$2(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i = 0;
      var F = function F2() {
      };
      return { s: F, n: function n() {
        if (i >= o.length)
          return { done: true };
        return { done: false, value: o[i++] };
      }, e: function e(_e) {
        throw _e;
      }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return { s: function s() {
    it = it.call(o);
  }, n: function n() {
    var step = it.next();
    normalCompletion = step.done;
    return step;
  }, e: function e(_e2) {
    didErr = true;
    err = _e2;
  }, f: function f() {
    try {
      if (!normalCompletion && it.return != null)
        it.return();
    } finally {
      if (didErr)
        throw err;
    }
  } };
}
function _unsupportedIterableToArray$1$2(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$1$2(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$1$2(o, minLen);
}
function _arrayLikeToArray$1$2(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var runtimeTypeValidation$1 = function runtimeTypeValidation2(rules, values4) {
  if (values4.length > rules.length) {
    throw new Error("Expected at most ".concat(rules.length, " argument(s), but got ").concat(values4.length));
  }
  while (values4.length < rules.length) {
    values4.push(void 0);
  }
  var _iterator = _createForOfIteratorHelper$1$2(values4.entries()), _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done; ) {
      var _step$value = _slicedToArray__default$2["default"](_step.value, 2), index2 = _step$value[0], value = _step$value[1];
      var _validateValue = validateValue$1(rules[index2], value), _validateValue2 = _slicedToArray__default$2["default"](_validateValue, 4), isValid = _validateValue2[0], received = _validateValue2[1], expected = _validateValue2[2], delimeter = _validateValue2[3];
      if (isValid) {
        continue;
      }
      var argumentIndex = index2 + 1;
      throw new Error("Argument ".concat(argumentIndex, " is expected to be ").concat(expected).concat(delimeter, " but got ").concat(received));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};
var stringifyReceivedType$1 = function stringifyReceivedType2(value) {
  var _value$constructor;
  var receivedType;
  var types = ["undefined", "boolean", "number", "bigint", "string"];
  if (types.includes(_typeof__default$2["default"](value))) {
    receivedType = typeof value === "string" ? '"'.concat(value, '"') : "".concat(value);
  }
  if (_typeof__default$2["default"](value) === "object" && (value === null || value === void 0 ? void 0 : (_value$constructor = value.constructor) === null || _value$constructor === void 0 ? void 0 : _value$constructor.name) !== "Object") {
    var _value$constructor2;
    receivedType = value === null ? "null" : "instance of ".concat(value === null || value === void 0 ? void 0 : (_value$constructor2 = value.constructor) === null || _value$constructor2 === void 0 ? void 0 : _value$constructor2.name);
  }
  if (!receivedType) {
    receivedType = _typeof__default$2["default"](value);
  }
  return receivedType;
};
var validateConstructorTypes$1 = function validateConstructorTypes2() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var finalRuleSet = convertRuleArguments$1(args);
  return function(ctor) {
    return /* @__PURE__ */ function(_ctor) {
      _inherits__default$2["default"](_class, _ctor);
      var _super = _createSuper$9(_class);
      function _class() {
        _classCallCheck__default$2["default"](this, _class);
        for (var _len2 = arguments.length, args2 = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args2[_key2] = arguments[_key2];
        }
        runtimeTypeValidation$1(finalRuleSet, args2);
        return _super.call.apply(_super, [this].concat(args2));
      }
      return _class;
    }(ctor);
  };
};
var validateTypes$1 = function validateTypes2() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }
  var finalRuleSet = convertRuleArguments$1(args);
  return function(target, propertyKey, descriptor) {
    if (typeof descriptor.value !== "function") {
      throw new Error("The validateTypes decorator can only be applied to methods");
    }
    var originalMethod = descriptor.value;
    descriptor.value = function() {
      for (var _len4 = arguments.length, args2 = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args2[_key4] = arguments[_key4];
      }
      runtimeTypeValidation$1(finalRuleSet, args2);
      return originalMethod.apply(this, args2);
    };
  };
};
var validateTypesAsync$1 = function validateTypesAsync2() {
  for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    args[_key5] = arguments[_key5];
  }
  var finalRuleSet = convertRuleArguments$1(args);
  return function(target, propertyKey, descriptor) {
    if (typeof descriptor.value !== "function") {
      throw new Error("The validateTypesAsync decorator can only be applied to methods");
    }
    var originalMethod = descriptor.value;
    descriptor.value = function() {
      for (var _len6 = arguments.length, args2 = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args2[_key6] = arguments[_key6];
      }
      try {
        runtimeTypeValidation$1(finalRuleSet, args2);
      } catch (e) {
        return Promise.reject(e);
      }
      return originalMethod.apply(this, args2);
    };
  };
};
var convertRuleArguments$1 = function convertRuleArguments2(args) {
  var finalRuleDefinitionSet = [];
  var _iterator2 = _createForOfIteratorHelper$1$2(args), _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
      var arg = _step2.value;
      finalRuleDefinitionSet.push(convertRuleArgument$1(arg));
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return finalRuleDefinitionSet;
};
var convertRuleArgument$1 = function convertRuleArgument2(arg) {
  var finalArgumentRuleDefinitions = [];
  var declaredRules = Array.isArray(arg) ? arg : [arg];
  var _iterator3 = _createForOfIteratorHelper$1$2(declaredRules), _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done; ) {
      var rule = _step3.value;
      if (typeof rule === "string" || typeof rule === "function") {
        finalArgumentRuleDefinitions.push(type$1(rule));
        continue;
      }
      finalArgumentRuleDefinitions.push(rule);
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return finalArgumentRuleDefinitions;
};
var validateValue$1 = function validateValue2(ruleDefinitions, value) {
  var expectedTypes = [];
  var customReceivedType;
  var isValid = false;
  var _iterator4 = _createForOfIteratorHelper$1$2(ruleDefinitions), _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done; ) {
      var definition = _step4.value;
      var _iterator5 = _createForOfIteratorHelper$1$2(definition.checks), _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done; ) {
          var check2 = _step5.value;
          var _check = check2(value), _check2 = _slicedToArray__default$2["default"](_check, 3), checkPassed = _check2[0], typeDescription = _check2[1], _receivedType = _check2[2];
          isValid = isValid || checkPassed;
          if (!customReceivedType && _receivedType) {
            customReceivedType = _receivedType;
          }
          if (typeDescription) {
            expectedTypes = typeof typeDescription === "string" ? [].concat(_toConsumableArray__default$1["default"](expectedTypes), [typeDescription]) : [].concat(_toConsumableArray__default$1["default"](expectedTypes), _toConsumableArray__default$1["default"](typeDescription));
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  if (isValid) {
    return [true];
  }
  var receivedType = customReceivedType || stringifyReceivedType$1(value);
  var lastIndex = expectedTypes.length - 1;
  var expectedTypesString = lastIndex > 0 ? "".concat(expectedTypes.slice(0, lastIndex).join(", "), " or ").concat(expectedTypes[lastIndex]) : expectedTypes.join(", ");
  return [false, receivedType, expectedTypesString, lastIndex > 1 ? ";" : ","];
};
var objectSchema$1 = function objectSchema2(name, schema) {
  return custom$1(function(object) {
    if (_typeof__default$2["default"](object) !== "object" || object === null || Array.isArray(object)) {
      return [false, "valid ".concat(name, " (should be a pure object)")];
    }
    for (var _i = 0, _Object$entries = Object.entries(schema); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray__default$2["default"](_Object$entries[_i], 2), key = _Object$entries$_i[0], rules = _Object$entries$_i[1];
      var _validateValue = validateValue$1(convertRuleArgument$1(rules), object[key]), _validateValue2 = _slicedToArray__default$2["default"](_validateValue, 3), isValid = _validateValue2[0], received = _validateValue2[1], expected = _validateValue2[2];
      if (!isValid) {
        return [false, "valid ".concat(name, ' (key "').concat(key, '" should be ').concat(expected, ")"), "malformed ".concat(name, ' (key "').concat(key, '" is ').concat(received, ")")];
      }
    }
    return [true];
  });
};
function _createForOfIteratorHelper$5(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$5(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i = 0;
      var F = function F2() {
      };
      return { s: F, n: function n() {
        if (i >= o.length)
          return { done: true };
        return { done: false, value: o[i++] };
      }, e: function e(_e) {
        throw _e;
      }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return { s: function s() {
    it = it.call(o);
  }, n: function n() {
    var step = it.next();
    normalCompletion = step.done;
    return step;
  }, e: function e(_e2) {
    didErr = true;
    err = _e2;
  }, f: function f() {
    try {
      if (!normalCompletion && it.return != null)
        it.return();
    } finally {
      if (didErr)
        throw err;
    }
  } };
}
function _unsupportedIterableToArray$5(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$5(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$5(o, minLen);
}
function _arrayLikeToArray$5(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var array$1 = function array2(name, rules) {
  return custom$1(function(value) {
    if (!Array.isArray(value)) {
      return [false, "an array of ".concat(name)];
    }
    var _iterator = _createForOfIteratorHelper$5(value.entries()), _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        var _step$value = _slicedToArray__default$2["default"](_step.value, 2), key = _step$value[0], valueOfKey = _step$value[1];
        var _validateValue = validateValue$1(convertRuleArgument$1(rules), valueOfKey), _validateValue2 = _slicedToArray__default$2["default"](_validateValue, 3), isValid = _validateValue2[0], received = _validateValue2[1], expected = _validateValue2[2];
        if (!isValid) {
          return [false, "a valid array of ".concat(name, " (index ").concat(key, " should be ").concat(expected, ")"), "malformed array of ".concat(name, " (index ").concat(key, " is ").concat(received, ")")];
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return [true];
  });
};
browser$5.array = array$1;
browser$5.custom = custom$1;
browser$5.literal = literal$1;
browser$5.nonEmptyString = nonEmptyString$1;
browser$5.nonNegativeInteger = nonNegativeInteger$1;
browser$5.objectSchema = objectSchema$1;
browser$5.pureObject = pureObject$1;
browser$5.runtimeTypeValidation = runtimeTypeValidation$1;
browser$5.stringifyReceivedType = stringifyReceivedType$1;
browser$5.type = type$1;
browser$5.validateConstructorTypes = validateConstructorTypes$1;
browser$5.validateTypes = validateTypes$1;
browser$5.validateTypesAsync = validateTypesAsync$1;
var collection$1 = collection$3;
var collectionStrong = collectionStrong$2;
collection$1("Set", function(init) {
  return function Set2() {
    return init(this, arguments.length ? arguments[0] : void 0);
  };
}, collectionStrong);
var stateMachine = { exports: {} };
stateMachine.exports;
(function(module, exports) {
  (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
  })(commonjsGlobal, function() {
    return (
      /******/
      function(modules) {
        var installedModules = {};
        function __webpack_require__(moduleId) {
          if (installedModules[moduleId]) {
            return installedModules[moduleId].exports;
          }
          var module2 = installedModules[moduleId] = {
            /******/
            i: moduleId,
            /******/
            l: false,
            /******/
            exports: {}
            /******/
          };
          modules[moduleId].call(module2.exports, module2, module2.exports, __webpack_require__);
          module2.l = true;
          return module2.exports;
        }
        __webpack_require__.m = modules;
        __webpack_require__.c = installedModules;
        __webpack_require__.i = function(value) {
          return value;
        };
        __webpack_require__.d = function(exports2, name, getter) {
          if (!__webpack_require__.o(exports2, name)) {
            Object.defineProperty(exports2, name, {
              /******/
              configurable: false,
              /******/
              enumerable: true,
              /******/
              get: getter
              /******/
            });
          }
        };
        __webpack_require__.n = function(module2) {
          var getter = module2 && module2.__esModule ? (
            /******/
            function getDefault() {
              return module2["default"];
            }
          ) : (
            /******/
            function getModuleExports() {
              return module2;
            }
          );
          __webpack_require__.d(getter, "a", getter);
          return getter;
        };
        __webpack_require__.o = function(object, property) {
          return Object.prototype.hasOwnProperty.call(object, property);
        };
        __webpack_require__.p = "";
        return __webpack_require__(__webpack_require__.s = 5);
      }([
        /* 0 */
        /***/
        function(module2, exports2, __webpack_require__) {
          module2.exports = function(target, sources) {
            var n, source, key;
            for (n = 1; n < arguments.length; n++) {
              source = arguments[n];
              for (key in source) {
                if (source.hasOwnProperty(key))
                  target[key] = source[key];
              }
            }
            return target;
          };
        },
        /* 1 */
        /***/
        function(module2, exports2, __webpack_require__) {
          var mixin = __webpack_require__(0);
          module2.exports = {
            build: function(target, config) {
              var n, max2, plugin, plugins = config.plugins;
              for (n = 0, max2 = plugins.length; n < max2; n++) {
                plugin = plugins[n];
                if (plugin.methods)
                  mixin(target, plugin.methods);
                if (plugin.properties)
                  Object.defineProperties(target, plugin.properties);
              }
            },
            hook: function(fsm, name, additional) {
              var n, max2, method, plugin, plugins = fsm.config.plugins, args = [fsm.context];
              if (additional)
                args = args.concat(additional);
              for (n = 0, max2 = plugins.length; n < max2; n++) {
                plugin = plugins[n];
                method = plugins[n][name];
                if (method)
                  method.apply(plugin, args);
              }
            }
          };
        },
        /* 2 */
        /***/
        function(module2, exports2, __webpack_require__) {
          function camelize(label) {
            if (label.length === 0)
              return label;
            var n, result, words = label.split(/[_-]/);
            if (words.length === 1 && words[0][0].toLowerCase() === words[0][0])
              return label;
            result = words[0].toLowerCase();
            for (n = 1; n < words.length; n++) {
              result = result + words[n].charAt(0).toUpperCase() + words[n].substring(1).toLowerCase();
            }
            return result;
          }
          camelize.prepended = function(prepend, label) {
            label = camelize(label);
            return prepend + label[0].toUpperCase() + label.substring(1);
          };
          module2.exports = camelize;
        },
        /* 3 */
        /***/
        function(module2, exports2, __webpack_require__) {
          var mixin = __webpack_require__(0), camelize = __webpack_require__(2);
          function Config(options, StateMachine) {
            options = options || {};
            this.options = options;
            this.defaults = StateMachine.defaults;
            this.states = [];
            this.transitions = [];
            this.map = {};
            this.lifecycle = this.configureLifecycle();
            this.init = this.configureInitTransition(options.init);
            this.data = this.configureData(options.data);
            this.methods = this.configureMethods(options.methods);
            this.map[this.defaults.wildcard] = {};
            this.configureTransitions(options.transitions || []);
            this.plugins = this.configurePlugins(options.plugins, StateMachine.plugin);
          }
          mixin(Config.prototype, {
            addState: function(name) {
              if (!this.map[name]) {
                this.states.push(name);
                this.addStateLifecycleNames(name);
                this.map[name] = {};
              }
            },
            addStateLifecycleNames: function(name) {
              this.lifecycle.onEnter[name] = camelize.prepended("onEnter", name);
              this.lifecycle.onLeave[name] = camelize.prepended("onLeave", name);
              this.lifecycle.on[name] = camelize.prepended("on", name);
            },
            addTransition: function(name) {
              if (this.transitions.indexOf(name) < 0) {
                this.transitions.push(name);
                this.addTransitionLifecycleNames(name);
              }
            },
            addTransitionLifecycleNames: function(name) {
              this.lifecycle.onBefore[name] = camelize.prepended("onBefore", name);
              this.lifecycle.onAfter[name] = camelize.prepended("onAfter", name);
              this.lifecycle.on[name] = camelize.prepended("on", name);
            },
            mapTransition: function(transition) {
              var name = transition.name, from4 = transition.from, to = transition.to;
              this.addState(from4);
              if (typeof to !== "function")
                this.addState(to);
              this.addTransition(name);
              this.map[from4][name] = transition;
              return transition;
            },
            configureLifecycle: function() {
              return {
                onBefore: { transition: "onBeforeTransition" },
                onAfter: { transition: "onAfterTransition" },
                onEnter: { state: "onEnterState" },
                onLeave: { state: "onLeaveState" },
                on: { transition: "onTransition" }
              };
            },
            configureInitTransition: function(init) {
              if (typeof init === "string") {
                return this.mapTransition(mixin({}, this.defaults.init, { to: init, active: true }));
              } else if (typeof init === "object") {
                return this.mapTransition(mixin({}, this.defaults.init, init, { active: true }));
              } else {
                this.addState(this.defaults.init.from);
                return this.defaults.init;
              }
            },
            configureData: function(data2) {
              if (typeof data2 === "function")
                return data2;
              else if (typeof data2 === "object")
                return function() {
                  return data2;
                };
              else
                return function() {
                  return {};
                };
            },
            configureMethods: function(methods) {
              return methods || {};
            },
            configurePlugins: function(plugins, builtin) {
              plugins = plugins || [];
              var n, max2, plugin;
              for (n = 0, max2 = plugins.length; n < max2; n++) {
                plugin = plugins[n];
                if (typeof plugin === "function")
                  plugins[n] = plugin = plugin();
                if (plugin.configure)
                  plugin.configure(this);
              }
              return plugins;
            },
            configureTransitions: function(transitions) {
              var i, n, transition, from4, to, wildcard = this.defaults.wildcard;
              for (n = 0; n < transitions.length; n++) {
                transition = transitions[n];
                from4 = Array.isArray(transition.from) ? transition.from : [transition.from || wildcard];
                to = transition.to || wildcard;
                for (i = 0; i < from4.length; i++) {
                  this.mapTransition({ name: transition.name, from: from4[i], to });
                }
              }
            },
            transitionFor: function(state, transition) {
              var wildcard = this.defaults.wildcard;
              return this.map[state][transition] || this.map[wildcard][transition];
            },
            transitionsFor: function(state) {
              var wildcard = this.defaults.wildcard;
              return Object.keys(this.map[state]).concat(Object.keys(this.map[wildcard]));
            },
            allStates: function() {
              return this.states;
            },
            allTransitions: function() {
              return this.transitions;
            }
          });
          module2.exports = Config;
        },
        /* 4 */
        /***/
        function(module2, exports2, __webpack_require__) {
          var mixin = __webpack_require__(0), Exception = __webpack_require__(6), plugin = __webpack_require__(1), UNOBSERVED = [null, []];
          function JSM(context, config) {
            this.context = context;
            this.config = config;
            this.state = config.init.from;
            this.observers = [context];
          }
          mixin(JSM.prototype, {
            init: function(args) {
              mixin(this.context, this.config.data.apply(this.context, args));
              plugin.hook(this, "init");
              if (this.config.init.active)
                return this.fire(this.config.init.name, []);
            },
            is: function(state) {
              return Array.isArray(state) ? state.indexOf(this.state) >= 0 : this.state === state;
            },
            isPending: function() {
              return this.pending;
            },
            can: function(transition) {
              return !this.isPending() && !!this.seek(transition);
            },
            cannot: function(transition) {
              return !this.can(transition);
            },
            allStates: function() {
              return this.config.allStates();
            },
            allTransitions: function() {
              return this.config.allTransitions();
            },
            transitions: function() {
              return this.config.transitionsFor(this.state);
            },
            seek: function(transition, args) {
              var wildcard = this.config.defaults.wildcard, entry = this.config.transitionFor(this.state, transition), to = entry && entry.to;
              if (typeof to === "function")
                return to.apply(this.context, args);
              else if (to === wildcard)
                return this.state;
              else
                return to;
            },
            fire: function(transition, args) {
              return this.transit(transition, this.state, this.seek(transition, args), args);
            },
            transit: function(transition, from4, to, args) {
              var lifecycle = this.config.lifecycle, changed = this.config.options.observeUnchangedState || from4 !== to;
              if (!to)
                return this.context.onInvalidTransition(transition, from4, to);
              if (this.isPending())
                return this.context.onPendingTransition(transition, from4, to);
              this.config.addState(to);
              this.beginTransit();
              args.unshift({
                // this context will be passed to each lifecycle event observer
                transition,
                from: from4,
                to,
                fsm: this.context
              });
              return this.observeEvents([
                this.observersForEvent(lifecycle.onBefore.transition),
                this.observersForEvent(lifecycle.onBefore[transition]),
                changed ? this.observersForEvent(lifecycle.onLeave.state) : UNOBSERVED,
                changed ? this.observersForEvent(lifecycle.onLeave[from4]) : UNOBSERVED,
                this.observersForEvent(lifecycle.on.transition),
                changed ? ["doTransit", [this]] : UNOBSERVED,
                changed ? this.observersForEvent(lifecycle.onEnter.state) : UNOBSERVED,
                changed ? this.observersForEvent(lifecycle.onEnter[to]) : UNOBSERVED,
                changed ? this.observersForEvent(lifecycle.on[to]) : UNOBSERVED,
                this.observersForEvent(lifecycle.onAfter.transition),
                this.observersForEvent(lifecycle.onAfter[transition]),
                this.observersForEvent(lifecycle.on[transition])
              ], args);
            },
            beginTransit: function() {
              this.pending = true;
            },
            endTransit: function(result) {
              this.pending = false;
              return result;
            },
            failTransit: function(result) {
              this.pending = false;
              throw result;
            },
            doTransit: function(lifecycle) {
              this.state = lifecycle.to;
            },
            observe: function(args) {
              if (args.length === 2) {
                var observer = {};
                observer[args[0]] = args[1];
                this.observers.push(observer);
              } else {
                this.observers.push(args[0]);
              }
            },
            observersForEvent: function(event) {
              var n = 0, max2 = this.observers.length, observer, result = [];
              for (; n < max2; n++) {
                observer = this.observers[n];
                if (observer[event])
                  result.push(observer);
              }
              return [event, result, true];
            },
            observeEvents: function(events, args, previousEvent, previousResult) {
              if (events.length === 0) {
                return this.endTransit(previousResult === void 0 ? true : previousResult);
              }
              var event = events[0][0], observers = events[0][1], pluggable = events[0][2];
              args[0].event = event;
              if (event && pluggable && event !== previousEvent)
                plugin.hook(this, "lifecycle", args);
              if (observers.length === 0) {
                events.shift();
                return this.observeEvents(events, args, event, previousResult);
              } else {
                var observer = observers.shift(), result = observer[event].apply(observer, args);
                if (result && typeof result.then === "function") {
                  return result.then(this.observeEvents.bind(this, events, args, event)).catch(this.failTransit.bind(this));
                } else if (result === false) {
                  return this.endTransit(false);
                } else {
                  return this.observeEvents(events, args, event, result);
                }
              }
            },
            onInvalidTransition: function(transition, from4, to) {
              throw new Exception("transition is invalid in current state", transition, from4, to, this.state);
            },
            onPendingTransition: function(transition, from4, to) {
              throw new Exception("transition is invalid while previous transition is still in progress", transition, from4, to, this.state);
            }
          });
          module2.exports = JSM;
        },
        /* 5 */
        /***/
        function(module2, exports2, __webpack_require__) {
          var mixin = __webpack_require__(0), camelize = __webpack_require__(2), plugin = __webpack_require__(1), Config = __webpack_require__(3), JSM = __webpack_require__(4);
          var PublicMethods = {
            is: function(state) {
              return this._fsm.is(state);
            },
            can: function(transition) {
              return this._fsm.can(transition);
            },
            cannot: function(transition) {
              return this._fsm.cannot(transition);
            },
            observe: function() {
              return this._fsm.observe(arguments);
            },
            transitions: function() {
              return this._fsm.transitions();
            },
            allTransitions: function() {
              return this._fsm.allTransitions();
            },
            allStates: function() {
              return this._fsm.allStates();
            },
            onInvalidTransition: function(t, from4, to) {
              return this._fsm.onInvalidTransition(t, from4, to);
            },
            onPendingTransition: function(t, from4, to) {
              return this._fsm.onPendingTransition(t, from4, to);
            }
          };
          var PublicProperties = {
            state: {
              configurable: false,
              enumerable: true,
              get: function() {
                return this._fsm.state;
              },
              set: function(state) {
                throw Error("use transitions to change state");
              }
            }
          };
          function StateMachine(options) {
            return apply2(this || {}, options);
          }
          function factory() {
            var cstor, options;
            if (typeof arguments[0] === "function") {
              cstor = arguments[0];
              options = arguments[1] || {};
            } else {
              cstor = function() {
                this._fsm.apply(this, arguments);
              };
              options = arguments[0] || {};
            }
            var config = new Config(options, StateMachine);
            build(cstor.prototype, config);
            cstor.prototype._fsm.config = config;
            return cstor;
          }
          function apply2(instance2, options) {
            var config = new Config(options, StateMachine);
            build(instance2, config);
            instance2._fsm();
            return instance2;
          }
          function build(target, config) {
            if (typeof target !== "object" || Array.isArray(target))
              throw Error("StateMachine can only be applied to objects");
            plugin.build(target, config);
            Object.defineProperties(target, PublicProperties);
            mixin(target, PublicMethods);
            mixin(target, config.methods);
            config.allTransitions().forEach(function(transition) {
              target[camelize(transition)] = function() {
                return this._fsm.fire(transition, [].slice.call(arguments));
              };
            });
            target._fsm = function() {
              this._fsm = new JSM(this, config);
              this._fsm.init(arguments);
            };
          }
          StateMachine.version = "3.0.1";
          StateMachine.factory = factory;
          StateMachine.apply = apply2;
          StateMachine.defaults = {
            wildcard: "*",
            init: {
              name: "init",
              from: "none"
            }
          };
          module2.exports = StateMachine;
        },
        /* 6 */
        /***/
        function(module2, exports2, __webpack_require__) {
          module2.exports = function(message, transition, from4, to, current) {
            this.message = message;
            this.transition = transition;
            this.from = from4;
            this.to = to;
            this.current = current;
          };
        }
        /******/
      ])
    );
  });
})(stateMachine, stateMachine.exports);
var stateMachineExports = stateMachine.exports;
var rngBrowser = { exports: {} };
rngBrowser.exports;
var getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if (getRandomValues) {
  var rnds8 = new Uint8Array(16);
  rngBrowser.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  var rnds = new Array(16);
  rngBrowser.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 3) === 0)
        r = Math.random() * 4294967296;
      rnds[i] = r >>> ((i & 3) << 3) & 255;
    }
    return rnds;
  };
}
var rngBrowserExports = rngBrowser.exports;
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 256).toString(16).substr(1);
}
function bytesToUuid$2(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  return [
    bth[buf[i++]],
    bth[buf[i++]],
    bth[buf[i++]],
    bth[buf[i++]],
    "-",
    bth[buf[i++]],
    bth[buf[i++]],
    "-",
    bth[buf[i++]],
    bth[buf[i++]],
    "-",
    bth[buf[i++]],
    bth[buf[i++]],
    "-",
    bth[buf[i++]],
    bth[buf[i++]],
    bth[buf[i++]],
    bth[buf[i++]],
    bth[buf[i++]],
    bth[buf[i++]]
  ].join("");
}
var bytesToUuid_1 = bytesToUuid$2;
var rng$1 = rngBrowserExports;
var bytesToUuid$1 = bytesToUuid_1;
var _nodeId;
var _clockseq;
var _lastMSecs = 0;
var _lastNSecs = 0;
function v1$1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];
  options = options || {};
  var node2 = options.node || _nodeId;
  var clockseq = options.clockseq !== void 0 ? options.clockseq : _clockseq;
  if (node2 == null || clockseq == null) {
    var seedBytes = rng$1();
    if (node2 == null) {
      node2 = _nodeId = [
        seedBytes[0] | 1,
        seedBytes[1],
        seedBytes[2],
        seedBytes[3],
        seedBytes[4],
        seedBytes[5]
      ];
    }
    if (clockseq == null) {
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 16383;
    }
  }
  var msecs = options.msecs !== void 0 ? options.msecs : (/* @__PURE__ */ new Date()).getTime();
  var nsecs = options.nsecs !== void 0 ? options.nsecs : _lastNSecs + 1;
  var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 1e4;
  if (dt < 0 && options.clockseq === void 0) {
    clockseq = clockseq + 1 & 16383;
  }
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === void 0) {
    nsecs = 0;
  }
  if (nsecs >= 1e4) {
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  }
  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;
  msecs += 122192928e5;
  var tl = ((msecs & 268435455) * 1e4 + nsecs) % 4294967296;
  b[i++] = tl >>> 24 & 255;
  b[i++] = tl >>> 16 & 255;
  b[i++] = tl >>> 8 & 255;
  b[i++] = tl & 255;
  var tmh = msecs / 4294967296 * 1e4 & 268435455;
  b[i++] = tmh >>> 8 & 255;
  b[i++] = tmh & 255;
  b[i++] = tmh >>> 24 & 15 | 16;
  b[i++] = tmh >>> 16 & 255;
  b[i++] = clockseq >>> 8 | 128;
  b[i++] = clockseq & 255;
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node2[n];
  }
  return buf ? buf : bytesToUuid$1(b);
}
var v1_1 = v1$1;
var rng = rngBrowserExports;
var bytesToUuid = bytesToUuid_1;
function v4$1(options, buf, offset) {
  var i = buf && offset || 0;
  if (typeof options == "string") {
    buf = options === "binary" ? new Array(16) : null;
    options = null;
  }
  options = options || {};
  var rnds = options.random || (options.rng || rng)();
  rnds[6] = rnds[6] & 15 | 64;
  rnds[8] = rnds[8] & 63 | 128;
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }
  return buf || bytesToUuid(rnds);
}
var v4_1 = v4$1;
var v1 = v1_1;
var v4 = v4_1;
var uuid$1 = v4;
uuid$1.v1 = v1;
uuid$1.v4 = v4;
var uuid_1 = uuid$1;
var typedArrayConstructor = { exports: {} };
var arrayBufferBasicDetection = typeof ArrayBuffer != "undefined" && typeof DataView != "undefined";
var NATIVE_ARRAY_BUFFER$1 = arrayBufferBasicDetection;
var DESCRIPTORS$7 = descriptors;
var global$b = global$D;
var isCallable$1 = isCallable$t;
var isObject$5 = isObject$q;
var hasOwn$4 = hasOwnProperty_1;
var classof$5 = classof$g;
var tryToString$1 = tryToString$7;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$9;
var defineBuiltIn$2 = defineBuiltIn$f;
var defineBuiltInAccessor$4 = defineBuiltInAccessor$a;
var isPrototypeOf$1 = objectIsPrototypeOf;
var getPrototypeOf$1 = objectGetPrototypeOf$1;
var setPrototypeOf$2 = objectSetPrototypeOf;
var wellKnownSymbol$5 = wellKnownSymbol$t;
var uid = uid$5;
var InternalStateModule$5 = internalState;
var enforceInternalState$1 = InternalStateModule$5.enforce;
var getInternalState$1 = InternalStateModule$5.get;
var Int8Array$4 = global$b.Int8Array;
var Int8ArrayPrototype$1 = Int8Array$4 && Int8Array$4.prototype;
var Uint8ClampedArray$1 = global$b.Uint8ClampedArray;
var Uint8ClampedArrayPrototype = Uint8ClampedArray$1 && Uint8ClampedArray$1.prototype;
var TypedArray$1 = Int8Array$4 && getPrototypeOf$1(Int8Array$4);
var TypedArrayPrototype$2 = Int8ArrayPrototype$1 && getPrototypeOf$1(Int8ArrayPrototype$1);
var ObjectPrototype$1 = Object.prototype;
var TypeError$3 = global$b.TypeError;
var TO_STRING_TAG = wellKnownSymbol$5("toStringTag");
var TYPED_ARRAY_TAG$1 = uid("TYPED_ARRAY_TAG");
var TYPED_ARRAY_CONSTRUCTOR = "TypedArrayConstructor";
var NATIVE_ARRAY_BUFFER_VIEWS$2 = NATIVE_ARRAY_BUFFER$1 && !!setPrototypeOf$2 && classof$5(global$b.opera) !== "Opera";
var TYPED_ARRAY_TAG_REQUIRED = false;
var NAME, Constructor, Prototype;
var TypedArrayConstructorsList = {
  Int8Array: 1,
  Uint8Array: 1,
  Uint8ClampedArray: 1,
  Int16Array: 2,
  Uint16Array: 2,
  Int32Array: 4,
  Uint32Array: 4,
  Float32Array: 4,
  Float64Array: 8
};
var BigIntArrayConstructorsList = {
  BigInt64Array: 8,
  BigUint64Array: 8
};
var isView = function isView2(it) {
  if (!isObject$5(it))
    return false;
  var klass = classof$5(it);
  return klass === "DataView" || hasOwn$4(TypedArrayConstructorsList, klass) || hasOwn$4(BigIntArrayConstructorsList, klass);
};
var getTypedArrayConstructor$1 = function(it) {
  var proto = getPrototypeOf$1(it);
  if (!isObject$5(proto))
    return;
  var state = getInternalState$1(proto);
  return state && hasOwn$4(state, TYPED_ARRAY_CONSTRUCTOR) ? state[TYPED_ARRAY_CONSTRUCTOR] : getTypedArrayConstructor$1(proto);
};
var isTypedArray$1 = function(it) {
  if (!isObject$5(it))
    return false;
  var klass = classof$5(it);
  return hasOwn$4(TypedArrayConstructorsList, klass) || hasOwn$4(BigIntArrayConstructorsList, klass);
};
var aTypedArray$n = function(it) {
  if (isTypedArray$1(it))
    return it;
  throw new TypeError$3("Target is not a typed array");
};
var aTypedArrayConstructor$2 = function(C) {
  if (isCallable$1(C) && (!setPrototypeOf$2 || isPrototypeOf$1(TypedArray$1, C)))
    return C;
  throw new TypeError$3(tryToString$1(C) + " is not a typed array constructor");
};
var exportTypedArrayMethod$o = function(KEY, property, forced, options) {
  if (!DESCRIPTORS$7)
    return;
  if (forced)
    for (var ARRAY in TypedArrayConstructorsList) {
      var TypedArrayConstructor = global$b[ARRAY];
      if (TypedArrayConstructor && hasOwn$4(TypedArrayConstructor.prototype, KEY))
        try {
          delete TypedArrayConstructor.prototype[KEY];
        } catch (error2) {
          try {
            TypedArrayConstructor.prototype[KEY] = property;
          } catch (error22) {
          }
        }
    }
  if (!TypedArrayPrototype$2[KEY] || forced) {
    defineBuiltIn$2(TypedArrayPrototype$2, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS$2 && Int8ArrayPrototype$1[KEY] || property, options);
  }
};
var exportTypedArrayStaticMethod = function(KEY, property, forced) {
  var ARRAY, TypedArrayConstructor;
  if (!DESCRIPTORS$7)
    return;
  if (setPrototypeOf$2) {
    if (forced)
      for (ARRAY in TypedArrayConstructorsList) {
        TypedArrayConstructor = global$b[ARRAY];
        if (TypedArrayConstructor && hasOwn$4(TypedArrayConstructor, KEY))
          try {
            delete TypedArrayConstructor[KEY];
          } catch (error2) {
          }
      }
    if (!TypedArray$1[KEY] || forced) {
      try {
        return defineBuiltIn$2(TypedArray$1, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS$2 && TypedArray$1[KEY] || property);
      } catch (error2) {
      }
    } else
      return;
  }
  for (ARRAY in TypedArrayConstructorsList) {
    TypedArrayConstructor = global$b[ARRAY];
    if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) {
      defineBuiltIn$2(TypedArrayConstructor, KEY, property);
    }
  }
};
for (NAME in TypedArrayConstructorsList) {
  Constructor = global$b[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype)
    enforceInternalState$1(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
  else
    NATIVE_ARRAY_BUFFER_VIEWS$2 = false;
}
for (NAME in BigIntArrayConstructorsList) {
  Constructor = global$b[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype)
    enforceInternalState$1(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
}
if (!NATIVE_ARRAY_BUFFER_VIEWS$2 || !isCallable$1(TypedArray$1) || TypedArray$1 === Function.prototype) {
  TypedArray$1 = function TypedArray2() {
    throw new TypeError$3("Incorrect invocation");
  };
  if (NATIVE_ARRAY_BUFFER_VIEWS$2)
    for (NAME in TypedArrayConstructorsList) {
      if (global$b[NAME])
        setPrototypeOf$2(global$b[NAME], TypedArray$1);
    }
}
if (!NATIVE_ARRAY_BUFFER_VIEWS$2 || !TypedArrayPrototype$2 || TypedArrayPrototype$2 === ObjectPrototype$1) {
  TypedArrayPrototype$2 = TypedArray$1.prototype;
  if (NATIVE_ARRAY_BUFFER_VIEWS$2)
    for (NAME in TypedArrayConstructorsList) {
      if (global$b[NAME])
        setPrototypeOf$2(global$b[NAME].prototype, TypedArrayPrototype$2);
    }
}
if (NATIVE_ARRAY_BUFFER_VIEWS$2 && getPrototypeOf$1(Uint8ClampedArrayPrototype) !== TypedArrayPrototype$2) {
  setPrototypeOf$2(Uint8ClampedArrayPrototype, TypedArrayPrototype$2);
}
if (DESCRIPTORS$7 && !hasOwn$4(TypedArrayPrototype$2, TO_STRING_TAG)) {
  TYPED_ARRAY_TAG_REQUIRED = true;
  defineBuiltInAccessor$4(TypedArrayPrototype$2, TO_STRING_TAG, {
    configurable: true,
    get: function() {
      return isObject$5(this) ? this[TYPED_ARRAY_TAG$1] : void 0;
    }
  });
  for (NAME in TypedArrayConstructorsList)
    if (global$b[NAME]) {
      createNonEnumerableProperty$2(global$b[NAME], TYPED_ARRAY_TAG$1, NAME);
    }
}
var arrayBufferViewCore = {
  NATIVE_ARRAY_BUFFER_VIEWS: NATIVE_ARRAY_BUFFER_VIEWS$2,
  TYPED_ARRAY_TAG: TYPED_ARRAY_TAG_REQUIRED && TYPED_ARRAY_TAG$1,
  aTypedArray: aTypedArray$n,
  aTypedArrayConstructor: aTypedArrayConstructor$2,
  exportTypedArrayMethod: exportTypedArrayMethod$o,
  exportTypedArrayStaticMethod,
  getTypedArrayConstructor: getTypedArrayConstructor$1,
  isView,
  isTypedArray: isTypedArray$1,
  TypedArray: TypedArray$1,
  TypedArrayPrototype: TypedArrayPrototype$2
};
var global$a = global$D;
var fails$d = fails$M;
var checkCorrectnessOfIteration = checkCorrectnessOfIteration$4;
var NATIVE_ARRAY_BUFFER_VIEWS$1 = arrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS;
var ArrayBuffer$3 = global$a.ArrayBuffer;
var Int8Array$3 = global$a.Int8Array;
var typedArrayConstructorsRequireWrappers = !NATIVE_ARRAY_BUFFER_VIEWS$1 || !fails$d(function() {
  Int8Array$3(1);
}) || !fails$d(function() {
  new Int8Array$3(-1);
}) || !checkCorrectnessOfIteration(function(iterable) {
  new Int8Array$3();
  new Int8Array$3(null);
  new Int8Array$3(1.5);
  new Int8Array$3(iterable);
}, true) || fails$d(function() {
  return new Int8Array$3(new ArrayBuffer$3(2), 1, void 0).length !== 1;
});
var toIntegerOrInfinity$5 = toIntegerOrInfinity$a;
var toLength$6 = toLength$9;
var $RangeError$3 = RangeError;
var toIndex$2 = function(it) {
  if (it === void 0)
    return 0;
  var number = toIntegerOrInfinity$5(it);
  var length = toLength$6(number);
  if (number !== length)
    throw new $RangeError$3("Wrong length or index");
  return length;
};
var mathSign = Math.sign || function sign(x) {
  var n = +x;
  return n === 0 || n !== n ? n : n < 0 ? -1 : 1;
};
var sign2 = mathSign;
var abs$1 = Math.abs;
var EPSILON = 2220446049250313e-31;
var INVERSE_EPSILON = 1 / EPSILON;
var roundTiesToEven = function(n) {
  return n + INVERSE_EPSILON - INVERSE_EPSILON;
};
var mathFloatRound = function(x, FLOAT_EPSILON, FLOAT_MAX_VALUE, FLOAT_MIN_VALUE) {
  var n = +x;
  var absolute = abs$1(n);
  var s = sign2(n);
  if (absolute < FLOAT_MIN_VALUE)
    return s * roundTiesToEven(absolute / FLOAT_MIN_VALUE / FLOAT_EPSILON) * FLOAT_MIN_VALUE * FLOAT_EPSILON;
  var a = (1 + FLOAT_EPSILON / EPSILON) * absolute;
  var result = a - (a - absolute);
  if (result > FLOAT_MAX_VALUE || result !== result)
    return s * Infinity;
  return s * result;
};
var floatRound = mathFloatRound;
var FLOAT32_EPSILON = 11920928955078125e-23;
var FLOAT32_MAX_VALUE = 34028234663852886e22;
var FLOAT32_MIN_VALUE = 11754943508222875e-54;
var mathFround = Math.fround || function fround(x) {
  return floatRound(x, FLOAT32_EPSILON, FLOAT32_MAX_VALUE, FLOAT32_MIN_VALUE);
};
var $Array = Array;
var abs = Math.abs;
var pow$1 = Math.pow;
var floor$4 = Math.floor;
var log$2 = Math.log;
var LN2 = Math.LN2;
var pack = function(number, mantissaLength, bytes) {
  var buffer = $Array(bytes);
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var rt = mantissaLength === 23 ? pow$1(2, -24) - pow$1(2, -77) : 0;
  var sign3 = number < 0 || number === 0 && 1 / number < 0 ? 1 : 0;
  var index2 = 0;
  var exponent, mantissa, c;
  number = abs(number);
  if (number !== number || number === Infinity) {
    mantissa = number !== number ? 1 : 0;
    exponent = eMax;
  } else {
    exponent = floor$4(log$2(number) / LN2);
    c = pow$1(2, -exponent);
    if (number * c < 1) {
      exponent--;
      c *= 2;
    }
    if (exponent + eBias >= 1) {
      number += rt / c;
    } else {
      number += rt * pow$1(2, 1 - eBias);
    }
    if (number * c >= 2) {
      exponent++;
      c /= 2;
    }
    if (exponent + eBias >= eMax) {
      mantissa = 0;
      exponent = eMax;
    } else if (exponent + eBias >= 1) {
      mantissa = (number * c - 1) * pow$1(2, mantissaLength);
      exponent += eBias;
    } else {
      mantissa = number * pow$1(2, eBias - 1) * pow$1(2, mantissaLength);
      exponent = 0;
    }
  }
  while (mantissaLength >= 8) {
    buffer[index2++] = mantissa & 255;
    mantissa /= 256;
    mantissaLength -= 8;
  }
  exponent = exponent << mantissaLength | mantissa;
  exponentLength += mantissaLength;
  while (exponentLength > 0) {
    buffer[index2++] = exponent & 255;
    exponent /= 256;
    exponentLength -= 8;
  }
  buffer[--index2] |= sign3 * 128;
  return buffer;
};
var unpack = function(buffer, mantissaLength) {
  var bytes = buffer.length;
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var nBits = exponentLength - 7;
  var index2 = bytes - 1;
  var sign3 = buffer[index2--];
  var exponent = sign3 & 127;
  var mantissa;
  sign3 >>= 7;
  while (nBits > 0) {
    exponent = exponent * 256 + buffer[index2--];
    nBits -= 8;
  }
  mantissa = exponent & (1 << -nBits) - 1;
  exponent >>= -nBits;
  nBits += mantissaLength;
  while (nBits > 0) {
    mantissa = mantissa * 256 + buffer[index2--];
    nBits -= 8;
  }
  if (exponent === 0) {
    exponent = 1 - eBias;
  } else if (exponent === eMax) {
    return mantissa ? NaN : sign3 ? -Infinity : Infinity;
  } else {
    mantissa += pow$1(2, mantissaLength);
    exponent -= eBias;
  }
  return (sign3 ? -1 : 1) * mantissa * pow$1(2, exponent - mantissaLength);
};
var ieee754 = {
  pack,
  unpack
};
var toObject$6 = toObject$f;
var toAbsoluteIndex$3 = toAbsoluteIndex$6;
var lengthOfArrayLike$9 = lengthOfArrayLike$g;
var arrayFill$1 = function fill(value) {
  var O = toObject$6(this);
  var length = lengthOfArrayLike$9(O);
  var argumentsLength = arguments.length;
  var index2 = toAbsoluteIndex$3(argumentsLength > 1 ? arguments[1] : void 0, length);
  var end2 = argumentsLength > 2 ? arguments[2] : void 0;
  var endPos = end2 === void 0 ? length : toAbsoluteIndex$3(end2, length);
  while (endPos > index2)
    O[index2++] = value;
  return O;
};
var global$9 = global$D;
var uncurryThis$f = functionUncurryThis;
var DESCRIPTORS$6 = descriptors;
var NATIVE_ARRAY_BUFFER = arrayBufferBasicDetection;
var FunctionName = functionName;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$9;
var defineBuiltInAccessor$3 = defineBuiltInAccessor$a;
var defineBuiltIns$2 = defineBuiltIns$4;
var fails$c = fails$M;
var anInstance$4 = anInstance$8;
var toIntegerOrInfinity$4 = toIntegerOrInfinity$a;
var toLength$5 = toLength$9;
var toIndex$1 = toIndex$2;
var fround2 = mathFround;
var IEEE754 = ieee754;
var getPrototypeOf = objectGetPrototypeOf$1;
var setPrototypeOf$1 = objectSetPrototypeOf;
var arrayFill = arrayFill$1;
var arraySlice$4 = arraySlice$9;
var inheritIfRequired$1 = inheritIfRequired$4;
var copyConstructorProperties = copyConstructorProperties$4;
var setToStringTag$2 = setToStringTag$a;
var InternalStateModule$4 = internalState;
var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var ARRAY_BUFFER$1 = "ArrayBuffer";
var DATA_VIEW = "DataView";
var PROTOTYPE = "prototype";
var WRONG_LENGTH$1 = "Wrong length";
var WRONG_INDEX = "Wrong index";
var getInternalArrayBufferState = InternalStateModule$4.getterFor(ARRAY_BUFFER$1);
var getInternalDataViewState = InternalStateModule$4.getterFor(DATA_VIEW);
var setInternalState$4 = InternalStateModule$4.set;
var NativeArrayBuffer$1 = global$9[ARRAY_BUFFER$1];
var $ArrayBuffer = NativeArrayBuffer$1;
var ArrayBufferPrototype$1 = $ArrayBuffer && $ArrayBuffer[PROTOTYPE];
var $DataView = global$9[DATA_VIEW];
var DataViewPrototype = $DataView && $DataView[PROTOTYPE];
var ObjectPrototype = Object.prototype;
var Array$1 = global$9.Array;
var RangeError$3 = global$9.RangeError;
var fill2 = uncurryThis$f(arrayFill);
var reverse = uncurryThis$f([].reverse);
var packIEEE754 = IEEE754.pack;
var unpackIEEE754 = IEEE754.unpack;
var packInt8 = function(number) {
  return [number & 255];
};
var packInt16 = function(number) {
  return [number & 255, number >> 8 & 255];
};
var packInt32 = function(number) {
  return [number & 255, number >> 8 & 255, number >> 16 & 255, number >> 24 & 255];
};
var unpackInt32 = function(buffer) {
  return buffer[3] << 24 | buffer[2] << 16 | buffer[1] << 8 | buffer[0];
};
var packFloat32 = function(number) {
  return packIEEE754(fround2(number), 23, 4);
};
var packFloat64 = function(number) {
  return packIEEE754(number, 52, 8);
};
var addGetter$1 = function(Constructor2, key, getInternalState2) {
  defineBuiltInAccessor$3(Constructor2[PROTOTYPE], key, {
    configurable: true,
    get: function() {
      return getInternalState2(this)[key];
    }
  });
};
var get = function(view, count, index2, isLittleEndian) {
  var store = getInternalDataViewState(view);
  var intIndex = toIndex$1(index2);
  var boolIsLittleEndian = !!isLittleEndian;
  if (intIndex + count > store.byteLength)
    throw new RangeError$3(WRONG_INDEX);
  var bytes = store.bytes;
  var start = intIndex + store.byteOffset;
  var pack2 = arraySlice$4(bytes, start, start + count);
  return boolIsLittleEndian ? pack2 : reverse(pack2);
};
var set = function(view, count, index2, conversion, value, isLittleEndian) {
  var store = getInternalDataViewState(view);
  var intIndex = toIndex$1(index2);
  var pack2 = conversion(+value);
  var boolIsLittleEndian = !!isLittleEndian;
  if (intIndex + count > store.byteLength)
    throw new RangeError$3(WRONG_INDEX);
  var bytes = store.bytes;
  var start = intIndex + store.byteOffset;
  for (var i = 0; i < count; i++)
    bytes[start + i] = pack2[boolIsLittleEndian ? i : count - i - 1];
};
if (!NATIVE_ARRAY_BUFFER) {
  $ArrayBuffer = function ArrayBuffer2(length) {
    anInstance$4(this, ArrayBufferPrototype$1);
    var byteLength = toIndex$1(length);
    setInternalState$4(this, {
      type: ARRAY_BUFFER$1,
      bytes: fill2(Array$1(byteLength), 0),
      byteLength
    });
    if (!DESCRIPTORS$6) {
      this.byteLength = byteLength;
      this.detached = false;
    }
  };
  ArrayBufferPrototype$1 = $ArrayBuffer[PROTOTYPE];
  $DataView = function DataView2(buffer, byteOffset, byteLength) {
    anInstance$4(this, DataViewPrototype);
    anInstance$4(buffer, ArrayBufferPrototype$1);
    var bufferState = getInternalArrayBufferState(buffer);
    var bufferLength = bufferState.byteLength;
    var offset = toIntegerOrInfinity$4(byteOffset);
    if (offset < 0 || offset > bufferLength)
      throw new RangeError$3("Wrong offset");
    byteLength = byteLength === void 0 ? bufferLength - offset : toLength$5(byteLength);
    if (offset + byteLength > bufferLength)
      throw new RangeError$3(WRONG_LENGTH$1);
    setInternalState$4(this, {
      type: DATA_VIEW,
      buffer,
      byteLength,
      byteOffset: offset,
      bytes: bufferState.bytes
    });
    if (!DESCRIPTORS$6) {
      this.buffer = buffer;
      this.byteLength = byteLength;
      this.byteOffset = offset;
    }
  };
  DataViewPrototype = $DataView[PROTOTYPE];
  if (DESCRIPTORS$6) {
    addGetter$1($ArrayBuffer, "byteLength", getInternalArrayBufferState);
    addGetter$1($DataView, "buffer", getInternalDataViewState);
    addGetter$1($DataView, "byteLength", getInternalDataViewState);
    addGetter$1($DataView, "byteOffset", getInternalDataViewState);
  }
  defineBuiltIns$2(DataViewPrototype, {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset) {
      var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : false);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset) {
      var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : false);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset) {
      return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false));
    },
    getUint32: function getUint32(byteOffset) {
      return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false)) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false), 23);
    },
    getFloat64: function getFloat64(byteOffset) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments.length > 1 ? arguments[1] : false), 52);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packInt8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packInt8, value);
    },
    setInt16: function setInt16(byteOffset, value) {
      set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : false);
    },
    setUint16: function setUint16(byteOffset, value) {
      set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : false);
    },
    setInt32: function setInt32(byteOffset, value) {
      set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : false);
    },
    setUint32: function setUint32(byteOffset, value) {
      set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : false);
    },
    setFloat32: function setFloat32(byteOffset, value) {
      set(this, 4, byteOffset, packFloat32, value, arguments.length > 2 ? arguments[2] : false);
    },
    setFloat64: function setFloat64(byteOffset, value) {
      set(this, 8, byteOffset, packFloat64, value, arguments.length > 2 ? arguments[2] : false);
    }
  });
} else {
  var INCORRECT_ARRAY_BUFFER_NAME = PROPER_FUNCTION_NAME && NativeArrayBuffer$1.name !== ARRAY_BUFFER$1;
  if (!fails$c(function() {
    NativeArrayBuffer$1(1);
  }) || !fails$c(function() {
    new NativeArrayBuffer$1(-1);
  }) || fails$c(function() {
    new NativeArrayBuffer$1();
    new NativeArrayBuffer$1(1.5);
    new NativeArrayBuffer$1(NaN);
    return NativeArrayBuffer$1.length !== 1 || INCORRECT_ARRAY_BUFFER_NAME && !CONFIGURABLE_FUNCTION_NAME;
  })) {
    $ArrayBuffer = function ArrayBuffer2(length) {
      anInstance$4(this, ArrayBufferPrototype$1);
      return inheritIfRequired$1(new NativeArrayBuffer$1(toIndex$1(length)), this, $ArrayBuffer);
    };
    $ArrayBuffer[PROTOTYPE] = ArrayBufferPrototype$1;
    ArrayBufferPrototype$1.constructor = $ArrayBuffer;
    copyConstructorProperties($ArrayBuffer, NativeArrayBuffer$1);
  } else if (INCORRECT_ARRAY_BUFFER_NAME && CONFIGURABLE_FUNCTION_NAME) {
    createNonEnumerableProperty$1(NativeArrayBuffer$1, "name", ARRAY_BUFFER$1);
  }
  if (setPrototypeOf$1 && getPrototypeOf(DataViewPrototype) !== ObjectPrototype) {
    setPrototypeOf$1(DataViewPrototype, ObjectPrototype);
  }
  var testView = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = uncurryThis$f(DataViewPrototype.setInt8);
  testView.setInt8(0, 2147483648);
  testView.setInt8(1, 2147483649);
  if (testView.getInt8(0) || !testView.getInt8(1))
    defineBuiltIns$2(DataViewPrototype, {
      setInt8: function setInt8(byteOffset, value) {
        $setInt8(this, byteOffset, value << 24 >> 24);
      },
      setUint8: function setUint8(byteOffset, value) {
        $setInt8(this, byteOffset, value << 24 >> 24);
      }
    }, { unsafe: true });
}
setToStringTag$2($ArrayBuffer, ARRAY_BUFFER$1);
setToStringTag$2($DataView, DATA_VIEW);
var arrayBuffer = {
  ArrayBuffer: $ArrayBuffer,
  DataView: $DataView
};
var toIntegerOrInfinity$3 = toIntegerOrInfinity$a;
var $RangeError$2 = RangeError;
var toPositiveInteger$1 = function(it) {
  var result = toIntegerOrInfinity$3(it);
  if (result < 0)
    throw new $RangeError$2("The argument can't be less than 0");
  return result;
};
var toPositiveInteger = toPositiveInteger$1;
var $RangeError$1 = RangeError;
var toOffset$2 = function(it, BYTES) {
  var offset = toPositiveInteger(it);
  if (offset % BYTES)
    throw new $RangeError$1("Wrong offset");
  return offset;
};
var round = Math.round;
var toUint8Clamped$1 = function(it) {
  var value = round(it);
  return value < 0 ? 0 : value > 255 ? 255 : value & 255;
};
var classof$4 = classof$g;
var isBigIntArray$1 = function(it) {
  var klass = classof$4(it);
  return klass === "BigInt64Array" || klass === "BigUint64Array";
};
var toPrimitive = toPrimitive$4;
var $TypeError$4 = TypeError;
var toBigInt$2 = function(argument) {
  var prim = toPrimitive(argument, "number");
  if (typeof prim == "number")
    throw new $TypeError$4("Can't convert number to bigint");
  return BigInt(prim);
};
var bind$2 = functionBindContext;
var call$8 = functionCall;
var aConstructor = aConstructor$3;
var toObject$5 = toObject$f;
var lengthOfArrayLike$8 = lengthOfArrayLike$g;
var getIterator$1 = getIterator$4;
var getIteratorMethod$1 = getIteratorMethod$5;
var isArrayIteratorMethod = isArrayIteratorMethod$3;
var isBigIntArray = isBigIntArray$1;
var aTypedArrayConstructor$1 = arrayBufferViewCore.aTypedArrayConstructor;
var toBigInt$1 = toBigInt$2;
var typedArrayFrom$1 = function from3(source) {
  var C = aConstructor(this);
  var O = toObject$5(source);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : void 0;
  var mapping = mapfn !== void 0;
  var iteratorMethod = getIteratorMethod$1(O);
  var i, length, result, thisIsBigIntArray, value, step, iterator, next3;
  if (iteratorMethod && !isArrayIteratorMethod(iteratorMethod)) {
    iterator = getIterator$1(O, iteratorMethod);
    next3 = iterator.next;
    O = [];
    while (!(step = call$8(next3, iterator)).done) {
      O.push(step.value);
    }
  }
  if (mapping && argumentsLength > 2) {
    mapfn = bind$2(mapfn, arguments[2]);
  }
  length = lengthOfArrayLike$8(O);
  result = new (aTypedArrayConstructor$1(C))(length);
  thisIsBigIntArray = isBigIntArray(result);
  for (i = 0; length > i; i++) {
    value = mapping ? mapfn(O[i], i) : O[i];
    result[i] = thisIsBigIntArray ? toBigInt$1(value) : +value;
  }
  return result;
};
var lengthOfArrayLike$7 = lengthOfArrayLike$g;
var arrayFromConstructorAndList$2 = function(Constructor2, list, $length) {
  var index2 = 0;
  var length = arguments.length > 2 ? $length : lengthOfArrayLike$7(list);
  var result = new Constructor2(length);
  while (length > index2)
    result[index2] = list[index2++];
  return result;
};
typedArrayConstructor.exports;
var $$a = _export;
var global$8 = global$D;
var call$7 = functionCall;
var DESCRIPTORS$5 = descriptors;
var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = typedArrayConstructorsRequireWrappers;
var ArrayBufferViewCore$o = arrayBufferViewCore;
var ArrayBufferModule = arrayBuffer;
var anInstance$3 = anInstance$8;
var createPropertyDescriptor$1 = createPropertyDescriptor$7;
var createNonEnumerableProperty = createNonEnumerableProperty$9;
var isIntegralNumber = isIntegralNumber$2;
var toLength$4 = toLength$9;
var toIndex = toIndex$2;
var toOffset$1 = toOffset$2;
var toUint8Clamped = toUint8Clamped$1;
var toPropertyKey = toPropertyKey$5;
var hasOwn$3 = hasOwnProperty_1;
var classof$3 = classof$g;
var isObject$4 = isObject$q;
var isSymbol = isSymbol$6;
var create$1 = objectCreate;
var isPrototypeOf = objectIsPrototypeOf;
var setPrototypeOf = objectSetPrototypeOf;
var getOwnPropertyNames4 = objectGetOwnPropertyNames.f;
var typedArrayFrom = typedArrayFrom$1;
var forEach2 = arrayIteration.forEach;
var setSpecies$1 = setSpecies$4;
var defineBuiltInAccessor$2 = defineBuiltInAccessor$a;
var definePropertyModule = objectDefineProperty;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var arrayFromConstructorAndList$1 = arrayFromConstructorAndList$2;
var InternalStateModule$3 = internalState;
var inheritIfRequired = inheritIfRequired$4;
var getInternalState = InternalStateModule$3.get;
var setInternalState$3 = InternalStateModule$3.set;
var enforceInternalState = InternalStateModule$3.enforce;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var RangeError$2 = global$8.RangeError;
var ArrayBuffer$2 = ArrayBufferModule.ArrayBuffer;
var ArrayBufferPrototype = ArrayBuffer$2.prototype;
var DataView$1 = ArrayBufferModule.DataView;
var NATIVE_ARRAY_BUFFER_VIEWS = ArrayBufferViewCore$o.NATIVE_ARRAY_BUFFER_VIEWS;
var TYPED_ARRAY_TAG = ArrayBufferViewCore$o.TYPED_ARRAY_TAG;
var TypedArray = ArrayBufferViewCore$o.TypedArray;
var TypedArrayPrototype$1 = ArrayBufferViewCore$o.TypedArrayPrototype;
var isTypedArray = ArrayBufferViewCore$o.isTypedArray;
var BYTES_PER_ELEMENT = "BYTES_PER_ELEMENT";
var WRONG_LENGTH = "Wrong length";
var addGetter = function(it, key) {
  defineBuiltInAccessor$2(it, key, {
    configurable: true,
    get: function() {
      return getInternalState(this)[key];
    }
  });
};
var isArrayBuffer = function(it) {
  var klass;
  return isPrototypeOf(ArrayBufferPrototype, it) || (klass = classof$3(it)) === "ArrayBuffer" || klass === "SharedArrayBuffer";
};
var isTypedArrayIndex = function(target, key) {
  return isTypedArray(target) && !isSymbol(key) && key in target && isIntegralNumber(+key) && key >= 0;
};
var wrappedGetOwnPropertyDescriptor = function getOwnPropertyDescriptor4(target, key) {
  key = toPropertyKey(key);
  return isTypedArrayIndex(target, key) ? createPropertyDescriptor$1(2, target[key]) : nativeGetOwnPropertyDescriptor(target, key);
};
var wrappedDefineProperty = function defineProperty4(target, key, descriptor) {
  key = toPropertyKey(key);
  if (isTypedArrayIndex(target, key) && isObject$4(descriptor) && hasOwn$3(descriptor, "value") && !hasOwn$3(descriptor, "get") && !hasOwn$3(descriptor, "set") && !descriptor.configurable && (!hasOwn$3(descriptor, "writable") || descriptor.writable) && (!hasOwn$3(descriptor, "enumerable") || descriptor.enumerable)) {
    target[key] = descriptor.value;
    return target;
  }
  return nativeDefineProperty(target, key, descriptor);
};
if (DESCRIPTORS$5) {
  if (!NATIVE_ARRAY_BUFFER_VIEWS) {
    getOwnPropertyDescriptorModule.f = wrappedGetOwnPropertyDescriptor;
    definePropertyModule.f = wrappedDefineProperty;
    addGetter(TypedArrayPrototype$1, "buffer");
    addGetter(TypedArrayPrototype$1, "byteOffset");
    addGetter(TypedArrayPrototype$1, "byteLength");
    addGetter(TypedArrayPrototype$1, "length");
  }
  $$a({ target: "Object", stat: true, forced: !NATIVE_ARRAY_BUFFER_VIEWS }, {
    getOwnPropertyDescriptor: wrappedGetOwnPropertyDescriptor,
    defineProperty: wrappedDefineProperty
  });
  typedArrayConstructor.exports = function(TYPE, wrapper, CLAMPED) {
    var BYTES = TYPE.match(/\d+/)[0] / 8;
    var CONSTRUCTOR_NAME = TYPE + (CLAMPED ? "Clamped" : "") + "Array";
    var GETTER = "get" + TYPE;
    var SETTER = "set" + TYPE;
    var NativeTypedArrayConstructor = global$8[CONSTRUCTOR_NAME];
    var TypedArrayConstructor = NativeTypedArrayConstructor;
    var TypedArrayConstructorPrototype = TypedArrayConstructor && TypedArrayConstructor.prototype;
    var exported = {};
    var getter = function(that, index2) {
      var data2 = getInternalState(that);
      return data2.view[GETTER](index2 * BYTES + data2.byteOffset, true);
    };
    var setter = function(that, index2, value) {
      var data2 = getInternalState(that);
      data2.view[SETTER](index2 * BYTES + data2.byteOffset, CLAMPED ? toUint8Clamped(value) : value, true);
    };
    var addElement = function(that, index2) {
      nativeDefineProperty(that, index2, {
        get: function() {
          return getter(this, index2);
        },
        set: function(value) {
          return setter(this, index2, value);
        },
        enumerable: true
      });
    };
    if (!NATIVE_ARRAY_BUFFER_VIEWS) {
      TypedArrayConstructor = wrapper(function(that, data2, offset, $length) {
        anInstance$3(that, TypedArrayConstructorPrototype);
        var index2 = 0;
        var byteOffset = 0;
        var buffer, byteLength, length;
        if (!isObject$4(data2)) {
          length = toIndex(data2);
          byteLength = length * BYTES;
          buffer = new ArrayBuffer$2(byteLength);
        } else if (isArrayBuffer(data2)) {
          buffer = data2;
          byteOffset = toOffset$1(offset, BYTES);
          var $len = data2.byteLength;
          if ($length === void 0) {
            if ($len % BYTES)
              throw new RangeError$2(WRONG_LENGTH);
            byteLength = $len - byteOffset;
            if (byteLength < 0)
              throw new RangeError$2(WRONG_LENGTH);
          } else {
            byteLength = toLength$4($length) * BYTES;
            if (byteLength + byteOffset > $len)
              throw new RangeError$2(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (isTypedArray(data2)) {
          return arrayFromConstructorAndList$1(TypedArrayConstructor, data2);
        } else {
          return call$7(typedArrayFrom, TypedArrayConstructor, data2);
        }
        setInternalState$3(that, {
          buffer,
          byteOffset,
          byteLength,
          length,
          view: new DataView$1(buffer)
        });
        while (index2 < length)
          addElement(that, index2++);
      });
      if (setPrototypeOf)
        setPrototypeOf(TypedArrayConstructor, TypedArray);
      TypedArrayConstructorPrototype = TypedArrayConstructor.prototype = create$1(TypedArrayPrototype$1);
    } else if (TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS) {
      TypedArrayConstructor = wrapper(function(dummy, data2, typedArrayOffset, $length) {
        anInstance$3(dummy, TypedArrayConstructorPrototype);
        return inheritIfRequired(function() {
          if (!isObject$4(data2))
            return new NativeTypedArrayConstructor(toIndex(data2));
          if (isArrayBuffer(data2))
            return $length !== void 0 ? new NativeTypedArrayConstructor(data2, toOffset$1(typedArrayOffset, BYTES), $length) : typedArrayOffset !== void 0 ? new NativeTypedArrayConstructor(data2, toOffset$1(typedArrayOffset, BYTES)) : new NativeTypedArrayConstructor(data2);
          if (isTypedArray(data2))
            return arrayFromConstructorAndList$1(TypedArrayConstructor, data2);
          return call$7(typedArrayFrom, TypedArrayConstructor, data2);
        }(), dummy, TypedArrayConstructor);
      });
      if (setPrototypeOf)
        setPrototypeOf(TypedArrayConstructor, TypedArray);
      forEach2(getOwnPropertyNames4(NativeTypedArrayConstructor), function(key) {
        if (!(key in TypedArrayConstructor)) {
          createNonEnumerableProperty(TypedArrayConstructor, key, NativeTypedArrayConstructor[key]);
        }
      });
      TypedArrayConstructor.prototype = TypedArrayConstructorPrototype;
    }
    if (TypedArrayConstructorPrototype.constructor !== TypedArrayConstructor) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, "constructor", TypedArrayConstructor);
    }
    enforceInternalState(TypedArrayConstructorPrototype).TypedArrayConstructor = TypedArrayConstructor;
    if (TYPED_ARRAY_TAG) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, TYPED_ARRAY_TAG, CONSTRUCTOR_NAME);
    }
    var FORCED2 = TypedArrayConstructor !== NativeTypedArrayConstructor;
    exported[CONSTRUCTOR_NAME] = TypedArrayConstructor;
    $$a({ global: true, constructor: true, forced: FORCED2, sham: !NATIVE_ARRAY_BUFFER_VIEWS }, exported);
    if (!(BYTES_PER_ELEMENT in TypedArrayConstructor)) {
      createNonEnumerableProperty(TypedArrayConstructor, BYTES_PER_ELEMENT, BYTES);
    }
    if (!(BYTES_PER_ELEMENT in TypedArrayConstructorPrototype)) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, BYTES_PER_ELEMENT, BYTES);
    }
    setSpecies$1(CONSTRUCTOR_NAME);
  };
} else
  typedArrayConstructor.exports = function() {
  };
var typedArrayConstructorExports = typedArrayConstructor.exports;
var createTypedArrayConstructor = typedArrayConstructorExports;
createTypedArrayConstructor("Uint8", function(init) {
  return function Uint8Array2(data2, byteOffset, length) {
    return init(this, data2, byteOffset, length);
  };
});
var tryToString = tryToString$7;
var $TypeError$3 = TypeError;
var deletePropertyOrThrow$3 = function(O, P) {
  if (!delete O[P])
    throw new $TypeError$3("Cannot delete property " + tryToString(P) + " of " + tryToString(O));
};
var toObject$4 = toObject$f;
var toAbsoluteIndex$2 = toAbsoluteIndex$6;
var lengthOfArrayLike$6 = lengthOfArrayLike$g;
var deletePropertyOrThrow$2 = deletePropertyOrThrow$3;
var min$4 = Math.min;
var arrayCopyWithin = [].copyWithin || function copyWithin(target, start) {
  var O = toObject$4(this);
  var len = lengthOfArrayLike$6(O);
  var to = toAbsoluteIndex$2(target, len);
  var from4 = toAbsoluteIndex$2(start, len);
  var end2 = arguments.length > 2 ? arguments[2] : void 0;
  var count = min$4((end2 === void 0 ? len : toAbsoluteIndex$2(end2, len)) - from4, len - to);
  var inc = 1;
  if (from4 < to && to < from4 + count) {
    inc = -1;
    from4 += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from4 in O)
      O[to] = O[from4];
    else
      deletePropertyOrThrow$2(O, to);
    to += inc;
    from4 += inc;
  }
  return O;
};
var uncurryThis$e = functionUncurryThis;
var ArrayBufferViewCore$n = arrayBufferViewCore;
var $ArrayCopyWithin = arrayCopyWithin;
var u$ArrayCopyWithin = uncurryThis$e($ArrayCopyWithin);
var aTypedArray$m = ArrayBufferViewCore$n.aTypedArray;
var exportTypedArrayMethod$n = ArrayBufferViewCore$n.exportTypedArrayMethod;
exportTypedArrayMethod$n("copyWithin", function copyWithin2(target, start) {
  return u$ArrayCopyWithin(aTypedArray$m(this), target, start, arguments.length > 2 ? arguments[2] : void 0);
});
var ArrayBufferViewCore$m = arrayBufferViewCore;
var $every = arrayIteration.every;
var aTypedArray$l = ArrayBufferViewCore$m.aTypedArray;
var exportTypedArrayMethod$m = ArrayBufferViewCore$m.exportTypedArrayMethod;
exportTypedArrayMethod$m("every", function every(callbackfn) {
  return $every(aTypedArray$l(this), callbackfn, arguments.length > 1 ? arguments[1] : void 0);
});
var ArrayBufferViewCore$l = arrayBufferViewCore;
var $fill = arrayFill$1;
var toBigInt = toBigInt$2;
var classof$2 = classof$g;
var call$6 = functionCall;
var uncurryThis$d = functionUncurryThis;
var fails$b = fails$M;
var aTypedArray$k = ArrayBufferViewCore$l.aTypedArray;
var exportTypedArrayMethod$l = ArrayBufferViewCore$l.exportTypedArrayMethod;
var slice2 = uncurryThis$d("".slice);
var CONVERSION_BUG = fails$b(function() {
  var count = 0;
  new Int8Array(2).fill({ valueOf: function() {
    return count++;
  } });
  return count !== 1;
});
exportTypedArrayMethod$l("fill", function fill3(value) {
  var length = arguments.length;
  aTypedArray$k(this);
  var actualValue = slice2(classof$2(this), 0, 3) === "Big" ? toBigInt(value) : +value;
  return call$6($fill, this, actualValue, length > 1 ? arguments[1] : void 0, length > 2 ? arguments[2] : void 0);
}, CONVERSION_BUG);
var ArrayBufferViewCore$k = arrayBufferViewCore;
var speciesConstructor$1 = speciesConstructor$3;
var aTypedArrayConstructor = ArrayBufferViewCore$k.aTypedArrayConstructor;
var getTypedArrayConstructor = ArrayBufferViewCore$k.getTypedArrayConstructor;
var typedArraySpeciesConstructor$4 = function(originalArray) {
  return aTypedArrayConstructor(speciesConstructor$1(originalArray, getTypedArrayConstructor(originalArray)));
};
var arrayFromConstructorAndList = arrayFromConstructorAndList$2;
var typedArraySpeciesConstructor$3 = typedArraySpeciesConstructor$4;
var typedArrayFromSpeciesAndList = function(instance2, list) {
  return arrayFromConstructorAndList(typedArraySpeciesConstructor$3(instance2), list);
};
var ArrayBufferViewCore$j = arrayBufferViewCore;
var $filter = arrayIteration.filter;
var fromSpeciesAndList = typedArrayFromSpeciesAndList;
var aTypedArray$j = ArrayBufferViewCore$j.aTypedArray;
var exportTypedArrayMethod$k = ArrayBufferViewCore$j.exportTypedArrayMethod;
exportTypedArrayMethod$k("filter", function filter2(callbackfn) {
  var list = $filter(aTypedArray$j(this), callbackfn, arguments.length > 1 ? arguments[1] : void 0);
  return fromSpeciesAndList(this, list);
});
var ArrayBufferViewCore$i = arrayBufferViewCore;
var $find$1 = arrayIteration.find;
var aTypedArray$i = ArrayBufferViewCore$i.aTypedArray;
var exportTypedArrayMethod$j = ArrayBufferViewCore$i.exportTypedArrayMethod;
exportTypedArrayMethod$j("find", function find(predicate) {
  return $find$1(aTypedArray$i(this), predicate, arguments.length > 1 ? arguments[1] : void 0);
});
var ArrayBufferViewCore$h = arrayBufferViewCore;
var $findIndex = arrayIteration.findIndex;
var aTypedArray$h = ArrayBufferViewCore$h.aTypedArray;
var exportTypedArrayMethod$i = ArrayBufferViewCore$h.exportTypedArrayMethod;
exportTypedArrayMethod$i("findIndex", function findIndex(predicate) {
  return $findIndex(aTypedArray$h(this), predicate, arguments.length > 1 ? arguments[1] : void 0);
});
var ArrayBufferViewCore$g = arrayBufferViewCore;
var $forEach = arrayIteration.forEach;
var aTypedArray$g = ArrayBufferViewCore$g.aTypedArray;
var exportTypedArrayMethod$h = ArrayBufferViewCore$g.exportTypedArrayMethod;
exportTypedArrayMethod$h("forEach", function forEach3(callbackfn) {
  $forEach(aTypedArray$g(this), callbackfn, arguments.length > 1 ? arguments[1] : void 0);
});
var ArrayBufferViewCore$f = arrayBufferViewCore;
var $includes = arrayIncludes.includes;
var aTypedArray$f = ArrayBufferViewCore$f.aTypedArray;
var exportTypedArrayMethod$g = ArrayBufferViewCore$f.exportTypedArrayMethod;
exportTypedArrayMethod$g("includes", function includes2(searchElement) {
  return $includes(aTypedArray$f(this), searchElement, arguments.length > 1 ? arguments[1] : void 0);
});
var ArrayBufferViewCore$e = arrayBufferViewCore;
var $indexOf = arrayIncludes.indexOf;
var aTypedArray$e = ArrayBufferViewCore$e.aTypedArray;
var exportTypedArrayMethod$f = ArrayBufferViewCore$e.exportTypedArrayMethod;
exportTypedArrayMethod$f("indexOf", function indexOf2(searchElement) {
  return $indexOf(aTypedArray$e(this), searchElement, arguments.length > 1 ? arguments[1] : void 0);
});
var global$7 = global$D;
var fails$a = fails$M;
var uncurryThis$c = functionUncurryThis;
var ArrayBufferViewCore$d = arrayBufferViewCore;
var ArrayIterators = es_array_iterator;
var wellKnownSymbol$4 = wellKnownSymbol$t;
var ITERATOR$2 = wellKnownSymbol$4("iterator");
var Uint8Array$2 = global$7.Uint8Array;
var arrayValues = uncurryThis$c(ArrayIterators.values);
var arrayKeys = uncurryThis$c(ArrayIterators.keys);
var arrayEntries = uncurryThis$c(ArrayIterators.entries);
var aTypedArray$d = ArrayBufferViewCore$d.aTypedArray;
var exportTypedArrayMethod$e = ArrayBufferViewCore$d.exportTypedArrayMethod;
var TypedArrayPrototype = Uint8Array$2 && Uint8Array$2.prototype;
var GENERIC = !fails$a(function() {
  TypedArrayPrototype[ITERATOR$2].call([1]);
});
var ITERATOR_IS_VALUES = !!TypedArrayPrototype && TypedArrayPrototype.values && TypedArrayPrototype[ITERATOR$2] === TypedArrayPrototype.values && TypedArrayPrototype.values.name === "values";
var typedArrayValues = function values2() {
  return arrayValues(aTypedArray$d(this));
};
exportTypedArrayMethod$e("entries", function entries2() {
  return arrayEntries(aTypedArray$d(this));
}, GENERIC);
exportTypedArrayMethod$e("keys", function keys4() {
  return arrayKeys(aTypedArray$d(this));
}, GENERIC);
exportTypedArrayMethod$e("values", typedArrayValues, GENERIC || !ITERATOR_IS_VALUES, { name: "values" });
exportTypedArrayMethod$e(ITERATOR$2, typedArrayValues, GENERIC || !ITERATOR_IS_VALUES, { name: "values" });
var ArrayBufferViewCore$c = arrayBufferViewCore;
var uncurryThis$b = functionUncurryThis;
var aTypedArray$c = ArrayBufferViewCore$c.aTypedArray;
var exportTypedArrayMethod$d = ArrayBufferViewCore$c.exportTypedArrayMethod;
var $join = uncurryThis$b([].join);
exportTypedArrayMethod$d("join", function join2(separator) {
  return $join(aTypedArray$c(this), separator);
});
var apply$2 = functionApply;
var toIndexedObject$1 = toIndexedObject$e;
var toIntegerOrInfinity$2 = toIntegerOrInfinity$a;
var lengthOfArrayLike$5 = lengthOfArrayLike$g;
var arrayMethodIsStrict$1 = arrayMethodIsStrict$4;
var min$3 = Math.min;
var $lastIndexOf$1 = [].lastIndexOf;
var NEGATIVE_ZERO = !!$lastIndexOf$1 && 1 / [1].lastIndexOf(1, -0) < 0;
var STRICT_METHOD$1 = arrayMethodIsStrict$1("lastIndexOf");
var FORCED$3 = NEGATIVE_ZERO || !STRICT_METHOD$1;
var arrayLastIndexOf = FORCED$3 ? function lastIndexOf(searchElement) {
  if (NEGATIVE_ZERO)
    return apply$2($lastIndexOf$1, this, arguments) || 0;
  var O = toIndexedObject$1(this);
  var length = lengthOfArrayLike$5(O);
  if (length === 0)
    return -1;
  var index2 = length - 1;
  if (arguments.length > 1)
    index2 = min$3(index2, toIntegerOrInfinity$2(arguments[1]));
  if (index2 < 0)
    index2 = length + index2;
  for (; index2 >= 0; index2--)
    if (index2 in O && O[index2] === searchElement)
      return index2 || 0;
  return -1;
} : $lastIndexOf$1;
var ArrayBufferViewCore$b = arrayBufferViewCore;
var apply$1 = functionApply;
var $lastIndexOf = arrayLastIndexOf;
var aTypedArray$b = ArrayBufferViewCore$b.aTypedArray;
var exportTypedArrayMethod$c = ArrayBufferViewCore$b.exportTypedArrayMethod;
exportTypedArrayMethod$c("lastIndexOf", function lastIndexOf2(searchElement) {
  var length = arguments.length;
  return apply$1($lastIndexOf, aTypedArray$b(this), length > 1 ? [searchElement, arguments[1]] : [searchElement]);
});
var ArrayBufferViewCore$a = arrayBufferViewCore;
var $map = arrayIteration.map;
var typedArraySpeciesConstructor$2 = typedArraySpeciesConstructor$4;
var aTypedArray$a = ArrayBufferViewCore$a.aTypedArray;
var exportTypedArrayMethod$b = ArrayBufferViewCore$a.exportTypedArrayMethod;
exportTypedArrayMethod$b("map", function map2(mapfn) {
  return $map(aTypedArray$a(this), mapfn, arguments.length > 1 ? arguments[1] : void 0, function(O, length) {
    return new (typedArraySpeciesConstructor$2(O))(length);
  });
});
var aCallable$2 = aCallable$c;
var toObject$3 = toObject$f;
var IndexedObject$1 = indexedObject;
var lengthOfArrayLike$4 = lengthOfArrayLike$g;
var $TypeError$2 = TypeError;
var REDUCE_EMPTY = "Reduce of empty array with no initial value";
var createMethod = function(IS_RIGHT) {
  return function(that, callbackfn, argumentsLength, memo) {
    var O = toObject$3(that);
    var self2 = IndexedObject$1(O);
    var length = lengthOfArrayLike$4(O);
    aCallable$2(callbackfn);
    if (length === 0 && argumentsLength < 2)
      throw new $TypeError$2(REDUCE_EMPTY);
    var index2 = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2)
      while (true) {
        if (index2 in self2) {
          memo = self2[index2];
          index2 += i;
          break;
        }
        index2 += i;
        if (IS_RIGHT ? index2 < 0 : length <= index2) {
          throw new $TypeError$2(REDUCE_EMPTY);
        }
      }
    for (; IS_RIGHT ? index2 >= 0 : length > index2; index2 += i)
      if (index2 in self2) {
        memo = callbackfn(memo, self2[index2], index2, O);
      }
    return memo;
  };
};
var arrayReduce = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod(true)
};
var ArrayBufferViewCore$9 = arrayBufferViewCore;
var $reduce = arrayReduce.left;
var aTypedArray$9 = ArrayBufferViewCore$9.aTypedArray;
var exportTypedArrayMethod$a = ArrayBufferViewCore$9.exportTypedArrayMethod;
exportTypedArrayMethod$a("reduce", function reduce(callbackfn) {
  var length = arguments.length;
  return $reduce(aTypedArray$9(this), callbackfn, length, length > 1 ? arguments[1] : void 0);
});
var ArrayBufferViewCore$8 = arrayBufferViewCore;
var $reduceRight = arrayReduce.right;
var aTypedArray$8 = ArrayBufferViewCore$8.aTypedArray;
var exportTypedArrayMethod$9 = ArrayBufferViewCore$8.exportTypedArrayMethod;
exportTypedArrayMethod$9("reduceRight", function reduceRight(callbackfn) {
  var length = arguments.length;
  return $reduceRight(aTypedArray$8(this), callbackfn, length, length > 1 ? arguments[1] : void 0);
});
var ArrayBufferViewCore$7 = arrayBufferViewCore;
var aTypedArray$7 = ArrayBufferViewCore$7.aTypedArray;
var exportTypedArrayMethod$8 = ArrayBufferViewCore$7.exportTypedArrayMethod;
var floor$3 = Math.floor;
exportTypedArrayMethod$8("reverse", function reverse2() {
  var that = this;
  var length = aTypedArray$7(that).length;
  var middle = floor$3(length / 2);
  var index2 = 0;
  var value;
  while (index2 < middle) {
    value = that[index2];
    that[index2++] = that[--length];
    that[length] = value;
  }
  return that;
});
var global$6 = global$D;
var call$5 = functionCall;
var ArrayBufferViewCore$6 = arrayBufferViewCore;
var lengthOfArrayLike$3 = lengthOfArrayLike$g;
var toOffset = toOffset$2;
var toIndexedObject = toObject$f;
var fails$9 = fails$M;
var RangeError$1 = global$6.RangeError;
var Int8Array$2 = global$6.Int8Array;
var Int8ArrayPrototype = Int8Array$2 && Int8Array$2.prototype;
var $set = Int8ArrayPrototype && Int8ArrayPrototype.set;
var aTypedArray$6 = ArrayBufferViewCore$6.aTypedArray;
var exportTypedArrayMethod$7 = ArrayBufferViewCore$6.exportTypedArrayMethod;
var WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS = !fails$9(function() {
  var array5 = new Uint8ClampedArray(2);
  call$5($set, array5, { length: 1, 0: 3 }, 1);
  return array5[1] !== 3;
});
var TO_OBJECT_BUG = WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS && ArrayBufferViewCore$6.NATIVE_ARRAY_BUFFER_VIEWS && fails$9(function() {
  var array5 = new Int8Array$2(2);
  array5.set(1);
  array5.set("2", 1);
  return array5[0] !== 0 || array5[1] !== 2;
});
exportTypedArrayMethod$7("set", function set2(arrayLike) {
  aTypedArray$6(this);
  var offset = toOffset(arguments.length > 1 ? arguments[1] : void 0, 1);
  var src2 = toIndexedObject(arrayLike);
  if (WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS)
    return call$5($set, this, src2, offset);
  var length = this.length;
  var len = lengthOfArrayLike$3(src2);
  var index2 = 0;
  if (len + offset > length)
    throw new RangeError$1("Wrong length");
  while (index2 < len)
    this[offset + index2] = src2[index2++];
}, !WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS || TO_OBJECT_BUG);
var ArrayBufferViewCore$5 = arrayBufferViewCore;
var typedArraySpeciesConstructor$1 = typedArraySpeciesConstructor$4;
var fails$8 = fails$M;
var arraySlice$3 = arraySlice$9;
var aTypedArray$5 = ArrayBufferViewCore$5.aTypedArray;
var exportTypedArrayMethod$6 = ArrayBufferViewCore$5.exportTypedArrayMethod;
var FORCED$2 = fails$8(function() {
  new Int8Array(1).slice();
});
exportTypedArrayMethod$6("slice", function slice3(start, end2) {
  var list = arraySlice$3(aTypedArray$5(this), start, end2);
  var C = typedArraySpeciesConstructor$1(this);
  var index2 = 0;
  var length = list.length;
  var result = new C(length);
  while (length > index2)
    result[index2] = list[index2++];
  return result;
}, FORCED$2);
var ArrayBufferViewCore$4 = arrayBufferViewCore;
var $some = arrayIteration.some;
var aTypedArray$4 = ArrayBufferViewCore$4.aTypedArray;
var exportTypedArrayMethod$5 = ArrayBufferViewCore$4.exportTypedArrayMethod;
exportTypedArrayMethod$5("some", function some(callbackfn) {
  return $some(aTypedArray$4(this), callbackfn, arguments.length > 1 ? arguments[1] : void 0);
});
var arraySlice$2 = arraySlice$9;
var floor$2 = Math.floor;
var sort = function(array5, comparefn) {
  var length = array5.length;
  if (length < 8) {
    var i = 1;
    var element, j;
    while (i < length) {
      j = i;
      element = array5[i];
      while (j && comparefn(array5[j - 1], element) > 0) {
        array5[j] = array5[--j];
      }
      if (j !== i++)
        array5[j] = element;
    }
  } else {
    var middle = floor$2(length / 2);
    var left = sort(arraySlice$2(array5, 0, middle), comparefn);
    var right = sort(arraySlice$2(array5, middle), comparefn);
    var llength = left.length;
    var rlength = right.length;
    var lindex = 0;
    var rindex = 0;
    while (lindex < llength || rindex < rlength) {
      array5[lindex + rindex] = lindex < llength && rindex < rlength ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++] : lindex < llength ? left[lindex++] : right[rindex++];
    }
  }
  return array5;
};
var arraySort$1 = sort;
var userAgent$1 = engineUserAgent;
var firefox = userAgent$1.match(/firefox\/(\d+)/i);
var engineFfVersion = !!firefox && +firefox[1];
var UA = engineUserAgent;
var engineIsIeOrEdge = /MSIE|Trident/.test(UA);
var userAgent = engineUserAgent;
var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);
var engineWebkitVersion = !!webkit && +webkit[1];
var global$5 = global$D;
var uncurryThis$a = functionUncurryThisClause;
var fails$7 = fails$M;
var aCallable$1 = aCallable$c;
var internalSort$1 = arraySort$1;
var ArrayBufferViewCore$3 = arrayBufferViewCore;
var FF$1 = engineFfVersion;
var IE_OR_EDGE$1 = engineIsIeOrEdge;
var V8$1 = engineV8Version;
var WEBKIT$1 = engineWebkitVersion;
var aTypedArray$3 = ArrayBufferViewCore$3.aTypedArray;
var exportTypedArrayMethod$4 = ArrayBufferViewCore$3.exportTypedArrayMethod;
var Uint16Array = global$5.Uint16Array;
var nativeSort$1 = Uint16Array && uncurryThis$a(Uint16Array.prototype.sort);
var ACCEPT_INCORRECT_ARGUMENTS = !!nativeSort$1 && !(fails$7(function() {
  nativeSort$1(new Uint16Array(2), null);
}) && fails$7(function() {
  nativeSort$1(new Uint16Array(2), {});
}));
var STABLE_SORT$1 = !!nativeSort$1 && !fails$7(function() {
  if (V8$1)
    return V8$1 < 74;
  if (FF$1)
    return FF$1 < 67;
  if (IE_OR_EDGE$1)
    return true;
  if (WEBKIT$1)
    return WEBKIT$1 < 602;
  var array5 = new Uint16Array(516);
  var expected = Array(516);
  var index2, mod;
  for (index2 = 0; index2 < 516; index2++) {
    mod = index2 % 4;
    array5[index2] = 515 - index2;
    expected[index2] = index2 - 2 * mod + 3;
  }
  nativeSort$1(array5, function(a, b) {
    return (a / 4 | 0) - (b / 4 | 0);
  });
  for (index2 = 0; index2 < 516; index2++) {
    if (array5[index2] !== expected[index2])
      return true;
  }
});
var getSortCompare$1 = function(comparefn) {
  return function(x, y) {
    if (comparefn !== void 0)
      return +comparefn(x, y) || 0;
    if (y !== y)
      return -1;
    if (x !== x)
      return 1;
    if (x === 0 && y === 0)
      return 1 / x > 0 && 1 / y < 0 ? 1 : -1;
    return x > y;
  };
};
exportTypedArrayMethod$4("sort", function sort2(comparefn) {
  if (comparefn !== void 0)
    aCallable$1(comparefn);
  if (STABLE_SORT$1)
    return nativeSort$1(this, comparefn);
  return internalSort$1(aTypedArray$3(this), getSortCompare$1(comparefn));
}, !STABLE_SORT$1 || ACCEPT_INCORRECT_ARGUMENTS);
var ArrayBufferViewCore$2 = arrayBufferViewCore;
var toLength$3 = toLength$9;
var toAbsoluteIndex$1 = toAbsoluteIndex$6;
var typedArraySpeciesConstructor = typedArraySpeciesConstructor$4;
var aTypedArray$2 = ArrayBufferViewCore$2.aTypedArray;
var exportTypedArrayMethod$3 = ArrayBufferViewCore$2.exportTypedArrayMethod;
exportTypedArrayMethod$3("subarray", function subarray(begin, end2) {
  var O = aTypedArray$2(this);
  var length = O.length;
  var beginIndex = toAbsoluteIndex$1(begin, length);
  var C = typedArraySpeciesConstructor(O);
  return new C(
    O.buffer,
    O.byteOffset + beginIndex * O.BYTES_PER_ELEMENT,
    toLength$3((end2 === void 0 ? length : toAbsoluteIndex$1(end2, length)) - beginIndex)
  );
});
var global$4 = global$D;
var apply = functionApply;
var ArrayBufferViewCore$1 = arrayBufferViewCore;
var fails$6 = fails$M;
var arraySlice$1 = arraySlice$9;
var Int8Array$1 = global$4.Int8Array;
var aTypedArray$1 = ArrayBufferViewCore$1.aTypedArray;
var exportTypedArrayMethod$2 = ArrayBufferViewCore$1.exportTypedArrayMethod;
var $toLocaleString = [].toLocaleString;
var TO_LOCALE_STRING_BUG = !!Int8Array$1 && fails$6(function() {
  $toLocaleString.call(new Int8Array$1(1));
});
var FORCED$1 = fails$6(function() {
  return [1, 2].toLocaleString() !== new Int8Array$1([1, 2]).toLocaleString();
}) || !fails$6(function() {
  Int8Array$1.prototype.toLocaleString.call([1, 2]);
});
exportTypedArrayMethod$2("toLocaleString", function toLocaleString() {
  return apply(
    $toLocaleString,
    TO_LOCALE_STRING_BUG ? arraySlice$1(aTypedArray$1(this)) : aTypedArray$1(this),
    arraySlice$1(arguments)
  );
}, FORCED$1);
var exportTypedArrayMethod$1 = arrayBufferViewCore.exportTypedArrayMethod;
var fails$5 = fails$M;
var global$3 = global$D;
var uncurryThis$9 = functionUncurryThis;
var Uint8Array$1 = global$3.Uint8Array;
var Uint8ArrayPrototype = Uint8Array$1 && Uint8Array$1.prototype || {};
var arrayToString = [].toString;
var join$3 = uncurryThis$9([].join);
if (fails$5(function() {
  arrayToString.call({});
})) {
  arrayToString = function toString6() {
    return join$3(this);
  };
}
var IS_NOT_ARRAY_METHOD = Uint8ArrayPrototype.toString !== arrayToString;
exportTypedArrayMethod$1("toString", arrayToString, IS_NOT_ARRAY_METHOD);
var call$4 = functionCall;
var uncurryThis$8 = functionUncurryThis;
var fixRegExpWellKnownSymbolLogic$2 = fixRegexpWellKnownSymbolLogic;
var anObject$4 = anObject$m;
var isNullOrUndefined$3 = isNullOrUndefined$b;
var requireObjectCoercible$4 = requireObjectCoercible$b;
var speciesConstructor = speciesConstructor$3;
var advanceStringIndex$1 = advanceStringIndex$3;
var toLength$2 = toLength$9;
var toString$5 = toString$g;
var getMethod$2 = getMethod$7;
var regExpExec$2 = regexpExecAbstract;
var stickyHelpers = regexpStickyHelpers;
var fails$4 = fails$M;
var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
var MAX_UINT32 = 4294967295;
var min$2 = Math.min;
var push$4 = uncurryThis$8([].push);
var stringSlice$3 = uncurryThis$8("".slice);
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails$4(function() {
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function() {
    return originalExec.apply(this, arguments);
  };
  var result = "ab".split(re);
  return result.length !== 2 || result[0] !== "a" || result[1] !== "b";
});
var BUGGY = "abbc".split(/(b)*/)[1] === "c" || // eslint-disable-next-line regexp/no-empty-group -- required for testing
"test".split(/(?:)/, -1).length !== 4 || "ab".split(/(?:ab)*/).length !== 2 || ".".split(/(.?)(.?)/).length !== 4 || // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
".".split(/()()/).length > 1 || "".split(/.?/).length;
fixRegExpWellKnownSymbolLogic$2("split", function(SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit = "0".split(void 0, 0).length ? function(separator, limit) {
    return separator === void 0 && limit === 0 ? [] : call$4(nativeSplit, this, separator, limit);
  } : nativeSplit;
  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split2(separator, limit) {
      var O = requireObjectCoercible$4(this);
      var splitter = isNullOrUndefined$3(separator) ? void 0 : getMethod$2(separator, SPLIT);
      return splitter ? call$4(splitter, separator, O, limit) : call$4(internalSplit, toString$5(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function(string, limit) {
      var rx = anObject$4(this);
      var S = toString$5(string);
      if (!BUGGY) {
        var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);
        if (res.done)
          return res.value;
      }
      var C = speciesConstructor(rx, RegExp);
      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? "i" : "") + (rx.multiline ? "m" : "") + (rx.unicode ? "u" : "") + (UNSUPPORTED_Y ? "g" : "y");
      var splitter = new C(UNSUPPORTED_Y ? "^(?:" + rx.source + ")" : rx, flags);
      var lim = limit === void 0 ? MAX_UINT32 : limit >>> 0;
      if (lim === 0)
        return [];
      if (S.length === 0)
        return regExpExec$2(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
        var z = regExpExec$2(splitter, UNSUPPORTED_Y ? stringSlice$3(S, q) : S);
        var e;
        if (z === null || (e = min$2(toLength$2(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p) {
          q = advanceStringIndex$1(S, q, unicodeMatching);
        } else {
          push$4(A, stringSlice$3(S, p, q));
          if (A.length === lim)
            return A;
          for (var i = 1; i <= z.length - 1; i++) {
            push$4(A, z[i]);
            if (A.length === lim)
              return A;
          }
          q = p = e;
        }
      }
      push$4(A, stringSlice$3(S, p));
      return A;
    }
  ];
}, BUGGY || !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);
var wrapNativeSuper = { exports: {} };
var isNativeFunction = { exports: {} };
isNativeFunction.exports;
(function(module) {
  function _isNativeFunction(t) {
    try {
      return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
      return "function" == typeof t;
    }
  }
  module.exports = _isNativeFunction, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(isNativeFunction);
var isNativeFunctionExports = isNativeFunction.exports;
var construct2 = { exports: {} };
var isNativeReflectConstruct = { exports: {} };
isNativeReflectConstruct.exports;
(function(module) {
  function _isNativeReflectConstruct2() {
    try {
      var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch (t2) {
    }
    return (module.exports = _isNativeReflectConstruct2 = function _isNativeReflectConstruct3() {
      return !!t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
  }
  module.exports = _isNativeReflectConstruct2, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(isNativeReflectConstruct);
var isNativeReflectConstructExports = isNativeReflectConstruct.exports;
construct2.exports;
(function(module) {
  var isNativeReflectConstruct2 = isNativeReflectConstructExports;
  var setPrototypeOf2 = setPrototypeOfExports;
  function _construct(t, e, r) {
    if (isNativeReflectConstruct2())
      return Reflect.construct.apply(null, arguments);
    var o = [null];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && setPrototypeOf2(p, r.prototype), p;
  }
  module.exports = _construct, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(construct2);
var constructExports = construct2.exports;
wrapNativeSuper.exports;
(function(module) {
  var getPrototypeOf2 = getPrototypeOfExports;
  var setPrototypeOf2 = setPrototypeOfExports;
  var isNativeFunction2 = isNativeFunctionExports;
  var construct3 = constructExports;
  function _wrapNativeSuper2(t) {
    var r = "function" == typeof Map ? /* @__PURE__ */ new Map() : void 0;
    return module.exports = _wrapNativeSuper2 = function _wrapNativeSuper3(t2) {
      if (null === t2 || !isNativeFunction2(t2))
        return t2;
      if ("function" != typeof t2)
        throw new TypeError("Super expression must either be null or a function");
      if (void 0 !== r) {
        if (r.has(t2))
          return r.get(t2);
        r.set(t2, Wrapper);
      }
      function Wrapper() {
        return construct3(t2, arguments, getPrototypeOf2(this).constructor);
      }
      return Wrapper.prototype = Object.create(t2.prototype, {
        constructor: {
          value: Wrapper,
          enumerable: false,
          writable: true,
          configurable: true
        }
      }), setPrototypeOf2(Wrapper, t2);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _wrapNativeSuper2(t);
  }
  module.exports = _wrapNativeSuper2, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(wrapNativeSuper);
var wrapNativeSuperExports = wrapNativeSuper.exports;
var platform$1 = { exports: {} };
/*!
 * Platform.js v1.3.6
 * Copyright 2014-2020 Benjamin Tan
 * Copyright 2011-2013 John-David Dalton
 * Available under MIT license
 */
platform$1.exports;
(function(module, exports) {
  (function() {
    var objectTypes = {
      "function": true,
      "object": true
    };
    var root = objectTypes[typeof window] && window || this;
    var freeExports = objectTypes["object"] && exports;
    var freeModule = objectTypes["object"] && module && !module.nodeType && module;
    var freeGlobal = freeExports && freeModule && typeof commonjsGlobal == "object" && commonjsGlobal;
    if (freeGlobal && (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal)) {
      root = freeGlobal;
    }
    var maxSafeInteger = Math.pow(2, 53) - 1;
    var reOpera = /\bOpera/;
    var objectProto = Object.prototype;
    var hasOwnProperty2 = objectProto.hasOwnProperty;
    var toString6 = objectProto.toString;
    function capitalize(string) {
      string = String(string);
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
    function cleanupOS(os, pattern2, label) {
      var data2 = {
        "10.0": "10",
        "6.4": "10 Technical Preview",
        "6.3": "8.1",
        "6.2": "8",
        "6.1": "Server 2008 R2 / 7",
        "6.0": "Server 2008 / Vista",
        "5.2": "Server 2003 / XP 64-bit",
        "5.1": "XP",
        "5.01": "2000 SP1",
        "5.0": "2000",
        "4.0": "NT",
        "4.90": "ME"
      };
      if (pattern2 && label && /^Win/i.test(os) && !/^Windows Phone /i.test(os) && (data2 = data2[/[\d.]+$/.exec(os)])) {
        os = "Windows " + data2;
      }
      os = String(os);
      if (pattern2 && label) {
        os = os.replace(RegExp(pattern2, "i"), label);
      }
      os = format(
        os.replace(/ ce$/i, " CE").replace(/\bhpw/i, "web").replace(/\bMacintosh\b/, "Mac OS").replace(/_PowerPC\b/i, " OS").replace(/\b(OS X) [^ \d]+/i, "$1").replace(/\bMac (OS X)\b/, "$1").replace(/\/(\d)/, " $1").replace(/_/g, ".").replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, "").replace(/\bx86\.64\b/gi, "x86_64").replace(/\b(Windows Phone) OS\b/, "$1").replace(/\b(Chrome OS \w+) [\d.]+\b/, "$1").split(" on ")[0]
      );
      return os;
    }
    function each(object, callback) {
      var index2 = -1, length = object ? object.length : 0;
      if (typeof length == "number" && length > -1 && length <= maxSafeInteger) {
        while (++index2 < length) {
          callback(object[index2], index2, object);
        }
      } else {
        forOwn(object, callback);
      }
    }
    function format(string) {
      string = trim2(string);
      return /^(?:webOS|i(?:OS|P))/.test(string) ? string : capitalize(string);
    }
    function forOwn(object, callback) {
      for (var key in object) {
        if (hasOwnProperty2.call(object, key)) {
          callback(object[key], key, object);
        }
      }
    }
    function getClassOf(value) {
      return value == null ? capitalize(value) : toString6.call(value).slice(8, -1);
    }
    function isHostType(object, property) {
      var type5 = object != null ? typeof object[property] : "number";
      return !/^(?:boolean|number|string|undefined)$/.test(type5) && (type5 == "object" ? !!object[property] : true);
    }
    function qualify(string) {
      return String(string).replace(/([ -])(?!$)/g, "$1?");
    }
    function reduce2(array5, callback) {
      var accumulator = null;
      each(array5, function(value, index2) {
        accumulator = callback(accumulator, value, index2, array5);
      });
      return accumulator;
    }
    function trim2(string) {
      return String(string).replace(/^ +| +$/g, "");
    }
    function parse2(ua) {
      var context = root;
      var isCustomContext = ua && typeof ua == "object" && getClassOf(ua) != "String";
      if (isCustomContext) {
        context = ua;
        ua = null;
      }
      var nav = context.navigator || {};
      var userAgent2 = nav.userAgent || "";
      ua || (ua = userAgent2);
      var likeChrome = isCustomContext ? !!nav.likeChrome : /\bChrome\b/.test(ua) && !/internal|\n/i.test(toString6.toString());
      var objectClass = "Object", airRuntimeClass = isCustomContext ? objectClass : "ScriptBridgingProxyObject", enviroClass = isCustomContext ? objectClass : "Environment", javaClass = isCustomContext && context.java ? "JavaPackage" : getClassOf(context.java), phantomClass = isCustomContext ? objectClass : "RuntimeObject";
      var java = /\bJava/.test(javaClass) && context.java;
      var rhino = java && getClassOf(context.environment) == enviroClass;
      var alpha = java ? "a" : "α";
      var beta = java ? "b" : "β";
      var doc = context.document || {};
      var opera = context.operamini || context.opera;
      var operaClass = reOpera.test(operaClass = isCustomContext && opera ? opera["[[Class]]"] : getClassOf(opera)) ? operaClass : opera = null;
      var data2;
      var arch = ua;
      var description = [];
      var prerelease = null;
      var useFeatures = ua == userAgent2;
      var version2 = useFeatures && opera && typeof opera.version == "function" && opera.version();
      var isSpecialCasedOS;
      var layout = getLayout([
        { "label": "EdgeHTML", "pattern": "Edge" },
        "Trident",
        { "label": "WebKit", "pattern": "AppleWebKit" },
        "iCab",
        "Presto",
        "NetFront",
        "Tasman",
        "KHTML",
        "Gecko"
      ]);
      var name = getName([
        "Adobe AIR",
        "Arora",
        "Avant Browser",
        "Breach",
        "Camino",
        "Electron",
        "Epiphany",
        "Fennec",
        "Flock",
        "Galeon",
        "GreenBrowser",
        "iCab",
        "Iceweasel",
        "K-Meleon",
        "Konqueror",
        "Lunascape",
        "Maxthon",
        { "label": "Microsoft Edge", "pattern": "(?:Edge|Edg|EdgA|EdgiOS)" },
        "Midori",
        "Nook Browser",
        "PaleMoon",
        "PhantomJS",
        "Raven",
        "Rekonq",
        "RockMelt",
        { "label": "Samsung Internet", "pattern": "SamsungBrowser" },
        "SeaMonkey",
        { "label": "Silk", "pattern": "(?:Cloud9|Silk-Accelerated)" },
        "Sleipnir",
        "SlimBrowser",
        { "label": "SRWare Iron", "pattern": "Iron" },
        "Sunrise",
        "Swiftfox",
        "Vivaldi",
        "Waterfox",
        "WebPositive",
        { "label": "Yandex Browser", "pattern": "YaBrowser" },
        { "label": "UC Browser", "pattern": "UCBrowser" },
        "Opera Mini",
        { "label": "Opera Mini", "pattern": "OPiOS" },
        "Opera",
        { "label": "Opera", "pattern": "OPR" },
        "Chromium",
        "Chrome",
        { "label": "Chrome", "pattern": "(?:HeadlessChrome)" },
        { "label": "Chrome Mobile", "pattern": "(?:CriOS|CrMo)" },
        { "label": "Firefox", "pattern": "(?:Firefox|Minefield)" },
        { "label": "Firefox for iOS", "pattern": "FxiOS" },
        { "label": "IE", "pattern": "IEMobile" },
        { "label": "IE", "pattern": "MSIE" },
        "Safari"
      ]);
      var product = getProduct([
        { "label": "BlackBerry", "pattern": "BB10" },
        "BlackBerry",
        { "label": "Galaxy S", "pattern": "GT-I9000" },
        { "label": "Galaxy S2", "pattern": "GT-I9100" },
        { "label": "Galaxy S3", "pattern": "GT-I9300" },
        { "label": "Galaxy S4", "pattern": "GT-I9500" },
        { "label": "Galaxy S5", "pattern": "SM-G900" },
        { "label": "Galaxy S6", "pattern": "SM-G920" },
        { "label": "Galaxy S6 Edge", "pattern": "SM-G925" },
        { "label": "Galaxy S7", "pattern": "SM-G930" },
        { "label": "Galaxy S7 Edge", "pattern": "SM-G935" },
        "Google TV",
        "Lumia",
        "iPad",
        "iPod",
        "iPhone",
        "Kindle",
        { "label": "Kindle Fire", "pattern": "(?:Cloud9|Silk-Accelerated)" },
        "Nexus",
        "Nook",
        "PlayBook",
        "PlayStation Vita",
        "PlayStation",
        "TouchPad",
        "Transformer",
        { "label": "Wii U", "pattern": "WiiU" },
        "Wii",
        "Xbox One",
        { "label": "Xbox 360", "pattern": "Xbox" },
        "Xoom"
      ]);
      var manufacturer = getManufacturer({
        "Apple": { "iPad": 1, "iPhone": 1, "iPod": 1 },
        "Alcatel": {},
        "Archos": {},
        "Amazon": { "Kindle": 1, "Kindle Fire": 1 },
        "Asus": { "Transformer": 1 },
        "Barnes & Noble": { "Nook": 1 },
        "BlackBerry": { "PlayBook": 1 },
        "Google": { "Google TV": 1, "Nexus": 1 },
        "HP": { "TouchPad": 1 },
        "HTC": {},
        "Huawei": {},
        "Lenovo": {},
        "LG": {},
        "Microsoft": { "Xbox": 1, "Xbox One": 1 },
        "Motorola": { "Xoom": 1 },
        "Nintendo": { "Wii U": 1, "Wii": 1 },
        "Nokia": { "Lumia": 1 },
        "Oppo": {},
        "Samsung": { "Galaxy S": 1, "Galaxy S2": 1, "Galaxy S3": 1, "Galaxy S4": 1 },
        "Sony": { "PlayStation": 1, "PlayStation Vita": 1 },
        "Xiaomi": { "Mi": 1, "Redmi": 1 }
      });
      var os = getOS([
        "Windows Phone",
        "KaiOS",
        "Android",
        "CentOS",
        { "label": "Chrome OS", "pattern": "CrOS" },
        "Debian",
        { "label": "DragonFly BSD", "pattern": "DragonFly" },
        "Fedora",
        "FreeBSD",
        "Gentoo",
        "Haiku",
        "Kubuntu",
        "Linux Mint",
        "OpenBSD",
        "Red Hat",
        "SuSE",
        "Ubuntu",
        "Xubuntu",
        "Cygwin",
        "Symbian OS",
        "hpwOS",
        "webOS ",
        "webOS",
        "Tablet OS",
        "Tizen",
        "Linux",
        "Mac OS X",
        "Macintosh",
        "Mac",
        "Windows 98;",
        "Windows "
      ]);
      function getLayout(guesses) {
        return reduce2(guesses, function(result, guess) {
          return result || RegExp("\\b" + (guess.pattern || qualify(guess)) + "\\b", "i").exec(ua) && (guess.label || guess);
        });
      }
      function getManufacturer(guesses) {
        return reduce2(guesses, function(result, value, key) {
          return result || (value[product] || value[/^[a-z]+(?: +[a-z]+\b)*/i.exec(product)] || RegExp("\\b" + qualify(key) + "(?:\\b|\\w*\\d)", "i").exec(ua)) && key;
        });
      }
      function getName(guesses) {
        return reduce2(guesses, function(result, guess) {
          return result || RegExp("\\b" + (guess.pattern || qualify(guess)) + "\\b", "i").exec(ua) && (guess.label || guess);
        });
      }
      function getOS(guesses) {
        return reduce2(guesses, function(result, guess) {
          var pattern2 = guess.pattern || qualify(guess);
          if (!result && (result = RegExp("\\b" + pattern2 + "(?:/[\\d.]+|[ \\w.]*)", "i").exec(ua))) {
            result = cleanupOS(result, pattern2, guess.label || guess);
          }
          return result;
        });
      }
      function getProduct(guesses) {
        return reduce2(guesses, function(result, guess) {
          var pattern2 = guess.pattern || qualify(guess);
          if (!result && (result = RegExp("\\b" + pattern2 + " *\\d+[.\\w_]*", "i").exec(ua) || RegExp("\\b" + pattern2 + " *\\w+-[\\w]*", "i").exec(ua) || RegExp("\\b" + pattern2 + "(?:; *(?:[a-z]+[_-])?[a-z]+\\d+|[^ ();-]*)", "i").exec(ua))) {
            if ((result = String(guess.label && !RegExp(pattern2, "i").test(guess.label) ? guess.label : result).split("/"))[1] && !/[\d.]+/.test(result[0])) {
              result[0] += " " + result[1];
            }
            guess = guess.label || guess;
            result = format(result[0].replace(RegExp(pattern2, "i"), guess).replace(RegExp("; *(?:" + guess + "[_-])?", "i"), " ").replace(RegExp("(" + guess + ")[-_.]?(\\w)", "i"), "$1 $2"));
          }
          return result;
        });
      }
      function getVersion(patterns) {
        return reduce2(patterns, function(result, pattern2) {
          return result || (RegExp(pattern2 + "(?:-[\\d.]+/|(?: for [\\w-]+)?[ /-])([\\d.]+[^ ();/_-]*)", "i").exec(ua) || 0)[1] || null;
        });
      }
      function toStringPlatform() {
        return this.description || "";
      }
      layout && (layout = [layout]);
      if (/\bAndroid\b/.test(os) && !product && (data2 = /\bAndroid[^;]*;(.*?)(?:Build|\) AppleWebKit)\b/i.exec(ua))) {
        product = trim2(data2[1]).replace(/^[a-z]{2}-[a-z]{2};\s*/i, "") || null;
      }
      if (manufacturer && !product) {
        product = getProduct([manufacturer]);
      } else if (manufacturer && product) {
        product = product.replace(RegExp("^(" + qualify(manufacturer) + ")[-_.\\s]", "i"), manufacturer + " ").replace(RegExp("^(" + qualify(manufacturer) + ")[-_.]?(\\w)", "i"), manufacturer + " $2");
      }
      if (data2 = /\bGoogle TV\b/.exec(product)) {
        product = data2[0];
      }
      if (/\bSimulator\b/i.test(ua)) {
        product = (product ? product + " " : "") + "Simulator";
      }
      if (name == "Opera Mini" && /\bOPiOS\b/.test(ua)) {
        description.push("running in Turbo/Uncompressed mode");
      }
      if (name == "IE" && /\blike iPhone OS\b/.test(ua)) {
        data2 = parse2(ua.replace(/like iPhone OS/, ""));
        manufacturer = data2.manufacturer;
        product = data2.product;
      } else if (/^iP/.test(product)) {
        name || (name = "Safari");
        os = "iOS" + ((data2 = / OS ([\d_]+)/i.exec(ua)) ? " " + data2[1].replace(/_/g, ".") : "");
      } else if (name == "Konqueror" && /^Linux\b/i.test(os)) {
        os = "Kubuntu";
      } else if (manufacturer && manufacturer != "Google" && (/Chrome/.test(name) && !/\bMobile Safari\b/i.test(ua) || /\bVita\b/.test(product)) || /\bAndroid\b/.test(os) && /^Chrome/.test(name) && /\bVersion\//i.test(ua)) {
        name = "Android Browser";
        os = /\bAndroid\b/.test(os) ? os : "Android";
      } else if (name == "Silk") {
        if (!/\bMobi/i.test(ua)) {
          os = "Android";
          description.unshift("desktop mode");
        }
        if (/Accelerated *= *true/i.test(ua)) {
          description.unshift("accelerated");
        }
      } else if (name == "UC Browser" && /\bUCWEB\b/.test(ua)) {
        description.push("speed mode");
      } else if (name == "PaleMoon" && (data2 = /\bFirefox\/([\d.]+)\b/.exec(ua))) {
        description.push("identifying as Firefox " + data2[1]);
      } else if (name == "Firefox" && (data2 = /\b(Mobile|Tablet|TV)\b/i.exec(ua))) {
        os || (os = "Firefox OS");
        product || (product = data2[1]);
      } else if (!name || (data2 = !/\bMinefield\b/i.test(ua) && /\b(?:Firefox|Safari)\b/.exec(name))) {
        if (name && !product && /[\/,]|^[^(]+?\)/.test(ua.slice(ua.indexOf(data2 + "/") + 8))) {
          name = null;
        }
        if ((data2 = product || manufacturer || os) && (product || manufacturer || /\b(?:Android|Symbian OS|Tablet OS|webOS)\b/.test(os))) {
          name = /[a-z]+(?: Hat)?/i.exec(/\bAndroid\b/.test(os) ? os : data2) + " Browser";
        }
      } else if (name == "Electron" && (data2 = (/\bChrome\/([\d.]+)\b/.exec(ua) || 0)[1])) {
        description.push("Chromium " + data2);
      }
      if (!version2) {
        version2 = getVersion([
          "(?:Cloud9|CriOS|CrMo|Edge|Edg|EdgA|EdgiOS|FxiOS|HeadlessChrome|IEMobile|Iron|Opera ?Mini|OPiOS|OPR|Raven|SamsungBrowser|Silk(?!/[\\d.]+$)|UCBrowser|YaBrowser)",
          "Version",
          qualify(name),
          "(?:Firefox|Minefield|NetFront)"
        ]);
      }
      if (data2 = layout == "iCab" && parseFloat(version2) > 3 && "WebKit" || /\bOpera\b/.test(name) && (/\bOPR\b/.test(ua) ? "Blink" : "Presto") || /\b(?:Midori|Nook|Safari)\b/i.test(ua) && !/^(?:Trident|EdgeHTML)$/.test(layout) && "WebKit" || !layout && /\bMSIE\b/i.test(ua) && (os == "Mac OS" ? "Tasman" : "Trident") || layout == "WebKit" && /\bPlayStation\b(?! Vita\b)/i.test(name) && "NetFront") {
        layout = [data2];
      }
      if (name == "IE" && (data2 = (/; *(?:XBLWP|ZuneWP)(\d+)/i.exec(ua) || 0)[1])) {
        name += " Mobile";
        os = "Windows Phone " + (/\+$/.test(data2) ? data2 : data2 + ".x");
        description.unshift("desktop mode");
      } else if (/\bWPDesktop\b/i.test(ua)) {
        name = "IE Mobile";
        os = "Windows Phone 8.x";
        description.unshift("desktop mode");
        version2 || (version2 = (/\brv:([\d.]+)/.exec(ua) || 0)[1]);
      } else if (name != "IE" && layout == "Trident" && (data2 = /\brv:([\d.]+)/.exec(ua))) {
        if (name) {
          description.push("identifying as " + name + (version2 ? " " + version2 : ""));
        }
        name = "IE";
        version2 = data2[1];
      }
      if (useFeatures) {
        if (isHostType(context, "global")) {
          if (java) {
            data2 = java.lang.System;
            arch = data2.getProperty("os.arch");
            os = os || data2.getProperty("os.name") + " " + data2.getProperty("os.version");
          }
          if (rhino) {
            try {
              version2 = context.require("ringo/engine").version.join(".");
              name = "RingoJS";
            } catch (e) {
              if ((data2 = context.system) && data2.global.system == context.system) {
                name = "Narwhal";
                os || (os = data2[0].os || null);
              }
            }
            if (!name) {
              name = "Rhino";
            }
          } else if (typeof context.process == "object" && !context.process.browser && (data2 = context.process)) {
            if (typeof data2.versions == "object") {
              if (typeof data2.versions.electron == "string") {
                description.push("Node " + data2.versions.node);
                name = "Electron";
                version2 = data2.versions.electron;
              } else if (typeof data2.versions.nw == "string") {
                description.push("Chromium " + version2, "Node " + data2.versions.node);
                name = "NW.js";
                version2 = data2.versions.nw;
              }
            }
            if (!name) {
              name = "Node.js";
              arch = data2.arch;
              os = data2.platform;
              version2 = /[\d.]+/.exec(data2.version);
              version2 = version2 ? version2[0] : null;
            }
          }
        } else if (getClassOf(data2 = context.runtime) == airRuntimeClass) {
          name = "Adobe AIR";
          os = data2.flash.system.Capabilities.os;
        } else if (getClassOf(data2 = context.phantom) == phantomClass) {
          name = "PhantomJS";
          version2 = (data2 = data2.version || null) && data2.major + "." + data2.minor + "." + data2.patch;
        } else if (typeof doc.documentMode == "number" && (data2 = /\bTrident\/(\d+)/i.exec(ua))) {
          version2 = [version2, doc.documentMode];
          if ((data2 = +data2[1] + 4) != version2[1]) {
            description.push("IE " + version2[1] + " mode");
            layout && (layout[1] = "");
            version2[1] = data2;
          }
          version2 = name == "IE" ? String(version2[1].toFixed(1)) : version2[0];
        } else if (typeof doc.documentMode == "number" && /^(?:Chrome|Firefox)\b/.test(name)) {
          description.push("masking as " + name + " " + version2);
          name = "IE";
          version2 = "11.0";
          layout = ["Trident"];
          os = "Windows";
        }
        os = os && format(os);
      }
      if (version2 && (data2 = /(?:[ab]|dp|pre|[ab]\d+pre)(?:\d+\+?)?$/i.exec(version2) || /(?:alpha|beta)(?: ?\d)?/i.exec(ua + ";" + (useFeatures && nav.appMinorVersion)) || /\bMinefield\b/i.test(ua) && "a")) {
        prerelease = /b/i.test(data2) ? "beta" : "alpha";
        version2 = version2.replace(RegExp(data2 + "\\+?$"), "") + (prerelease == "beta" ? beta : alpha) + (/\d+\+?/.exec(data2) || "");
      }
      if (name == "Fennec" || name == "Firefox" && /\b(?:Android|Firefox OS|KaiOS)\b/.test(os)) {
        name = "Firefox Mobile";
      } else if (name == "Maxthon" && version2) {
        version2 = version2.replace(/\.[\d.]+/, ".x");
      } else if (/\bXbox\b/i.test(product)) {
        if (product == "Xbox 360") {
          os = null;
        }
        if (product == "Xbox 360" && /\bIEMobile\b/.test(ua)) {
          description.unshift("mobile mode");
        }
      } else if ((/^(?:Chrome|IE|Opera)$/.test(name) || name && !product && !/Browser|Mobi/.test(name)) && (os == "Windows CE" || /Mobi/i.test(ua))) {
        name += " Mobile";
      } else if (name == "IE" && useFeatures) {
        try {
          if (context.external === null) {
            description.unshift("platform preview");
          }
        } catch (e) {
          description.unshift("embedded");
        }
      } else if ((/\bBlackBerry\b/.test(product) || /\bBB10\b/.test(ua)) && (data2 = (RegExp(product.replace(/ +/g, " *") + "/([.\\d]+)", "i").exec(ua) || 0)[1] || version2)) {
        data2 = [data2, /BB10/.test(ua)];
        os = (data2[1] ? (product = null, manufacturer = "BlackBerry") : "Device Software") + " " + data2[0];
        version2 = null;
      } else if (this != forOwn && product != "Wii" && (useFeatures && opera || /Opera/.test(name) && /\b(?:MSIE|Firefox)\b/i.test(ua) || name == "Firefox" && /\bOS X (?:\d+\.){2,}/.test(os) || name == "IE" && (os && !/^Win/.test(os) && version2 > 5.5 || /\bWindows XP\b/.test(os) && version2 > 8 || version2 == 8 && !/\bTrident\b/.test(ua))) && !reOpera.test(data2 = parse2.call(forOwn, ua.replace(reOpera, "") + ";")) && data2.name) {
        data2 = "ing as " + data2.name + ((data2 = data2.version) ? " " + data2 : "");
        if (reOpera.test(name)) {
          if (/\bIE\b/.test(data2) && os == "Mac OS") {
            os = null;
          }
          data2 = "identify" + data2;
        } else {
          data2 = "mask" + data2;
          if (operaClass) {
            name = format(operaClass.replace(/([a-z])([A-Z])/g, "$1 $2"));
          } else {
            name = "Opera";
          }
          if (/\bIE\b/.test(data2)) {
            os = null;
          }
          if (!useFeatures) {
            version2 = null;
          }
        }
        layout = ["Presto"];
        description.push(data2);
      }
      if (data2 = (/\bAppleWebKit\/([\d.]+\+?)/i.exec(ua) || 0)[1]) {
        data2 = [parseFloat(data2.replace(/\.(\d)$/, ".0$1")), data2];
        if (name == "Safari" && data2[1].slice(-1) == "+") {
          name = "WebKit Nightly";
          prerelease = "alpha";
          version2 = data2[1].slice(0, -1);
        } else if (version2 == data2[1] || version2 == (data2[2] = (/\bSafari\/([\d.]+\+?)/i.exec(ua) || 0)[1])) {
          version2 = null;
        }
        data2[1] = (/\b(?:Headless)?Chrome\/([\d.]+)/i.exec(ua) || 0)[1];
        if (data2[0] == 537.36 && data2[2] == 537.36 && parseFloat(data2[1]) >= 28 && layout == "WebKit") {
          layout = ["Blink"];
        }
        if (!useFeatures || !likeChrome && !data2[1]) {
          layout && (layout[1] = "like Safari");
          data2 = (data2 = data2[0], data2 < 400 ? 1 : data2 < 500 ? 2 : data2 < 526 ? 3 : data2 < 533 ? 4 : data2 < 534 ? "4+" : data2 < 535 ? 5 : data2 < 537 ? 6 : data2 < 538 ? 7 : data2 < 601 ? 8 : data2 < 602 ? 9 : data2 < 604 ? 10 : data2 < 606 ? 11 : data2 < 608 ? 12 : "12");
        } else {
          layout && (layout[1] = "like Chrome");
          data2 = data2[1] || (data2 = data2[0], data2 < 530 ? 1 : data2 < 532 ? 2 : data2 < 532.05 ? 3 : data2 < 533 ? 4 : data2 < 534.03 ? 5 : data2 < 534.07 ? 6 : data2 < 534.1 ? 7 : data2 < 534.13 ? 8 : data2 < 534.16 ? 9 : data2 < 534.24 ? 10 : data2 < 534.3 ? 11 : data2 < 535.01 ? 12 : data2 < 535.02 ? "13+" : data2 < 535.07 ? 15 : data2 < 535.11 ? 16 : data2 < 535.19 ? 17 : data2 < 536.05 ? 18 : data2 < 536.1 ? 19 : data2 < 537.01 ? 20 : data2 < 537.11 ? "21+" : data2 < 537.13 ? 23 : data2 < 537.18 ? 24 : data2 < 537.24 ? 25 : data2 < 537.36 ? 26 : layout != "Blink" ? "27" : "28");
        }
        layout && (layout[1] += " " + (data2 += typeof data2 == "number" ? ".x" : /[.+]/.test(data2) ? "" : "+"));
        if (name == "Safari" && (!version2 || parseInt(version2) > 45)) {
          version2 = data2;
        } else if (name == "Chrome" && /\bHeadlessChrome/i.test(ua)) {
          description.unshift("headless");
        }
      }
      if (name == "Opera" && (data2 = /\bzbov|zvav$/.exec(os))) {
        name += " ";
        description.unshift("desktop mode");
        if (data2 == "zvav") {
          name += "Mini";
          version2 = null;
        } else {
          name += "Mobile";
        }
        os = os.replace(RegExp(" *" + data2 + "$"), "");
      } else if (name == "Safari" && /\bChrome\b/.exec(layout && layout[1])) {
        description.unshift("desktop mode");
        name = "Chrome Mobile";
        version2 = null;
        if (/\bOS X\b/.test(os)) {
          manufacturer = "Apple";
          os = "iOS 4.3+";
        } else {
          os = null;
        }
      } else if (/\bSRWare Iron\b/.test(name) && !version2) {
        version2 = getVersion("Chrome");
      }
      if (version2 && version2.indexOf(data2 = /[\d.]+$/.exec(os)) == 0 && ua.indexOf("/" + data2 + "-") > -1) {
        os = trim2(os.replace(data2, ""));
      }
      if (os && os.indexOf(name) != -1 && !RegExp(name + " OS").test(os)) {
        os = os.replace(RegExp(" *" + qualify(name) + " *"), "");
      }
      if (layout && !/\b(?:Avant|Nook)\b/.test(name) && (/Browser|Lunascape|Maxthon/.test(name) || name != "Safari" && /^iOS/.test(os) && /\bSafari\b/.test(layout[1]) || /^(?:Adobe|Arora|Breach|Midori|Opera|Phantom|Rekonq|Rock|Samsung Internet|Sleipnir|SRWare Iron|Vivaldi|Web)/.test(name) && layout[1])) {
        (data2 = layout[layout.length - 1]) && description.push(data2);
      }
      if (description.length) {
        description = ["(" + description.join("; ") + ")"];
      }
      if (manufacturer && product && product.indexOf(manufacturer) < 0) {
        description.push("on " + manufacturer);
      }
      if (product) {
        description.push((/^on /.test(description[description.length - 1]) ? "" : "on ") + product);
      }
      if (os) {
        data2 = / ([\d.+]+)$/.exec(os);
        isSpecialCasedOS = data2 && os.charAt(os.length - data2[0].length - 1) == "/";
        os = {
          "architecture": 32,
          "family": data2 && !isSpecialCasedOS ? os.replace(data2[0], "") : os,
          "version": data2 ? data2[1] : null,
          "toString": function() {
            var version3 = this.version;
            return this.family + (version3 && !isSpecialCasedOS ? " " + version3 : "") + (this.architecture == 64 ? " 64-bit" : "");
          }
        };
      }
      if ((data2 = /\b(?:AMD|IA|Win|WOW|x86_|x)64\b/i.exec(arch)) && !/\bi686\b/i.test(arch)) {
        if (os) {
          os.architecture = 64;
          os.family = os.family.replace(RegExp(" *" + data2), "");
        }
        if (name && (/\bWOW64\b/i.test(ua) || useFeatures && /\w(?:86|32)$/.test(nav.cpuClass || nav.platform) && !/\bWin64; x64\b/i.test(ua))) {
          description.unshift("32-bit");
        }
      } else if (os && /^OS X/.test(os.family) && name == "Chrome" && parseFloat(version2) >= 39) {
        os.architecture = 64;
      }
      ua || (ua = null);
      var platform3 = {};
      platform3.description = ua;
      platform3.layout = layout && layout[0];
      platform3.manufacturer = manufacturer;
      platform3.name = name;
      platform3.prerelease = prerelease;
      platform3.product = product;
      platform3.ua = ua;
      platform3.version = name && version2;
      platform3.os = os || {
        /**
         * The CPU architecture the OS is built for.
         *
         * @memberOf platform.os
         * @type number|null
         */
        "architecture": null,
        /**
         * The family of the OS.
         *
         * Common values include:
         * "Windows", "Windows Server 2008 R2 / 7", "Windows Server 2008 / Vista",
         * "Windows XP", "OS X", "Linux", "Ubuntu", "Debian", "Fedora", "Red Hat",
         * "SuSE", "Android", "iOS" and "Windows Phone"
         *
         * @memberOf platform.os
         * @type string|null
         */
        "family": null,
        /**
         * The version of the OS.
         *
         * @memberOf platform.os
         * @type string|null
         */
        "version": null,
        /**
         * Returns the OS string.
         *
         * @memberOf platform.os
         * @returns {string} The OS string.
         */
        "toString": function() {
          return "null";
        }
      };
      platform3.parse = parse2;
      platform3.toString = toStringPlatform;
      if (platform3.version) {
        description.unshift(version2);
      }
      if (platform3.name) {
        description.unshift(name);
      }
      if (os && name && !(os == String(os).split(" ")[0] && (os == name.split(" ")[0] || product))) {
        description.push(product ? "(" + os + ")" : "on " + os);
      }
      if (description.length) {
        platform3.description = description.join(" ");
      }
      return platform3;
    }
    var platform2 = parse2();
    if (freeExports && freeModule) {
      forOwn(platform2, function(value, key) {
        freeExports[key] = value;
      });
    } else {
      root.platform = platform2;
    }
  }).call(commonjsGlobal);
})(platform$1, platform$1.exports);
var platformExports = platform$1.exports;
var call$3 = functionCall;
var fixRegExpWellKnownSymbolLogic$1 = fixRegexpWellKnownSymbolLogic;
var anObject$3 = anObject$m;
var isNullOrUndefined$2 = isNullOrUndefined$b;
var toLength$1 = toLength$9;
var toString$4 = toString$g;
var requireObjectCoercible$3 = requireObjectCoercible$b;
var getMethod$1 = getMethod$7;
var advanceStringIndex = advanceStringIndex$3;
var regExpExec$1 = regexpExecAbstract;
fixRegExpWellKnownSymbolLogic$1("match", function(MATCH2, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match2(regexp) {
      var O = requireObjectCoercible$3(this);
      var matcher = isNullOrUndefined$2(regexp) ? void 0 : getMethod$1(regexp, MATCH2);
      return matcher ? call$3(matcher, regexp, O) : new RegExp(regexp)[MATCH2](toString$4(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function(string) {
      var rx = anObject$3(this);
      var S = toString$4(string);
      var res = maybeCallNative(nativeMatch, rx, S);
      if (res.done)
        return res.value;
      if (!rx.global)
        return regExpExec$1(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec$1(rx, S)) !== null) {
        var matchStr = toString$4(result[0]);
        A[n] = matchStr;
        if (matchStr === "")
          rx.lastIndex = advanceStringIndex(S, toLength$1(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});
var sameValue$1 = Object.is || function is(x, y) {
  return x === y ? x !== 0 || 1 / x === 1 / y : x !== x && y !== y;
};
var call$2 = functionCall;
var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
var anObject$2 = anObject$m;
var isNullOrUndefined$1 = isNullOrUndefined$b;
var requireObjectCoercible$2 = requireObjectCoercible$b;
var sameValue = sameValue$1;
var toString$3 = toString$g;
var getMethod = getMethod$7;
var regExpExec = regexpExecAbstract;
fixRegExpWellKnownSymbolLogic("search", function(SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.es/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible$2(this);
      var searcher = isNullOrUndefined$1(regexp) ? void 0 : getMethod(regexp, SEARCH);
      return searcher ? call$2(searcher, regexp, O) : new RegExp(regexp)[SEARCH](toString$3(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
    function(string) {
      var rx = anObject$2(this);
      var S = toString$3(string);
      var res = maybeCallNative(nativeSearch, rx, S);
      if (res.done)
        return res.value;
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0))
        rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex))
        rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});
var DESCRIPTORS$4 = descriptors;
var isArray2 = isArray$5;
var $TypeError$1 = TypeError;
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS$4 && !function() {
  if (this !== void 0)
    return true;
  try {
    Object.defineProperty([], "length", { writable: false }).length = 1;
  } catch (error2) {
    return error2 instanceof TypeError;
  }
}();
var arraySetLength = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function(O, length) {
  if (isArray2(O) && !getOwnPropertyDescriptor$1(O, "length").writable) {
    throw new $TypeError$1("Cannot set read only .length");
  }
  return O.length = length;
} : function(O, length) {
  return O.length = length;
};
var $$9 = _export;
var toObject$2 = toObject$f;
var toAbsoluteIndex = toAbsoluteIndex$6;
var toIntegerOrInfinity$1 = toIntegerOrInfinity$a;
var lengthOfArrayLike$2 = lengthOfArrayLike$g;
var setArrayLength = arraySetLength;
var doesNotExceedSafeInteger = doesNotExceedSafeInteger$2;
var arraySpeciesCreate = arraySpeciesCreate$3;
var createProperty = createProperty$5;
var deletePropertyOrThrow$1 = deletePropertyOrThrow$3;
var arrayMethodHasSpeciesSupport = arrayMethodHasSpeciesSupport$5;
var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport("splice");
var max = Math.max;
var min$1 = Math.min;
$$9({ target: "Array", proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  splice: function splice(start, deleteCount) {
    var O = toObject$2(this);
    var len = lengthOfArrayLike$2(O);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from4, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min$1(max(toIntegerOrInfinity$1(deleteCount), 0), len - actualStart);
    }
    doesNotExceedSafeInteger(len + insertCount - actualDeleteCount);
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from4 = actualStart + k;
      if (from4 in O)
        createProperty(A, k, O[from4]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from4 = k + actualDeleteCount;
        to = k + insertCount;
        if (from4 in O)
          O[to] = O[from4];
        else
          deletePropertyOrThrow$1(O, to);
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--)
        deletePropertyOrThrow$1(O, k - 1);
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from4 = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from4 in O)
          O[to] = O[from4];
        else
          deletePropertyOrThrow$1(O, to);
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    setArrayLength(O, len - actualDeleteCount + insertCount);
    return A;
  }
});
/*
@license
The following license applies to all parts of this software except as
documented below.

    Copyright (c) 2016, Twilio, inc.
    All rights reserved.

    Redistribution and use in source and binary forms, with or without
    modification, are permitted provided that the following conditions are
    met:

      1. Redistributions of source code must retain the above copyright
         notice, this list of conditions and the following disclaimer.

      2. Redistributions in binary form must reproduce the above copyright
         notice, this list of conditions and the following disclaimer in
         the documentation and/or other materials provided with the
         distribution.

      3. Neither the name of Twilio nor the names of its contributors may
         be used to endorse or promote products derived from this software
         without specific prior written permission.

    THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
    "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
    LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
    A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
    HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
    SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
    LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
    DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
    THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
    (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
    OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

This software includes javascript-state-machine under the following license.

    Copyright (c) 2012, 2013, 2014, 2015, Jake Gordon and contributors

    Permission is hereby granted, free of charge, to any person obtaining a copy
    of this software and associated documentation files (the "Software"), to deal
    in the Software without restriction, including without limitation the rights
    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
    copies of the Software, and to permit persons to whom the Software is
    furnished to do so, subject to the following conditions:

    The above copyright notice and this permission notice shall be included in all
    copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE

This software includes loglevel under the following license.

    Copyright (c) 2013 Tim Perry

    Permission is hereby granted, free of charge, to any person
    obtaining a copy of this software and associated documentation
    files (the "Software"), to deal in the Software without
    restriction, including without limitation the rights to use,
    copy, modify, merge, publish, distribute, sublicense, and/or sell
    copies of the Software, and to permit persons to whom the
    Software is furnished to do so, subject to the following
    conditions:

    The above copyright notice and this permission notice shall be
    included in all copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
    EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
    OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
    NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
    HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
    WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
    FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
    OTHER DEALINGS IN THE SOFTWARE.


*/
(function(exports) {
  var global2 = typeof global2 !== "undefined" ? global2 : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {};
  Object.defineProperty(exports, "__esModule", { value: true });
  var _asyncToGenerator2 = asyncToGeneratorExports;
  var _createClass2 = createClassExports;
  var _assertThisInitialized2 = assertThisInitializedExports;
  var _get2 = getExports;
  var _inherits2 = inheritsExports;
  var _possibleConstructorReturn2 = possibleConstructorReturnExports;
  var _getPrototypeOf2 = getPrototypeOfExports;
  var _classCallCheck2 = classCallCheckExports;
  var _defineProperty2 = definePropertyExports;
  var _regeneratorRuntime2 = regenerator;
  var _typeof2 = _typeofExports;
  var declarativeTypeValidator2 = browser$5;
  var loglevelLog2 = loglevelExports$1;
  var StateMachine = stateMachineExports;
  var uuid2 = uuid_1;
  var _wrapNativeSuper2 = wrapNativeSuperExports;
  var operationRetrier2 = browser$7;
  var platform2 = platformExports;
  function _interopDefaultLegacy2(e) {
    return e && typeof e === "object" && "default" in e ? e : { "default": e };
  }
  function _interopNamespace2(e) {
    if (e && e.__esModule)
      return e;
    var n = /* @__PURE__ */ Object.create(null);
    if (e) {
      Object.keys(e).forEach(function(k) {
        if (k !== "default") {
          var d = Object.getOwnPropertyDescriptor(e, k);
          Object.defineProperty(n, k, d.get ? d : {
            enumerable: true,
            get: function() {
              return e[k];
            }
          });
        }
      });
    }
    n["default"] = e;
    return Object.freeze(n);
  }
  var _asyncToGenerator__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_asyncToGenerator2);
  var _createClass__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_createClass2);
  var _assertThisInitialized__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_assertThisInitialized2);
  var _get__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_get2);
  var _inherits__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_inherits2);
  var _possibleConstructorReturn__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_possibleConstructorReturn2);
  var _getPrototypeOf__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_getPrototypeOf2);
  var _classCallCheck__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_classCallCheck2);
  var _defineProperty__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_defineProperty2);
  var _regeneratorRuntime__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_regeneratorRuntime2);
  var _typeof__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_typeof2);
  var loglevelLog__namespace2 = /* @__PURE__ */ _interopNamespace2(loglevelLog2);
  var StateMachine__namespace = /* @__PURE__ */ _interopNamespace2(StateMachine);
  var _wrapNativeSuper__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_wrapNativeSuper2);
  var platform__namespace2 = /* @__PURE__ */ _interopNamespace2(platform2);
  function __decorate2(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof__default2["default"](Reflect)) === "object" && typeof Reflect.decorate === "function")
      r = Reflect.decorate(decorators, target, key, desc);
    else
      for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i])
          r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
      }
    return c > 3 && r && Object.defineProperty(target, key, r), r;
  }
  function __metadata2(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof__default2["default"](Reflect)) === "object" && typeof Reflect.metadata === "function")
      return Reflect.metadata(metadataKey, metadataValue);
  }
  var domain2;
  function EventHandlers2() {
  }
  EventHandlers2.prototype = /* @__PURE__ */ Object.create(null);
  function EventEmitter2() {
    EventEmitter2.init.call(this);
  }
  EventEmitter2.EventEmitter = EventEmitter2;
  EventEmitter2.usingDomains = false;
  EventEmitter2.prototype.domain = void 0;
  EventEmitter2.prototype._events = void 0;
  EventEmitter2.prototype._maxListeners = void 0;
  EventEmitter2.defaultMaxListeners = 10;
  EventEmitter2.init = function() {
    this.domain = null;
    if (EventEmitter2.usingDomains) {
      if (domain2.active)
        ;
    }
    if (!this._events || this._events === Object.getPrototypeOf(this)._events) {
      this._events = new EventHandlers2();
      this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || void 0;
  };
  EventEmitter2.prototype.setMaxListeners = function setMaxListeners4(n) {
    if (typeof n !== "number" || n < 0 || isNaN(n))
      throw new TypeError('"n" argument must be a positive number');
    this._maxListeners = n;
    return this;
  };
  function $getMaxListeners2(that) {
    if (that._maxListeners === void 0)
      return EventEmitter2.defaultMaxListeners;
    return that._maxListeners;
  }
  EventEmitter2.prototype.getMaxListeners = function getMaxListeners4() {
    return $getMaxListeners2(this);
  };
  function emitNone2(handler, isFn, self2) {
    if (isFn)
      handler.call(self2);
    else {
      var len = handler.length;
      var listeners4 = arrayClone2(handler, len);
      for (var i = 0; i < len; ++i)
        listeners4[i].call(self2);
    }
  }
  function emitOne2(handler, isFn, self2, arg1) {
    if (isFn)
      handler.call(self2, arg1);
    else {
      var len = handler.length;
      var listeners4 = arrayClone2(handler, len);
      for (var i = 0; i < len; ++i)
        listeners4[i].call(self2, arg1);
    }
  }
  function emitTwo2(handler, isFn, self2, arg1, arg2) {
    if (isFn)
      handler.call(self2, arg1, arg2);
    else {
      var len = handler.length;
      var listeners4 = arrayClone2(handler, len);
      for (var i = 0; i < len; ++i)
        listeners4[i].call(self2, arg1, arg2);
    }
  }
  function emitThree2(handler, isFn, self2, arg1, arg2, arg3) {
    if (isFn)
      handler.call(self2, arg1, arg2, arg3);
    else {
      var len = handler.length;
      var listeners4 = arrayClone2(handler, len);
      for (var i = 0; i < len; ++i)
        listeners4[i].call(self2, arg1, arg2, arg3);
    }
  }
  function emitMany2(handler, isFn, self2, args) {
    if (isFn)
      handler.apply(self2, args);
    else {
      var len = handler.length;
      var listeners4 = arrayClone2(handler, len);
      for (var i = 0; i < len; ++i)
        listeners4[i].apply(self2, args);
    }
  }
  EventEmitter2.prototype.emit = function emit4(type5) {
    var er, handler, len, args, i, events, domain3;
    var doError = type5 === "error";
    events = this._events;
    if (events)
      doError = doError && events.error == null;
    else if (!doError)
      return false;
    domain3 = this.domain;
    if (doError) {
      er = arguments[1];
      if (domain3) {
        if (!er)
          er = new Error('Uncaught, unspecified "error" event');
        er.domainEmitter = this;
        er.domain = domain3;
        er.domainThrown = false;
        domain3.emit("error", er);
      } else if (er instanceof Error) {
        throw er;
      } else {
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ")");
        err.context = er;
        throw err;
      }
      return false;
    }
    handler = events[type5];
    if (!handler)
      return false;
    var isFn = typeof handler === "function";
    len = arguments.length;
    switch (len) {
      case 1:
        emitNone2(handler, isFn, this);
        break;
      case 2:
        emitOne2(handler, isFn, this, arguments[1]);
        break;
      case 3:
        emitTwo2(handler, isFn, this, arguments[1], arguments[2]);
        break;
      case 4:
        emitThree2(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
        break;
      default:
        args = new Array(len - 1);
        for (i = 1; i < len; i++)
          args[i - 1] = arguments[i];
        emitMany2(handler, isFn, this, args);
    }
    return true;
  };
  function _addListener2(target, type5, listener, prepend) {
    var m;
    var events;
    var existing;
    if (typeof listener !== "function")
      throw new TypeError('"listener" argument must be a function');
    events = target._events;
    if (!events) {
      events = target._events = new EventHandlers2();
      target._eventsCount = 0;
    } else {
      if (events.newListener) {
        target.emit(
          "newListener",
          type5,
          listener.listener ? listener.listener : listener
        );
        events = target._events;
      }
      existing = events[type5];
    }
    if (!existing) {
      existing = events[type5] = listener;
      ++target._eventsCount;
    } else {
      if (typeof existing === "function") {
        existing = events[type5] = prepend ? [listener, existing] : [existing, listener];
      } else {
        if (prepend) {
          existing.unshift(listener);
        } else {
          existing.push(listener);
        }
      }
      if (!existing.warned) {
        m = $getMaxListeners2(target);
        if (m && m > 0 && existing.length > m) {
          existing.warned = true;
          var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + type5 + " listeners added. Use emitter.setMaxListeners() to increase limit");
          w.name = "MaxListenersExceededWarning";
          w.emitter = target;
          w.type = type5;
          w.count = existing.length;
          emitWarning2(w);
        }
      }
    }
    return target;
  }
  function emitWarning2(e) {
    typeof console.warn === "function" ? console.warn(e) : console.log(e);
  }
  EventEmitter2.prototype.addListener = function addListener4(type5, listener) {
    return _addListener2(this, type5, listener, false);
  };
  EventEmitter2.prototype.on = EventEmitter2.prototype.addListener;
  EventEmitter2.prototype.prependListener = function prependListener4(type5, listener) {
    return _addListener2(this, type5, listener, true);
  };
  function _onceWrap2(target, type5, listener) {
    var fired = false;
    function g() {
      target.removeListener(type5, g);
      if (!fired) {
        fired = true;
        listener.apply(target, arguments);
      }
    }
    g.listener = listener;
    return g;
  }
  EventEmitter2.prototype.once = function once4(type5, listener) {
    if (typeof listener !== "function")
      throw new TypeError('"listener" argument must be a function');
    this.on(type5, _onceWrap2(this, type5, listener));
    return this;
  };
  EventEmitter2.prototype.prependOnceListener = function prependOnceListener4(type5, listener) {
    if (typeof listener !== "function")
      throw new TypeError('"listener" argument must be a function');
    this.prependListener(type5, _onceWrap2(this, type5, listener));
    return this;
  };
  EventEmitter2.prototype.removeListener = function removeListener4(type5, listener) {
    var list, events, position, i, originalListener;
    if (typeof listener !== "function")
      throw new TypeError('"listener" argument must be a function');
    events = this._events;
    if (!events)
      return this;
    list = events[type5];
    if (!list)
      return this;
    if (list === listener || list.listener && list.listener === listener) {
      if (--this._eventsCount === 0)
        this._events = new EventHandlers2();
      else {
        delete events[type5];
        if (events.removeListener)
          this.emit("removeListener", type5, list.listener || listener);
      }
    } else if (typeof list !== "function") {
      position = -1;
      for (i = list.length; i-- > 0; ) {
        if (list[i] === listener || list[i].listener && list[i].listener === listener) {
          originalListener = list[i].listener;
          position = i;
          break;
        }
      }
      if (position < 0)
        return this;
      if (list.length === 1) {
        list[0] = void 0;
        if (--this._eventsCount === 0) {
          this._events = new EventHandlers2();
          return this;
        } else {
          delete events[type5];
        }
      } else {
        spliceOne2(list, position);
      }
      if (events.removeListener)
        this.emit("removeListener", type5, originalListener || listener);
    }
    return this;
  };
  EventEmitter2.prototype.off = function(type5, listener) {
    return this.removeListener(type5, listener);
  };
  EventEmitter2.prototype.removeAllListeners = function removeAllListeners4(type5) {
    var listeners4, events;
    events = this._events;
    if (!events)
      return this;
    if (!events.removeListener) {
      if (arguments.length === 0) {
        this._events = new EventHandlers2();
        this._eventsCount = 0;
      } else if (events[type5]) {
        if (--this._eventsCount === 0)
          this._events = new EventHandlers2();
        else
          delete events[type5];
      }
      return this;
    }
    if (arguments.length === 0) {
      var keys6 = Object.keys(events);
      for (var i = 0, key; i < keys6.length; ++i) {
        key = keys6[i];
        if (key === "removeListener")
          continue;
        this.removeAllListeners(key);
      }
      this.removeAllListeners("removeListener");
      this._events = new EventHandlers2();
      this._eventsCount = 0;
      return this;
    }
    listeners4 = events[type5];
    if (typeof listeners4 === "function") {
      this.removeListener(type5, listeners4);
    } else if (listeners4) {
      do {
        this.removeListener(type5, listeners4[listeners4.length - 1]);
      } while (listeners4[0]);
    }
    return this;
  };
  EventEmitter2.prototype.listeners = function listeners4(type5) {
    var evlistener;
    var ret;
    var events = this._events;
    if (!events)
      ret = [];
    else {
      evlistener = events[type5];
      if (!evlistener)
        ret = [];
      else if (typeof evlistener === "function")
        ret = [evlistener.listener || evlistener];
      else
        ret = unwrapListeners2(evlistener);
    }
    return ret;
  };
  EventEmitter2.listenerCount = function(emitter, type5) {
    if (typeof emitter.listenerCount === "function") {
      return emitter.listenerCount(type5);
    } else {
      return listenerCount2.call(emitter, type5);
    }
  };
  EventEmitter2.prototype.listenerCount = listenerCount2;
  function listenerCount2(type5) {
    var events = this._events;
    if (events) {
      var evlistener = events[type5];
      if (typeof evlistener === "function") {
        return 1;
      } else if (evlistener) {
        return evlistener.length;
      }
    }
    return 0;
  }
  EventEmitter2.prototype.eventNames = function eventNames4() {
    return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
  };
  function spliceOne2(list, index2) {
    for (var i = index2, k = i + 1, n = list.length; k < n; i += 1, k += 1)
      list[i] = list[k];
    list.pop();
  }
  function arrayClone2(arr, i) {
    var copy = new Array(i);
    while (i--)
      copy[i] = arr[i];
    return copy;
  }
  function unwrapListeners2(arr) {
    var ret = new Array(arr.length);
    for (var i = 0; i < ret.length; ++i) {
      ret[i] = arr[i].listener || arr[i];
    }
    return ret;
  }
  var log2 = loglevelLog__namespace2.getLogger("twilsock");
  function prepareLine2(prefix, args) {
    return ["".concat((/* @__PURE__ */ new Date()).toISOString(), " Twilsock ").concat(prefix, ":")].concat(Array.from(args));
  }
  var Logger = /* @__PURE__ */ function() {
    function Logger2(prefix) {
      _classCallCheck__default2["default"](this, Logger2);
      _defineProperty__default2["default"](this, "prefix", "");
      this.prefix = prefix !== null && prefix !== void 0 && prefix.length > 0 ? " " + prefix + ":" : "";
    }
    _createClass__default2["default"](Logger2, [{
      key: "setLevel",
      value: function setLevel2(level) {
        log2.setLevel(level);
      }
    }, {
      key: "trace",
      value: function trace2() {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        log2.trace.apply(null, prepareLine2("T", args));
      }
    }, {
      key: "debug",
      value: function debug3() {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        log2.debug.apply(null, prepareLine2("D", args));
      }
    }, {
      key: "info",
      value: function info2() {
        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }
        log2.info.apply(null, prepareLine2("I", args));
      }
    }, {
      key: "warn",
      value: function warn2() {
        for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          args[_key4] = arguments[_key4];
        }
        log2.warn.apply(null, prepareLine2("W", args));
      }
    }, {
      key: "error",
      value: function error2() {
        for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
          args[_key5] = arguments[_key5];
        }
        log2.error.apply(null, prepareLine2("E", args));
      }
    }], [{
      key: "setLevel",
      value: function setLevel2(level) {
        log2.setLevel(level);
      }
    }, {
      key: "trace",
      value: function trace2() {
        for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
          args[_key6] = arguments[_key6];
        }
        log2.trace.apply(null, prepareLine2("T", args));
      }
    }, {
      key: "debug",
      value: function debug3() {
        for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
          args[_key7] = arguments[_key7];
        }
        log2.debug.apply(null, prepareLine2("D", args));
      }
    }, {
      key: "info",
      value: function info2() {
        for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
          args[_key8] = arguments[_key8];
        }
        log2.info.apply(null, prepareLine2("I", args));
      }
    }, {
      key: "warn",
      value: function warn2() {
        for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
          args[_key9] = arguments[_key9];
        }
        log2.warn.apply(null, prepareLine2("W", args));
      }
    }, {
      key: "error",
      value: function error2() {
        for (var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
          args[_key10] = arguments[_key10];
        }
        log2.error.apply(null, prepareLine2("E", args));
      }
    }]);
    return Logger2;
  }();
  var logInstance = new Logger("");
  var version2 = "0.12.2";
  var Configuration2 = /* @__PURE__ */ function() {
    function Configuration3(token, activeGrant, options) {
      _classCallCheck__default2["default"](this, Configuration3);
      _defineProperty__default2["default"](this, "confirmedCapabilities", /* @__PURE__ */ new Set());
      this.activeGrant = activeGrant;
      this._token = token;
      var region = options.region || "us1";
      var defaultTwilsockUrl = "wss://tsock.".concat(region, ".twilio.com/v3/wsconnect");
      var twilsockOptions = options.twilsock || options.Twilsock || {};
      this.url = twilsockOptions.uri || defaultTwilsockUrl;
      this._continuationToken = options.continuationToken ? options.continuationToken : null;
      this.logLevel = options.logLevel ? options.logLevel : "error";
      this.retryPolicy = options.retryPolicy ? options.retryPolicy : {
        min: 1 * 1e3,
        max: 2 * 60 * 1e3,
        randomness: 0.2
      };
      this.clientMetadata = options.clientMetadata ? options.clientMetadata : {};
      this.clientMetadata.ver = version2;
      this.initRegistrations = options.initRegistrations ? options.initRegistrations : null;
      this.tweaks = options.tweaks ? options.tweaks : null;
    }
    _createClass__default2["default"](Configuration3, [{
      key: "token",
      get: function get3() {
        return this._token;
      }
    }, {
      key: "continuationToken",
      get: function get3() {
        return this._continuationToken;
      }
    }, {
      key: "updateToken",
      value: function updateToken(token) {
        this._token = token;
      }
    }, {
      key: "updateContinuationToken",
      value: function updateContinuationToken(continuationToken) {
        this._continuationToken = continuationToken;
      }
    }]);
    return Configuration3;
  }();
  var AbstractMessage = function AbstractMessage2(id2) {
    _classCallCheck__default2["default"](this, AbstractMessage2);
    this.id = id2 || "TM".concat(uuid2.v4());
  };
  function _createSuper$f(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$f();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf__default2["default"](Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf__default2["default"](this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn__default2["default"](this, result);
    };
  }
  function _isNativeReflectConstruct$f() {
    if (typeof Reflect === "undefined" || !Reflect.construct)
      return false;
    if (Reflect.construct.sham)
      return false;
    if (typeof Proxy === "function")
      return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  var Init = /* @__PURE__ */ function(_AbstractMessage) {
    _inherits__default2["default"](Init2, _AbstractMessage);
    var _super = _createSuper$f(Init2);
    function Init2(token, continuationToken, metadata, registrations, tweaks) {
      var _this;
      _classCallCheck__default2["default"](this, Init2);
      _this = _super.call(this);
      _defineProperty__default2["default"](_assertThisInitialized__default2["default"](_this), "method", "init");
      _this.token = token;
      _this.continuation_token = continuationToken;
      _this.metadata = metadata;
      _this.registrations = registrations;
      _this.tweaks = tweaks;
      _this.capabilities = ["client_update", "offline_storage", "telemetry.v1"];
      return _this;
    }
    return Init2;
  }(AbstractMessage);
  function _createSuper$e(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$e();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf__default2["default"](Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf__default2["default"](this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn__default2["default"](this, result);
    };
  }
  function _isNativeReflectConstruct$e() {
    if (typeof Reflect === "undefined" || !Reflect.construct)
      return false;
    if (Reflect.construct.sham)
      return false;
    if (typeof Proxy === "function")
      return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  var InitReply = /* @__PURE__ */ function(_AbstractMessage) {
    _inherits__default2["default"](InitReply2, _AbstractMessage);
    var _super = _createSuper$e(InitReply2);
    function InitReply2(id2, continuationToken, confirmedCapabilities, continuationTokenStatus, offlineStorage, initRegistrations, debugInfo) {
      var _this;
      _classCallCheck__default2["default"](this, InitReply2);
      _this = _super.call(this, id2);
      _this.continuationToken = continuationToken;
      _this.continuationTokenStatus = continuationTokenStatus;
      _this.offlineStorage = offlineStorage;
      _this.initRegistrations = initRegistrations;
      _this.debugInfo = debugInfo;
      _this.confirmedCapabilities = confirmedCapabilities;
      return _this;
    }
    return InitReply2;
  }(AbstractMessage);
  function _createSuper$d(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$d();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf__default2["default"](Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf__default2["default"](this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn__default2["default"](this, result);
    };
  }
  function _isNativeReflectConstruct$d() {
    if (typeof Reflect === "undefined" || !Reflect.construct)
      return false;
    if (Reflect.construct.sham)
      return false;
    if (typeof Proxy === "function")
      return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  var Update = /* @__PURE__ */ function(_AbstractMessage) {
    _inherits__default2["default"](Update2, _AbstractMessage);
    var _super = _createSuper$d(Update2);
    function Update2(token) {
      var _this;
      _classCallCheck__default2["default"](this, Update2);
      _this = _super.call(this);
      _defineProperty__default2["default"](_assertThisInitialized__default2["default"](_this), "method", "update");
      _this.token = token;
      return _this;
    }
    return Update2;
  }(AbstractMessage);
  function _createSuper$c2(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$c2();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf__default2["default"](Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf__default2["default"](this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn__default2["default"](this, result);
    };
  }
  function _isNativeReflectConstruct$c2() {
    if (typeof Reflect === "undefined" || !Reflect.construct)
      return false;
    if (Reflect.construct.sham)
      return false;
    if (typeof Proxy === "function")
      return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  var Message = /* @__PURE__ */ function(_AbstractMessage) {
    _inherits__default2["default"](Message2, _AbstractMessage);
    var _super = _createSuper$c2(Message2);
    function Message2(grant, contentType, request) {
      var _this;
      _classCallCheck__default2["default"](this, Message2);
      _this = _super.call(this);
      _defineProperty__default2["default"](_assertThisInitialized__default2["default"](_this), "method", "message");
      _this.active_grant = grant;
      _this.payload_type = contentType;
      _this.http_request = request;
      return _this;
    }
    return Message2;
  }(AbstractMessage);
  function _createSuper$b2(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$b2();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf__default2["default"](Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf__default2["default"](this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn__default2["default"](this, result);
    };
  }
  function _isNativeReflectConstruct$b2() {
    if (typeof Reflect === "undefined" || !Reflect.construct)
      return false;
    if (Reflect.construct.sham)
      return false;
    if (typeof Proxy === "function")
      return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  var Reply = /* @__PURE__ */ function(_AbstractMessage) {
    _inherits__default2["default"](Reply2, _AbstractMessage);
    var _super = _createSuper$b2(Reply2);
    function Reply2(id2) {
      var _this;
      _classCallCheck__default2["default"](this, Reply2);
      _this = _super.call(this, id2);
      _defineProperty__default2["default"](_assertThisInitialized__default2["default"](_this), "method", "reply");
      _defineProperty__default2["default"](_assertThisInitialized__default2["default"](_this), "payload_type", "application/json");
      _defineProperty__default2["default"](_assertThisInitialized__default2["default"](_this), "status", {
        code: 200,
        status: "OK"
      });
      return _this;
    }
    return Reply2;
  }(AbstractMessage);
  function _createSuper$a2(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$a2();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf__default2["default"](Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf__default2["default"](this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn__default2["default"](this, result);
    };
  }
  function _isNativeReflectConstruct$a2() {
    if (typeof Reflect === "undefined" || !Reflect.construct)
      return false;
    if (Reflect.construct.sham)
      return false;
    if (typeof Proxy === "function")
      return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  var Close = /* @__PURE__ */ function(_AbstractMessage) {
    _inherits__default2["default"](Close2, _AbstractMessage);
    var _super = _createSuper$a2(Close2);
    function Close2() {
      var _this;
      _classCallCheck__default2["default"](this, Close2);
      _this = _super.call(this);
      _defineProperty__default2["default"](_assertThisInitialized__default2["default"](_this), "method", "close");
      return _this;
    }
    return Close2;
  }(AbstractMessage);
  function _createSuper$92(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$92();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf__default2["default"](Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf__default2["default"](this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn__default2["default"](this, result);
    };
  }
  function _isNativeReflectConstruct$92() {
    if (typeof Reflect === "undefined" || !Reflect.construct)
      return false;
    if (Reflect.construct.sham)
      return false;
    if (typeof Proxy === "function")
      return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  var TelemetryEvent = function TelemetryEvent2(start, end2, title, details, id2, type5) {
    _classCallCheck__default2["default"](this, TelemetryEvent2);
    this.start = start;
    this.end = end2;
    this.title = title;
    this.details = details;
    this.id = id2;
    this.type = type5;
  };
  var Telemetry = /* @__PURE__ */ function(_AbstractMessage) {
    _inherits__default2["default"](Telemetry2, _AbstractMessage);
    var _super = _createSuper$92(Telemetry2);
    function Telemetry2(events) {
      var _this;
      _classCallCheck__default2["default"](this, Telemetry2);
      _this = _super.call(this);
      _defineProperty__default2["default"](_assertThisInitialized__default2["default"](_this), "method", "telemetry.v1");
      _this.events = events;
      return _this;
    }
    return Telemetry2;
  }(AbstractMessage);
  function byteLength(s) {
    var escstr = encodeURIComponent(s);
    var binstr = escstr.replace(/%([0-9A-F]{2})/g, function(match2, p1) {
      return String.fromCharCode(Number("0x" + p1));
    });
    return binstr.length;
  }
  function stringToUint8Array(s) {
    var escstr = encodeURIComponent(s);
    var binstr = escstr.replace(/%([0-9A-F]{2})/g, function(match2, p1) {
      return String.fromCharCode(Number("0x" + p1));
    });
    var ua = new Uint8Array(binstr.length);
    Array.prototype.forEach.call(binstr, function(ch, i) {
      ua[i] = ch.charCodeAt(0);
    });
    return ua;
  }
  function uint8ArrayToString(ua) {
    var binstr = Array.prototype.map.call(ua, function(ch) {
      return String.fromCharCode(ch);
    }).join("");
    var escstr = binstr.replace(/(.)/g, function(m, p) {
      var code = p.charCodeAt(0).toString(16).toUpperCase();
      if (code.length < 2) {
        code = "0" + code;
      }
      return "%" + code;
    });
    return decodeURIComponent(escstr);
  }
  function getJsonObject(array5) {
    return JSON.parse(uint8ArrayToString(array5));
  }
  function getMagic(buffer) {
    var strMagic = "";
    var idx = 0;
    for (; idx < buffer.length; ++idx) {
      var chr = String.fromCharCode(buffer[idx]);
      strMagic += chr;
      if (chr === "\r") {
        idx += 2;
        break;
      }
    }
    var magics = strMagic.split(" ");
    return {
      size: idx,
      protocol: magics[0],
      version: magics[1],
      headerSize: Number(magics[2])
    };
  }
  var Parser = /* @__PURE__ */ function() {
    function Parser2() {
      _classCallCheck__default2["default"](this, Parser2);
    }
    _createClass__default2["default"](Parser2, null, [{
      key: "parse",
      value: function parse2(message) {
        var fieldMargin = 2;
        var dataView = new Uint8Array(message);
        var magic = getMagic(dataView);
        if (magic.protocol !== "TWILSOCK" || magic.version !== "V3.0") {
          logInstance.error("unsupported protocol: ".concat(magic.protocol, " ver ").concat(magic.version));
          return null;
        }
        var header;
        try {
          header = getJsonObject(dataView.subarray(magic.size, magic.size + magic.headerSize));
        } catch (e) {
          logInstance.error("failed to parse message header", e, message);
          return null;
        }
        logInstance.debug("message received: ", header.method);
        logInstance.trace("message received: ", header);
        var payload;
        if (header.payload_size > 0) {
          var payloadOffset = fieldMargin + magic.size + magic.headerSize;
          var payloadSize = header.payload_size;
          if (!header.hasOwnProperty("payload_type") || header.payload_type.indexOf("application/json") === 0) {
            try {
              payload = getJsonObject(dataView.subarray(payloadOffset, payloadOffset + payloadSize));
            } catch (e) {
              logInstance.error("failed to parse message body", e, message);
              return null;
            }
          } else if (header.payload_type.indexOf("text/plain") === 0) {
            payload = uint8ArrayToString(dataView.subarray(payloadOffset, payloadOffset + payloadSize));
          }
        }
        return {
          method: header.method,
          header,
          payload
        };
      }
    }, {
      key: "createPacket",
      value: function createPacket(header) {
        var payloadString = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        header.payload_size = byteLength(payloadString);
        var headerString = JSON.stringify(header);
        var magicString = "TWILSOCK V3.0 " + byteLength(headerString);
        logInstance.debug("send request:", magicString + headerString + payloadString);
        var message = stringToUint8Array(magicString + "\r\n" + headerString + "\r\n" + payloadString);
        return message.buffer;
      }
    }]);
    return Parser2;
  }();
  function _createSuper$82(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$82();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf__default2["default"](Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf__default2["default"](this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn__default2["default"](this, result);
    };
  }
  function _isNativeReflectConstruct$82() {
    if (typeof Reflect === "undefined" || !Reflect.construct)
      return false;
    if (Reflect.construct.sham)
      return false;
    if (typeof Proxy === "function")
      return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  var TwilsockError = /* @__PURE__ */ function(_Error) {
    _inherits__default2["default"](TwilsockError2, _Error);
    var _super = _createSuper$82(TwilsockError2);
    function TwilsockError2(description) {
      _classCallCheck__default2["default"](this, TwilsockError2);
      return _super.call(this, description);
    }
    return TwilsockError2;
  }(/* @__PURE__ */ _wrapNativeSuper__default2["default"](Error));
  function _createSuper$72(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$72();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf__default2["default"](Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf__default2["default"](this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn__default2["default"](this, result);
    };
  }
  function _isNativeReflectConstruct$72() {
    if (typeof Reflect === "undefined" || !Reflect.construct)
      return false;
    if (Reflect.construct.sham)
      return false;
    if (typeof Proxy === "function")
      return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  var TwilsockReplyError = /* @__PURE__ */ function(_TwilsockError) {
    _inherits__default2["default"](TwilsockReplyError2, _TwilsockError);
    var _super = _createSuper$72(TwilsockReplyError2);
    function TwilsockReplyError2(description, reply) {
      var _this;
      _classCallCheck__default2["default"](this, TwilsockReplyError2);
      _this = _super.call(this, description);
      _this.reply = reply;
      return _this;
    }
    return TwilsockReplyError2;
  }(TwilsockError);
  function ownKeys3(object, enumerableOnly) {
    var keys6 = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) {
        symbols = symbols.filter(function(sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }
      keys6.push.apply(keys6, symbols);
    }
    return keys6;
  }
  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      if (i % 2) {
        ownKeys3(Object(source), true).forEach(function(key) {
          _defineProperty__default2["default"](target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys3(Object(source)).forEach(function(key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }
    return target;
  }
  function _createSuper$62(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$62();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf__default2["default"](Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf__default2["default"](this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn__default2["default"](this, result);
    };
  }
  function _isNativeReflectConstruct$62() {
    if (typeof Reflect === "undefined" || !Reflect.construct)
      return false;
    if (Reflect.construct.sham)
      return false;
    if (typeof Proxy === "function")
      return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  var BackoffRetrier = /* @__PURE__ */ function(_EventEmitter) {
    _inherits__default2["default"](BackoffRetrier2, _EventEmitter);
    var _super = _createSuper$62(BackoffRetrier2);
    function BackoffRetrier2(options) {
      var _this;
      _classCallCheck__default2["default"](this, BackoffRetrier2);
      _this = _super.call(this);
      _defineProperty__default2["default"](_assertThisInitialized__default2["default"](_this), "newBackoff", null);
      _defineProperty__default2["default"](_assertThisInitialized__default2["default"](_this), "usedBackoff", null);
      _defineProperty__default2["default"](_assertThisInitialized__default2["default"](_this), "retrier", null);
      _this.options = options ? _objectSpread2({}, options) : {};
      return _this;
    }
    _createClass__default2["default"](BackoffRetrier2, [{
      key: "inProgress",
      get: function get3() {
        return !!this.retrier;
      }
    }, {
      key: "start",
      value: function start() {
        if (this.inProgress) {
          throw new Error("Already waiting for next attempt, call finishAttempt(success : boolean) to finish it");
        }
        this.createRetrier();
      }
      /**
       * Should be called to stop retrier entirely.
       */
    }, {
      key: "stop",
      value: function stop() {
        this.cleanRetrier();
        this.newBackoff = null;
        this.usedBackoff = null;
      }
      /**
       * Modifies backoff for next attempt.
       * Expected behavior:
       * - If there was no backoff passed previously reschedulling next attempt to given backoff
       * - If previous backoff was longer then ignoring this one.
       * - If previous backoff was shorter then reschedulling with this one.
       * With or without backoff retrier will keep growing normally.
       * @param delay delay of next attempts in ms.
       */
    }, {
      key: "modifyBackoff",
      value: function modifyBackoff(delay) {
        this.newBackoff = delay;
      }
      /**
       * Mark last emmited attempt as failed, initiating either next of fail if limits were hit.
       */
    }, {
      key: "attemptFailed",
      value: function attemptFailed() {
        if (!this.inProgress) {
          throw new Error("No attempt is in progress");
        }
        if (this.newBackoff) {
          var shouldUseNewBackoff = !this.usedBackoff || this.usedBackoff < this.newBackoff;
          if (shouldUseNewBackoff) {
            this.createRetrier();
          } else {
            var _this$retrier;
            (_this$retrier = this.retrier) === null || _this$retrier === void 0 ? void 0 : _this$retrier.failed(new Error());
          }
        } else {
          var _this$retrier2;
          (_this$retrier2 = this.retrier) === null || _this$retrier2 === void 0 ? void 0 : _this$retrier2.failed(new Error());
        }
      }
    }, {
      key: "cancel",
      value: function cancel() {
        var _this$retrier3;
        (_this$retrier3 = this.retrier) === null || _this$retrier3 === void 0 ? void 0 : _this$retrier3.cancel();
      }
    }, {
      key: "cleanRetrier",
      value: function cleanRetrier() {
        var _this$retrier4, _this$retrier5;
        (_this$retrier4 = this.retrier) === null || _this$retrier4 === void 0 ? void 0 : _this$retrier4.removeAllListeners();
        (_this$retrier5 = this.retrier) === null || _this$retrier5 === void 0 ? void 0 : _this$retrier5.cancel();
        this.retrier = null;
      }
    }, {
      key: "getRetryPolicy",
      value: function getRetryPolicy() {
        var clone = _objectSpread2({}, this.options);
        if (this.newBackoff) {
          clone.min = this.newBackoff;
          clone.max = this.options.max && this.options.max > this.newBackoff ? this.options.max : this.newBackoff;
        }
        clone.maxAttemptsCount = this.options.maxAttemptsCount ? this.options.maxAttemptsCount + 1 : void 0;
        return clone;
      }
    }, {
      key: "createRetrier",
      value: function createRetrier() {
        var _this2 = this;
        this.cleanRetrier();
        var retryPolicy = this.getRetryPolicy();
        this.retrier = new operationRetrier2.Retrier(retryPolicy);
        this.retrier.once("attempt", function() {
          var _this2$retrier, _this2$retrier2;
          (_this2$retrier = _this2.retrier) === null || _this2$retrier === void 0 ? void 0 : _this2$retrier.on("attempt", function() {
            return _this2.emit("attempt");
          });
          (_this2$retrier2 = _this2.retrier) === null || _this2$retrier2 === void 0 ? void 0 : _this2$retrier2.failed(new Error("Skipping first attempt"));
        });
        this.retrier.on("failed", function(err) {
          return _this2.emit("failed", err);
        });
        this.usedBackoff = this.newBackoff;
        this.newBackoff = null;
        this.retrier.start();
      }
    }]);
    return BackoffRetrier2;
  }(EventEmitter2);
  function _createSuper$52(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$52();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf__default2["default"](Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf__default2["default"](this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn__default2["default"](this, result);
    };
  }
  function _isNativeReflectConstruct$52() {
    if (typeof Reflect === "undefined" || !Reflect.construct)
      return false;
    if (Reflect.construct.sham)
      return false;
    if (typeof Proxy === "function")
      return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  var DISCONNECTING_TIMEOUT = 3e3;
  function trampoline(f) {
    setTimeout(f, 0);
  }
  var TwilsockChannel = /* @__PURE__ */ function(_EventEmitter) {
    _inherits__default2["default"](TwilsockChannel2, _EventEmitter);
    var _super = _createSuper$52(TwilsockChannel2);
    function TwilsockChannel2(websocket, transport, config) {
      var _this;
      _classCallCheck__default2["default"](this, TwilsockChannel2);
      _this = _super.call(this);
      _defineProperty__default2["default"](_assertThisInitialized__default2["default"](_this), "disconnectingTimer", null);
      _defineProperty__default2["default"](_assertThisInitialized__default2["default"](_this), "disconnectedPromiseResolve", null);
      _defineProperty__default2["default"](_assertThisInitialized__default2["default"](_this), "terminalStates", ["disconnected", "rejected"]);
      _defineProperty__default2["default"](_assertThisInitialized__default2["default"](_this), "tokenExpiredSasCode", 20104);
      _defineProperty__default2["default"](_assertThisInitialized__default2["default"](_this), "terminationReason", "Connection is not initialized");
      _this.websocket = websocket;
      _this.websocket.on("connected", function() {
        return _this.fsm.socketConnected();
      });
      _this.websocket.on("disconnected", function() {
        return _this.fsm.socketClosed();
      });
      _this.websocket.on("message", function(message) {
        return _this.onIncomingMessage(message);
      });
      _this.websocket.on("socketError", function(e) {
        return _this.emit("connectionError", {
          terminal: false,
          message: "Socket error: ".concat(e.message),
          httpStatusCode: null,
          errorCode: null
        });
      });
      _this.transport = transport;
      _this.config = config;
      _this.retrier = new BackoffRetrier(config.retryPolicy);
      _this.retrier.on("attempt", function() {
        return _this.retry();
      });
      _this.retrier.on("failed", function(err) {
        logInstance.warn("Retrying failed: ".concat(err.message));
        _this.disconnect();
      });
      if (typeof window !== "undefined" && typeof window.addEventListener !== "undefined") {
        window.addEventListener("online", function() {
          logInstance.debug("Browser reported connectivity state: online");
          _this.resetBackoff();
          _this.fsm.systemOnline();
        });
        window.addEventListener("offline", function() {
          logInstance.debug("Browser reported connectivity state: offline");
          _this.websocket.close();
          _this.fsm.socketClosed();
        });
      }
      var TwilsockStateMachine = StateMachine__namespace.factory({
        init: "disconnected",
        transitions: [{
          name: "userConnect",
          from: ["disconnected", "rejected"],
          to: "connecting"
        }, {
          name: "userConnect",
          from: ["connecting", "connected"]
        }, {
          name: "userDisconnect",
          from: ["connecting", "initialising", "connected", "updating", "retrying", "rejected", "waitSocketClosed", "waitOffloadSocketClosed"],
          to: "disconnecting"
        }, {
          name: "userRetry",
          from: ["retrying"],
          to: "connecting"
        }, {
          name: "socketConnected",
          from: ["connecting"],
          to: "initialising"
        }, {
          name: "socketClosed",
          from: ["connecting", "initialising", "connected", "updating", "error", "waitOffloadSocketClosed"],
          to: "retrying"
        }, {
          name: "socketClosed",
          from: ["disconnecting"],
          to: "disconnected"
        }, {
          name: "socketClosed",
          from: ["waitSocketClosed"],
          to: "disconnected"
        }, {
          name: "socketClosed",
          from: ["rejected"],
          to: "rejected"
        }, {
          name: "initSuccess",
          from: ["initialising"],
          to: "connected"
        }, {
          name: "initError",
          from: ["initialising"],
          to: "error"
        }, {
          name: "tokenRejected",
          from: ["initialising", "updating"],
          to: "rejected"
        }, {
          name: "protocolError",
          from: ["initialising", "connected", "updating"],
          to: "error"
        }, {
          name: "receiveClose",
          from: ["initialising", "connected", "updating"],
          to: "waitSocketClosed"
        }, {
          name: "receiveOffload",
          from: ["initialising", "connected", "updating"],
          to: "waitOffloadSocketClosed"
        }, {
          name: "unsupportedProtocol",
          from: ["initialising", "connected", "updating"],
          to: "unsupported"
        }, {
          name: "receiveFatalClose",
          from: ["initialising", "connected", "updating"],
          to: "unsupported"
        }, {
          name: "userUpdateToken",
          from: ["disconnected", "rejected", "connecting", "retrying"],
          to: "connecting"
        }, {
          name: "userUpdateToken",
          from: ["connected"],
          to: "updating"
        }, {
          name: "updateSuccess",
          from: ["updating"],
          to: "connected"
        }, {
          name: "updateError",
          from: ["updating"],
          to: "error"
        }, {
          name: "userSend",
          from: ["connected"],
          to: "connected"
        }, {
          name: "systemOnline",
          from: ["retrying"],
          to: "connecting"
        }],
        methods: {
          onConnecting: function onConnecting() {
            _this.setupSocket();
            _this.emit("connecting");
          },
          onEnterInitialising: function onEnterInitialising() {
            _this.sendInit();
          },
          onLeaveInitialising: function onLeaveInitialising() {
            _this.cancelInit();
          },
          onEnterUpdating: function onEnterUpdating() {
            _this.sendUpdate();
          },
          onLeaveUpdating: function onLeaveUpdating() {
            _this.cancelUpdate();
          },
          onEnterRetrying: function onEnterRetrying() {
            _this.initRetry();
            _this.emit("connecting");
          },
          onEnterConnected: function onEnterConnected() {
            _this.resetBackoff();
            _this.onConnected();
          },
          onUserUpdateToken: function onUserUpdateToken() {
            _this.resetBackoff();
          },
          onTokenRejected: function onTokenRejected() {
            _this.resetBackoff();
            _this.closeSocket(true);
            _this.finalizeSocket();
          },
          onUserDisconnect: function onUserDisconnect() {
            _this.closeSocket(true);
          },
          onEnterDisconnecting: function onEnterDisconnecting() {
            _this.startDisconnectTimer();
          },
          onLeaveDisconnecting: function onLeaveDisconnecting() {
            _this.cancelDisconnectTimer();
          },
          onEnterWaitSocketClosed: function onEnterWaitSocketClosed() {
            _this.startDisconnectTimer();
          },
          onLeaveWaitSocketClosed: function onLeaveWaitSocketClosed() {
            _this.cancelDisconnectTimer();
          },
          onEnterWaitOffloadSocketClosed: function onEnterWaitOffloadSocketClosed() {
            _this.startDisconnectTimer();
          },
          onLeaveWaitOffloadSocketClosed: function onLeaveWaitOffloadSocketClosed() {
            _this.cancelDisconnectTimer();
          },
          onDisconnected: function onDisconnected() {
            _this.resetBackoff();
            _this.finalizeSocket();
          },
          onReceiveClose: function onReceiveClose() {
            _this.onCloseReceived();
          },
          onReceiveOffload: function onReceiveOffload(event, args) {
            logInstance.debug("onreceiveoffload: ", args);
            _this.modifyBackoff(args.body);
            _this.onCloseReceived();
          },
          onUnsupported: function onUnsupported() {
            _this.closeSocket(true);
            _this.finalizeSocket();
          },
          onError: function onError(lifecycle, graceful) {
            _this.closeSocket(graceful);
            _this.finalizeSocket();
          },
          onEnterState: function onEnterState(event) {
            if (event.from !== "none") {
              _this.changeState(event);
            }
          },
          onInvalidTransition: function onInvalidTransition(transition, from4, to) {
            logInstance.warn("FSM: unexpected transition", from4, to);
          }
        }
      });
      _this.fsm = new TwilsockStateMachine();
      return _this;
    }
    _createClass__default2["default"](TwilsockChannel2, [{
      key: "changeState",
      value: function changeState(event) {
        logInstance.debug("FSM: ".concat(event.transition, ": ").concat(event.from, " --> ").concat(event.to));
        if (this.lastEmittedState !== this.state) {
          this.lastEmittedState = this.state;
          this.emit("stateChanged", this.state);
        }
      }
    }, {
      key: "resetBackoff",
      value: function resetBackoff() {
        logInstance.trace("resetBackoff");
        this.retrier.stop();
      }
    }, {
      key: "modifyBackoff",
      value: function modifyBackoff(body) {
        logInstance.trace("modifyBackoff", body);
        var backoffPolicy = body ? body.backoff_policy : null;
        if (backoffPolicy && typeof backoffPolicy.reconnect_min_ms === "number") {
          this.retrier.modifyBackoff(backoffPolicy.reconnect_min_ms);
        }
      }
    }, {
      key: "startDisconnectTimer",
      value: function startDisconnectTimer() {
        var _this2 = this;
        logInstance.trace("startDisconnectTimer");
        if (this.disconnectingTimer) {
          clearTimeout(this.disconnectingTimer);
          this.disconnectingTimer = null;
        }
        this.disconnectingTimer = setTimeout(function() {
          logInstance.debug("disconnecting is timed out");
          _this2.closeSocket(true);
        }, DISCONNECTING_TIMEOUT);
      }
    }, {
      key: "cancelDisconnectTimer",
      value: function cancelDisconnectTimer() {
        logInstance.trace("cancelDisconnectTimer");
        if (this.disconnectingTimer) {
          clearTimeout(this.disconnectingTimer);
          this.disconnectingTimer = null;
        }
      }
    }, {
      key: "isConnected",
      get: function get3() {
        return this.state === "connected" && this.websocket.isConnected;
      }
    }, {
      key: "state",
      get: function get3() {
        switch (this.fsm.state) {
          case "connecting":
          case "initialising":
          case "retrying":
          case "error":
            return "connecting";
          case "updating":
          case "connected":
            return "connected";
          case "rejected":
            return "denied";
          case "disconnecting":
          case "waitSocketClosed":
          case "waitOffloadSocketClosed":
            return "disconnecting";
          case "disconnected":
          default:
            return "disconnected";
        }
      }
    }, {
      key: "initRetry",
      value: function initRetry() {
        logInstance.debug("initRetry");
        if (this.retrier.inProgress) {
          this.retrier.attemptFailed();
        } else {
          this.retrier.start();
        }
      }
    }, {
      key: "retry",
      value: function retry() {
        if (this.fsm.state != "connecting") {
          logInstance.trace("retry");
          this.websocket.close();
          this.fsm.userRetry();
        } else {
          logInstance.trace("can	 retry as already connecting");
        }
      }
    }, {
      key: "onConnected",
      value: function onConnected() {
        this.emit("connected");
      }
    }, {
      key: "finalizeSocket",
      value: function finalizeSocket() {
        logInstance.trace("finalizeSocket");
        this.websocket.close();
        this.emit("disconnected");
        if (this.disconnectedPromiseResolve) {
          this.disconnectedPromiseResolve();
          this.disconnectedPromiseResolve = null;
        }
      }
    }, {
      key: "setupSocket",
      value: function setupSocket() {
        logInstance.trace("setupSocket:", this.config.token);
        this.emit("beforeConnect");
        this.websocket.connect();
      }
    }, {
      key: "onIncomingMessage",
      value: function onIncomingMessage(message) {
        var parsedMessage = Parser.parse(message);
        if (!parsedMessage) {
          return;
        }
        var method = parsedMessage.method, header = parsedMessage.header, payload = parsedMessage.payload;
        if (method !== "reply") {
          this.confirmReceiving(header);
        }
        if (method === "notification") {
          this.emit("message", header.message_type, payload);
        } else if (header.method === "reply") {
          this.transport.processReply({
            id: header.id,
            status: header.status,
            header,
            body: payload
          });
        } else if (header.method === "client_update") {
          if (header.client_update_type === "token_about_to_expire") {
            this.emit("tokenAboutToExpire");
          }
        } else if (header.method === "close") {
          if (header.status.code === 308) {
            logInstance.debug("Connection has been offloaded");
            this.fsm.receiveOffload({
              status: header.status.status,
              body: payload
            });
          } else if (header.status.code === 406) {
            var _message = "Server closed connection because can't parse protocol: ".concat(JSON.stringify(header.status));
            this.emitReplyConnectionError(_message, header, true);
            logInstance.error(_message);
            this.fsm.receiveFatalClose();
          } else if (header.status.code === 417) {
            logInstance.error("Server closed connection because can't parse client reply: ".concat(JSON.stringify(header.status)));
            this.fsm.receiveFatalClose(header.status.status);
          } else if (header.status.code === 410) {
            logInstance.warn("Server closed connection: ".concat(JSON.stringify(header.status)));
            this.fsm.receiveClose(header.status.status);
            this.emit("tokenExpired");
          } else if (header.status.code === 401) {
            logInstance.error("Server closed connection: ".concat(JSON.stringify(header.status)));
            this.fsm.receiveClose(header.status.status);
          } else {
            logInstance.warn("unexpected message: ", header.status);
            this.fsm.receiveOffload({
              status: header.status.status,
              body: null
            });
          }
        }
      }
    }, {
      key: "sendInit",
      value: function() {
        var _sendInit = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee() {
          var reply, isTerminalError;
          return _regeneratorRuntime__default2["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  logInstance.trace("sendInit");
                  _context.prev = 1;
                  this.emit("beforeSendInit");
                  _context.next = 5;
                  return this.transport.sendInit();
                case 5:
                  reply = _context.sent;
                  this.config.updateContinuationToken(reply.continuationToken);
                  this.config.confirmedCapabilities = reply.confirmedCapabilities;
                  this.fsm.initSuccess(reply);
                  this.emit("initialized", reply);
                  this.emit("tokenUpdated");
                  _context.next = 17;
                  break;
                case 13:
                  _context.prev = 13;
                  _context.t0 = _context["catch"](1);
                  if (_context.t0 instanceof TwilsockReplyError) {
                    isTerminalError = false;
                    logInstance.warn("Init rejected by server: ".concat(JSON.stringify(_context.t0.reply.status)));
                    this.emit("sendInitFailed");
                    if (_context.t0.reply.status.code === 401 || _context.t0.reply.status.code === 403) {
                      isTerminalError = true;
                      this.fsm.tokenRejected(_context.t0.reply.status);
                      if (_context.t0.reply.status.errorCode === this.tokenExpiredSasCode) {
                        this.emit("tokenExpired");
                      }
                    } else if (_context.t0.reply.status.code === 429) {
                      this.modifyBackoff(_context.t0.reply.body);
                      this.fsm.initError(true);
                    } else if (_context.t0.reply.status.code === 500) {
                      this.fsm.initError(false);
                    } else {
                      this.fsm.initError(true);
                    }
                    this.emitReplyConnectionError(_context.t0.message, _context.t0.reply, isTerminalError);
                  } else {
                    this.terminationReason = _context.t0.message;
                    this.emit("connectionError", {
                      terminal: true,
                      message: "Unknown error during connection initialisation: ".concat(_context.t0.message, "\n").concat(JSON.stringify(_context.t0, null, 2)),
                      httpStatusCode: null,
                      errorCode: null
                    });
                    this.fsm.initError(true);
                  }
                  this.emit("tokenUpdated", _context.t0);
                case 17:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this, [[1, 13]]);
        }));
        function sendInit() {
          return _sendInit.apply(this, arguments);
        }
        return sendInit;
      }()
    }, {
      key: "sendUpdate",
      value: function() {
        var _sendUpdate = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee2() {
          var message, reply, isTerminalError;
          return _regeneratorRuntime__default2["default"].wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  logInstance.trace("sendUpdate");
                  message = new Update(this.config.token);
                  _context2.prev = 2;
                  _context2.next = 5;
                  return this.transport.sendWithReply(message);
                case 5:
                  reply = _context2.sent;
                  this.fsm.updateSuccess(reply.body);
                  this.emit("tokenUpdated");
                  _context2.next = 14;
                  break;
                case 10:
                  _context2.prev = 10;
                  _context2.t0 = _context2["catch"](2);
                  if (_context2.t0 instanceof TwilsockReplyError) {
                    isTerminalError = false;
                    logInstance.warn("Token update rejected by server: ".concat(JSON.stringify(_context2.t0.reply.status)));
                    if (_context2.t0.reply.status.code === 401 || _context2.t0.reply.status.code === 403) {
                      isTerminalError = true;
                      this.fsm.tokenRejected(_context2.t0.reply.status);
                      if (_context2.t0.reply.status.errorCode === this.tokenExpiredSasCode) {
                        this.emit("tokenExpired");
                      }
                    } else if (_context2.t0.reply.status.code === 429) {
                      this.modifyBackoff(_context2.t0.reply.body);
                      this.fsm.updateError(_context2.t0.reply.status);
                    } else {
                      this.fsm.updateError(_context2.t0.reply.status);
                    }
                    this.emitReplyConnectionError(_context2.t0.message, _context2.t0.reply, isTerminalError);
                  } else {
                    this.emit("error", false, _context2.t0.message, null, null);
                    this.fsm.updateError(_context2.t0);
                  }
                  this.emit("tokenUpdated", _context2.t0);
                case 14:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this, [[2, 10]]);
        }));
        function sendUpdate() {
          return _sendUpdate.apply(this, arguments);
        }
        return sendUpdate;
      }()
    }, {
      key: "emitReplyConnectionError",
      value: function emitReplyConnectionError(message, header, terminal) {
        var description = header.status && header.status.description ? header.status.description : message;
        var httpStatusCode = header.status.code;
        var errorCode = header.status && header.status.errorCode ? header.status.errorCode : null;
        if (terminal) {
          this.terminationReason = description;
        }
        this.emit("connectionError", {
          terminal,
          message: "Connection error: ".concat(description),
          httpStatusCode,
          errorCode
        });
      }
    }, {
      key: "cancelInit",
      value: function cancelInit() {
        logInstance.trace("cancelInit");
      }
    }, {
      key: "cancelUpdate",
      value: function cancelUpdate() {
        logInstance.trace("cancelUpdate");
      }
      /**
       * Should be called for each message to confirm it received
       */
    }, {
      key: "confirmReceiving",
      value: function confirmReceiving(messageHeader) {
        logInstance.trace("confirmReceiving");
        try {
          this.transport.send(new Reply(messageHeader.id));
        } catch (e) {
          logInstance.debug("failed to confirm packet receiving", e);
        }
      }
      /**
       * Shutdown connection
       */
    }, {
      key: "closeSocket",
      value: function closeSocket(graceful) {
        var _this3 = this;
        logInstance.trace("closeSocket (graceful: ".concat(graceful, ")"));
        if (graceful && this.transport.isConnected) {
          this.transport.sendClose();
        }
        this.websocket.close();
        trampoline(function() {
          return _this3.fsm.socketClosed();
        });
      }
      /**
       * Initiate the twilsock connection
       * If already connected, it does nothing
       */
    }, {
      key: "connect",
      value: function connect() {
        logInstance.trace("connect");
        this.fsm.userConnect();
      }
      /**
       * Close twilsock connection
       * If already disconnected, it does nothing
       */
    }, {
      key: "disconnect",
      value: function disconnect() {
        var _this4 = this;
        logInstance.trace("disconnect");
        if (this.fsm.is("disconnected")) {
          return Promise.resolve();
        }
        return new Promise(function(resolve2) {
          _this4.disconnectedPromiseResolve = resolve2;
          _this4.fsm.userDisconnect();
        });
      }
      /**
       * Update fpa token for twilsock connection
       */
    }, {
      key: "updateToken",
      value: function updateToken(token) {
        var _this5 = this;
        logInstance.trace("updateToken:", token);
        return new Promise(function(resolve2, reject2) {
          _this5.once("tokenUpdated", function(e) {
            if (e) {
              reject2(e);
            } else {
              resolve2();
            }
          });
          _this5.fsm.userUpdateToken();
        });
      }
    }, {
      key: "isTerminalState",
      get: function get3() {
        return this.terminalStates.indexOf(this.fsm.state) !== -1;
      }
    }, {
      key: "getTerminationReason",
      get: function get3() {
        return this.terminationReason;
      }
    }, {
      key: "onCloseReceived",
      value: function onCloseReceived() {
        this.websocket.close();
      }
    }]);
    return TwilsockChannel2;
  }(EventEmitter2);
  var Metadata = /* @__PURE__ */ function() {
    function Metadata2() {
      _classCallCheck__default2["default"](this, Metadata2);
    }
    _createClass__default2["default"](Metadata2, null, [{
      key: "getMetadata",
      value: function getMetadata(options) {
        var _platform$name, _platform$version, _platform$os$family, _platform$os, _platform$os$version, _platform$os2, _platform$os$architec, _platform$os3;
        var overrides = options && options.clientMetadata ? options.clientMetadata : {};
        var fieldNames = ["ver", "env", "envv", "os", "osv", "osa", "type", "sdk", "sdkv", "dev", "devv", "devt", "app", "appv"];
        var defaults = {
          env: (_platform$name = platform__namespace2.name) !== null && _platform$name !== void 0 ? _platform$name : "unknown",
          envv: (_platform$version = platform__namespace2.version) !== null && _platform$version !== void 0 ? _platform$version : "unknown",
          os: (_platform$os$family = (_platform$os = platform__namespace2.os) === null || _platform$os === void 0 ? void 0 : _platform$os.family) !== null && _platform$os$family !== void 0 ? _platform$os$family : "unknown",
          osv: (_platform$os$version = (_platform$os2 = platform__namespace2.os) === null || _platform$os2 === void 0 ? void 0 : _platform$os2.version) !== null && _platform$os$version !== void 0 ? _platform$os$version : "unknown",
          osa: (_platform$os$architec = (_platform$os3 = platform__namespace2.os) === null || _platform$os3 === void 0 ? void 0 : _platform$os3.architecture) !== null && _platform$os$architec !== void 0 ? _platform$os$architec : "unknown",
          sdk: "js-default"
        };
        var finalClientMetadata = {};
        fieldNames.filter(function(key) {
          return key in overrides || key in defaults;
        }).forEach(function(key) {
          return finalClientMetadata[key] = key in overrides ? overrides[key] : defaults[key];
        });
        return finalClientMetadata;
      }
    }]);
    return Metadata2;
  }();
  var REQUEST_TIMEOUT$1 = 3e4;
  function isHttpSuccess$1(code) {
    return code >= 200 && code < 300;
  }
  function preparePayload(payload) {
    switch (_typeof__default2["default"](payload)) {
      case "undefined":
        return "";
      case "object":
        return JSON.stringify(payload);
      default:
        return payload;
    }
  }
  var PacketInterface = /* @__PURE__ */ function() {
    function PacketInterface2(channel2, config) {
      var _this = this;
      _classCallCheck__default2["default"](this, PacketInterface2);
      this.config = config;
      this.activeRequests = /* @__PURE__ */ new Map();
      this.channel = channel2;
      this.channel.on("reply", function(reply) {
        return _this.processReply(reply);
      });
      this.channel.on("disconnected", function() {
        _this.activeRequests.forEach(function(descriptor) {
          clearTimeout(descriptor.timeout);
          descriptor.reject(new TwilsockError("disconnected"));
        });
        _this.activeRequests.clear();
      });
    }
    _createClass__default2["default"](PacketInterface2, [{
      key: "isConnected",
      get: function get3() {
        return this.channel.isConnected;
      }
    }, {
      key: "processReply",
      value: function processReply(reply) {
        var request = this.activeRequests.get(reply.id);
        if (request) {
          clearTimeout(request.timeout);
          this.activeRequests.delete(reply.id);
          if (!isHttpSuccess$1(reply.status.code)) {
            request.reject(new TwilsockReplyError("Transport failure: " + reply.status.status, reply));
            logInstance.trace("message rejected");
          } else {
            request.resolve(reply);
          }
        }
      }
    }, {
      key: "storeRequest",
      value: function storeRequest(id2, resolve2, reject2) {
        var requestDescriptor = {
          resolve: resolve2,
          reject: reject2,
          timeout: setTimeout(function() {
            logInstance.trace("request", id2, "is timed out");
            reject2(new TwilsockError("Twilsock: request timeout: " + id2));
          }, REQUEST_TIMEOUT$1)
        };
        this.activeRequests.set(id2, requestDescriptor);
      }
    }, {
      key: "shutdown",
      value: function shutdown() {
        this.activeRequests.forEach(function(descriptor) {
          clearTimeout(descriptor.timeout);
          descriptor.reject(new TwilsockError("Twilsock: request cancelled by user"));
        });
        this.activeRequests.clear();
      }
    }, {
      key: "sendInit",
      value: function() {
        var _sendInit = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee() {
          var metadata, message, response;
          return _regeneratorRuntime__default2["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  logInstance.trace("sendInit");
                  metadata = Metadata.getMetadata(this.config);
                  message = new Init(this.config.token, this.config.continuationToken, metadata, this.config.initRegistrations, this.config.tweaks);
                  _context.next = 5;
                  return this.sendWithReply(message);
                case 5:
                  response = _context.sent;
                  return _context.abrupt("return", new InitReply(response.id, response.header.continuation_token, new Set(response.header.capabilities), response.header.continuation_token_status, response.header.offline_storage, response.header.init_registrations, response.header.debug_info));
                case 7:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));
        function sendInit() {
          return _sendInit.apply(this, arguments);
        }
        return sendInit;
      }()
    }, {
      key: "sendClose",
      value: function sendClose() {
        var message = new Close();
        this.send(message);
      }
    }, {
      key: "sendWithReply",
      value: function sendWithReply(header, payload) {
        var _this2 = this;
        return new Promise(function(resolve2, reject2) {
          var id2 = _this2.send(header, payload);
          _this2.storeRequest(id2, resolve2, reject2);
        });
      }
    }, {
      key: "send",
      value: function send(header, payload) {
        header.id = header.id || "TM".concat(uuid2.v4());
        var message = Parser.createPacket(header, preparePayload(payload));
        try {
          this.channel.send(message);
          return header.id;
        } catch (e) {
          logInstance.debug("failed to send ", header, e);
          logInstance.trace(e.stack);
          throw e;
        }
      }
    }]);
    return PacketInterface2;
  }();
  function _createSuper$42(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$42();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf__default2["default"](Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf__default2["default"](this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn__default2["default"](this, result);
    };
  }
  function _isNativeReflectConstruct$42() {
    if (typeof Reflect === "undefined" || !Reflect.construct)
      return false;
    if (Reflect.construct.sham)
      return false;
    if (typeof Proxy === "function")
      return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  var WebSocketChannel = /* @__PURE__ */ function(_EventEmitter) {
    _inherits__default2["default"](WebSocketChannel2, _EventEmitter);
    var _super = _createSuper$42(WebSocketChannel2);
    function WebSocketChannel2(url) {
      var _this;
      _classCallCheck__default2["default"](this, WebSocketChannel2);
      _this = _super.call(this);
      _defineProperty__default2["default"](_assertThisInitialized__default2["default"](_this), "socket", null);
      _this.url = url;
      _this.url = url;
      _this.WebSocket = global2["WebSocket"] || global2["MozWebSocket"] || {};
      return _this;
    }
    _createClass__default2["default"](WebSocketChannel2, [{
      key: "isConnected",
      get: function get3() {
        return !!this.socket && this.socket.readyState === 1;
      }
    }, {
      key: "connect",
      value: function connect() {
        var _this2 = this;
        logInstance.trace("connecting to socket");
        var socket;
        try {
          socket = new this.WebSocket(this.url);
        } catch (e) {
          logInstance.debug("Socket error: ".concat(this.url));
          this.emit("socketError", e);
          return;
        }
        socket.binaryType = "arraybuffer";
        socket.onopen = function() {
          logInstance.debug("socket opened ".concat(_this2.url));
          _this2.emit("connected");
        };
        socket.onclose = function(e) {
          logInstance.debug("socket closed", e);
          _this2.emit("disconnected", e);
        };
        socket.onerror = function(e) {
          logInstance.debug("Socket error:", e);
          _this2.emit("socketError", e);
        };
        socket.onmessage = function(message) {
          _this2.emit("message", message.data);
        };
        this.socket = socket;
      }
    }, {
      key: "send",
      value: function send(message) {
        return this.socket && this.socket.send(message);
      }
    }, {
      key: "close",
      value: function close() {
        logInstance.trace("closing socket");
        if (this.socket) {
          this.socket.onopen = null;
          this.socket.onclose = null;
          this.socket.onerror = null;
          this.socket.onmessage = null;
          try {
            this.socket.close();
          } finally {
          }
        }
      }
    }]);
    return WebSocketChannel2;
  }(EventEmitter2);
  function _createSuper$32(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$32();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf__default2["default"](Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf__default2["default"](this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn__default2["default"](this, result);
    };
  }
  function _isNativeReflectConstruct$32() {
    if (typeof Reflect === "undefined" || !Reflect.construct)
      return false;
    if (Reflect.construct.sham)
      return false;
    if (typeof Proxy === "function")
      return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  var Registrations = /* @__PURE__ */ function(_EventEmitter) {
    _inherits__default2["default"](Registrations2, _EventEmitter);
    var _super = _createSuper$32(Registrations2);
    function Registrations2(transport) {
      var _this;
      _classCallCheck__default2["default"](this, Registrations2);
      _this = _super.call(this);
      _this.transport = transport;
      _this.registrations = /* @__PURE__ */ new Map();
      _this.registrationsInProgress = /* @__PURE__ */ new Map();
      return _this;
    }
    _createClass__default2["default"](Registrations2, [{
      key: "putNotificationContext",
      value: function() {
        var _putNotificationContext = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee(contextId, context) {
          var header;
          return _regeneratorRuntime__default2["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  header = {
                    method: "put_notification_ctx",
                    notification_ctx_id: contextId
                  };
                  _context.next = 3;
                  return this.transport.sendWithReply(header, context);
                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));
        function putNotificationContext(_x, _x2) {
          return _putNotificationContext.apply(this, arguments);
        }
        return putNotificationContext;
      }()
    }, {
      key: "deleteNotificationContext",
      value: function() {
        var _deleteNotificationContext = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee2(contextId) {
          var message;
          return _regeneratorRuntime__default2["default"].wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  message = {
                    method: "delete_notification_ctx",
                    notification_ctx_id: contextId
                  };
                  _context2.next = 3;
                  return this.transport.sendWithReply(message);
                case 3:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));
        function deleteNotificationContext(_x3) {
          return _deleteNotificationContext.apply(this, arguments);
        }
        return deleteNotificationContext;
      }()
    }, {
      key: "updateRegistration",
      value: function() {
        var _updateRegistration = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee3(contextId, context) {
          var registrationAttempts, attemptId;
          return _regeneratorRuntime__default2["default"].wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  logInstance.debug("update registration for context", contextId);
                  registrationAttempts = this.registrationsInProgress.get(contextId);
                  if (!registrationAttempts) {
                    registrationAttempts = /* @__PURE__ */ new Set();
                    this.registrationsInProgress.set(contextId, registrationAttempts);
                  }
                  attemptId = uuid2.v4();
                  registrationAttempts.add(attemptId);
                  _context3.prev = 5;
                  _context3.next = 8;
                  return this.putNotificationContext(contextId, context);
                case 8:
                  logInstance.debug("registration attempt succeeded for context", context);
                  registrationAttempts.delete(attemptId);
                  if (registrationAttempts.size === 0) {
                    this.registrationsInProgress.delete(contextId);
                    this.emit("registered", contextId);
                  }
                  _context3.next = 19;
                  break;
                case 13:
                  _context3.prev = 13;
                  _context3.t0 = _context3["catch"](5);
                  logInstance.warn("registration attempt failed for context", context);
                  logInstance.debug(_context3.t0);
                  registrationAttempts.delete(attemptId);
                  if (registrationAttempts.size === 0) {
                    this.registrationsInProgress.delete(contextId);
                    this.emit("registrationFailed", contextId, _context3.t0);
                  }
                case 19:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this, [[5, 13]]);
        }));
        function updateRegistration(_x4, _x5) {
          return _updateRegistration.apply(this, arguments);
        }
        return updateRegistration;
      }()
    }, {
      key: "updateRegistrations",
      value: function() {
        var _updateRegistrations = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee4() {
          var _this2 = this;
          var promises;
          return _regeneratorRuntime__default2["default"].wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  logInstance.trace("refreshing ".concat(this.registrations.size, " registrations"));
                  promises = [];
                  this.registrations.forEach(function(context, id2) {
                    promises.push(_this2.updateRegistration(id2, context));
                  });
                  _context4.next = 5;
                  return Promise.all(promises);
                case 5:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));
        function updateRegistrations() {
          return _updateRegistrations.apply(this, arguments);
        }
        return updateRegistrations;
      }()
    }, {
      key: "setNotificationsContext",
      value: function() {
        var _setNotificationsContext = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee5(contextId, context) {
          return _regeneratorRuntime__default2["default"].wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  if (!(!contextId || !context)) {
                    _context5.next = 2;
                    break;
                  }
                  throw new TwilsockError("Invalid arguments provided");
                case 2:
                  this.registrations.set(contextId, context);
                  _context5.next = 5;
                  return this.updateRegistration(contextId, context);
                case 5:
                  return _context5.abrupt("return", _context5.sent);
                case 6:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, this);
        }));
        function setNotificationsContext(_x6, _x7) {
          return _setNotificationsContext.apply(this, arguments);
        }
        return setNotificationsContext;
      }()
    }, {
      key: "removeNotificationsContext",
      value: function() {
        var _removeNotificationsContext = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee6(contextId) {
          return _regeneratorRuntime__default2["default"].wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  if (this.registrations.has(contextId)) {
                    _context6.next = 2;
                    break;
                  }
                  return _context6.abrupt("return");
                case 2:
                  _context6.next = 4;
                  return this.deleteNotificationContext(contextId);
                case 4:
                  if (this.transport.isConnected) {
                    this.registrations.delete(contextId);
                  }
                case 5:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6, this);
        }));
        function removeNotificationsContext(_x8) {
          return _removeNotificationsContext.apply(this, arguments);
        }
        return removeNotificationsContext;
      }()
    }]);
    return Registrations2;
  }(EventEmitter2);
  function _createSuper$22(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$22();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf__default2["default"](Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf__default2["default"](this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn__default2["default"](this, result);
    };
  }
  function _isNativeReflectConstruct$22() {
    if (typeof Reflect === "undefined" || !Reflect.construct)
      return false;
    if (Reflect.construct.sham)
      return false;
    if (typeof Proxy === "function")
      return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  var TwilsockUpstreamError = /* @__PURE__ */ function(_TwilsockError) {
    _inherits__default2["default"](TwilsockUpstreamError2, _TwilsockError);
    var _super = _createSuper$22(TwilsockUpstreamError2);
    function TwilsockUpstreamError2(status, description, body) {
      var _this;
      _classCallCheck__default2["default"](this, TwilsockUpstreamError2);
      _this = _super.call(this, description);
      _this.status = status;
      _this.description = description;
      _this.body = body;
      return _this;
    }
    return TwilsockUpstreamError2;
  }(TwilsockError);
  function _createSuper$12(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$12();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf__default2["default"](Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf__default2["default"](this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn__default2["default"](this, result);
    };
  }
  function _isNativeReflectConstruct$12() {
    if (typeof Reflect === "undefined" || !Reflect.construct)
      return false;
    if (Reflect.construct.sham)
      return false;
    if (typeof Proxy === "function")
      return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  var TransportUnavailableError = /* @__PURE__ */ function(_TwilsockError) {
    _inherits__default2["default"](TransportUnavailableError2, _TwilsockError);
    var _super = _createSuper$12(TransportUnavailableError2);
    function TransportUnavailableError2(description) {
      _classCallCheck__default2["default"](this, TransportUnavailableError2);
      return _super.call(this, description);
    }
    return TransportUnavailableError2;
  }(TwilsockError);
  var REQUEST_TIMEOUT = 2e4;
  function isHttpSuccess(code) {
    return code >= 200 && code < 300;
  }
  function isHttpReply(packet) {
    return packet && packet.header && packet.header.http_status;
  }
  function parseUri(uri) {
    var match2 = uri.match(/^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)(\/[^?#]*)(\?[^#]*|)(#.*|)$/);
    if (match2) {
      var uriStruct = {
        protocol: match2[1],
        host: match2[2],
        hostname: match2[3],
        port: match2[4],
        pathname: match2[5],
        search: match2[6],
        hash: match2[7],
        params: {}
      };
      if (uriStruct.search.length > 0) {
        var paramsString = uriStruct.search.substring(1);
        uriStruct.params = paramsString.split("&").map(function(el) {
          return el.split("=");
        }).reduce(function(prev, curr) {
          if (!prev.hasOwnProperty(curr[0])) {
            prev[curr[0]] = curr[1];
          } else if (Array.isArray(prev[curr[0]])) {
            prev[curr[0]].push(curr[1]);
          } else {
            prev[curr[0]] = [prev[curr[0]], curr[1]];
          }
          return prev;
        }, {});
      }
      return uriStruct;
    }
    throw new TwilsockError("Incorrect URI: " + uri);
  }
  function twilsockAddress(method, uri) {
    var parsedUri = parseUri(uri);
    var to = {
      method,
      host: parsedUri.host,
      path: parsedUri.pathname
    };
    if (parsedUri.params) {
      to.params = parsedUri.params;
    }
    return to;
  }
  function twilsockParams(method, uri, headers, body, grant) {
    return {
      to: twilsockAddress(method, uri),
      headers,
      body,
      grant
    };
  }
  var Upstream = /* @__PURE__ */ function() {
    function Upstream2(transport, twilsock2, config) {
      _classCallCheck__default2["default"](this, Upstream2);
      this.config = config;
      this.transport = transport;
      this.pendingMessages = [];
      this.twilsock = twilsock2;
    }
    _createClass__default2["default"](Upstream2, [{
      key: "saveMessage",
      value: function saveMessage(message) {
        var _this = this;
        return new Promise(function(resolve2, reject2) {
          var requestDescriptor = {
            message,
            resolve: resolve2,
            reject: reject2,
            alreadyRejected: false,
            timeout: setTimeout(function() {
              logInstance.debug("request is timed out");
              reject2(new TwilsockError("request '".concat(message.to.method, "' to '").concat(message.to.host, "' timed out")));
              requestDescriptor.alreadyRejected = true;
            }, REQUEST_TIMEOUT)
          };
          _this.pendingMessages.push(requestDescriptor);
        });
      }
    }, {
      key: "sendPendingMessages",
      value: function sendPendingMessages() {
        var _this2 = this;
        var _loop = function _loop2() {
          var request = _this2.pendingMessages[0];
          if (!request.alreadyRejected) {
            try {
              var message = request.message;
              _this2.actualSend(message).then(function(response) {
                return request.resolve(response);
              }).catch(function(e) {
                return request.reject(e);
              });
              clearTimeout(request.timeout);
            } catch (e) {
              logInstance.debug("Failed to send pending message", e);
              return "break";
            }
          }
          _this2.pendingMessages.splice(0, 1);
        };
        while (this.pendingMessages.length > 0) {
          var _ret = _loop();
          if (_ret === "break")
            break;
        }
      }
    }, {
      key: "rejectPendingMessages",
      value: function rejectPendingMessages() {
        var _this3 = this;
        this.pendingMessages.forEach(function(message) {
          message.reject(new TransportUnavailableError(
            // @todo Error Unhandled promise rejection!
            "Unable to connect: " + _this3.twilsock.getTerminationReason
          ));
          message.alreadyRejected = true;
          clearTimeout(message.timeout);
        });
        this.pendingMessages.splice(0, this.pendingMessages.length);
      }
    }, {
      key: "actualSend",
      value: function() {
        var _actualSend = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee(message) {
          var _message$grant;
          var address, headers, body, grant, httpRequest, upstreamMessage, reply;
          return _regeneratorRuntime__default2["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  address = message.to;
                  headers = message.headers;
                  body = message.body;
                  grant = (_message$grant = message.grant) !== null && _message$grant !== void 0 ? _message$grant : this.config.activeGrant;
                  httpRequest = {
                    host: address.host,
                    path: address.path,
                    method: address.method,
                    params: address.params,
                    headers
                  };
                  upstreamMessage = new Message(grant, headers["Content-Type"] || "application/json", httpRequest);
                  logInstance.trace("Sending upstream message", upstreamMessage);
                  _context.next = 9;
                  return this.transport.sendWithReply(upstreamMessage, body);
                case 9:
                  reply = _context.sent;
                  logInstance.trace("Received upstream message response", reply);
                  if (!(isHttpReply(reply) && !isHttpSuccess(reply.header.http_status.code))) {
                    _context.next = 13;
                    break;
                  }
                  throw new TwilsockUpstreamError(reply.header.http_status.code, reply.header.http_status.status, reply.body);
                case 13:
                  return _context.abrupt("return", {
                    status: reply.header.http_status,
                    headers: reply.header.http_headers,
                    body: reply.body
                  });
                case 14:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));
        function actualSend(_x) {
          return _actualSend.apply(this, arguments);
        }
        return actualSend;
      }()
      /**
       * Send an upstream message
       * @param {string} method The upstream method
       * @param {string} url URL to send the message to
       * @param {object} [headers] The message headers
       * @param {any} [body] The message body
       * @param {string} [grant] The product grant
       * @returns {Promise<Result>} Result from remote side
       */
    }, {
      key: "send",
      value: function send(method, url) {
        var headers = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        var body = arguments.length > 3 ? arguments[3] : void 0;
        var grant = arguments.length > 4 ? arguments[4] : void 0;
        if (this.twilsock.isTerminalState) {
          return Promise.reject(new TransportUnavailableError("Unable to connect: " + this.twilsock.getTerminationReason));
        }
        var twilsockMessage = twilsockParams(method, url, headers, body, grant);
        if (!this.twilsock.isConnected) {
          return this.saveMessage(twilsockMessage);
        }
        return this.actualSend(twilsockMessage);
      }
    }]);
    return Upstream2;
  }();
  var Deferred = /* @__PURE__ */ function() {
    function Deferred2() {
      var _this = this;
      _classCallCheck__default2["default"](this, Deferred2);
      this._promise = new Promise(function(resolve2, reject2) {
        _this._resolve = resolve2;
        _this._reject = reject2;
      });
    }
    _createClass__default2["default"](Deferred2, [{
      key: "promise",
      get: function get3() {
        return this._promise;
      }
    }, {
      key: "update",
      value: function update(value) {
        this._resolve(value);
      }
    }, {
      key: "set",
      value: function set4(value) {
        this._resolve(value);
      }
    }, {
      key: "fail",
      value: function fail(e) {
        this._reject(e);
      }
    }]);
    return Deferred2;
  }();
  var OfflineProductStorage = /* @__PURE__ */ function() {
    function OfflineProductStorage2(id2) {
      _classCallCheck__default2["default"](this, OfflineProductStorage2);
      this.id = id2;
    }
    _createClass__default2["default"](OfflineProductStorage2, null, [{
      key: "create",
      value: function create4(productPayload) {
        if (productPayload instanceof Object && "storage_id" in productPayload) {
          return new OfflineProductStorage2(productPayload.storage_id);
        } else {
          throw new TwilsockError('Field "storage_id" is missing');
        }
      }
    }]);
    return OfflineProductStorage2;
  }();
  var TokenStorage = /* @__PURE__ */ function() {
    function TokenStorage2() {
      _classCallCheck__default2["default"](this, TokenStorage2);
      _defineProperty__default2["default"](this, "initializedFlag", "twilio_twilsock_token_storage");
      _defineProperty__default2["default"](this, "tokenStoragePrefix", "twilio_continuation_token_");
      if (!TokenStorage2._instance) {
        this.initialize();
        TokenStorage2._instance = this;
      }
      return TokenStorage2._instance;
    }
    _createClass__default2["default"](TokenStorage2, [{
      key: "sessionStorage",
      value: function sessionStorage2() {
        try {
          return global2["sessionStorage"];
        } catch (err) {
          return null;
        }
      }
    }, {
      key: "window",
      value: function window2() {
        try {
          return global2["window"];
        } catch (err) {
          return null;
        }
      }
    }, {
      key: "storeToken",
      value: function storeToken(continuationToken, productId) {
        if (this.canStore()) {
          this.sessionStorage.setItem(this.getKeyName(productId), continuationToken);
        }
      }
    }, {
      key: "getStoredToken",
      value: function getStoredToken(productId) {
        if (!this.canStore()) {
          return null;
        }
        return this.sessionStorage.getItem(this.getKeyName(productId));
      }
    }, {
      key: "initialize",
      value: function initialize() {
        var _this = this;
        if (this.canStore()) {
          var flag = this.sessionStorage.getItem(this.initializedFlag);
          if (flag) {
            this.clear();
          }
          this.sessionStorage.setItem(this.initializedFlag, "true");
          var removeStorageItem = this.sessionStorage.removeItem;
          this.window.addEventListener("unload", function() {
            removeStorageItem(_this.initializedFlag);
          });
        }
      }
    }, {
      key: "clear",
      value: function clear2() {
        if (this.canStore()) {
          var keyToDelete = [];
          for (var i = 0; i < this.sessionStorage.length; i++) {
            var key = this.sessionStorage.key(i);
            if (key && key.indexOf(this.tokenStoragePrefix) === 0) {
              keyToDelete.push(key);
            }
          }
          var removeStorageItem = this.sessionStorage.removeItem;
          keyToDelete.forEach(function(key2) {
            return removeStorageItem(key2);
          });
          removeStorageItem(this.initializedFlag);
        }
      }
    }, {
      key: "getKeyName",
      value: function getKeyName(productId) {
        return "".concat(this.tokenStoragePrefix).concat(productId);
      }
    }, {
      key: "canStore",
      value: function canStore() {
        return !!(this.sessionStorage && this.sessionStorage.length && this.window);
      }
    }]);
    return TokenStorage2;
  }();
  _defineProperty__default2["default"](TokenStorage, "_instance", null);
  var TokenStorage$1 = new TokenStorage();
  var TelemetryEventDescription = /* @__PURE__ */ function() {
    function TelemetryEventDescription2(title, details, start, end2, type5, id2) {
      _classCallCheck__default2["default"](this, TelemetryEventDescription2);
      this.title = title;
      this.details = details;
      this.start = start;
      this.type = type5;
      this.id = id2;
      this.end = end2;
    }
    _createClass__default2["default"](TelemetryEventDescription2, [{
      key: "toTelemetryEvent",
      value: function toTelemetryEvent() {
        var now = /* @__PURE__ */ new Date();
        var actualStart = this.start;
        var actualEnd = this.end ? this.end : now;
        if (actualEnd < actualStart) {
          var tmp = actualEnd;
          actualEnd = actualStart;
          actualStart = tmp;
        }
        var startOffset = actualStart.getTime() - now.getTime();
        var endOffset = actualEnd.getTime() - now.getTime();
        var result = new TelemetryEvent(startOffset, endOffset, this.title, this.details, this.id, this.type);
        return result;
      }
    }]);
    return TelemetryEventDescription2;
  }();
  exports.TelemetryPoint = void 0;
  (function(TelemetryPoint) {
    TelemetryPoint[TelemetryPoint["Start"] = 0] = "Start";
    TelemetryPoint[TelemetryPoint["End"] = 1] = "End";
  })(exports.TelemetryPoint || (exports.TelemetryPoint = {}));
  exports.EventSendingLimitation = void 0;
  (function(EventSendingLimitation) {
    EventSendingLimitation[EventSendingLimitation["MinEventsPortion"] = 0] = "MinEventsPortion";
    EventSendingLimitation[EventSendingLimitation["AnyEvents"] = 1] = "AnyEvents";
    EventSendingLimitation[EventSendingLimitation["AnyEventsIncludingUnfinished"] = 2] = "AnyEventsIncludingUnfinished";
  })(exports.EventSendingLimitation || (exports.EventSendingLimitation = {}));
  var TelemetryTracker = /* @__PURE__ */ function() {
    function TelemetryTracker2(config, packetInterface) {
      _classCallCheck__default2["default"](this, TelemetryTracker2);
      _defineProperty__default2["default"](this, "minEventsPortionToSend", 50);
      _defineProperty__default2["default"](this, "maxEventsPortionToSend", 100);
      _defineProperty__default2["default"](this, "pendingEvents", /* @__PURE__ */ new Map());
      _defineProperty__default2["default"](this, "readyEvents", []);
      _defineProperty__default2["default"](this, "hasInitializationFinished", false);
      _defineProperty__default2["default"](this, "_canSendTelemetry", false);
      this.config = config;
      this.packetInterface = packetInterface;
    }
    _createClass__default2["default"](TelemetryTracker2, [{
      key: "isTelemetryEnabled",
      get: function get3() {
        return this.config.confirmedCapabilities.has("telemetry.v1");
      }
    }, {
      key: "canSendTelemetry",
      get: function get3() {
        return this._canSendTelemetry && this.isTelemetryEnabled;
      },
      set: function set4(enable2) {
        logInstance.debug("TelemetryTracker.canSendTelemetry: ".concat(enable2, " TelemetryTracker.isTelemetryEnabled: ").concat(this.isTelemetryEnabled));
        if (this._canSendTelemetry && !enable2) {
          this.pendingEvents.clear();
          this.readyEvents = [];
        }
        this._canSendTelemetry = enable2;
        if (enable2) {
          this.sendTelemetry(exports.EventSendingLimitation.AnyEvents);
        }
        if (enable2 && !this.hasInitializationFinished) {
          this.hasInitializationFinished = true;
        }
      }
      // Add complete event
    }, {
      key: "addTelemetryEvent",
      value: function addTelemetryEvent(event) {
        if (!this.canSendTelemetry && this.hasInitializationFinished) {
          return;
        }
        this.readyEvents.push(event);
      }
      // Add incomplete event (with either starting or ending time point)
    }, {
      key: "addPartialEvent",
      value: function addPartialEvent(incompleteEvent, eventKey, point) {
        logInstance.debug("Adding ".concat(point === exports.TelemetryPoint.Start ? "starting" : "ending", " timepoint for '").concat(eventKey, "' event"));
        var exists = this.pendingEvents.has(eventKey);
        if (point === exports.TelemetryPoint.Start) {
          if (exists) {
            logInstance.debug("Overwriting starting point for '".concat(eventKey, "' event"));
          }
          this.pendingEvents.set(eventKey, incompleteEvent);
        } else {
          if (!exists) {
            logInstance.info("Could not find started event for '".concat(eventKey, "' event"));
            return;
          }
          this.addTelemetryEvent(this.merge(this.pendingEvents.get(eventKey), incompleteEvent));
          this.pendingEvents.delete(eventKey);
        }
      }
    }, {
      key: "getTelemetryToSend",
      value: function getTelemetryToSend(sendingLimit) {
        if (!this.canSendTelemetry || this.readyEvents.length == 0) {
          return [];
        }
        if (sendingLimit == exports.EventSendingLimitation.MinEventsPortion && this.readyEvents.length < this.minEventsPortionToSend) {
          return [];
        }
        return this.getTelemetryPortion(sendingLimit == exports.EventSendingLimitation.AnyEventsIncludingUnfinished);
      }
    }, {
      key: "getTelemetryPortion",
      value: function getTelemetryPortion(includeUnfinished) {
        var _this = this;
        var eventsPortionToSend = Math.min(this.readyEvents.length, this.maxEventsPortionToSend);
        var res = this.readyEvents.splice(0, eventsPortionToSend);
        if (includeUnfinished && res.length < this.maxEventsPortionToSend) {
          this.pendingEvents.forEach(function(value, key) {
            if (res.length >= _this.maxEventsPortionToSend) {
              return;
            }
            var event = _this.pendingEvents.get(key);
            _this.pendingEvents.delete(key);
            res.push(new TelemetryEventDescription(
              "[UNFINISHED] ".concat(event.title),
              // add prefix title to mark unfinished events for CleanSock
              event.details,
              event.start,
              null,
              // Not ended, on sending will be replaced with now
              event.type,
              event.id
            ));
          });
        }
        return res;
      }
      // Merging 2 partial events:
      //   use start.startTime & end.endTime.
      // For other fields,
      //   if there are values in end, use them,
      //   else use values from start.
    }, {
      key: "merge",
      value: function merge(start, end2) {
        return new TelemetryEventDescription(end2.title ? end2.title : start.title, end2.details ? end2.details : start.details, start.start, end2.end, end2.type ? end2.type : start.type, end2.id ? end2.id : start.id);
      }
    }, {
      key: "sendTelemetryIfMinimalPortionCollected",
      value: function sendTelemetryIfMinimalPortionCollected() {
        this.sendTelemetry(exports.EventSendingLimitation.MinEventsPortion);
      }
      // NB: getTelemetryToSend will return non-empty array only if we have already received initReply
      // and telemetry.v1 capability is enabled there.
    }, {
      key: "sendTelemetry",
      value: function sendTelemetry(limit) {
        var events = this.getTelemetryToSend(limit);
        if (events.length === 0) {
          return;
        }
        try {
          this.packetInterface.send(new Telemetry(events.map(function(e) {
            return e.toTelemetryEvent();
          })));
        } catch (err) {
          logInstance.debug("Error while sending ".concat(events.length, " telemetry events due to ").concat(err, "; they will be resubmitted"));
          this.readyEvents = this.readyEvents.concat(events);
        }
      }
    }]);
    return TelemetryTracker2;
  }();
  function _createSuper2(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct2();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf__default2["default"](Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf__default2["default"](this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn__default2["default"](this, result);
    };
  }
  function _isNativeReflectConstruct2() {
    if (typeof Reflect === "undefined" || !Reflect.construct)
      return false;
    if (Reflect.construct.sham)
      return false;
    if (typeof Proxy === "function")
      return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  var TelemetryEvents = function TelemetryEvents2() {
    _classCallCheck__default2["default"](this, TelemetryEvents2);
  };
  _defineProperty__default2["default"](TelemetryEvents, "TWILSOCK_CONNECT", "twilsock.sdk.connect");
  _defineProperty__default2["default"](TelemetryEvents, "TWILSOCK_INIT", "twilsock.sdk.init");
  exports.TwilsockClient = /* @__PURE__ */ function(_EventEmitter) {
    _inherits__default2["default"](TwilsockClient, _EventEmitter);
    var _super = _createSuper2(TwilsockClient);
    function TwilsockClient(token, productId, options) {
      var _this;
      _classCallCheck__default2["default"](this, TwilsockClient);
      _this = _super.call(this);
      _defineProperty__default2["default"](_assertThisInitialized__default2["default"](_this), "version", version2);
      _defineProperty__default2["default"](_assertThisInitialized__default2["default"](_this), "offlineStorageDeferred", new Deferred());
      options.continuationToken = options.continuationToken ? options.continuationToken : TokenStorage$1.getStoredToken(productId);
      var config = _this.config = new Configuration2(token, productId, options);
      logInstance.setLevel(config.logLevel);
      var websocket = new WebSocketChannel(config.url);
      var transport = new PacketInterface(websocket, config);
      _this.channel = new TwilsockChannel(websocket, transport, config);
      _this.registrations = new Registrations(transport);
      _this.upstream = new Upstream(transport, _this.channel, config);
      _this.telemetryTracker = new TelemetryTracker(config, transport);
      _this.channel.on("initialized", function() {
        return _this.telemetryTracker.canSendTelemetry = true;
      });
      websocket.on("disconnected", function() {
        return _this.telemetryTracker.canSendTelemetry = false;
      });
      _this.registrations.on("registered", function(id2) {
        return _this.emit("registered", id2);
      });
      _this.channel.on("message", function(type5, message) {
        return setTimeout(function() {
          return _this.emit("message", type5, message);
        }, 0);
      });
      _this.channel.on("stateChanged", function(state) {
        return setTimeout(function() {
          return _this.emit("stateChanged", state);
        }, 0);
      });
      _this.channel.on("connectionError", function(connectionError) {
        return setTimeout(function() {
          return _this.emit("connectionError", connectionError);
        }, 0);
      });
      _this.channel.on("tokenAboutToExpire", function() {
        return setTimeout(function() {
          return _this.emit("tokenAboutToExpire");
        }, 0);
      });
      _this.channel.on("tokenExpired", function() {
        return setTimeout(function() {
          return _this.emit("tokenExpired");
        }, 0);
      });
      _this.channel.on("connected", function() {
        return _this.registrations.updateRegistrations();
      });
      _this.channel.on("connected", function() {
        return _this.upstream.sendPendingMessages();
      });
      _this.channel.on("connected", function() {
        return setTimeout(function() {
          return _this.emit("connected");
        }, 0);
      });
      _this.channel.on("beforeConnect", function() {
        return _this.telemetryTracker.addPartialEvent(new TelemetryEventDescription("Establish WebSocket connection", "", /* @__PURE__ */ new Date()), TelemetryEvents.TWILSOCK_CONNECT, exports.TelemetryPoint.Start);
      });
      _this.channel.on("connected", function() {
        return _this.telemetryTracker.addPartialEvent(new TelemetryEventDescription("Establish WebSocket connection", "", /* @__PURE__ */ new Date(), /* @__PURE__ */ new Date()), TelemetryEvents.TWILSOCK_CONNECT, exports.TelemetryPoint.End);
      });
      _this.channel.on("beforeSendInit", function() {
        return _this.telemetryTracker.addPartialEvent(new TelemetryEventDescription("Send Twilsock init", "", /* @__PURE__ */ new Date()), TelemetryEvents.TWILSOCK_INIT, exports.TelemetryPoint.Start);
      });
      _this.channel.on("initialized", function() {
        return _this.telemetryTracker.addPartialEvent(new TelemetryEventDescription("Send Twilsock init", "Succeeded", /* @__PURE__ */ new Date(), /* @__PURE__ */ new Date()), TelemetryEvents.TWILSOCK_INIT, exports.TelemetryPoint.End);
      });
      _this.channel.on("sendInitFailed", function() {
        return _this.telemetryTracker.addPartialEvent(new TelemetryEventDescription("Send Twilsock init", "Failed", /* @__PURE__ */ new Date(), /* @__PURE__ */ new Date()), TelemetryEvents.TWILSOCK_INIT, exports.TelemetryPoint.End);
      });
      _this.channel.on("initialized", function(initReply) {
        _this.handleStorageId(productId, initReply);
        TokenStorage$1.storeToken(initReply.continuationToken, productId);
        setTimeout(function() {
          return _this.emit("initialized", initReply);
        }, 0);
      });
      _this.channel.on("disconnected", function() {
        return setTimeout(function() {
          return _this.emit("disconnected");
        }, 0);
      });
      _this.channel.on("disconnected", function() {
        return _this.upstream.rejectPendingMessages();
      });
      _this.channel.on("disconnected", function() {
        return _this.offlineStorageDeferred.fail(new TwilsockError("Client disconnected"));
      });
      _this.offlineStorageDeferred.promise.catch(function() {
        return void 0;
      });
      return _this;
    }
    _createClass__default2["default"](TwilsockClient, [{
      key: "emit",
      value: function emit4(event) {
        var _get22;
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }
        logInstance.debug("Emitting ".concat(event.toString(), "(").concat(args.map(function(a) {
          return JSON.stringify(a);
        }).join(", "), ")"));
        return (_get22 = _get__default2["default"](_getPrototypeOf__default2["default"](TwilsockClient.prototype), "emit", this)).call.apply(_get22, [this, event].concat(args));
      }
    }, {
      key: "handleStorageId",
      value: function handleStorageId(productId, initReply) {
        if (!initReply.offlineStorage) {
          this.offlineStorageDeferred.fail(new TwilsockError("No offline storage id"));
        } else if (initReply.offlineStorage.hasOwnProperty(productId)) {
          try {
            this.offlineStorageDeferred.set(OfflineProductStorage.create(initReply.offlineStorage[productId]));
            logInstance.debug("Offline storage for '".concat(productId, "' product: ").concat(JSON.stringify(initReply.offlineStorage[productId]), "."));
          } catch (e) {
            this.offlineStorageDeferred.fail(new TwilsockError("Failed to parse offline storage for ".concat(productId, " ").concat(JSON.stringify(initReply.offlineStorage[productId]), ". ").concat(e, ".")));
          }
        } else {
          this.offlineStorageDeferred.fail(new TwilsockError("No offline storage id for '".concat(productId, "' product: ").concat(JSON.stringify(initReply.offlineStorage))));
        }
      }
      /**
       * Get offline storage ID
       * @returns {Promise}
       */
    }, {
      key: "storageId",
      value: function storageId() {
        return this.offlineStorageDeferred.promise;
      }
      /**
       * Indicates if twilsock is connected now
       * @returns {Boolean}
       */
    }, {
      key: "isConnected",
      get: function get3() {
        return this.channel.isConnected;
      }
      /**
       * Current state
       * @returns {ConnectionState}
       */
    }, {
      key: "state",
      get: function get3() {
        return this.channel.state;
      }
      /**
       * Update token
       * @param {String} token
       * @returns {Promise}
       */
    }, {
      key: "updateToken",
      value: function() {
        var _updateToken = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee(token) {
          return _regeneratorRuntime__default2["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  logInstance.trace("updating token '".concat(token, "'"));
                  if (!(this.config.token === token)) {
                    _context.next = 3;
                    break;
                  }
                  return _context.abrupt("return");
                case 3:
                  this.config.updateToken(token);
                  _context.next = 6;
                  return this.channel.updateToken(token);
                case 6:
                  return _context.abrupt("return", _context.sent);
                case 7:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));
        function updateToken(_x) {
          return _updateToken.apply(this, arguments);
        }
        return updateToken;
      }()
      /**
       * Updates notification context.
       * This method shouldn't be used anyone except twilio notifications library
       * @param contextId id of notification context
       * @param context value of notification context
       * @private
       */
    }, {
      key: "setNotificationsContext",
      value: function() {
        var _setNotificationsContext = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee2(contextId, context) {
          return _regeneratorRuntime__default2["default"].wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return this.registrations.setNotificationsContext(contextId, context);
                case 2:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));
        function setNotificationsContext(_x2, _x3) {
          return _setNotificationsContext.apply(this, arguments);
        }
        return setNotificationsContext;
      }()
      /**
       * Remove notification context.
       * This method shouldn't be used anyone except twilio notifications library
       * @param contextId id of notification context
       * @private
       */
    }, {
      key: "removeNotificationsContext",
      value: function() {
        var _removeNotificationsContext = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee3(contextId) {
          return _regeneratorRuntime__default2["default"].wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return this.registrations.removeNotificationsContext(contextId);
                case 2:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));
        function removeNotificationsContext(_x4) {
          return _removeNotificationsContext.apply(this, arguments);
        }
        return removeNotificationsContext;
      }()
      /**
       * Connect to the server
       * @fires Twilsock#connected
       * @public
       * @returns {void}
       */
    }, {
      key: "connect",
      value: function connect() {
        return this.channel.connect();
      }
      /**
       * Disconnect from the server
       * @fires Twilsock#disconnected
       * @public
       * @returns {Promise}
       */
    }, {
      key: "disconnect",
      value: function() {
        var _disconnect = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee4() {
          return _regeneratorRuntime__default2["default"].wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  this.telemetryTracker.sendTelemetry(exports.EventSendingLimitation.AnyEventsIncludingUnfinished);
                  _context4.next = 3;
                  return this.channel.disconnect();
                case 3:
                  return _context4.abrupt("return", _context4.sent);
                case 4:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));
        function disconnect() {
          return _disconnect.apply(this, arguments);
        }
        return disconnect;
      }()
      /**
       * Get HTTP request to upstream service
       * @param {string} url Upstream service url
       * @param {headers} headers Set of custom headers
       * @param {string} [grant] The product grant
       * @returns {Promise}
       */
    }, {
      key: "get",
      value: function() {
        var _get3 = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee5(url, headers, grant) {
          return _regeneratorRuntime__default2["default"].wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  this.telemetryTracker.sendTelemetry(exports.EventSendingLimitation.AnyEvents);
                  _context5.next = 3;
                  return this.upstream.send("GET", url, headers, void 0, grant);
                case 3:
                  return _context5.abrupt("return", _context5.sent);
                case 4:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, this);
        }));
        function get3(_x5, _x6, _x7) {
          return _get3.apply(this, arguments);
        }
        return get3;
      }()
      /**
       * Post HTTP request to upstream service
       * @param {string} url Upstream service url
       * @param {headers} headers Set of custom headers
       * @param {body} body Body to send
       * @param {string} [grant] The product grant
       * @returns {Promise}
       */
    }, {
      key: "post",
      value: function() {
        var _post = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee6(url, headers, body, grant) {
          return _regeneratorRuntime__default2["default"].wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  this.telemetryTracker.sendTelemetry(exports.EventSendingLimitation.AnyEvents);
                  _context6.next = 3;
                  return this.upstream.send("POST", url, headers, body, grant);
                case 3:
                  return _context6.abrupt("return", _context6.sent);
                case 4:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6, this);
        }));
        function post(_x8, _x9, _x10, _x11) {
          return _post.apply(this, arguments);
        }
        return post;
      }()
      /**
       * Put HTTP request to upstream service
       * @param {string} url Upstream service url
       * @param {headers} headers Set of custom headers
       * @param {body} body Body to send
       * @param {string} [grant] The product grant
       * @returns {Promise}
       */
    }, {
      key: "put",
      value: function() {
        var _put = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee7(url, headers, body, grant) {
          return _regeneratorRuntime__default2["default"].wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  this.telemetryTracker.sendTelemetry(exports.EventSendingLimitation.AnyEvents);
                  _context7.next = 3;
                  return this.upstream.send("PUT", url, headers, body, grant);
                case 3:
                  return _context7.abrupt("return", _context7.sent);
                case 4:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7, this);
        }));
        function put(_x12, _x13, _x14, _x15) {
          return _put.apply(this, arguments);
        }
        return put;
      }()
      /**
       * Delete HTTP request to upstream service
       * @param {string} url Upstream service url
       * @param {headers} headers Set of custom headers
       * @param {body} body Body to send
       * @param {string} [grant] The product grant
       * @returns {Promise}
       */
    }, {
      key: "delete",
      value: function() {
        var _delete2 = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee8(url, headers, body, grant) {
          return _regeneratorRuntime__default2["default"].wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  this.telemetryTracker.sendTelemetry(exports.EventSendingLimitation.AnyEvents);
                  _context8.next = 3;
                  return this.upstream.send("DELETE", url, headers, body, grant);
                case 3:
                  return _context8.abrupt("return", _context8.sent);
                case 4:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8, this);
        }));
        function _delete(_x16, _x17, _x18, _x19) {
          return _delete2.apply(this, arguments);
        }
        return _delete;
      }()
      /**
       * Submits internal telemetry event. Not to be used for any customer and/or sensitive data.
       * @param {TelemetryEventDescription} event Event details.
       * @returns {void}
       */
    }, {
      key: "addTelemetryEvent",
      value: function addTelemetryEvent(event) {
        this.telemetryTracker.addTelemetryEvent(event);
        this.telemetryTracker.sendTelemetryIfMinimalPortionCollected();
      }
      /**
       * Submits internal telemetry event. Not to be used for any customer and/or sensitive data.
       * @param {TelemetryEventDescription} event Event details.
       * @param {string} eventKey Unique event key.
       * @param {TelemetryPoint} point Is this partial event for start or end of measurement.
       * @returns {void}
       */
    }, {
      key: "addPartialTelemetryEvent",
      value: function addPartialTelemetryEvent(event, eventKey, point) {
        this.telemetryTracker.addPartialEvent(event, eventKey, point);
        if (point === exports.TelemetryPoint.End) {
          this.telemetryTracker.sendTelemetryIfMinimalPortionCollected();
        }
      }
    }]);
    return TwilsockClient;
  }(EventEmitter2);
  exports.TwilsockClient = __decorate2([declarativeTypeValidator2.validateConstructorTypes(declarativeTypeValidator2.nonEmptyString, declarativeTypeValidator2.nonEmptyString, [declarativeTypeValidator2.pureObject, "undefined", declarativeTypeValidator2.literal(null)]), __metadata2("design:paramtypes", [String, String, Object])], exports.TwilsockClient);
  var InitRegistration = /* @__PURE__ */ function() {
    function InitRegistration2(product) {
      _classCallCheck__default2["default"](this, InitRegistration2);
      this.product = product;
      this.type = "ers";
      this.notification_protocol_version = 0;
      this.message_types = [];
    }
    _createClass__default2["default"](InitRegistration2, [{
      key: "populateInitRegistrations",
      value: function populateInitRegistrations(types) {
        var s = new Set(this.message_types);
        for (var idx in types) {
          s.add(types[idx]);
        }
        this.message_types = Array.from(s);
      }
    }]);
    return InitRegistration2;
  }();
  exports.InitRegistration = InitRegistration;
  exports.TelemetryEventDescription = TelemetryEventDescription;
  exports.TelemetryTracker = TelemetryTracker;
  exports.TransportUnavailableError = TransportUnavailableError;
  exports.Twilsock = exports.TwilsockClient;
  exports.TwilsockError = TwilsockError;
})(browser$6);
var browser$4 = {};
var DESCRIPTORS$3 = descriptors;
var uncurryThis$7 = functionUncurryThis;
var call$1 = functionCall;
var fails$3 = fails$M;
var objectKeys = objectKeys$4;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$1 = toObject$f;
var IndexedObject = indexedObject;
var $assign = Object.assign;
var defineProperty5 = Object.defineProperty;
var concat2 = uncurryThis$7([].concat);
var objectAssign = !$assign || fails$3(function() {
  if (DESCRIPTORS$3 && $assign({ b: 1 }, $assign(defineProperty5({}, "a", {
    enumerable: true,
    get: function() {
      defineProperty5(this, "b", {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1)
    return true;
  var A = {};
  var B = {};
  var symbol = Symbol("assign detection");
  var alphabet = "abcdefghijklmnopqrst";
  A[symbol] = 7;
  alphabet.split("").forEach(function(chr) {
    B[chr] = chr;
  });
  return $assign({}, A)[symbol] !== 7 || objectKeys($assign({}, B)).join("") !== alphabet;
}) ? function assign(target, source) {
  var T = toObject$1(target);
  var argumentsLength = arguments.length;
  var index2 = 1;
  var getOwnPropertySymbols2 = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable4 = propertyIsEnumerableModule.f;
  while (argumentsLength > index2) {
    var S = IndexedObject(arguments[index2++]);
    var keys6 = getOwnPropertySymbols2 ? concat2(objectKeys(S), getOwnPropertySymbols2(S)) : objectKeys(S);
    var length = keys6.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys6[j++];
      if (!DESCRIPTORS$3 || call$1(propertyIsEnumerable4, S, key))
        T[key] = S[key];
    }
  }
  return T;
} : $assign;
var $$8 = _export;
var assign$1 = objectAssign;
$$8({ target: "Object", stat: true, arity: 2, forced: Object.assign !== assign$1 }, {
  assign: assign$1
});
/*
@license
The MIT License (MIT)

Copyright (c) 2016 Twilio Inc.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.

*/
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var _asyncToGenerator2 = asyncToGeneratorExports;
  var _classCallCheck2 = classCallCheckExports;
  var _createClass2 = createClassExports;
  var _inherits2 = inheritsExports;
  var _possibleConstructorReturn2 = possibleConstructorReturnExports;
  var _getPrototypeOf2 = getPrototypeOfExports;
  var _regeneratorRuntime2 = regenerator;
  var _typeof2 = _typeofExports;
  var twilsock2 = browser$6;
  var _assertThisInitialized2 = assertThisInitializedExports;
  var _defineProperty2 = definePropertyExports;
  var operationRetrier2 = browser$7;
  var _slicedToArray2 = slicedToArrayExports;
  var _toConsumableArray2 = toConsumableArrayExports;
  var logger = loglevelExports$1;
  var uuid2 = uuid_1;
  var declarativeTypeValidator2 = browser$9;
  function _interopDefaultLegacy2(e) {
    return e && typeof e === "object" && "default" in e ? e : { "default": e };
  }
  function _interopNamespace2(e) {
    if (e && e.__esModule)
      return e;
    var n = /* @__PURE__ */ Object.create(null);
    if (e) {
      Object.keys(e).forEach(function(k) {
        if (k !== "default") {
          var d = Object.getOwnPropertyDescriptor(e, k);
          Object.defineProperty(n, k, d.get ? d : {
            enumerable: true,
            get: function() {
              return e[k];
            }
          });
        }
      });
    }
    n["default"] = e;
    return Object.freeze(n);
  }
  var _asyncToGenerator__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_asyncToGenerator2);
  var _classCallCheck__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_classCallCheck2);
  var _createClass__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_createClass2);
  var _inherits__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_inherits2);
  var _possibleConstructorReturn__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_possibleConstructorReturn2);
  var _getPrototypeOf__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_getPrototypeOf2);
  var _regeneratorRuntime__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_regeneratorRuntime2);
  var _typeof__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_typeof2);
  var _assertThisInitialized__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_assertThisInitialized2);
  var _defineProperty__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_defineProperty2);
  var _slicedToArray__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_slicedToArray2);
  var _toConsumableArray__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_toConsumableArray2);
  var logger__namespace = /* @__PURE__ */ _interopNamespace2(logger);
  var uuid__namespace2 = /* @__PURE__ */ _interopNamespace2(uuid2);
  function __decorate2(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof__default2["default"](Reflect)) === "object" && typeof Reflect.decorate === "function")
      r = Reflect.decorate(decorators, target, key, desc);
    else
      for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i])
          r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
      }
    return c > 3 && r && Object.defineProperty(target, key, r), r;
  }
  function __metadata2(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof__default2["default"](Reflect)) === "object" && typeof Reflect.metadata === "function")
      return Reflect.metadata(metadataKey, metadataValue);
  }
  var domain2;
  function EventHandlers2() {
  }
  EventHandlers2.prototype = /* @__PURE__ */ Object.create(null);
  function EventEmitter2() {
    EventEmitter2.init.call(this);
  }
  EventEmitter2.EventEmitter = EventEmitter2;
  EventEmitter2.usingDomains = false;
  EventEmitter2.prototype.domain = void 0;
  EventEmitter2.prototype._events = void 0;
  EventEmitter2.prototype._maxListeners = void 0;
  EventEmitter2.defaultMaxListeners = 10;
  EventEmitter2.init = function() {
    this.domain = null;
    if (EventEmitter2.usingDomains) {
      if (domain2.active)
        ;
    }
    if (!this._events || this._events === Object.getPrototypeOf(this)._events) {
      this._events = new EventHandlers2();
      this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || void 0;
  };
  EventEmitter2.prototype.setMaxListeners = function setMaxListeners4(n) {
    if (typeof n !== "number" || n < 0 || isNaN(n))
      throw new TypeError('"n" argument must be a positive number');
    this._maxListeners = n;
    return this;
  };
  function $getMaxListeners2(that) {
    if (that._maxListeners === void 0)
      return EventEmitter2.defaultMaxListeners;
    return that._maxListeners;
  }
  EventEmitter2.prototype.getMaxListeners = function getMaxListeners4() {
    return $getMaxListeners2(this);
  };
  function emitNone2(handler, isFn, self2) {
    if (isFn)
      handler.call(self2);
    else {
      var len = handler.length;
      var listeners4 = arrayClone2(handler, len);
      for (var i = 0; i < len; ++i)
        listeners4[i].call(self2);
    }
  }
  function emitOne2(handler, isFn, self2, arg1) {
    if (isFn)
      handler.call(self2, arg1);
    else {
      var len = handler.length;
      var listeners4 = arrayClone2(handler, len);
      for (var i = 0; i < len; ++i)
        listeners4[i].call(self2, arg1);
    }
  }
  function emitTwo2(handler, isFn, self2, arg1, arg2) {
    if (isFn)
      handler.call(self2, arg1, arg2);
    else {
      var len = handler.length;
      var listeners4 = arrayClone2(handler, len);
      for (var i = 0; i < len; ++i)
        listeners4[i].call(self2, arg1, arg2);
    }
  }
  function emitThree2(handler, isFn, self2, arg1, arg2, arg3) {
    if (isFn)
      handler.call(self2, arg1, arg2, arg3);
    else {
      var len = handler.length;
      var listeners4 = arrayClone2(handler, len);
      for (var i = 0; i < len; ++i)
        listeners4[i].call(self2, arg1, arg2, arg3);
    }
  }
  function emitMany2(handler, isFn, self2, args) {
    if (isFn)
      handler.apply(self2, args);
    else {
      var len = handler.length;
      var listeners4 = arrayClone2(handler, len);
      for (var i = 0; i < len; ++i)
        listeners4[i].apply(self2, args);
    }
  }
  EventEmitter2.prototype.emit = function emit4(type5) {
    var er, handler, len, args, i, events, domain3;
    var doError = type5 === "error";
    events = this._events;
    if (events)
      doError = doError && events.error == null;
    else if (!doError)
      return false;
    domain3 = this.domain;
    if (doError) {
      er = arguments[1];
      if (domain3) {
        if (!er)
          er = new Error('Uncaught, unspecified "error" event');
        er.domainEmitter = this;
        er.domain = domain3;
        er.domainThrown = false;
        domain3.emit("error", er);
      } else if (er instanceof Error) {
        throw er;
      } else {
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ")");
        err.context = er;
        throw err;
      }
      return false;
    }
    handler = events[type5];
    if (!handler)
      return false;
    var isFn = typeof handler === "function";
    len = arguments.length;
    switch (len) {
      case 1:
        emitNone2(handler, isFn, this);
        break;
      case 2:
        emitOne2(handler, isFn, this, arguments[1]);
        break;
      case 3:
        emitTwo2(handler, isFn, this, arguments[1], arguments[2]);
        break;
      case 4:
        emitThree2(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
        break;
      default:
        args = new Array(len - 1);
        for (i = 1; i < len; i++)
          args[i - 1] = arguments[i];
        emitMany2(handler, isFn, this, args);
    }
    return true;
  };
  function _addListener2(target, type5, listener, prepend) {
    var m;
    var events;
    var existing;
    if (typeof listener !== "function")
      throw new TypeError('"listener" argument must be a function');
    events = target._events;
    if (!events) {
      events = target._events = new EventHandlers2();
      target._eventsCount = 0;
    } else {
      if (events.newListener) {
        target.emit(
          "newListener",
          type5,
          listener.listener ? listener.listener : listener
        );
        events = target._events;
      }
      existing = events[type5];
    }
    if (!existing) {
      existing = events[type5] = listener;
      ++target._eventsCount;
    } else {
      if (typeof existing === "function") {
        existing = events[type5] = prepend ? [listener, existing] : [existing, listener];
      } else {
        if (prepend) {
          existing.unshift(listener);
        } else {
          existing.push(listener);
        }
      }
      if (!existing.warned) {
        m = $getMaxListeners2(target);
        if (m && m > 0 && existing.length > m) {
          existing.warned = true;
          var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + type5 + " listeners added. Use emitter.setMaxListeners() to increase limit");
          w.name = "MaxListenersExceededWarning";
          w.emitter = target;
          w.type = type5;
          w.count = existing.length;
          emitWarning2(w);
        }
      }
    }
    return target;
  }
  function emitWarning2(e) {
    typeof console.warn === "function" ? console.warn(e) : console.log(e);
  }
  EventEmitter2.prototype.addListener = function addListener4(type5, listener) {
    return _addListener2(this, type5, listener, false);
  };
  EventEmitter2.prototype.on = EventEmitter2.prototype.addListener;
  EventEmitter2.prototype.prependListener = function prependListener4(type5, listener) {
    return _addListener2(this, type5, listener, true);
  };
  function _onceWrap2(target, type5, listener) {
    var fired = false;
    function g() {
      target.removeListener(type5, g);
      if (!fired) {
        fired = true;
        listener.apply(target, arguments);
      }
    }
    g.listener = listener;
    return g;
  }
  EventEmitter2.prototype.once = function once4(type5, listener) {
    if (typeof listener !== "function")
      throw new TypeError('"listener" argument must be a function');
    this.on(type5, _onceWrap2(this, type5, listener));
    return this;
  };
  EventEmitter2.prototype.prependOnceListener = function prependOnceListener4(type5, listener) {
    if (typeof listener !== "function")
      throw new TypeError('"listener" argument must be a function');
    this.prependListener(type5, _onceWrap2(this, type5, listener));
    return this;
  };
  EventEmitter2.prototype.removeListener = function removeListener4(type5, listener) {
    var list, events, position, i, originalListener;
    if (typeof listener !== "function")
      throw new TypeError('"listener" argument must be a function');
    events = this._events;
    if (!events)
      return this;
    list = events[type5];
    if (!list)
      return this;
    if (list === listener || list.listener && list.listener === listener) {
      if (--this._eventsCount === 0)
        this._events = new EventHandlers2();
      else {
        delete events[type5];
        if (events.removeListener)
          this.emit("removeListener", type5, list.listener || listener);
      }
    } else if (typeof list !== "function") {
      position = -1;
      for (i = list.length; i-- > 0; ) {
        if (list[i] === listener || list[i].listener && list[i].listener === listener) {
          originalListener = list[i].listener;
          position = i;
          break;
        }
      }
      if (position < 0)
        return this;
      if (list.length === 1) {
        list[0] = void 0;
        if (--this._eventsCount === 0) {
          this._events = new EventHandlers2();
          return this;
        } else {
          delete events[type5];
        }
      } else {
        spliceOne2(list, position);
      }
      if (events.removeListener)
        this.emit("removeListener", type5, originalListener || listener);
    }
    return this;
  };
  EventEmitter2.prototype.off = function(type5, listener) {
    return this.removeListener(type5, listener);
  };
  EventEmitter2.prototype.removeAllListeners = function removeAllListeners4(type5) {
    var listeners4, events;
    events = this._events;
    if (!events)
      return this;
    if (!events.removeListener) {
      if (arguments.length === 0) {
        this._events = new EventHandlers2();
        this._eventsCount = 0;
      } else if (events[type5]) {
        if (--this._eventsCount === 0)
          this._events = new EventHandlers2();
        else
          delete events[type5];
      }
      return this;
    }
    if (arguments.length === 0) {
      var keys6 = Object.keys(events);
      for (var i = 0, key; i < keys6.length; ++i) {
        key = keys6[i];
        if (key === "removeListener")
          continue;
        this.removeAllListeners(key);
      }
      this.removeAllListeners("removeListener");
      this._events = new EventHandlers2();
      this._eventsCount = 0;
      return this;
    }
    listeners4 = events[type5];
    if (typeof listeners4 === "function") {
      this.removeListener(type5, listeners4);
    } else if (listeners4) {
      do {
        this.removeListener(type5, listeners4[listeners4.length - 1]);
      } while (listeners4[0]);
    }
    return this;
  };
  EventEmitter2.prototype.listeners = function listeners4(type5) {
    var evlistener;
    var ret;
    var events = this._events;
    if (!events)
      ret = [];
    else {
      evlistener = events[type5];
      if (!evlistener)
        ret = [];
      else if (typeof evlistener === "function")
        ret = [evlistener.listener || evlistener];
      else
        ret = unwrapListeners2(evlistener);
    }
    return ret;
  };
  EventEmitter2.listenerCount = function(emitter, type5) {
    if (typeof emitter.listenerCount === "function") {
      return emitter.listenerCount(type5);
    } else {
      return listenerCount2.call(emitter, type5);
    }
  };
  EventEmitter2.prototype.listenerCount = listenerCount2;
  function listenerCount2(type5) {
    var events = this._events;
    if (events) {
      var evlistener = events[type5];
      if (typeof evlistener === "function") {
        return 1;
      } else if (evlistener) {
        return evlistener.length;
      }
    }
    return 0;
  }
  EventEmitter2.prototype.eventNames = function eventNames4() {
    return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
  };
  function spliceOne2(list, index2) {
    for (var i = index2, k = i + 1, n = list.length; k < n; i += 1, k += 1)
      list[i] = list[k];
    list.pop();
  }
  function arrayClone2(arr, i) {
    var copy = new Array(i);
    while (i--)
      copy[i] = arr[i];
    return copy;
  }
  function unwrapListeners2(arr) {
    var ret = new Array(arr.length);
    for (var i = 0; i < ret.length; ++i) {
      ret[i] = arr[i].listener || arr[i];
    }
    return ret;
  }
  var log2 = logger__namespace.getLogger("twilio-notificatiions");
  function prepareLine2(prefix, args) {
    return ["".concat((/* @__PURE__ */ new Date()).toISOString(), " Twilio.Notifications ").concat(prefix, ":")].concat(Array.from(args));
  }
  var Logger = /* @__PURE__ */ function() {
    function Logger2() {
      _classCallCheck__default2["default"](this, Logger2);
    }
    _createClass__default2["default"](Logger2, [{
      key: "setLevel",
      value: function setLevel2(level) {
        log2.setLevel(level);
      }
    }, {
      key: "trace",
      value: function trace2() {
        if (log2.getLevel() == log2.levels.TRACE) {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          log2.debug.apply(null, prepareLine2("T", args));
        }
      }
    }, {
      key: "debug",
      value: function debug3() {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        log2.debug.apply(null, prepareLine2("D", args));
      }
    }, {
      key: "info",
      value: function info2() {
        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }
        log2.info.apply(null, prepareLine2("I", args));
      }
    }, {
      key: "warn",
      value: function warn2() {
        for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          args[_key4] = arguments[_key4];
        }
        log2.warn.apply(null, prepareLine2("W", args));
      }
    }, {
      key: "error",
      value: function error2() {
        for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
          args[_key5] = arguments[_key5];
        }
        log2.error.apply(null, prepareLine2("E", args));
      }
    }]);
    return Logger2;
  }();
  var logInstance = new Logger();
  function _createSuper$32(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$32();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf__default2["default"](Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf__default2["default"](this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn__default2["default"](this, result);
    };
  }
  function _isNativeReflectConstruct$32() {
    if (typeof Reflect === "undefined" || !Reflect.construct)
      return false;
    if (Reflect.construct.sham)
      return false;
    if (typeof Proxy === "function")
      return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  var RegistrationState = /* @__PURE__ */ _createClass__default2["default"](function RegistrationState2() {
    var token = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var notificationId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var messageTypes = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : /* @__PURE__ */ new Set();
    _classCallCheck__default2["default"](this, RegistrationState2);
    this.token = token;
    this.notificationId = notificationId;
    this.messageTypes = messageTypes;
  });
  function setDifference(a, b) {
    return [].concat(_toConsumableArray__default2["default"](_toConsumableArray__default2["default"](a).filter(function(x) {
      return !b.has(x);
    })), _toConsumableArray__default2["default"](_toConsumableArray__default2["default"](b).filter(function(x) {
      return !a.has(x);
    })));
  }
  function hasDifference(a, b) {
    var reasons = /* @__PURE__ */ new Set();
    if (a.notificationId !== b.notificationId) {
      reasons.add("notificationId");
    }
    if (a.token !== b.token) {
      reasons.add("token");
    }
    if (setDifference(a.messageTypes, b.messageTypes).length > 0) {
      reasons.add("messageType");
    }
    return [reasons.size > 0, reasons];
  }
  var Connector = /* @__PURE__ */ function(_EventEmitter) {
    _inherits__default2["default"](Connector2, _EventEmitter);
    var _super = _createSuper$32(Connector2);
    function Connector2(channelType) {
      var _this;
      _classCallCheck__default2["default"](this, Connector2);
      _this = _super.call(this);
      _defineProperty__default2["default"](_assertThisInitialized__default2["default"](_this), "desiredState", new RegistrationState());
      _defineProperty__default2["default"](_assertThisInitialized__default2["default"](_this), "currentState", new RegistrationState());
      _defineProperty__default2["default"](_assertThisInitialized__default2["default"](_this), "_hasActiveAttempt", false);
      _this.channelType = channelType;
      return _this;
    }
    _createClass__default2["default"](Connector2, [{
      key: "setNotificationId",
      value: function setNotificationId(notificationId) {
        this.desiredState.notificationId = notificationId;
      }
      /**
       * Return true is this connector is in usable state and should be able to commit changes.
       */
    }, {
      key: "isActive",
      value: function isActive() {
        return this.desiredState.notificationId !== "";
      }
    }, {
      key: "subscribe",
      value: function subscribe(messageType) {
        if (this.desiredState.messageTypes.has(messageType)) {
          logInstance.debug("message type '".concat(messageType, "' for channel ").concat(this.channelType, " is already registered"));
          return;
        }
        this.desiredState.messageTypes.add(messageType);
      }
    }, {
      key: "unsubscribe",
      value: function unsubscribe(messageType) {
        if (!this.desiredState.messageTypes.has(messageType)) {
          return;
        }
        this.desiredState.messageTypes.delete(messageType);
      }
    }, {
      key: "updateToken",
      value: function updateToken(token) {
        this.desiredState.token = token;
      }
      /**
       * Perform actual registration after all required changes are settled.
       */
    }, {
      key: "commitChanges",
      value: function() {
        var _commitChanges = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee() {
          var _hasDifference, _hasDifference2, needToUpdate, reasons, stateToPersist, persistedState;
          return _regeneratorRuntime__default2["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!this._hasActiveAttempt) {
                    _context.next = 3;
                    break;
                  }
                  logInstance.error("One registration attempt is already in progress");
                  throw new Error("One registration attempt is already in progress");
                case 3:
                  _hasDifference = hasDifference(this.desiredState, this.currentState), _hasDifference2 = _slicedToArray__default2["default"](_hasDifference, 2), needToUpdate = _hasDifference2[0], reasons = _hasDifference2[1];
                  if (needToUpdate) {
                    _context.next = 6;
                    break;
                  }
                  return _context.abrupt("return");
                case 6:
                  if (!this.currentState.notificationId) {
                    reasons.delete("notificationId");
                  }
                  logInstance.trace("Persisting ".concat(this.channelType, " registration"), reasons, this.desiredState);
                  _context.prev = 8;
                  this._hasActiveAttempt = true;
                  stateToPersist = new RegistrationState();
                  stateToPersist.token = this.desiredState.token;
                  stateToPersist.notificationId = this.desiredState.notificationId;
                  stateToPersist.messageTypes = new Set(this.desiredState.messageTypes);
                  if (!(stateToPersist.messageTypes.size > 0)) {
                    _context.next = 24;
                    break;
                  }
                  _context.next = 17;
                  return this.updateRegistration(stateToPersist, reasons);
                case 17:
                  persistedState = _context.sent;
                  this.currentState.token = persistedState.token;
                  this.currentState.notificationId = persistedState.notificationId;
                  this.currentState.messageTypes = new Set(persistedState.messageTypes);
                  this.emit("stateChanged", this.channelType, "registered", this.currentState);
                  _context.next = 30;
                  break;
                case 24:
                  _context.next = 26;
                  return this.removeRegistration();
                case 26:
                  this.currentState.token = stateToPersist.token;
                  this.currentState.notificationId = stateToPersist.notificationId;
                  this.currentState.messageTypes.clear();
                  this.emit("stateChanged", this.channelType, "unregistered", this.currentState);
                case 30:
                  _context.next = 35;
                  break;
                case 32:
                  _context.prev = 32;
                  _context.t0 = _context["catch"](8);
                  throw _context.t0;
                case 35:
                  _context.prev = 35;
                  this._hasActiveAttempt = false;
                  return _context.finish(35);
                case 38:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this, [[8, 32, 35, 38]]);
        }));
        function commitChanges() {
          return _commitChanges.apply(this, arguments);
        }
        return commitChanges;
      }()
    }]);
    return Connector2;
  }(EventEmitter2);
  function _createSuper$22(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$22();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf__default2["default"](Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf__default2["default"](this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn__default2["default"](this, result);
    };
  }
  function _isNativeReflectConstruct$22() {
    if (typeof Reflect === "undefined" || !Reflect.construct)
      return false;
    if (Reflect.construct.sham)
      return false;
    if (typeof Proxy === "function")
      return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  var retrierConfig = {
    min: 2e3,
    max: 12e4,
    randomness: 0.2
  };
  var RegistrarConnector = /* @__PURE__ */ function(_Connector) {
    _inherits__default2["default"](RegistrarConnector2, _Connector);
    var _super = _createSuper$22(RegistrarConnector2);
    function RegistrarConnector2(channelType, context, twilsock3, registrarUrl) {
      var _this;
      _classCallCheck__default2["default"](this, RegistrarConnector2);
      _this = _super.call(this, channelType);
      _defineProperty__default2["default"](_assertThisInitialized__default2["default"](_this), "registrationId", null);
      _this.context = context;
      _this.twilsock = twilsock3;
      _this.registrarUrl = registrarUrl;
      return _this;
    }
    _createClass__default2["default"](RegistrarConnector2, [{
      key: "updateRegistration",
      value: function() {
        var _updateRegistration = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee(registration, reasons) {
          var _this2 = this;
          var registrarRequest, productId, url, headers, response;
          return _regeneratorRuntime__default2["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!reasons.has("notificationId")) {
                    _context.next = 3;
                    break;
                  }
                  _context.next = 3;
                  return this.removeRegistration();
                case 3:
                  if (!(!registration.notificationId || !registration.notificationId.length)) {
                    _context.next = 6;
                    break;
                  }
                  logInstance.error("No push notification ID for registration");
                  throw new Error("No push notification ID for registration");
                case 6:
                  logInstance.trace("Registering", this.channelType, registration);
                  registrarRequest = {
                    endpoint_platform: this.context.platform,
                    channel_type: this.channelType,
                    version: this.context.protocolVersion.toString(),
                    message_types: Array.from(registration.messageTypes),
                    data: {
                      registration_id: registration.notificationId
                    }
                    //ttl: 'PT24H' - This is totally ignored by notify, all bindings use PT1Y ttl.
                  };
                  productId = this.context.productId;
                  url = "".concat(this.registrarUrl, "?productId=").concat(productId);
                  headers = {
                    "Content-Type": "application/json"
                    // 'X-Twilio-Token': registration.token
                  };
                  logInstance.trace("Creating registration for channel ".concat(this.channelType));
                  _context.prev = 12;
                  _context.next = 15;
                  return new operationRetrier2.AsyncRetrier(retrierConfig).run(function() {
                    return _this2.twilsock.post(url, headers, registrarRequest, productId);
                  });
                case 15:
                  response = _context.sent;
                  this.registrationId = response.body.id;
                  logInstance.debug("Registration created: ", response);
                  _context.next = 24;
                  break;
                case 20:
                  _context.prev = 20;
                  _context.t0 = _context["catch"](12);
                  logInstance.error("Registration failed: ", _context.t0);
                  throw _context.t0;
                case 24:
                  return _context.abrupt("return", registration);
                case 25:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this, [[12, 20]]);
        }));
        function updateRegistration(_x, _x2) {
          return _updateRegistration.apply(this, arguments);
        }
        return updateRegistration;
      }()
    }, {
      key: "removeRegistration",
      value: function() {
        var _removeRegistration = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee2() {
          var _this3 = this;
          var productId, url, headers;
          return _regeneratorRuntime__default2["default"].wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (this.registrationId) {
                    _context2.next = 2;
                    break;
                  }
                  return _context2.abrupt("return");
                case 2:
                  productId = this.context.productId;
                  url = "".concat(this.registrarUrl, "/").concat(this.registrationId, "?productId=").concat(productId);
                  headers = {
                    "Content-Type": "application/json"
                    // 'X-Twilio-Token': this.config.token
                  };
                  logInstance.trace("Removing registration for ".concat(this.channelType));
                  _context2.prev = 6;
                  _context2.next = 9;
                  return new operationRetrier2.AsyncRetrier(Object.assign(retrierConfig, {
                    maxAttemptsCount: 3
                  })).run(function() {
                    return _this3.twilsock.delete(url, headers, {}, productId);
                  });
                case 9:
                  this.registrationId = null;
                  this.currentState.notificationId = "";
                  logInstance.debug("Registration removed for ".concat(this.channelType));
                  _context2.next = 18;
                  break;
                case 14:
                  _context2.prev = 14;
                  _context2.t0 = _context2["catch"](6);
                  logInstance.error("Failed to remove registration ", this.channelType, _context2.t0);
                  throw _context2.t0;
                case 18:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this, [[6, 14]]);
        }));
        function removeRegistration() {
          return _removeRegistration.apply(this, arguments);
        }
        return removeRegistration;
      }()
    }, {
      key: "sendDeviceRemoveRequest",
      value: function() {
        var _sendDeviceRemoveRequest = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee3(registrationId) {
          var _this4 = this;
          var productId, url, headers, payload;
          return _regeneratorRuntime__default2["default"].wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (!(registrationId === "")) {
                    _context3.next = 2;
                    break;
                  }
                  throw new Error("Empty registration ID");
                case 2:
                  productId = this.context.productId;
                  url = "".concat(this.registrarUrl, "?productId=").concat(productId);
                  headers = {
                    "Content-Type": "application/json"
                    // @todo Content-Length??
                  };
                  payload = {
                    binding_type: this.channelType,
                    address: registrationId
                  };
                  _context3.prev = 6;
                  logInstance.trace("Removing old registrations for ".concat(this.channelType));
                  _context3.next = 10;
                  return new operationRetrier2.AsyncRetrier(Object.assign(retrierConfig, {
                    maxAttemptsCount: 3
                  })).run(function() {
                    return _this4.twilsock.delete(url, headers, payload, productId);
                  });
                case 10:
                  this.registrationId = null;
                  this.currentState.notificationId = "";
                  logInstance.debug("Registration removed for ".concat(this.channelType));
                  _context3.next = 19;
                  break;
                case 15:
                  _context3.prev = 15;
                  _context3.t0 = _context3["catch"](6);
                  logInstance.error("Failed to remove registration ", this.channelType, _context3.t0);
                  throw _context3.t0;
                case 19:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this, [[6, 15]]);
        }));
        function sendDeviceRemoveRequest(_x3) {
          return _sendDeviceRemoveRequest.apply(this, arguments);
        }
        return sendDeviceRemoveRequest;
      }()
    }]);
    return RegistrarConnector2;
  }(Connector);
  function _createSuper$12(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$12();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf__default2["default"](Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf__default2["default"](this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn__default2["default"](this, result);
    };
  }
  function _isNativeReflectConstruct$12() {
    if (typeof Reflect === "undefined" || !Reflect.construct)
      return false;
    if (Reflect.construct.sham)
      return false;
    if (typeof Proxy === "function")
      return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  var TwilsockConnector = /* @__PURE__ */ function(_Connector) {
    _inherits__default2["default"](TwilsockConnector2, _Connector);
    var _super = _createSuper$12(TwilsockConnector2);
    function TwilsockConnector2(productId, platform2, twilsock3) {
      var _this;
      _classCallCheck__default2["default"](this, TwilsockConnector2);
      _this = _super.call(this, "twilsock");
      _defineProperty__default2["default"](_assertThisInitialized__default2["default"](_this), "contextId", uuid__namespace2.v4());
      _this.productId = productId;
      _this.platform = platform2;
      _this.twilsock = twilsock3;
      return _this;
    }
    _createClass__default2["default"](TwilsockConnector2, [{
      key: "updateRegistration",
      value: function() {
        var _updateRegistration = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee(registration, reasons) {
          var messageTypes, context;
          return _regeneratorRuntime__default2["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (reasons.has("messageType")) {
                    _context.next = 2;
                    break;
                  }
                  return _context.abrupt("return", registration);
                case 2:
                  messageTypes = Array.from(registration.messageTypes);
                  context = {
                    product_id: this.productId,
                    notification_protocol_version: 4,
                    endpoint_platform: this.platform,
                    message_types: messageTypes
                  };
                  _context.prev = 4;
                  _context.next = 7;
                  return this.twilsock.setNotificationsContext(this.contextId, context);
                case 7:
                  _context.next = 13;
                  break;
                case 9:
                  _context.prev = 9;
                  _context.t0 = _context["catch"](4);
                  logInstance.error("Failed to update twilsock notification context: ".concat(_context.t0));
                  throw _context.t0;
                case 13:
                  return _context.abrupt("return", registration);
                case 14:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this, [[4, 9]]);
        }));
        function updateRegistration(_x, _x2) {
          return _updateRegistration.apply(this, arguments);
        }
        return updateRegistration;
      }()
    }, {
      key: "removeRegistration",
      value: function() {
        var _removeRegistration = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee2() {
          return _regeneratorRuntime__default2["default"].wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.prev = 0;
                  _context2.next = 3;
                  return this.twilsock.removeNotificationsContext(this.contextId);
                case 3:
                  _context2.next = 9;
                  break;
                case 5:
                  _context2.prev = 5;
                  _context2.t0 = _context2["catch"](0);
                  logInstance.error("Failed to remove twilsock notification context: ".concat(_context2.t0));
                  throw _context2.t0;
                case 9:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this, [[0, 5]]);
        }));
        function removeRegistration() {
          return _removeRegistration.apply(this, arguments);
        }
        return removeRegistration;
      }()
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    }, {
      key: "sendDeviceRemoveRequest",
      value: function() {
        var _sendDeviceRemoveRequest = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee3(registrationId) {
          return _regeneratorRuntime__default2["default"].wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));
        function sendDeviceRemoveRequest(_x3) {
          return _sendDeviceRemoveRequest.apply(this, arguments);
        }
        return sendDeviceRemoveRequest;
      }()
    }]);
    return TwilsockConnector2;
  }(Connector);
  function _createSuper2(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct2();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf__default2["default"](Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf__default2["default"](this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn__default2["default"](this, result);
    };
  }
  function _isNativeReflectConstruct2() {
    if (typeof Reflect === "undefined" || !Reflect.construct)
      return false;
    if (Reflect.construct.sham)
      return false;
    if (typeof Proxy === "function")
      return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  var Client_1;
  var channelTypeRule = declarativeTypeValidator2.literal("apn", "fcm", "twilsock");
  exports.Notifications = Client_1 = /* @__PURE__ */ function(_EventEmitter) {
    _inherits__default2["default"](Client2, _EventEmitter);
    var _super = _createSuper2(Client2);
    function Client2(token) {
      var _options$logLevel, _options$productId, _options$twilsockClie, _options$notification, _ref, _config$region;
      var _this;
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      _classCallCheck__default2["default"](this, Client2);
      _this = _super.call(this);
      options.logLevel = (_options$logLevel = options.logLevel) !== null && _options$logLevel !== void 0 ? _options$logLevel : "error";
      logInstance.setLevel(options.logLevel);
      var productId = (_options$productId = options.productId) !== null && _options$productId !== void 0 ? _options$productId : "notifications";
      var startTwilsock = !options.twilsockClient;
      var twilsock$1 = options.twilsockClient = (_options$twilsockClie = options.twilsockClient) !== null && _options$twilsockClie !== void 0 ? _options$twilsockClie : new twilsock2.TwilsockClient(token, productId, options);
      var config = (_options$notification = options.notifications) !== null && _options$notification !== void 0 ? _options$notification : {};
      var region = (_ref = (_config$region = config.region) !== null && _config$region !== void 0 ? _config$region : options.region) !== null && _ref !== void 0 ? _ref : "us1";
      var defaultUrl = "https://ers.".concat(region, ".twilio.com/v1/registrations");
      var registrarUrl = config.ersUrl || defaultUrl;
      _this.connectors = /* @__PURE__ */ new Map();
      var platform2 = Client_1._detectPlatform();
      _this.connectors.set("apn", new RegistrarConnector("apn", {
        protocolVersion: 4,
        productId,
        platform: platform2
      }, twilsock$1, registrarUrl));
      _this.connectors.set("fcm", new RegistrarConnector("fcm", {
        protocolVersion: 3,
        productId,
        platform: platform2
      }, twilsock$1, registrarUrl));
      _this.connectors.set("twilsock", new TwilsockConnector(productId, platform2, twilsock$1));
      twilsock$1.on("stateChanged", function(state) {
        return _this.emit("transportState", state);
      });
      _this._connector("twilsock").on("stateChanged", function(type5, value, state) {
        return _this.emit("stateChanged", type5, value, state);
      });
      _this._connector("apn").on("stateChanged", function(type5, value, state) {
        return _this.emit("stateChanged", type5, value, state);
      });
      _this._connector("fcm").on("stateChanged", function(type5, value, state) {
        return _this.emit("stateChanged", type5, value, state);
      });
      twilsock$1.on("message", function(type5, message) {
        return _this._routeMessage(type5, message);
      });
      _this.updateToken(token);
      if (startTwilsock) {
        twilsock$1.connect();
        _this.twilsock = twilsock$1;
      }
      return _this;
    }
    _createClass__default2["default"](Client2, [{
      key: "shutdown",
      value: function() {
        var _shutdown = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee() {
          return _regeneratorRuntime__default2["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  this.connectors.clear();
                  if (!this.twilsock) {
                    _context.next = 4;
                    break;
                  }
                  _context.next = 4;
                  return this.twilsock.disconnect();
                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));
        function shutdown() {
          return _shutdown.apply(this, arguments);
        }
        return shutdown;
      }()
      /**
       * Set OS-provided APNS/FCM registration binding for the given channel type. Not used for 'twilsock'.
       *
       * You must call this function once you've received the ID of your device from the underlying OS.
       *
       * @param {ChannelType} channelType Channel type ('apn'/'fcm').
       * @param {string} pushRegistrationId Token received from FCM/APNS system on device.
       */
    }, {
      key: "setPushRegistrationId",
      value: function setPushRegistrationId(channelType, pushRegistrationId) {
        logInstance.debug("Set ".concat(channelType, " push registration id '").concat(pushRegistrationId, "'"));
        this._connector(channelType).setNotificationId(pushRegistrationId);
      }
      /**
       * Subscribe to a given message type for a given channel type.
       *
       * Creates a subscriptions to receive incoming messages according to message type.
       * Subscription establishes a binding and you will receive a signal when a notification
       * of this type has been received by the library.
       *
       * Subscribed binding is preserved for 1 year, after which time it needs to be re-subscribed.
       * This is the responsibility of the client SDK.
       *
       * @param {ChannelType} channelType Supported are 'twilsock', 'apn' and 'fcm'
       * @param {string} messageType The type of message that you want to receive
       */
    }, {
      key: "subscribe",
      value: function subscribe(channelType, messageType) {
        logInstance.debug("Add ".concat(channelType, " subscriptions for message type ").concat(messageType));
        this._connector(channelType).subscribe(messageType);
      }
      /**
       * Unsubscribe from a given message type.
       *
       * Unsubscribing breaks a binding and you will not receive more notifications for this message type.
       * Please note that you have to call commitChanges() and receive a successful result before
       * the subscription is actually removed.
       *
       * @param {ChannelType} channelType Supported are 'twilsock', 'apn' and 'fcm'
       * @param {string} messageType The type of message that you don't want to receive anymore
       */
    }, {
      key: "unsubscribe",
      value: function unsubscribe(channelType, messageType) {
        logInstance.debug("Remove ".concat(channelType, " subscriptions for message type ").concat(messageType));
        this._connector(channelType).unsubscribe(messageType);
      }
      /**
       * Update subscription token. You must update the token when the old one expires.
       *
       * When you receive onTokenWillExpire event from twilsock, call this function with the new refreshed
       * token _after_ you have updated twilsock and other associated objects with the new token.
       *
       * @param {string} token Authentication token for registrations
       */
    }, {
      key: "updateToken",
      value: function updateToken(token) {
        this.connectors.forEach(function(connector) {
          return connector.updateToken(token);
        });
      }
      /**
       * Commit all collected subscription changes as a batched update. This function tries to reduce
       * number of network calls necessary to update bindings status.
       */
    }, {
      key: "commitChanges",
      value: function() {
        var _commitChanges = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee2() {
          var promises;
          return _regeneratorRuntime__default2["default"].wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  promises = [];
                  this.connectors.forEach(function(connector) {
                    if (connector.isActive()) {
                      promises.push(connector.commitChanges());
                    }
                  });
                  _context2.next = 4;
                  return Promise.all(promises);
                case 4:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));
        function commitChanges() {
          return _commitChanges.apply(this, arguments);
        }
        return commitChanges;
      }()
      /**
       * Clear existing registrations directly using provided device token.
       * This is useful to ensure stopped subscriptions without resubscribing.
       *
       * This function goes completely beside the state machine and removes all registrations.
       * Use with caution: if it races with current state machine operations, madness will ensue.
       *
       * @param {ChannelType} channelType Channel type ('apn'/'fcm').
       * @param {string} registrationId Token received from FCM/APNS system on device.
       */
    }, {
      key: "removeRegistrations",
      value: function() {
        var _removeRegistrations = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee3(channelType, registrationId) {
          return _regeneratorRuntime__default2["default"].wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return this._connector(channelType).sendDeviceRemoveRequest(registrationId);
                case 2:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));
        function removeRegistrations(_x, _x2) {
          return _removeRegistrations.apply(this, arguments);
        }
        return removeRegistrations;
      }()
      /**
       * Handle incoming push notification.
       * Client application should call this method when it receives push notifications and pass the received data.
       * @param {Object} message push message
       * @return {PushNotification} A reformatted payload with extracted message type.
       */
    }, {
      key: "handlePushNotification",
      value: function handlePushNotification(message) {
        return {
          messageType: message.twi_message_type,
          payload: message.payload
        };
      }
      /**
       * Routes messages to the external subscribers
       */
    }, {
      key: "_routeMessage",
      value: function _routeMessage(type5, message) {
        logInstance.debug("Notification message arrived: ", type5, message);
        this.emit("message", type5, message);
      }
      /**
       * @param {String} type Channel type
       * @throws {Error} Error with description
       */
    }, {
      key: "_connector",
      value: function _connector(type5) {
        var connector = this.connectors.get(type5);
        if (!connector) {
          throw new Error("Unknown channel type: ".concat(type5));
        }
        return connector;
      }
      /**
       * Returns platform string limited to max 128 chars
       */
    }], [{
      key: "_detectPlatform",
      value: function _detectPlatform() {
        var platform2 = "";
        if (typeof navigator !== "undefined") {
          platform2 = "unknown";
          if (typeof navigator.product !== "undefined") {
            platform2 = navigator.product;
          }
          if (typeof navigator.userAgent !== "undefined") {
            platform2 = navigator.userAgent;
          }
        } else {
          platform2 = "web";
        }
        return platform2.substring(0, 128);
      }
    }]);
    return Client2;
  }(EventEmitter2);
  __decorate2([declarativeTypeValidator2.validateTypes(channelTypeRule, declarativeTypeValidator2.nonEmptyString), __metadata2("design:type", Function), __metadata2("design:paramtypes", [String, String]), __metadata2("design:returntype", void 0)], exports.Notifications.prototype, "setPushRegistrationId", null);
  __decorate2([declarativeTypeValidator2.validateTypes(channelTypeRule, declarativeTypeValidator2.nonEmptyString), __metadata2("design:type", Function), __metadata2("design:paramtypes", [String, String]), __metadata2("design:returntype", void 0)], exports.Notifications.prototype, "subscribe", null);
  __decorate2([declarativeTypeValidator2.validateTypes(channelTypeRule, declarativeTypeValidator2.nonEmptyString), __metadata2("design:type", Function), __metadata2("design:paramtypes", [String, String]), __metadata2("design:returntype", void 0)], exports.Notifications.prototype, "unsubscribe", null);
  __decorate2([declarativeTypeValidator2.validateTypes(declarativeTypeValidator2.nonEmptyString), __metadata2("design:type", Function), __metadata2("design:paramtypes", [String]), __metadata2("design:returntype", void 0)], exports.Notifications.prototype, "updateToken", null);
  __decorate2([declarativeTypeValidator2.validateTypesAsync(channelTypeRule, declarativeTypeValidator2.nonEmptyString), __metadata2("design:type", Function), __metadata2("design:paramtypes", [String, String]), __metadata2("design:returntype", Promise)], exports.Notifications.prototype, "removeRegistrations", null);
  exports.Notifications = Client_1 = __decorate2([declarativeTypeValidator2.validateConstructorTypes(declarativeTypeValidator2.nonEmptyString, [declarativeTypeValidator2.pureObject, "undefined", declarativeTypeValidator2.literal(null)]), __metadata2("design:paramtypes", [String, Object])], exports.Notifications);
})(browser$4);
var browser$3 = {};
var browser$2 = {};
/*
@license
Copyright (c) 2021 Twilio Inc.

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.


*/
Object.defineProperty(browser$2, "__esModule", { value: true });
var _typeof$1 = _typeofExports;
var _slicedToArray$1 = slicedToArrayExports;
var _toConsumableArray = toConsumableArrayExports;
var _classCallCheck$1 = classCallCheckExports;
var _inherits$1 = inheritsExports;
var _possibleConstructorReturn$1 = possibleConstructorReturnExports;
var _getPrototypeOf$1 = getPrototypeOfExports;
function _interopDefaultLegacy$2(e) {
  return e && typeof e === "object" && "default" in e ? e : { "default": e };
}
var _typeof__default$1 = /* @__PURE__ */ _interopDefaultLegacy$2(_typeof$1);
var _slicedToArray__default$1 = /* @__PURE__ */ _interopDefaultLegacy$2(_slicedToArray$1);
var _toConsumableArray__default = /* @__PURE__ */ _interopDefaultLegacy$2(_toConsumableArray);
var _classCallCheck__default$1 = /* @__PURE__ */ _interopDefaultLegacy$2(_classCallCheck$1);
var _inherits__default$1 = /* @__PURE__ */ _interopDefaultLegacy$2(_inherits$1);
var _possibleConstructorReturn__default$1 = /* @__PURE__ */ _interopDefaultLegacy$2(_possibleConstructorReturn$1);
var _getPrototypeOf__default$1 = /* @__PURE__ */ _interopDefaultLegacy$2(_getPrototypeOf$1);
var custom3 = function custom4() {
  for (var _len = arguments.length, checks = new Array(_len), _key = 0; _key < _len; _key++) {
    checks[_key] = arguments[_key];
  }
  return {
    checks
  };
};
function _createForOfIteratorHelper$3$1(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$3$1(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i = 0;
      var F = function F2() {
      };
      return { s: F, n: function n() {
        if (i >= o.length)
          return { done: true };
        return { done: false, value: o[i++] };
      }, e: function e(_e) {
        throw _e;
      }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return { s: function s() {
    it = it.call(o);
  }, n: function n() {
    var step = it.next();
    normalCompletion = step.done;
    return step;
  }, e: function e(_e2) {
    didErr = true;
    err = _e2;
  }, f: function f() {
    try {
      if (!normalCompletion && it.return != null)
        it.return();
    } finally {
      if (didErr)
        throw err;
    }
  } };
}
function _unsupportedIterableToArray$3$1(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$3$1(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$3$1(o, minLen);
}
function _arrayLikeToArray$3$1(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var type3 = function type4() {
  for (var _len = arguments.length, checks = new Array(_len), _key = 0; _key < _len; _key++) {
    checks[_key] = arguments[_key];
  }
  return custom3(function(value) {
    var isValid = false;
    var expectedTypes = [];
    var _iterator = _createForOfIteratorHelper$3$1(checks), _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        var _type = _step.value;
        if (typeof _type === "string") {
          isValid = isValid || _typeof__default$1["default"](value) === _type;
          expectedTypes.push("of type ".concat(_type));
          continue;
        }
        isValid = isValid || value instanceof _type;
        expectedTypes.push("an instance of ".concat(_type.name));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return [isValid, expectedTypes];
  });
};
function _createForOfIteratorHelper$2$1(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$2$1(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i = 0;
      var F = function F2() {
      };
      return { s: F, n: function n() {
        if (i >= o.length)
          return { done: true };
        return { done: false, value: o[i++] };
      }, e: function e(_e) {
        throw _e;
      }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return { s: function s() {
    it = it.call(o);
  }, n: function n() {
    var step = it.next();
    normalCompletion = step.done;
    return step;
  }, e: function e(_e2) {
    didErr = true;
    err = _e2;
  }, f: function f() {
    try {
      if (!normalCompletion && it.return != null)
        it.return();
    } finally {
      if (didErr)
        throw err;
    }
  } };
}
function _unsupportedIterableToArray$2$1(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$2$1(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$2$1(o, minLen);
}
function _arrayLikeToArray$2$1(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var literal3 = function literal4() {
  for (var _len = arguments.length, checks = new Array(_len), _key = 0; _key < _len; _key++) {
    checks[_key] = arguments[_key];
  }
  return custom3(function(value) {
    var isValid = false;
    var expectedTypes = [];
    var _iterator = _createForOfIteratorHelper$2$1(checks), _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        var type5 = _step.value;
        isValid = isValid || value === type5;
        expectedTypes.push(typeof type5 === "string" ? '"'.concat(type5, '"') : "".concat(type5));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return [isValid, expectedTypes];
  });
};
var nonEmptyString = custom3(function(value) {
  return [typeof value === "string" && value.length > 0, "a non-empty string"];
});
var nonNegativeInteger = custom3(function(value) {
  return [typeof value === "number" && Number.isInteger(value) && value >= 0, "a non-negative integer"];
});
var pureObject = custom3(function(value) {
  return [_typeof__default$1["default"](value) === "object" && value !== null && !Array.isArray(value), "a pure object (non-null and non-array)"];
});
function _createSuper$8(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$8();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf__default$1["default"](Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf__default$1["default"](this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn__default$1["default"](this, result);
  };
}
function _isNativeReflectConstruct$8() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _createForOfIteratorHelper$1$1(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$1$1(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i = 0;
      var F = function F2() {
      };
      return { s: F, n: function n() {
        if (i >= o.length)
          return { done: true };
        return { done: false, value: o[i++] };
      }, e: function e(_e) {
        throw _e;
      }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return { s: function s() {
    it = it.call(o);
  }, n: function n() {
    var step = it.next();
    normalCompletion = step.done;
    return step;
  }, e: function e(_e2) {
    didErr = true;
    err = _e2;
  }, f: function f() {
    try {
      if (!normalCompletion && it.return != null)
        it.return();
    } finally {
      if (didErr)
        throw err;
    }
  } };
}
function _unsupportedIterableToArray$1$1(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$1$1(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$1$1(o, minLen);
}
function _arrayLikeToArray$1$1(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var runtimeTypeValidation3 = function runtimeTypeValidation4(rules, values4) {
  if (values4.length > rules.length) {
    throw new Error("Expected at most ".concat(rules.length, " argument(s), but got ").concat(values4.length));
  }
  while (values4.length < rules.length) {
    values4.push(void 0);
  }
  var _iterator = _createForOfIteratorHelper$1$1(values4.entries()), _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done; ) {
      var _step$value = _slicedToArray__default$1["default"](_step.value, 2), index2 = _step$value[0], value = _step$value[1];
      var _validateValue = validateValue3(rules[index2], value), _validateValue2 = _slicedToArray__default$1["default"](_validateValue, 4), isValid = _validateValue2[0], received = _validateValue2[1], expected = _validateValue2[2], delimeter = _validateValue2[3];
      if (isValid) {
        continue;
      }
      var argumentIndex = index2 + 1;
      throw new Error("Argument ".concat(argumentIndex, " is expected to be ").concat(expected).concat(delimeter, " but got ").concat(received));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};
var stringifyReceivedType3 = function stringifyReceivedType4(value) {
  var _value$constructor;
  var receivedType;
  var types = ["undefined", "boolean", "number", "bigint", "string"];
  if (types.includes(_typeof__default$1["default"](value))) {
    receivedType = typeof value === "string" ? '"'.concat(value, '"') : "".concat(value);
  }
  if (_typeof__default$1["default"](value) === "object" && (value === null || value === void 0 ? void 0 : (_value$constructor = value.constructor) === null || _value$constructor === void 0 ? void 0 : _value$constructor.name) !== "Object") {
    var _value$constructor2;
    receivedType = value === null ? "null" : "instance of ".concat(value === null || value === void 0 ? void 0 : (_value$constructor2 = value.constructor) === null || _value$constructor2 === void 0 ? void 0 : _value$constructor2.name);
  }
  if (!receivedType) {
    receivedType = _typeof__default$1["default"](value);
  }
  return receivedType;
};
var validateConstructorTypes3 = function validateConstructorTypes4() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var finalRuleSet = convertRuleArguments3(args);
  return function(ctor) {
    return /* @__PURE__ */ function(_ctor) {
      _inherits__default$1["default"](_class, _ctor);
      var _super = _createSuper$8(_class);
      function _class() {
        _classCallCheck__default$1["default"](this, _class);
        for (var _len2 = arguments.length, args2 = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args2[_key2] = arguments[_key2];
        }
        runtimeTypeValidation3(finalRuleSet, args2);
        return _super.call.apply(_super, [this].concat(args2));
      }
      return _class;
    }(ctor);
  };
};
var validateTypes3 = function validateTypes4() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }
  var finalRuleSet = convertRuleArguments3(args);
  return function(target, propertyKey, descriptor) {
    if (typeof descriptor.value !== "function") {
      throw new Error("The validateTypes decorator can only be applied to methods");
    }
    var originalMethod = descriptor.value;
    descriptor.value = function() {
      for (var _len4 = arguments.length, args2 = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args2[_key4] = arguments[_key4];
      }
      runtimeTypeValidation3(finalRuleSet, args2);
      return originalMethod.apply(this, args2);
    };
  };
};
var validateTypesAsync3 = function validateTypesAsync4() {
  for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    args[_key5] = arguments[_key5];
  }
  var finalRuleSet = convertRuleArguments3(args);
  return function(target, propertyKey, descriptor) {
    if (typeof descriptor.value !== "function") {
      throw new Error("The validateTypesAsync decorator can only be applied to methods");
    }
    var originalMethod = descriptor.value;
    descriptor.value = function() {
      for (var _len6 = arguments.length, args2 = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args2[_key6] = arguments[_key6];
      }
      try {
        runtimeTypeValidation3(finalRuleSet, args2);
      } catch (e) {
        return Promise.reject(e);
      }
      return originalMethod.apply(this, args2);
    };
  };
};
var convertRuleArguments3 = function convertRuleArguments4(args) {
  var finalRuleDefinitionSet = [];
  var _iterator2 = _createForOfIteratorHelper$1$1(args), _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
      var arg = _step2.value;
      finalRuleDefinitionSet.push(convertRuleArgument3(arg));
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return finalRuleDefinitionSet;
};
var convertRuleArgument3 = function convertRuleArgument4(arg) {
  var finalArgumentRuleDefinitions = [];
  var declaredRules = Array.isArray(arg) ? arg : [arg];
  var _iterator3 = _createForOfIteratorHelper$1$1(declaredRules), _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done; ) {
      var rule = _step3.value;
      if (typeof rule === "string" || typeof rule === "function") {
        finalArgumentRuleDefinitions.push(type3(rule));
        continue;
      }
      finalArgumentRuleDefinitions.push(rule);
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return finalArgumentRuleDefinitions;
};
var validateValue3 = function validateValue4(ruleDefinitions, value) {
  var expectedTypes = [];
  var customReceivedType;
  var isValid = false;
  var _iterator4 = _createForOfIteratorHelper$1$1(ruleDefinitions), _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done; ) {
      var definition = _step4.value;
      var _iterator5 = _createForOfIteratorHelper$1$1(definition.checks), _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done; ) {
          var check2 = _step5.value;
          var _check = check2(value), _check2 = _slicedToArray__default$1["default"](_check, 3), checkPassed = _check2[0], typeDescription = _check2[1], _receivedType = _check2[2];
          isValid = isValid || checkPassed;
          if (!customReceivedType && _receivedType) {
            customReceivedType = _receivedType;
          }
          if (typeDescription) {
            expectedTypes = typeof typeDescription === "string" ? [].concat(_toConsumableArray__default["default"](expectedTypes), [typeDescription]) : [].concat(_toConsumableArray__default["default"](expectedTypes), _toConsumableArray__default["default"](typeDescription));
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  if (isValid) {
    return [true];
  }
  var receivedType = customReceivedType || stringifyReceivedType3(value);
  var lastIndex = expectedTypes.length - 1;
  var expectedTypesString = lastIndex > 0 ? "".concat(expectedTypes.slice(0, lastIndex).join(", "), " or ").concat(expectedTypes[lastIndex]) : expectedTypes.join(", ");
  return [false, receivedType, expectedTypesString, lastIndex > 1 ? ";" : ","];
};
var objectSchema3 = function objectSchema4(name, schema) {
  return custom3(function(object) {
    if (_typeof__default$1["default"](object) !== "object" || object === null || Array.isArray(object)) {
      return [false, "valid ".concat(name, " (should be a pure object)")];
    }
    for (var _i = 0, _Object$entries = Object.entries(schema); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray__default$1["default"](_Object$entries[_i], 2), key = _Object$entries$_i[0], rules = _Object$entries$_i[1];
      var _validateValue = validateValue3(convertRuleArgument3(rules), object[key]), _validateValue2 = _slicedToArray__default$1["default"](_validateValue, 3), isValid = _validateValue2[0], received = _validateValue2[1], expected = _validateValue2[2];
      if (!isValid) {
        return [false, "valid ".concat(name, ' (key "').concat(key, '" should be ').concat(expected, ")"), "malformed ".concat(name, ' (key "').concat(key, '" is ').concat(received, ")")];
      }
    }
    return [true];
  });
};
function _createForOfIteratorHelper$4(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$4(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i = 0;
      var F = function F2() {
      };
      return { s: F, n: function n() {
        if (i >= o.length)
          return { done: true };
        return { done: false, value: o[i++] };
      }, e: function e(_e) {
        throw _e;
      }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return { s: function s() {
    it = it.call(o);
  }, n: function n() {
    var step = it.next();
    normalCompletion = step.done;
    return step;
  }, e: function e(_e2) {
    didErr = true;
    err = _e2;
  }, f: function f() {
    try {
      if (!normalCompletion && it.return != null)
        it.return();
    } finally {
      if (didErr)
        throw err;
    }
  } };
}
function _unsupportedIterableToArray$4(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$4(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$4(o, minLen);
}
function _arrayLikeToArray$4(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var array3 = function array4(name, rules) {
  return custom3(function(value) {
    if (!Array.isArray(value)) {
      return [false, "an array of ".concat(name)];
    }
    var _iterator = _createForOfIteratorHelper$4(value.entries()), _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        var _step$value = _slicedToArray__default$1["default"](_step.value, 2), key = _step$value[0], valueOfKey = _step$value[1];
        var _validateValue = validateValue3(convertRuleArgument3(rules), valueOfKey), _validateValue2 = _slicedToArray__default$1["default"](_validateValue, 3), isValid = _validateValue2[0], received = _validateValue2[1], expected = _validateValue2[2];
        if (!isValid) {
          return [false, "a valid array of ".concat(name, " (index ").concat(key, " should be ").concat(expected, ")"), "malformed array of ".concat(name, " (index ").concat(key, " is ").concat(received, ")")];
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return [true];
  });
};
browser$2.array = array3;
browser$2.custom = custom3;
browser$2.literal = literal3;
browser$2.nonEmptyString = nonEmptyString;
browser$2.nonNegativeInteger = nonNegativeInteger;
browser$2.objectSchema = objectSchema3;
browser$2.pureObject = pureObject;
browser$2.runtimeTypeValidation = runtimeTypeValidation3;
browser$2.stringifyReceivedType = stringifyReceivedType3;
browser$2.type = type3;
browser$2.validateConstructorTypes = validateConstructorTypes3;
browser$2.validateTypes = validateTypes3;
browser$2.validateTypesAsync = validateTypesAsync3;
/*
@license
The following license applies to all parts of this software except as
documented below.

    Copyright (c) 2016, Twilio, inc.
    All rights reserved.

    Redistribution and use in source and binary forms, with or without
    modification, are permitted provided that the following conditions are
    met:

      1. Redistributions of source code must retain the above copyright
         notice, this list of conditions and the following disclaimer.

      2. Redistributions in binary form must reproduce the above copyright
         notice, this list of conditions and the following disclaimer in
         the documentation and/or other materials provided with the
         distribution.

      3. Neither the name of Twilio nor the names of its contributors may
         be used to endorse or promote products derived from this software
         without specific prior written permission.

    THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
    "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
    LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
    A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
    HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
    SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
    LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
    DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
    THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
    (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
    OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

This software includes loglevel under the following license.

    Copyright (c) 2013 Tim Perry

    Permission is hereby granted, free of charge, to any person
    obtaining a copy of this software and associated documentation
    files (the "Software"), to deal in the Software without
    restriction, including without limitation the rights to use,
    copy, modify, merge, publish, distribute, sublicense, and/or sell
    copies of the Software, and to permit persons to whom the
    Software is furnished to do so, subject to the following
    conditions:

    The above copyright notice and this permission notice shall be
    included in all copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
    EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
    OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
    NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
    HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
    WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
    FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
    OTHER DEALINGS IN THE SOFTWARE.

This software includes Backoff library under the following license

    Copyright (C) 2012 Mathieu Turcotte

    Permission is hereby granted, free of charge, to any person obtaining a copy of
    this software and associated documentation files (the "Software"), to deal in
    the Software without restriction, including without limitation the rights to
    use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies
    of the Software, and to permit persons to whom the Software is furnished to do
    so, subject to the following conditions:

    The above copyright notice and this permission notice shall be included in all
    copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
    SOFTWARE.

This software includes Event-to-Promise library under the following license

    Copyright (c) 2014, Julien Fontanet <julien.fontanet@isonoe.net>.

    Permission to use, copy, modify, and/or distribute this software for any purpose
    with or without fee is hereby granted, provided that the above copyright notice
    and this permission notice appear in all copies.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND
    FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS
    OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER
    TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF
    THIS SOFTWARE.

*/
Object.defineProperty(browser$3, "__esModule", { value: true });
var _asyncToGenerator = asyncToGeneratorExports;
var _classCallCheck = classCallCheckExports;
var _createClass = createClassExports;
var _assertThisInitialized = assertThisInitializedExports;
var _inherits = inheritsExports;
var _possibleConstructorReturn = possibleConstructorReturnExports;
var _getPrototypeOf = getPrototypeOfExports;
var _defineProperty = definePropertyExports;
var _regeneratorRuntime = regenerator;
var _typeof = _typeofExports;
var declarativeTypeValidator = browser$2;
var twilsock = browser$6;
var _wrapNativeSuper = wrapNativeSuperExports;
var loglevelLog = loglevelExports$1;
var _slicedToArray = slicedToArrayExports;
var operationRetrier = browser$7;
var uuid = uuid_1;
var _get = getExports;
var platform = platformExports;
function _interopDefaultLegacy$1(e) {
  return e && typeof e === "object" && "default" in e ? e : { "default": e };
}
function _interopNamespace(e) {
  if (e && e.__esModule)
    return e;
  var n = /* @__PURE__ */ Object.create(null);
  if (e) {
    Object.keys(e).forEach(function(k) {
      if (k !== "default") {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function() {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _asyncToGenerator__default = /* @__PURE__ */ _interopDefaultLegacy$1(_asyncToGenerator);
var _classCallCheck__default = /* @__PURE__ */ _interopDefaultLegacy$1(_classCallCheck);
var _createClass__default = /* @__PURE__ */ _interopDefaultLegacy$1(_createClass);
var _assertThisInitialized__default = /* @__PURE__ */ _interopDefaultLegacy$1(_assertThisInitialized);
var _inherits__default = /* @__PURE__ */ _interopDefaultLegacy$1(_inherits);
var _possibleConstructorReturn__default = /* @__PURE__ */ _interopDefaultLegacy$1(_possibleConstructorReturn);
var _getPrototypeOf__default = /* @__PURE__ */ _interopDefaultLegacy$1(_getPrototypeOf);
var _defineProperty__default = /* @__PURE__ */ _interopDefaultLegacy$1(_defineProperty);
var _regeneratorRuntime__default = /* @__PURE__ */ _interopDefaultLegacy$1(_regeneratorRuntime);
var _typeof__default = /* @__PURE__ */ _interopDefaultLegacy$1(_typeof);
var _wrapNativeSuper__default = /* @__PURE__ */ _interopDefaultLegacy$1(_wrapNativeSuper);
var loglevelLog__namespace = /* @__PURE__ */ _interopNamespace(loglevelLog);
var _slicedToArray__default = /* @__PURE__ */ _interopDefaultLegacy$1(_slicedToArray);
var uuid__namespace = /* @__PURE__ */ _interopNamespace(uuid);
var _get__default = /* @__PURE__ */ _interopDefaultLegacy$1(_get);
var platform__namespace = /* @__PURE__ */ _interopNamespace(platform);
function __decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof__default["default"](Reflect)) === "object" && typeof Reflect.decorate === "function")
    r = Reflect.decorate(decorators, target, key, desc);
  else
    for (var i = decorators.length - 1; i >= 0; i--) {
      if (d = decorators[i])
        r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __metadata(metadataKey, metadataValue) {
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof__default["default"](Reflect)) === "object" && typeof Reflect.metadata === "function")
    return Reflect.metadata(metadataKey, metadataValue);
}
var domain;
function EventHandlers() {
}
EventHandlers.prototype = /* @__PURE__ */ Object.create(null);
function EventEmitter() {
  EventEmitter.init.call(this);
}
EventEmitter.EventEmitter = EventEmitter;
EventEmitter.usingDomains = false;
EventEmitter.prototype.domain = void 0;
EventEmitter.prototype._events = void 0;
EventEmitter.prototype._maxListeners = void 0;
EventEmitter.defaultMaxListeners = 10;
EventEmitter.init = function() {
  this.domain = null;
  if (EventEmitter.usingDomains) {
    if (domain.active)
      ;
  }
  if (!this._events || this._events === Object.getPrototypeOf(this)._events) {
    this._events = new EventHandlers();
    this._eventsCount = 0;
  }
  this._maxListeners = this._maxListeners || void 0;
};
EventEmitter.prototype.setMaxListeners = function setMaxListeners3(n) {
  if (typeof n !== "number" || n < 0 || isNaN(n))
    throw new TypeError('"n" argument must be a positive number');
  this._maxListeners = n;
  return this;
};
function $getMaxListeners(that) {
  if (that._maxListeners === void 0)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}
EventEmitter.prototype.getMaxListeners = function getMaxListeners3() {
  return $getMaxListeners(this);
};
function emitNone(handler, isFn, self2) {
  if (isFn)
    handler.call(self2);
  else {
    var len = handler.length;
    var listeners4 = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners4[i].call(self2);
  }
}
function emitOne(handler, isFn, self2, arg1) {
  if (isFn)
    handler.call(self2, arg1);
  else {
    var len = handler.length;
    var listeners4 = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners4[i].call(self2, arg1);
  }
}
function emitTwo(handler, isFn, self2, arg1, arg2) {
  if (isFn)
    handler.call(self2, arg1, arg2);
  else {
    var len = handler.length;
    var listeners4 = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners4[i].call(self2, arg1, arg2);
  }
}
function emitThree(handler, isFn, self2, arg1, arg2, arg3) {
  if (isFn)
    handler.call(self2, arg1, arg2, arg3);
  else {
    var len = handler.length;
    var listeners4 = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners4[i].call(self2, arg1, arg2, arg3);
  }
}
function emitMany(handler, isFn, self2, args) {
  if (isFn)
    handler.apply(self2, args);
  else {
    var len = handler.length;
    var listeners4 = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners4[i].apply(self2, args);
  }
}
EventEmitter.prototype.emit = function emit3(type5) {
  var er, handler, len, args, i, events, domain2;
  var doError = type5 === "error";
  events = this._events;
  if (events)
    doError = doError && events.error == null;
  else if (!doError)
    return false;
  domain2 = this.domain;
  if (doError) {
    er = arguments[1];
    if (domain2) {
      if (!er)
        er = new Error('Uncaught, unspecified "error" event');
      er.domainEmitter = this;
      er.domain = domain2;
      er.domainThrown = false;
      domain2.emit("error", er);
    } else if (er instanceof Error) {
      throw er;
    } else {
      var err = new Error('Uncaught, unspecified "error" event. (' + er + ")");
      err.context = er;
      throw err;
    }
    return false;
  }
  handler = events[type5];
  if (!handler)
    return false;
  var isFn = typeof handler === "function";
  len = arguments.length;
  switch (len) {
    case 1:
      emitNone(handler, isFn, this);
      break;
    case 2:
      emitOne(handler, isFn, this, arguments[1]);
      break;
    case 3:
      emitTwo(handler, isFn, this, arguments[1], arguments[2]);
      break;
    case 4:
      emitThree(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
      break;
    default:
      args = new Array(len - 1);
      for (i = 1; i < len; i++)
        args[i - 1] = arguments[i];
      emitMany(handler, isFn, this, args);
  }
  return true;
};
function _addListener(target, type5, listener, prepend) {
  var m;
  var events;
  var existing;
  if (typeof listener !== "function")
    throw new TypeError('"listener" argument must be a function');
  events = target._events;
  if (!events) {
    events = target._events = new EventHandlers();
    target._eventsCount = 0;
  } else {
    if (events.newListener) {
      target.emit(
        "newListener",
        type5,
        listener.listener ? listener.listener : listener
      );
      events = target._events;
    }
    existing = events[type5];
  }
  if (!existing) {
    existing = events[type5] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === "function") {
      existing = events[type5] = prepend ? [listener, existing] : [existing, listener];
    } else {
      if (prepend) {
        existing.unshift(listener);
      } else {
        existing.push(listener);
      }
    }
    if (!existing.warned) {
      m = $getMaxListeners(target);
      if (m && m > 0 && existing.length > m) {
        existing.warned = true;
        var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + type5 + " listeners added. Use emitter.setMaxListeners() to increase limit");
        w.name = "MaxListenersExceededWarning";
        w.emitter = target;
        w.type = type5;
        w.count = existing.length;
        emitWarning(w);
      }
    }
  }
  return target;
}
function emitWarning(e) {
  typeof console.warn === "function" ? console.warn(e) : console.log(e);
}
EventEmitter.prototype.addListener = function addListener3(type5, listener) {
  return _addListener(this, type5, listener, false);
};
EventEmitter.prototype.on = EventEmitter.prototype.addListener;
EventEmitter.prototype.prependListener = function prependListener3(type5, listener) {
  return _addListener(this, type5, listener, true);
};
function _onceWrap(target, type5, listener) {
  var fired = false;
  function g() {
    target.removeListener(type5, g);
    if (!fired) {
      fired = true;
      listener.apply(target, arguments);
    }
  }
  g.listener = listener;
  return g;
}
EventEmitter.prototype.once = function once3(type5, listener) {
  if (typeof listener !== "function")
    throw new TypeError('"listener" argument must be a function');
  this.on(type5, _onceWrap(this, type5, listener));
  return this;
};
EventEmitter.prototype.prependOnceListener = function prependOnceListener3(type5, listener) {
  if (typeof listener !== "function")
    throw new TypeError('"listener" argument must be a function');
  this.prependListener(type5, _onceWrap(this, type5, listener));
  return this;
};
EventEmitter.prototype.removeListener = function removeListener3(type5, listener) {
  var list, events, position, i, originalListener;
  if (typeof listener !== "function")
    throw new TypeError('"listener" argument must be a function');
  events = this._events;
  if (!events)
    return this;
  list = events[type5];
  if (!list)
    return this;
  if (list === listener || list.listener && list.listener === listener) {
    if (--this._eventsCount === 0)
      this._events = new EventHandlers();
    else {
      delete events[type5];
      if (events.removeListener)
        this.emit("removeListener", type5, list.listener || listener);
    }
  } else if (typeof list !== "function") {
    position = -1;
    for (i = list.length; i-- > 0; ) {
      if (list[i] === listener || list[i].listener && list[i].listener === listener) {
        originalListener = list[i].listener;
        position = i;
        break;
      }
    }
    if (position < 0)
      return this;
    if (list.length === 1) {
      list[0] = void 0;
      if (--this._eventsCount === 0) {
        this._events = new EventHandlers();
        return this;
      } else {
        delete events[type5];
      }
    } else {
      spliceOne(list, position);
    }
    if (events.removeListener)
      this.emit("removeListener", type5, originalListener || listener);
  }
  return this;
};
EventEmitter.prototype.off = function(type5, listener) {
  return this.removeListener(type5, listener);
};
EventEmitter.prototype.removeAllListeners = function removeAllListeners3(type5) {
  var listeners4, events;
  events = this._events;
  if (!events)
    return this;
  if (!events.removeListener) {
    if (arguments.length === 0) {
      this._events = new EventHandlers();
      this._eventsCount = 0;
    } else if (events[type5]) {
      if (--this._eventsCount === 0)
        this._events = new EventHandlers();
      else
        delete events[type5];
    }
    return this;
  }
  if (arguments.length === 0) {
    var keys6 = Object.keys(events);
    for (var i = 0, key; i < keys6.length; ++i) {
      key = keys6[i];
      if (key === "removeListener")
        continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners("removeListener");
    this._events = new EventHandlers();
    this._eventsCount = 0;
    return this;
  }
  listeners4 = events[type5];
  if (typeof listeners4 === "function") {
    this.removeListener(type5, listeners4);
  } else if (listeners4) {
    do {
      this.removeListener(type5, listeners4[listeners4.length - 1]);
    } while (listeners4[0]);
  }
  return this;
};
EventEmitter.prototype.listeners = function listeners3(type5) {
  var evlistener;
  var ret;
  var events = this._events;
  if (!events)
    ret = [];
  else {
    evlistener = events[type5];
    if (!evlistener)
      ret = [];
    else if (typeof evlistener === "function")
      ret = [evlistener.listener || evlistener];
    else
      ret = unwrapListeners(evlistener);
  }
  return ret;
};
EventEmitter.listenerCount = function(emitter, type5) {
  if (typeof emitter.listenerCount === "function") {
    return emitter.listenerCount(type5);
  } else {
    return listenerCount.call(emitter, type5);
  }
};
EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type5) {
  var events = this._events;
  if (events) {
    var evlistener = events[type5];
    if (typeof evlistener === "function") {
      return 1;
    } else if (evlistener) {
      return evlistener.length;
    }
  }
  return 0;
}
EventEmitter.prototype.eventNames = function eventNames3() {
  return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
};
function spliceOne(list, index2) {
  for (var i = index2, k = i + 1, n = list.length; k < n; i += 1, k += 1)
    list[i] = list[k];
  list.pop();
}
function arrayClone(arr, i) {
  var copy = new Array(i);
  while (i--)
    copy[i] = arr[i];
  return copy;
}
function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}
var UriBuilder = /* @__PURE__ */ function() {
  function UriBuilder2(base2) {
    _classCallCheck__default["default"](this, UriBuilder2);
    this.base = base2;
    this.args = new Array();
    this.paths = new Array();
  }
  _createClass__default["default"](UriBuilder2, [{
    key: "pathSegment",
    value: function pathSegment(name) {
      this.paths.push(encodeURIComponent(name));
      return this;
    }
  }, {
    key: "queryParam",
    value: function queryParam(name, value) {
      if (typeof value !== "undefined") {
        this.args.push(encodeURIComponent(name) + "=" + encodeURIComponent(value));
      }
      return this;
    }
  }, {
    key: "build",
    value: function build() {
      var result = this.base;
      if (this.paths.length) {
        result += "/" + this.paths.join("/");
      }
      if (this.args.length) {
        result += "?" + this.args.join("&");
      }
      return result;
    }
  }]);
  return UriBuilder2;
}();
function _createSuper$7(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$7();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf__default["default"](Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf__default["default"](this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn__default["default"](this, result);
  };
}
function _isNativeReflectConstruct$7() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var SyncError = /* @__PURE__ */ function(_Error) {
  _inherits__default["default"](SyncError2, _Error);
  var _super = _createSuper$7(SyncError2);
  function SyncError2(message) {
    var _this;
    var status = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var code = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    _classCallCheck__default["default"](this, SyncError2);
    _this = _super.call(this);
    _this.name = _this.constructor.name;
    _this.message = "".concat(message, " (status: ").concat(status, ", code: ").concat(code, ")");
    _this.status = status;
    _this.code = code;
    return _this;
  }
  return SyncError2;
}(/* @__PURE__ */ _wrapNativeSuper__default["default"](Error));
var SyncNetworkError = /* @__PURE__ */ function(_SyncError) {
  _inherits__default["default"](SyncNetworkError2, _SyncError);
  var _super2 = _createSuper$7(SyncNetworkError2);
  function SyncNetworkError2(message) {
    var _this2;
    var status = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var code = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    var body = arguments.length > 3 ? arguments[3] : void 0;
    _classCallCheck__default["default"](this, SyncNetworkError2);
    _this2 = _super2.call(this, message, status, code);
    _this2.body = body;
    return _this2;
  }
  return SyncNetworkError2;
}(SyncError);
function deepClone(obj) {
  return JSON.parse(JSON.stringify(obj));
}
function validatePageSize(pageSize) {
  var validPageSize = pageSize === void 0 || isPositiveInteger(pageSize);
  if (!validPageSize) {
    throw new SyncError("Invalid pageSize parameter. Expected a positive integer, was '".concat(pageSize, "'."), 400, 20007);
  }
}
function isInteger2(number) {
  return !isNaN(parseInt(number)) && isFinite(number);
}
function isPositiveInteger(number) {
  return isInteger2(number) && number > 0;
}
var log$1 = loglevelLog__namespace.getLogger("twilio-sync");
function prepareLine(prefix, args) {
  return ["".concat((/* @__PURE__ */ new Date()).toISOString(), " Sync ").concat(prefix, ":")].concat(Array.from(args));
}
var log$1$1 = {
  setLevel: function setLevel(level) {
    log$1.setLevel(level);
  },
  trace: function trace() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    log$1.trace.apply(null, prepareLine("T", args));
  },
  debug: function debug2() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    log$1.debug.apply(null, prepareLine("D", args));
  },
  info: function info() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    log$1.info.apply(null, prepareLine("I", args));
  },
  warn: function warn() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }
    log$1.warn.apply(null, prepareLine("W", args));
  },
  error: function error() {
    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }
    log$1.error.apply(null, prepareLine("E", args));
  }
};
var SUBSCRIPTIONS_PATH = "/v4/Subscriptions";
var MAPS_PATH = "/v3/Maps";
var LISTS_PATH = "/v3/Lists";
var DOCUMENTS_PATH = "/v3/Documents";
var STREAMS_PATH = "/v3/Streams";
var INSIGHTS_PATH = "/v3/Insights";
function getWithDefault(container, key, defaultValue) {
  if (container && typeof container[key] !== "undefined") {
    return container[key];
  }
  return defaultValue;
}
var Configuration = /* @__PURE__ */ function() {
  function Configuration2() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _classCallCheck__default["default"](this, Configuration2);
    var region = options.region || "us1";
    var defaultCdsUrl = "https://cds.".concat(region, ".twilio.com");
    var baseUri = options.cdsUri || defaultCdsUrl;
    this.settings = {
      subscriptionsUri: baseUri + SUBSCRIPTIONS_PATH,
      documentsUri: baseUri + DOCUMENTS_PATH,
      listsUri: baseUri + LISTS_PATH,
      mapsUri: baseUri + MAPS_PATH,
      streamsUri: baseUri + STREAMS_PATH,
      insightsUri: baseUri + INSIGHTS_PATH,
      sessionStorageEnabled: getWithDefault(options.Sync, "enableSessionStorage", true),
      productId: options.productId
    };
  }
  _createClass__default["default"](Configuration2, [{
    key: "subscriptionsUri",
    get: function get3() {
      return this.settings.subscriptionsUri;
    }
  }, {
    key: "documentsUri",
    get: function get3() {
      return this.settings.documentsUri;
    }
  }, {
    key: "listsUri",
    get: function get3() {
      return this.settings.listsUri;
    }
  }, {
    key: "mapsUri",
    get: function get3() {
      return this.settings.mapsUri;
    }
  }, {
    key: "streamsUri",
    get: function get3() {
      return this.settings.streamsUri;
    }
  }, {
    key: "insightsUri",
    get: function get3() {
      return this.settings.insightsUri;
    }
  }, {
    key: "backoffConfig",
    get: function get3() {
      return this.settings.backoffConfig || {};
    }
  }, {
    key: "sessionStorageEnabled",
    get: function get3() {
      return this.settings.sessionStorageEnabled;
    }
  }, {
    key: "productId",
    get: function get3() {
      return this.settings.productId;
    }
  }]);
  return Configuration2;
}();
function _createForOfIteratorHelper$3(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$3(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i = 0;
      var F = function F2() {
      };
      return { s: F, n: function n() {
        if (i >= o.length)
          return { done: true };
        return { done: false, value: o[i++] };
      }, e: function e(_e) {
        throw _e;
      }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return { s: function s() {
    it = it.call(o);
  }, n: function n() {
    var step = it.next();
    normalCompletion = step.done;
    return step;
  }, e: function e(_e2) {
    didErr = true;
    err = _e2;
  }, f: function f() {
    try {
      if (!normalCompletion && it.return != null)
        it.return();
    } finally {
      if (didErr)
        throw err;
    }
  } };
}
function _unsupportedIterableToArray$3(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$3(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$3(o, minLen);
}
function _arrayLikeToArray$3(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var SubscribedEntity = /* @__PURE__ */ function() {
  function SubscribedEntity2(entity) {
    _classCallCheck__default["default"](this, SubscribedEntity2);
    this.localObject = entity;
    this.pendingCorrelationId = null;
    this.pendingAction = null;
    this.established = false;
    this.retryCount = 0;
  }
  _createClass__default["default"](SubscribedEntity2, [{
    key: "sid",
    get: function get3() {
      return this.localObject.sid;
    }
  }, {
    key: "type",
    get: function get3() {
      return this.localObject.type;
    }
  }, {
    key: "lastEventId",
    get: function get3() {
      return this.localObject.lastEventId;
    }
    // below properties are specific to Insights only
  }, {
    key: "indexName",
    get: function get3() {
      return this.localObject.indexName;
    }
  }, {
    key: "queryString",
    get: function get3() {
      return this.localObject.queryString;
    }
  }, {
    key: "isEstablished",
    get: function get3() {
      return this.established;
    }
  }, {
    key: "update",
    value: function update(event, isStrictlyOrdered) {
      this.localObject._update(event, isStrictlyOrdered);
    }
  }, {
    key: "updatePending",
    value: function updatePending(action, correlationId) {
      this.pendingAction = action;
      this.pendingCorrelationId = correlationId;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.updatePending(null, null);
      this.retryCount = 0;
      this.established = false;
      this.setSubscriptionState("none");
    }
  }, {
    key: "markAsFailed",
    value: function markAsFailed(message) {
      this.rejectedWithError = message.error;
      this.updatePending(null, null);
      this.localObject.reportFailure(new SyncError("Failed to subscribe on service events: ".concat(message.error.message), message.error.status, message.error.code));
    }
  }, {
    key: "complete",
    value: function complete(eventId) {
      this.updatePending(null, null);
      this.established = true;
      this.localObject._advanceLastEventId(eventId);
    }
  }, {
    key: "setSubscriptionState",
    value: function setSubscriptionState(newState) {
      this.localObject._setSubscriptionState(newState);
    }
  }]);
  return SubscribedEntity2;
}();
var Subscriptions = /* @__PURE__ */ function() {
  function Subscriptions2(services) {
    var _this = this;
    _classCallCheck__default["default"](this, Subscriptions2);
    _defineProperty__default["default"](this, "isConnected", false);
    _defineProperty__default["default"](this, "maxBatchSize", 100);
    _defineProperty__default["default"](this, "subscriptionTtlTimer", null);
    _defineProperty__default["default"](this, "pendingPokeReason", null);
    this.services = services;
    this.subscriptions = /* @__PURE__ */ new Map();
    this.persisted = /* @__PURE__ */ new Map();
    this.latestPokeResponseArrivalTimestampByCorrelationId = /* @__PURE__ */ new Map();
    var defaultBackoffConfig = {
      randomisationFactor: 0.2,
      initialDelay: 100,
      maxDelay: 2 * 60 * 1e3
    };
    this.backoff = operationRetrier.Backoff.exponential(Object.assign(defaultBackoffConfig, this.services.config.backoffConfig));
    this.backoff.on("ready", function() {
      var _this$getSubscription = _this.getSubscriptionUpdateBatch(), action = _this$getSubscription.action, subscriptionRequests = _this$getSubscription.subscriptions;
      if (action) {
        _this.applyNewSubscriptionUpdateBatch(action, subscriptionRequests);
      } else {
        _this.backoff.reset();
        log$1$1.debug("All subscriptions resolved.");
      }
    });
  }
  _createClass__default["default"](Subscriptions2, [{
    key: "getSubscriptionUpdateBatch",
    value: function getSubscriptionUpdateBatch() {
      function subtract(these, those, action, limit) {
        var result = [];
        var _iterator = _createForOfIteratorHelper$3(these), _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done; ) {
            var _step$value = _slicedToArray__default["default"](_step.value, 2), thisKey = _step$value[0], thisValue = _step$value[1];
            var otherValue = those.get(thisKey);
            if (!otherValue && action !== thisValue.pendingAction && !thisValue.rejectedWithError) {
              result.push(thisValue);
              if (limit && result.length >= limit) {
                break;
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        return result;
      }
      var listToAdd = subtract(this.subscriptions, this.persisted, "establish", this.maxBatchSize);
      if (listToAdd.length > 0) {
        return {
          action: "establish",
          subscriptions: listToAdd
        };
      }
      var listToRemove = subtract(this.persisted, this.subscriptions, "cancel", this.maxBatchSize);
      if (listToRemove.length > 0) {
        return {
          action: "cancel",
          subscriptions: listToRemove
        };
      }
      return {
        action: null,
        subscriptions: null
      };
    }
  }, {
    key: "persist",
    value: function persist() {
      this.backoff.backoff();
    }
  }, {
    key: "applyNewSubscriptionUpdateBatch",
    value: function() {
      var _applyNewSubscriptionUpdateBatch = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee(action, requests) {
        var _this2 = this;
        var correlationId, _iterator2, _step2, subscribed, reason, response, newMaxBatchSize, subscriptionTtlInS, isNumeric, isValidTtl, estimatedDeliveryInMs, _isNumeric, isValidTimeout, _iterator3, _step3, attemptedSubscription;
        return _regeneratorRuntime__default["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.isConnected) {
                  _context.next = 4;
                  break;
                }
                log$1$1.debug("Twilsock connection (required for subscription) not ready; waiting…");
                this.backoff.reset();
                return _context.abrupt("return");
              case 4:
                requests = this.processLocalActions(action, requests);
                correlationId = (/* @__PURE__ */ new Date()).getTime();
                _iterator2 = _createForOfIteratorHelper$3(requests);
                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
                    subscribed = _step2.value;
                    this.recordActionAttemptOn(subscribed, action, correlationId);
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }
                reason = this.pendingPokeReason;
                this.pendingPokeReason = null;
                _context.prev = 10;
                _context.next = 13;
                return this.request(action, correlationId, reason, requests);
              case 13:
                response = _context.sent;
                newMaxBatchSize = response.body.max_batch_size;
                if (!isNaN(parseInt(newMaxBatchSize)) && isFinite(newMaxBatchSize) && newMaxBatchSize > 0) {
                  this.maxBatchSize = newMaxBatchSize;
                }
                if (!this.subscriptionTtlTimer) {
                  subscriptionTtlInS = response.body.ttl_in_s;
                  isNumeric = !isNaN(parseFloat(subscriptionTtlInS)) && isFinite(subscriptionTtlInS);
                  isValidTtl = isNumeric && subscriptionTtlInS > 0;
                  if (isValidTtl) {
                    this.subscriptionTtlTimer = setTimeout(function() {
                      return _this2.onSubscriptionTtlElapsed();
                    }, subscriptionTtlInS * 1e3);
                  }
                }
                if (action === "establish") {
                  estimatedDeliveryInMs = response.body.estimated_delivery_in_ms;
                  _isNumeric = !isNaN(parseFloat(estimatedDeliveryInMs)) && isFinite(estimatedDeliveryInMs);
                  isValidTimeout = _isNumeric && estimatedDeliveryInMs > 0;
                  if (isValidTimeout) {
                    setTimeout(function() {
                      return _this2.verifyPokeDelivery(correlationId, estimatedDeliveryInMs, requests);
                    }, estimatedDeliveryInMs);
                  } else {
                    log$1$1.error("Invalid timeout: ".concat(estimatedDeliveryInMs));
                  }
                  requests.filter(function(r) {
                    return r.pendingCorrelationId === correlationId;
                  }).forEach(function(r) {
                    return r.setSubscriptionState("response_in_flight");
                  });
                }
                this.backoff.reset();
                _context.next = 26;
                break;
              case 21:
                _context.prev = 21;
                _context.t0 = _context["catch"](10);
                _iterator3 = _createForOfIteratorHelper$3(requests);
                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done; ) {
                    attemptedSubscription = _step3.value;
                    this.recordActionFailureOn(attemptedSubscription, action);
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }
                if (_context.t0 instanceof twilsock.TransportUnavailableError) {
                  log$1$1.debug("Twilsock connection (required for subscription) not ready (c:".concat(correlationId, "); waiting…"));
                  this.backoff.reset();
                } else {
                  log$1$1.debug("Failed an attempt to ".concat(action, " subscriptions (c:").concat(correlationId, "); retrying"), _context.t0);
                  this.persist();
                }
              case 26:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[10, 21]]);
      }));
      function applyNewSubscriptionUpdateBatch(_x, _x2) {
        return _applyNewSubscriptionUpdateBatch.apply(this, arguments);
      }
      return applyNewSubscriptionUpdateBatch;
    }()
  }, {
    key: "verifyPokeDelivery",
    value: function verifyPokeDelivery(correlationId, estimatedDeliveryInMs, requests) {
      var _this3 = this;
      var lastReceived = this.latestPokeResponseArrivalTimestampByCorrelationId.get(correlationId);
      var silencePeriod = lastReceived ? (/* @__PURE__ */ new Date()).getTime() - lastReceived : estimatedDeliveryInMs;
      if (silencePeriod >= estimatedDeliveryInMs) {
        requests.filter(function(r) {
          return r.pendingCorrelationId === correlationId;
        }).forEach(function(r) {
          r.updatePending(null, null);
          r.retryCount++;
          _this3.persisted.delete(r.sid);
        });
        this.persist();
        this.latestPokeResponseArrivalTimestampByCorrelationId.delete(correlationId);
      } else {
        var timeoutExtension = estimatedDeliveryInMs - silencePeriod;
        setTimeout(function() {
          return _this3.verifyPokeDelivery(correlationId, estimatedDeliveryInMs, requests);
        }, timeoutExtension);
      }
    }
  }, {
    key: "processLocalActions",
    value: function processLocalActions(action, requests) {
      if (action === "cancel") {
        return requests.filter(function(request) {
          return !request.rejectedWithError;
        });
      }
      return requests;
    }
  }, {
    key: "recordActionAttemptOn",
    value: function recordActionAttemptOn(attemptedSubscription, action, correlationId) {
      attemptedSubscription.setSubscriptionState("request_in_flight");
      if (action === "establish") {
        this.persisted.set(attemptedSubscription.sid, attemptedSubscription);
        attemptedSubscription.updatePending(action, correlationId);
      } else {
        var persistedSubscription = this.persisted.get(attemptedSubscription.sid);
        if (persistedSubscription) {
          persistedSubscription.updatePending(action, correlationId);
        }
      }
    }
  }, {
    key: "recordActionFailureOn",
    value: function recordActionFailureOn(attemptedSubscription, action) {
      attemptedSubscription.setSubscriptionState("none");
      attemptedSubscription.updatePending(null, null);
      if (action === "establish") {
        this.persisted.delete(attemptedSubscription.sid);
      }
    }
  }, {
    key: "request",
    value: function request(action, correlationId, reason, objects) {
      var requests = objects.map(function(object) {
        return {
          object_sid: object.sid,
          object_type: object.type,
          last_event_id: action === "establish" ? object.lastEventId : void 0,
          index_name: action === "establish" ? object.indexName : void 0,
          query_string: action === "establish" ? object.queryString : void 0
        };
      });
      var retriedRequests = objects.filter(function(a) {
        return a.retryCount > 0;
      }).length;
      log$1$1.debug("Attempting '".concat(action, "' request (c:").concat(correlationId, "):"), requests);
      var requestBody = {
        event_protocol_version: 4,
        action,
        correlation_id: correlationId,
        retried_requests: retriedRequests,
        ttl_in_s: -1,
        requests
      };
      if (reason === "ttl") {
        requestBody.reason = reason;
      }
      return this.services.network.post(this.services.config.subscriptionsUri, requestBody);
    }
    /**
     * Establishes intent to be subscribed to this entity. That subscription will be effected
     * asynchronously.
     * If subscription to the given sid already exists, it will be overwritten.
     *
     * @param {String} sid should be a well-formed SID, uniquely identifying a single instance of a Sync entity.
     * @param {Object} entity should represent the (singular) local representation of this entity.
     *      Incoming events and modifications to the entity will be directed at the _update() function
     *      of this provided reference.
     *
     * @return undefined
     */
  }, {
    key: "add",
    value: function add(sid, entity) {
      log$1$1.debug("Establishing intent to subscribe to ".concat(sid));
      var existingSubscription = this.subscriptions.get(sid);
      if (existingSubscription && entity && existingSubscription.lastEventId === entity.lastEventId) {
        return;
      }
      this.persisted.delete(sid);
      this.subscriptions.set(sid, new SubscribedEntity(entity));
      this.persist();
    }
    /**
     * Establishes the caller's intent to no longer be subscribed to this entity. Following this
     * call, no further events shall be routed to the local representation of the entity, even
     * though a server-side subscription may take more time to actually terminate.
     *
     * @param {string} sid should be any well-formed SID, uniquely identifying a Sync entity.
     *      This call only has meaningful effect if that entity is subscribed at the
     *      time of call. Otherwise does nothing.
     *
     * @return undefined
     */
  }, {
    key: "remove",
    value: function remove(sid) {
      log$1$1.debug("Establishing intent to unsubscribe from ".concat(sid));
      var removed = this.subscriptions.delete(sid);
      if (removed) {
        this.persist();
      }
    }
    /**
     * The point of ingestion for remote incoming messages (e.g. new data was written to a map
     * to which we are subscribed).
     *
     * @param {object} message is the full, unaltered body of the incoming notification.
     *
     * @return undefined
     */
  }, {
    key: "acceptMessage",
    value: function acceptMessage(message, isStrictlyOrdered) {
      log$1$1.trace("Subscriptions received", message);
      var eventType = message.event_type;
      var events = typeof message.events !== "undefined" ? message.events : [message.event];
      var correlationId = message.correlation_id;
      if (correlationId) {
        this.latestPokeResponseArrivalTimestampByCorrelationId.set(correlationId, (/* @__PURE__ */ new Date()).getTime());
      }
      var _iterator4 = _createForOfIteratorHelper$3(events), _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done; ) {
          var event = _step4.value;
          var matchedEventType = void 0;
          switch (message.event_type) {
            case "subscription_established":
              this.applySubscriptionEstablishedMessage(event, correlationId);
              break;
            case "subscription_canceled":
              this.applySubscriptionCancelledMessage(event, correlationId);
              break;
            case "subscription_failed":
              this.applySubscriptionFailedMessage(event, correlationId);
              break;
            case (matchedEventType = eventType.match(/^(?:map|list|document|stream|live_query)_/) || {}).input: {
              var typedSid = void 0;
              switch (matchedEventType[0]) {
                case "map_":
                  typedSid = event.map_sid;
                  break;
                case "list_":
                  typedSid = event.list_sid;
                  break;
                case "document_":
                  typedSid = event.document_sid;
                  break;
                case "stream_":
                  typedSid = event.stream_sid;
                  break;
                case "live_query_":
                  typedSid = event.query_id;
                  isStrictlyOrdered = false;
                  if (message.strictly_ordered === true) {
                    isStrictlyOrdered = true;
                  }
                  break;
                default:
                  typedSid = void 0;
              }
              this.applyEventToSubscribedEntity(typedSid, event, eventType, isStrictlyOrdered);
              break;
            }
            default:
              log$1$1.debug("Dropping unknown message type ".concat(eventType));
              break;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }, {
    key: "applySubscriptionEstablishedMessage",
    value: function applySubscriptionEstablishedMessage(message, correlationId) {
      var sid = message.object_sid;
      var subscriptionIntent = this.persisted.get(message.object_sid);
      if (subscriptionIntent && subscriptionIntent.pendingCorrelationId === correlationId) {
        if (message.replay_status === "interrupted") {
          log$1$1.debug("Event Replay for subscription to ".concat(sid, " (c:").concat(correlationId, ") interrupted; continuing eagerly."));
          subscriptionIntent.updatePending(null, null);
          this.persisted.delete(subscriptionIntent.sid);
          this.backoff.reset();
        } else if (message.replay_status === "completed") {
          log$1$1.debug("Event Replay for subscription to ".concat(sid, " (c:").concat(correlationId, ") completed. Subscription is ready."));
          subscriptionIntent.complete(message.last_event_id);
          this.persisted.set(message.object_sid, subscriptionIntent);
          subscriptionIntent.setSubscriptionState("established");
          this.backoff.reset();
        }
      } else {
        log$1$1.debug("Late message for ".concat(message.object_sid, " (c:").concat(correlationId, ") dropped."));
      }
      this.persist();
    }
  }, {
    key: "applySubscriptionCancelledMessage",
    value: function applySubscriptionCancelledMessage(message, correlationId) {
      var persistedSubscription = this.persisted.get(message.object_sid);
      if (persistedSubscription && persistedSubscription.pendingCorrelationId === correlationId) {
        persistedSubscription.updatePending(null, null);
        persistedSubscription.setSubscriptionState("none");
        this.persisted.delete(message.object_sid);
      } else {
        log$1$1.debug("Late message for ".concat(message.object_sid, " (c:").concat(correlationId, ") dropped."));
      }
      this.persist();
    }
  }, {
    key: "applySubscriptionFailedMessage",
    value: function applySubscriptionFailedMessage(message, correlationId) {
      var sid = message.object_sid;
      var subscriptionIntent = this.subscriptions.get(sid);
      var subscription = this.persisted.get(sid);
      if (subscriptionIntent && subscription) {
        if (subscription.pendingCorrelationId === correlationId) {
          log$1$1.error("Failed to subscribe on ".concat(subscription.sid), message.error);
          subscription.markAsFailed(message);
          subscription.setSubscriptionState("none");
        }
      } else if (!subscriptionIntent && subscription) {
        this.persisted.delete(sid);
        subscription.setSubscriptionState("none");
      }
      this.persist();
    }
  }, {
    key: "applyEventToSubscribedEntity",
    value: function applyEventToSubscribedEntity(sid, event, eventType, isStrictlyOrdered) {
      var _this4 = this;
      if (!sid) {
        return;
      }
      isStrictlyOrdered = isStrictlyOrdered || function() {
        var subscription = _this4.persisted.get(sid);
        return subscription && subscription.isEstablished;
      }();
      var subscriptionIntent = this.subscriptions.get(sid);
      if (subscriptionIntent) {
        event.type = eventType;
        subscriptionIntent.update(event, isStrictlyOrdered);
      } else {
        log$1$1.debug("Message dropped for SID '".concat(sid, "', for which there is no subscription."));
      }
    }
  }, {
    key: "onConnectionStateChanged",
    value: function onConnectionStateChanged(isConnected) {
      this.isConnected = isConnected;
      if (isConnected) {
        this.poke("reconnect");
      }
    }
  }, {
    key: "onSubscriptionTtlElapsed",
    value: function onSubscriptionTtlElapsed() {
      if (this.isConnected) {
        this.poke("ttl");
      }
    }
    /**
     * Prompts a playback of any missed changes made to any subscribed object. This method
     * should be invoked whenever the connectivity layer has experienced cross-cutting
     * delivery failures that would affect the entire local sync set. Any tangible result
     * of this operation will result in calls to the _update() function of subscribed
     * Sync entities.
     */
  }, {
    key: "poke",
    value: function poke(reason) {
      log$1$1.debug("Triggering event replay for all subscriptions, reason=".concat(reason));
      this.pendingPokeReason = reason;
      if (this.subscriptionTtlTimer) {
        clearTimeout(this.subscriptionTtlTimer);
        this.subscriptionTtlTimer = null;
      }
      var failedSubscriptions = [];
      var _iterator5 = _createForOfIteratorHelper$3(this.persisted.values()), _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done; ) {
          var _it = _step5.value;
          _it.reset();
          if (_it.rejectedWithError) {
            failedSubscriptions.push(_it);
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      this.persisted.clear();
      for (var _i = 0, _failedSubscriptions = failedSubscriptions; _i < _failedSubscriptions.length; _i++) {
        var it = _failedSubscriptions[_i];
        this.persisted.set(it.sid, it);
      }
      this.persist();
    }
    /**
     * Stops all communication, clears any subscription intent, and returns.
     */
  }, {
    key: "shutdown",
    value: function shutdown() {
      this.backoff.reset();
      this.subscriptions.clear();
    }
  }]);
  return Subscriptions2;
}();
var MINIMUM_RETRY_DELAY = 4e3;
var MAXIMUM_RETRY_DELAY = 6e4;
var MAXIMUM_ATTEMPTS_TIME = 9e4;
var RETRY_DELAY_RANDOMNESS = 0.2;
function messageFromErrorBody(transportError) {
  if (transportError.body) {
    if (transportError.body.message) {
      return transportError.body.message;
    }
  }
  switch (transportError.status) {
    case 429:
      return "Throttled by server";
    case 404:
      return "Not found from server";
    default:
      return "Error from server";
  }
}
function codeFromErrorBody(trasportError) {
  if (trasportError.body) {
    return trasportError.body.code;
  }
  return 0;
}
function mapTransportError(transportError) {
  if (transportError.status === 409) {
    return new SyncNetworkError(messageFromErrorBody(transportError), transportError.status, codeFromErrorBody(transportError), transportError.body);
  } else if (transportError.status) {
    return new SyncError(messageFromErrorBody(transportError), transportError.status, codeFromErrorBody(transportError));
  } else if (transportError instanceof twilsock.TransportUnavailableError) {
    return transportError;
  } else {
    return new SyncError(transportError.message, 0, 0);
  }
}
var NetworkService = /* @__PURE__ */ function() {
  function NetworkService2(clientInfo, config, transport) {
    _classCallCheck__default["default"](this, NetworkService2);
    this.clientInfo = clientInfo;
    this.config = config;
    this.transport = transport;
  }
  _createClass__default["default"](NetworkService2, [{
    key: "createHeaders",
    value: function createHeaders() {
      return {
        "Content-Type": "application/json",
        "Twilio-Sync-Client-Info": JSON.stringify(this.clientInfo),
        "Twilio-Request-Id": "RQ" + uuid__namespace.v4().replace(/-/g, "")
      };
    }
  }, {
    key: "backoffConfig",
    value: function backoffConfig() {
      return Object.assign({
        min: MINIMUM_RETRY_DELAY,
        max: MAXIMUM_RETRY_DELAY,
        maxAttemptsTime: MAXIMUM_ATTEMPTS_TIME,
        randomness: RETRY_DELAY_RANDOMNESS
      }, this.config.backoffConfig);
    }
  }, {
    key: "executeWithRetry",
    value: function executeWithRetry(request) {
      var _this = this;
      var retryWhenThrottled = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
      return new Promise(function(resolve2, reject2) {
        var codesToRetryOn = [502, 503, 504];
        if (retryWhenThrottled) {
          codesToRetryOn.push(429);
        }
        var retrier = new operationRetrier.Retrier(_this.backoffConfig());
        retrier.on("attempt", function() {
          request().then(function(result) {
            return retrier.succeeded(result);
          }).catch(function(err) {
            if (codesToRetryOn.includes(err.status)) {
              var delayOverride = parseInt(err.headers ? err.headers["Retry-After"] : null);
              retrier.failed(mapTransportError(err), isNaN(delayOverride) ? null : delayOverride * 1e3);
            } else if (err.message === "Twilsock disconnected") {
              retrier.failed(mapTransportError(err));
            } else {
              retrier.removeAllListeners();
              retrier.cancel();
              reject2(mapTransportError(err));
            }
          });
        });
        retrier.on("succeeded", function(result) {
          resolve2(result);
        });
        retrier.on("cancelled", function(err) {
          return reject2(mapTransportError(err));
        });
        retrier.on("failed", function(err) {
          return reject2(mapTransportError(err));
        });
        retrier.start();
      });
    }
    /**
     * Make a GET request by given URI
     * @Returns Promise<Response> Result of successful get request
     */
  }, {
    key: "get",
    value: function get3(uri) {
      var _this2 = this;
      var headers = this.createHeaders();
      log$1$1.debug("GET", uri, "ID:", headers["Twilio-Request-Id"]);
      return this.executeWithRetry(function() {
        return _this2.transport.get(uri, headers, _this2.config.productId);
      }, true);
    }
  }, {
    key: "post",
    value: function post(uri, body, revision) {
      var _this3 = this;
      var retryWhenThrottled = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
      var headers = this.createHeaders();
      if (typeof revision !== "undefined" && revision !== null) {
        headers["If-Match"] = revision;
      }
      log$1$1.debug("POST", uri, "ID:", headers["Twilio-Request-Id"]);
      return this.executeWithRetry(function() {
        return _this3.transport.post(uri, headers, body, _this3.config.productId);
      }, retryWhenThrottled);
    }
  }, {
    key: "put",
    value: function put(uri, body, revision) {
      var _this4 = this;
      var headers = this.createHeaders();
      if (typeof revision !== "undefined" && revision !== null) {
        headers["If-Match"] = revision;
      }
      log$1$1.debug("PUT", uri, "ID:", headers["Twilio-Request-Id"]);
      return this.executeWithRetry(function() {
        return _this4.transport.put(uri, headers, body, _this4.config.productId);
      }, false);
    }
  }, {
    key: "delete",
    value: function _delete(uri) {
      var _this5 = this;
      var headers = this.createHeaders();
      log$1$1.debug("DELETE", uri, "ID:", headers["Twilio-Request-Id"]);
      return this.executeWithRetry(function() {
        return _this5.transport.delete(uri, headers, _this5.config.productId);
      }, false);
    }
  }]);
  return NetworkService2;
}();
var SessionStorage = /* @__PURE__ */ function() {
  function SessionStorage2(config, storage) {
    _classCallCheck__default["default"](this, SessionStorage2);
    this.config = config;
    this.storageId = null;
    try {
      this.storage = storage || sessionStorage;
    } catch (e) {
    }
  }
  _createClass__default["default"](SessionStorage2, [{
    key: "storageKey",
    value: function storageKey(type5, key) {
      return "".concat(this.storageId, "::").concat(type5, "::").concat(key);
    }
  }, {
    key: "isReady",
    get: function get3() {
      return this.config.sessionStorageEnabled && !!this.storageId;
    }
  }, {
    key: "updateStorageId",
    value: function updateStorageId(storageId) {
      this.storageId = storageId;
    }
  }, {
    key: "store",
    value: function store(type5, id2, value) {
      if (!this.isReady) {
        return null;
      }
      return this._store(this.storageKey(type5, id2), value);
    }
  }, {
    key: "read",
    value: function read(type5, id2) {
      if (!this.isReady) {
        return null;
      }
      return this._read(this.storageKey(type5, id2));
    }
  }, {
    key: "remove",
    value: function remove(type5, sid, uniqueName) {
      if (!this.isReady) {
        return null;
      }
      try {
        this.storage.removeItem(this.storageKey(type5, sid));
        if (uniqueName) {
          this.storage.removeItem(this.storageKey(type5, uniqueName));
        }
      } catch (e) {
      }
    }
  }, {
    key: "update",
    value: function update(type5, sid, uniqueName, patch) {
      if (!this.isReady) {
        return null;
      }
      this._apply(this.storageKey(type5, sid), patch);
      if (uniqueName) {
        this._apply(this.storageKey(type5, uniqueName), patch);
      }
    }
  }, {
    key: "_store",
    value: function _store(key, value) {
      try {
        this.storage.setItem(key, JSON.stringify(value));
      } catch (e) {
      }
    }
  }, {
    key: "_read",
    value: function _read(key) {
      try {
        var storedData = this.storage.getItem(key);
        if (storedData) {
          return JSON.parse(storedData);
        }
      } catch (e) {
      }
      return null;
    }
  }, {
    key: "_apply",
    value: function _apply(key, patch) {
      var value = this._read(key);
      if (!value) {
        return false;
      }
      this._store(key, Object.assign(value, patch));
    }
  }]);
  return SessionStorage2;
}();
function _createForOfIteratorHelper$2(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$2(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i = 0;
      var F = function F2() {
      };
      return { s: F, n: function n() {
        if (i >= o.length)
          return { done: true };
        return { done: false, value: o[i++] };
      }, e: function e(_e) {
        throw _e;
      }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return { s: function s() {
    it = it.call(o);
  }, n: function n() {
    var step = it.next();
    normalCompletion = step.done;
    return step;
  }, e: function e(_e2) {
    didErr = true;
    err = _e2;
  }, f: function f() {
    try {
      if (!normalCompletion && it.return != null)
        it.return();
    } finally {
      if (didErr)
        throw err;
    }
  } };
}
function _unsupportedIterableToArray$2(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$2(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$2(o, minLen);
}
function _arrayLikeToArray$2(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var SyncEntity = /* @__PURE__ */ function() {
  function SyncEntity2(services, removalHandler) {
    _classCallCheck__default["default"](this, SyncEntity2);
    this.services = services;
    this.removalHandler = removalHandler;
    this.subscriptionState = "none";
    this._attachedListeners = /* @__PURE__ */ new Map();
  }
  _createClass__default["default"](SyncEntity2, [{
    key: "_advanceLastEventId",
    value: function _advanceLastEventId(eventId, revision) {
    }
  }, {
    key: "reportFailure",
    value: function reportFailure(err) {
      if (err.status === 404) {
        this.onRemoved(false);
      } else {
        this.broadcastEventToListeners("failure", err);
      }
    }
    /**
     * Subscribe to changes of data entity
     * @private
     */
  }, {
    key: "_subscribe",
    value: function _subscribe() {
      this.services.router._subscribe(this.sid, this);
    }
    /**
     * Unsubscribe from changes of current data entity
     * @private
     */
  }, {
    key: "_unsubscribe",
    value: function _unsubscribe() {
      this.services.router._unsubscribe(this.sid);
    }
  }, {
    key: "_setSubscriptionState",
    value: function _setSubscriptionState(newState) {
      this.subscriptionState = newState;
      this.broadcastEventToListeners("_subscriptionStateChanged", newState);
    }
    /**
     * @public
     */
  }, {
    key: "close",
    value: function close() {
      this._unsubscribe();
      if (this.removalHandler != null) {
        this.removalHandler(this.type, this.sid, this.uniqueName);
      }
    }
  }, {
    key: "attach",
    value: function attach(closeable) {
      var uuid2 = closeable.listenerUuid;
      var existingRecord = this._attachedListeners.get(uuid2);
      if (existingRecord) {
        return;
      }
      if (!this._attachedListeners.size) {
        this._subscribe();
      }
      this._attachedListeners.set(uuid2, closeable);
    }
  }, {
    key: "detach",
    value: function detach(listenerUuid) {
      this._attachedListeners.delete(listenerUuid);
      if (!this._attachedListeners.size) {
        this.close();
      }
    }
  }, {
    key: "broadcastEventToListeners",
    value: function broadcastEventToListeners(eventName, args) {
      var _iterator = _createForOfIteratorHelper$2(this._attachedListeners.values()), _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done; ) {
          var listener = _step.value;
          listener.emit(eventName, args);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }]);
  return SyncEntity2;
}();
var MergingQueue = /* @__PURE__ */ function() {
  function MergingQueue2(inputMergingFunction) {
    _classCallCheck__default["default"](this, MergingQueue2);
    _defineProperty__default["default"](this, "queuedRequests", []);
    _defineProperty__default["default"](this, "isRequestInFlight", false);
    this.inputMergingFunction = inputMergingFunction;
  }
  _createClass__default["default"](MergingQueue2, [{
    key: "add",
    value: function add(input, requestFunction) {
      var _this = this;
      var promise2 = new Promise(function(resolve2, reject2) {
        return _this.queuedRequests.push({
          input,
          requestFunction,
          resolve: resolve2,
          reject: reject2
        });
      });
      this.wakeupQueue();
      return promise2;
    }
  }, {
    key: "squashAndAdd",
    value: function squashAndAdd(input, requestFunction) {
      var queueToSquash = this.queuedRequests;
      this.queuedRequests = [];
      var reducedInput;
      if (queueToSquash.length > 0) {
        reducedInput = queueToSquash.map(function(r) {
          return r.input;
        }).reduce(this.inputMergingFunction);
        reducedInput = this.inputMergingFunction(reducedInput, input);
      } else {
        reducedInput = input;
      }
      var promise2 = this.add(reducedInput, requestFunction);
      queueToSquash.forEach(function(request) {
        return promise2.then(request.resolve, request.reject);
      });
      return promise2;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.queuedRequests.length === 0 && !this.isRequestInFlight;
    }
  }, {
    key: "wakeupQueue",
    value: function wakeupQueue() {
      var _this2 = this;
      if (this.queuedRequests.length === 0 || this.isRequestInFlight) {
        return;
      } else {
        var requestToExecute = this.queuedRequests.shift();
        this.isRequestInFlight = true;
        requestToExecute.requestFunction(requestToExecute.input).then(requestToExecute.resolve, requestToExecute.reject).then(function(__) {
          _this2.isRequestInFlight = false;
          _this2.wakeupQueue();
        });
      }
    }
  }]);
  return MergingQueue2;
}();
var NamespacedMergingQueue = /* @__PURE__ */ function() {
  function NamespacedMergingQueue2(inputReducer) {
    _classCallCheck__default["default"](this, NamespacedMergingQueue2);
    _defineProperty__default["default"](this, "queueByNamespaceKey", /* @__PURE__ */ new Map());
    this.inputReducer = inputReducer;
  }
  _createClass__default["default"](NamespacedMergingQueue2, [{
    key: "add",
    value: function() {
      var _add = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee(namespaceKey, input, requestFunction) {
        return _regeneratorRuntime__default["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.invokeQueueMethod(namespaceKey, function(queue) {
                  return queue.add(input, requestFunction);
                }));
              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function add(_x, _x2, _x3) {
        return _add.apply(this, arguments);
      }
      return add;
    }()
  }, {
    key: "squashAndAdd",
    value: function() {
      var _squashAndAdd = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee2(namespaceKey, input, requestFunction) {
        return _regeneratorRuntime__default["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this.invokeQueueMethod(namespaceKey, function(queue) {
                  return queue.squashAndAdd(input, requestFunction);
                }));
              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function squashAndAdd(_x4, _x5, _x6) {
        return _squashAndAdd.apply(this, arguments);
      }
      return squashAndAdd;
    }()
  }, {
    key: "invokeQueueMethod",
    value: function() {
      var _invokeQueueMethod = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee3(namespaceKey, queueMethodInvoker) {
        var queue, result;
        return _regeneratorRuntime__default["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.queueByNamespaceKey.has(namespaceKey)) {
                  this.queueByNamespaceKey.set(namespaceKey, new MergingQueue(this.inputReducer));
                }
                queue = this.queueByNamespaceKey.get(namespaceKey);
                result = queueMethodInvoker(queue);
                if (this.queueByNamespaceKey.get(namespaceKey).isEmpty()) {
                  this.queueByNamespaceKey.delete(namespaceKey);
                }
                return _context3.abrupt("return", result);
              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function invokeQueueMethod(_x7, _x8) {
        return _invokeQueueMethod.apply(this, arguments);
      }
      return invokeQueueMethod;
    }()
  }]);
  return NamespacedMergingQueue2;
}();
function _createSuper$6(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$6();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf__default["default"](Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf__default["default"](this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn__default["default"](this, result);
  };
}
function _isNativeReflectConstruct$6() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var Closeable = /* @__PURE__ */ function(_EventEmitter) {
  _inherits__default["default"](Closeable2, _EventEmitter);
  var _super = _createSuper$6(Closeable2);
  function Closeable2() {
    var _this;
    _classCallCheck__default["default"](this, Closeable2);
    _this = _super.call(this);
    _this.closed = false;
    _this.uuid = uuid.v4();
    return _this;
  }
  _createClass__default["default"](Closeable2, [{
    key: "listenerUuid",
    get: function get3() {
      return this.uuid;
    }
  }, {
    key: "close",
    value: function close() {
      this.removeAllListeners();
      this.closed = true;
    }
  }, {
    key: "ensureNotClosed",
    value: function ensureNotClosed() {
      if (this.closed) {
        throw new Error("Invalid operation on closed object");
      }
    }
  }]);
  return Closeable2;
}(EventEmitter);
function _createSuper$5(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$5();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf__default["default"](Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf__default["default"](this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn__default["default"](this, result);
  };
}
function _isNativeReflectConstruct$5() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var SyncDocumentImpl = /* @__PURE__ */ function(_SyncEntity) {
  _inherits__default["default"](SyncDocumentImpl2, _SyncEntity);
  var _super = _createSuper$5(SyncDocumentImpl2);
  function SyncDocumentImpl2(services, descriptor, removalHandler) {
    var _this;
    _classCallCheck__default["default"](this, SyncDocumentImpl2);
    _this = _super.call(this, services, removalHandler);
    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this), "isDeleted", false);
    var updateRequestReducer = function updateRequestReducer2(acc, input) {
      return typeof input.ttl === "number" ? {
        ttl: input.ttl
      } : acc;
    };
    _this.updateMergingQueue = new MergingQueue(updateRequestReducer);
    _this.descriptor = descriptor;
    _this.descriptor.data = _this.descriptor.data || {};
    _this.descriptor.date_updated = new Date(_this.descriptor.date_updated);
    return _this;
  }
  _createClass__default["default"](SyncDocumentImpl2, [{
    key: "uri",
    get: function get3() {
      return this.descriptor.url;
    }
  }, {
    key: "revision",
    get: function get3() {
      return this.descriptor.revision;
    }
  }, {
    key: "lastEventId",
    get: function get3() {
      return this.descriptor.last_event_id;
    }
  }, {
    key: "dateExpires",
    get: function get3() {
      return this.descriptor.date_expires;
    }
  }, {
    key: "type",
    get: function get3() {
      return "document";
    }
    // below properties are specific to Insights only
  }, {
    key: "indexName",
    get: function get3() {
      return void 0;
    }
  }, {
    key: "queryString",
    get: function get3() {
      return void 0;
    }
    // public props, documented along with class description
  }, {
    key: "sid",
    get: function get3() {
      return this.descriptor.sid;
    }
  }, {
    key: "data",
    get: function get3() {
      return this.descriptor.data;
    }
  }, {
    key: "dateUpdated",
    get: function get3() {
      return this.descriptor.date_updated;
    }
  }, {
    key: "uniqueName",
    get: function get3() {
      return this.descriptor.unique_name || null;
    }
    /**
     * Update data entity with new data
     * @private
     */
  }, {
    key: "_update",
    value: function _update(update) {
      update.date_created = new Date(update.date_created);
      switch (update.type) {
        case "document_updated":
          if (update.id <= this.lastEventId) {
            log$1$1.trace("Document update skipped, current:", this.lastEventId, ", remote:", update.id);
            break;
          }
          var previousData = this.descriptor.data !== void 0 ? deepClone(this.descriptor.data) : null;
          this.descriptor.last_event_id = update.id;
          this.descriptor.revision = update.document_revision;
          this.descriptor.date_updated = update.date_created;
          this.descriptor.data = update.document_data;
          this.broadcastEventToListeners("updated", {
            data: update.document_data,
            isLocal: false,
            previousData
          });
          this.services.storage.update(this.type, this.sid, this.uniqueName, {
            last_event_id: update.id,
            revision: update.document_revision,
            date_updated: update.date_created,
            data: update.document_data
          });
          break;
        case "document_removed":
          this.onRemoved(false);
          break;
      }
    }
  }, {
    key: "set",
    value: function() {
      var _set = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee(value, metadataUpdates) {
        var _this2 = this;
        var input;
        return _regeneratorRuntime__default["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                input = metadataUpdates || {};
                return _context.abrupt("return", this.updateMergingQueue.squashAndAdd(input, function(input2) {
                  return _this2._setUnconditionally(value, input2.ttl);
                }));
              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function set4(_x, _x2) {
        return _set.apply(this, arguments);
      }
      return set4;
    }()
  }, {
    key: "mutate",
    value: function() {
      var _mutate = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee2(mutator, metadataUpdates) {
        var _this3 = this;
        var input;
        return _regeneratorRuntime__default["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                input = metadataUpdates || {};
                return _context2.abrupt("return", this.updateMergingQueue.add(input, function(input2) {
                  return _this3._setWithIfMatch(mutator, input2.ttl);
                }));
              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function mutate(_x3, _x4) {
        return _mutate.apply(this, arguments);
      }
      return mutate;
    }()
  }, {
    key: "update",
    value: function() {
      var _update2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee3(obj, metadataUpdates) {
        return _regeneratorRuntime__default["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.mutate(function(remote) {
                  return Object.assign(remote, obj);
                }, metadataUpdates));
              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function update(_x5, _x6) {
        return _update2.apply(this, arguments);
      }
      return update;
    }()
  }, {
    key: "setTtl",
    value: function() {
      var _setTtl = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee4(ttl) {
        var response;
        return _regeneratorRuntime__default["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this._postUpdateToServer({
                  ttl
                });
              case 2:
                response = _context4.sent;
                this.descriptor.date_expires = response.date_expires;
              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
      function setTtl(_x7) {
        return _setTtl.apply(this, arguments);
      }
      return setTtl;
    }()
    /**
     * @private
     */
  }, {
    key: "_setUnconditionally",
    value: function() {
      var _setUnconditionally2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee5(value, ttl) {
        var result;
        return _regeneratorRuntime__default["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this._postUpdateToServer({
                  data: value,
                  revision: void 0,
                  ttl
                });
              case 2:
                result = _context5.sent;
                this._handleSuccessfulUpdateResult(result);
                return _context5.abrupt("return", this.descriptor.data);
              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
      function _setUnconditionally(_x8, _x9) {
        return _setUnconditionally2.apply(this, arguments);
      }
      return _setUnconditionally;
    }()
    /**
     * @private
     */
  }, {
    key: "_setWithIfMatch",
    value: function() {
      var _setWithIfMatch2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee6(mutatorFunction, ttl) {
        var data2, revision, result;
        return _regeneratorRuntime__default["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                data2 = mutatorFunction(deepClone(this.descriptor.data));
                if (!data2) {
                  _context6.next = 22;
                  break;
                }
                revision = this.revision;
                _context6.prev = 3;
                _context6.next = 6;
                return this._postUpdateToServer({
                  data: data2,
                  revision,
                  ttl
                });
              case 6:
                result = _context6.sent;
                this._handleSuccessfulUpdateResult(result);
                return _context6.abrupt("return", this.descriptor.data);
              case 11:
                _context6.prev = 11;
                _context6.t0 = _context6["catch"](3);
                if (!(_context6.t0.status === 412)) {
                  _context6.next = 19;
                  break;
                }
                _context6.next = 16;
                return this._softSync();
              case 16:
                return _context6.abrupt("return", this._setWithIfMatch(mutatorFunction));
              case 19:
                throw _context6.t0;
              case 20:
                _context6.next = 23;
                break;
              case 22:
                return _context6.abrupt("return", this.descriptor.data);
              case 23:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[3, 11]]);
      }));
      function _setWithIfMatch(_x10, _x11) {
        return _setWithIfMatch2.apply(this, arguments);
      }
      return _setWithIfMatch;
    }()
    /**
     * @private
     */
  }, {
    key: "_handleSuccessfulUpdateResult",
    value: function _handleSuccessfulUpdateResult(result) {
      if (result.last_event_id <= this.descriptor.last_event_id) {
        return;
      }
      var previousData = this.descriptor.data !== void 0 ? deepClone(this.descriptor.data) : null;
      this.descriptor.revision = result.revision;
      this.descriptor.data = result.data;
      this.descriptor.last_event_id = result.last_event_id;
      this.descriptor.date_expires = result.date_expires;
      this.descriptor.date_updated = new Date(result.date_updated);
      this.services.storage.update(this.type, this.sid, this.uniqueName, {
        last_event_id: result.last_event_id,
        revision: result.revision,
        date_updated: result.date_updated,
        data: result.data
      });
      this.broadcastEventToListeners("updated", {
        data: this.descriptor.data,
        isLocal: true,
        previousData
      });
    }
    /**
     * @private
     */
  }, {
    key: "_postUpdateToServer",
    value: function() {
      var _postUpdateToServer2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee7(request) {
        var requestBody, ifMatch, response;
        return _regeneratorRuntime__default["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (this.isDeleted) {
                  _context7.next = 17;
                  break;
                }
                requestBody = {
                  data: request.data
                };
                if (request.ttl !== void 0) {
                  requestBody.ttl = request.ttl;
                }
                ifMatch = request.revision;
                _context7.prev = 4;
                _context7.next = 7;
                return this.services.network.post(this.uri, requestBody, ifMatch);
              case 7:
                response = _context7.sent;
                return _context7.abrupt("return", {
                  revision: response.body.revision,
                  data: request.data,
                  last_event_id: response.body.last_event_id,
                  date_updated: response.body.date_updated,
                  date_expires: response.body.date_expires
                });
              case 11:
                _context7.prev = 11;
                _context7.t0 = _context7["catch"](4);
                if (_context7.t0.status === 404) {
                  this.onRemoved(false);
                }
                throw _context7.t0;
              case 15:
                _context7.next = 18;
                break;
              case 17:
                return _context7.abrupt("return", Promise.reject(new SyncError("The Document has been removed", 404, 54100)));
              case 18:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[4, 11]]);
      }));
      function _postUpdateToServer(_x12) {
        return _postUpdateToServer2.apply(this, arguments);
      }
      return _postUpdateToServer;
    }()
    /**
     * Get new data from server
     * @private
     */
  }, {
    key: "_softSync",
    value: function() {
      var _softSync2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee8() {
        var _this4 = this;
        return _regeneratorRuntime__default["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", this.services.network.get(this.uri).then(function(response) {
                  var event = {
                    type: "document_updated",
                    id: response.body.last_event_id,
                    document_revision: response.body.revision,
                    document_data: response.body.data,
                    date_created: response.body.date_updated
                  };
                  _this4._update(event);
                  return _this4;
                }).catch(function(err) {
                  if (err.status === 404) {
                    _this4.onRemoved(false);
                  } else {
                    log$1$1.error("Can't get updates for ".concat(_this4.sid, ":"), err);
                  }
                }));
              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
      function _softSync() {
        return _softSync2.apply(this, arguments);
      }
      return _softSync;
    }()
  }, {
    key: "onRemoved",
    value: function onRemoved(locally) {
      if (this.isDeleted) {
        return;
      }
      var previousData = this.descriptor.data !== void 0 ? deepClone(this.descriptor.data) : null;
      this.isDeleted = true;
      this._unsubscribe();
      this.removalHandler(this.type, this.sid, this.uniqueName);
      this.broadcastEventToListeners("removed", {
        isLocal: locally,
        previousData
      });
    }
  }, {
    key: "removeDocument",
    value: function() {
      var _removeDocument = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee9() {
        return _regeneratorRuntime__default["default"].wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (this.isDeleted) {
                  _context9.next = 6;
                  break;
                }
                _context9.next = 3;
                return this.services.network.delete(this.uri);
              case 3:
                this.onRemoved(true);
                _context9.next = 7;
                break;
              case 6:
                return _context9.abrupt("return", Promise.reject(new SyncError("The Document has been removed", 404, 54100)));
              case 7:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
      function removeDocument() {
        return _removeDocument.apply(this, arguments);
      }
      return removeDocument;
    }()
  }], [{
    key: "type",
    get: function get3() {
      return "document";
    }
  }]);
  return SyncDocumentImpl2;
}(SyncEntity);
var SyncDocument = /* @__PURE__ */ function(_Closeable) {
  _inherits__default["default"](SyncDocument2, _Closeable);
  var _super2 = _createSuper$5(SyncDocument2);
  function SyncDocument2(syncDocumentImpl) {
    var _this5;
    _classCallCheck__default["default"](this, SyncDocument2);
    _this5 = _super2.call(this);
    _this5.syncDocumentImpl = syncDocumentImpl;
    _this5.syncDocumentImpl.attach(_assertThisInitialized__default["default"](_this5));
    return _this5;
  }
  _createClass__default["default"](SyncDocument2, [{
    key: "uri",
    get: (
      // private props
      function get3() {
        return this.syncDocumentImpl.uri;
      }
    )
  }, {
    key: "revision",
    get: function get3() {
      return this.syncDocumentImpl.revision;
    }
  }, {
    key: "lastEventId",
    get: function get3() {
      return this.syncDocumentImpl.lastEventId;
    }
  }, {
    key: "dateExpires",
    get: function get3() {
      return this.syncDocumentImpl.dateExpires;
    }
  }, {
    key: "type",
    get: function get3() {
      return SyncDocumentImpl.type;
    }
    /**
     * The immutable identifier of this document, assigned by the system.
     */
  }, {
    key: "sid",
    get: function get3() {
      return this.syncDocumentImpl.sid;
    }
    /**
     * The contents of this document.
     */
  }, {
    key: "data",
    get: function get3() {
      return this.syncDocumentImpl.data;
    }
    /**
     * Date when the document was last updated.
     */
  }, {
    key: "dateUpdated",
    get: function get3() {
      return this.syncDocumentImpl.dateUpdated;
    }
    /**
     * An optional immutable identifier that may be assigned by the programmer
     * to this document during creation. Globally unique among other documents.
     */
  }, {
    key: "uniqueName",
    get: function get3() {
      return this.syncDocumentImpl.uniqueName;
    }
  }, {
    key: "set",
    value: (
      /**
       * Assign new contents to this document. The current data will be overwritten.
       * @param data The new contents to assign.
       * @param metadataUpdates New document metadata.
       * @return A promise resolving to the new data of the document.
       * @example
       * ```typescript
       * // Say, the Document data is `{ name: 'John Smith', age: 34 }`
       * document.set({ name: 'Barbara Oaks' }, { ttl: 86400 })
       *   .then((newValue) => {
       *     // Now the Document data is `{ name: 'Barbara Oaks' }`
       *     console.log('Document set() successful, new data:', newValue);
       *   })
       *   .catch((error) => {
       *     console.error('Document set() failed', error);
       *   });
       * ```
       */
      function() {
        var _set2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee10(data2, metadataUpdates) {
          return _regeneratorRuntime__default["default"].wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  this.ensureNotClosed();
                  return _context10.abrupt("return", this.syncDocumentImpl.set(data2, metadataUpdates));
                case 2:
                case "end":
                  return _context10.stop();
              }
            }
          }, _callee10, this);
        }));
        function set4(_x13, _x14) {
          return _set2.apply(this, arguments);
        }
        return set4;
      }()
    )
    /**
     * Schedules a modification to this document that will apply a mutation function.
     * @param mutator A function that outputs new data based on the existing data.
     * May be called multiple times, particularly if this document is modified concurrently by remote code.
     * If the mutation ultimately succeeds, the document will have made the particular transition described
     * by this function.
     * @param metadataUpdates New document metadata.
     * @return Resolves with the most recent Document state, whether the output of a
     * successful mutation or a state that prompted graceful cancellation (mutator returned `null`).
     * @example
     * ```typescript
     * const mutatorFunction = (currentValue) => {
     *     currentValue.viewCount = (currentValue.viewCount ?? 0) + 1;
     *     return currentValue;
     * };
     * document.mutate(mutatorFunction, { ttl: 86400 }))
     *   .then((newValue) => {
     *     console.log('Document mutate() successful, new data:', newValue);
     *   })
     *   .catch((error) => {
     *     console.error('Document mutate() failed', error);
     *   });
     * ```
     */
  }, {
    key: "mutate",
    value: function() {
      var _mutate2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee11(mutator, metadataUpdates) {
        return _regeneratorRuntime__default["default"].wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                this.ensureNotClosed();
                return _context11.abrupt("return", this.syncDocumentImpl.mutate(mutator, metadataUpdates));
              case 2:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));
      function mutate(_x15, _x16) {
        return _mutate2.apply(this, arguments);
      }
      return mutate;
    }()
    /**
     * Modify a document by appending new fields (or by overwriting existing ones) with the values from the provided Object.
     * This is equivalent to:
     * ```typescript
     * document.mutate((currentValue) => Object.assign(currentValue, obj));
     * ```
     * @param obj Specifies the particular (top-level) attributes that will receive new values.
     * @param metadataUpdates New document metadata.
     * @return A promise resolving to the new data of the document.
     * @example
     * ```typescript
     * // Say, the Document data is `{ name: 'John Smith' }`
     * document.update({ age: 34 }, { ttl: 86400 })
     *   .then((newValue) => {
     *     // Now the Document data is `{ name: 'John Smith', age: 34 }`
     *     console.log('Document update() successful, new data:', newValue);
     *   })
     *   .catch((error) => {
     *     console.error('Document update() failed', error);
     *   });
     * ```
     */
  }, {
    key: "update",
    value: function() {
      var _update3 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee12(obj, metadataUpdates) {
        return _regeneratorRuntime__default["default"].wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                this.ensureNotClosed();
                return _context12.abrupt("return", this.syncDocumentImpl.update(obj, metadataUpdates));
              case 2:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));
      function update(_x17, _x18) {
        return _update3.apply(this, arguments);
      }
      return update;
    }()
    /**
     * Update the time-to-live of the document.
     * @param ttl Specifies the time-to-live in seconds after which the document is subject to automatic deletion. The value 0 means infinity.
     * @return A promise that resolves after the TTL update was successful.
     * @example
     * ```typescript
     * document.setTtl(3600)
     *   .then(() => {
     *     console.log('Document setTtl() successful');
     *   })
     *   .catch((error) => {
     *     console.error('Document setTtl() failed', error);
     *   });
     * ```
     */
  }, {
    key: "setTtl",
    value: function() {
      var _setTtl2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee13(ttl) {
        return _regeneratorRuntime__default["default"].wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                this.ensureNotClosed();
                return _context13.abrupt("return", this.syncDocumentImpl.setTtl(ttl));
              case 2:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));
      function setTtl(_x19) {
        return _setTtl2.apply(this, arguments);
      }
      return setTtl;
    }()
    /**
     * Delete a document.
     * @return A promise which resolves if (and only if) the document is ultimately deleted.
     * @example
     * ```typescript
     * document.removeDocument()
     *   .then(() => {
     *     console.log('Document removeDocument() successful');
     *   })
     *   .catch((error) => {
     *     console.error('Document removeDocument() failed', error);
     *   });
     * ```
     */
  }, {
    key: "removeDocument",
    value: function() {
      var _removeDocument2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee14() {
        return _regeneratorRuntime__default["default"].wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                this.ensureNotClosed();
                return _context14.abrupt("return", this.syncDocumentImpl.removeDocument());
              case 2:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));
      function removeDocument() {
        return _removeDocument2.apply(this, arguments);
      }
      return removeDocument;
    }()
    /**
     * Conclude work with the document instance and remove all event listeners attached to it.
     * Any subsequent operation on this object will be rejected with error.
     * Other local copies of this document will continue operating and receiving events normally.
     * @example
     * ```typescript
     * document.close();
     * ```
     */
  }, {
    key: "close",
    value: function close() {
      _get__default["default"](_getPrototypeOf__default["default"](SyncDocument2.prototype), "close", this).call(this);
      this.syncDocumentImpl.detach(this.listenerUuid);
    }
  }], [{
    key: "type",
    get: function get3() {
      return SyncDocumentImpl.type;
    }
  }]);
  return SyncDocument2;
}(Closeable);
_defineProperty__default["default"](SyncDocument, "removed", "removed");
_defineProperty__default["default"](SyncDocument, "updated", "updated");
__decorate([declarativeTypeValidator.validateTypesAsync(declarativeTypeValidator.pureObject, ["undefined", declarativeTypeValidator.objectSchema("document metadata", {
  ttl: [declarativeTypeValidator.nonNegativeInteger, "undefined"]
})]), __metadata("design:type", Function), __metadata("design:paramtypes", [Object, Object]), __metadata("design:returntype", Promise)], SyncDocument.prototype, "set", null);
__decorate([declarativeTypeValidator.validateTypesAsync("function", ["undefined", declarativeTypeValidator.objectSchema("document metadata", {
  ttl: [declarativeTypeValidator.nonNegativeInteger, "undefined"]
})]), __metadata("design:type", Function), __metadata("design:paramtypes", [Function, Object]), __metadata("design:returntype", Promise)], SyncDocument.prototype, "mutate", null);
__decorate([declarativeTypeValidator.validateTypesAsync(declarativeTypeValidator.pureObject, ["undefined", declarativeTypeValidator.objectSchema("document metadata", {
  ttl: [declarativeTypeValidator.nonNegativeInteger, "undefined"]
})]), __metadata("design:type", Function), __metadata("design:paramtypes", [Object, Object]), __metadata("design:returntype", Promise)], SyncDocument.prototype, "update", null);
__decorate([declarativeTypeValidator.validateTypesAsync(declarativeTypeValidator.nonNegativeInteger), __metadata("design:type", Function), __metadata("design:paramtypes", [Number]), __metadata("design:returntype", Promise)], SyncDocument.prototype, "setTtl", null);
var SyncListItem = /* @__PURE__ */ function() {
  function SyncListItem2(descriptor) {
    _classCallCheck__default["default"](this, SyncListItem2);
    this.descriptor = descriptor;
  }
  _createClass__default["default"](SyncListItem2, [{
    key: "uri",
    get: function get3() {
      return this.descriptor.uri;
    }
  }, {
    key: "revision",
    get: function get3() {
      return this.descriptor.revision;
    }
  }, {
    key: "lastEventId",
    get: function get3() {
      return this.descriptor.lastEventId;
    }
    /**
     * Date when the list item was last updated.
     */
  }, {
    key: "dateUpdated",
    get: function get3() {
      return this.descriptor.dateUpdated;
    }
  }, {
    key: "dateExpires",
    get: function get3() {
      return this.descriptor.dateExpires;
    }
    /**
     * The index, within the containing list, of this item. This index is stable;
     * even if lower-indexed items are removed, this index will remain as is.
     */
  }, {
    key: "index",
    get: function get3() {
      return this.descriptor.index;
    }
    /**
     * The contents of the item.
     */
  }, {
    key: "data",
    get: function get3() {
      return this.descriptor.data;
    }
    /**
     * @internal
     */
  }, {
    key: "update",
    value: function update(eventId, revision, data2, dateUpdated) {
      this.descriptor.lastEventId = eventId;
      this.descriptor.revision = revision;
      this.descriptor.data = data2;
      this.descriptor.dateUpdated = dateUpdated;
      return this;
    }
    /**
     * @internal
     */
  }, {
    key: "updateDateExpires",
    value: function updateDateExpires(dateExpires) {
      this.descriptor.dateExpires = dateExpires;
    }
  }]);
  return SyncListItem2;
}();
var Paginator = /* @__PURE__ */ function() {
  function Paginator2(items, source, prevToken, nextToken) {
    _classCallCheck__default["default"](this, Paginator2);
    this.prevToken = prevToken;
    this.nextToken = nextToken;
    this.items = items;
    this.source = source;
  }
  _createClass__default["default"](Paginator2, [{
    key: "hasNextPage",
    get: function get3() {
      return !!this.nextToken;
    }
    /**
     * Indicates the existence of the previous page.
     */
  }, {
    key: "hasPrevPage",
    get: function get3() {
      return !!this.prevToken;
    }
    /**
     * Request next page.
     * Does not modify existing object.
     */
  }, {
    key: "nextPage",
    value: function() {
      var _nextPage = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee() {
        return _regeneratorRuntime__default["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.hasNextPage) {
                  _context.next = 2;
                  break;
                }
                throw new Error("No next page");
              case 2:
                return _context.abrupt("return", this.source(this.nextToken));
              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function nextPage() {
        return _nextPage.apply(this, arguments);
      }
      return nextPage;
    }()
    /**
     * Request previous page.
     * Does not modify existing object.
     */
  }, {
    key: "prevPage",
    value: function() {
      var _prevPage = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee2() {
        return _regeneratorRuntime__default["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.hasPrevPage) {
                  _context2.next = 2;
                  break;
                }
                throw new Error("No previous page");
              case 2:
                return _context2.abrupt("return", this.source(this.prevToken));
              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function prevPage() {
        return _prevPage.apply(this, arguments);
      }
      return prevPage;
    }()
  }]);
  return Paginator2;
}();
function _createForOfIteratorHelper$1(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i = 0;
      var F = function F2() {
      };
      return { s: F, n: function n() {
        if (i >= o.length)
          return { done: true };
        return { done: false, value: o[i++] };
      }, e: function e(_e) {
        throw _e;
      }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return { s: function s() {
    it = it.call(o);
  }, n: function n() {
    var step = it.next();
    normalCompletion = step.done;
    return step;
  }, e: function e(_e2) {
    didErr = true;
    err = _e2;
  }, f: function f() {
    try {
      if (!normalCompletion && it.return != null)
        it.return();
    } finally {
      if (didErr)
        throw err;
    }
  } };
}
function _unsupportedIterableToArray$1(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$1(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$1(o, minLen);
}
function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var Node = /* @__PURE__ */ function() {
  function Node2(key, value) {
    _classCallCheck__default["default"](this, Node2);
    this.balanceFactor = 0;
    this.key = key;
    this.value = value;
    this.parent = null;
    this.left = null;
    this.right = null;
  }
  _createClass__default["default"](Node2, [{
    key: "isRoot",
    get: function get3() {
      return this.parent === null;
    }
  }, {
    key: "isLeaf",
    get: function get3() {
      return this.left === null && this.right === null;
    }
  }, {
    key: "isLeftChild",
    get: function get3() {
      return this.parent.left === this;
    }
  }, {
    key: "update",
    value: function update(value) {
      this.value = value;
    }
  }, {
    key: "replace",
    value: function replace2(target, replacement2) {
      if (!target) {
        return;
      }
      if (this.left === replacement2) {
        this.left = replacement2;
      } else if (this.right === replacement2) {
        this.right = replacement2;
      }
    }
  }]);
  return Node2;
}();
var TreeMap = /* @__PURE__ */ function() {
  function TreeMap2(less, equal) {
    _classCallCheck__default["default"](this, TreeMap2);
    this.isLessThan = less || function(x, y) {
      return x < y;
    };
    this.isEqual = equal || function(x, y) {
      return x === y;
    };
    this.root = null;
    this.count = null;
  }
  _createClass__default["default"](TreeMap2, [{
    key: "size",
    get: function get3() {
      return this.count;
    }
  }, {
    key: "clear",
    value: function clear2() {
      this.root = null;
      this.count = 0;
    }
  }, {
    key: "set",
    value: function set4(key, value) {
      var node2 = this.getNode(key);
      if (node2) {
        node2.update(value);
      } else {
        this.insert(key, value);
      }
    }
  }, {
    key: "insert",
    value: function insert(key, value) {
      var node2 = new Node(key, value);
      this.count++;
      if (!this.root) {
        this.root = node2;
        return;
      }
      var currNode = this.root;
      for (; ; ) {
        if (this.isLessThan(key, currNode.key)) {
          if (currNode.left) {
            currNode = currNode.left;
          } else {
            currNode.left = node2;
            break;
          }
        } else {
          if (currNode.right) {
            currNode = currNode.right;
          } else {
            currNode.right = node2;
            break;
          }
        }
      }
      node2.parent = currNode;
      currNode = node2;
      while (currNode.parent) {
        var parent = currNode.parent;
        var prevBalanceFactor = parent.balanceFactor;
        if (currNode.isLeftChild) {
          parent.balanceFactor++;
        } else {
          parent.balanceFactor--;
        }
        if (Math.abs(parent.balanceFactor) < Math.abs(prevBalanceFactor)) {
          break;
        }
        if (parent.balanceFactor < -1 || parent.balanceFactor > 1) {
          this.rebalance(parent);
          break;
        }
        currNode = parent;
      }
    }
  }, {
    key: "get",
    value: function get3(key) {
      var currentNode = this.root;
      while (currentNode) {
        if (this.isEqual(key, currentNode.key)) {
          return currentNode.value;
        }
        if (this.isLessThan(key, currentNode.key)) {
          currentNode = currentNode.left;
        } else {
          currentNode = currentNode.right;
        }
      }
      return null;
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      var node2 = this.getNode(key);
      if (!node2 || node2.key !== key) {
        return null;
      }
      var parent = node2.parent;
      var left = node2.left;
      var right = node2.right;
      if (!!left !== !!right) {
        var child = left || right;
        if (!parent && !child) {
          this.root = null;
        } else if (parent && !child) {
          this.root = child;
        } else {
          parent.replace(node2, null);
          this.rebalance(parent);
        }
      } else {
        var maxLeft = node2.left;
        while (maxLeft.right) {
          maxLeft = maxLeft.right;
        }
        if (node2.left === maxLeft) {
          if (node2.isRoot) {
            this.root = maxLeft;
            maxLeft.parent = null;
          } else {
            if (node2.isLeftChild) {
              node2.parent.left = maxLeft;
            } else {
              node2.parent.right = maxLeft;
            }
            maxLeft.parent = node2.parent;
          }
          maxLeft.right = node2.right;
          maxLeft.right.parent = maxLeft;
          maxLeft.balanceFactor = node2.balanceFactor;
          node2 = {
            parent: maxLeft,
            isLeftChild: true
          };
        } else {
          var mlParent = maxLeft.parent;
          var mlLeft = maxLeft.left;
          mlParent.right = mlLeft;
          if (mlLeft) {
            mlLeft.parent = mlParent;
          }
          if (node2.isRoot) {
            this.root = maxLeft;
            maxLeft.parent = null;
          } else {
            if (node2.isLeftChild) {
              node2.parent.left = maxLeft;
            } else {
              node2.parent.right = maxLeft;
            }
            maxLeft.parent = node2.parent;
          }
          maxLeft.right = node2.right;
          maxLeft.right.parent = maxLeft;
          maxLeft.left = node2.left;
          maxLeft.left.parent = maxLeft;
          maxLeft.balanceFactor = node2.balanceFactor;
          node2 = {
            parent: mlParent,
            isLeftChild: false
          };
        }
      }
      this.count--;
      while (node2.parent) {
        var _parent = node2.parent;
        var prevBalanceFactor = _parent.balanceFactor;
        if (node2.isLeftChild) {
          _parent.balanceFactor -= 1;
        } else {
          _parent.balanceFactor += 1;
        }
        if (Math.abs(_parent.balanceFactor) > Math.abs(prevBalanceFactor)) {
          if (_parent.balanceFactor < -1 || _parent.balanceFactor > 1) {
            this.rebalance(_parent);
            if (_parent.parent.balanceFactor === 0) {
              node2 = _parent.parent;
            } else {
              break;
            }
          } else {
            break;
          }
        } else {
          node2 = _parent;
        }
      }
      return null;
    }
  }, {
    key: "getNode",
    value: function getNode(key) {
      var currentNode = this.root;
      while (currentNode) {
        if (this.isEqual(key, currentNode.key)) {
          return currentNode;
        }
        if (this.isLessThan(key, currentNode.key)) {
          currentNode = currentNode.left;
        } else {
          currentNode = currentNode.right;
        }
      }
      return null;
    }
  }, {
    key: "rebalance",
    value: function rebalance(node2) {
      if (node2.balanceFactor < 0) {
        if (node2.right.balanceFactor > 0) {
          this.rotateRight(node2.right);
          this.rotateLeft(node2);
        } else {
          this.rotateLeft(node2);
        }
      } else if (node2.balanceFactor > 0) {
        if (node2.left.balanceFactor < 0) {
          this.rotateLeft(node2.left);
          this.rotateRight(node2);
        } else {
          this.rotateRight(node2);
        }
      }
    }
  }, {
    key: "rotateLeft",
    value: function rotateLeft(pivot) {
      var root = pivot.right;
      pivot.right = root.left;
      if (root.left !== null) {
        root.left.parent = pivot;
      }
      root.parent = pivot.parent;
      if (root.parent === null) {
        this.root = root;
      } else if (pivot.isLeftChild) {
        root.parent.left = root;
      } else {
        root.parent.right = root;
      }
      root.left = pivot;
      pivot.parent = root;
      pivot.balanceFactor = pivot.balanceFactor + 1 - Math.min(root.balanceFactor, 0);
      root.balanceFactor = root.balanceFactor + 1 - Math.max(pivot.balanceFactor, 0);
    }
  }, {
    key: "rotateRight",
    value: function rotateRight(pivot) {
      var root = pivot.left;
      pivot.left = root.right;
      if (root.right !== null) {
        root.right.parent = pivot;
      }
      root.parent = pivot.parent;
      if (root.parent === null) {
        this.root = root;
      } else if (pivot.isLeftChild) {
        root.parent.left = root;
      } else {
        root.parent.right = root;
      }
      root.right = pivot;
      pivot.parent = root;
      pivot.balanceFactor = pivot.balanceFactor - 1 - Math.min(root.balanceFactor, 0);
      root.balanceFactor = root.balanceFactor - 1 - Math.max(pivot.balanceFactor, 0);
    }
  }, {
    key: Symbol.iterator,
    value: /* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function value() {
      var _iterator, _step, iter;
      return _regeneratorRuntime__default["default"].wrap(function value$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _iterator = _createForOfIteratorHelper$1(this.getIterator());
              _context.prev = 1;
              _iterator.s();
            case 3:
              if ((_step = _iterator.n()).done) {
                _context.next = 9;
                break;
              }
              iter = _step.value;
              _context.next = 7;
              return iter;
            case 7:
              _context.next = 3;
              break;
            case 9:
              _context.next = 14;
              break;
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](1);
              _iterator.e(_context.t0);
            case 14:
              _context.prev = 14;
              _iterator.f();
              return _context.finish(14);
            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, value, this, [[1, 11, 14, 17]]);
    })
  }, {
    key: "getIterator",
    value: /* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function getIterator2() {
      var key, currentNode, fromleft, _args2 = arguments;
      return _regeneratorRuntime__default["default"].wrap(function getIterator$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              key = _args2.length > 0 && _args2[0] !== void 0 ? _args2[0] : null;
              currentNode = this.root;
            case 2:
              if (!currentNode) {
                _context2.next = 8;
                break;
              }
              if (!(this.isEqual(key, currentNode.key) || key === null && !currentNode.left)) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("break", 8);
            case 5:
              if (this.isLessThan(key, currentNode.key) || key === null) {
                currentNode = currentNode.left;
              } else {
                currentNode = currentNode.right;
              }
              _context2.next = 2;
              break;
            case 8:
              if (currentNode) {
                _context2.next = 10;
                break;
              }
              return _context2.abrupt("return", null);
            case 10:
              fromleft = true;
            case 11:
              if (!fromleft) {
                _context2.next = 29;
                break;
              }
              _context2.next = 14;
              return [currentNode.key, currentNode.value];
            case 14:
              fromleft = false;
              if (!currentNode.right) {
                _context2.next = 21;
                break;
              }
              currentNode = currentNode.right;
              while (currentNode.left) {
                currentNode = currentNode.left;
              }
              fromleft = true;
              _context2.next = 27;
              break;
            case 21:
              if (!currentNode.parent) {
                _context2.next = 26;
                break;
              }
              fromleft = currentNode.parent.left === currentNode;
              currentNode = currentNode.parent;
              _context2.next = 27;
              break;
            case 26:
              return _context2.abrupt("break", 37);
            case 27:
              _context2.next = 35;
              break;
            case 29:
              if (!currentNode.parent) {
                _context2.next = 34;
                break;
              }
              fromleft = currentNode.parent.left === currentNode;
              currentNode = currentNode.parent;
              _context2.next = 35;
              break;
            case 34:
              return _context2.abrupt("break", 37);
            case 35:
              _context2.next = 11;
              break;
            case 37:
              return _context2.abrupt("return", null);
            case 38:
            case "end":
              return _context2.stop();
          }
        }
      }, getIterator2, this);
    })
  }, {
    key: "getReverseIterator",
    value: /* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function getReverseIterator() {
      var key, currentNode, fromright, _args3 = arguments;
      return _regeneratorRuntime__default["default"].wrap(function getReverseIterator$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              key = _args3.length > 0 && _args3[0] !== void 0 ? _args3[0] : null;
              currentNode = this.root;
            case 2:
              if (!currentNode) {
                _context3.next = 8;
                break;
              }
              if (!(this.isEqual(key, currentNode.key) || key === null && !currentNode.right)) {
                _context3.next = 5;
                break;
              }
              return _context3.abrupt("break", 8);
            case 5:
              if (!this.isLessThan(key, currentNode.key) || key === null) {
                currentNode = currentNode.right;
              } else {
                currentNode = currentNode.left;
              }
              _context3.next = 2;
              break;
            case 8:
              if (currentNode) {
                _context3.next = 10;
                break;
              }
              return _context3.abrupt("return", null);
            case 10:
              fromright = true;
            case 11:
              if (!fromright) {
                _context3.next = 29;
                break;
              }
              _context3.next = 14;
              return [currentNode.key, currentNode.value];
            case 14:
              fromright = false;
              if (!currentNode.left) {
                _context3.next = 21;
                break;
              }
              currentNode = currentNode.left;
              while (currentNode.right) {
                currentNode = currentNode.right;
              }
              fromright = true;
              _context3.next = 27;
              break;
            case 21:
              if (!currentNode.parent) {
                _context3.next = 26;
                break;
              }
              fromright = currentNode.parent.right === currentNode;
              currentNode = currentNode.parent;
              _context3.next = 27;
              break;
            case 26:
              return _context3.abrupt("break", 37);
            case 27:
              _context3.next = 35;
              break;
            case 29:
              if (!currentNode.parent) {
                _context3.next = 34;
                break;
              }
              fromright = currentNode.parent.right === currentNode;
              currentNode = currentNode.parent;
              _context3.next = 35;
              break;
            case 34:
              return _context3.abrupt("break", 37);
            case 35:
              _context3.next = 11;
              break;
            case 37:
              return _context3.abrupt("return", null);
            case 38:
            case "end":
              return _context3.stop();
          }
        }
      }, getReverseIterator, this);
    })
  }]);
  return TreeMap2;
}();
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i = 0;
      var F = function F2() {
      };
      return { s: F, n: function n() {
        if (i >= o.length)
          return { done: true };
        return { done: false, value: o[i++] };
      }, e: function e(_e) {
        throw _e;
      }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return { s: function s() {
    it = it.call(o);
  }, n: function n() {
    var step = it.next();
    normalCompletion = step.done;
    return step;
  }, e: function e(_e2) {
    didErr = true;
    err = _e2;
  }, f: function f() {
    try {
      if (!normalCompletion && it.return != null)
        it.return();
    } finally {
      if (didErr)
        throw err;
    }
  } };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var Entry = /* @__PURE__ */ function() {
  function Entry2(value, revision) {
    _classCallCheck__default["default"](this, Entry2);
    this.value = value;
    this.revision = revision || 0;
  }
  _createClass__default["default"](Entry2, [{
    key: "isValid",
    get: function get3() {
      return true;
    }
  }]);
  return Entry2;
}();
var Tombstone = /* @__PURE__ */ function() {
  function Tombstone2(revision) {
    _classCallCheck__default["default"](this, Tombstone2);
    this.revision = revision;
  }
  _createClass__default["default"](Tombstone2, [{
    key: "isValid",
    get: function get3() {
      return false;
    }
  }]);
  return Tombstone2;
}();
var Cache = /* @__PURE__ */ function() {
  function Cache2() {
    _classCallCheck__default["default"](this, Cache2);
    this.items = new TreeMap();
  }
  _createClass__default["default"](Cache2, [{
    key: "store",
    value: function store(key, value, revision) {
      var entry = this.items.get(key);
      if (entry && entry.revision > revision) {
        if (entry.isValid) {
          return entry.value;
        }
        return null;
      }
      this.items.set(key, new Entry(value, revision));
      return value;
    }
  }, {
    key: "delete",
    value: function _delete(key, revision) {
      var force = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
      var curr = this.items.get(key);
      if (!curr || curr.revision < revision || curr && force === true) {
        this.items.set(key, new Tombstone(revision));
      }
    }
  }, {
    key: "isKnown",
    value: function isKnown(key, revision) {
      var curr = this.items.get(key);
      return curr && curr.revision >= revision;
    }
  }, {
    key: "get",
    value: function get3(key) {
      var entry = this.items.get(key);
      if (entry && entry.isValid) {
        return entry.value;
      }
      return null;
    }
  }, {
    key: "has",
    value: function has3(key) {
      var entry = this.items.get(key);
      return entry && entry.isValid;
    }
  }, {
    key: "forEach",
    value: function forEach5(callbackfn) {
      if (this.items) {
        var _iterator = _createForOfIteratorHelper(this.items), _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done; ) {
            var _step$value = _slicedToArray__default["default"](_step.value, 2), key = _step$value[0], entry = _step$value[1];
            if (entry.isValid) {
              callbackfn(key, entry.value);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
  }]);
  return Cache2;
}();
function _createSuper$4(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$4();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf__default["default"](Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf__default["default"](this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn__default["default"](this, result);
  };
}
function _isNativeReflectConstruct$4() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var SyncListImpl = /* @__PURE__ */ function(_SyncEntity) {
  _inherits__default["default"](SyncListImpl2, _SyncEntity);
  var _super = _createSuper$4(SyncListImpl2);
  function SyncListImpl2(services, descriptor, removalHandler) {
    var _this;
    _classCallCheck__default["default"](this, SyncListImpl2);
    _this = _super.call(this, services, removalHandler);
    var updateRequestReducer = function updateRequestReducer2(acc, input) {
      return typeof input.ttl === "number" ? {
        ttl: input.ttl
      } : acc;
    };
    _this.updateMergingQueue = new NamespacedMergingQueue(updateRequestReducer);
    _this.cache = new Cache();
    _this.descriptor = descriptor;
    _this.descriptor.date_updated = new Date(_this.descriptor.date_updated);
    return _this;
  }
  _createClass__default["default"](SyncListImpl2, [{
    key: "uri",
    get: function get3() {
      return this.descriptor.url;
    }
  }, {
    key: "revision",
    get: function get3() {
      return this.descriptor.revision;
    }
  }, {
    key: "lastEventId",
    get: function get3() {
      return this.descriptor.last_event_id;
    }
  }, {
    key: "links",
    get: function get3() {
      return this.descriptor.links;
    }
  }, {
    key: "dateExpires",
    get: function get3() {
      return this.descriptor.date_expires;
    }
  }, {
    key: "type",
    get: function get3() {
      return "list";
    }
    // below properties are specific to Insights only
  }, {
    key: "indexName",
    get: function get3() {
      return void 0;
    }
  }, {
    key: "queryString",
    get: function get3() {
      return void 0;
    }
    // public props, documented along with class description
  }, {
    key: "sid",
    get: function get3() {
      return this.descriptor.sid;
    }
  }, {
    key: "uniqueName",
    get: function get3() {
      return this.descriptor.unique_name || null;
    }
  }, {
    key: "dateUpdated",
    get: function get3() {
      return this.descriptor.date_updated;
    }
  }, {
    key: "_addOrUpdateItemOnServer",
    value: function() {
      var _addOrUpdateItemOnServer2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee(url, data2, ifMatch, ttl) {
        var requestBody, response;
        return _regeneratorRuntime__default["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                requestBody = {
                  data: data2
                };
                if (ttl !== void 0) {
                  requestBody.ttl = ttl;
                }
                _context.next = 4;
                return this.services.network.post(url, requestBody, ifMatch);
              case 4:
                response = _context.sent;
                response.body.data = data2;
                response.body.date_updated = new Date(response.body.date_updated);
                return _context.abrupt("return", response.body);
              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function _addOrUpdateItemOnServer(_x, _x2, _x3, _x4) {
        return _addOrUpdateItemOnServer2.apply(this, arguments);
      }
      return _addOrUpdateItemOnServer;
    }()
  }, {
    key: "push",
    value: function() {
      var _push = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee2(value, itemMetadata) {
        var ttl, item, index2;
        return _regeneratorRuntime__default["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                ttl = (itemMetadata || {}).ttl;
                _context2.next = 3;
                return this._addOrUpdateItemOnServer(this.links.items, value, void 0, ttl);
              case 3:
                item = _context2.sent;
                index2 = Number(item.index);
                this._handleItemMutated(index2, item.url, item.last_event_id, item.revision, value, item.date_updated, item.date_expires, true, false);
                return _context2.abrupt("return", this.cache.get(index2));
              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function push2(_x5, _x6) {
        return _push.apply(this, arguments);
      }
      return push2;
    }()
  }, {
    key: "set",
    value: function() {
      var _set = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee3(index2, value, itemMetadataUpdates) {
        var _this2 = this;
        var input;
        return _regeneratorRuntime__default["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                input = itemMetadataUpdates || {};
                return _context3.abrupt("return", this.updateMergingQueue.squashAndAdd(index2, input, function(input2) {
                  return _this2._updateItemUnconditionally(index2, value, input2.ttl);
                }));
              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function set4(_x7, _x8, _x9) {
        return _set.apply(this, arguments);
      }
      return set4;
    }()
  }, {
    key: "_updateItemUnconditionally",
    value: function() {
      var _updateItemUnconditionally2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee4(index2, data2, ttl) {
        var existingItem, itemDescriptor;
        return _regeneratorRuntime__default["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.get(index2);
              case 2:
                existingItem = _context4.sent;
                _context4.next = 5;
                return this._addOrUpdateItemOnServer(existingItem.uri, data2, void 0, ttl);
              case 5:
                itemDescriptor = _context4.sent;
                this._handleItemMutated(index2, itemDescriptor.url, itemDescriptor.last_event_id, itemDescriptor.revision, itemDescriptor.data, itemDescriptor.date_updated, itemDescriptor.date_expires, false, false);
                return _context4.abrupt("return", this.cache.get(index2));
              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
      function _updateItemUnconditionally(_x10, _x11, _x12) {
        return _updateItemUnconditionally2.apply(this, arguments);
      }
      return _updateItemUnconditionally;
    }()
  }, {
    key: "_updateItemWithIfMatch",
    value: function() {
      var _updateItemWithIfMatch2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee5(index2, mutatorFunction, ttl) {
        var existingItem, data2, ifMatch, itemDescriptor;
        return _regeneratorRuntime__default["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.get(index2);
              case 2:
                existingItem = _context5.sent;
                data2 = mutatorFunction(deepClone(existingItem.data));
                if (!data2) {
                  _context5.next = 25;
                  break;
                }
                ifMatch = existingItem.revision;
                _context5.prev = 6;
                _context5.next = 9;
                return this._addOrUpdateItemOnServer(existingItem.uri, data2, ifMatch, ttl);
              case 9:
                itemDescriptor = _context5.sent;
                this._handleItemMutated(index2, itemDescriptor.url, itemDescriptor.last_event_id, itemDescriptor.revision, itemDescriptor.data, itemDescriptor.date_updated, itemDescriptor.date_expires, false, false);
                return _context5.abrupt("return", this.cache.get(index2));
              case 14:
                _context5.prev = 14;
                _context5.t0 = _context5["catch"](6);
                if (!(_context5.t0.status === 412)) {
                  _context5.next = 22;
                  break;
                }
                _context5.next = 19;
                return this._getItemFromServer(index2);
              case 19:
                return _context5.abrupt("return", this._updateItemWithIfMatch(index2, mutatorFunction, ttl));
              case 22:
                throw _context5.t0;
              case 23:
                _context5.next = 26;
                break;
              case 25:
                return _context5.abrupt("return", existingItem);
              case 26:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[6, 14]]);
      }));
      function _updateItemWithIfMatch(_x13, _x14, _x15) {
        return _updateItemWithIfMatch2.apply(this, arguments);
      }
      return _updateItemWithIfMatch;
    }()
  }, {
    key: "mutate",
    value: function() {
      var _mutate = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee6(index2, mutator, itemMetadataUpdates) {
        var _this3 = this;
        var input;
        return _regeneratorRuntime__default["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                input = itemMetadataUpdates || {};
                return _context6.abrupt("return", this.updateMergingQueue.add(index2, input, function(input2) {
                  return _this3._updateItemWithIfMatch(index2, mutator, input2.ttl);
                }));
              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
      function mutate(_x16, _x17, _x18) {
        return _mutate.apply(this, arguments);
      }
      return mutate;
    }()
  }, {
    key: "update",
    value: function() {
      var _update2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee7(index2, obj, itemMetadataUpdates) {
        return _regeneratorRuntime__default["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", this.mutate(index2, function(remote) {
                  return Object.assign(remote, obj);
                }, itemMetadataUpdates));
              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
      function update(_x19, _x20, _x21) {
        return _update2.apply(this, arguments);
      }
      return update;
    }()
  }, {
    key: "remove",
    value: function() {
      var _remove = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee8(index2) {
        var item, previousItemData, response;
        return _regeneratorRuntime__default["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.get(index2);
              case 2:
                item = _context8.sent;
                previousItemData = deepClone(item.data);
                _context8.next = 6;
                return this.services.network.delete(item.uri);
              case 6:
                response = _context8.sent;
                this._handleItemRemoved(index2, response.body.last_event_id, previousItemData, new Date(response.body.date_updated), false);
              case 8:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
      function remove(_x22) {
        return _remove.apply(this, arguments);
      }
      return remove;
    }()
  }, {
    key: "get",
    value: function() {
      var _get2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee9(index2) {
        var cachedItem;
        return _regeneratorRuntime__default["default"].wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                cachedItem = this.cache.get(index2);
                if (!cachedItem) {
                  _context9.next = 5;
                  break;
                }
                return _context9.abrupt("return", cachedItem);
              case 5:
                return _context9.abrupt("return", this._getItemFromServer(index2));
              case 6:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
      function get3(_x23) {
        return _get2.apply(this, arguments);
      }
      return get3;
    }()
  }, {
    key: "_getItemFromServer",
    value: function() {
      var _getItemFromServer2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee10(index2) {
        var result;
        return _regeneratorRuntime__default["default"].wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.queryItems({
                  index: index2
                });
              case 2:
                result = _context10.sent;
                if (!(result.items.length < 1)) {
                  _context10.next = 7;
                  break;
                }
                throw new SyncError("No item with index ".concat(index2, " found"), 404, 54151);
              case 7:
                return _context10.abrupt("return", result.items[0]);
              case 8:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
      function _getItemFromServer(_x24) {
        return _getItemFromServer2.apply(this, arguments);
      }
      return _getItemFromServer;
    }()
    /**
     * Query items from the List
     * @private
     */
  }, {
    key: "queryItems",
    value: function() {
      var _queryItems2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee11(arg) {
        var _this4 = this;
        var url, response, items, meta2;
        return _regeneratorRuntime__default["default"].wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                arg = arg || {};
                url = new UriBuilder(this.links.items).queryParam("From", arg.from).queryParam("PageSize", arg.limit).queryParam("Index", arg.index).queryParam("PageToken", arg.pageToken).queryParam("Order", arg.order).build();
                _context11.next = 4;
                return this.services.network.get(url);
              case 4:
                response = _context11.sent;
                items = response.body.items.map(function(el) {
                  el.date_updated = new Date(el.date_updated);
                  var itemInCache = _this4.cache.get(el.index);
                  if (itemInCache) {
                    _this4._handleItemMutated(el.index, el.url, el.last_event_id, el.revision, el.data, el.date_updated, el.date_expires, false, true);
                  } else {
                    _this4.cache.store(Number(el.index), new SyncListItem({
                      index: Number(el.index),
                      uri: el.url,
                      revision: el.revision,
                      lastEventId: el.last_event_id,
                      dateUpdated: el.date_updated,
                      dateExpires: el.date_expires,
                      data: el.data
                    }), el.last_event_id);
                  }
                  return _this4.cache.get(el.index);
                });
                meta2 = response.body.meta;
                return _context11.abrupt("return", new Paginator(items, function(pageToken) {
                  return _this4.queryItems({
                    pageToken
                  });
                }, meta2.previous_token, meta2.next_token));
              case 8:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));
      function queryItems2(_x25) {
        return _queryItems2.apply(this, arguments);
      }
      return queryItems2;
    }()
  }, {
    key: "getItems",
    value: function() {
      var _getItems = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee12(args) {
        return _regeneratorRuntime__default["default"].wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                args = args || {};
                validatePageSize(args.pageSize);
                args.limit = args.pageSize || args.limit || 50;
                args.order = args.order || "asc";
                return _context12.abrupt("return", this.queryItems(args));
              case 5:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));
      function getItems(_x26) {
        return _getItems.apply(this, arguments);
      }
      return getItems;
    }()
    /**
     * @return {Promise<Object>} Context of List
     * @private
     */
  }, {
    key: "getContext",
    value: function() {
      var _getContext = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee13() {
        var response;
        return _regeneratorRuntime__default["default"].wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                if (this.context) {
                  _context13.next = 5;
                  break;
                }
                _context13.next = 3;
                return this.services.network.get(this.links.context);
              case 3:
                response = _context13.sent;
                this._updateContextIfRequired(response.body.data, response.body.last_event_id);
              case 5:
                return _context13.abrupt("return", this.context);
              case 6:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));
      function getContext() {
        return _getContext.apply(this, arguments);
      }
      return getContext;
    }()
  }, {
    key: "setTtl",
    value: function() {
      var _setTtl = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee14(ttl) {
        var requestBody, response;
        return _regeneratorRuntime__default["default"].wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.prev = 0;
                requestBody = {
                  ttl
                };
                _context14.next = 4;
                return this.services.network.post(this.uri, requestBody);
              case 4:
                response = _context14.sent;
                this.descriptor.date_expires = response.body.date_expires;
                _context14.next = 12;
                break;
              case 8:
                _context14.prev = 8;
                _context14.t0 = _context14["catch"](0);
                if (_context14.t0.status === 404) {
                  this.onRemoved(false);
                }
                throw _context14.t0;
              case 12:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this, [[0, 8]]);
      }));
      function setTtl(_x27) {
        return _setTtl.apply(this, arguments);
      }
      return setTtl;
    }()
  }, {
    key: "setItemTtl",
    value: function() {
      var _setItemTtl = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee15(index2, ttl) {
        var existingItem, requestBody, response;
        return _regeneratorRuntime__default["default"].wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return this.get(index2);
              case 2:
                existingItem = _context15.sent;
                requestBody = {
                  ttl
                };
                _context15.next = 6;
                return this.services.network.post(existingItem.uri, requestBody);
              case 6:
                response = _context15.sent;
                existingItem.updateDateExpires(response.body.date_expires);
              case 8:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));
      function setItemTtl(_x28, _x29) {
        return _setItemTtl.apply(this, arguments);
      }
      return setItemTtl;
    }()
  }, {
    key: "removeList",
    value: function() {
      var _removeList = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee16() {
        return _regeneratorRuntime__default["default"].wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return this.services.network.delete(this.uri);
              case 2:
                this.onRemoved(true);
              case 3:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));
      function removeList() {
        return _removeList.apply(this, arguments);
      }
      return removeList;
    }()
  }, {
    key: "onRemoved",
    value: function onRemoved(locally) {
      this._unsubscribe();
      this.removalHandler(this.type, this.sid, this.uniqueName);
      this.broadcastEventToListeners("removed", {
        isLocal: locally
      });
    }
  }, {
    key: "shouldIgnoreEvent",
    value: function shouldIgnoreEvent(key, eventId) {
      return this.cache.isKnown(key, eventId);
    }
    /**
     * Handle update, which came from the server.
     * @private
     */
  }, {
    key: "_update",
    value: function _update(update, isStrictlyOrdered) {
      var itemIndex = Number(update.item_index);
      update.date_created = new Date(update.date_created);
      switch (update.type) {
        case "list_item_added":
        case "list_item_updated":
          {
            this._handleItemMutated(
              itemIndex,
              update.item_url,
              update.id,
              update.item_revision,
              update.item_data,
              update.date_created,
              void 0,
              // orchestration does not include date_expires  -- @todo  it does now?
              update.type === "list_item_added",
              true
            );
          }
          break;
        case "list_item_removed":
          {
            this._handleItemRemoved(itemIndex, update.id, update.item_data, update.date_created, true);
          }
          break;
        case "list_context_updated":
          {
            this._handleContextUpdate(update.context_data, update.id, update.date_created);
          }
          break;
        case "list_removed":
          {
            this.onRemoved(false);
          }
          break;
      }
      if (isStrictlyOrdered) {
        this._advanceLastEventId(update.id, update.list_revision);
      }
    }
  }, {
    key: "_advanceLastEventId",
    value: function _advanceLastEventId(eventId, revision) {
      if (this.lastEventId < eventId) {
        this.descriptor.last_event_id = eventId;
        if (revision) {
          this.descriptor.revision = revision;
        }
      }
    }
  }, {
    key: "_updateRootDateUpdated",
    value: function _updateRootDateUpdated(dateUpdated) {
      if (!this.descriptor.date_updated || dateUpdated.getTime() > this.descriptor.date_updated.getTime()) {
        this.descriptor.date_updated = dateUpdated;
        this.services.storage.update(this.type, this.sid, this.uniqueName, {
          date_updated: dateUpdated
        });
      }
    }
  }, {
    key: "_handleItemMutated",
    value: function _handleItemMutated(index2, uri, lastEventId, revision, data2, dateUpdated, dateExpires, added, remote) {
      if (this.shouldIgnoreEvent(index2, lastEventId)) {
        log$1$1.trace("Item ".concat(index2, " update skipped, current: ").concat(this.lastEventId, ", remote: ").concat(lastEventId));
        return;
      }
      this._updateRootDateUpdated(dateUpdated);
      var item = this.cache.get(index2);
      if (!item) {
        var newItem = new SyncListItem({
          index: index2,
          uri,
          lastEventId,
          revision,
          data: data2,
          dateUpdated,
          dateExpires
        });
        this.cache.store(index2, newItem, lastEventId);
        this.emitItemMutationEvent(newItem, remote, added);
        return;
      }
      var previousItemData = deepClone(item.data);
      item.update(lastEventId, revision, data2, dateUpdated);
      this.cache.store(index2, item, lastEventId);
      if (dateExpires !== void 0) {
        item.updateDateExpires(dateExpires);
      }
      this.emitItemMutationEvent(item, remote, false, previousItemData);
    }
    /**
     * @private
     */
  }, {
    key: "emitItemMutationEvent",
    value: function emitItemMutationEvent(item, remote, added) {
      var previousItemData = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
      var eventName = added ? "itemAdded" : "itemUpdated";
      var args = {
        item,
        isLocal: !remote
      };
      if (!added) {
        args.previousItemData = previousItemData;
      }
      this.broadcastEventToListeners(eventName, args);
    }
    /**
     * @private
     */
  }, {
    key: "_handleItemRemoved",
    value: function _handleItemRemoved(index2, eventId, oldData, dateUpdated, remote) {
      this._updateRootDateUpdated(dateUpdated);
      this.cache.delete(index2, eventId);
      this.broadcastEventToListeners("itemRemoved", {
        index: index2,
        isLocal: !remote,
        previousItemData: oldData
      });
    }
    /**
     * @private
     */
  }, {
    key: "_handleContextUpdate",
    value: function _handleContextUpdate(data2, eventId, dateUpdated) {
      this._updateRootDateUpdated(dateUpdated);
      if (this._updateContextIfRequired(data2, eventId)) {
        this.broadcastEventToListeners("contextUpdated", {
          context: data2,
          isLocal: false
        });
      }
    }
    /**
     * @private
     */
  }, {
    key: "_updateContextIfRequired",
    value: function _updateContextIfRequired(data2, eventId) {
      if (!this.contextEventId || eventId > this.contextEventId) {
        this.context = data2;
        this.contextEventId = eventId;
        return true;
      } else {
        log$1$1.trace("Context update skipped, current:", this.lastEventId, ", remote:", eventId);
        return false;
      }
    }
  }], [{
    key: "type",
    get: function get3() {
      return "list";
    }
  }]);
  return SyncListImpl2;
}(SyncEntity);
var SyncList = /* @__PURE__ */ function(_Closeable) {
  _inherits__default["default"](SyncList2, _Closeable);
  var _super2 = _createSuper$4(SyncList2);
  function SyncList2(syncListImpl) {
    var _this5;
    _classCallCheck__default["default"](this, SyncList2);
    _this5 = _super2.call(this);
    _this5.syncListImpl = syncListImpl;
    _this5.syncListImpl.attach(_assertThisInitialized__default["default"](_this5));
    return _this5;
  }
  _createClass__default["default"](SyncList2, [{
    key: "uri",
    get: (
      // private props
      function get3() {
        return this.syncListImpl.uri;
      }
    )
  }, {
    key: "revision",
    get: function get3() {
      return this.syncListImpl.revision;
    }
  }, {
    key: "lastEventId",
    get: function get3() {
      return this.syncListImpl.lastEventId;
    }
  }, {
    key: "links",
    get: function get3() {
      return this.syncListImpl.links;
    }
  }, {
    key: "dateExpires",
    get: function get3() {
      return this.syncListImpl.dateExpires;
    }
  }, {
    key: "type",
    get: function get3() {
      return SyncListImpl.type;
    }
    /**
     * Unique ID of the list, immutable identifier assigned by the system.
     */
  }, {
    key: "sid",
    get: function get3() {
      return this.syncListImpl.sid;
    }
    /**
     * Unique name of the list, immutable identifier that can be assigned to the list during creation.
     */
  }, {
    key: "uniqueName",
    get: function get3() {
      return this.syncListImpl.uniqueName;
    }
    /**
     * Date when the list was last updated, given in UTC ISO 8601 format (e.g., '2018-04-26T15:23:19.732Z').
     */
  }, {
    key: "dateUpdated",
    get: function get3() {
      return this.syncListImpl.dateUpdated;
    }
  }, {
    key: "push",
    value: (
      /**
       * Add a new item to the list.
       * @param data Data to be added.
       * @param itemMetadata Item metadata.
       * @return The newly added item.
       * @example
       * ```typescript
       * list.push({ name: 'John Smith' }, { ttl: 86400 })
       *   .then((item) => {
       *     console.log(`List Item push() successful, item index: ${item.index}, data:`, item.data)
       *   })
       *   .catch((error) => {
       *     console.error('List Item push() failed', error);
       *   });
       * ```
       */
      function() {
        var _push2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee17(data2, itemMetadata) {
          return _regeneratorRuntime__default["default"].wrap(function _callee17$(_context17) {
            while (1) {
              switch (_context17.prev = _context17.next) {
                case 0:
                  this.ensureNotClosed();
                  return _context17.abrupt("return", this.syncListImpl.push(data2, itemMetadata));
                case 2:
                case "end":
                  return _context17.stop();
              }
            }
          }, _callee17, this);
        }));
        function push2(_x30, _x31) {
          return _push2.apply(this, arguments);
        }
        return push2;
      }()
    )
    /**
     * Assign new data to an existing item, given its index.
     * @param index Index of the item to be updated.
     * @param value New data to be assigned to an item.
     * @param itemMetadataUpdates New item metadata.
     * @return A promise with the updated item containing latest known data.
     * The promise will be rejected if the item does not exist.
     * @example
     * ```typescript
     * list.set(42, { name: 'John Smith' }, { ttl: 86400 })
     *   .then((item) => {
     *     console.log('List Item set() successful, item data:', item.data)
     *   })
     *   .catch((error) => {
     *     console.error('List Item set() failed', error);
     *   });
     * ```
     */
  }, {
    key: "set",
    value: function() {
      var _set2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee18(index2, value, itemMetadataUpdates) {
        return _regeneratorRuntime__default["default"].wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                this.ensureNotClosed();
                return _context18.abrupt("return", this.syncListImpl.set(index2, value, itemMetadataUpdates));
              case 2:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));
      function set4(_x32, _x33, _x34) {
        return _set2.apply(this, arguments);
      }
      return set4;
    }()
    /**
     * Modify an existing item by applying a mutation function to it.
     * @param index Index of the item to be changed.
     * @param mutator A function that outputs a new data based on the existing data.
     * @param itemMetadataUpdates New item metadata.
     * @return Resolves with the most recent item state, the output of a successful
     * mutation or a state that prompted graceful cancellation (mutator returned `null`). This promise
     * will be rejected if the indicated item does not already exist.
     * @example
     * ```typescript
     * const mutatorFunction = (currentValue) => {
     *     currentValue.viewCount = (currentValue.viewCount || 0) + 1;
     *     return currentValue;
     * };
     * list.mutate(42, mutatorFunction, { ttl: 86400 })
     *   .then((item) => {
     *     console.log('List Item mutate() successful, new data:', item.data)
     *   })
     *   .catch((error) => {
     *     console.error('List Item mutate() failed', error);
     *   });
     * ```
     */
  }, {
    key: "mutate",
    value: function() {
      var _mutate2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee19(index2, mutator, itemMetadataUpdates) {
        return _regeneratorRuntime__default["default"].wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                this.ensureNotClosed();
                return _context19.abrupt("return", this.syncListImpl.mutate(index2, mutator, itemMetadataUpdates));
              case 2:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));
      function mutate(_x35, _x36, _x37) {
        return _mutate2.apply(this, arguments);
      }
      return mutate;
    }()
    /**
     * Modify an existing item by appending new fields (or overwriting existing ones) with the values from the object.
     * This is equivalent to
     * ```typescript
     * list.mutate(42, (currentValue) => Object.assign(currentValue, obj));
     * ```
     * @param index Index of an item to be changed.
     * @param obj Set of fields to update.
     * @param itemMetadataUpdates New item metadata.
     * @return A promise with a modified item containing latest known data.
     * The promise will be rejected if the item was not found.
     * @example
     * ```typescript
     * // Say, the List Item (index: 42) data is `{ name: 'John Smith' }`
     * list.update(42, { age: 34 }, { ttl: 86400 })
     *   .then((item) => {
     *     // Now the List Item data is `{ name: 'John Smith', age: 34 }`
     *     console.log('List Item update() successful, new data:', item.data);
     *   })
     *   .catch((error) => {
     *     console.error('List Item update() failed', error);
     *   });
     * ```
     */
  }, {
    key: "update",
    value: function() {
      var _update3 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee20(index2, obj, itemMetadataUpdates) {
        return _regeneratorRuntime__default["default"].wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                this.ensureNotClosed();
                return _context20.abrupt("return", this.syncListImpl.update(index2, obj, itemMetadataUpdates));
              case 2:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));
      function update(_x38, _x39, _x40) {
        return _update3.apply(this, arguments);
      }
      return update;
    }()
    /**
     * Delete an item given its index.
     * @param index Index of the item to be removed.
     * @return A promise to remove the item.
     * The promise will be rejected if the item was not found.
     * @example
     * ```typescript
     * list.remove(42)
     *   .then(() => {
     *     console.log('List Item remove() successful');
     *   })
     *   .catch((error) => {
     *     console.error('List Item remove() failed', error);
     *   });
     * ```
     */
  }, {
    key: "remove",
    value: function() {
      var _remove2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee21(index2) {
        return _regeneratorRuntime__default["default"].wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                this.ensureNotClosed();
                return _context21.abrupt("return", this.syncListImpl.remove(index2));
              case 2:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));
      function remove(_x41) {
        return _remove2.apply(this, arguments);
      }
      return remove;
    }()
    /**
     * Retrieve an item by List index.
     * @param index Item index in the list.
     * @return A promise with the item containing latest known data.
     * The promise will be rejected if the item was not found.
     * @example
     * ```typescript
     * list.get(42)
     *   .then((item) => {
     *     console.log('List Item get() successful, item data:', item.data)
     *   })
     *   .catch((error) => {
     *     console.error('List Item get() failed', error);
     *   });
     * ```
     */
  }, {
    key: "get",
    value: function() {
      var _get3 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee22(index2) {
        return _regeneratorRuntime__default["default"].wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                this.ensureNotClosed();
                return _context22.abrupt("return", this.syncListImpl.get(index2));
              case 2:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));
      function get3(_x42) {
        return _get3.apply(this, arguments);
      }
      return get3;
    }()
    /**
     * Retrieve a list context
     * @return A promise with the list's context
     * @internal
     */
  }, {
    key: "getContext",
    value: function() {
      var _getContext2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee23() {
        return _regeneratorRuntime__default["default"].wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                this.ensureNotClosed();
                return _context23.abrupt("return", this.syncListImpl.getContext());
              case 2:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));
      function getContext() {
        return _getContext2.apply(this, arguments);
      }
      return getContext;
    }()
    /**
     * Query a list of items from collection.
     * Information about the query limits can be found {@link https://www.twilio.com/docs/sync/limits|here}.
     * @param queryOptions Query options.
     * @example
     * ```typescript
     * const pageHandler = (paginator) => {
     *   paginator.items.forEach((item) => {
     *     console.log(`Item ${item.index}:`, item.data);
     *   });
     *   return paginator.hasNextPage
     *     ? paginator.nextPage().then(pageHandler)
     *     : null;
     * };
     * list.getItems({ from: 0, order: 'asc' })
     *   .then(pageHandler)
     *   .catch((error) => {
     *     console.error('List getItems() failed', error);
     *   });
     * ```
     */
  }, {
    key: "getItems",
    value: function() {
      var _getItems2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee24(queryOptions) {
        return _regeneratorRuntime__default["default"].wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                this.ensureNotClosed();
                return _context24.abrupt("return", this.syncListImpl.getItems(queryOptions));
              case 2:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));
      function getItems(_x43) {
        return _getItems2.apply(this, arguments);
      }
      return getItems;
    }()
    /**
     * Update the time-to-live of the list.
     * @param ttl Specifies the TTL in seconds after which the list is subject to automatic deletion. The value 0 means infinity.
     * @return A promise that resolves after the TTL update was successful.
     * @example
     * ```typescript
     * list.setTtl(3600)
     *   .then(() => {
     *     console.log('List setTtl() successful');
     *   })
     *   .catch((error) => {
     *     console.error('List setTtl() failed', error);
     *   });
     * ```
     */
  }, {
    key: "setTtl",
    value: function() {
      var _setTtl2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee25(ttl) {
        return _regeneratorRuntime__default["default"].wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                this.ensureNotClosed();
                return _context25.abrupt("return", this.syncListImpl.setTtl(ttl));
              case 2:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));
      function setTtl(_x44) {
        return _setTtl2.apply(this, arguments);
      }
      return setTtl;
    }()
    /**
     * Update the time-to-live of a list item.
     * @param index Item index.
     * @param ttl Specifies the TTL in seconds after which the list item is subject to automatic deletion. The value 0 means infinity.
     * @return A promise that resolves after the TTL update was successful.
     * @example
     * ```typescript
     * list.setItemTtl(42, 86400)
     *   .then(() => {
     *     console.log('List setItemTtl() successful');
     *   })
     *   .catch((error) => {
     *     console.error('List setItemTtl() failed', error);
     *   });
     * ```
     */
  }, {
    key: "setItemTtl",
    value: function() {
      var _setItemTtl2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee26(index2, ttl) {
        return _regeneratorRuntime__default["default"].wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                this.ensureNotClosed();
                return _context26.abrupt("return", this.syncListImpl.setItemTtl(index2, ttl));
              case 2:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));
      function setItemTtl(_x45, _x46) {
        return _setItemTtl2.apply(this, arguments);
      }
      return setItemTtl;
    }()
    /**
     * Delete this list. It will be impossible to restore it.
     * @return A promise that resolves when the list has been deleted.
     * @example
     * list.removeList()
     *   .then(() => {
     *     console.log('List removeList() successful');
     *   })
     *   .catch((error) => {
     *     console.error('List removeList() failed', error);
     *   });
     */
  }, {
    key: "removeList",
    value: function() {
      var _removeList2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee27() {
        return _regeneratorRuntime__default["default"].wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                this.ensureNotClosed();
                return _context27.abrupt("return", this.syncListImpl.removeList());
              case 2:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));
      function removeList() {
        return _removeList2.apply(this, arguments);
      }
      return removeList;
    }()
    /**
     * Conclude work with the list instance and remove all event listeners attached to it.
     * Any subsequent operation on this object will be rejected with error.
     * Other local copies of this list will continue operating and receiving events normally.
     * @example
     * ```typescript
     * list.close();
     * ```
     */
  }, {
    key: "close",
    value: function close() {
      _get__default["default"](_getPrototypeOf__default["default"](SyncList2.prototype), "close", this).call(this);
      this.syncListImpl.detach(this.listenerUuid);
    }
  }], [{
    key: "type",
    get: function get3() {
      return SyncListImpl.type;
    }
  }]);
  return SyncList2;
}(Closeable);
_defineProperty__default["default"](SyncList, "itemAdded", "itemAdded");
_defineProperty__default["default"](SyncList, "itemUpdated", "itemUpdated");
_defineProperty__default["default"](SyncList, "itemRemoved", "itemRemoved");
_defineProperty__default["default"](SyncList, "removed", "removed");
__decorate([declarativeTypeValidator.validateTypesAsync(declarativeTypeValidator.pureObject, ["undefined", declarativeTypeValidator.objectSchema("item metadata", {
  ttl: [declarativeTypeValidator.nonNegativeInteger, "undefined"]
})]), __metadata("design:type", Function), __metadata("design:paramtypes", [Object, Object]), __metadata("design:returntype", Promise)], SyncList.prototype, "push", null);
__decorate([declarativeTypeValidator.validateTypesAsync(declarativeTypeValidator.nonNegativeInteger, declarativeTypeValidator.pureObject, ["undefined", declarativeTypeValidator.objectSchema("item metadata", {
  ttl: [declarativeTypeValidator.nonNegativeInteger, "undefined"]
})]), __metadata("design:type", Function), __metadata("design:paramtypes", [Number, Object, Object]), __metadata("design:returntype", Promise)], SyncList.prototype, "set", null);
__decorate([declarativeTypeValidator.validateTypesAsync(declarativeTypeValidator.nonNegativeInteger, "function", ["undefined", declarativeTypeValidator.objectSchema("item metadata", {
  ttl: [declarativeTypeValidator.nonNegativeInteger, "undefined"]
})]), __metadata("design:type", Function), __metadata("design:paramtypes", [Number, Function, Object]), __metadata("design:returntype", Promise)], SyncList.prototype, "mutate", null);
__decorate([declarativeTypeValidator.validateTypesAsync(declarativeTypeValidator.nonNegativeInteger, declarativeTypeValidator.pureObject, ["undefined", declarativeTypeValidator.objectSchema("item metadata", {
  ttl: [declarativeTypeValidator.nonNegativeInteger, "undefined"]
})]), __metadata("design:type", Function), __metadata("design:paramtypes", [Number, Object, Object]), __metadata("design:returntype", Promise)], SyncList.prototype, "update", null);
__decorate([declarativeTypeValidator.validateTypesAsync(declarativeTypeValidator.nonNegativeInteger), __metadata("design:type", Function), __metadata("design:paramtypes", [Number]), __metadata("design:returntype", Promise)], SyncList.prototype, "remove", null);
__decorate([declarativeTypeValidator.validateTypesAsync(declarativeTypeValidator.nonNegativeInteger), __metadata("design:type", Function), __metadata("design:paramtypes", [Number]), __metadata("design:returntype", Promise)], SyncList.prototype, "get", null);
__decorate([declarativeTypeValidator.validateTypesAsync(["undefined", declarativeTypeValidator.objectSchema("query options", {
  from: [declarativeTypeValidator.nonNegativeInteger, "undefined"],
  pageSize: [declarativeTypeValidator.custom(function(value) {
    return [isPositiveInteger(value), "a positive integer"];
  }), "undefined"]
})]), __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", Promise)], SyncList.prototype, "getItems", null);
__decorate([declarativeTypeValidator.validateTypesAsync(declarativeTypeValidator.nonNegativeInteger), __metadata("design:type", Function), __metadata("design:paramtypes", [Number]), __metadata("design:returntype", Promise)], SyncList.prototype, "setTtl", null);
__decorate([declarativeTypeValidator.validateTypesAsync(declarativeTypeValidator.nonNegativeInteger, declarativeTypeValidator.nonNegativeInteger), __metadata("design:type", Function), __metadata("design:paramtypes", [Number, Number]), __metadata("design:returntype", Promise)], SyncList.prototype, "setItemTtl", null);
var SyncMapItem = /* @__PURE__ */ function() {
  function SyncMapItem2(descriptor) {
    _classCallCheck__default["default"](this, SyncMapItem2);
    this.descriptor = descriptor;
  }
  _createClass__default["default"](SyncMapItem2, [{
    key: "uri",
    get: function get3() {
      return this.descriptor.url;
    }
  }, {
    key: "revision",
    get: function get3() {
      return this.descriptor.revision;
    }
  }, {
    key: "lastEventId",
    get: function get3() {
      return this.descriptor.last_event_id;
    }
  }, {
    key: "dateExpires",
    get: function get3() {
      return this.descriptor.date_expires;
    }
    /**
     * The identifier that maps to this item within the containing Map.
     */
  }, {
    key: "key",
    get: function get3() {
      return this.descriptor.key;
    }
    /**
     * The contents of the item.
     */
  }, {
    key: "data",
    get: function get3() {
      return this.descriptor.data;
    }
    /**
     * Date when the map item was last updated.
     */
  }, {
    key: "dateUpdated",
    get: function get3() {
      return this.descriptor.date_updated;
    }
    /**
     * @internal
     */
  }, {
    key: "update",
    value: function update(eventId, revision, value, dateUpdated) {
      this.descriptor.last_event_id = eventId;
      this.descriptor.revision = revision;
      this.descriptor.data = value;
      this.descriptor.date_updated = dateUpdated;
      return this;
    }
    /**
     * @internal
     */
  }, {
    key: "updateDateExpires",
    value: function updateDateExpires(dateExpires) {
      this.descriptor.date_expires = dateExpires;
    }
  }]);
  return SyncMapItem2;
}();
function _createSuper$3(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$3();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf__default["default"](Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf__default["default"](this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn__default["default"](this, result);
  };
}
function _isNativeReflectConstruct$3() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var SyncMapImpl = /* @__PURE__ */ function(_SyncEntity) {
  _inherits__default["default"](SyncMapImpl2, _SyncEntity);
  var _super = _createSuper$3(SyncMapImpl2);
  function SyncMapImpl2(services, descriptor, removalHandler) {
    var _this;
    _classCallCheck__default["default"](this, SyncMapImpl2);
    _this = _super.call(this, services, removalHandler);
    var updateRequestReducer = function updateRequestReducer2(acc, input) {
      return typeof input.ttl === "number" ? {
        ttl: input.ttl
      } : acc;
    };
    _this.updateMergingQueue = new NamespacedMergingQueue(updateRequestReducer);
    _this.cache = new Cache();
    _this.descriptor = descriptor;
    _this.descriptor.date_updated = new Date(_this.descriptor.date_updated);
    if (descriptor.items) {
      descriptor.items.forEach(function(itemDescriptor) {
        itemDescriptor.date_updated = new Date(itemDescriptor.date_updated);
        _this.cache.store(itemDescriptor.key, new SyncMapItem(itemDescriptor), itemDescriptor.last_event_id);
      });
    }
    return _this;
  }
  _createClass__default["default"](SyncMapImpl2, [{
    key: "uri",
    get: function get3() {
      return this.descriptor.url;
    }
  }, {
    key: "links",
    get: function get3() {
      return this.descriptor.links;
    }
  }, {
    key: "revision",
    get: function get3() {
      return this.descriptor.revision;
    }
  }, {
    key: "lastEventId",
    get: function get3() {
      return this.descriptor.last_event_id;
    }
  }, {
    key: "dateExpires",
    get: function get3() {
      return this.descriptor.date_expires;
    }
  }, {
    key: "type",
    get: function get3() {
      return "map";
    }
    // below properties are specific to Insights only
  }, {
    key: "indexName",
    get: function get3() {
      return void 0;
    }
  }, {
    key: "queryString",
    get: function get3() {
      return void 0;
    }
    // public props, documented along with class description
  }, {
    key: "sid",
    get: function get3() {
      return this.descriptor.sid;
    }
  }, {
    key: "uniqueName",
    get: function get3() {
      return this.descriptor.unique_name || null;
    }
  }, {
    key: "dateUpdated",
    get: function get3() {
      return this.descriptor.date_updated;
    }
  }, {
    key: "set",
    value: function() {
      var _set = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee(key, value, itemMetadataUpdates) {
        var _this2 = this;
        var input;
        return _regeneratorRuntime__default["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                input = itemMetadataUpdates || {};
                return _context.abrupt("return", this.updateMergingQueue.squashAndAdd(key, input, function(input2) {
                  return _this2._putItemUnconditionally(key, value, input2.ttl);
                }));
              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function set4(_x, _x2, _x3) {
        return _set.apply(this, arguments);
      }
      return set4;
    }()
  }, {
    key: "get",
    value: function() {
      var _get2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee2(key) {
        return _regeneratorRuntime__default["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(key === null || key === void 0)) {
                  _context2.next = 2;
                  break;
                }
                throw new SyncError("SyncMapItem key may not be empty", 400, 54209);
              case 2:
                if (!this.cache.has(key)) {
                  _context2.next = 6;
                  break;
                }
                return _context2.abrupt("return", this.cache.get(key));
              case 6:
                return _context2.abrupt("return", this._getItemFromServer(key));
              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function get3(_x4) {
        return _get2.apply(this, arguments);
      }
      return get3;
    }()
  }, {
    key: "_getItemFromServer",
    value: function() {
      var _getItemFromServer2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee3(key) {
        var result;
        return _regeneratorRuntime__default["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.queryItems({
                  key
                });
              case 2:
                result = _context3.sent;
                if (!(result.items.length < 1)) {
                  _context3.next = 7;
                  break;
                }
                throw new SyncError("The specified Map Item does not exist", 404, 54201);
              case 7:
                return _context3.abrupt("return", result.items[0]);
              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function _getItemFromServer(_x5) {
        return _getItemFromServer2.apply(this, arguments);
      }
      return _getItemFromServer;
    }()
  }, {
    key: "mutate",
    value: function() {
      var _mutate = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee4(key, mutator, itemMetadataUpdates) {
        var _this3 = this;
        var input;
        return _regeneratorRuntime__default["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                input = itemMetadataUpdates || {};
                return _context4.abrupt("return", this.updateMergingQueue.add(key, input, function(input2) {
                  return _this3._putItemWithIfMatch(key, mutator, input2.ttl);
                }));
              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
      function mutate(_x6, _x7, _x8) {
        return _mutate.apply(this, arguments);
      }
      return mutate;
    }()
  }, {
    key: "update",
    value: function() {
      var _update2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee5(key, obj, itemMetadataUpdates) {
        return _regeneratorRuntime__default["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", this.mutate(key, function(remote) {
                  return Object.assign(remote, obj);
                }, itemMetadataUpdates));
              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
      function update(_x9, _x10, _x11) {
        return _update2.apply(this, arguments);
      }
      return update;
    }()
  }, {
    key: "_putItemUnconditionally",
    value: function() {
      var _putItemUnconditionally2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee6(key, data2, ttl) {
        var result, item;
        return _regeneratorRuntime__default["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this._putItemToServer(key, data2, void 0, ttl);
              case 2:
                result = _context6.sent;
                item = result.item;
                this._handleItemMutated(item.key, item.url, item.last_event_id, item.revision, item.data, item.date_updated, item.date_expires, result.added, false);
                return _context6.abrupt("return", this.cache.get(item.key));
              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
      function _putItemUnconditionally(_x12, _x13, _x14) {
        return _putItemUnconditionally2.apply(this, arguments);
      }
      return _putItemUnconditionally;
    }()
  }, {
    key: "_putItemWithIfMatch",
    value: function() {
      var _putItemWithIfMatch2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee7(key, mutatorFunction, ttl) {
        var currentItem, data2, ifMatch, result, item;
        return _regeneratorRuntime__default["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.get(key).catch(function(error2) {
                  if (error2.status === 404) {
                    return new SyncMapItem({
                      key,
                      data: {},
                      last_event_id: -1,
                      revision: "-1",
                      url: null,
                      date_updated: null,
                      date_expires: null
                    });
                  } else {
                    throw error2;
                  }
                });
              case 2:
                currentItem = _context7.sent;
                data2 = mutatorFunction(deepClone(currentItem.data));
                if (!data2) {
                  _context7.next = 26;
                  break;
                }
                ifMatch = currentItem.revision;
                _context7.prev = 6;
                _context7.next = 9;
                return this._putItemToServer(key, data2, ifMatch, ttl);
              case 9:
                result = _context7.sent;
                item = result.item;
                this._handleItemMutated(item.key, item.url, item.last_event_id, item.revision, item.data, item.date_updated, item.date_expires, result.added, false);
                return _context7.abrupt("return", this.cache.get(item.key));
              case 15:
                _context7.prev = 15;
                _context7.t0 = _context7["catch"](6);
                if (!(_context7.t0.status === 412)) {
                  _context7.next = 23;
                  break;
                }
                _context7.next = 20;
                return this._getItemFromServer(key);
              case 20:
                return _context7.abrupt("return", this._putItemWithIfMatch(key, mutatorFunction, ttl));
              case 23:
                throw _context7.t0;
              case 24:
                _context7.next = 27;
                break;
              case 26:
                return _context7.abrupt("return", currentItem);
              case 27:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[6, 15]]);
      }));
      function _putItemWithIfMatch(_x15, _x16, _x17) {
        return _putItemWithIfMatch2.apply(this, arguments);
      }
      return _putItemWithIfMatch;
    }()
  }, {
    key: "_putItemToServer",
    value: function() {
      var _putItemToServer2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee8(key, data2, ifMatch, ttl) {
        var url, requestBody, response, mapItemDescriptor, added;
        return _regeneratorRuntime__default["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                url = new UriBuilder(this.links.items).pathSegment(key).build();
                requestBody = {
                  data: data2
                };
                if (ttl !== void 0) {
                  requestBody.ttl = ttl;
                }
                _context8.prev = 3;
                _context8.next = 6;
                return this.services.network.put(url, requestBody, ifMatch);
              case 6:
                response = _context8.sent;
                mapItemDescriptor = response.body;
                mapItemDescriptor.data = data2;
                mapItemDescriptor.date_updated = new Date(mapItemDescriptor.date_updated);
                added = response.status.code === 201;
                return _context8.abrupt("return", {
                  added,
                  item: mapItemDescriptor
                });
              case 14:
                _context8.prev = 14;
                _context8.t0 = _context8["catch"](3);
                if (_context8.t0.status === 404) {
                  this.onRemoved(false);
                }
                throw _context8.t0;
              case 18:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[3, 14]]);
      }));
      function _putItemToServer(_x18, _x19, _x20, _x21) {
        return _putItemToServer2.apply(this, arguments);
      }
      return _putItemToServer;
    }()
  }, {
    key: "remove",
    value: function() {
      var _remove = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee9(key) {
        var item, previousItemData, response;
        return _regeneratorRuntime__default["default"].wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.get(key);
              case 2:
                item = _context9.sent;
                previousItemData = deepClone(item.data);
                _context9.next = 6;
                return this.services.network.delete(item.uri);
              case 6:
                response = _context9.sent;
                this._handleItemRemoved(key, response.body.last_event_id, previousItemData, new Date(response.body.date_updated), false);
              case 8:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
      function remove(_x22) {
        return _remove.apply(this, arguments);
      }
      return remove;
    }()
    /**
     * @private
     */
  }, {
    key: "queryItems",
    value: function() {
      var _queryItems2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee10(args) {
        var _this4 = this;
        var uri, response, items, meta2;
        return _regeneratorRuntime__default["default"].wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                args = args || {};
                uri = new UriBuilder(this.links.items).queryParam("From", args.from).queryParam("PageSize", args.limit).queryParam("Key", args.key).queryParam("PageToken", args.pageToken).queryParam("Order", args.order).build();
                _context10.next = 4;
                return this.services.network.get(uri);
              case 4:
                response = _context10.sent;
                items = response.body.items.map(function(el) {
                  el.date_updated = new Date(el.date_updated);
                  var itemInCache = _this4.cache.get(el.key);
                  if (itemInCache) {
                    _this4._handleItemMutated(el.key, el.url, el.last_event_id, el.revision, el.data, el.date_updated, el.date_expires, false, true);
                  } else {
                    _this4.cache.store(el.key, new SyncMapItem(el), el.last_event_id);
                  }
                  return _this4.cache.get(el.key);
                });
                meta2 = response.body.meta;
                return _context10.abrupt("return", new Paginator(items, function(pageToken) {
                  return _this4.queryItems({
                    pageToken
                  });
                }, meta2.previous_token, meta2.next_token));
              case 8:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
      function queryItems2(_x23) {
        return _queryItems2.apply(this, arguments);
      }
      return queryItems2;
    }()
  }, {
    key: "getItems",
    value: function() {
      var _getItems = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee11(args) {
        return _regeneratorRuntime__default["default"].wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                args = args || {};
                validatePageSize(args.pageSize);
                args.limit = args.pageSize || args.limit || 50;
                args.order = args.order || "asc";
                return _context11.abrupt("return", this.queryItems(args));
              case 5:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));
      function getItems(_x24) {
        return _getItems.apply(this, arguments);
      }
      return getItems;
    }()
  }, {
    key: "shouldIgnoreEvent",
    value: function shouldIgnoreEvent(key, eventId) {
      return this.cache.isKnown(key, eventId);
    }
    /**
     * Handle update from the server
     * @private
     */
  }, {
    key: "_update",
    value: function _update(update, isStrictlyOrdered) {
      update.date_created = new Date(update.date_created);
      switch (update.type) {
        case "map_item_added":
        case "map_item_updated":
          {
            this._handleItemMutated(
              update.item_key,
              update.item_url,
              update.id,
              update.item_revision,
              update.item_data,
              update.date_created,
              void 0,
              // orchestration events do not include date_expires
              update.type === "map_item_added",
              true
            );
          }
          break;
        case "map_item_removed":
          {
            this._handleItemRemoved(update.item_key, update.id, update.item_data, update.date_created, true);
          }
          break;
        case "map_removed":
          {
            this.onRemoved(false);
          }
          break;
      }
      if (isStrictlyOrdered) {
        this._advanceLastEventId(update.id, update.map_revision);
      }
    }
  }, {
    key: "_advanceLastEventId",
    value: function _advanceLastEventId(eventId, revision) {
      if (this.lastEventId < eventId) {
        this.descriptor.last_event_id = eventId;
        if (revision) {
          this.descriptor.revision = revision;
        }
      }
    }
  }, {
    key: "_updateRootDateUpdated",
    value: function _updateRootDateUpdated(dateUpdated) {
      if (!this.descriptor.date_updated || dateUpdated.getTime() > this.descriptor.date_updated.getTime()) {
        this.descriptor.date_updated = dateUpdated;
        this.services.storage.update(this.type, this.sid, this.uniqueName, {
          date_updated: dateUpdated
        });
      }
    }
  }, {
    key: "_handleItemMutated",
    value: function _handleItemMutated(key, url, lastEventId, revision, data2, dateUpdated, dateExpires, added, remote) {
      if (this.shouldIgnoreEvent(key, lastEventId)) {
        log$1$1.trace("SyncMapItem ", key, " update skipped, current:", this.lastEventId, ", remote:", lastEventId);
        return;
      }
      this._updateRootDateUpdated(dateUpdated);
      var item = this.cache.get(key);
      if (!item) {
        var newItem = new SyncMapItem({
          key,
          url,
          last_event_id: lastEventId,
          revision,
          data: data2,
          date_updated: dateUpdated,
          date_expires: dateExpires
        });
        this.cache.store(key, newItem, lastEventId);
        this.emitItemMutationEvent(newItem, remote, added);
        return;
      }
      var previousItemData = deepClone(item.data);
      item.update(lastEventId, revision, data2, dateUpdated);
      this.cache.store(key, item, lastEventId);
      if (dateExpires !== void 0) {
        item.updateDateExpires(dateExpires);
      }
      this.emitItemMutationEvent(item, remote, false, previousItemData);
    }
  }, {
    key: "emitItemMutationEvent",
    value: function emitItemMutationEvent(item, remote, added) {
      var previousItemData = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
      var eventName = added ? "itemAdded" : "itemUpdated";
      var args = {
        item,
        isLocal: !remote
      };
      if (!added) {
        args.previousItemData = previousItemData;
      }
      this.broadcastEventToListeners(eventName, args);
    }
    /**
     * @private
     */
  }, {
    key: "_handleItemRemoved",
    value: function _handleItemRemoved(key, eventId, oldData, dateUpdated, remote) {
      this._updateRootDateUpdated(dateUpdated);
      this.cache.delete(key, eventId);
      this.broadcastEventToListeners("itemRemoved", {
        key,
        isLocal: !remote,
        previousItemData: oldData
      });
    }
  }, {
    key: "onRemoved",
    value: function onRemoved(locally) {
      this._unsubscribe();
      this.removalHandler(this.type, this.sid, this.uniqueName);
      this.broadcastEventToListeners("removed", {
        isLocal: locally
      });
    }
  }, {
    key: "setTtl",
    value: function() {
      var _setTtl = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee12(ttl) {
        var requestBody, response;
        return _regeneratorRuntime__default["default"].wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;
                requestBody = {
                  ttl
                };
                _context12.next = 4;
                return this.services.network.post(this.uri, requestBody);
              case 4:
                response = _context12.sent;
                this.descriptor.date_expires = response.body.date_expires;
                _context12.next = 12;
                break;
              case 8:
                _context12.prev = 8;
                _context12.t0 = _context12["catch"](0);
                if (_context12.t0.status === 404) {
                  this.onRemoved(false);
                }
                throw _context12.t0;
              case 12:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this, [[0, 8]]);
      }));
      function setTtl(_x25) {
        return _setTtl.apply(this, arguments);
      }
      return setTtl;
    }()
  }, {
    key: "setItemTtl",
    value: function() {
      var _setItemTtl = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee13(key, ttl) {
        var existingItem, requestBody, response;
        return _regeneratorRuntime__default["default"].wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return this.get(key);
              case 2:
                existingItem = _context13.sent;
                requestBody = {
                  ttl
                };
                _context13.next = 6;
                return this.services.network.post(existingItem.uri, requestBody);
              case 6:
                response = _context13.sent;
                existingItem.updateDateExpires(response.body.date_expires);
              case 8:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));
      function setItemTtl(_x26, _x27) {
        return _setItemTtl.apply(this, arguments);
      }
      return setItemTtl;
    }()
  }, {
    key: "removeMap",
    value: function() {
      var _removeMap = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee14() {
        return _regeneratorRuntime__default["default"].wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return this.services.network.delete(this.uri);
              case 2:
                this.onRemoved(true);
              case 3:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));
      function removeMap() {
        return _removeMap.apply(this, arguments);
      }
      return removeMap;
    }()
  }], [{
    key: "type",
    get: function get3() {
      return "map";
    }
  }]);
  return SyncMapImpl2;
}(SyncEntity);
var SyncMap = /* @__PURE__ */ function(_Closeable) {
  _inherits__default["default"](SyncMap2, _Closeable);
  var _super2 = _createSuper$3(SyncMap2);
  function SyncMap2(syncMapImpl) {
    var _this5;
    _classCallCheck__default["default"](this, SyncMap2);
    _this5 = _super2.call(this);
    _this5.syncMapImpl = syncMapImpl;
    _this5.syncMapImpl.attach(_assertThisInitialized__default["default"](_this5));
    return _this5;
  }
  _createClass__default["default"](SyncMap2, [{
    key: "uri",
    get: (
      // private props
      function get3() {
        return this.syncMapImpl.uri;
      }
    )
  }, {
    key: "links",
    get: function get3() {
      return this.syncMapImpl.links;
    }
  }, {
    key: "revision",
    get: function get3() {
      return this.syncMapImpl.revision;
    }
  }, {
    key: "lastEventId",
    get: function get3() {
      return this.syncMapImpl.lastEventId;
    }
  }, {
    key: "dateExpires",
    get: function get3() {
      return this.syncMapImpl.dateExpires;
    }
  }, {
    key: "type",
    get: function get3() {
      return SyncMapImpl.type;
    }
    /**
     * An immutable identifier (a SID) assigned by the system on creation.
     */
  }, {
    key: "sid",
    get: function get3() {
      return this.syncMapImpl.sid;
    }
    /**
     * An optional immutable identifier that may be assigned by the
     * programmer to this map on creation. Unique among other Maps.
     */
  }, {
    key: "uniqueName",
    get: function get3() {
      return this.syncMapImpl.uniqueName;
    }
    /**
     * Date when the map was last updated.
     */
  }, {
    key: "dateUpdated",
    get: function get3() {
      return this.syncMapImpl.dateUpdated;
    }
  }, {
    key: "set",
    value: (
      /**
       * Add a new item to the map with the given key-value pair. Overwrites any data that might already exist with that key.
       * @param key Unique item identifier.
       * @param data Data to be set.
       * @param itemMetadataUpdates New item metadata.
       * @return Newly added item, or modified one if already exists, with the latest known data.
       * @example
       * ```typescript
       * map.set('myKey', { name: 'John Smith' }, { ttl: 86400 })
       *   .then((item) => {
       *     console.log('Map SyncMapItem set() successful, item data:', item.data);
       *   })
       *   .catch((error) => {
       *     console.error('Map SyncMapItem set() failed', error);
       *   });
       * ```
       */
      function() {
        var _set2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee15(key, data2, itemMetadataUpdates) {
          return _regeneratorRuntime__default["default"].wrap(function _callee15$(_context15) {
            while (1) {
              switch (_context15.prev = _context15.next) {
                case 0:
                  this.ensureNotClosed();
                  return _context15.abrupt("return", this.syncMapImpl.set(key, data2, itemMetadataUpdates));
                case 2:
                case "end":
                  return _context15.stop();
              }
            }
          }, _callee15, this);
        }));
        function set4(_x28, _x29, _x30) {
          return _set2.apply(this, arguments);
        }
        return set4;
      }()
    )
    /**
     * Retrieve an item by key.
     * @param key Identifies the desired item.
     * @return A promise that resolves when the item has been fetched.
     * This promise will be rejected if item was not found.
     * @example
     * ```typescript
     * map.get('myKey')
     *   .then((item) => {
     *     console.log('Map SyncMapItem get() successful, item data:', item.data)
     *   })
     *   .catch((error) => {
     *     console.error('Map SyncMapItem get() failed', error);
     *   });
     * ```
     */
  }, {
    key: "get",
    value: function() {
      var _get3 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee16(key) {
        return _regeneratorRuntime__default["default"].wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                this.ensureNotClosed();
                return _context16.abrupt("return", this.syncMapImpl.get(key));
              case 2:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));
      function get3(_x31) {
        return _get3.apply(this, arguments);
      }
      return get3;
    }()
    /**
     * Schedules a modification to this Map SyncMapItem that will apply a mutation function.
     * If no SyncMapItem with the given key exists, it will first be created, having the default data (`{}`).
     * @param key Selects the map item to be mutated.
     * @param mutator A function that outputs a new data based on the existing data.
     * May be called multiple times, particularly if this Map SyncMapItem is modified concurrently by remote code.
     * If the mutation ultimately succeeds, the Map SyncMapItem will have made the particular transition described
     * by this function.
     * @param itemMetadataUpdates New item metadata.
     * @return Resolves with the most recent item state, the output of a successful
     * mutation or a state that prompted graceful cancellation (mutator returned `null`).
     * @example
     * ```typescript
     * const mutatorFunction = (currentData) => {
     *     currentData.viewCount = (currentData.viewCount || 0) + 1;
     *     return currentData;
     * };
     * map.mutate('myKey', mutatorFunction, { ttl: 86400 })
     *   .then((item) => {
     *     console.log('Map SyncMapItem mutate() successful, new data:', item.data)
     *   })
     *   .catch((error) => {
     *     console.error('Map SyncMapItem mutate() failed', error);
     *   });
     * ```
     */
  }, {
    key: "mutate",
    value: function() {
      var _mutate2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee17(key, mutator, itemMetadataUpdates) {
        return _regeneratorRuntime__default["default"].wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                this.ensureNotClosed();
                return _context17.abrupt("return", this.syncMapImpl.mutate(key, mutator, itemMetadataUpdates));
              case 2:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));
      function mutate(_x32, _x33, _x34) {
        return _mutate2.apply(this, arguments);
      }
      return mutate;
    }()
    /**
     * Modify a map item by appending new fields (or by overwriting existing ones) with the values from
     * the provided Object. Creates a new item if no item by this key exists, copying all given fields and values
     * into it.
     * This is equivalent to
     * ```typescript
     * map.mutate('myKey', (currentData) => Object.assign(currentData, obj));
     * ```
     * @param key Selects the map item to update.
     * @param obj Specifies the particular (top-level) attributes that will receive new values.
     * @param itemMetadataUpdates New item metadata.
     * @return A promise resolving to the modified item in its new state.
     * @example
     * ```typescript
     * // Say, the Map SyncMapItem (key: `'myKey'`) data is `{ name: 'John Smith' }`
     * map.update('myKey', { age: 34 }, { ttl: 86400 })
     *   .then((item) => {
     *     // Now the Map SyncMapItem data is `{ name: 'John Smith', age: 34 }`
     *     console.log('Map SyncMapItem update() successful, new data:', item.data);
     *   })
     *   .catch((error) => {
     *     console.error('Map SyncMapItem update() failed', error);
     *   });
     * ```
     */
  }, {
    key: "update",
    value: function() {
      var _update3 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee18(key, obj, itemMetadataUpdates) {
        return _regeneratorRuntime__default["default"].wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                this.ensureNotClosed();
                return _context18.abrupt("return", this.syncMapImpl.update(key, obj, itemMetadataUpdates));
              case 2:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));
      function update(_x35, _x36, _x37) {
        return _update3.apply(this, arguments);
      }
      return update;
    }()
    /**
     * Delete an item, given its key.
     * @param key Selects the item to delete.
     * @return A promise to remove an item.
     * The promise will be rejected if 'key' is undefined or an item was not found.
     * @example
     * ```typescript
     * map.remove('myKey')
     *   .then(() => {
     *     console.log('Map SyncMapItem remove() successful');
     *   })
     *   .catch((error) => {
     *     console.error('Map SyncMapItem remove() failed', error);
     *   });
     * ```
     */
  }, {
    key: "remove",
    value: function() {
      var _remove2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee19(key) {
        return _regeneratorRuntime__default["default"].wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                this.ensureNotClosed();
                return _context19.abrupt("return", this.syncMapImpl.remove(key));
              case 2:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));
      function remove(_x38) {
        return _remove2.apply(this, arguments);
      }
      return remove;
    }()
    /**
     * Get a complete list of items from the map.
     * Information about the query limits can be found [here](https://www.twilio.com/docs/sync/limits).
     * @param queryOptions Query options.
     * @example
     * ```typescript
     * const pageHandler = (paginator) => {
     *   paginator.items.forEach((item) => {
     *     console.log(`SyncMapItem ${item.key}: `, item.data);
     *   });
     *   return paginator.hasNextPage
     *     ? paginator.nextPage().then(pageHandler)
     *     : null;
     * };
     * map.getItems({ from: 'myKey', order: 'asc' })
     *   .then(pageHandler)
     *   .catch((error) => {
     *     console.error('Map getItems() failed', error);
     *   });
     * ```
     */
  }, {
    key: "getItems",
    value: function() {
      var _getItems2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee20(queryOptions) {
        return _regeneratorRuntime__default["default"].wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                this.ensureNotClosed();
                return _context20.abrupt("return", this.syncMapImpl.getItems(queryOptions));
              case 2:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));
      function getItems(_x39) {
        return _getItems2.apply(this, arguments);
      }
      return getItems;
    }()
    /**
     * Update the time-to-live of the map.
     * @param ttl Specifies the TTL in seconds after which the map is subject to automatic deletion. The value 0 means infinity.
     * @return A promise that resolves after the TTL update was successful.
     * @example
     * ```typescript
     * map.setTtl(3600)
     *   .then(() => {
     *     console.log('Map setTtl() successful');
     *   })
     *   .catch((error) => {
     *     console.error('Map setTtl() failed', error);
     *   });
     * ```
     */
  }, {
    key: "setTtl",
    value: function() {
      var _setTtl2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee21(ttl) {
        return _regeneratorRuntime__default["default"].wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                this.ensureNotClosed();
                return _context21.abrupt("return", this.syncMapImpl.setTtl(ttl));
              case 2:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));
      function setTtl(_x40) {
        return _setTtl2.apply(this, arguments);
      }
      return setTtl;
    }()
    /**
     * Update the time-to-live of a map item.
     * @param key SyncMapItem key.
     * @param ttl Specifies the TTL in seconds after which the map item is subject to automatic deletion. The value 0 means infinity.
     * @return A promise that resolves after the TTL update was successful.
     * @example
     * ```typescript
     * map.setItemTtl('myKey', 86400)
     *   .then(() => {
     *     console.log('Map setItemTtl() successful');
     *   })
     *   .catch((error) => {
     *     console.error('Map setItemTtl() failed', error);
     *   });
     * ```
     */
  }, {
    key: "setItemTtl",
    value: function() {
      var _setItemTtl2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee22(key, ttl) {
        return _regeneratorRuntime__default["default"].wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                this.ensureNotClosed();
                return _context22.abrupt("return", this.syncMapImpl.setItemTtl(key, ttl));
              case 2:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));
      function setItemTtl(_x41, _x42) {
        return _setItemTtl2.apply(this, arguments);
      }
      return setItemTtl;
    }()
    /**
     * Delete this map. It will be impossible to restore it.
     * @return A promise that resolves when the map has been deleted.
     * @example
     * ```typescript
     * map.removeMap()
     *   .then(() => {
     *     console.log('Map removeMap() successful');
     *   })
     *   .catch((error) => {
     *     console.error('Map removeMap() failed', error);
     *   });
     * ```
     */
  }, {
    key: "removeMap",
    value: function() {
      var _removeMap2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee23() {
        return _regeneratorRuntime__default["default"].wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                this.ensureNotClosed();
                _context23.next = 3;
                return this.syncMapImpl.removeMap();
              case 3:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));
      function removeMap() {
        return _removeMap2.apply(this, arguments);
      }
      return removeMap;
    }()
    /**
     * Conclude work with the map instance and remove all event listeners attached to it.
     * Any subsequent operation on this object will be rejected with error.
     * Other local copies of this map will continue operating and receiving events normally.
     * @example
     * ```typescript
     * map.close();
     * ````
     */
  }, {
    key: "close",
    value: function close() {
      _get__default["default"](_getPrototypeOf__default["default"](SyncMap2.prototype), "close", this).call(this);
      this.syncMapImpl.detach(this.listenerUuid);
    }
  }], [{
    key: "type",
    get: function get3() {
      return SyncMapImpl.type;
    }
  }]);
  return SyncMap2;
}(Closeable);
_defineProperty__default["default"](SyncMap, "itemAdded", "itemAdded");
_defineProperty__default["default"](SyncMap, "itemUpdated", "itemUpdated");
_defineProperty__default["default"](SyncMap, "itemRemoved", "itemRemoved");
_defineProperty__default["default"](SyncMap, "removed", "removed");
__decorate([declarativeTypeValidator.validateTypesAsync("string", declarativeTypeValidator.pureObject, ["undefined", declarativeTypeValidator.objectSchema("item metadata", {
  ttl: [declarativeTypeValidator.nonNegativeInteger, "undefined"]
})]), __metadata("design:type", Function), __metadata("design:paramtypes", [String, Object, Object]), __metadata("design:returntype", Promise)], SyncMap.prototype, "set", null);
__decorate([declarativeTypeValidator.validateTypesAsync("string"), __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", Promise)], SyncMap.prototype, "get", null);
__decorate([declarativeTypeValidator.validateTypesAsync("string", "function", ["undefined", declarativeTypeValidator.objectSchema("item metadata", {
  ttl: [declarativeTypeValidator.nonNegativeInteger, "undefined"]
})]), __metadata("design:type", Function), __metadata("design:paramtypes", [String, Function, Object]), __metadata("design:returntype", Promise)], SyncMap.prototype, "mutate", null);
__decorate([declarativeTypeValidator.validateTypesAsync("string", declarativeTypeValidator.pureObject, ["undefined", declarativeTypeValidator.objectSchema("item metadata", {
  ttl: [declarativeTypeValidator.nonNegativeInteger, "undefined"]
})]), __metadata("design:type", Function), __metadata("design:paramtypes", [String, Object, Object]), __metadata("design:returntype", Promise)], SyncMap.prototype, "update", null);
__decorate([declarativeTypeValidator.validateTypesAsync("string"), __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", Promise)], SyncMap.prototype, "remove", null);
__decorate([declarativeTypeValidator.validateTypesAsync(["undefined", declarativeTypeValidator.objectSchema("query options", {
  from: ["string", "undefined"],
  pageSize: [declarativeTypeValidator.custom(function(value) {
    return [isPositiveInteger(value), "a positive integer"];
  }), "undefined"]
})]), __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", Promise)], SyncMap.prototype, "getItems", null);
__decorate([declarativeTypeValidator.validateTypesAsync(declarativeTypeValidator.nonNegativeInteger), __metadata("design:type", Function), __metadata("design:paramtypes", [Number]), __metadata("design:returntype", Promise)], SyncMap.prototype, "setTtl", null);
__decorate([declarativeTypeValidator.validateTypesAsync("string", declarativeTypeValidator.nonNegativeInteger), __metadata("design:type", Function), __metadata("design:paramtypes", [String, Number]), __metadata("design:returntype", Promise)], SyncMap.prototype, "setItemTtl", null);
function _createSuper$2(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$2();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf__default["default"](Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf__default["default"](this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn__default["default"](this, result);
  };
}
function _isNativeReflectConstruct$2() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var SyncStreamImpl = /* @__PURE__ */ function(_SyncEntity) {
  _inherits__default["default"](SyncStreamImpl2, _SyncEntity);
  var _super = _createSuper$2(SyncStreamImpl2);
  function SyncStreamImpl2(services, descriptor, removalHandler) {
    var _this;
    _classCallCheck__default["default"](this, SyncStreamImpl2);
    _this = _super.call(this, services, removalHandler);
    _this.descriptor = descriptor;
    return _this;
  }
  _createClass__default["default"](SyncStreamImpl2, [{
    key: "uri",
    get: function get3() {
      return this.descriptor.url;
    }
  }, {
    key: "links",
    get: function get3() {
      return this.descriptor.links;
    }
  }, {
    key: "dateExpires",
    get: function get3() {
      return this.descriptor.date_expires;
    }
  }, {
    key: "type",
    get: function get3() {
      return "stream";
    }
  }, {
    key: "lastEventId",
    get: function get3() {
      return null;
    }
    // below properties are specific to Insights only
  }, {
    key: "indexName",
    get: function get3() {
      return void 0;
    }
  }, {
    key: "queryString",
    get: function get3() {
      return void 0;
    }
    // public props, documented along with class description
  }, {
    key: "sid",
    get: function get3() {
      return this.descriptor.sid;
    }
  }, {
    key: "uniqueName",
    get: function get3() {
      return this.descriptor.unique_name || null;
    }
  }, {
    key: "publishMessage",
    value: function() {
      var _publishMessage = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee(data2) {
        var requestBody, response, responseBody, event;
        return _regeneratorRuntime__default["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                requestBody = {
                  data: data2
                };
                _context.next = 3;
                return this.services.network.post(this.links.messages, requestBody);
              case 3:
                response = _context.sent;
                responseBody = response.body;
                event = this._handleMessagePublished(responseBody.sid, data2, false);
                return _context.abrupt("return", event);
              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function publishMessage(_x) {
        return _publishMessage.apply(this, arguments);
      }
      return publishMessage;
    }()
  }, {
    key: "setTtl",
    value: function() {
      var _setTtl = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee2(ttl) {
        var requestBody, response;
        return _regeneratorRuntime__default["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                requestBody = {
                  ttl
                };
                _context2.next = 4;
                return this.services.network.post(this.uri, requestBody);
              case 4:
                response = _context2.sent;
                this.descriptor.date_expires = response.body.date_expires;
                _context2.next = 12;
                break;
              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);
                if (_context2.t0.status === 404) {
                  this.onRemoved(false);
                }
                throw _context2.t0;
              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 8]]);
      }));
      function setTtl(_x2) {
        return _setTtl.apply(this, arguments);
      }
      return setTtl;
    }()
  }, {
    key: "removeStream",
    value: function() {
      var _removeStream = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee3() {
        return _regeneratorRuntime__default["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.services.network.delete(this.uri);
              case 2:
                this.onRemoved(true);
              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function removeStream() {
        return _removeStream.apply(this, arguments);
      }
      return removeStream;
    }()
    /**
     * Handle event from the server
     * @private
     */
  }, {
    key: "_update",
    value: function _update(update) {
      switch (update.type) {
        case "stream_message_published": {
          this._handleMessagePublished(update.message_sid, update.message_data, true);
          break;
        }
        case "stream_removed": {
          this.onRemoved(false);
          break;
        }
      }
    }
  }, {
    key: "_handleMessagePublished",
    value: function _handleMessagePublished(sid, data2, remote) {
      var event = {
        sid,
        data: data2
      };
      this.broadcastEventToListeners("messagePublished", {
        message: event,
        isLocal: !remote
      });
      return event;
    }
  }, {
    key: "onRemoved",
    value: function onRemoved(isLocal) {
      this._unsubscribe();
      this.removalHandler(this.type, this.sid, this.uniqueName);
      this.broadcastEventToListeners("removed", {
        isLocal
      });
    }
  }], [{
    key: "type",
    get: function get3() {
      return "stream";
    }
  }]);
  return SyncStreamImpl2;
}(SyncEntity);
__decorate([declarativeTypeValidator.validateTypesAsync(declarativeTypeValidator.pureObject), __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", Promise)], SyncStreamImpl.prototype, "publishMessage", null);
__decorate([declarativeTypeValidator.validateTypesAsync(declarativeTypeValidator.nonNegativeInteger), __metadata("design:type", Function), __metadata("design:paramtypes", [Number]), __metadata("design:returntype", Promise)], SyncStreamImpl.prototype, "setTtl", null);
var SyncStream = /* @__PURE__ */ function(_Closeable) {
  _inherits__default["default"](SyncStream2, _Closeable);
  var _super2 = _createSuper$2(SyncStream2);
  function SyncStream2(syncStreamImpl) {
    var _this2;
    _classCallCheck__default["default"](this, SyncStream2);
    _this2 = _super2.call(this);
    _this2.syncStreamImpl = syncStreamImpl;
    _this2.syncStreamImpl.attach(_assertThisInitialized__default["default"](_this2));
    return _this2;
  }
  _createClass__default["default"](SyncStream2, [{
    key: "uri",
    get: (
      // private props
      function get3() {
        return this.syncStreamImpl.uri;
      }
    )
  }, {
    key: "links",
    get: function get3() {
      return this.syncStreamImpl.links;
    }
  }, {
    key: "dateExpires",
    get: function get3() {
      return this.syncStreamImpl.dateExpires;
    }
  }, {
    key: "type",
    get: function get3() {
      return SyncStreamImpl.type;
    }
  }, {
    key: "lastEventId",
    get: function get3() {
      return null;
    }
    /**
     * The immutable system-assigned identifier of this stream. Never null.
     */
  }, {
    key: "sid",
    get: function get3() {
      return this.syncStreamImpl.sid;
    }
    /**
     * A unique identifier optionally assigned to the stream on creation.
     */
  }, {
    key: "uniqueName",
    get: function get3() {
      return this.syncStreamImpl.uniqueName;
    }
  }, {
    key: "publishMessage",
    value: (
      /**
       * Publish a message to the stream. The system will attempt delivery to all online subscribers.
       * @param data The body of the dispatched message. Maximum size in serialized JSON: 4KB.
       * A rate limit applies to this operation, refer to the [Sync API documentation](https://www.twilio.com/docs/api/sync) for details.
       * @return A promise which resolves after the message is successfully published
       * to the Sync service. Resolves irrespective of ultimate delivery to any subscribers.
       * @example
       * ```typescript
       * stream.publishMessage({ x: 42, y: 123 })
       *   .then((message) => {
       *     console.log('Stream publishMessage() successful, message SID:', message.sid);
       *   })
       *   .catch((error) => {
       *     console.error('Stream publishMessage() failed', error);
       *   });
       * ```
       */
      function() {
        var _publishMessage2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee4(data2) {
          return _regeneratorRuntime__default["default"].wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  this.ensureNotClosed();
                  return _context4.abrupt("return", this.syncStreamImpl.publishMessage(data2));
                case 2:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));
        function publishMessage(_x3) {
          return _publishMessage2.apply(this, arguments);
        }
        return publishMessage;
      }()
    )
    /**
     * Update the time-to-live of the stream.
     * @param ttl Specifies the TTL in seconds after which the stream is subject to automatic deletion. The value 0 means infinity.
     * @return A promise that resolves after the TTL update was successful.
     * @example
     * ```typescript
     * stream.setTtl(3600)
     *   .then(() => {
     *     console.log('Stream setTtl() successful');
     *   })
     *   .catch((error) => {
     *     console.error('Stream setTtl() failed', error);
     *   });
     * ```
     */
  }, {
    key: "setTtl",
    value: function() {
      var _setTtl2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee5(ttl) {
        return _regeneratorRuntime__default["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this.ensureNotClosed();
                return _context5.abrupt("return", this.syncStreamImpl.setTtl(ttl));
              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
      function setTtl(_x4) {
        return _setTtl2.apply(this, arguments);
      }
      return setTtl;
    }()
    /**
     * Permanently delete this Stream.
     * @return A promise which resolves after the Stream is successfully deleted.
     * @example
     * ```typescript
     * stream.removeStream()
     *   .then(() => {
     *     console.log('Stream removeStream() successful');
     *   })
     *   .catch((error) => {
     *     console.error('Stream removeStream() failed', error);
     *   });
     * ```
     */
  }, {
    key: "removeStream",
    value: function() {
      var _removeStream2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee6() {
        return _regeneratorRuntime__default["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.ensureNotClosed();
                return _context6.abrupt("return", this.syncStreamImpl.removeStream());
              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
      function removeStream() {
        return _removeStream2.apply(this, arguments);
      }
      return removeStream;
    }()
    /**
     * Conclude work with the stream instance and remove all event listeners attached to it.
     * Any subsequent operation on this object will be rejected with error.
     * Other local copies of this stream will continue operating and receiving events normally.
     * @example
     * ```typescript
     * stream.close();
     * ```
     */
  }, {
    key: "close",
    value: function close() {
      _get__default["default"](_getPrototypeOf__default["default"](SyncStream2.prototype), "close", this).call(this);
      this.syncStreamImpl.detach(this.listenerUuid);
    }
  }], [{
    key: "type",
    get: function get3() {
      return SyncStreamImpl.type;
    }
  }]);
  return SyncStream2;
}(Closeable);
_defineProperty__default["default"](SyncStream, "messagePublished", "messagePublished");
_defineProperty__default["default"](SyncStream, "removed", "removed");
__decorate([declarativeTypeValidator.validateTypesAsync(declarativeTypeValidator.pureObject), __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", Promise)], SyncStream.prototype, "publishMessage", null);
__decorate([declarativeTypeValidator.validateTypesAsync(declarativeTypeValidator.nonNegativeInteger), __metadata("design:type", Function), __metadata("design:paramtypes", [Number]), __metadata("design:returntype", Promise)], SyncStream.prototype, "setTtl", null);
var ClientInfo = function ClientInfo2(version2) {
  _classCallCheck__default["default"](this, ClientInfo2);
  this.sdk = "js";
  this.sdkVer = version2;
  this.os = platform__namespace.os.family;
  this.osVer = platform__namespace.os.version;
  this.pl = platform__namespace.name;
  this.plVer = platform__namespace.version;
};
var EntitiesCache = /* @__PURE__ */ function() {
  function EntitiesCache2() {
    _classCallCheck__default["default"](this, EntitiesCache2);
    this.names = /* @__PURE__ */ new Map();
    this.entities = /* @__PURE__ */ new Map();
  }
  _createClass__default["default"](EntitiesCache2, [{
    key: "store",
    value: function store(entity) {
      var stored = this.entities.get(entity.sid);
      if (stored) {
        return stored;
      }
      this.entities.set(entity.sid, entity);
      if (entity.uniqueName) {
        this.names.set(entity.type + "::" + entity.uniqueName, entity.sid);
      }
      return entity;
    }
  }, {
    key: "getResolved",
    value: function getResolved(id2, type5) {
      var resolvedSid = this.names.get(type5 + "::" + id2);
      return resolvedSid ? this.entities.get(resolvedSid) : null;
    }
  }, {
    key: "get",
    value: function get3(id2, type5) {
      return this.entities.get(id2) || this.getResolved(id2, type5) || null;
    }
  }, {
    key: "remove",
    value: function remove(sid) {
      var cached = this.entities.get(sid);
      if (cached) {
        this.entities.delete(sid);
        if (cached.uniqueName) {
          this.names.delete(cached.type + "::" + cached.uniqueName);
        }
      }
    }
  }]);
  return EntitiesCache2;
}();
function _createSuper$1(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf__default["default"](Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf__default["default"](this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn__default["default"](this, result);
  };
}
function _isNativeReflectConstruct$1() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var InsightsItem = (
  /**
   * @internal
   */
  function InsightsItem2() {
    _classCallCheck__default["default"](this, InsightsItem2);
  }
);
var LiveQueryImpl = /* @__PURE__ */ function(_SyncEntity) {
  _inherits__default["default"](LiveQueryImpl2, _SyncEntity);
  var _super = _createSuper$1(LiveQueryImpl2);
  function LiveQueryImpl2(descriptor, services, removalHandler, items) {
    var _this;
    _classCallCheck__default["default"](this, LiveQueryImpl2);
    _this = _super.call(this, services, removalHandler);
    _this.descriptor = descriptor;
    _this.cache = new Cache();
    if (items) {
      items.forEach(function(item) {
        _this.cache.store(item.key, {
          key: item.key,
          value: item.data
        }, item.revision);
      });
    }
    return _this;
  }
  _createClass__default["default"](LiveQueryImpl2, [{
    key: "sid",
    get: function get3() {
      return this.descriptor.sid;
    }
    // private extension of SyncEntity
  }, {
    key: "uniqueName",
    get: function get3() {
      return null;
    }
  }, {
    key: "type",
    get: function get3() {
      return LiveQueryImpl2.type;
    }
  }, {
    key: "lastEventId",
    get: function get3() {
      return this.descriptor.last_event_id;
    }
  }, {
    key: "indexName",
    get: function get3() {
      return this.descriptor.indexName;
    }
  }, {
    key: "queryString",
    get: function get3() {
      return this.descriptor.queryExpression;
    }
    // custom private props
  }, {
    key: "queryUri",
    get: function get3() {
      return this.descriptor.queryUri;
    }
  }, {
    key: "liveQueryDescriptor",
    get: function get3() {
      return this.descriptor;
    }
    // dummy stub from iface
  }, {
    key: "onRemoved",
    value: function onRemoved() {
    }
  }, {
    key: "getItems",
    value: function getItems() {
      var dataByKey = {};
      this.cache.forEach(function(key, item) {
        dataByKey[key] = item.value;
      });
      return dataByKey;
    }
    /**
     * @internal
     */
  }, {
    key: "_update",
    value: function _update(message, isStrictlyOrdered) {
      switch (message.type) {
        case "live_query_item_updated":
          this.handleItemMutated(message.item_key, message.item_data, message.item_revision);
          break;
        case "live_query_item_removed":
          this.handleItemRemoved(message.item_key, message.item_revision);
          break;
        case "live_query_updated":
          this.handleBatchUpdate(message.items);
          break;
      }
      if (isStrictlyOrdered) {
        this._advanceLastEventId(message.last_event_id);
      }
    }
  }, {
    key: "handleItemMutated",
    value: function handleItemMutated(key, value, revision) {
      if (this.shouldIgnoreEvent(key, revision)) {
        log$1$1.trace("Item ".concat(key, " update skipped, revision: ").concat(revision));
      } else {
        var newItem = {
          key,
          value
        };
        this.cache.store(key, newItem, revision);
        this.broadcastEventToListeners("itemUpdated", newItem);
      }
    }
  }, {
    key: "handleItemRemoved",
    value: function handleItemRemoved(key, revision) {
      var force = revision === null;
      if (this.shouldIgnoreEvent(key, revision)) {
        log$1$1.trace("Item ".concat(key, " delete skipped, revision: ").concat(revision));
      } else {
        this.cache.delete(key, revision, force);
        this.broadcastEventToListeners("itemRemoved", {
          key
        });
      }
    }
  }, {
    key: "handleBatchUpdate",
    value: function handleBatchUpdate(items) {
      var _this2 = this;
      var newItems = {};
      if (items != null) {
        items.forEach(function(item) {
          newItems[item.key] = {
            data: item.data,
            revision: item.revision
          };
        });
      }
      this.cache.forEach(function(key2, item) {
        var newItem = newItems[key2];
        if (newItem != null) {
          _this2.handleItemMutated(key2, newItem.data, newItem.revision);
        } else {
          _this2.handleItemRemoved(key2, null);
        }
        delete newItems[key2];
      });
      for (var key in newItems) {
        this.handleItemMutated(key, newItems[key].data, newItems[key].revision);
      }
    }
  }, {
    key: "shouldIgnoreEvent",
    value: function shouldIgnoreEvent(key, eventId) {
      return key != null && eventId != null && this.cache.isKnown(key, eventId);
    }
    /**
     * @internal
     */
  }, {
    key: "_advanceLastEventId",
    value: function _advanceLastEventId(eventId, revision) {
      if (this.lastEventId < eventId) {
        this.descriptor.last_event_id = eventId;
      }
    }
  }], [{
    key: "type",
    get: function get3() {
      return "live_query";
    }
  }]);
  return LiveQueryImpl2;
}(SyncEntity);
function queryItems(_x) {
  return _queryItems.apply(this, arguments);
}
function _queryItems() {
  _queryItems = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee3(params) {
    var network, queryString, uri, type5, liveQueryRequestBody, response;
    return _regeneratorRuntime__default["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            network = params.network, queryString = params.queryString, uri = params.uri, type5 = params.type;
            if (!(queryString == null)) {
              _context3.next = 3;
              break;
            }
            throw new SyncError("Invalid query", 400, 54507);
          case 3:
            liveQueryRequestBody = {
              query_string: queryString
              // raw query string (like `key == "value" AND key2 != "value2"`)
            };
            if (type5 === LiveQuery.type) {
              liveQueryRequestBody.type = type5;
            }
            _context3.next = 7;
            return network.post(uri, liveQueryRequestBody, void 0, true);
          case 7:
            response = _context3.sent;
            return _context3.abrupt("return", response.body);
          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _queryItems.apply(this, arguments);
}
var LiveQuery = /* @__PURE__ */ function(_Closeable) {
  _inherits__default["default"](LiveQuery2, _Closeable);
  var _super2 = _createSuper$1(LiveQuery2);
  function LiveQuery2(liveQueryImpl) {
    var _this3;
    _classCallCheck__default["default"](this, LiveQuery2);
    _this3 = _super2.call(this);
    _this3.liveQueryImpl = liveQueryImpl;
    _this3.liveQueryImpl.attach(_assertThisInitialized__default["default"](_this3));
    return _this3;
  }
  _createClass__default["default"](LiveQuery2, [{
    key: "type",
    get: function get3() {
      return LiveQueryImpl.type;
    }
  }, {
    key: "lastEventId",
    get: function get3() {
      return this.liveQueryImpl.lastEventId;
    }
    /**
     * The immutable identifier of this query object, assigned by the system.
     */
  }, {
    key: "sid",
    get: function get3() {
      return this.liveQueryImpl.sid;
    }
  }, {
    key: "close",
    value: (
      /**
       * Closes this query instance and unsubscribes from further service events.
       * This will eventually stop the physical inflow of updates over the network, when all other instances of this query are closed as well.
       */
      function close() {
        _get__default["default"](_getPrototypeOf__default["default"](LiveQuery2.prototype), "close", this).call(this);
        this.liveQueryImpl.detach(this.listenerUuid);
      }
    )
    /**
     * @return A snapshot of items matching the current query expression.
     */
  }, {
    key: "getItems",
    value: function getItems() {
      this.ensureNotClosed();
      return this.liveQueryImpl.getItems();
    }
  }], [{
    key: "type",
    get: (
      // private props
      function get3() {
        return LiveQueryImpl.type;
      }
    )
  }]);
  return LiveQuery2;
}(Closeable);
_defineProperty__default["default"](LiveQuery, "itemUpdated", "itemUpdated");
_defineProperty__default["default"](LiveQuery, "itemRemoved", "itemRemoved");
var InstantQuery = /* @__PURE__ */ function(_EventEmitter) {
  _inherits__default["default"](InstantQuery2, _EventEmitter);
  var _super3 = _createSuper$1(InstantQuery2);
  function InstantQuery2(params) {
    var _this4;
    _classCallCheck__default["default"](this, InstantQuery2);
    _this4 = _super3.call(this);
    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this4), "queryExpression", null);
    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this4), "items", {});
    Object.assign(_assertThisInitialized__default["default"](_this4), params);
    _this4.updateIndexName(params.indexName);
    return _this4;
  }
  _createClass__default["default"](InstantQuery2, [{
    key: "type",
    get: function get3() {
      return InstantQuery2.type;
    }
  }, {
    key: "search",
    value: (
      /**
       * Spawns a new search request. The result will be provided asynchronously via the {@link InstantQuery.searchResult}
       * event.
       * @param queryExpression A query expression to be executed against the given data index. For more information
       * on the syntax read {@link SyncClient.liveQuery}.
       * @return A promise that resolves when query result has been received.
       */
      function() {
        var _search = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee(queryExpression) {
          var _this5 = this;
          return _regeneratorRuntime__default["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  this.items = {};
                  return _context.abrupt("return", queryItems({
                    network: this.network,
                    uri: this.queryUri,
                    queryString: queryExpression
                  }).then(function(response) {
                    _this5.queryExpression = queryExpression;
                    if (response.items) {
                      response.items.forEach(function(item) {
                        _this5.items[item.key] = item.data;
                      });
                    }
                    _this5.emit("searchResult", _this5.getItems());
                  }).catch(function(err) {
                    log$1$1.error("Error '".concat(err.message, "' while executing query '").concat(queryExpression, "'"));
                    _this5.queryExpression = null;
                    throw err;
                  }));
                case 2:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));
        function search(_x2) {
          return _search.apply(this, arguments);
        }
        return search;
      }()
    )
    /**
     * Instantiates a LiveQuery object based on the last known query expression that was passed to the
     * {@link InstantQuery.search} method. This LiveQuery will start receiving updates with new results,
     * while current object can be still used to execute repetitive searches.
     * @return A promise which resolves when the LiveQuery object is ready.
     */
  }, {
    key: "subscribe",
    value: function() {
      var _subscribe = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee2() {
        return _regeneratorRuntime__default["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this.queryExpression == null)) {
                  _context2.next = 2;
                  break;
                }
                return _context2.abrupt("return", Promise.reject(new SyncError("Invalid query", 400, 54507)));
              case 2:
                return _context2.abrupt("return", this.liveQueryCreator(this.indexName, this.queryExpression));
              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function subscribe() {
        return _subscribe.apply(this, arguments);
      }
      return subscribe;
    }()
    /**
     * @return A snapshot of items matching current query expression.
     */
  }, {
    key: "getItems",
    value: function getItems() {
      return this.items;
    }
    /**
     * Set new index name
     * @param indexName New index name to set
     */
  }, {
    key: "updateIndexName",
    value: function updateIndexName(indexName) {
      this.indexName = indexName;
      this.queryUri = this.generateQueryUri(this.indexName);
    }
  }, {
    key: "generateQueryUri",
    value: function generateQueryUri(indexName) {
      return new UriBuilder(this.insightsUri).pathSegment(indexName).pathSegment("Items").build();
    }
  }], [{
    key: "type",
    get: (
      // private props
      function get3() {
        return "instant_query";
      }
    )
  }]);
  return InstantQuery2;
}(EventEmitter);
_defineProperty__default["default"](InstantQuery, "searchResult", "searchResult");
__decorate([declarativeTypeValidator.validateTypesAsync("string"), __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", Promise)], InstantQuery.prototype, "search", null);
__decorate([declarativeTypeValidator.validateTypes(declarativeTypeValidator.nonEmptyString), __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", void 0)], InstantQuery.prototype, "updateIndexName", null);
var version = "3.1.0";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf__default["default"](Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf__default["default"](this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn__default["default"](this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function ownKeys2(object, enumerableOnly) {
  var keys6 = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys6.push.apply(keys6, symbols);
  }
  return keys6;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys2(Object(source), true).forEach(function(key) {
        _defineProperty__default["default"](target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys2(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var SYNC_PRODUCT_ID = "data_sync";
var SDK_VERSION = version;
function decompose(arg) {
  if (!arg) {
    return {
      mode: "create_new"
    };
  } else if (typeof arg === "string") {
    return {
      id: arg,
      mode: "open_or_create"
    };
  } else {
    var mode = arg.mode || (arg.id ? "open_or_create" : "create_new");
    return _objectSpread(_objectSpread({}, arg), {}, {
      mode
    });
  }
}
var SYNC_DOCUMENT_NOTIFICATION_TYPE = "com.twilio.rtd.cds.document";
var SYNC_LIST_NOTIFICATION_TYPE = "com.twilio.rtd.cds.list";
var SYNC_MAP_NOTIFICATION_TYPE = "com.twilio.rtd.cds.map";
var SYNC_NOTIFICATION_TYPE = "twilio.sync.event";
var Client = /* @__PURE__ */ function(_EventEmitter) {
  _inherits__default["default"](Client2, _EventEmitter);
  var _super = _createSuper(Client2);
  function Client2(fpaToken) {
    var _this;
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    _classCallCheck__default["default"](this, Client2);
    _this = _super.call(this);
    if (!fpaToken) {
      throw new Error("Sync library needs a valid Twilio token to be passed");
    }
    if (options.hasOwnProperty("logLevel")) {
      log$1$1.setLevel(options.logLevel);
    } else {
      log$1$1.setLevel("silent");
    }
    var productId = options.productId = options.productId || SYNC_PRODUCT_ID;
    options.clientMetadata = options.clientMetadata || {};
    if (!options.clientMetadata.hasOwnProperty("type")) {
      options.clientMetadata.type = "sync";
    }
    if (!options.clientMetadata.hasOwnProperty("sdk")) {
      options.clientMetadata.sdk = "JS";
      options.clientMetadata.sdkv = SDK_VERSION;
    }
    var startTwilsock = !options.twilsockClient;
    if (!options.initRegistrations) {
      var initRegistration = new twilsock.InitRegistration(productId);
      Client2.populateInitRegistrations(initRegistration);
      options.initRegistrations = [initRegistration];
    }
    var twilsock$1 = options.twilsockClient = options.twilsockClient || new twilsock.Twilsock(fpaToken, productId, options);
    twilsock$1.on("tokenAboutToExpire", function(ttl) {
      return _this.emit("tokenAboutToExpire", ttl);
    });
    twilsock$1.on("tokenExpired", function() {
      return _this.emit("tokenExpired");
    });
    twilsock$1.on("connectionError", function(err) {
      return _this.emit("connectionError", err);
    });
    twilsock$1.on("stateChanged", function(state) {
      _this.emit("connectionStateChanged", state);
      _this.services.subscriptions.onConnectionStateChanged(state === "connected");
    });
    twilsock$1.on("message", function(messageType, payload) {
      return _this._routeMessage(messageType, payload);
    });
    var config = new Configuration(options);
    var network = new NetworkService(new ClientInfo(SDK_VERSION), config, twilsock$1);
    var storage = new SessionStorage(config);
    _this.services = {
      config,
      twilsock: twilsock$1,
      network,
      storage,
      router: _assertThisInitialized__default["default"](_this),
      subscriptions: null
    };
    _this.services.subscriptions = new Subscriptions(_this.services);
    _this.entities = new EntitiesCache();
    if (startTwilsock) {
      twilsock$1.connect();
    }
    return _this;
  }
  _createClass__default["default"](Client2, [{
    key: "_routeMessage",
    value: (
      /**
       * Entry point for all the incoming messages (Router).
       *
       * @param type Type of the incoming message
       * @param message Message to route
       * @internal
       */
      function _routeMessage(type5, message) {
        log$1$1.trace("Notification type:", type5, "content:", message);
        switch (type5) {
          case SYNC_DOCUMENT_NOTIFICATION_TYPE:
          case SYNC_LIST_NOTIFICATION_TYPE:
          case SYNC_MAP_NOTIFICATION_TYPE:
            this.services.subscriptions.acceptMessage(message, false);
            break;
          case SYNC_NOTIFICATION_TYPE:
            this.services.subscriptions.acceptMessage(message, true);
            break;
        }
      }
    )
    /**
     * Subscribe for events (Router)
     *
     * @internal
     */
  }, {
    key: "_subscribe",
    value: function _subscribe(sid, entity) {
      this.services.subscriptions.add(sid, entity);
    }
    /**
     * Unsubscribe from events (Router)
     *
     * @internal
     */
  }, {
    key: "_unsubscribe",
    value: function _unsubscribe(sid) {
      this.services.subscriptions.remove(sid);
    }
    /**
     * Current version of the Sync client.
     */
  }, {
    key: "connectionState",
    get: (
      /**
       * Current service connection state.
       */
      function get3() {
        return this.services.twilsock.state;
      }
    )
    /**
     * Returns a promise which resolves when library is correctly initialized
     * Or throws if initialization is impossible
     *
     * @internal
     */
  }, {
    key: "ensureReady",
    value: function() {
      var _ensureReady = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee() {
        var storageSettings;
        return _regeneratorRuntime__default["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.services.config.sessionStorageEnabled) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return");
              case 2:
                _context.prev = 2;
                _context.next = 5;
                return this.services.twilsock.storageId();
              case 5:
                storageSettings = _context.sent;
                this.services.storage.updateStorageId(storageSettings.id);
                _context.next = 12;
                break;
              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](2);
                log$1$1.warn("Failed to initialize storage", _context.t0);
              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 9]]);
      }));
      function ensureReady() {
        return _ensureReady.apply(this, arguments);
      }
      return ensureReady;
    }()
  }, {
    key: "storeRootInSessionCache",
    value: function storeRootInSessionCache(type5, id2, value) {
      if (!this.services.config.sessionStorageEnabled || !id2) {
        return;
      }
      var valueToStore = deepClone(value);
      if (type5 === SyncList.type || type5 === SyncMap.type) {
        valueToStore["last_event_id"] = null;
        delete valueToStore["items"];
      }
      this.services.storage.store(type5, id2, valueToStore);
    }
  }, {
    key: "readRootFromSessionCache",
    value: function readRootFromSessionCache(type5, id2) {
      if (!this.services.config.sessionStorageEnabled || !id2) {
        return null;
      }
      return this.services.storage.read(type5, id2);
    }
  }, {
    key: "_get",
    value: function() {
      var _get2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee2(baseUri, id2) {
        var optimistic, uri, response, _args2 = arguments;
        return _regeneratorRuntime__default["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                optimistic = _args2.length > 2 && _args2[2] !== void 0 ? _args2[2] : false;
                if (id2) {
                  _context2.next = 3;
                  break;
                }
                throw new SyncError("Cannot get entity without id", 404);
              case 3:
                uri = new UriBuilder(baseUri).pathSegment(id2).queryParam("Include", optimistic ? "items" : void 0).build();
                _context2.next = 6;
                return this.services.network.get(uri);
              case 6:
                response = _context2.sent;
                return _context2.abrupt("return", response.body);
              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function _get3(_x, _x2) {
        return _get2.apply(this, arguments);
      }
      return _get3;
    }()
  }, {
    key: "_createDocument",
    value: function _createDocument(id2, data2, ttl) {
      var requestBody = {
        unique_name: id2,
        data: data2 || {}
      };
      if (ttl !== void 0) {
        requestBody.ttl = ttl;
      }
      return this.services.network.post(this.services.config.documentsUri, requestBody).then(function(response) {
        response.body.data = requestBody.data;
        return response.body;
      });
    }
  }, {
    key: "_getDocument",
    value: function() {
      var _getDocument2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee3(id2) {
        return _regeneratorRuntime__default["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.readRootFromSessionCache(SyncDocument.type, id2) || this._get(this.services.config.documentsUri, id2));
              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function _getDocument(_x3) {
        return _getDocument2.apply(this, arguments);
      }
      return _getDocument;
    }()
  }, {
    key: "_createList",
    value: function _createList(id2, purpose, context, ttl) {
      var requestBody = {
        unique_name: id2,
        purpose,
        context
      };
      if (ttl !== void 0) {
        requestBody.ttl = ttl;
      }
      return this.services.network.post(this.services.config.listsUri, requestBody).then(function(response) {
        return response.body;
      });
    }
  }, {
    key: "_getList",
    value: function() {
      var _getList2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee4(id2) {
        return _regeneratorRuntime__default["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", this.readRootFromSessionCache(SyncList.type, id2) || this._get(this.services.config.listsUri, id2));
              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
      function _getList(_x4) {
        return _getList2.apply(this, arguments);
      }
      return _getList;
    }()
  }, {
    key: "_createMap",
    value: function _createMap(id2, ttl) {
      var requestBody = {
        unique_name: id2
      };
      if (ttl !== void 0) {
        requestBody.ttl = ttl;
      }
      return this.services.network.post(this.services.config.mapsUri, requestBody).then(function(response) {
        return response.body;
      });
    }
  }, {
    key: "_getMap",
    value: function() {
      var _getMap2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee5(id2) {
        var optimistic, _args5 = arguments;
        return _regeneratorRuntime__default["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                optimistic = _args5.length > 1 && _args5[1] !== void 0 ? _args5[1] : false;
                return _context5.abrupt("return", this.readRootFromSessionCache(SyncMap.type, id2) || this._get(this.services.config.mapsUri, id2, optimistic));
              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
      function _getMap(_x5) {
        return _getMap2.apply(this, arguments);
      }
      return _getMap;
    }()
  }, {
    key: "_getStream",
    value: function() {
      var _getStream2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee6(id2) {
        return _regeneratorRuntime__default["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", this.readRootFromSessionCache(SyncStream.type, id2) || this._get(this.services.config.streamsUri, id2, false));
              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
      function _getStream(_x6) {
        return _getStream2.apply(this, arguments);
      }
      return _getStream;
    }()
  }, {
    key: "_createStream",
    value: function() {
      var _createStream2 = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee7(id2, ttl) {
        var requestBody, response;
        return _regeneratorRuntime__default["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                requestBody = {
                  unique_name: id2
                };
                if (ttl !== void 0) {
                  requestBody.ttl = ttl;
                }
                _context7.next = 4;
                return this.services.network.post(this.services.config.streamsUri, requestBody);
              case 4:
                response = _context7.sent;
                return _context7.abrupt("return", response.body);
              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
      function _createStream(_x7, _x8) {
        return _createStream2.apply(this, arguments);
      }
      return _createStream;
    }()
  }, {
    key: "_getLiveQuery",
    value: function _getLiveQuery(sid) {
      return this.readRootFromSessionCache(LiveQuery.type, sid);
    }
  }, {
    key: "getCached",
    value: function getCached(id2, type5) {
      if (id2) {
        return this.entities.get(id2, type5) || null;
      }
      return null;
    }
  }, {
    key: "removeFromCacheAndSession",
    value: function removeFromCacheAndSession(type5, sid, uniqueName) {
      this.entities.remove(sid);
      if (this.services.config.sessionStorageEnabled) {
        this.services.storage.remove(type5, sid, uniqueName);
      }
    }
    /**
     * Read or create a Sync document.
     * @param arg Could be any of the following:
     * * Unique name or SID identifying the Sync document - opens the document with the given identifier or creates one if it does not exist.
     * * none - creates a new document with a randomly assigned SID and no unique name.
     * * {@link OpenDocumentOptions} object for more granular control.
     * @return A promise which resolves after the document is successfully read (or created).
     * This promise may reject if the document could not be created or if this endpoint lacks the necessary permissions to access it.
     * @example
     * ```typescript
     * syncClient.document('MyDocument')
     *   .then((document) => {
     *     console.log('Successfully opened a document. SID:', document.sid);
     *     document.on('updated', (event) => {
     *       console.log('Received an "updated" event: ', event);
     *     });
     *   })
     *   .catch((error) => {
     *     console.error('Unexpected error', error);
     *   });
     * ```
     */
  }, {
    key: "document",
    value: function() {
      var _document = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee8(arg) {
        var _this2 = this;
        var opts, docDescriptor, docFromInMemoryCache, syncDocumentImpl;
        return _regeneratorRuntime__default["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.ensureReady();
              case 2:
                opts = decompose(arg);
                if (!(opts.mode === "create_new")) {
                  _context8.next = 9;
                  break;
                }
                _context8.next = 6;
                return this._createDocument(opts.id, opts.data, opts.ttl);
              case 6:
                docDescriptor = _context8.sent;
                _context8.next = 39;
                break;
              case 9:
                docFromInMemoryCache = this.getCached(opts.id, SyncDocument.type);
                if (!docFromInMemoryCache) {
                  _context8.next = 14;
                  break;
                }
                return _context8.abrupt("return", new SyncDocument(docFromInMemoryCache));
              case 14:
                _context8.prev = 14;
                _context8.next = 17;
                return this._getDocument(opts.id);
              case 17:
                docDescriptor = _context8.sent;
                _context8.next = 39;
                break;
              case 20:
                _context8.prev = 20;
                _context8.t0 = _context8["catch"](14);
                if (!(_context8.t0.status !== 404 || opts.mode === "open_existing")) {
                  _context8.next = 26;
                  break;
                }
                throw _context8.t0;
              case 26:
                _context8.prev = 26;
                _context8.next = 29;
                return this._createDocument(opts.id, opts.data, opts.ttl);
              case 29:
                docDescriptor = _context8.sent;
                _context8.next = 39;
                break;
              case 32:
                _context8.prev = 32;
                _context8.t1 = _context8["catch"](26);
                if (!(_context8.t1.status === 409)) {
                  _context8.next = 38;
                  break;
                }
                return _context8.abrupt("return", this.document(arg));
              case 38:
                throw _context8.t1;
              case 39:
                this.storeRootInSessionCache(SyncDocument.type, opts.id, docDescriptor);
                syncDocumentImpl = new SyncDocumentImpl(this.services, docDescriptor, function(type5, sid, uniqueName) {
                  return _this2.removeFromCacheAndSession(type5, sid, uniqueName);
                });
                syncDocumentImpl = this.entities.store(syncDocumentImpl);
                return _context8.abrupt("return", new SyncDocument(syncDocumentImpl));
              case 43:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[14, 20], [26, 32]]);
      }));
      function document2(_x9) {
        return _document.apply(this, arguments);
      }
      return document2;
    }()
    /**
     * Read or create a Sync map.
     * @param arg Could be any of the following:
     * * Unique name or SID identifying the Sync map - opens the map with the given identifier or creates one if it does not exist.
     * * none - creates a new map with a randomly assigned SID and no unique name.
     * * {@link OpenMapOptions} object for more granular control.
     * @return A promise which resolves after the map is successfully read (or created).
     * This promise may reject if the map could not be created or if this endpoint lacks the necessary permissions to access it.
     * @example
     * ```typescript
     * syncClient.map('MyMap')
     *   .then((map) => {
     *     console.log('Successfully opened a map. SID:', map.sid);
     *     map.on('itemUpdated', (event) => {
     *       console.log('Received an "itemUpdated" event:', event);
     *     });
     *   })
     *   .catch((error) => {
     *     console.error('Unexpected error', error);
     *   });
     * ```
     */
  }, {
    key: "map",
    value: function() {
      var _map = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee9(arg) {
        var _this3 = this;
        var opts, mapDescriptor, mapFromInMemoryCache, syncMapImpl;
        return _regeneratorRuntime__default["default"].wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.ensureReady();
              case 2:
                opts = decompose(arg);
                if (!(opts.mode === "create_new")) {
                  _context9.next = 9;
                  break;
                }
                _context9.next = 6;
                return this._createMap(opts.id, opts.ttl);
              case 6:
                mapDescriptor = _context9.sent;
                _context9.next = 39;
                break;
              case 9:
                mapFromInMemoryCache = this.getCached(opts.id, SyncMap.type);
                if (!mapFromInMemoryCache) {
                  _context9.next = 14;
                  break;
                }
                return _context9.abrupt("return", new SyncMap(mapFromInMemoryCache));
              case 14:
                _context9.prev = 14;
                _context9.next = 17;
                return this._getMap(opts.id, opts.includeItems);
              case 17:
                mapDescriptor = _context9.sent;
                _context9.next = 39;
                break;
              case 20:
                _context9.prev = 20;
                _context9.t0 = _context9["catch"](14);
                if (!(_context9.t0.status !== 404 || opts.mode === "open_existing")) {
                  _context9.next = 26;
                  break;
                }
                throw _context9.t0;
              case 26:
                _context9.prev = 26;
                _context9.next = 29;
                return this._createMap(opts.id, opts.ttl);
              case 29:
                mapDescriptor = _context9.sent;
                _context9.next = 39;
                break;
              case 32:
                _context9.prev = 32;
                _context9.t1 = _context9["catch"](26);
                if (!(_context9.t1.status === 409)) {
                  _context9.next = 38;
                  break;
                }
                return _context9.abrupt("return", this.map(arg));
              case 38:
                throw _context9.t1;
              case 39:
                this.storeRootInSessionCache(SyncMap.type, opts.id, mapDescriptor);
                syncMapImpl = new SyncMapImpl(this.services, mapDescriptor, function(type5, sid, uniqueName) {
                  return _this3.removeFromCacheAndSession(type5, sid, uniqueName);
                });
                syncMapImpl = this.entities.store(syncMapImpl);
                return _context9.abrupt("return", new SyncMap(syncMapImpl));
              case 43:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[14, 20], [26, 32]]);
      }));
      function map3(_x10) {
        return _map.apply(this, arguments);
      }
      return map3;
    }()
    /**
     * Read or create a Sync list.
     * @param arg Could be any of the following:
     * * Unique name or SID identifying a Sync list - opens the list with the given identifier or creates one if it does not exist.
     * * none - creates a new list with a randomly assigned SID and no unique name.
     * * {@link OpenListOptions} object for more granular control.
     * @return A promise which resolves after the list is successfully read (or created).
     * This promise may reject if the list could not be created or if this endpoint lacks the necessary permissions to access it.
     * @example
     * ```typescript
     * syncClient.list('MyList')
     *   .then((list) => {
     *     console.log('Successfully opened a List. SID:', list.sid);
     *     list.on('itemAdded', (event) => {
     *       console.log('Received an "itemAdded" event:', event);
     *     });
     *   })
     *   .catch((error) => {
     *     console.error('Unexpected error', error);
     *   });
     * ```
     */
  }, {
    key: "list",
    value: function() {
      var _list = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee10(arg) {
        var _this4 = this;
        var opts, listDescriptor, listFromInMemoryCache, syncListImpl;
        return _regeneratorRuntime__default["default"].wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.ensureReady();
              case 2:
                opts = decompose(arg);
                if (!(opts.mode === "create_new")) {
                  _context10.next = 9;
                  break;
                }
                _context10.next = 6;
                return this._createList(opts.id, opts.purpose, opts.context, opts.ttl);
              case 6:
                listDescriptor = _context10.sent;
                _context10.next = 39;
                break;
              case 9:
                listFromInMemoryCache = this.getCached(opts.id, SyncList.type);
                if (!listFromInMemoryCache) {
                  _context10.next = 14;
                  break;
                }
                return _context10.abrupt("return", new SyncList(listFromInMemoryCache));
              case 14:
                _context10.prev = 14;
                _context10.next = 17;
                return this._getList(opts.id);
              case 17:
                listDescriptor = _context10.sent;
                _context10.next = 39;
                break;
              case 20:
                _context10.prev = 20;
                _context10.t0 = _context10["catch"](14);
                if (!(_context10.t0.status !== 404 || opts.mode === "open_existing")) {
                  _context10.next = 26;
                  break;
                }
                throw _context10.t0;
              case 26:
                _context10.prev = 26;
                _context10.next = 29;
                return this._createList(opts.id, opts.purpose, opts.context, opts.ttl);
              case 29:
                listDescriptor = _context10.sent;
                _context10.next = 39;
                break;
              case 32:
                _context10.prev = 32;
                _context10.t1 = _context10["catch"](26);
                if (!(_context10.t1.status === 409)) {
                  _context10.next = 38;
                  break;
                }
                return _context10.abrupt("return", this.list(arg));
              case 38:
                throw _context10.t1;
              case 39:
                this.storeRootInSessionCache(SyncList.type, opts.id, listDescriptor);
                syncListImpl = new SyncListImpl(this.services, listDescriptor, function(type5, sid, uniqueName) {
                  return _this4.removeFromCacheAndSession(type5, sid, uniqueName);
                });
                syncListImpl = this.entities.store(syncListImpl);
                return _context10.abrupt("return", new SyncList(syncListImpl));
              case 43:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[14, 20], [26, 32]]);
      }));
      function list(_x11) {
        return _list.apply(this, arguments);
      }
      return list;
    }()
    /**
     * Read or create a Sync message stream.
     * @param arg Could be any of the following:
     * * Unique name or SID identifying a stream - opens the stream with the given identifier or creates one if it does not exist.
     * * none - creates a new stream with a randomly assigned SID and no unique name.
     * * {@link OpenStreamOptions} object for more granular control.
     * @return A promise which resolves after the stream is successfully read (or created).
     * The flow of messages will begin imminently (but not necessarily immediately) upon resolution.
     * This promise may reject if the stream could not be created or if this endpoint lacks the necessary permissions to access it.
     * @example
     * ```typescript
     * syncClient.stream('MyStream')
     *   .then((stream) => {
     *     console.log('Successfully opened a message stream. SID:', stream.sid);
     *     stream.on('messagePublished', (event) => {
     *       console.log('Received a "messagePublished" event:', event);
     *     });
     *   })
     *   .catch((error) => {
     *     console.error('Unexpected error', error);
     *   });
     * ```
     */
  }, {
    key: "stream",
    value: function() {
      var _stream = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee11(arg) {
        var _this5 = this;
        var opts, streamDescriptor, streamFromInMemoryCache, streamRemovalHandler, syncStreamImpl;
        return _regeneratorRuntime__default["default"].wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.ensureReady();
              case 2:
                opts = decompose(arg);
                if (!(opts.mode === "create_new")) {
                  _context11.next = 9;
                  break;
                }
                _context11.next = 6;
                return this._createStream(opts.id, opts.ttl);
              case 6:
                streamDescriptor = _context11.sent;
                _context11.next = 39;
                break;
              case 9:
                streamFromInMemoryCache = this.getCached(opts.id, SyncStream.type);
                if (!streamFromInMemoryCache) {
                  _context11.next = 14;
                  break;
                }
                return _context11.abrupt("return", new SyncStream(streamFromInMemoryCache));
              case 14:
                _context11.prev = 14;
                _context11.next = 17;
                return this._getStream(opts.id);
              case 17:
                streamDescriptor = _context11.sent;
                _context11.next = 39;
                break;
              case 20:
                _context11.prev = 20;
                _context11.t0 = _context11["catch"](14);
                if (!(_context11.t0.status !== 404 || opts.mode === "open_existing")) {
                  _context11.next = 26;
                  break;
                }
                throw _context11.t0;
              case 26:
                _context11.prev = 26;
                _context11.next = 29;
                return this._createStream(opts.id, opts.ttl);
              case 29:
                streamDescriptor = _context11.sent;
                _context11.next = 39;
                break;
              case 32:
                _context11.prev = 32;
                _context11.t1 = _context11["catch"](26);
                if (!(_context11.t1.status === 409)) {
                  _context11.next = 38;
                  break;
                }
                return _context11.abrupt("return", this.stream(arg));
              case 38:
                throw _context11.t1;
              case 39:
                this.storeRootInSessionCache(SyncStream.type, opts.id, streamDescriptor);
                streamRemovalHandler = function streamRemovalHandler2(type5, sid, uniqueName) {
                  return _this5.removeFromCacheAndSession(type5, sid, uniqueName);
                };
                syncStreamImpl = new SyncStreamImpl(this.services, streamDescriptor, streamRemovalHandler);
                syncStreamImpl = this.entities.store(syncStreamImpl);
                return _context11.abrupt("return", new SyncStream(syncStreamImpl));
              case 44:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[14, 20], [26, 32]]);
      }));
      function stream(_x12) {
        return _stream.apply(this, arguments);
      }
      return stream;
    }()
    /**
     * Gracefully shuts the Sync client down.
     */
  }, {
    key: "shutdown",
    value: function() {
      var _shutdown = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee12() {
        return _regeneratorRuntime__default["default"].wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.services.subscriptions.shutdown();
              case 2:
                _context12.next = 4;
                return this.services.twilsock.disconnect();
              case 4:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));
      function shutdown() {
        return _shutdown.apply(this, arguments);
      }
      return shutdown;
    }()
    /**
     * Set the authentication token.
     * @param token New token to set.
     */
  }, {
    key: "updateToken",
    value: function() {
      var _updateToken = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee13(token) {
        return _regeneratorRuntime__default["default"].wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                return _context13.abrupt("return", this.services.twilsock.updateToken(token).catch(function(error2) {
                  var _error$reply;
                  var status = error2 === null || error2 === void 0 ? void 0 : (_error$reply = error2.reply) === null || _error$reply === void 0 ? void 0 : _error$reply.status;
                  if ((status === null || status === void 0 ? void 0 : status.code) === 401 && (status === null || status === void 0 ? void 0 : status.status) === "UNAUTHORIZED") {
                    throw new SyncError("Updated token was rejected by server", 400, 51130);
                  }
                  throw error2;
                }));
              case 1:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));
      function updateToken(_x13) {
        return _updateToken.apply(this, arguments);
      }
      return updateToken;
    }()
    /**
     * For Flex customers only. Establishes a long-running query against Flex data wherein the returned
     * result set is updated whenever new (or updated) records match the given expression. Updated results
     * are presented row-by-row according to the lifetime of the returned LiveQuery object.
     *
     * @param indexName Must specify one of the Flex data classes for which Live Queries are available.
     * @param queryExpression A query expression to be executed against the given data index.
     * Please review the [Live Query Language](https://www.twilio.com/docs/sync/live-query)
     * page for Sync client limits and a full list of operators currently supported in query expressions.
     *
     * @return A promise that resolves when the query has been successfully executed.
     * @example
     * ```typescript
     * syncClient.liveQuery('tr-worker', 'data.attributes.worker_name == "Bob"')
     *   .then((args) => {
     *      console.log('Subscribed to live data updates for worker Bob');
     *      const items = args.getItems();
     *      Object.entries(items).forEach(([key, value]) => {
     *        console.log('Search result item key:', key);
     *        console.log('Search result item value:', value);
     *      });
     *   })
     *   .catch((err) => {
     *      console.error('Error when subscribing to live updates for worker Bob', err);
     *   });
     * ```
     */
  }, {
    key: "liveQuery",
    value: function() {
      var _liveQuery = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee14(indexName, queryExpression) {
        var _this6 = this;
        var queryUri, response, liveQueryImpl, descriptor, liveQueryRemovalHandler;
        return _regeneratorRuntime__default["default"].wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return this.ensureReady();
              case 2:
                queryUri = new UriBuilder(this.services.config.insightsUri).pathSegment(indexName).pathSegment("Items").build();
                _context14.next = 5;
                return queryItems({
                  network: this.services.network,
                  uri: queryUri,
                  queryString: queryExpression,
                  type: LiveQuery.type
                });
              case 5:
                response = _context14.sent;
                liveQueryImpl = this.getCached(response.query_id, LiveQuery.type);
                if (!liveQueryImpl) {
                  descriptor = this._getLiveQuery(response.query_id);
                  if (!descriptor) {
                    descriptor = {
                      indexName,
                      queryExpression,
                      sid: response.query_id,
                      queryUri,
                      last_event_id: response.last_event_id
                    };
                  }
                  liveQueryRemovalHandler = function liveQueryRemovalHandler2(type5, sid, uniqueName) {
                    return _this6.removeFromCacheAndSession(type5, sid, uniqueName);
                  };
                  liveQueryImpl = new LiveQueryImpl(descriptor, this.services, liveQueryRemovalHandler, response.items);
                }
                this.storeRootInSessionCache(LiveQuery.type, response.query_id, liveQueryImpl.liveQueryDescriptor);
                liveQueryImpl = this.entities.store(liveQueryImpl);
                return _context14.abrupt("return", new LiveQuery(liveQueryImpl));
              case 11:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));
      function liveQuery(_x14, _x15) {
        return _liveQuery.apply(this, arguments);
      }
      return liveQuery;
    }()
    /**
     * For Flex customers only. Creates a query object that can be used to issue one-time queries repeatedly
     * against the target index.
     *
     * @param indexName Must specify one of the Flex data classes for which live queries are available.
     * @return A promise which resolves after the instance of InstantQuery is successfully created.
     * @example
     * ```typescript
     * syncClient.instantQuery('tr-worker')
     *   .then((q) => {
     *     q.on('searchResult', (items) => {
     *       Object.entries(items).forEach(([key, value]) => {
     *         console.log('Search result item key:', key);
     *         console.log('Search result item value:', value);
     *       });
     *     });
     *   });
     * ```
     */
  }, {
    key: "instantQuery",
    value: function() {
      var _instantQuery = _asyncToGenerator__default["default"](/* @__PURE__ */ _regeneratorRuntime__default["default"].mark(function _callee15(indexName) {
        var _this7 = this;
        var liveQueryCreator;
        return _regeneratorRuntime__default["default"].wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return this.ensureReady();
              case 2:
                liveQueryCreator = function liveQueryCreator2(indexName2, queryExpression) {
                  return _this7.liveQuery(indexName2, queryExpression);
                };
                return _context15.abrupt("return", new InstantQuery({
                  indexName,
                  network: this.services.network,
                  insightsUri: this.services.config.insightsUri,
                  liveQueryCreator
                }));
              case 4:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));
      function instantQuery(_x16) {
        return _instantQuery.apply(this, arguments);
      }
      return instantQuery;
    }()
  }], [{
    key: "populateInitRegistrations",
    value: function populateInitRegistrations(reg) {
      reg.populateInitRegistrations([SYNC_NOTIFICATION_TYPE, SYNC_DOCUMENT_NOTIFICATION_TYPE, SYNC_LIST_NOTIFICATION_TYPE, SYNC_MAP_NOTIFICATION_TYPE]);
    }
  }, {
    key: "version",
    get: function get3() {
      return SDK_VERSION;
    }
  }]);
  return Client2;
}(EventEmitter);
_defineProperty__default["default"](Client, "connectionStateChanged", "connectionStateChanged");
_defineProperty__default["default"](Client, "connectionError", "connectionError");
_defineProperty__default["default"](Client, "tokenAboutToExpire", "tokenAboutToExpire");
_defineProperty__default["default"](Client, "tokenExpired", "tokenExpired");
__decorate([declarativeTypeValidator.validateTypesAsync(["undefined", "string", declarativeTypeValidator.objectSchema("open document options", {
  id: ["string", "undefined"],
  mode: [declarativeTypeValidator.literal("open_or_create", "open_existing", "create_new"), "undefined"],
  ttl: [declarativeTypeValidator.nonNegativeInteger, "undefined"],
  data: [declarativeTypeValidator.pureObject, "undefined", declarativeTypeValidator.literal(null)]
})]), __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", Promise)], Client.prototype, "document", null);
__decorate([declarativeTypeValidator.validateTypesAsync(["undefined", "string", declarativeTypeValidator.objectSchema("open map options", {
  id: ["string", "undefined"],
  mode: [declarativeTypeValidator.literal("open_or_create", "open_existing", "create_new"), "undefined"],
  ttl: [declarativeTypeValidator.nonNegativeInteger, "undefined"],
  data: [declarativeTypeValidator.pureObject, "undefined", declarativeTypeValidator.literal(null)],
  includeItems: ["boolean", "undefined"]
})]), __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", Promise)], Client.prototype, "map", null);
__decorate([declarativeTypeValidator.validateTypesAsync(["undefined", "string", declarativeTypeValidator.objectSchema("open list options", {
  id: ["string", "undefined"],
  mode: [declarativeTypeValidator.literal("open_or_create", "open_existing", "create_new"), "undefined"],
  ttl: [declarativeTypeValidator.nonNegativeInteger, "undefined"],
  data: [declarativeTypeValidator.pureObject, "undefined", declarativeTypeValidator.literal(null)],
  purpose: ["string", "undefined"],
  context: [declarativeTypeValidator.pureObject, "undefined"],
  includeItems: ["boolean", "undefined"]
})]), __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", Promise)], Client.prototype, "list", null);
__decorate([declarativeTypeValidator.validateTypesAsync(["undefined", "string", declarativeTypeValidator.objectSchema("open stream options", {
  id: ["string", "undefined"],
  mode: [declarativeTypeValidator.literal("open_or_create", "open_existing", "create_new"), "undefined"],
  ttl: [declarativeTypeValidator.nonNegativeInteger, "undefined"],
  data: [declarativeTypeValidator.pureObject, "undefined", declarativeTypeValidator.literal(null)]
})]), __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", Promise)], Client.prototype, "stream", null);
__decorate([declarativeTypeValidator.validateTypesAsync(declarativeTypeValidator.nonEmptyString), __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", Promise)], Client.prototype, "updateToken", null);
__decorate([declarativeTypeValidator.validateTypesAsync(declarativeTypeValidator.nonEmptyString, "string"), __metadata("design:type", Function), __metadata("design:paramtypes", [String, String]), __metadata("design:returntype", Promise)], Client.prototype, "liveQuery", null);
__decorate([declarativeTypeValidator.validateTypesAsync(declarativeTypeValidator.nonEmptyString), __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", Promise)], Client.prototype, "instantQuery", null);
browser$3.Client = Client;
browser$3.InsightsItem = InsightsItem;
browser$3.InstantQuery = InstantQuery;
browser$3.LiveQuery = LiveQuery;
browser$3.Paginator = Paginator;
browser$3.SyncClient = Client;
browser$3.SyncDocument = SyncDocument;
browser$3.SyncList = SyncList;
browser$3.SyncListItem = SyncListItem;
browser$3.SyncMap = SyncMap;
browser$3.SyncMapItem = SyncMapItem;
browser$3.SyncStream = SyncStream;
var browser$1 = {};
var isObject$3 = isObject$q;
var classof$1 = classofRaw$2;
var wellKnownSymbol$3 = wellKnownSymbol$t;
var MATCH$1 = wellKnownSymbol$3("match");
var isRegexp = function(it) {
  var isRegExp2;
  return isObject$3(it) && ((isRegExp2 = it[MATCH$1]) !== void 0 ? !!isRegExp2 : classof$1(it) === "RegExp");
};
var isRegExp = isRegexp;
var $TypeError = TypeError;
var notARegexp = function(it) {
  if (isRegExp(it)) {
    throw new $TypeError("The method doesn't accept regular expressions");
  }
  return it;
};
var wellKnownSymbol$2 = wellKnownSymbol$t;
var MATCH = wellKnownSymbol$2("match");
var correctIsRegexpLogic = function(METHOD_NAME) {
  var regexp = /./;
  try {
    "/./"[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return "/./"[METHOD_NAME](regexp);
    } catch (error2) {
    }
  }
  return false;
};
var $$7 = _export;
var uncurryThis$6 = functionUncurryThisClause;
var getOwnPropertyDescriptor5 = objectGetOwnPropertyDescriptor.f;
var toLength = toLength$9;
var toString$2 = toString$g;
var notARegExp$1 = notARegexp;
var requireObjectCoercible$1 = requireObjectCoercible$b;
var correctIsRegExpLogic$1 = correctIsRegexpLogic;
var IS_PURE$1 = isPure;
var stringSlice$2 = uncurryThis$6("".slice);
var min = Math.min;
var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic$1("startsWith");
var MDN_POLYFILL_BUG = !IS_PURE$1 && !CORRECT_IS_REGEXP_LOGIC && !!function() {
  var descriptor = getOwnPropertyDescriptor5(String.prototype, "startsWith");
  return descriptor && !descriptor.writable;
}();
$$7({ target: "String", proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString) {
    var that = toString$2(requireObjectCoercible$1(this));
    notARegExp$1(searchString);
    var index2 = toLength(min(arguments.length > 1 ? arguments[1] : void 0, that.length));
    var search = toString$2(searchString);
    return stringSlice$2(that, index2, index2 + search.length) === search;
  }
});
var fails$2 = fails$M;
var wellKnownSymbol$1 = wellKnownSymbol$t;
var DESCRIPTORS$2 = descriptors;
var IS_PURE = isPure;
var ITERATOR$1 = wellKnownSymbol$1("iterator");
var urlConstructorDetection = !fails$2(function() {
  var url = new URL("b?a=1&b=2&c=3", "http://a");
  var params = url.searchParams;
  var params2 = new URLSearchParams("a=1&a=2&b=3");
  var result = "";
  url.pathname = "c%20d";
  params.forEach(function(value, key) {
    params["delete"]("b");
    result += key + value;
  });
  params2["delete"]("a", 2);
  params2["delete"]("b", void 0);
  return IS_PURE && (!url.toJSON || !params2.has("a", 1) || params2.has("a", 2) || !params2.has("a", void 0) || params2.has("b")) || !params.size && (IS_PURE || !DESCRIPTORS$2) || !params.sort || url.href !== "http://a/c%20d?a=1&c=3" || params.get("c") !== "3" || String(new URLSearchParams("?a=1")) !== "a=1" || !params[ITERATOR$1] || new URL("https://a@b").username !== "a" || new URLSearchParams(new URLSearchParams("a=b")).get("a") !== "b" || new URL("http://тест").host !== "xn--e1aybc" || new URL("http://a#б").hash !== "#%D0%B1" || result !== "a1c3" || new URL("http://x", void 0).host !== "x";
});
var uncurryThis$5 = functionUncurryThis;
var maxInt = 2147483647;
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128;
var delimiter = "-";
var regexNonASCII = /[^\0-\u007E]/;
var regexSeparators = /[.\u3002\uFF0E\uFF61]/g;
var OVERFLOW_ERROR = "Overflow: input needs wider integers to process";
var baseMinusTMin = base - tMin;
var $RangeError = RangeError;
var exec$1 = uncurryThis$5(regexSeparators.exec);
var floor$1 = Math.floor;
var fromCharCode = String.fromCharCode;
var charCodeAt = uncurryThis$5("".charCodeAt);
var join$2 = uncurryThis$5([].join);
var push$3 = uncurryThis$5([].push);
var replace$2 = uncurryThis$5("".replace);
var split$2 = uncurryThis$5("".split);
var toLowerCase$1 = uncurryThis$5("".toLowerCase);
var ucs2decode = function(string) {
  var output = [];
  var counter2 = 0;
  var length = string.length;
  while (counter2 < length) {
    var value = charCodeAt(string, counter2++);
    if (value >= 55296 && value <= 56319 && counter2 < length) {
      var extra = charCodeAt(string, counter2++);
      if ((extra & 64512) === 56320) {
        push$3(output, ((value & 1023) << 10) + (extra & 1023) + 65536);
      } else {
        push$3(output, value);
        counter2--;
      }
    } else {
      push$3(output, value);
    }
  }
  return output;
};
var digitToBasic = function(digit) {
  return digit + 22 + 75 * (digit < 26);
};
var adapt = function(delta, numPoints, firstTime) {
  var k = 0;
  delta = firstTime ? floor$1(delta / damp) : delta >> 1;
  delta += floor$1(delta / numPoints);
  while (delta > baseMinusTMin * tMax >> 1) {
    delta = floor$1(delta / baseMinusTMin);
    k += base;
  }
  return floor$1(k + (baseMinusTMin + 1) * delta / (delta + skew));
};
var encode = function(input) {
  var output = [];
  input = ucs2decode(input);
  var inputLength = input.length;
  var n = initialN;
  var delta = 0;
  var bias = initialBias;
  var i, currentValue;
  for (i = 0; i < input.length; i++) {
    currentValue = input[i];
    if (currentValue < 128) {
      push$3(output, fromCharCode(currentValue));
    }
  }
  var basicLength = output.length;
  var handledCPCount = basicLength;
  if (basicLength) {
    push$3(output, delimiter);
  }
  while (handledCPCount < inputLength) {
    var m = maxInt;
    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue >= n && currentValue < m) {
        m = currentValue;
      }
    }
    var handledCPCountPlusOne = handledCPCount + 1;
    if (m - n > floor$1((maxInt - delta) / handledCPCountPlusOne)) {
      throw new $RangeError(OVERFLOW_ERROR);
    }
    delta += (m - n) * handledCPCountPlusOne;
    n = m;
    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue < n && ++delta > maxInt) {
        throw new $RangeError(OVERFLOW_ERROR);
      }
      if (currentValue === n) {
        var q = delta;
        var k = base;
        while (true) {
          var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
          if (q < t)
            break;
          var qMinusT = q - t;
          var baseMinusT = base - t;
          push$3(output, fromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
          q = floor$1(qMinusT / baseMinusT);
          k += base;
        }
        push$3(output, fromCharCode(digitToBasic(q)));
        bias = adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
        delta = 0;
        handledCPCount++;
      }
    }
    delta++;
    n++;
  }
  return join$2(output, "");
};
var stringPunycodeToAscii = function(input) {
  var encoded = [];
  var labels = split$2(replace$2(toLowerCase$1(input), regexSeparators, "."), ".");
  var i, label;
  for (i = 0; i < labels.length; i++) {
    label = labels[i];
    push$3(encoded, exec$1(regexNonASCII, label) ? "xn--" + encode(label) : label);
  }
  return join$2(encoded, ".");
};
var $$6 = _export;
var global$2 = global$D;
var safeGetBuiltIn = safeGetBuiltIn$2;
var call = functionCall;
var uncurryThis$4 = functionUncurryThis;
var DESCRIPTORS$1 = descriptors;
var USE_NATIVE_URL$1 = urlConstructorDetection;
var defineBuiltIn$1 = defineBuiltIn$f;
var defineBuiltInAccessor$1 = defineBuiltInAccessor$a;
var defineBuiltIns$1 = defineBuiltIns$4;
var setToStringTag$1 = setToStringTag$a;
var createIteratorConstructor = iteratorCreateConstructor;
var InternalStateModule$2 = internalState;
var anInstance$2 = anInstance$8;
var isCallable = isCallable$t;
var hasOwn$2 = hasOwnProperty_1;
var bind$1 = functionBindContext;
var classof = classof$g;
var anObject$1 = anObject$m;
var isObject$2 = isObject$q;
var $toString$1 = toString$g;
var create3 = objectCreate;
var createPropertyDescriptor = createPropertyDescriptor$7;
var getIterator = getIterator$4;
var getIteratorMethod = getIteratorMethod$5;
var createIterResultObject = createIterResultObject$4;
var validateArgumentsLength$1 = validateArgumentsLength$3;
var wellKnownSymbol = wellKnownSymbol$t;
var arraySort = arraySort$1;
var ITERATOR = wellKnownSymbol("iterator");
var URL_SEARCH_PARAMS = "URLSearchParams";
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + "Iterator";
var setInternalState$2 = InternalStateModule$2.set;
var getInternalParamsState = InternalStateModule$2.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = InternalStateModule$2.getterFor(URL_SEARCH_PARAMS_ITERATOR);
var nativeFetch = safeGetBuiltIn("fetch");
var NativeRequest = safeGetBuiltIn("Request");
var Headers = safeGetBuiltIn("Headers");
var RequestPrototype = NativeRequest && NativeRequest.prototype;
var HeadersPrototype = Headers && Headers.prototype;
var RegExp$1 = global$2.RegExp;
var TypeError$2 = global$2.TypeError;
var decodeURIComponent$1 = global$2.decodeURIComponent;
var encodeURIComponent$1 = global$2.encodeURIComponent;
var charAt$1 = uncurryThis$4("".charAt);
var join$1 = uncurryThis$4([].join);
var push$2 = uncurryThis$4([].push);
var replace$1 = uncurryThis$4("".replace);
var shift$1 = uncurryThis$4([].shift);
var splice$1 = uncurryThis$4([].splice);
var split$1 = uncurryThis$4("".split);
var stringSlice$1 = uncurryThis$4("".slice);
var plus = /\+/g;
var sequences = Array(4);
var percentSequence = function(bytes) {
  return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp$1("((?:%[\\da-f]{2}){" + bytes + "})", "gi"));
};
var percentDecode = function(sequence) {
  try {
    return decodeURIComponent$1(sequence);
  } catch (error2) {
    return sequence;
  }
};
var deserialize = function(it) {
  var result = replace$1(it, plus, " ");
  var bytes = 4;
  try {
    return decodeURIComponent$1(result);
  } catch (error2) {
    while (bytes) {
      result = replace$1(result, percentSequence(bytes--), percentDecode);
    }
    return result;
  }
};
var find$1 = /[!'()~]|%20/g;
var replacements = {
  "!": "%21",
  "'": "%27",
  "(": "%28",
  ")": "%29",
  "~": "%7E",
  "%20": "+"
};
var replacer = function(match2) {
  return replacements[match2];
};
var serialize = function(it) {
  return replace$1(encodeURIComponent$1(it), find$1, replacer);
};
var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
  setInternalState$2(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    target: getInternalParamsState(params).entries,
    index: 0,
    kind
  });
}, URL_SEARCH_PARAMS, function next2() {
  var state = getInternalIteratorState(this);
  var target = state.target;
  var index2 = state.index++;
  if (!target || index2 >= target.length) {
    state.target = void 0;
    return createIterResultObject(void 0, true);
  }
  var entry = target[index2];
  switch (state.kind) {
    case "keys":
      return createIterResultObject(entry.key, false);
    case "values":
      return createIterResultObject(entry.value, false);
  }
  return createIterResultObject([entry.key, entry.value], false);
}, true);
var URLSearchParamsState = function(init) {
  this.entries = [];
  this.url = null;
  if (init !== void 0) {
    if (isObject$2(init))
      this.parseObject(init);
    else
      this.parseQuery(typeof init == "string" ? charAt$1(init, 0) === "?" ? stringSlice$1(init, 1) : init : $toString$1(init));
  }
};
URLSearchParamsState.prototype = {
  type: URL_SEARCH_PARAMS,
  bindURL: function(url) {
    this.url = url;
    this.update();
  },
  parseObject: function(object) {
    var entries4 = this.entries;
    var iteratorMethod = getIteratorMethod(object);
    var iterator, next3, step, entryIterator, entryNext, first, second;
    if (iteratorMethod) {
      iterator = getIterator(object, iteratorMethod);
      next3 = iterator.next;
      while (!(step = call(next3, iterator)).done) {
        entryIterator = getIterator(anObject$1(step.value));
        entryNext = entryIterator.next;
        if ((first = call(entryNext, entryIterator)).done || (second = call(entryNext, entryIterator)).done || !call(entryNext, entryIterator).done)
          throw new TypeError$2("Expected sequence with length 2");
        push$2(entries4, { key: $toString$1(first.value), value: $toString$1(second.value) });
      }
    } else
      for (var key in object)
        if (hasOwn$2(object, key)) {
          push$2(entries4, { key, value: $toString$1(object[key]) });
        }
  },
  parseQuery: function(query) {
    if (query) {
      var entries4 = this.entries;
      var attributes = split$1(query, "&");
      var index2 = 0;
      var attribute, entry;
      while (index2 < attributes.length) {
        attribute = attributes[index2++];
        if (attribute.length) {
          entry = split$1(attribute, "=");
          push$2(entries4, {
            key: deserialize(shift$1(entry)),
            value: deserialize(join$1(entry, "="))
          });
        }
      }
    }
  },
  serialize: function() {
    var entries4 = this.entries;
    var result = [];
    var index2 = 0;
    var entry;
    while (index2 < entries4.length) {
      entry = entries4[index2++];
      push$2(result, serialize(entry.key) + "=" + serialize(entry.value));
    }
    return join$1(result, "&");
  },
  update: function() {
    this.entries.length = 0;
    this.parseQuery(this.url.query);
  },
  updateURL: function() {
    if (this.url)
      this.url.update();
  }
};
var URLSearchParamsConstructor = function URLSearchParams2() {
  anInstance$2(this, URLSearchParamsPrototype);
  var init = arguments.length > 0 ? arguments[0] : void 0;
  var state = setInternalState$2(this, new URLSearchParamsState(init));
  if (!DESCRIPTORS$1)
    this.size = state.entries.length;
};
var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;
defineBuiltIns$1(URLSearchParamsPrototype, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    var state = getInternalParamsState(this);
    validateArgumentsLength$1(arguments.length, 2);
    push$2(state.entries, { key: $toString$1(name), value: $toString$1(value) });
    if (!DESCRIPTORS$1)
      this.length++;
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  "delete": function(name) {
    var state = getInternalParamsState(this);
    var length = validateArgumentsLength$1(arguments.length, 1);
    var entries4 = state.entries;
    var key = $toString$1(name);
    var $value = length < 2 ? void 0 : arguments[1];
    var value = $value === void 0 ? $value : $toString$1($value);
    var index2 = 0;
    while (index2 < entries4.length) {
      var entry = entries4[index2];
      if (entry.key === key && (value === void 0 || entry.value === value)) {
        splice$1(entries4, index2, 1);
        if (value !== void 0)
          break;
      } else
        index2++;
    }
    if (!DESCRIPTORS$1)
      this.size = entries4.length;
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get2(name) {
    var entries4 = getInternalParamsState(this).entries;
    validateArgumentsLength$1(arguments.length, 1);
    var key = $toString$1(name);
    var index2 = 0;
    for (; index2 < entries4.length; index2++) {
      if (entries4[index2].key === key)
        return entries4[index2].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    var entries4 = getInternalParamsState(this).entries;
    validateArgumentsLength$1(arguments.length, 1);
    var key = $toString$1(name);
    var result = [];
    var index2 = 0;
    for (; index2 < entries4.length; index2++) {
      if (entries4[index2].key === key)
        push$2(result, entries4[index2].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has2(name) {
    var entries4 = getInternalParamsState(this).entries;
    var length = validateArgumentsLength$1(arguments.length, 1);
    var key = $toString$1(name);
    var $value = length < 2 ? void 0 : arguments[1];
    var value = $value === void 0 ? $value : $toString$1($value);
    var index2 = 0;
    while (index2 < entries4.length) {
      var entry = entries4[index2++];
      if (entry.key === key && (value === void 0 || entry.value === value))
        return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set3(name, value) {
    var state = getInternalParamsState(this);
    validateArgumentsLength$1(arguments.length, 1);
    var entries4 = state.entries;
    var found = false;
    var key = $toString$1(name);
    var val = $toString$1(value);
    var index2 = 0;
    var entry;
    for (; index2 < entries4.length; index2++) {
      entry = entries4[index2];
      if (entry.key === key) {
        if (found)
          splice$1(entries4, index2--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found)
      push$2(entries4, { key, value: val });
    if (!DESCRIPTORS$1)
      this.size = entries4.length;
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort3() {
    var state = getInternalParamsState(this);
    arraySort(state.entries, function(a, b) {
      return a.key > b.key ? 1 : -1;
    });
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach4(callback) {
    var entries4 = getInternalParamsState(this).entries;
    var boundFunction = bind$1(callback, arguments.length > 1 ? arguments[1] : void 0);
    var index2 = 0;
    var entry;
    while (index2 < entries4.length) {
      entry = entries4[index2++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys5() {
    return new URLSearchParamsIterator(this, "keys");
  },
  // `URLSearchParams.prototype.values` method
  values: function values3() {
    return new URLSearchParamsIterator(this, "values");
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries3() {
    return new URLSearchParamsIterator(this, "entries");
  }
}, { enumerable: true });
defineBuiltIn$1(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries, { name: "entries" });
defineBuiltIn$1(URLSearchParamsPrototype, "toString", function toString3() {
  return getInternalParamsState(this).serialize();
}, { enumerable: true });
if (DESCRIPTORS$1)
  defineBuiltInAccessor$1(URLSearchParamsPrototype, "size", {
    get: function size() {
      return getInternalParamsState(this).entries.length;
    },
    configurable: true,
    enumerable: true
  });
setToStringTag$1(URLSearchParamsConstructor, URL_SEARCH_PARAMS);
$$6({ global: true, constructor: true, forced: !USE_NATIVE_URL$1 }, {
  URLSearchParams: URLSearchParamsConstructor
});
if (!USE_NATIVE_URL$1 && isCallable(Headers)) {
  var headersHas = uncurryThis$4(HeadersPrototype.has);
  var headersSet = uncurryThis$4(HeadersPrototype.set);
  var wrapRequestOptions = function(init) {
    if (isObject$2(init)) {
      var body = init.body;
      var headers;
      if (classof(body) === URL_SEARCH_PARAMS) {
        headers = init.headers ? new Headers(init.headers) : new Headers();
        if (!headersHas(headers, "content-type")) {
          headersSet(headers, "content-type", "application/x-www-form-urlencoded;charset=UTF-8");
        }
        return create3(init, {
          body: createPropertyDescriptor(0, $toString$1(body)),
          headers: createPropertyDescriptor(0, headers)
        });
      }
    }
    return init;
  };
  if (isCallable(nativeFetch)) {
    $$6({ global: true, enumerable: true, dontCallGetSet: true, forced: true }, {
      fetch: function fetch(input) {
        return nativeFetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
      }
    });
  }
  if (isCallable(NativeRequest)) {
    var RequestConstructor = function Request(input) {
      anInstance$2(this, RequestPrototype);
      return new NativeRequest(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
    };
    RequestPrototype.constructor = RequestConstructor;
    RequestConstructor.prototype = RequestPrototype;
    $$6({ global: true, constructor: true, dontCallGetSet: true, forced: true }, {
      Request: RequestConstructor
    });
  }
}
var web_urlSearchParams_constructor = {
  URLSearchParams: URLSearchParamsConstructor,
  getState: getInternalParamsState
};
var $$5 = _export;
var DESCRIPTORS = descriptors;
var USE_NATIVE_URL = urlConstructorDetection;
var global$1 = global$D;
var bind2 = functionBindContext;
var uncurryThis$3 = functionUncurryThis;
var defineBuiltIn = defineBuiltIn$f;
var defineBuiltInAccessor = defineBuiltInAccessor$a;
var anInstance$1 = anInstance$8;
var hasOwn$1 = hasOwnProperty_1;
var assign2 = objectAssign;
var arrayFrom = arrayFrom$1;
var arraySlice = arraySlice$9;
var codeAt = stringMultibyte.codeAt;
var toASCII = stringPunycodeToAscii;
var $toString = toString$g;
var setToStringTag = setToStringTag$a;
var validateArgumentsLength = validateArgumentsLength$3;
var URLSearchParamsModule = web_urlSearchParams_constructor;
var InternalStateModule$1 = internalState;
var setInternalState$1 = InternalStateModule$1.set;
var getInternalURLState = InternalStateModule$1.getterFor("URL");
var URLSearchParams$1 = URLSearchParamsModule.URLSearchParams;
var getInternalSearchParamsState = URLSearchParamsModule.getState;
var NativeURL = global$1.URL;
var TypeError$1 = global$1.TypeError;
var parseInt$1 = global$1.parseInt;
var floor = Math.floor;
var pow = Math.pow;
var charAt = uncurryThis$3("".charAt);
var exec = uncurryThis$3(/./.exec);
var join3 = uncurryThis$3([].join);
var numberToString = uncurryThis$3(1 .toString);
var pop = uncurryThis$3([].pop);
var push$1 = uncurryThis$3([].push);
var replace = uncurryThis$3("".replace);
var shift = uncurryThis$3([].shift);
var split = uncurryThis$3("".split);
var stringSlice = uncurryThis$3("".slice);
var toLowerCase = uncurryThis$3("".toLowerCase);
var unshift = uncurryThis$3([].unshift);
var INVALID_AUTHORITY = "Invalid authority";
var INVALID_SCHEME = "Invalid scheme";
var INVALID_HOST = "Invalid host";
var INVALID_PORT = "Invalid port";
var ALPHA = /[a-z]/i;
var ALPHANUMERIC = /[\d+-.a-z]/i;
var DIGIT = /\d/;
var HEX_START = /^0x/i;
var OCT = /^[0-7]+$/;
var DEC = /^\d+$/;
var HEX = /^[\da-f]+$/i;
var FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:<>?@[\\\]^|]/;
var LEADING_C0_CONTROL_OR_SPACE = /^[\u0000-\u0020]+/;
var TRAILING_C0_CONTROL_OR_SPACE = /(^|[^\u0000-\u0020])[\u0000-\u0020]+$/;
var TAB_AND_NEW_LINE = /[\t\n\r]/g;
var EOF;
var parseIPv4 = function(input) {
  var parts = split(input, ".");
  var partsLength, numbers2, index2, part, radix, number, ipv4;
  if (parts.length && parts[parts.length - 1] === "") {
    parts.length--;
  }
  partsLength = parts.length;
  if (partsLength > 4)
    return input;
  numbers2 = [];
  for (index2 = 0; index2 < partsLength; index2++) {
    part = parts[index2];
    if (part === "")
      return input;
    radix = 10;
    if (part.length > 1 && charAt(part, 0) === "0") {
      radix = exec(HEX_START, part) ? 16 : 8;
      part = stringSlice(part, radix === 8 ? 1 : 2);
    }
    if (part === "") {
      number = 0;
    } else {
      if (!exec(radix === 10 ? DEC : radix === 8 ? OCT : HEX, part))
        return input;
      number = parseInt$1(part, radix);
    }
    push$1(numbers2, number);
  }
  for (index2 = 0; index2 < partsLength; index2++) {
    number = numbers2[index2];
    if (index2 === partsLength - 1) {
      if (number >= pow(256, 5 - partsLength))
        return null;
    } else if (number > 255)
      return null;
  }
  ipv4 = pop(numbers2);
  for (index2 = 0; index2 < numbers2.length; index2++) {
    ipv4 += numbers2[index2] * pow(256, 3 - index2);
  }
  return ipv4;
};
var parseIPv6 = function(input) {
  var address = [0, 0, 0, 0, 0, 0, 0, 0];
  var pieceIndex = 0;
  var compress = null;
  var pointer = 0;
  var value, length, numbersSeen, ipv4Piece, number, swaps, swap;
  var chr = function() {
    return charAt(input, pointer);
  };
  if (chr() === ":") {
    if (charAt(input, 1) !== ":")
      return;
    pointer += 2;
    pieceIndex++;
    compress = pieceIndex;
  }
  while (chr()) {
    if (pieceIndex === 8)
      return;
    if (chr() === ":") {
      if (compress !== null)
        return;
      pointer++;
      pieceIndex++;
      compress = pieceIndex;
      continue;
    }
    value = length = 0;
    while (length < 4 && exec(HEX, chr())) {
      value = value * 16 + parseInt$1(chr(), 16);
      pointer++;
      length++;
    }
    if (chr() === ".") {
      if (length === 0)
        return;
      pointer -= length;
      if (pieceIndex > 6)
        return;
      numbersSeen = 0;
      while (chr()) {
        ipv4Piece = null;
        if (numbersSeen > 0) {
          if (chr() === "." && numbersSeen < 4)
            pointer++;
          else
            return;
        }
        if (!exec(DIGIT, chr()))
          return;
        while (exec(DIGIT, chr())) {
          number = parseInt$1(chr(), 10);
          if (ipv4Piece === null)
            ipv4Piece = number;
          else if (ipv4Piece === 0)
            return;
          else
            ipv4Piece = ipv4Piece * 10 + number;
          if (ipv4Piece > 255)
            return;
          pointer++;
        }
        address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
        numbersSeen++;
        if (numbersSeen === 2 || numbersSeen === 4)
          pieceIndex++;
      }
      if (numbersSeen !== 4)
        return;
      break;
    } else if (chr() === ":") {
      pointer++;
      if (!chr())
        return;
    } else if (chr())
      return;
    address[pieceIndex++] = value;
  }
  if (compress !== null) {
    swaps = pieceIndex - compress;
    pieceIndex = 7;
    while (pieceIndex !== 0 && swaps > 0) {
      swap = address[pieceIndex];
      address[pieceIndex--] = address[compress + swaps - 1];
      address[compress + --swaps] = swap;
    }
  } else if (pieceIndex !== 8)
    return;
  return address;
};
var findLongestZeroSequence = function(ipv6) {
  var maxIndex = null;
  var maxLength = 1;
  var currStart = null;
  var currLength = 0;
  var index2 = 0;
  for (; index2 < 8; index2++) {
    if (ipv6[index2] !== 0) {
      if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
      }
      currStart = null;
      currLength = 0;
    } else {
      if (currStart === null)
        currStart = index2;
      ++currLength;
    }
  }
  if (currLength > maxLength) {
    maxIndex = currStart;
    maxLength = currLength;
  }
  return maxIndex;
};
var serializeHost = function(host) {
  var result, index2, compress, ignore0;
  if (typeof host == "number") {
    result = [];
    for (index2 = 0; index2 < 4; index2++) {
      unshift(result, host % 256);
      host = floor(host / 256);
    }
    return join3(result, ".");
  } else if (typeof host == "object") {
    result = "";
    compress = findLongestZeroSequence(host);
    for (index2 = 0; index2 < 8; index2++) {
      if (ignore0 && host[index2] === 0)
        continue;
      if (ignore0)
        ignore0 = false;
      if (compress === index2) {
        result += index2 ? ":" : "::";
        ignore0 = true;
      } else {
        result += numberToString(host[index2], 16);
        if (index2 < 7)
          result += ":";
      }
    }
    return "[" + result + "]";
  }
  return host;
};
var C0ControlPercentEncodeSet = {};
var fragmentPercentEncodeSet = assign2({}, C0ControlPercentEncodeSet, {
  " ": 1,
  '"': 1,
  "<": 1,
  ">": 1,
  "`": 1
});
var pathPercentEncodeSet = assign2({}, fragmentPercentEncodeSet, {
  "#": 1,
  "?": 1,
  "{": 1,
  "}": 1
});
var userinfoPercentEncodeSet = assign2({}, pathPercentEncodeSet, {
  "/": 1,
  ":": 1,
  ";": 1,
  "=": 1,
  "@": 1,
  "[": 1,
  "\\": 1,
  "]": 1,
  "^": 1,
  "|": 1
});
var percentEncode = function(chr, set4) {
  var code = codeAt(chr, 0);
  return code > 32 && code < 127 && !hasOwn$1(set4, chr) ? chr : encodeURIComponent(chr);
};
var specialSchemes = {
  ftp: 21,
  file: null,
  http: 80,
  https: 443,
  ws: 80,
  wss: 443
};
var isWindowsDriveLetter = function(string, normalized) {
  var second;
  return string.length === 2 && exec(ALPHA, charAt(string, 0)) && ((second = charAt(string, 1)) === ":" || !normalized && second === "|");
};
var startsWithWindowsDriveLetter = function(string) {
  var third;
  return string.length > 1 && isWindowsDriveLetter(stringSlice(string, 0, 2)) && (string.length === 2 || ((third = charAt(string, 2)) === "/" || third === "\\" || third === "?" || third === "#"));
};
var isSingleDot = function(segment) {
  return segment === "." || toLowerCase(segment) === "%2e";
};
var isDoubleDot = function(segment) {
  segment = toLowerCase(segment);
  return segment === ".." || segment === "%2e." || segment === ".%2e" || segment === "%2e%2e";
};
var SCHEME_START = {};
var SCHEME = {};
var NO_SCHEME = {};
var SPECIAL_RELATIVE_OR_AUTHORITY = {};
var PATH_OR_AUTHORITY = {};
var RELATIVE = {};
var RELATIVE_SLASH = {};
var SPECIAL_AUTHORITY_SLASHES = {};
var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var AUTHORITY = {};
var HOST = {};
var HOSTNAME = {};
var PORT = {};
var FILE = {};
var FILE_SLASH = {};
var FILE_HOST = {};
var PATH_START = {};
var PATH = {};
var CANNOT_BE_A_BASE_URL_PATH = {};
var QUERY = {};
var FRAGMENT = {};
var URLState = function(url, isBase, base2) {
  var urlString = $toString(url);
  var baseState, failure, searchParams;
  if (isBase) {
    failure = this.parse(urlString);
    if (failure)
      throw new TypeError$1(failure);
    this.searchParams = null;
  } else {
    if (base2 !== void 0)
      baseState = new URLState(base2, true);
    failure = this.parse(urlString, null, baseState);
    if (failure)
      throw new TypeError$1(failure);
    searchParams = getInternalSearchParamsState(new URLSearchParams$1());
    searchParams.bindURL(this);
    this.searchParams = searchParams;
  }
};
URLState.prototype = {
  type: "URL",
  // https://url.spec.whatwg.org/#url-parsing
  // eslint-disable-next-line max-statements -- TODO
  parse: function(input, stateOverride, base2) {
    var url = this;
    var state = stateOverride || SCHEME_START;
    var pointer = 0;
    var buffer = "";
    var seenAt = false;
    var seenBracket = false;
    var seenPasswordToken = false;
    var codePoints, chr, bufferCodePoints, failure;
    input = $toString(input);
    if (!stateOverride) {
      url.scheme = "";
      url.username = "";
      url.password = "";
      url.host = null;
      url.port = null;
      url.path = [];
      url.query = null;
      url.fragment = null;
      url.cannotBeABaseURL = false;
      input = replace(input, LEADING_C0_CONTROL_OR_SPACE, "");
      input = replace(input, TRAILING_C0_CONTROL_OR_SPACE, "$1");
    }
    input = replace(input, TAB_AND_NEW_LINE, "");
    codePoints = arrayFrom(input);
    while (pointer <= codePoints.length) {
      chr = codePoints[pointer];
      switch (state) {
        case SCHEME_START:
          if (chr && exec(ALPHA, chr)) {
            buffer += toLowerCase(chr);
            state = SCHEME;
          } else if (!stateOverride) {
            state = NO_SCHEME;
            continue;
          } else
            return INVALID_SCHEME;
          break;
        case SCHEME:
          if (chr && (exec(ALPHANUMERIC, chr) || chr === "+" || chr === "-" || chr === ".")) {
            buffer += toLowerCase(chr);
          } else if (chr === ":") {
            if (stateOverride && (url.isSpecial() !== hasOwn$1(specialSchemes, buffer) || buffer === "file" && (url.includesCredentials() || url.port !== null) || url.scheme === "file" && !url.host))
              return;
            url.scheme = buffer;
            if (stateOverride) {
              if (url.isSpecial() && specialSchemes[url.scheme] === url.port)
                url.port = null;
              return;
            }
            buffer = "";
            if (url.scheme === "file") {
              state = FILE;
            } else if (url.isSpecial() && base2 && base2.scheme === url.scheme) {
              state = SPECIAL_RELATIVE_OR_AUTHORITY;
            } else if (url.isSpecial()) {
              state = SPECIAL_AUTHORITY_SLASHES;
            } else if (codePoints[pointer + 1] === "/") {
              state = PATH_OR_AUTHORITY;
              pointer++;
            } else {
              url.cannotBeABaseURL = true;
              push$1(url.path, "");
              state = CANNOT_BE_A_BASE_URL_PATH;
            }
          } else if (!stateOverride) {
            buffer = "";
            state = NO_SCHEME;
            pointer = 0;
            continue;
          } else
            return INVALID_SCHEME;
          break;
        case NO_SCHEME:
          if (!base2 || base2.cannotBeABaseURL && chr !== "#")
            return INVALID_SCHEME;
          if (base2.cannotBeABaseURL && chr === "#") {
            url.scheme = base2.scheme;
            url.path = arraySlice(base2.path);
            url.query = base2.query;
            url.fragment = "";
            url.cannotBeABaseURL = true;
            state = FRAGMENT;
            break;
          }
          state = base2.scheme === "file" ? FILE : RELATIVE;
          continue;
        case SPECIAL_RELATIVE_OR_AUTHORITY:
          if (chr === "/" && codePoints[pointer + 1] === "/") {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
            pointer++;
          } else {
            state = RELATIVE;
            continue;
          }
          break;
        case PATH_OR_AUTHORITY:
          if (chr === "/") {
            state = AUTHORITY;
            break;
          } else {
            state = PATH;
            continue;
          }
        case RELATIVE:
          url.scheme = base2.scheme;
          if (chr === EOF) {
            url.username = base2.username;
            url.password = base2.password;
            url.host = base2.host;
            url.port = base2.port;
            url.path = arraySlice(base2.path);
            url.query = base2.query;
          } else if (chr === "/" || chr === "\\" && url.isSpecial()) {
            state = RELATIVE_SLASH;
          } else if (chr === "?") {
            url.username = base2.username;
            url.password = base2.password;
            url.host = base2.host;
            url.port = base2.port;
            url.path = arraySlice(base2.path);
            url.query = "";
            state = QUERY;
          } else if (chr === "#") {
            url.username = base2.username;
            url.password = base2.password;
            url.host = base2.host;
            url.port = base2.port;
            url.path = arraySlice(base2.path);
            url.query = base2.query;
            url.fragment = "";
            state = FRAGMENT;
          } else {
            url.username = base2.username;
            url.password = base2.password;
            url.host = base2.host;
            url.port = base2.port;
            url.path = arraySlice(base2.path);
            url.path.length--;
            state = PATH;
            continue;
          }
          break;
        case RELATIVE_SLASH:
          if (url.isSpecial() && (chr === "/" || chr === "\\")) {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          } else if (chr === "/") {
            state = AUTHORITY;
          } else {
            url.username = base2.username;
            url.password = base2.password;
            url.host = base2.host;
            url.port = base2.port;
            state = PATH;
            continue;
          }
          break;
        case SPECIAL_AUTHORITY_SLASHES:
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          if (chr !== "/" || charAt(buffer, pointer + 1) !== "/")
            continue;
          pointer++;
          break;
        case SPECIAL_AUTHORITY_IGNORE_SLASHES:
          if (chr !== "/" && chr !== "\\") {
            state = AUTHORITY;
            continue;
          }
          break;
        case AUTHORITY:
          if (chr === "@") {
            if (seenAt)
              buffer = "%40" + buffer;
            seenAt = true;
            bufferCodePoints = arrayFrom(buffer);
            for (var i = 0; i < bufferCodePoints.length; i++) {
              var codePoint = bufferCodePoints[i];
              if (codePoint === ":" && !seenPasswordToken) {
                seenPasswordToken = true;
                continue;
              }
              var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
              if (seenPasswordToken)
                url.password += encodedCodePoints;
              else
                url.username += encodedCodePoints;
            }
            buffer = "";
          } else if (chr === EOF || chr === "/" || chr === "?" || chr === "#" || chr === "\\" && url.isSpecial()) {
            if (seenAt && buffer === "")
              return INVALID_AUTHORITY;
            pointer -= arrayFrom(buffer).length + 1;
            buffer = "";
            state = HOST;
          } else
            buffer += chr;
          break;
        case HOST:
        case HOSTNAME:
          if (stateOverride && url.scheme === "file") {
            state = FILE_HOST;
            continue;
          } else if (chr === ":" && !seenBracket) {
            if (buffer === "")
              return INVALID_HOST;
            failure = url.parseHost(buffer);
            if (failure)
              return failure;
            buffer = "";
            state = PORT;
            if (stateOverride === HOSTNAME)
              return;
          } else if (chr === EOF || chr === "/" || chr === "?" || chr === "#" || chr === "\\" && url.isSpecial()) {
            if (url.isSpecial() && buffer === "")
              return INVALID_HOST;
            if (stateOverride && buffer === "" && (url.includesCredentials() || url.port !== null))
              return;
            failure = url.parseHost(buffer);
            if (failure)
              return failure;
            buffer = "";
            state = PATH_START;
            if (stateOverride)
              return;
            continue;
          } else {
            if (chr === "[")
              seenBracket = true;
            else if (chr === "]")
              seenBracket = false;
            buffer += chr;
          }
          break;
        case PORT:
          if (exec(DIGIT, chr)) {
            buffer += chr;
          } else if (chr === EOF || chr === "/" || chr === "?" || chr === "#" || chr === "\\" && url.isSpecial() || stateOverride) {
            if (buffer !== "") {
              var port2 = parseInt$1(buffer, 10);
              if (port2 > 65535)
                return INVALID_PORT;
              url.port = url.isSpecial() && port2 === specialSchemes[url.scheme] ? null : port2;
              buffer = "";
            }
            if (stateOverride)
              return;
            state = PATH_START;
            continue;
          } else
            return INVALID_PORT;
          break;
        case FILE:
          url.scheme = "file";
          if (chr === "/" || chr === "\\")
            state = FILE_SLASH;
          else if (base2 && base2.scheme === "file") {
            switch (chr) {
              case EOF:
                url.host = base2.host;
                url.path = arraySlice(base2.path);
                url.query = base2.query;
                break;
              case "?":
                url.host = base2.host;
                url.path = arraySlice(base2.path);
                url.query = "";
                state = QUERY;
                break;
              case "#":
                url.host = base2.host;
                url.path = arraySlice(base2.path);
                url.query = base2.query;
                url.fragment = "";
                state = FRAGMENT;
                break;
              default:
                if (!startsWithWindowsDriveLetter(join3(arraySlice(codePoints, pointer), ""))) {
                  url.host = base2.host;
                  url.path = arraySlice(base2.path);
                  url.shortenPath();
                }
                state = PATH;
                continue;
            }
          } else {
            state = PATH;
            continue;
          }
          break;
        case FILE_SLASH:
          if (chr === "/" || chr === "\\") {
            state = FILE_HOST;
            break;
          }
          if (base2 && base2.scheme === "file" && !startsWithWindowsDriveLetter(join3(arraySlice(codePoints, pointer), ""))) {
            if (isWindowsDriveLetter(base2.path[0], true))
              push$1(url.path, base2.path[0]);
            else
              url.host = base2.host;
          }
          state = PATH;
          continue;
        case FILE_HOST:
          if (chr === EOF || chr === "/" || chr === "\\" || chr === "?" || chr === "#") {
            if (!stateOverride && isWindowsDriveLetter(buffer)) {
              state = PATH;
            } else if (buffer === "") {
              url.host = "";
              if (stateOverride)
                return;
              state = PATH_START;
            } else {
              failure = url.parseHost(buffer);
              if (failure)
                return failure;
              if (url.host === "localhost")
                url.host = "";
              if (stateOverride)
                return;
              buffer = "";
              state = PATH_START;
            }
            continue;
          } else
            buffer += chr;
          break;
        case PATH_START:
          if (url.isSpecial()) {
            state = PATH;
            if (chr !== "/" && chr !== "\\")
              continue;
          } else if (!stateOverride && chr === "?") {
            url.query = "";
            state = QUERY;
          } else if (!stateOverride && chr === "#") {
            url.fragment = "";
            state = FRAGMENT;
          } else if (chr !== EOF) {
            state = PATH;
            if (chr !== "/")
              continue;
          }
          break;
        case PATH:
          if (chr === EOF || chr === "/" || chr === "\\" && url.isSpecial() || !stateOverride && (chr === "?" || chr === "#")) {
            if (isDoubleDot(buffer)) {
              url.shortenPath();
              if (chr !== "/" && !(chr === "\\" && url.isSpecial())) {
                push$1(url.path, "");
              }
            } else if (isSingleDot(buffer)) {
              if (chr !== "/" && !(chr === "\\" && url.isSpecial())) {
                push$1(url.path, "");
              }
            } else {
              if (url.scheme === "file" && !url.path.length && isWindowsDriveLetter(buffer)) {
                if (url.host)
                  url.host = "";
                buffer = charAt(buffer, 0) + ":";
              }
              push$1(url.path, buffer);
            }
            buffer = "";
            if (url.scheme === "file" && (chr === EOF || chr === "?" || chr === "#")) {
              while (url.path.length > 1 && url.path[0] === "") {
                shift(url.path);
              }
            }
            if (chr === "?") {
              url.query = "";
              state = QUERY;
            } else if (chr === "#") {
              url.fragment = "";
              state = FRAGMENT;
            }
          } else {
            buffer += percentEncode(chr, pathPercentEncodeSet);
          }
          break;
        case CANNOT_BE_A_BASE_URL_PATH:
          if (chr === "?") {
            url.query = "";
            state = QUERY;
          } else if (chr === "#") {
            url.fragment = "";
            state = FRAGMENT;
          } else if (chr !== EOF) {
            url.path[0] += percentEncode(chr, C0ControlPercentEncodeSet);
          }
          break;
        case QUERY:
          if (!stateOverride && chr === "#") {
            url.fragment = "";
            state = FRAGMENT;
          } else if (chr !== EOF) {
            if (chr === "'" && url.isSpecial())
              url.query += "%27";
            else if (chr === "#")
              url.query += "%23";
            else
              url.query += percentEncode(chr, C0ControlPercentEncodeSet);
          }
          break;
        case FRAGMENT:
          if (chr !== EOF)
            url.fragment += percentEncode(chr, fragmentPercentEncodeSet);
          break;
      }
      pointer++;
    }
  },
  // https://url.spec.whatwg.org/#host-parsing
  parseHost: function(input) {
    var result, codePoints, index2;
    if (charAt(input, 0) === "[") {
      if (charAt(input, input.length - 1) !== "]")
        return INVALID_HOST;
      result = parseIPv6(stringSlice(input, 1, -1));
      if (!result)
        return INVALID_HOST;
      this.host = result;
    } else if (!this.isSpecial()) {
      if (exec(FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT, input))
        return INVALID_HOST;
      result = "";
      codePoints = arrayFrom(input);
      for (index2 = 0; index2 < codePoints.length; index2++) {
        result += percentEncode(codePoints[index2], C0ControlPercentEncodeSet);
      }
      this.host = result;
    } else {
      input = toASCII(input);
      if (exec(FORBIDDEN_HOST_CODE_POINT, input))
        return INVALID_HOST;
      result = parseIPv4(input);
      if (result === null)
        return INVALID_HOST;
      this.host = result;
    }
  },
  // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
  cannotHaveUsernamePasswordPort: function() {
    return !this.host || this.cannotBeABaseURL || this.scheme === "file";
  },
  // https://url.spec.whatwg.org/#include-credentials
  includesCredentials: function() {
    return this.username !== "" || this.password !== "";
  },
  // https://url.spec.whatwg.org/#is-special
  isSpecial: function() {
    return hasOwn$1(specialSchemes, this.scheme);
  },
  // https://url.spec.whatwg.org/#shorten-a-urls-path
  shortenPath: function() {
    var path2 = this.path;
    var pathSize = path2.length;
    if (pathSize && (this.scheme !== "file" || pathSize !== 1 || !isWindowsDriveLetter(path2[0], true))) {
      path2.length--;
    }
  },
  // https://url.spec.whatwg.org/#concept-url-serializer
  serialize: function() {
    var url = this;
    var scheme = url.scheme;
    var username = url.username;
    var password = url.password;
    var host = url.host;
    var port2 = url.port;
    var path2 = url.path;
    var query = url.query;
    var fragment = url.fragment;
    var output = scheme + ":";
    if (host !== null) {
      output += "//";
      if (url.includesCredentials()) {
        output += username + (password ? ":" + password : "") + "@";
      }
      output += serializeHost(host);
      if (port2 !== null)
        output += ":" + port2;
    } else if (scheme === "file")
      output += "//";
    output += url.cannotBeABaseURL ? path2[0] : path2.length ? "/" + join3(path2, "/") : "";
    if (query !== null)
      output += "?" + query;
    if (fragment !== null)
      output += "#" + fragment;
    return output;
  },
  // https://url.spec.whatwg.org/#dom-url-href
  setHref: function(href) {
    var failure = this.parse(href);
    if (failure)
      throw new TypeError$1(failure);
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-origin
  getOrigin: function() {
    var scheme = this.scheme;
    var port2 = this.port;
    if (scheme === "blob")
      try {
        return new URLConstructor(scheme.path[0]).origin;
      } catch (error2) {
        return "null";
      }
    if (scheme === "file" || !this.isSpecial())
      return "null";
    return scheme + "://" + serializeHost(this.host) + (port2 !== null ? ":" + port2 : "");
  },
  // https://url.spec.whatwg.org/#dom-url-protocol
  getProtocol: function() {
    return this.scheme + ":";
  },
  setProtocol: function(protocol) {
    this.parse($toString(protocol) + ":", SCHEME_START);
  },
  // https://url.spec.whatwg.org/#dom-url-username
  getUsername: function() {
    return this.username;
  },
  setUsername: function(username) {
    var codePoints = arrayFrom($toString(username));
    if (this.cannotHaveUsernamePasswordPort())
      return;
    this.username = "";
    for (var i = 0; i < codePoints.length; i++) {
      this.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-password
  getPassword: function() {
    return this.password;
  },
  setPassword: function(password) {
    var codePoints = arrayFrom($toString(password));
    if (this.cannotHaveUsernamePasswordPort())
      return;
    this.password = "";
    for (var i = 0; i < codePoints.length; i++) {
      this.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-host
  getHost: function() {
    var host = this.host;
    var port2 = this.port;
    return host === null ? "" : port2 === null ? serializeHost(host) : serializeHost(host) + ":" + port2;
  },
  setHost: function(host) {
    if (this.cannotBeABaseURL)
      return;
    this.parse(host, HOST);
  },
  // https://url.spec.whatwg.org/#dom-url-hostname
  getHostname: function() {
    var host = this.host;
    return host === null ? "" : serializeHost(host);
  },
  setHostname: function(hostname) {
    if (this.cannotBeABaseURL)
      return;
    this.parse(hostname, HOSTNAME);
  },
  // https://url.spec.whatwg.org/#dom-url-port
  getPort: function() {
    var port2 = this.port;
    return port2 === null ? "" : $toString(port2);
  },
  setPort: function(port2) {
    if (this.cannotHaveUsernamePasswordPort())
      return;
    port2 = $toString(port2);
    if (port2 === "")
      this.port = null;
    else
      this.parse(port2, PORT);
  },
  // https://url.spec.whatwg.org/#dom-url-pathname
  getPathname: function() {
    var path2 = this.path;
    return this.cannotBeABaseURL ? path2[0] : path2.length ? "/" + join3(path2, "/") : "";
  },
  setPathname: function(pathname) {
    if (this.cannotBeABaseURL)
      return;
    this.path = [];
    this.parse(pathname, PATH_START);
  },
  // https://url.spec.whatwg.org/#dom-url-search
  getSearch: function() {
    var query = this.query;
    return query ? "?" + query : "";
  },
  setSearch: function(search) {
    search = $toString(search);
    if (search === "") {
      this.query = null;
    } else {
      if (charAt(search, 0) === "?")
        search = stringSlice(search, 1);
      this.query = "";
      this.parse(search, QUERY);
    }
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-searchparams
  getSearchParams: function() {
    return this.searchParams.facade;
  },
  // https://url.spec.whatwg.org/#dom-url-hash
  getHash: function() {
    var fragment = this.fragment;
    return fragment ? "#" + fragment : "";
  },
  setHash: function(hash) {
    hash = $toString(hash);
    if (hash === "") {
      this.fragment = null;
      return;
    }
    if (charAt(hash, 0) === "#")
      hash = stringSlice(hash, 1);
    this.fragment = "";
    this.parse(hash, FRAGMENT);
  },
  update: function() {
    this.query = this.searchParams.serialize() || null;
  }
};
var URLConstructor = function URL2(url) {
  var that = anInstance$1(this, URLPrototype);
  var base2 = validateArgumentsLength(arguments.length, 1) > 1 ? arguments[1] : void 0;
  var state = setInternalState$1(that, new URLState(url, false, base2));
  if (!DESCRIPTORS) {
    that.href = state.serialize();
    that.origin = state.getOrigin();
    that.protocol = state.getProtocol();
    that.username = state.getUsername();
    that.password = state.getPassword();
    that.host = state.getHost();
    that.hostname = state.getHostname();
    that.port = state.getPort();
    that.pathname = state.getPathname();
    that.search = state.getSearch();
    that.searchParams = state.getSearchParams();
    that.hash = state.getHash();
  }
};
var URLPrototype = URLConstructor.prototype;
var accessorDescriptor = function(getter, setter) {
  return {
    get: function() {
      return getInternalURLState(this)[getter]();
    },
    set: setter && function(value) {
      return getInternalURLState(this)[setter](value);
    },
    configurable: true,
    enumerable: true
  };
};
if (DESCRIPTORS) {
  defineBuiltInAccessor(URLPrototype, "href", accessorDescriptor("serialize", "setHref"));
  defineBuiltInAccessor(URLPrototype, "origin", accessorDescriptor("getOrigin"));
  defineBuiltInAccessor(URLPrototype, "protocol", accessorDescriptor("getProtocol", "setProtocol"));
  defineBuiltInAccessor(URLPrototype, "username", accessorDescriptor("getUsername", "setUsername"));
  defineBuiltInAccessor(URLPrototype, "password", accessorDescriptor("getPassword", "setPassword"));
  defineBuiltInAccessor(URLPrototype, "host", accessorDescriptor("getHost", "setHost"));
  defineBuiltInAccessor(URLPrototype, "hostname", accessorDescriptor("getHostname", "setHostname"));
  defineBuiltInAccessor(URLPrototype, "port", accessorDescriptor("getPort", "setPort"));
  defineBuiltInAccessor(URLPrototype, "pathname", accessorDescriptor("getPathname", "setPathname"));
  defineBuiltInAccessor(URLPrototype, "search", accessorDescriptor("getSearch", "setSearch"));
  defineBuiltInAccessor(URLPrototype, "searchParams", accessorDescriptor("getSearchParams"));
  defineBuiltInAccessor(URLPrototype, "hash", accessorDescriptor("getHash", "setHash"));
}
defineBuiltIn(URLPrototype, "toJSON", function toJSON() {
  return getInternalURLState(this).serialize();
}, { enumerable: true });
defineBuiltIn(URLPrototype, "toString", function toString4() {
  return getInternalURLState(this).serialize();
}, { enumerable: true });
if (NativeURL) {
  var nativeCreateObjectURL = NativeURL.createObjectURL;
  var nativeRevokeObjectURL = NativeURL.revokeObjectURL;
  if (nativeCreateObjectURL)
    defineBuiltIn(URLConstructor, "createObjectURL", bind2(nativeCreateObjectURL, NativeURL));
  if (nativeRevokeObjectURL)
    defineBuiltIn(URLConstructor, "revokeObjectURL", bind2(nativeRevokeObjectURL, NativeURL));
}
setToStringTag(URLConstructor, "URL");
$$5({ global: true, constructor: true, forced: !USE_NATIVE_URL, sham: !DESCRIPTORS }, {
  URL: URLConstructor
});
/*
@license
Copyright (c) 2018, Twilio, Inc.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY
SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION
OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN
CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.

*/
(function(exports) {
  var global2 = typeof global2 !== "undefined" ? global2 : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {};
  Object.defineProperty(exports, "__esModule", { value: true });
  var _classCallCheck2 = classCallCheckExports;
  var _createClass2 = createClassExports;
  var _inherits2 = inheritsExports;
  var _possibleConstructorReturn2 = possibleConstructorReturnExports;
  var _getPrototypeOf2 = getPrototypeOfExports;
  var _wrapNativeSuper2 = wrapNativeSuperExports;
  var _defineProperty2 = definePropertyExports;
  var _asyncToGenerator2 = asyncToGeneratorExports;
  var _regeneratorRuntime2 = regenerator;
  var _typeof2 = _typeofExports;
  var log$22 = loglevelExports$1;
  var operationRetrier2 = browser$7;
  var declarativeTypeValidator2 = browser$9;
  function _interopDefaultLegacy2(e) {
    return e && typeof e === "object" && "default" in e ? e : { "default": e };
  }
  function _interopNamespace2(e) {
    if (e && e.__esModule)
      return e;
    var n = /* @__PURE__ */ Object.create(null);
    if (e) {
      Object.keys(e).forEach(function(k) {
        if (k !== "default") {
          var d = Object.getOwnPropertyDescriptor(e, k);
          Object.defineProperty(n, k, d.get ? d : {
            enumerable: true,
            get: function() {
              return e[k];
            }
          });
        }
      });
    }
    n["default"] = e;
    return Object.freeze(n);
  }
  var _classCallCheck__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_classCallCheck2);
  var _createClass__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_createClass2);
  var _inherits__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_inherits2);
  var _possibleConstructorReturn__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_possibleConstructorReturn2);
  var _getPrototypeOf__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_getPrototypeOf2);
  var _wrapNativeSuper__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_wrapNativeSuper2);
  var _defineProperty__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_defineProperty2);
  var _asyncToGenerator__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_asyncToGenerator2);
  var _regeneratorRuntime__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_regeneratorRuntime2);
  var _typeof__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_typeof2);
  var log__namespace = /* @__PURE__ */ _interopNamespace2(log$22);
  var rngBrowser2 = { exports: {} };
  var getRandomValues2 = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
  if (getRandomValues2) {
    var rnds8 = new Uint8Array(16);
    rngBrowser2.exports = function whatwgRNG() {
      getRandomValues2(rnds8);
      return rnds8;
    };
  } else {
    var rnds = new Array(16);
    rngBrowser2.exports = function mathRNG() {
      for (var i2 = 0, r; i2 < 16; i2++) {
        if ((i2 & 3) === 0)
          r = Math.random() * 4294967296;
        rnds[i2] = r >>> ((i2 & 3) << 3) & 255;
      }
      return rnds;
    };
  }
  var byteToHex2 = [];
  for (var i = 0; i < 256; ++i) {
    byteToHex2[i] = (i + 256).toString(16).substr(1);
  }
  function bytesToUuid$22(buf, offset) {
    var i2 = offset || 0;
    var bth = byteToHex2;
    return [bth[buf[i2++]], bth[buf[i2++]], bth[buf[i2++]], bth[buf[i2++]], "-", bth[buf[i2++]], bth[buf[i2++]], "-", bth[buf[i2++]], bth[buf[i2++]], "-", bth[buf[i2++]], bth[buf[i2++]], "-", bth[buf[i2++]], bth[buf[i2++]], bth[buf[i2++]], bth[buf[i2++]], bth[buf[i2++]], bth[buf[i2++]]].join("");
  }
  var bytesToUuid_12 = bytesToUuid$22;
  var rng$12 = rngBrowser2.exports;
  var bytesToUuid$12 = bytesToUuid_12;
  var _nodeId2;
  var _clockseq2;
  var _lastMSecs2 = 0;
  var _lastNSecs2 = 0;
  function v1$12(options, buf, offset) {
    var i2 = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node2 = options.node || _nodeId2;
    var clockseq = options.clockseq !== void 0 ? options.clockseq : _clockseq2;
    if (node2 == null || clockseq == null) {
      var seedBytes = rng$12();
      if (node2 == null) {
        node2 = _nodeId2 = [seedBytes[0] | 1, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
      }
      if (clockseq == null) {
        clockseq = _clockseq2 = (seedBytes[6] << 8 | seedBytes[7]) & 16383;
      }
    }
    var msecs = options.msecs !== void 0 ? options.msecs : (/* @__PURE__ */ new Date()).getTime();
    var nsecs = options.nsecs !== void 0 ? options.nsecs : _lastNSecs2 + 1;
    var dt = msecs - _lastMSecs2 + (nsecs - _lastNSecs2) / 1e4;
    if (dt < 0 && options.clockseq === void 0) {
      clockseq = clockseq + 1 & 16383;
    }
    if ((dt < 0 || msecs > _lastMSecs2) && options.nsecs === void 0) {
      nsecs = 0;
    }
    if (nsecs >= 1e4) {
      throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    }
    _lastMSecs2 = msecs;
    _lastNSecs2 = nsecs;
    _clockseq2 = clockseq;
    msecs += 122192928e5;
    var tl = ((msecs & 268435455) * 1e4 + nsecs) % 4294967296;
    b[i2++] = tl >>> 24 & 255;
    b[i2++] = tl >>> 16 & 255;
    b[i2++] = tl >>> 8 & 255;
    b[i2++] = tl & 255;
    var tmh = msecs / 4294967296 * 1e4 & 268435455;
    b[i2++] = tmh >>> 8 & 255;
    b[i2++] = tmh & 255;
    b[i2++] = tmh >>> 24 & 15 | 16;
    b[i2++] = tmh >>> 16 & 255;
    b[i2++] = clockseq >>> 8 | 128;
    b[i2++] = clockseq & 255;
    for (var n = 0; n < 6; ++n) {
      b[i2 + n] = node2[n];
    }
    return buf ? buf : bytesToUuid$12(b);
  }
  var v1_12 = v1$12;
  var rng2 = rngBrowser2.exports;
  var bytesToUuid2 = bytesToUuid_12;
  function v4$12(options, buf, offset) {
    var i2 = buf && offset || 0;
    if (typeof options == "string") {
      buf = options === "binary" ? new Array(16) : null;
      options = null;
    }
    options = options || {};
    var rnds2 = options.random || (options.rng || rng2)();
    rnds2[6] = rnds2[6] & 15 | 64;
    rnds2[8] = rnds2[8] & 63 | 128;
    if (buf) {
      for (var ii = 0; ii < 16; ++ii) {
        buf[i2 + ii] = rnds2[ii];
      }
    }
    return buf || bytesToUuid2(rnds2);
  }
  var v4_12 = v4$12;
  var v12 = v1_12;
  var v42 = v4_12;
  var uuid2 = v42;
  uuid2.v1 = v12;
  uuid2.v4 = v42;
  var uuid_12 = uuid2;
  function _createSuper$12(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$12();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf__default2["default"](Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf__default2["default"](this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn__default2["default"](this, result);
    };
  }
  function _isNativeReflectConstruct$12() {
    if (typeof Reflect === "undefined" || !Reflect.construct)
      return false;
    if (Reflect.construct.sham)
      return false;
    if (typeof Proxy === "function")
      return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  var CancellablePromise = /* @__PURE__ */ function(_Promise) {
    _inherits__default2["default"](CancellablePromise2, _Promise);
    var _super = _createSuper$12(CancellablePromise2);
    function CancellablePromise2(executor) {
      var _this;
      _classCallCheck__default2["default"](this, CancellablePromise2);
      var outerId = uuid_12.v4();
      var outerRejectPromise;
      _this = _super.call(this, function(resolve2, reject2) {
        outerRejectPromise = reject2;
        return executor(function(value) {
          CancellablePromise2.cancellationMap.delete(outerId);
          resolve2(value);
        }, function(reason) {
          CancellablePromise2.cancellationMap.delete(outerId);
          reject2(reason);
        }, function(cancellationFunction) {
          CancellablePromise2.cancellationMap.set(outerId, cancellationFunction);
        });
      });
      _this.id = outerId;
      _this.rejectPromise = outerRejectPromise;
      return _this;
    }
    _createClass__default2["default"](CancellablePromise2, [{
      key: "cancel",
      value: function cancel() {
        var onCancel = CancellablePromise2.cancellationMap.get(this.id);
        onCancel === null || onCancel === void 0 ? void 0 : onCancel();
        if (this.rejectPromise) {
          this.catch(function() {
            return void 0;
          });
          this.rejectPromise(new Error("Promise was cancelled"));
        }
        return this;
      }
    }]);
    return CancellablePromise2;
  }(/* @__PURE__ */ _wrapNativeSuper__default2["default"](Promise));
  _defineProperty__default2["default"](CancellablePromise, "cancellationMap", /* @__PURE__ */ new Map());
  function __decorate2(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof__default2["default"](Reflect)) === "object" && typeof Reflect.decorate === "function")
      r = Reflect.decorate(decorators, target, key, desc);
    else
      for (var i2 = decorators.length - 1; i2 >= 0; i2--) {
        if (d = decorators[i2])
          r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
      }
    return c > 3 && r && Object.defineProperty(target, key, r), r;
  }
  function __metadata2(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof__default2["default"](Reflect)) === "object" && typeof Reflect.metadata === "function")
      return Reflect.metadata(metadataKey, metadataValue);
  }
  function prepareLine2(prefix, args) {
    return ["".concat((/* @__PURE__ */ new Date()).toISOString(), " MCS Client ").concat(prefix, ":")].concat(Array.from(args));
  }
  var Logger = /* @__PURE__ */ function() {
    function Logger2(prefix) {
      _classCallCheck__default2["default"](this, Logger2);
      _defineProperty__default2["default"](this, "prefix", "");
      this.prefix = prefix !== null && prefix !== void 0 && prefix.length > 0 ? prefix + " " : "";
    }
    _createClass__default2["default"](Logger2, [{
      key: "setLevel",
      value: function setLevel2(level) {
        log__namespace.setLevel(level);
      }
    }, {
      key: "trace",
      value: (
        /* eslint-disable @typescript-eslint/explicit-module-boundary-types */
        function trace2() {
          if (log__namespace.getLevel() == log__namespace.levels.TRACE) {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            log__namespace.debug.apply(null, prepareLine2(this.prefix + "T", args));
          }
        }
      )
    }, {
      key: "debug",
      value: function debug3() {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        log__namespace.debug.apply(null, prepareLine2(this.prefix + "D", args));
      }
    }, {
      key: "info",
      value: function info2() {
        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }
        log__namespace.info.apply(null, prepareLine2(this.prefix + "I", args));
      }
    }, {
      key: "warn",
      value: function warn2() {
        for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          args[_key4] = arguments[_key4];
        }
        log__namespace.warn.apply(null, prepareLine2(this.prefix + "W", args));
      }
    }, {
      key: "error",
      value: function error2() {
        for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
          args[_key5] = arguments[_key5];
        }
        log__namespace.error.apply(null, prepareLine2(this.prefix + "E", args));
      }
    }], [{
      key: "scope",
      value: function scope(prefix) {
        return new Logger2(prefix);
      }
    }, {
      key: "setLevel",
      value: function setLevel2(level) {
        log__namespace.setLevel(level);
      }
    }, {
      key: "trace",
      value: function trace2() {
        if (log__namespace.getLevel() == log__namespace.levels.TRACE) {
          for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
            args[_key6] = arguments[_key6];
          }
          log__namespace.debug.apply(null, prepareLine2("T", args));
        }
      }
    }, {
      key: "debug",
      value: function debug3() {
        for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
          args[_key7] = arguments[_key7];
        }
        log__namespace.debug.apply(null, prepareLine2("D", args));
      }
    }, {
      key: "info",
      value: function info2() {
        for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
          args[_key8] = arguments[_key8];
        }
        log__namespace.info.apply(null, prepareLine2("I", args));
      }
    }, {
      key: "warn",
      value: function warn2() {
        for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
          args[_key9] = arguments[_key9];
        }
        log__namespace.warn.apply(null, prepareLine2("W", args));
      }
    }, {
      key: "error",
      value: function error2() {
        for (var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
          args[_key10] = arguments[_key10];
        }
        log__namespace.error.apply(null, prepareLine2("E", args));
      }
    }]);
    return Logger2;
  }();
  var MINIMUM_RETRY_DELAY2 = 1e3;
  var MAXIMUM_RETRY_DELAY2 = 4e3;
  var MAXIMUM_ATTEMPTS_COUNT = 3;
  var RETRY_WHEN_THROTTLED = true;
  var regionalMcsHost = function regionalMcsHost2(region) {
    return "https://mcs.".concat(region !== null && region !== void 0 ? region : "us1", ".twilio.com");
  };
  var isFullUrl = function isFullUrl2(url) {
    return url.startsWith("http");
  };
  var fullUrl = function fullUrl2(partUrl, region) {
    return "".concat(!isFullUrl(partUrl) ? regionalMcsHost(region) : "").concat(partUrl);
  };
  var Configuration2 = /* @__PURE__ */ function() {
    function Configuration3(token, baseUrl, baseSetUrl, options) {
      var _ref, _options$MCS, _ref2, _constructorOptions$r, _constructorOptions$r2, _constructorOptions$b;
      _classCallCheck__default2["default"](this, Configuration3);
      var constructorOptions = (_ref = (_options$MCS = options.MCS) !== null && _options$MCS !== void 0 ? _options$MCS : options) !== null && _ref !== void 0 ? _ref : {};
      this.region = (_ref2 = (_constructorOptions$r = constructorOptions.region) !== null && _constructorOptions$r !== void 0 ? _constructorOptions$r : options.region) !== null && _ref2 !== void 0 ? _ref2 : "us1";
      this.mediaUrl = fullUrl(baseUrl, this.region);
      this.mediaSetUrl = baseSetUrl ? fullUrl(baseSetUrl) : "".concat(this.mediaUrl, "Set");
      this.token = token;
      this.retryWhenThrottledOverride = (_constructorOptions$r2 = constructorOptions.retryWhenThrottledOverride) !== null && _constructorOptions$r2 !== void 0 ? _constructorOptions$r2 : RETRY_WHEN_THROTTLED;
      this.backoffConfigOverride = (_constructorOptions$b = constructorOptions.backoffConfigOverride) !== null && _constructorOptions$b !== void 0 ? _constructorOptions$b : Configuration3.backoffConfigDefault;
    }
    _createClass__default2["default"](Configuration3, [{
      key: "updateToken",
      value: function updateToken(token) {
        this.token = token;
      }
    }], [{
      key: "backoffConfigDefault",
      get: function get3() {
        return {
          min: MINIMUM_RETRY_DELAY2,
          max: MAXIMUM_RETRY_DELAY2,
          maxAttemptsCount: MAXIMUM_ATTEMPTS_COUNT
        };
      }
    }, {
      key: "retryWhenThrottledDefault",
      get: function get3() {
        return RETRY_WHEN_THROTTLED;
      }
    }]);
    return Configuration3;
  }();
  var Media = /* @__PURE__ */ function() {
    function Media2(config, network, data2) {
      _classCallCheck__default2["default"](this, Media2);
      this.config = config;
      this.network = network;
      this._update(data2);
    }
    _createClass__default2["default"](Media2, [{
      key: "sid",
      get: function get3() {
        return this.state.sid;
      }
    }, {
      key: "serviceSid",
      get: function get3() {
        return this.state.serviceSid;
      }
    }, {
      key: "dateCreated",
      get: function get3() {
        return this.state.dateCreated;
      }
    }, {
      key: "dateUpdated",
      get: function get3() {
        return this.state.dateUpdated;
      }
    }, {
      key: "contentType",
      get: function get3() {
        return this.state.contentType;
      }
    }, {
      key: "size",
      get: function get3() {
        return this.state.size;
      }
      /** @deprecated Use filename instead */
    }, {
      key: "fileName",
      get: function get3() {
        return this.state.filename;
      }
    }, {
      key: "filename",
      get: function get3() {
        return this.state.filename;
      }
    }, {
      key: "category",
      get: function get3() {
        return this.state.category;
      }
      /**
       * Returns direct content URL to uploaded binary. This URL will expire after some time.
       * This function gets a new URL every time, preventing it from expiring but putting additional load on backend.
       * See getCachedContentUrl() for a function that reduces the amount of network requests.
       *
       * It is reasonable to build your own refresh logic upon these two functions: as soon as URL returned
       * by getCachedContentUrl() returns 40x status you should call getContentUrl() to refresh it.
       */
    }, {
      key: "getContentUrl",
      value: function getContentUrl() {
        var _this = this;
        return new CancellablePromise(/* @__PURE__ */ function() {
          var _ref = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee(resolve2, reject2, onCancel) {
            var request, response;
            return _regeneratorRuntime__default2["default"].wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    request = _this.network.get("".concat(_this.config.mediaUrl, "/").concat(_this.sid));
                    onCancel(function() {
                      return request.cancel();
                    });
                    _context.prev = 2;
                    _context.next = 5;
                    return request;
                  case 5:
                    response = _context.sent;
                    _this._update(response.body);
                    resolve2(_this.state.contentDirectUrl);
                    _context.next = 13;
                    break;
                  case 10:
                    _context.prev = 10;
                    _context.t0 = _context["catch"](2);
                    reject2(_context.t0);
                  case 13:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, null, [[2, 10]]);
          }));
          return function(_x, _x2, _x3) {
            return _ref.apply(this, arguments);
          };
        }());
      }
    }, {
      key: "_update",
      value: function _update(data2) {
        var _data$links$content_d, _data$filename, _data$category, _data$is_multipart_up;
        this.state = {
          sid: data2.sid,
          serviceSid: data2.service_sid,
          channelSid: data2.channel_sid,
          messageSid: data2.message_sid,
          dateCreated: data2.date_created ? new Date(data2.date_created) : null,
          dateUploadUpdated: data2.date_upload_updated ? new Date(data2.date_upload_updated) : null,
          dateUpdated: data2.date_updated ? new Date(data2.date_updated) : null,
          size: data2.size,
          contentType: data2.content_type,
          author: data2.author,
          url: data2.url,
          contentUrl: data2.links.content,
          contentDirectUrl: (_data$links$content_d = data2.links.content_direct_temporary) !== null && _data$links$content_d !== void 0 ? _data$links$content_d : null,
          filename: (_data$filename = data2.filename) !== null && _data$filename !== void 0 ? _data$filename : null,
          category: (_data$category = data2.category) !== null && _data$category !== void 0 ? _data$category : "media",
          isMultipartUpstream: (_data$is_multipart_up = data2.is_multipart_upstream) !== null && _data$is_multipart_up !== void 0 ? _data$is_multipart_up : false
        };
      }
      /**
       * @internal
       * This payload is compatible with Conversations' media object _state().
       */
    }, {
      key: "_state",
      value: function _state() {
        var _this$state$filename;
        return {
          sid: this.state.sid,
          category: this.state.category,
          filename: (_this$state$filename = this.state.filename) !== null && _this$state$filename !== void 0 ? _this$state$filename : null,
          contentType: this.state.contentType,
          size: this.state.size
        };
      }
    }]);
    return Media2;
  }();
  function _createSuper2(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct2();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf__default2["default"](Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf__default2["default"](this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn__default2["default"](this, result);
    };
  }
  function _isNativeReflectConstruct2() {
    if (typeof Reflect === "undefined" || !Reflect.construct)
      return false;
    if (Reflect.construct.sham)
      return false;
    if (typeof Proxy === "function")
      return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  var TransportError = /* @__PURE__ */ function(_Error) {
    _inherits__default2["default"](TransportError2, _Error);
    var _super = _createSuper2(TransportError2);
    function TransportError2(message, code, body, status, headers) {
      var _this;
      _classCallCheck__default2["default"](this, TransportError2);
      _this = _super.call(this, message);
      _this.code = code;
      _this.body = body;
      _this.status = status;
      _this.headers = headers;
      return _this;
    }
    return _createClass__default2["default"](TransportError2);
  }(/* @__PURE__ */ _wrapNativeSuper__default2["default"](Error));
  var XHR = global2["XMLHttpRequest"] || {};
  function parseResponseHeaders(headerString) {
    if (!headerString) {
      return {};
    }
    return headerString.split("\r\n").map(function(el) {
      return el.split(": ");
    }).filter(function(el) {
      return el.length === 2 && el[1].length > 0;
    }).reduce(function(prev, curr) {
      prev[curr[0]] = curr[1];
      return prev;
    }, {});
  }
  function extractBody(xhr) {
    var contentType = xhr.getResponseHeader("Content-Type");
    if (!contentType || contentType.indexOf("application/json") !== 0 || xhr.responseText.length === 0) {
      return xhr.responseText;
    }
    try {
      return JSON.parse(xhr.responseText);
    } catch (e) {
      return xhr.responseText;
    }
  }
  var Transport = /* @__PURE__ */ function() {
    function Transport2() {
      _classCallCheck__default2["default"](this, Transport2);
    }
    _createClass__default2["default"](Transport2, [{
      key: "get",
      value: (
        /**
         * Make a GET request by given URL
         */
        function get3(url, headers) {
          return Transport2.request("GET", url, headers);
        }
      )
      /**
       * Make a POST request by given URL
       */
    }, {
      key: "post",
      value: function post(url, headers, body) {
        return Transport2.request("POST", url, headers, body);
      }
    }], [{
      key: "request",
      value: function request(method, url, headers, body) {
        return new CancellablePromise(function(resolve2, reject2, onCancel) {
          var xhr = new XHR();
          var isCancelled = false;
          onCancel(function() {
            xhr.abort();
            isCancelled = true;
          });
          xhr.open(method, url, true);
          xhr.onreadystatechange = function onreadystatechange() {
            if (xhr.readyState !== 4 || isCancelled) {
              return;
            }
            var responseHeaders = parseResponseHeaders(xhr.getAllResponseHeaders());
            var body2 = extractBody(xhr);
            if (200 <= xhr.status && xhr.status < 300) {
              resolve2({
                status: xhr.status,
                headers: responseHeaders,
                body: body2
              });
            } else {
              var _xhr$statusText;
              var status = (_xhr$statusText = xhr.statusText) !== null && _xhr$statusText !== void 0 ? _xhr$statusText : "NONE";
              var bodyRepresentation;
              if (typeof body2 === "string") {
                if (body2 && body2.split("\n", 2).length === 1)
                  bodyRepresentation = body2;
                else {
                  var _body$replace$split$f;
                  var errorInfo = (_body$replace$split$f = body2.replace(/<.*?>/g, "").split(/\r\n/g).filter(function(str) {
                    return str.length;
                  })[0]) === null || _body$replace$split$f === void 0 ? void 0 : _body$replace$split$f.split(" ");
                  bodyRepresentation = (errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.length) > 2 ? errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.slice(1).join(" ") : "";
                }
              } else {
                bodyRepresentation = JSON.stringify(body2);
              }
              var message = "".concat(xhr.status, ": [").concat(status, "] ").concat(bodyRepresentation);
              reject2(new TransportError(message, xhr.status, body2, status, responseHeaders));
            }
          };
          for (var headerName in headers) {
            xhr.setRequestHeader(headerName, headers[headerName]);
            if (headerName === "Content-Type" && headers[headerName] === "application/json") {
              body = JSON.stringify(body);
            }
          }
          xhr.send(body);
        });
      }
    }]);
    return Transport2;
  }();
  var log$12 = Logger.scope("Network");
  var Network = /* @__PURE__ */ function() {
    function Network2(config, transport) {
      _classCallCheck__default2["default"](this, Network2);
      this.config = config;
      this.transport = transport;
    }
    _createClass__default2["default"](Network2, [{
      key: "backoffConfig",
      value: function backoffConfig() {
        return Object.assign(Configuration2.backoffConfigDefault, this.config.backoffConfigOverride);
      }
    }, {
      key: "retryWhenThrottled",
      value: function retryWhenThrottled() {
        var _ref, _this$config$retryWhe;
        return (_ref = (_this$config$retryWhe = this.config.retryWhenThrottledOverride) !== null && _this$config$retryWhe !== void 0 ? _this$config$retryWhe : Configuration2.retryWhenThrottledDefault) !== null && _ref !== void 0 ? _ref : false;
      }
    }, {
      key: "executeWithRetry",
      value: function executeWithRetry(request, retryWhenThrottled) {
        var _this = this;
        return new CancellablePromise(/* @__PURE__ */ function() {
          var _ref2 = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee2(resolve2, reject2, onCancel) {
            var retrier, codesToRetryOn;
            return _regeneratorRuntime__default2["default"].wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    retrier = new operationRetrier2.Retrier(_this.backoffConfig());
                    codesToRetryOn = [502, 503, 504];
                    if (retryWhenThrottled) {
                      codesToRetryOn.push(429);
                    }
                    onCancel(function() {
                      retrier.cancel();
                      retrier.removeAllListeners();
                    });
                    retrier.on("attempt", /* @__PURE__ */ _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee() {
                      var requestPromise, result;
                      return _regeneratorRuntime__default2["default"].wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              _context.prev = 0;
                              requestPromise = request();
                              onCancel(function() {
                                requestPromise.cancel();
                                retrier.cancel();
                                retrier.removeAllListeners();
                              });
                              _context.next = 5;
                              return requestPromise;
                            case 5:
                              result = _context.sent;
                              retrier.succeeded(result);
                              _context.next = 12;
                              break;
                            case 9:
                              _context.prev = 9;
                              _context.t0 = _context["catch"](0);
                              if (codesToRetryOn.indexOf(_context.t0.status) > -1) {
                                retrier.failed(_context.t0);
                              } else if (_context.t0.message === "Twilsock disconnected") {
                                retrier.failed(_context.t0);
                              } else {
                                retrier.removeAllListeners();
                                retrier.cancel();
                                reject2(_context.t0);
                              }
                            case 12:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee, null, [[0, 9]]);
                    })));
                    retrier.on("succeeded", function(result) {
                      resolve2(result);
                    });
                    retrier.on("cancelled", function(err) {
                      return reject2(err);
                    });
                    retrier.on("failed", function(err) {
                      return reject2(err);
                    });
                    retrier.start();
                  case 9:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));
          return function(_x, _x2, _x3) {
            return _ref2.apply(this, arguments);
          };
        }());
      }
    }, {
      key: "get",
      value: function get3(url) {
        var _this2 = this;
        return new CancellablePromise(/* @__PURE__ */ function() {
          var _ref4 = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee3(resolve2, reject2, onCancel) {
            var headers, request, response;
            return _regeneratorRuntime__default2["default"].wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    headers = {
                      "X-Twilio-Token": _this2.config.token
                    };
                    request = _this2.executeWithRetry(function() {
                      return _this2.transport.get(url, headers);
                    }, _this2.retryWhenThrottled());
                    log$12.trace("sending GET request to ", url, " headers ", headers);
                    onCancel(function() {
                      return request.cancel();
                    });
                    _context3.prev = 4;
                    _context3.next = 7;
                    return request;
                  case 7:
                    response = _context3.sent;
                    log$12.trace("response", response);
                    resolve2(response);
                    _context3.next = 16;
                    break;
                  case 12:
                    _context3.prev = 12;
                    _context3.t0 = _context3["catch"](4);
                    log$12.debug("get() error ".concat(_context3.t0));
                    reject2(_context3.t0);
                  case 16:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3, null, [[4, 12]]);
          }));
          return function(_x4, _x5, _x6) {
            return _ref4.apply(this, arguments);
          };
        }());
      }
    }, {
      key: "post",
      value: function post(url, category, media, contentType, filename) {
        var _this3 = this;
        var headers = {
          "X-Twilio-Token": this.config.token
        };
        if ((typeof FormData === "undefined" || !(media instanceof FormData)) && contentType) {
          Object.assign(headers, {
            "Content-Type": contentType
          });
        }
        var fullUrl2 = new URL(url);
        if (category) {
          fullUrl2.searchParams.append("Category", category);
        }
        if (filename) {
          fullUrl2.searchParams.append("Filename", filename);
        }
        return new CancellablePromise(/* @__PURE__ */ function() {
          var _ref5 = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee4(resolve2, reject2, onCancel) {
            var request, response;
            return _regeneratorRuntime__default2["default"].wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    request = _this3.transport.post(fullUrl2.href, headers, media);
                    onCancel(function() {
                      return request.cancel();
                    });
                    log$12.trace("sending POST request to ".concat(url, " with headers ").concat(headers));
                    _context4.prev = 3;
                    _context4.next = 6;
                    return request;
                  case 6:
                    response = _context4.sent;
                    _context4.next = 17;
                    break;
                  case 9:
                    _context4.prev = 9;
                    _context4.t0 = _context4["catch"](3);
                    if (!(global2["XMLHttpRequest"] === void 0 && media instanceof FormData)) {
                      _context4.next = 14;
                      break;
                    }
                    reject2(new TypeError("Posting FormData supported only with browser engine's FormData"));
                    return _context4.abrupt("return");
                  case 14:
                    log$12.debug("post() error ".concat(_context4.t0));
                    reject2(_context4.t0);
                    return _context4.abrupt("return");
                  case 17:
                    log$12.trace("response", response);
                    resolve2(response);
                  case 19:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4, null, [[3, 9]]);
          }));
          return function(_x7, _x8, _x9) {
            return _ref5.apply(this, arguments);
          };
        }());
      }
    }]);
    return Network2;
  }();
  var version2 = "0.6.7";
  var _class;
  var log2 = Logger.scope("");
  exports["default"] = (_class = /* @__PURE__ */ function() {
    function Client2(token, baseUrl, baseSetUrl) {
      var _this$options$logLeve, _this$options$transpo;
      var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      _classCallCheck__default2["default"](this, Client2);
      this.options = options;
      this.options.logLevel = (_this$options$logLeve = this.options.logLevel) !== null && _this$options$logLeve !== void 0 ? _this$options$logLeve : "silent";
      this.config = new Configuration2(token, baseUrl, baseSetUrl, this.options);
      log2.setLevel(this.options.logLevel);
      this.options.transport = (_this$options$transpo = this.options.transport) !== null && _this$options$transpo !== void 0 ? _this$options$transpo : new Transport();
      this.transport = this.options.transport;
      this.network = new Network(this.config, this.transport);
    }
    _createClass__default2["default"](Client2, [{
      key: "updateToken",
      value: function updateToken(token) {
        log2.info("updateToken");
        this.config.updateToken(token);
      }
      /**
       * Gets media from media service
       * @param {String} sid - Media's SID
       */
    }, {
      key: "get",
      value: function get3(sid) {
        var _this = this;
        return new CancellablePromise(/* @__PURE__ */ function() {
          var _ref = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee(resolve2, reject2, onCancel) {
            var request, response;
            return _regeneratorRuntime__default2["default"].wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    request = _this.network.get("".concat(_this.config.mediaUrl, "/").concat(sid));
                    onCancel(function() {
                      return request.cancel();
                    });
                    _context.prev = 2;
                    _context.next = 5;
                    return request;
                  case 5:
                    response = _context.sent;
                    resolve2(new Media(_this.config, _this.network, response.body));
                    _context.next = 12;
                    break;
                  case 9:
                    _context.prev = 9;
                    _context.t0 = _context["catch"](2);
                    reject2(_context.t0);
                  case 12:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, null, [[2, 9]]);
          }));
          return function(_x, _x2, _x3) {
            return _ref.apply(this, arguments);
          };
        }());
      }
      /**
       * Posts raw content to media service
       * @param {String} contentType - content type of media
       * @param {String|Buffer|Blob} media - content to post
       * @param {MediaCategory|null} category - category for the media
       */
    }, {
      key: "post",
      value: function post(contentType, media, category, filename) {
        var _this2 = this;
        return new CancellablePromise(/* @__PURE__ */ function() {
          var _ref2 = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee2(resolve2, reject2, onCancel) {
            var request, response;
            return _regeneratorRuntime__default2["default"].wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    request = _this2.network.post(_this2.config.mediaUrl, category !== null && category !== void 0 ? category : "media", media, contentType, filename);
                    onCancel(function() {
                      return request.cancel();
                    });
                    _context2.prev = 2;
                    _context2.next = 5;
                    return request;
                  case 5:
                    response = _context2.sent;
                    resolve2(new Media(_this2.config, _this2.network, response.body));
                    _context2.next = 12;
                    break;
                  case 9:
                    _context2.prev = 9;
                    _context2.t0 = _context2["catch"](2);
                    reject2(_context2.t0);
                  case 12:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, null, [[2, 9]]);
          }));
          return function(_x4, _x5, _x6) {
            return _ref2.apply(this, arguments);
          };
        }());
      }
      /**
       * Posts FormData to media service. Can be used only with browser engine's FormData.
       * In non-browser FormData case the method will do promise reject with
       * new TypeError("Posting FormData supported only with browser engine's FormData")
       * @param {FormData} formData - form data to post
       * @param {MediaCategory|null} category - category for the media
       */
    }, {
      key: "postFormData",
      value: function postFormData(formData, category) {
        var _this3 = this;
        return new CancellablePromise(/* @__PURE__ */ function() {
          var _ref3 = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee3(resolve2, reject2, onCancel) {
            var request, response;
            return _regeneratorRuntime__default2["default"].wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    request = _this3.network.post(_this3.config.mediaUrl, category !== null && category !== void 0 ? category : "media", formData);
                    onCancel(function() {
                      return request.cancel();
                    });
                    _context3.prev = 2;
                    _context3.next = 5;
                    return request;
                  case 5:
                    response = _context3.sent;
                    resolve2(new Media(_this3.config, _this3.network, response.body));
                    _context3.next = 12;
                    break;
                  case 9:
                    _context3.prev = 9;
                    _context3.t0 = _context3["catch"](2);
                    reject2(_context3.t0);
                  case 12:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3, null, [[2, 9]]);
          }));
          return function(_x7, _x8, _x9) {
            return _ref3.apply(this, arguments);
          };
        }());
      }
      /**
       * Retrieve information about multiple media SIDs at the same time.
       * @param mediaSids Array of Media SIDs to get information from.
       */
    }, {
      key: "mediaSetGet",
      value: function mediaSetGet(mediaSids) {
        var _this4 = this;
        return new CancellablePromise(/* @__PURE__ */ function() {
          var _ref4 = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee4(resolve2, reject2, onCancel) {
            var query, request, response, media;
            return _regeneratorRuntime__default2["default"].wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    query = {
                      command: "get",
                      list: mediaSids.map(function(sid) {
                        return {
                          media_sid: sid
                        };
                      })
                    };
                    request = _this4.network.post("".concat(_this4.config.mediaSetUrl), null, query, "application/json");
                    onCancel(function() {
                      return request.cancel();
                    });
                    _context4.prev = 3;
                    _context4.next = 6;
                    return request;
                  case 6:
                    response = _context4.sent;
                    media = response.body.map(function(item) {
                      if (item.code !== 200) {
                        reject2("Failed to obtain detailed information about Media items (failed SID ".concat(item.media_record.sid, ")"));
                        return;
                      }
                      return new Media(_this4.config, _this4.network, item.media_record);
                    });
                    resolve2(media);
                    _context4.next = 14;
                    break;
                  case 11:
                    _context4.prev = 11;
                    _context4.t0 = _context4["catch"](3);
                    reject2(_context4.t0);
                  case 14:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4, null, [[3, 11]]);
          }));
          return function(_x10, _x11, _x12) {
            return _ref4.apply(this, arguments);
          };
        }());
      }
      /**
       * Retrieve temporary URLs for a set of media SIDs.
       * @param mediaSids array of the media SIDs to get URLs from.
       */
    }, {
      key: "mediaSetGetContentUrls",
      value: function mediaSetGetContentUrls(mediaSids) {
        var _this5 = this;
        return new CancellablePromise(/* @__PURE__ */ function() {
          var _ref5 = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee5(resolve2, reject2, onCancel) {
            var query, request, response, urls;
            return _regeneratorRuntime__default2["default"].wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    query = {
                      command: "get",
                      list: mediaSids.map(function(sid) {
                        return {
                          media_sid: sid
                        };
                      })
                    };
                    request = _this5.network.post("".concat(_this5.config.mediaSetUrl), null, query, "application/json");
                    onCancel(function() {
                      return request.cancel();
                    });
                    _context5.prev = 3;
                    _context5.next = 6;
                    return request;
                  case 6:
                    response = _context5.sent;
                    urls = /* @__PURE__ */ new Map();
                    response.body.forEach(function(item) {
                      if (item.code !== 200) {
                        reject2("Failed to obtain detailed information about Media items (failed SID ".concat(item.media_record.sid, ")"));
                        return;
                      }
                      urls.set(item.media_record.sid, item.media_record.links.content_direct_temporary);
                    });
                    resolve2(urls);
                    _context5.next = 15;
                    break;
                  case 12:
                    _context5.prev = 12;
                    _context5.t0 = _context5["catch"](3);
                    reject2(_context5.t0);
                  case 15:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5, null, [[3, 12]]);
          }));
          return function(_x13, _x14, _x15) {
            return _ref5.apply(this, arguments);
          };
        }());
      }
    }]);
    return Client2;
  }(), _defineProperty__default2["default"](_class, "version", version2), _class);
  __decorate2([declarativeTypeValidator2.validateTypes(declarativeTypeValidator2.nonEmptyString), __metadata2("design:type", Function), __metadata2("design:paramtypes", [String]), __metadata2("design:returntype", void 0)], exports["default"].prototype, "updateToken", null);
  __decorate2([declarativeTypeValidator2.validateTypesAsync(declarativeTypeValidator2.nonEmptyString), __metadata2("design:type", Function), __metadata2("design:paramtypes", [String]), __metadata2("design:returntype", CancellablePromise)], exports["default"].prototype, "get", null);
  exports["default"] = __decorate2([declarativeTypeValidator2.validateConstructorTypes(declarativeTypeValidator2.nonEmptyString, declarativeTypeValidator2.nonEmptyString, [declarativeTypeValidator2.nonEmptyString, declarativeTypeValidator2.literal(null)], [declarativeTypeValidator2.pureObject, "undefined"]), __metadata2("design:paramtypes", [String, String, Object, Object])], exports["default"]);
  exports.CancellablePromise = CancellablePromise;
  exports.Client = exports["default"];
  exports.McsClient = exports["default"];
  exports.McsMedia = Media;
  exports.Media = Media;
})(browser$1);
var ArrayBufferViewCore = arrayBufferViewCore;
var lengthOfArrayLike$1 = lengthOfArrayLike$g;
var toIntegerOrInfinity = toIntegerOrInfinity$a;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
exportTypedArrayMethod("at", function at(index2) {
  var O = aTypedArray(this);
  var len = lengthOfArrayLike$1(O);
  var relativeIndex = toIntegerOrInfinity(index2);
  var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
  return k < 0 || k >= len ? void 0 : O[k];
});
var $$4 = _export;
var global = global$D;
var arrayBufferModule = arrayBuffer;
var setSpecies = setSpecies$4;
var ARRAY_BUFFER = "ArrayBuffer";
var ArrayBuffer$1 = arrayBufferModule[ARRAY_BUFFER];
var NativeArrayBuffer = global[ARRAY_BUFFER];
$$4({ global: true, constructor: true, forced: NativeArrayBuffer !== ArrayBuffer$1 }, {
  ArrayBuffer: ArrayBuffer$1
});
setSpecies(ARRAY_BUFFER);
var $$3 = _export;
var uncurryThis$2 = functionUncurryThis;
var aCallable = aCallable$c;
var toObject = toObject$f;
var lengthOfArrayLike = lengthOfArrayLike$g;
var deletePropertyOrThrow = deletePropertyOrThrow$3;
var toString$1 = toString$g;
var fails$1 = fails$M;
var internalSort = arraySort$1;
var arrayMethodIsStrict = arrayMethodIsStrict$4;
var FF = engineFfVersion;
var IE_OR_EDGE = engineIsIeOrEdge;
var V8 = engineV8Version;
var WEBKIT = engineWebkitVersion;
var test = [];
var nativeSort = uncurryThis$2(test.sort);
var push = uncurryThis$2(test.push);
var FAILS_ON_UNDEFINED = fails$1(function() {
  test.sort(void 0);
});
var FAILS_ON_NULL = fails$1(function() {
  test.sort(null);
});
var STRICT_METHOD = arrayMethodIsStrict("sort");
var STABLE_SORT = !fails$1(function() {
  if (V8)
    return V8 < 70;
  if (FF && FF > 3)
    return;
  if (IE_OR_EDGE)
    return true;
  if (WEBKIT)
    return WEBKIT < 603;
  var result = "";
  var code, chr, value, index2;
  for (code = 65; code < 76; code++) {
    chr = String.fromCharCode(code);
    switch (code) {
      case 66:
      case 69:
      case 70:
      case 72:
        value = 3;
        break;
      case 68:
      case 71:
        value = 4;
        break;
      default:
        value = 2;
    }
    for (index2 = 0; index2 < 47; index2++) {
      test.push({ k: chr + index2, v: value });
    }
  }
  test.sort(function(a, b) {
    return b.v - a.v;
  });
  for (index2 = 0; index2 < test.length; index2++) {
    chr = test[index2].k.charAt(0);
    if (result.charAt(result.length - 1) !== chr)
      result += chr;
  }
  return result !== "DGBEFHACIJK";
});
var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;
var getSortCompare = function(comparefn) {
  return function(x, y) {
    if (y === void 0)
      return -1;
    if (x === void 0)
      return 1;
    if (comparefn !== void 0)
      return +comparefn(x, y) || 0;
    return toString$1(x) > toString$1(y) ? 1 : -1;
  };
};
$$3({ target: "Array", proto: true, forced: FORCED }, {
  sort: function sort4(comparefn) {
    if (comparefn !== void 0)
      aCallable(comparefn);
    var array5 = toObject(this);
    if (STABLE_SORT)
      return comparefn === void 0 ? nativeSort(array5) : nativeSort(array5, comparefn);
    var items = [];
    var arrayLength = lengthOfArrayLike(array5);
    var itemsLength, index2;
    for (index2 = 0; index2 < arrayLength; index2++) {
      if (index2 in array5)
        push(items, array5[index2]);
    }
    internalSort(items, getSortCompare(comparefn));
    itemsLength = lengthOfArrayLike(items);
    index2 = 0;
    while (index2 < itemsLength)
      array5[index2] = items[index2++];
    while (index2 < arrayLength)
      deletePropertyOrThrow(array5, index2++);
    return array5;
  }
});
var $$2 = _export;
var uncurryThis$1 = functionUncurryThis;
var notARegExp = notARegexp;
var requireObjectCoercible = requireObjectCoercible$b;
var toString5 = toString$g;
var correctIsRegExpLogic = correctIsRegexpLogic;
var stringIndexOf = uncurryThis$1("".indexOf);
$$2({ target: "String", proto: true, forced: !correctIsRegExpLogic("includes") }, {
  includes: function includes3(searchString) {
    return !!~stringIndexOf(
      toString5(requireObjectCoercible(this)),
      toString5(notARegExp(searchString)),
      arguments.length > 1 ? arguments[1] : void 0
    );
  }
});
var uncurryThis = functionUncurryThis;
var defineBuiltIns = defineBuiltIns$4;
var getWeakData = internalMetadataExports.getWeakData;
var anInstance = anInstance$8;
var anObject = anObject$m;
var isNullOrUndefined = isNullOrUndefined$b;
var isObject$1 = isObject$q;
var iterate = iterate$5;
var ArrayIterationModule = arrayIteration;
var hasOwn2 = hasOwnProperty_1;
var InternalStateModule = internalState;
var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;
var find2 = ArrayIterationModule.find;
var findIndex2 = ArrayIterationModule.findIndex;
var splice2 = uncurryThis([].splice);
var id = 0;
var uncaughtFrozenStore = function(state) {
  return state.frozen || (state.frozen = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function() {
  this.entries = [];
};
var findUncaughtFrozen = function(store, key) {
  return find2(store.entries, function(it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function(key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry)
      return entry[1];
  },
  has: function(key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function(key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry)
      entry[1] = value;
    else
      this.entries.push([key, value]);
  },
  "delete": function(key) {
    var index2 = findIndex2(this.entries, function(it) {
      return it[0] === key;
    });
    if (~index2)
      splice2(this.entries, index2, 1);
    return !!~index2;
  }
};
var collectionWeak$1 = {
  getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var Constructor2 = wrapper(function(that, iterable) {
      anInstance(that, Prototype2);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        id: id++,
        frozen: void 0
      });
      if (!isNullOrUndefined(iterable))
        iterate(iterable, that[ADDER], { that, AS_ENTRIES: IS_MAP });
    });
    var Prototype2 = Constructor2.prototype;
    var getInternalState2 = internalStateGetterFor(CONSTRUCTOR_NAME);
    var define = function(that, key, value) {
      var state = getInternalState2(that);
      var data2 = getWeakData(anObject(key), true);
      if (data2 === true)
        uncaughtFrozenStore(state).set(key, value);
      else
        data2[state.id] = value;
      return that;
    };
    defineBuiltIns(Prototype2, {
      // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
      // https://tc39.es/ecma262/#sec-weakset.prototype.delete
      "delete": function(key) {
        var state = getInternalState2(this);
        if (!isObject$1(key))
          return false;
        var data2 = getWeakData(key);
        if (data2 === true)
          return uncaughtFrozenStore(state)["delete"](key);
        return data2 && hasOwn2(data2, state.id) && delete data2[state.id];
      },
      // `{ WeakMap, WeakSet }.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.has
      // https://tc39.es/ecma262/#sec-weakset.prototype.has
      has: function has3(key) {
        var state = getInternalState2(this);
        if (!isObject$1(key))
          return false;
        var data2 = getWeakData(key);
        if (data2 === true)
          return uncaughtFrozenStore(state).has(key);
        return data2 && hasOwn2(data2, state.id);
      }
    });
    defineBuiltIns(Prototype2, IS_MAP ? {
      // `WeakMap.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.get
      get: function get3(key) {
        var state = getInternalState2(this);
        if (isObject$1(key)) {
          var data2 = getWeakData(key);
          if (data2 === true)
            return uncaughtFrozenStore(state).get(key);
          return data2 ? data2[state.id] : void 0;
        }
      },
      // `WeakMap.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.set
      set: function set4(key, value) {
        return define(this, key, value);
      }
    } : {
      // `WeakSet.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-weakset.prototype.add
      add: function add(value) {
        return define(this, value, true);
      }
    });
    return Constructor2;
  }
};
var collection = collection$3;
var collectionWeak = collectionWeak$1;
collection("WeakSet", function(init) {
  return function WeakSet2() {
    return init(this, arguments.length ? arguments[0] : void 0);
  };
}, collectionWeak);
var browser = {};
var loglevel = { exports: {} };
loglevel.exports;
(function(module) {
  (function(root, definition) {
    if (module.exports) {
      module.exports = definition();
    } else {
      root.log = definition();
    }
  })(commonjsGlobal, function() {
    var noop2 = function() {
    };
    var undefinedType = "undefined";
    var isIE = typeof window !== undefinedType && typeof window.navigator !== undefinedType && /Trident\/|MSIE /.test(window.navigator.userAgent);
    var logMethods = [
      "trace",
      "debug",
      "info",
      "warn",
      "error"
    ];
    function bindMethod(obj, methodName) {
      var method = obj[methodName];
      if (typeof method.bind === "function") {
        return method.bind(obj);
      } else {
        try {
          return Function.prototype.bind.call(method, obj);
        } catch (e) {
          return function() {
            return Function.prototype.apply.apply(method, [obj, arguments]);
          };
        }
      }
    }
    function traceForIE() {
      if (console.log) {
        if (console.log.apply) {
          console.log.apply(console, arguments);
        } else {
          Function.prototype.apply.apply(console.log, [console, arguments]);
        }
      }
      if (console.trace)
        console.trace();
    }
    function realMethod(methodName) {
      if (methodName === "debug") {
        methodName = "log";
      }
      if (typeof console === undefinedType) {
        return false;
      } else if (methodName === "trace" && isIE) {
        return traceForIE;
      } else if (console[methodName] !== void 0) {
        return bindMethod(console, methodName);
      } else if (console.log !== void 0) {
        return bindMethod(console, "log");
      } else {
        return noop2;
      }
    }
    function replaceLoggingMethods(level, loggerName) {
      for (var i = 0; i < logMethods.length; i++) {
        var methodName = logMethods[i];
        this[methodName] = i < level ? noop2 : this.methodFactory(methodName, level, loggerName);
      }
      this.log = this.debug;
    }
    function enableLoggingWhenConsoleArrives(methodName, level, loggerName) {
      return function() {
        if (typeof console !== undefinedType) {
          replaceLoggingMethods.call(this, level, loggerName);
          this[methodName].apply(this, arguments);
        }
      };
    }
    function defaultMethodFactory(methodName, level, loggerName) {
      return realMethod(methodName) || enableLoggingWhenConsoleArrives.apply(this, arguments);
    }
    function Logger(name, defaultLevel, factory) {
      var self2 = this;
      var currentLevel;
      defaultLevel = defaultLevel == null ? "WARN" : defaultLevel;
      var storageKey = "loglevel";
      if (typeof name === "string") {
        storageKey += ":" + name;
      } else if (typeof name === "symbol") {
        storageKey = void 0;
      }
      function persistLevelIfPossible(levelNum) {
        var levelName = (logMethods[levelNum] || "silent").toUpperCase();
        if (typeof window === undefinedType || !storageKey)
          return;
        try {
          window.localStorage[storageKey] = levelName;
          return;
        } catch (ignore) {
        }
        try {
          window.document.cookie = encodeURIComponent(storageKey) + "=" + levelName + ";";
        } catch (ignore) {
        }
      }
      function getPersistedLevel() {
        var storedLevel;
        if (typeof window === undefinedType || !storageKey)
          return;
        try {
          storedLevel = window.localStorage[storageKey];
        } catch (ignore) {
        }
        if (typeof storedLevel === undefinedType) {
          try {
            var cookie = window.document.cookie;
            var location = cookie.indexOf(
              encodeURIComponent(storageKey) + "="
            );
            if (location !== -1) {
              storedLevel = /^([^;]+)/.exec(cookie.slice(location))[1];
            }
          } catch (ignore) {
          }
        }
        if (self2.levels[storedLevel] === void 0) {
          storedLevel = void 0;
        }
        return storedLevel;
      }
      function clearPersistedLevel() {
        if (typeof window === undefinedType || !storageKey)
          return;
        try {
          window.localStorage.removeItem(storageKey);
          return;
        } catch (ignore) {
        }
        try {
          window.document.cookie = encodeURIComponent(storageKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
        } catch (ignore) {
        }
      }
      self2.name = name;
      self2.levels = {
        "TRACE": 0,
        "DEBUG": 1,
        "INFO": 2,
        "WARN": 3,
        "ERROR": 4,
        "SILENT": 5
      };
      self2.methodFactory = factory || defaultMethodFactory;
      self2.getLevel = function() {
        return currentLevel;
      };
      self2.setLevel = function(level, persist) {
        if (typeof level === "string" && self2.levels[level.toUpperCase()] !== void 0) {
          level = self2.levels[level.toUpperCase()];
        }
        if (typeof level === "number" && level >= 0 && level <= self2.levels.SILENT) {
          currentLevel = level;
          if (persist !== false) {
            persistLevelIfPossible(level);
          }
          replaceLoggingMethods.call(self2, level, name);
          if (typeof console === undefinedType && level < self2.levels.SILENT) {
            return "No console available for logging";
          }
        } else {
          throw "log.setLevel() called with invalid level: " + level;
        }
      };
      self2.setDefaultLevel = function(level) {
        defaultLevel = level;
        if (!getPersistedLevel()) {
          self2.setLevel(level, false);
        }
      };
      self2.resetLevel = function() {
        self2.setLevel(defaultLevel, false);
        clearPersistedLevel();
      };
      self2.enableAll = function(persist) {
        self2.setLevel(self2.levels.TRACE, persist);
      };
      self2.disableAll = function(persist) {
        self2.setLevel(self2.levels.SILENT, persist);
      };
      var initialLevel = getPersistedLevel();
      if (initialLevel == null) {
        initialLevel = defaultLevel;
      }
      self2.setLevel(initialLevel, false);
    }
    var defaultLogger = new Logger();
    var _loggersByName = {};
    defaultLogger.getLogger = function getLogger(name) {
      if (typeof name !== "symbol" && typeof name !== "string" || name === "") {
        throw new TypeError("You must supply a name when creating a logger.");
      }
      var logger = _loggersByName[name];
      if (!logger) {
        logger = _loggersByName[name] = new Logger(
          name,
          defaultLogger.getLevel(),
          defaultLogger.methodFactory
        );
      }
      return logger;
    };
    var _log = typeof window !== undefinedType ? window.log : void 0;
    defaultLogger.noConflict = function() {
      if (typeof window !== undefinedType && window.log === defaultLogger) {
        window.log = _log;
      }
      return defaultLogger;
    };
    defaultLogger.getLoggers = function getLoggers() {
      return _loggersByName;
    };
    defaultLogger["default"] = defaultLogger;
    return defaultLogger;
  });
})(loglevel);
var loglevelExports = loglevel.exports;
/*
@license
Copyright (c) 2022 Twilio Inc.

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.


*/
Object.defineProperty(browser, "__esModule", { value: true });
var log = loglevelExports;
function _interopDefaultLegacy(e) {
  return e && typeof e === "object" && "default" in e ? e : { "default": e };
}
var log__default = /* @__PURE__ */ _interopDefaultLegacy(log);
var deprecated = function deprecated2(oldName, newName, link) {
  return function(target, propertyKey, descriptor) {
    if (typeof descriptor.value !== "function" && (descriptor === null || descriptor === void 0 ? void 0 : descriptor.get) === void 0) {
      throw new Error("The deprecated decorator can only be applied to methods or getters");
    }
    if (typeof descriptor.value === "function") {
      var originalMethod = descriptor.value;
      descriptor.value = function() {
        deprecationWarning("The method ".concat(oldName, " is deprecated").concat(newName ? ", use " + newName + " instead" : "").concat(link ? ", " + link : "."));
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return originalMethod.apply(this, args);
      };
      return;
    }
    var originalGet = descriptor.get;
    descriptor.get = function() {
      deprecationWarning("The getter ".concat(oldName, " is deprecated").concat(newName ? ", use " + newName + " instead" : "").concat(link ? ", " + link : "."));
      return originalGet === null || originalGet === void 0 ? void 0 : originalGet.apply(this);
    };
  };
};
var deprecationWarning = function deprecationWarning2(warning) {
  var currentLevel = log__default["default"].getLevel();
  log__default["default"].setLevel("warn");
  log__default["default"].warn(warning);
  log__default["default"].setLevel(currentLevel);
};
browser.deprecated = deprecated;
browser.deprecationWarning = deprecationWarning;
var $$1 = _export;
var $find = arrayIteration.find;
var addToUnscopables = addToUnscopables$3;
var FIND = "find";
var SKIPS_HOLES = true;
if (FIND in [])
  Array(1)[FIND](function() {
    SKIPS_HOLES = false;
  });
$$1({ target: "Array", proto: true, forced: SKIPS_HOLES }, {
  find: function find3(callbackfn) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : void 0);
  }
});
addToUnscopables(FIND);
var $ = _export;
var FREEZING = freezing;
var fails = fails$M;
var isObject = isObject$q;
var onFreeze = internalMetadataExports.onFreeze;
var $freeze = Object.freeze;
var FAILS_ON_PRIMITIVES = fails(function() {
  $freeze(1);
});
$({ target: "Object", stat: true, forced: FAILS_ON_PRIMITIVES, sham: !FREEZING }, {
  freeze: function freeze(it) {
    return $freeze && isObject(it) ? $freeze(onFreeze(it)) : it;
  }
});
(function(exports) {
  var global2 = typeof global2 !== "undefined" ? global2 : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {};
  Object.defineProperty(exports, "__esModule", { value: true });
  var _asyncToGenerator2 = asyncToGeneratorExports;
  var _assertThisInitialized2 = assertThisInitializedExports;
  var _inherits2 = inheritsExports;
  var _possibleConstructorReturn2 = possibleConstructorReturnExports;
  var _getPrototypeOf2 = getPrototypeOfExports;
  var _defineProperty2 = definePropertyExports;
  var _createClass2 = createClassExports;
  var _classCallCheck2 = classCallCheckExports;
  var _regeneratorRuntime2 = regenerator;
  var _typeof2 = _typeofExports;
  var loglevelLog2 = loglevelExports$1;
  var iso8601Duration = require$$25;
  var declarativeTypeValidator2 = browser$9;
  var _toConsumableArray2 = toConsumableArrayExports;
  var replayEventEmitter = browser$8;
  var isEqual = lodash_isequalExports;
  var _slicedToArray2 = slicedToArrayExports;
  var operationRetrier2 = browser$7;
  var twilsock2 = browser$6;
  var notifications = browser$4;
  var twilioSync = browser$3;
  var mcsClient = browser$1;
  var deprecationDecorator = browser;
  var _wrapNativeSuper2 = wrapNativeSuperExports;
  var uuid2 = uuid_1;
  function _interopDefaultLegacy2(e) {
    return e && typeof e === "object" && "default" in e ? e : { "default": e };
  }
  function _interopNamespace2(e) {
    if (e && e.__esModule)
      return e;
    var n = /* @__PURE__ */ Object.create(null);
    if (e) {
      Object.keys(e).forEach(function(k) {
        if (k !== "default") {
          var d = Object.getOwnPropertyDescriptor(e, k);
          Object.defineProperty(n, k, d.get ? d : {
            enumerable: true,
            get: function() {
              return e[k];
            }
          });
        }
      });
    }
    n["default"] = e;
    return Object.freeze(n);
  }
  var _asyncToGenerator__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_asyncToGenerator2);
  var _assertThisInitialized__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_assertThisInitialized2);
  var _inherits__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_inherits2);
  var _possibleConstructorReturn__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_possibleConstructorReturn2);
  var _getPrototypeOf__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_getPrototypeOf2);
  var _defineProperty__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_defineProperty2);
  var _createClass__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_createClass2);
  var _classCallCheck__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_classCallCheck2);
  var _regeneratorRuntime__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_regeneratorRuntime2);
  var _typeof__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_typeof2);
  var loglevelLog__namespace2 = /* @__PURE__ */ _interopNamespace2(loglevelLog2);
  var _toConsumableArray__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_toConsumableArray2);
  var isEqual__default = /* @__PURE__ */ _interopDefaultLegacy2(isEqual);
  var _slicedToArray__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_slicedToArray2);
  var _wrapNativeSuper__default2 = /* @__PURE__ */ _interopDefaultLegacy2(_wrapNativeSuper2);
  function __decorate2(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof__default2["default"](Reflect)) === "object" && typeof Reflect.decorate === "function")
      r = Reflect.decorate(decorators, target, key, desc);
    else
      for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i])
          r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
      }
    return c > 3 && r && Object.defineProperty(target, key, r), r;
  }
  function __metadata2(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof__default2["default"](Reflect)) === "object" && typeof Reflect.metadata === "function")
      return Reflect.metadata(metadataKey, metadataValue);
  }
  function prepareLine2(prefix, args) {
    return ["".concat((/* @__PURE__ */ new Date()).toISOString(), " Conversations ").concat(prefix, ":")].concat(Array.from(args));
  }
  var log$7 = loglevelLog__namespace2.getLogger("twilio-conversations");
  var Logger = /* @__PURE__ */ function() {
    function Logger2(prefix) {
      _classCallCheck__default2["default"](this, Logger2);
      _defineProperty__default2["default"](this, "prefix", "");
      this.prefix = prefix !== null && prefix !== void 0 && prefix.length > 0 ? prefix + " " : "";
    }
    _createClass__default2["default"](Logger2, [{
      key: "setLevel",
      value: function setLevel2(level) {
        log$7.setLevel(level);
      }
    }, {
      key: "trace",
      value: function trace2() {
        if (log$7.getLevel() == log$7.levels.TRACE) {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          log$7.debug.apply(null, prepareLine2(this.prefix + "T", args));
        }
      }
    }, {
      key: "debug",
      value: function debug3() {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        log$7.debug.apply(null, prepareLine2(this.prefix + "D", args));
      }
    }, {
      key: "info",
      value: function info2() {
        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }
        log$7.info.apply(null, prepareLine2(this.prefix + "I", args));
      }
    }, {
      key: "warn",
      value: function warn2() {
        for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          args[_key4] = arguments[_key4];
        }
        log$7.warn.apply(null, prepareLine2(this.prefix + "W", args));
      }
    }, {
      key: "error",
      value: function error2() {
        for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
          args[_key5] = arguments[_key5];
        }
        log$7.error.apply(null, prepareLine2(this.prefix + "E", args));
      }
    }], [{
      key: "scope",
      value: function scope(prefix) {
        return new Logger2(prefix);
      }
    }, {
      key: "setLevel",
      value: function setLevel2(level) {
        log$7.setLevel(level);
      }
    }, {
      key: "trace",
      value: function trace2() {
        if (log$7.getLevel() == log$7.levels.TRACE) {
          for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
            args[_key6] = arguments[_key6];
          }
          log$7.debug.apply(null, prepareLine2("T", args));
        }
      }
    }, {
      key: "debug",
      value: function debug3() {
        for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
          args[_key7] = arguments[_key7];
        }
        log$7.debug.apply(null, prepareLine2("D", args));
      }
    }, {
      key: "info",
      value: function info2() {
        for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
          args[_key8] = arguments[_key8];
        }
        log$7.info.apply(null, prepareLine2("I", args));
      }
    }, {
      key: "warn",
      value: function warn2() {
        for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
          args[_key9] = arguments[_key9];
        }
        log$7.warn.apply(null, prepareLine2("W", args));
      }
    }, {
      key: "error",
      value: function error2() {
        for (var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
          args[_key10] = arguments[_key10];
        }
        log$7.error.apply(null, prepareLine2("E", args));
      }
    }]);
    return Logger2;
  }();
  function ownKeys$5(object, enumerableOnly) {
    var keys6 = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys6.push.apply(keys6, symbols);
    }
    return keys6;
  }
  function _objectSpread$5(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$5(Object(source), true).forEach(function(key) {
        _defineProperty__default2["default"](target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var TYPING_TIMEOUT = 5;
  var HTTP_CACHE_LIFETIME = "PT5S";
  var CONSUMPTION_HORIZON_SENDING_INTERVAL = "PT5S";
  var USER_INFOS_TO_SUBSCRIBE = 100;
  var MINIMUM_RETRY_DELAY2 = 1e3;
  var MAXIMUM_RETRY_DELAY2 = 4e3;
  var MAXIMUM_ATTEMPTS_COUNT = 3;
  var RETRY_WHEN_THROTTLED = true;
  var CHANNEL_METADATA_CACHE_CAPACITY = 100;
  var MESSAGE_RECIPIENTS_CACHE_CAPACITY = 1e3;
  var Configuration2 = /* @__PURE__ */ _createClass__default2["default"](function Configuration3() {
    var _ref, _constructorOptions$u, _ref2, _constructorOptions$h, _ref3, _constructorOptions$c, _options$channelMetad, _options$messageRecip;
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var configurationResponse = arguments.length > 1 ? arguments[1] : void 0;
    var logger = arguments.length > 2 ? arguments[2] : void 0;
    _classCallCheck__default2["default"](this, Configuration3);
    _defineProperty__default2["default"](this, "typingIndicatorTimeoutDefault", TYPING_TIMEOUT * 1e3);
    var constructorOptions = options.Chat || options.IPMessaging || options || {};
    this.productId = constructorOptions.productId;
    this.links = {
      myConversations: configurationResponse.links.my_conversations,
      conversations: configurationResponse.links.conversations,
      users: configurationResponse.links.users,
      currentUser: configurationResponse.links.current_user,
      typing: configurationResponse.links.typing,
      mediaService: configurationResponse.links.media_service,
      mediaSetService: configurationResponse.links.media_set_service,
      messagesReceipts: configurationResponse.links.messages_receipts
    };
    this.limits = {
      mediaAttachmentsCountLimit: configurationResponse.options.media_attachments_count_limit,
      mediaAttachmentSizeLimitInMb: configurationResponse.options.media_attachment_size_limit_in_mb,
      mediaAttachmentsTotalSizeLimitInMb: configurationResponse.options.media_attachments_total_size_limit_in_mb,
      emailHistoriesAllowedContentTypes: configurationResponse.options.email_histories_allowed_mime_types,
      emailBodiesAllowedContentTypes: configurationResponse.options.email_bodies_allowed_mime_types
    };
    this.typingIndicatorTimeoutOverride = constructorOptions.typingIndicatorTimeoutOverride;
    this.backoffConfiguration = _objectSpread$5({
      min: MINIMUM_RETRY_DELAY2,
      max: MAXIMUM_RETRY_DELAY2,
      maxAttemptsCount: MAXIMUM_ATTEMPTS_COUNT
    }, constructorOptions.backoffConfigOverride);
    this.retryWhenThrottled = constructorOptions.retryWhenThrottledOverride !== void 0 ? constructorOptions.retryWhenThrottledOverride : RETRY_WHEN_THROTTLED;
    this.userInfosToSubscribe = (_ref = (_constructorOptions$u = constructorOptions.userInfosToSubscribeOverride) !== null && _constructorOptions$u !== void 0 ? _constructorOptions$u : configurationResponse.options.user_infos_to_subscribe) !== null && _ref !== void 0 ? _ref : USER_INFOS_TO_SUBSCRIBE;
    this.reachabilityEnabled = configurationResponse.options.reachability_enabled;
    this.userIdentity = configurationResponse.identity;
    this.userInfo = configurationResponse.sync_objects.my_user_info;
    this.myConversations = configurationResponse.sync_objects.my_conversations;
    var httpCacheInterval = (_ref2 = (_constructorOptions$h = constructorOptions.httpCacheIntervalOverride) !== null && _constructorOptions$h !== void 0 ? _constructorOptions$h : configurationResponse.options.http_cache_interval) !== null && _ref2 !== void 0 ? _ref2 : HTTP_CACHE_LIFETIME;
    try {
      this.httpCacheInterval = iso8601Duration.toSeconds(iso8601Duration.parse(httpCacheInterval));
    } catch (_unused) {
      logger.error("Failed to parse http cache interval ".concat(httpCacheInterval, ", using default value ").concat(HTTP_CACHE_LIFETIME));
      this.httpCacheInterval = iso8601Duration.toSeconds(iso8601Duration.parse(HTTP_CACHE_LIFETIME));
    }
    var consumptionReportInterval = (_ref3 = (_constructorOptions$c = constructorOptions.consumptionReportIntervalOverride) !== null && _constructorOptions$c !== void 0 ? _constructorOptions$c : configurationResponse.options.consumption_report_interval) !== null && _ref3 !== void 0 ? _ref3 : CONSUMPTION_HORIZON_SENDING_INTERVAL;
    try {
      this.consumptionReportInterval = iso8601Duration.toSeconds(iso8601Duration.parse(consumptionReportInterval));
    } catch (_unused2) {
      logger.error("Failed to parse consumption report interval ".concat(consumptionReportInterval, ", using default value ").concat(CONSUMPTION_HORIZON_SENDING_INTERVAL));
      this.consumptionReportInterval = iso8601Duration.toSeconds(iso8601Duration.parse(CONSUMPTION_HORIZON_SENDING_INTERVAL));
    }
    this.channelMetadataCacheCapacity = (_options$channelMetad = options.channelMetadataCacheCapacity) !== null && _options$channelMetad !== void 0 ? _options$channelMetad : CHANNEL_METADATA_CACHE_CAPACITY;
    this.messageRecipientsCacheCapacity = (_options$messageRecip = options.messageRecipientsCacheCapacity) !== null && _options$messageRecip !== void 0 ? _options$messageRecip : MESSAGE_RECIPIENTS_CACHE_CAPACITY;
  });
  function deepClone2(obj) {
    return JSON.parse(JSON.stringify(obj));
  }
  function parseToNumber(value) {
    if (typeof value !== "undefined" && !isNaN(Number(value))) {
      return Number(value);
    }
    return null;
  }
  function parseTime(timeString) {
    try {
      return new Date(timeString);
    } catch (e) {
      return null;
    }
  }
  function parseAttributes(rawAttributes, warningMessage, log3) {
    var attributes = {};
    if (rawAttributes) {
      try {
        attributes = JSON.parse(rawAttributes);
      } catch (e) {
        log3.warn(warningMessage, e);
      }
    }
    return attributes;
  }
  var UriBuilder2 = /* @__PURE__ */ function() {
    function UriBuilder3(base2) {
      _classCallCheck__default2["default"](this, UriBuilder3);
      this.base = base2.replace(/\/$/, "");
      this.args = [];
      this.paths = [];
    }
    _createClass__default2["default"](UriBuilder3, [{
      key: "arg",
      value: function arg(name, value) {
        if (typeof value !== "undefined") {
          this.args.push(encodeURIComponent(name) + "=" + encodeURIComponent(value));
        }
        return this;
      }
    }, {
      key: "path",
      value: function path2(name) {
        this.paths.push(encodeURIComponent(name));
        return this;
      }
    }, {
      key: "build",
      value: function build() {
        var result = this.base;
        if (this.paths.length) {
          result += "/" + this.paths.join("/");
        }
        if (this.args.length) {
          result += "?" + this.args.join("&");
        }
        return result;
      }
    }]);
    return UriBuilder3;
  }();
  var json = declarativeTypeValidator2.custom(function(value) {
    return [["string", "number", "boolean", "object"].includes(_typeof__default2["default"](value)), "a JSON type"];
  });
  var optionalJson = declarativeTypeValidator2.custom(function(value) {
    return [["undefined", "string", "number", "boolean", "object"].includes(_typeof__default2["default"](value)), "an optional JSON type"];
  });
  var sendMediaOptions = declarativeTypeValidator2.objectSchema("send media options", {
    contentType: [declarativeTypeValidator2.literal(null), "string"],
    filename: ["string", "undefined"],
    media: [declarativeTypeValidator2.literal("null"), "string"].concat(_toConsumableArray__default2["default"](typeof Buffer2 === "function" ? [Buffer2] : []), _toConsumableArray__default2["default"](typeof Blob === "function" ? [Blob] : []))
  });
  function _createSuper$92(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$92();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf__default2["default"](Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf__default2["default"](this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn__default2["default"](this, result);
    };
  }
  function _isNativeReflectConstruct$92() {
    if (typeof Reflect === "undefined" || !Reflect.construct)
      return false;
    if (Reflect.construct.sham)
      return false;
    if (typeof Proxy === "function")
      return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  var log$6 = Logger.scope("User");
  var User = /* @__PURE__ */ function(_ReplayEventEmitter) {
    _inherits__default2["default"](User2, _ReplayEventEmitter);
    var _super = _createSuper$92(User2);
    function User2(identity, entityName, configuration, services) {
      var _this;
      _classCallCheck__default2["default"](this, User2);
      _this = _super.call(this);
      _defineProperty__default2["default"](_assertThisInitialized__default2["default"](_this), "promiseToFetch", null);
      _defineProperty__default2["default"](_assertThisInitialized__default2["default"](_this), "updated", "updated");
      _defineProperty__default2["default"](_assertThisInitialized__default2["default"](_this), "userSubscribed", "userSubscribed");
      _defineProperty__default2["default"](_assertThisInitialized__default2["default"](_this), "userUnsubscribed", "userUnsubscribed");
      _this.services = services;
      _this.subscribed = "initializing";
      _this.setMaxListeners(0);
      _this.state = {
        identity,
        entityName,
        friendlyName: null,
        attributes: {},
        online: null,
        notifiable: null
      };
      _this._initializationPromise = new Promise(function(resolve2) {
        _this._resolveInitializationPromise = resolve2;
      });
      if (configuration !== null) {
        _this._resolveInitialization(configuration, identity, entityName, false);
      }
      return _this;
    }
    _createClass__default2["default"](User2, [{
      key: "identity",
      get: (
        /**
         * User identity.
         */
        function get3() {
          return this.state.identity;
        }
      ),
      set: function set4(identity) {
        this.state.identity = identity;
      }
    }, {
      key: "entityName",
      set: function set4(name) {
        this.state.entityName = name;
      }
      /**
       * Custom attributes of the user.
       */
    }, {
      key: "attributes",
      get: function get3() {
        return this.state.attributes;
      }
      /**
       * Friendly name of the user, null if not set.
       */
    }, {
      key: "friendlyName",
      get: function get3() {
        return this.state.friendlyName;
      }
      /**
       * Status of the real-time conversation connection of the user.
       */
    }, {
      key: "isOnline",
      get: function get3() {
        return this.state.online;
      }
      /**
       * User push notification registration status.
       */
    }, {
      key: "isNotifiable",
      get: function get3() {
        return this.state.notifiable;
      }
      /**
       * True if this user is receiving real-time status updates.
       */
    }, {
      key: "isSubscribed",
      get: function get3() {
        return this.subscribed == "subscribed";
      }
      // Handles service updates
    }, {
      key: "_update",
      value: function() {
        var _update2 = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee(key, value) {
          var updateReasons, updateAttributes;
          return _regeneratorRuntime__default2["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return this._initializationPromise;
                case 2:
                  updateReasons = [];
                  log$6.debug("User for", this.state.identity, "updated:", key, value);
                  _context.t0 = key;
                  _context.next = _context.t0 === "friendlyName" ? 7 : _context.t0 === "attributes" ? 9 : _context.t0 === "reachability" ? 12 : 15;
                  break;
                case 7:
                  if (this.state.friendlyName !== value.value) {
                    updateReasons.push("friendlyName");
                    this.state.friendlyName = value.value;
                  }
                  return _context.abrupt("break", 16);
                case 9:
                  updateAttributes = parseAttributes(value.value, "Retrieved malformed attributes from the server for user: ".concat(this.state.identity), log$6);
                  if (!isEqual__default["default"](this.state.attributes, updateAttributes)) {
                    this.state.attributes = updateAttributes;
                    updateReasons.push("attributes");
                  }
                  return _context.abrupt("break", 16);
                case 12:
                  if (this.state.online !== value.online) {
                    this.state.online = value.online;
                    updateReasons.push("reachabilityOnline");
                  }
                  if (this.state.notifiable !== value.notifiable) {
                    this.state.notifiable = value.notifiable;
                    updateReasons.push("reachabilityNotifiable");
                  }
                  return _context.abrupt("break", 16);
                case 15:
                  return _context.abrupt("return");
                case 16:
                  if (updateReasons.length > 0) {
                    this.emit("updated", {
                      user: this,
                      updateReasons
                    });
                  }
                case 17:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));
        function _update(_x, _x2) {
          return _update2.apply(this, arguments);
        }
        return _update;
      }()
      // Fetch reachability info
    }, {
      key: "_updateReachabilityInfo",
      value: function() {
        var _updateReachabilityInfo2 = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee2(map3, update) {
          var _this2 = this;
          return _regeneratorRuntime__default2["default"].wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return this._initializationPromise;
                case 2:
                  if (this.configuration.reachabilityEnabled) {
                    _context2.next = 4;
                    break;
                  }
                  return _context2.abrupt("return", Promise.resolve());
                case 4:
                  return _context2.abrupt("return", map3.get("reachability").then(update).catch(function(err) {
                    log$6.warn("Failed to get reachability info for ", _this2.state.identity, err);
                  }));
                case 5:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));
        function _updateReachabilityInfo(_x3, _x4) {
          return _updateReachabilityInfo2.apply(this, arguments);
        }
        return _updateReachabilityInfo;
      }()
      // Fetch user
    }, {
      key: "_fetch",
      value: function() {
        var _fetch2 = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee3() {
          var _this3 = this;
          return _regeneratorRuntime__default2["default"].wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return this._initializationPromise;
                case 2:
                  if (this.state.entityName) {
                    _context3.next = 4;
                    break;
                  }
                  return _context3.abrupt("return", this);
                case 4:
                  this.promiseToFetch = this.services.syncClient.map({
                    id: this.state.entityName,
                    mode: "open_existing",
                    includeItems: true
                  }).then(function(map3) {
                    _this3.entity = map3;
                    map3.on("itemUpdated", function(args) {
                      log$6.debug(_this3.state.entityName + " (" + _this3.state.identity + ") itemUpdated: " + args.item.key);
                      return _this3._update(args.item.key, args.item.data);
                    });
                    map3.on("itemAdded", function(args) {
                      log$6.debug(_this3.state.entityName + " (" + _this3.state.identity + ") itemAdded: " + args.item.key);
                      return _this3._update(args.item.key, args.item.data);
                    });
                    return Promise.all([map3.get("friendlyName").then(function(item) {
                      return _this3._update(item.key, item.data);
                    }), map3.get("attributes").then(function(item) {
                      return _this3._update(item.key, item.data);
                    }), _this3._updateReachabilityInfo(map3, function(item) {
                      return _this3._update(item.key, item.data);
                    })]);
                  }).then(function() {
                    log$6.debug("Fetched for", _this3.identity);
                    _this3.subscribed = "subscribed";
                    _this3.emit("userSubscribed", _this3);
                    return _this3;
                  }).catch(function(err) {
                    _this3.promiseToFetch = null;
                    throw err;
                  });
                  return _context3.abrupt("return", this.promiseToFetch);
                case 6:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));
        function _fetch() {
          return _fetch2.apply(this, arguments);
        }
        return _fetch;
      }()
    }, {
      key: "_ensureFetched",
      value: function() {
        var _ensureFetched2 = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee4() {
          return _regeneratorRuntime__default2["default"].wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return this._initializationPromise;
                case 2:
                  return _context4.abrupt("return", this.promiseToFetch || this._fetch());
                case 3:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));
        function _ensureFetched() {
          return _ensureFetched2.apply(this, arguments);
        }
        return _ensureFetched;
      }()
      /**
       * Edit user attributes.
       * @param attributes New attributes.
       */
    }, {
      key: "updateAttributes",
      value: function() {
        var _updateAttributes = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee5(attributes) {
          return _regeneratorRuntime__default2["default"].wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return this._initializationPromise;
                case 2:
                  if (!(this.subscribed == "unsubscribed")) {
                    _context5.next = 4;
                    break;
                  }
                  throw new Error("Can't modify unsubscribed object");
                case 4:
                  _context5.next = 6;
                  return this.services.commandExecutor.mutateResource("post", this.links.self, {
                    attributes: JSON.stringify(attributes)
                  });
                case 6:
                  return _context5.abrupt("return", this);
                case 7:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, this);
        }));
        function updateAttributes(_x5) {
          return _updateAttributes.apply(this, arguments);
        }
        return updateAttributes;
      }()
      /**
       * Update the friendly name of the user.
       * @param friendlyName New friendly name.
       */
    }, {
      key: "updateFriendlyName",
      value: function() {
        var _updateFriendlyName = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee6(friendlyName) {
          return _regeneratorRuntime__default2["default"].wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  _context6.next = 2;
                  return this._initializationPromise;
                case 2:
                  if (!(this.subscribed == "unsubscribed")) {
                    _context6.next = 4;
                    break;
                  }
                  throw new Error("Can't modify unsubscribed object");
                case 4:
                  _context6.next = 6;
                  return this.services.commandExecutor.mutateResource("post", this.links.self, {
                    friendly_name: friendlyName
                  });
                case 6:
                  return _context6.abrupt("return", this);
                case 7:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6, this);
        }));
        function updateFriendlyName(_x6) {
          return _updateFriendlyName.apply(this, arguments);
        }
        return updateFriendlyName;
      }()
      /**
       * Remove the user from the subscription list.
       * @return A promise of completion.
       */
    }, {
      key: "unsubscribe",
      value: function() {
        var _unsubscribe = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee7() {
          return _regeneratorRuntime__default2["default"].wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  _context7.next = 2;
                  return this._initializationPromise;
                case 2:
                  if (!this.promiseToFetch) {
                    _context7.next = 9;
                    break;
                  }
                  _context7.next = 5;
                  return this.promiseToFetch;
                case 5:
                  this.entity.close();
                  this.promiseToFetch = null;
                  this.subscribed = "unsubscribed";
                  this.emit("userUnsubscribed", this);
                case 9:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7, this);
        }));
        function unsubscribe() {
          return _unsubscribe.apply(this, arguments);
        }
        return unsubscribe;
      }()
    }, {
      key: "_resolveInitialization",
      value: function _resolveInitialization(configuration, identity, entityName, emitUpdated) {
        this.configuration = configuration;
        this.identity = identity;
        this.entityName = entityName;
        this.links = {
          self: "".concat(this.configuration.links.users, "/").concat(encodeURIComponent(this.identity))
        };
        this._resolveInitializationPromise();
        if (emitUpdated) {
          this.emit("updated", {
            user: this,
            updateReasons: ["friendlyName", "attributes", "reachabilityOnline", "reachabilityNotifiable"]
          });
        }
      }
    }]);
    return User2;
  }(replayEventEmitter.ReplayEventEmitter);
  __decorate2([declarativeTypeValidator2.validateTypesAsync(json), __metadata2("design:type", Function), __metadata2("design:paramtypes", [Object]), __metadata2("design:returntype", Promise)], User.prototype, "updateAttributes", null);
  __decorate2([declarativeTypeValidator2.validateTypesAsync(["string"]), __metadata2("design:type", Function), __metadata2("design:paramtypes", [String]), __metadata2("design:returntype", Promise)], User.prototype, "updateFriendlyName", null);
  function _createForOfIteratorHelper$52(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
      if (Array.isArray(o) || (it = _unsupportedIterableToArray$52(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it)
          o = it;
        var i = 0;
        var F = function F2() {
        };
        return { s: F, n: function n() {
          if (i >= o.length)
            return { done: true };
          return { done: false, value: o[i++] };
        }, e: function e(_e) {
          throw _e;
        }, f: F };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return { s: function s() {
      it = it.call(o);
    }, n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    }, e: function e(_e2) {
      didErr = true;
      err = _e2;
    }, f: function f() {
      try {
        if (!normalCompletion && it.return != null)
          it.return();
      } finally {
        if (didErr)
          throw err;
      }
    } };
  }
  function _unsupportedIterableToArray$52(o, minLen) {
    if (!o)
      return;
    if (typeof o === "string")
      return _arrayLikeToArray$52(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor)
      n = o.constructor.name;
    if (n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$52(o, minLen);
  }
  function _arrayLikeToArray$52(arr, len) {
    if (len == null || len > arr.length)
      len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  }
  var Network = /* @__PURE__ */ function() {
    function Network2(configuration, services) {
      _classCallCheck__default2["default"](this, Network2);
      this.configuration = configuration;
      this.services = services;
      this.cache = /* @__PURE__ */ new Map();
      this.cacheLifetime = this.configuration.httpCacheInterval * 100;
      this.cleanupCache();
    }
    _createClass__default2["default"](Network2, [{
      key: "isExpired",
      value: function isExpired(timestamp) {
        return !this.cacheLifetime || Date.now() - timestamp > this.cacheLifetime;
      }
    }, {
      key: "cleanupCache",
      value: function cleanupCache() {
        var _iterator = _createForOfIteratorHelper$52(this.cache), _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done; ) {
            var _step$value = _slicedToArray__default2["default"](_step.value, 2), k = _step$value[0], v = _step$value[1];
            if (this.isExpired(v.timestamp)) {
              this.cache.delete(k);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        if (this.cache.size === 0) {
          clearInterval(this.timer);
        }
      }
    }, {
      key: "pokeTimer",
      value: function pokeTimer() {
        var _this = this;
        this.timer = this.timer || setInterval(function() {
          return _this.cleanupCache();
        }, this.cacheLifetime * 2);
      }
    }, {
      key: "executeWithRetry",
      value: function executeWithRetry(request) {
        var _this2 = this;
        var retryWhenThrottled = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return new Promise(function(resolve2, reject2) {
          var codesToRetryOn = [502, 503, 504];
          if (retryWhenThrottled) {
            codesToRetryOn.push(429);
          }
          var retrier = new operationRetrier2.Retrier(_this2.configuration.backoffConfiguration);
          retrier.on("attempt", function() {
            request().then(function(result) {
              return retrier.succeeded(result);
            }).catch(function(err) {
              if (codesToRetryOn.indexOf(err.status) > -1) {
                retrier.failed(err);
              } else if (err.message === "Twilsock disconnected") {
                retrier.failed(err);
              } else {
                retrier.removeAllListeners();
                retrier.cancel();
                reject2(err);
              }
            });
          });
          retrier.on("succeeded", function(result) {
            resolve2(result);
          });
          retrier.on("cancelled", function(err) {
            return reject2(err);
          });
          retrier.on("failed", function(err) {
            return reject2(err);
          });
          retrier.start();
        });
      }
    }, {
      key: "get",
      value: function() {
        var _get2 = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee(url) {
          var _this3 = this;
          var cacheEntry, headers, response;
          return _regeneratorRuntime__default2["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  cacheEntry = this.cache.get(url);
                  if (!(cacheEntry && !this.isExpired(cacheEntry.timestamp))) {
                    _context.next = 3;
                    break;
                  }
                  return _context.abrupt("return", cacheEntry.response);
                case 3:
                  headers = {};
                  _context.next = 6;
                  return this.executeWithRetry(function() {
                    return _this3.services.transport.get(url, headers, _this3.configuration.productId);
                  }, this.configuration.retryWhenThrottled);
                case 6:
                  response = _context.sent;
                  this.cache.set(url, {
                    response,
                    timestamp: Date.now()
                  });
                  this.pokeTimer();
                  return _context.abrupt("return", response);
                case 10:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));
        function get3(_x) {
          return _get2.apply(this, arguments);
        }
        return get3;
      }()
    }]);
    return Network2;
  }();
  var NotificationTypes = /* @__PURE__ */ _createClass__default2["default"](function NotificationTypes2() {
    _classCallCheck__default2["default"](this, NotificationTypes2);
  });
  _defineProperty__default2["default"](NotificationTypes, "TYPING_INDICATOR", "twilio.ipmsg.typing_indicator");
  _defineProperty__default2["default"](NotificationTypes, "NEW_MESSAGE", "twilio.conversations.new_message");
  _defineProperty__default2["default"](NotificationTypes, "ADDED_TO_CONVERSATION", "twilio.conversations.added_to_conversation");
  _defineProperty__default2["default"](NotificationTypes, "REMOVED_FROM_CONVERSATION", "twilio.conversations.removed_from_conversation");
  _defineProperty__default2["default"](NotificationTypes, "CONSUMPTION_UPDATE", "twilio.channel.consumption_update");
  function _createSuper$82(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$82();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf__default2["default"](Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf__default2["default"](this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn__default2["default"](this, result);
    };
  }
  function _isNativeReflectConstruct$82() {
    if (typeof Reflect === "undefined" || !Reflect.construct)
      return false;
    if (Reflect.construct.sham)
      return false;
    if (typeof Proxy === "function")
      return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  var log$5 = Logger.scope("Participant");
  var Participant = /* @__PURE__ */ function(_ReplayEventEmitter) {
    _inherits__default2["default"](Participant2, _ReplayEventEmitter);
    var _super = _createSuper$82(Participant2);
    function Participant2(data2, sid, conversation, links, services) {
      var _data$roleSid, _data$bindings;
      var _this;
      _classCallCheck__default2["default"](this, Participant2);
      _this = _super.call(this);
      _this.conversation = conversation;
      _this.links = links;
      _this.services = services;
      _this.state = {
        attributes: parseAttributes(data2.attributes, "Retrieved malformed attributes from the server for participant: " + sid, log$5),
        dateCreated: data2.dateCreated ? parseTime(data2.dateCreated) : null,
        dateUpdated: data2.dateCreated ? parseTime(data2.dateUpdated) : null,
        sid,
        typingTimeout: null,
        isTyping: false,
        identity: data2.identity,
        roleSid: (_data$roleSid = data2.roleSid) !== null && _data$roleSid !== void 0 ? _data$roleSid : "",
        lastReadMessageIndex: Number.isInteger(data2.lastConsumedMessageIndex) ? data2.lastConsumedMessageIndex : null,
        lastReadTimestamp: data2.lastConsumptionTimestamp ? parseTime(data2.lastConsumptionTimestamp) : null,
        type: data2.type || "chat",
        userInfo: data2.userInfo,
        bindings: (_data$bindings = data2.bindings) !== null && _data$bindings !== void 0 ? _data$bindings : {}
      };
      if (!data2.identity && !data2.type) {
        throw new Error("Received invalid Participant object from server: Missing identity or type of Participant.");
      }
      return _this;
    }
    _createClass__default2["default"](Participant2, [{
      key: "sid",
      get: (
        /**
         * Conversation that the remote client is a participant of.
         */
        /**
         * The server-assigned unique identifier for the participant.
         */
        function get3() {
          return this.state.sid;
        }
      )
      /**
       * Custom attributes of the participant.
       */
    }, {
      key: "attributes",
      get: function get3() {
        return this.state.attributes;
      }
      /**
       * Date this participant was created on.
       */
    }, {
      key: "dateCreated",
      get: function get3() {
        return this.state.dateCreated;
      }
      /**
       * Date this participant was last updated on.
       */
    }, {
      key: "dateUpdated",
      get: function get3() {
        return this.state.dateUpdated;
      }
      /**
       * Identity of the participant.
       */
    }, {
      key: "identity",
      get: function get3() {
        return this.state.identity;
      }
      /**
       * Indicates whether the participant is currently typing.
       */
    }, {
      key: "isTyping",
      get: function get3() {
        return this.state.isTyping;
      }
      /**
       * The index of the last read message by the participant.
       * Note that retrieving messages on a client endpoint does not mean that messages are read,
       * please consider reading about the [Read Horizon feature](https://www.twilio.com/docs/api/chat/guides/consumption-horizon)
       * to find out about the proper way to mark messages as read.
       */
    }, {
      key: "lastReadMessageIndex",
      get: function get3() {
        return this.state.lastReadMessageIndex;
      }
      /**
       * Date of the most recent read horizon update.
       */
    }, {
      key: "lastReadTimestamp",
      get: function get3() {
        return this.state.lastReadTimestamp;
      }
    }, {
      key: "roleSid",
      get: function get3() {
        return this.state.roleSid;
      }
      /**
       * Type of the participant.
       */
    }, {
      key: "type",
      get: function get3() {
        return this.state.type;
      }
      /**
       * Get the bindings mapping for the current participant.
       * Available binding depends on the participant type.
       * You could access it as `participant.bindings.sms?.address` or
       * using the type dynamically `participant.bindings[participant.type]`
       * just be aware that the binding information has different structure for
       * each participant type.
       * See also {ParticipantEmailBinding}, the only available currently binding descriptor.
       */
    }, {
      key: "bindings",
      get: function get3() {
        var _this$state$bindings;
        return (_this$state$bindings = this.state.bindings) !== null && _this$state$bindings !== void 0 ? _this$state$bindings : {};
      }
    }, {
      key: "_startTyping",
      value: (
        /**
         * Internal method used to start or reset the typing indicator timeout (with event emitting).
         * @internal
         */
        function _startTyping(timeout) {
          var _this2 = this;
          if (this.state.typingTimeout) {
            clearTimeout(this.state.typingTimeout);
          }
          this.state.isTyping = true;
          this.emit(Participant2.typingStarted, this);
          this.conversation.emit(Conversation.typingStarted, this);
          this.state.typingTimeout = Number(setTimeout(function() {
            return _this2._endTyping();
          }, timeout));
          return this;
        }
      )
      /**
       * Internal method function used to stop the typing indicator timeout (with event emitting).
       * @internal
       */
    }, {
      key: "_endTyping",
      value: function _endTyping() {
        if (!this.state.typingTimeout) {
          return;
        }
        this.state.isTyping = false;
        this.emit(Participant2.typingEnded, this);
        this.conversation.emit(Conversation.typingEnded, this);
        clearInterval(this.state.typingTimeout);
        this.state.typingTimeout = null;
      }
      /**
       * Internal method function used update local object's property roleSid with a new value.
       * @internal
       */
    }, {
      key: "_update",
      value: function _update(data2) {
        var updateReasons = [];
        var updateAttributes = parseAttributes(data2.attributes, "Retrieved malformed attributes from the server for participant: " + this.state.sid, log$5);
        if (data2.attributes && !isEqual__default["default"](this.state.attributes, updateAttributes)) {
          this.state.attributes = updateAttributes;
          updateReasons.push("attributes");
        }
        var updatedDateUpdated = parseTime(data2.dateUpdated);
        if (data2.dateUpdated && (updatedDateUpdated === null || updatedDateUpdated === void 0 ? void 0 : updatedDateUpdated.getTime()) !== (this.state.dateUpdated && this.state.dateUpdated.getTime())) {
          this.state.dateUpdated = updatedDateUpdated;
          updateReasons.push("dateUpdated");
        }
        var updatedDateCreated = parseTime(data2.dateCreated);
        if (data2.dateCreated && (updatedDateCreated === null || updatedDateCreated === void 0 ? void 0 : updatedDateCreated.getTime()) !== (this.state.dateCreated && this.state.dateCreated.getTime())) {
          this.state.dateCreated = updatedDateCreated;
          updateReasons.push("dateCreated");
        }
        if (data2.roleSid && this.state.roleSid !== data2.roleSid) {
          this.state.roleSid = data2.roleSid;
          updateReasons.push("roleSid");
        }
        if ((Number.isInteger(data2.lastConsumedMessageIndex) || data2.lastConsumedMessageIndex === null) && this.state.lastReadMessageIndex !== data2.lastConsumedMessageIndex) {
          this.state.lastReadMessageIndex = data2.lastConsumedMessageIndex;
          updateReasons.push("lastReadMessageIndex");
        }
        if (data2.lastConsumptionTimestamp) {
          var lastReadTimestamp = new Date(data2.lastConsumptionTimestamp);
          if (!this.state.lastReadTimestamp || this.state.lastReadTimestamp.getTime() !== lastReadTimestamp.getTime()) {
            this.state.lastReadTimestamp = lastReadTimestamp;
            updateReasons.push("lastReadTimestamp");
          }
        }
        if (data2.bindings && !isEqual__default["default"](this.state.bindings, data2.bindings)) {
          this.state.bindings = data2.bindings;
          updateReasons.push("bindings");
        }
        if (updateReasons.length > 0) {
          this.emit(Participant2.updated, {
            participant: this,
            updateReasons
          });
        }
        return this;
      }
      /**
       * Get the user for this participant and subscribes to it. Supported only for participants of type `chat`.
       */
    }, {
      key: "getUser",
      value: function() {
        var _getUser = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee() {
          return _regeneratorRuntime__default2["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!(this.type != "chat")) {
                    _context.next = 2;
                    break;
                  }
                  throw new Error("Getting User is not supported for this Participant type: " + this.type);
                case 2:
                  return _context.abrupt("return", this.services.users.getUser(this.state.identity, this.state.userInfo));
                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));
        function getUser() {
          return _getUser.apply(this, arguments);
        }
        return getUser;
      }()
      /**
       * Remove the participant from the conversation.
       */
    }, {
      key: "remove",
      value: function() {
        var _remove = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee2() {
          return _regeneratorRuntime__default2["default"].wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  return _context2.abrupt("return", this.conversation.removeParticipant(this));
                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));
        function remove() {
          return _remove.apply(this, arguments);
        }
        return remove;
      }()
      /**
       * Update the attributes of the participant.
       * @param attributes New attributes.
       */
    }, {
      key: "updateAttributes",
      value: function() {
        var _updateAttributes = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee3(attributes) {
          return _regeneratorRuntime__default2["default"].wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return this.services.commandExecutor.mutateResource("post", this.links.self, {
                    attributes: JSON.stringify(attributes)
                  });
                case 2:
                  return _context3.abrupt("return", this);
                case 3:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));
        function updateAttributes(_x) {
          return _updateAttributes.apply(this, arguments);
        }
        return updateAttributes;
      }()
    }]);
    return Participant2;
  }(replayEventEmitter.ReplayEventEmitter);
  _defineProperty__default2["default"](Participant, "typingStarted", "typingStarted");
  _defineProperty__default2["default"](Participant, "typingEnded", "typingEnded");
  _defineProperty__default2["default"](Participant, "updated", "updated");
  __decorate2([declarativeTypeValidator2.validateTypesAsync(json), __metadata2("design:type", Function), __metadata2("design:paramtypes", [Object]), __metadata2("design:returntype", Promise)], Participant.prototype, "updateAttributes", null);
  function _createSuper$72(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$72();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf__default2["default"](Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf__default2["default"](this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn__default2["default"](this, result);
    };
  }
  function _isNativeReflectConstruct$72() {
    if (typeof Reflect === "undefined" || !Reflect.construct)
      return false;
    if (Reflect.construct.sham)
      return false;
    if (typeof Proxy === "function")
      return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  var log$4 = Logger.scope("Participants");
  var Participants = /* @__PURE__ */ function(_ReplayEventEmitter) {
    _inherits__default2["default"](Participants2, _ReplayEventEmitter);
    var _super = _createSuper$72(Participants2);
    function Participants2(conversation, participants, links, services) {
      var _this;
      _classCallCheck__default2["default"](this, Participants2);
      _this = _super.call(this);
      _defineProperty__default2["default"](_assertThisInitialized__default2["default"](_this), "rosterEntityPromise", null);
      _this.conversation = conversation;
      _this.participants = participants;
      _this.links = links;
      _this.services = services;
      return _this;
    }
    _createClass__default2["default"](Participants2, [{
      key: "unsubscribe",
      value: function() {
        var _unsubscribe = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee() {
          var entity;
          return _regeneratorRuntime__default2["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!this.rosterEntityPromise) {
                    _context.next = 6;
                    break;
                  }
                  _context.next = 3;
                  return this.rosterEntityPromise;
                case 3:
                  entity = _context.sent;
                  entity.close();
                  this.rosterEntityPromise = null;
                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));
        function unsubscribe() {
          return _unsubscribe.apply(this, arguments);
        }
        return unsubscribe;
      }()
    }, {
      key: "subscribe",
      value: function subscribe(arg) {
        var _this2 = this;
        var participantsMapPromise = typeof arg === "string" ? this.services.syncClient.map({
          id: arg,
          mode: "open_existing"
        }) : Promise.resolve(arg);
        return this.rosterEntityPromise = this.rosterEntityPromise || participantsMapPromise.then(function(rosterMap) {
          rosterMap.on(twilioSync.SyncMap.itemAdded, function(args) {
            log$4.debug(_this2.conversation.sid + " itemAdded: " + args.item.key);
            _this2.upsertParticipant(args.item.key, args.item.data).then(function(participant) {
              _this2.emit(Conversation.participantJoined, participant);
            });
          });
          rosterMap.on(twilioSync.SyncMap.itemRemoved, function(args) {
            log$4.debug(_this2.conversation.sid + " itemRemoved: " + args.key);
            var participantSid = args.key;
            if (!_this2.participants.has(participantSid)) {
              return;
            }
            var leftParticipant = _this2.participants.get(participantSid);
            _this2.participants.delete(participantSid);
            if (!leftParticipant) {
              return;
            }
            _this2.emit(Conversation.participantLeft, leftParticipant);
          });
          rosterMap.on(twilioSync.SyncMap.itemUpdated, function(args) {
            log$4.debug(_this2.conversation.sid + " itemUpdated: " + args.item.key);
            _this2.upsertParticipant(args.item.key, args.item.data).catch(function(e) {
              return log$4.error(e);
            });
          });
          var participantsPromises = [];
          var rosterMapHandler = function rosterMapHandler2(paginator) {
            paginator.items.forEach(function(item) {
              participantsPromises.push(_this2.upsertParticipant(item.key, item.data));
            });
            return paginator.hasNextPage ? paginator.nextPage().then(rosterMapHandler2) : null;
          };
          return rosterMap.getItems().then(rosterMapHandler).then(function() {
            return Promise.all(participantsPromises);
          }).then(function() {
            return rosterMap;
          });
        }).catch(function(err) {
          _this2.rosterEntityPromise = null;
          if (_this2.services.syncClient.connectionState != "disconnected") {
            log$4.error("Failed to get roster object for conversation", _this2.conversation.sid, err);
          }
          log$4.debug("ERROR: Failed to get roster object for conversation", _this2.conversation.sid, err);
          throw err;
        });
      }
    }, {
      key: "upsertParticipantFromResponse",
      value: function() {
        var _upsertParticipantFromResponse = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee2(data2) {
          var _messagingBinding$typ;
          var sid, responseAttributes, dateCreated, dateUpdated, responseIdentity, roleSid, messagingBinding;
          return _regeneratorRuntime__default2["default"].wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  sid = data2.sid, responseAttributes = data2.attributes, dateCreated = data2.date_created, dateUpdated = data2.date_updated, responseIdentity = data2.identity, roleSid = data2.role_sid, messagingBinding = data2.messaging_binding;
                  _context2.next = 3;
                  return this.upsertParticipant(sid, {
                    attributes: responseAttributes,
                    dateCreated: new Date(dateCreated),
                    dateUpdated: new Date(dateUpdated),
                    identity: responseIdentity,
                    roleSid,
                    lastConsumedMessageIndex: null,
                    lastConsumptionTimestamp: null,
                    type: (_messagingBinding$typ = messagingBinding === null || messagingBinding === void 0 ? void 0 : messagingBinding.type) !== null && _messagingBinding$typ !== void 0 ? _messagingBinding$typ : "chat"
                  });
                case 3:
                  return _context2.abrupt("return", _context2.sent);
                case 4:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));
        function upsertParticipantFromResponse(_x) {
          return _upsertParticipantFromResponse.apply(this, arguments);
        }
        return upsertParticipantFromResponse;
      }()
    }, {
      key: "upsertParticipant",
      value: function() {
        var _upsertParticipant = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee3(participantSid, data2) {
          var _this3 = this;
          var participant, links;
          return _regeneratorRuntime__default2["default"].wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  participant = this.participants.get(participantSid);
                  if (!participant) {
                    _context3.next = 3;
                    break;
                  }
                  return _context3.abrupt("return", participant._update(data2));
                case 3:
                  links = {
                    self: "".concat(this.links.participants, "/").concat(participantSid)
                  };
                  participant = new Participant(data2, participantSid, this.conversation, links, this.services);
                  this.participants.set(participantSid, participant);
                  participant.on(Participant.updated, function(args) {
                    return _this3.emit(Conversation.participantUpdated, args);
                  });
                  return _context3.abrupt("return", participant);
                case 8:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));
        function upsertParticipant(_x2, _x3) {
          return _upsertParticipant.apply(this, arguments);
        }
        return upsertParticipant;
      }()
      /**
       * @returns {Promise<Array<Participant>>} returns list of participants {@see Participant}
       */
    }, {
      key: "getParticipants",
      value: function() {
        var _getParticipants = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee4() {
          var _this4 = this;
          return _regeneratorRuntime__default2["default"].wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  return _context4.abrupt("return", this.rosterEntityPromise ? this.rosterEntityPromise.then(function() {
                    var participants = [];
                    _this4.participants.forEach(function(participant) {
                      return participants.push(participant);
                    });
                    return participants;
                  }) : []);
                case 1:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));
        function getParticipants() {
          return _getParticipants.apply(this, arguments);
        }
        return getParticipants;
      }()
      /**
       * Get participant by SID from conversation
       * @returns {Promise<Participant>}
       */
    }, {
      key: "getParticipantBySid",
      value: function() {
        var _getParticipantBySid = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee5(participantSid) {
          var _this5 = this;
          return _regeneratorRuntime__default2["default"].wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  return _context5.abrupt("return", this.rosterEntityPromise ? this.rosterEntityPromise.then(function() {
                    var participant = _this5.participants.get(participantSid);
                    if (!participant) {
                      throw new Error("Participant with SID " + participantSid + " was not found");
                    }
                    return participant;
                  }) : null);
                case 1:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, this);
        }));
        function getParticipantBySid(_x4) {
          return _getParticipantBySid.apply(this, arguments);
        }
        return getParticipantBySid;
      }()
      /**
       * Get participant by identity from conversation
       * @returns {Promise<Participant>}
       */
    }, {
      key: "getParticipantByIdentity",
      value: function() {
        var _getParticipantByIdentity = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee6(identity) {
          var _this6 = this;
          var foundParticipant;
          return _regeneratorRuntime__default2["default"].wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  foundParticipant = null;
                  return _context6.abrupt("return", this.rosterEntityPromise ? this.rosterEntityPromise.then(function() {
                    _this6.participants.forEach(function(participant) {
                      if (participant.identity === identity) {
                        foundParticipant = participant;
                      }
                    });
                    if (!foundParticipant) {
                      throw new Error("Participant with identity " + identity + " was not found");
                    }
                    return foundParticipant;
                  }) : null);
                case 2:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6, this);
        }));
        function getParticipantByIdentity(_x5) {
          return _getParticipantByIdentity.apply(this, arguments);
        }
        return getParticipantByIdentity;
      }()
      /**
       * Add a chat participant to the conversation
       */
    }, {
      key: "add",
      value: function() {
        var _add = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee7(identity, attributes) {
          return _regeneratorRuntime__default2["default"].wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  _context7.next = 2;
                  return this.services.commandExecutor.mutateResource("post", this.links.participants, {
                    identity,
                    attributes: typeof attributes !== "undefined" ? JSON.stringify(attributes) : void 0
                  });
                case 2:
                  return _context7.abrupt("return", _context7.sent);
                case 3:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7, this);
        }));
        function add(_x6, _x7) {
          return _add.apply(this, arguments);
        }
        return add;
      }()
      /**
       * Add a non-chat participant to the conversation.
       */
    }, {
      key: "addNonChatParticipant",
      value: function() {
        var _addNonChatParticipant = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee8(proxyAddress, address) {
          var _bindingOptions$email, _bindingOptions$email2;
          var attributes, bindingOptions, _args8 = arguments;
          return _regeneratorRuntime__default2["default"].wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  attributes = _args8.length > 2 && _args8[2] !== void 0 ? _args8[2] : {};
                  bindingOptions = _args8.length > 3 && _args8[3] !== void 0 ? _args8[3] : {};
                  _context8.next = 4;
                  return this.services.commandExecutor.mutateResource("post", this.links.participants, {
                    attributes: typeof attributes !== "undefined" ? JSON.stringify(attributes) : void 0,
                    messaging_binding: {
                      address,
                      proxy_address: proxyAddress,
                      name: bindingOptions === null || bindingOptions === void 0 ? void 0 : (_bindingOptions$email = bindingOptions.email) === null || _bindingOptions$email === void 0 ? void 0 : _bindingOptions$email.name,
                      level: bindingOptions === null || bindingOptions === void 0 ? void 0 : (_bindingOptions$email2 = bindingOptions.email) === null || _bindingOptions$email2 === void 0 ? void 0 : _bindingOptions$email2.level
                    }
                  });
                case 4:
                  return _context8.abrupt("return", _context8.sent);
                case 5:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8, this);
        }));
        function addNonChatParticipant(_x8, _x9) {
          return _addNonChatParticipant.apply(this, arguments);
        }
        return addNonChatParticipant;
      }()
      /**
       * Remove the participant with a given identity from a conversation.
       */
    }, {
      key: "remove",
      value: function remove(identity) {
        return this.services.commandExecutor.mutateResource("delete", "".concat(this.links.participants, "/").concat(encodeURIComponent(identity)));
      }
    }]);
    return Participants2;
  }(replayEventEmitter.ReplayEventEmitter);
  var Media = /* @__PURE__ */ function() {
    function Media2(data2, services) {
      var _data$filename;
      _classCallCheck__default2["default"](this, Media2);
      _defineProperty__default2["default"](this, "mcsMedia", null);
      this.services = services;
      if (data2 instanceof mcsClient.McsMedia) {
        this.mcsMedia = data2;
      }
      this.state = {
        sid: data2.sid,
        category: data2.category,
        filename: (_data$filename = data2.filename) !== null && _data$filename !== void 0 ? _data$filename : null,
        contentType: data2.contentType,
        size: data2.size
      };
    }
    _createClass__default2["default"](Media2, [{
      key: "sid",
      get: function get3() {
        return this.state.sid;
      }
      /**
       * File name. Null if absent.
       */
    }, {
      key: "filename",
      get: function get3() {
        return this.state.filename;
      }
      /**
       * Content type of the media.
       */
    }, {
      key: "contentType",
      get: function get3() {
        return this.state.contentType;
      }
      /**
       * Size of the media in bytes.
       */
    }, {
      key: "size",
      get: function get3() {
        return this.state.size;
      }
      /**
       * Media category, can be one of the {@link MediaCategory} values.
       */
    }, {
      key: "category",
      get: function get3() {
        return this.state.category;
      }
      /**
       * Returns the direct content URL for the media.
       *
       * This URL is impermanent, it will expire in several minutes and cannot be cached.
       * If the URL becomes expired, you need to request a new one.
       * Each call to this function produces a new temporary URL.
       */
    }, {
      key: "getContentTemporaryUrl",
      value: function getContentTemporaryUrl() {
        var _this = this;
        return new mcsClient.CancellablePromise(/* @__PURE__ */ function() {
          var _ref = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee(resolve2, reject2, onCancel) {
            var _this$mcsMedia;
            var fetchMediaRequest, contentUrlRequest, mcsMedia;
            return _regeneratorRuntime__default2["default"].wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    fetchMediaRequest = _this.mcsMedia ? void 0 : _this._fetchMcsMedia();
                    contentUrlRequest = (_this$mcsMedia = _this.mcsMedia) === null || _this$mcsMedia === void 0 ? void 0 : _this$mcsMedia.getContentUrl();
                    onCancel(function() {
                      if (fetchMediaRequest) {
                        fetchMediaRequest.cancel();
                      }
                      if (contentUrlRequest) {
                        contentUrlRequest.cancel();
                      }
                    });
                    _context.prev = 3;
                    if (contentUrlRequest) {
                      _context.next = 9;
                      break;
                    }
                    _context.next = 7;
                    return fetchMediaRequest;
                  case 7:
                    mcsMedia = _context.sent;
                    contentUrlRequest = mcsMedia === null || mcsMedia === void 0 ? void 0 : mcsMedia.getContentUrl();
                  case 9:
                    _context.t0 = resolve2;
                    if (!contentUrlRequest) {
                      _context.next = 16;
                      break;
                    }
                    _context.next = 13;
                    return contentUrlRequest;
                  case 13:
                    _context.t1 = _context.sent;
                    _context.next = 17;
                    break;
                  case 16:
                    _context.t1 = null;
                  case 17:
                    _context.t2 = _context.t1;
                    (0, _context.t0)(_context.t2);
                    _context.next = 24;
                    break;
                  case 21:
                    _context.prev = 21;
                    _context.t3 = _context["catch"](3);
                    reject2(_context.t3);
                  case 24:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, null, [[3, 21]]);
          }));
          return function(_x, _x2, _x3) {
            return _ref.apply(this, arguments);
          };
        }());
      }
    }, {
      key: "_fetchMcsMedia",
      value: function _fetchMcsMedia() {
        var _this2 = this;
        return new mcsClient.CancellablePromise(/* @__PURE__ */ function() {
          var _ref2 = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee2(resolve2, reject2, onCancel) {
            var request;
            return _regeneratorRuntime__default2["default"].wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    if (_this2.services.mcsClient === null) {
                      reject2(new Error("Media Content Service is unavailable"));
                    }
                    request = _this2.services.mcsClient.get(_this2.state.sid);
                    onCancel(function() {
                      return request.cancel();
                    });
                    _context2.prev = 3;
                    _context2.next = 6;
                    return request;
                  case 6:
                    _this2.mcsMedia = _context2.sent;
                    _this2.state = _this2.mcsMedia._state();
                    resolve2(_this2.mcsMedia);
                    _context2.next = 14;
                    break;
                  case 11:
                    _context2.prev = 11;
                    _context2.t0 = _context2["catch"](3);
                    reject2(_context2.t0);
                  case 14:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, null, [[3, 11]]);
          }));
          return function(_x4, _x5, _x6) {
            return _ref2.apply(this, arguments);
          };
        }());
      }
      /**
       * @internal
       */
    }, {
      key: "_state",
      value: function _state() {
        return this.state;
      }
    }]);
    return Media2;
  }();
  var AggregatedDeliveryReceipt = /* @__PURE__ */ function() {
    function AggregatedDeliveryReceipt2(data2) {
      _classCallCheck__default2["default"](this, AggregatedDeliveryReceipt2);
      this.state = data2;
    }
    _createClass__default2["default"](AggregatedDeliveryReceipt2, [{
      key: "total",
      get: function get3() {
        return this.state.total;
      }
      /**
       * Message is considered as **sent** to a participant if the nearest upstream carrier accepted the message.
       *
       * @return Amount of participants that have the **sent** delivery status for the message.
       */
    }, {
      key: "sent",
      get: function get3() {
        return this.state.sent;
      }
      /**
       * Message is considered as **delivered** to a participant if Twilio has received confirmation of message
       * delivery from the upstream carrier, and, where available, the destination handset.
       *
       * @return Amount of participants that have the **delivered** delivery status for the message.
       */
    }, {
      key: "delivered",
      get: function get3() {
        return this.state.delivered;
      }
      /**
       * Message is considered as **read** by a participant, if the message has been delivered and opened by the
       * recipient in a conversation. The recipient must have enabled the read receipts.
       *
       * @return Amount of participants that have the **read** delivery status for the message.
       */
    }, {
      key: "read",
      get: function get3() {
        return this.state.read;
      }
      /**
       * Message is considered as **undelivered** to a participant if Twilio has received a delivery receipt
       * indicating that the message was not delivered. This can happen for many reasons including carrier content
       * filtering and the availability of the destination handset.
       *
       * @return Ammount of participants that have the **undelivered** delivery status for the message.
       */
    }, {
      key: "undelivered",
      get: function get3() {
        return this.state.undelivered;
      }
      /**
       * Message is considered as **failed** to be delivered to a participant if the message could not be sent.
       * This can happen for various reasons including queue overflows, account suspensions and media
       * errors (in the case of MMS for instance). Twilio does not charge you for failed messages.
       *
       * @return Amount of participants that have the **failed** delivery status for the message.
       */
    }, {
      key: "failed",
      get: function get3() {
        return this.state.failed;
      }
    }, {
      key: "_update",
      value: function _update(data2) {
        this.state = data2;
      }
    }, {
      key: "_isEquals",
      value: function _isEquals(data2) {
        var isTotalSame = this.total === data2.total;
        var isSentSame = this.sent === data2.sent;
        var isDeliveredSame = this.delivered === data2.delivered;
        var isReadSame = this.read === data2.read;
        var isUndeliveredSame = this.undelivered === data2.undelivered;
        var isFailedSame = this.failed === data2.failed;
        return isTotalSame && isSentSame && isDeliveredSame && isReadSame && isUndeliveredSame && isFailedSame;
      }
    }]);
    return AggregatedDeliveryReceipt2;
  }();
  var RestPaginator = /* @__PURE__ */ function() {
    function RestPaginator2(items, source, prevToken, nextToken) {
      _classCallCheck__default2["default"](this, RestPaginator2);
      this.state = {
        prevToken,
        nextToken,
        source,
        items
      };
    }
    _createClass__default2["default"](RestPaginator2, [{
      key: "hasNextPage",
      get: (
        /**
         * Indicates the existence of the next page.
         */
        function get3() {
          return !!this.state.nextToken;
        }
      )
      /**
       * Indicates the existence of the previous page
       */
    }, {
      key: "hasPrevPage",
      get: function get3() {
        return !!this.state.prevToken;
      }
      /**
       * Array of elements on the current page.
       */
    }, {
      key: "items",
      get: function get3() {
        return this.state.items;
      }
    }, {
      key: "nextPage",
      value: function nextPage() {
        return this.hasNextPage ? this.state.source(this.state.nextToken) : Promise.reject(new Error("No next page"));
      }
      /**
       * Request the previous page. Does not modify the existing object.
       */
    }, {
      key: "prevPage",
      value: function prevPage() {
        return this.hasPrevPage ? this.state.source(this.state.prevToken) : Promise.reject(new Error("No previous page"));
      }
    }]);
    return RestPaginator2;
  }();
  var DetailedDeliveryReceipt = /* @__PURE__ */ _createClass__default2["default"](
    /**
     * Unique identifier for the delivery receipt.
     */
    /**
     * Unique identifier for the message in the conversation.
     */
    /**
     * Unique identifier for the conversation.
     */
    /**
     * Unique identifier for the `‘channel’` message (e.g., `WAxx` for WhatsApp, `SMxx` for SMS).
     */
    /**
     * Unique identifier for the participant.
     */
    /**
     * Status of the message delivery.
     */
    /**
     * Numeric error code mapped from Status callback code. Information about the error codes can be found
     * [here](https://www.twilio.com/docs/sms/api/message-resource#delivery-related-errors).
     */
    /**
     * Date this delivery receipt was created on.
     */
    /**
     * Date this delivery receipt was last updated on.
     */
    /**
     * @internal
     */
    function DetailedDeliveryReceipt2(descriptor) {
      _classCallCheck__default2["default"](this, DetailedDeliveryReceipt2);
      this.sid = descriptor.sid;
      this.messageSid = descriptor.message_sid;
      this.conversationSid = descriptor.conversation_sid;
      this.channelMessageSid = descriptor.channel_message_sid;
      this.participantSid = descriptor.participant_sid;
      this.status = descriptor.status || "queued";
      this.errorCode = descriptor.error_code || 0;
      this.dateCreated = descriptor.date_created;
      this.dateUpdated = descriptor.date_updated;
    }
  );
  var collectActions = function collectActions2(actions) {
    return actions.map(function(action) {
      var _action$id, _action$index, _action$phone, _action$url;
      var rawData = JSON.stringify(action);
      switch (action.type) {
        case "QUICK_REPLY":
          return {
            type: "reply",
            title: action.title,
            id: (_action$id = action.id) !== null && _action$id !== void 0 ? _action$id : "",
            index: (_action$index = action.index) !== null && _action$index !== void 0 ? _action$index : 0,
            rawData
          };
        case "PHONE_NUMBER":
          return {
            type: "phone",
            title: action.title,
            phone: (_action$phone = action.phone) !== null && _action$phone !== void 0 ? _action$phone : "",
            rawData
          };
        case "URL":
          return {
            type: "url",
            title: action.title,
            url: (_action$url = action.url) !== null && _action$url !== void 0 ? _action$url : "",
            rawData
          };
        default:
          return {
            type: "other",
            rawData
          };
      }
    });
  };
  var parseVariant = function parseVariant2(type5, data2) {
    var rawData = JSON.stringify(data2);
    switch (type5) {
      case "twilio/text": {
        var variant = data2;
        return {
          type: "text",
          body: variant.body,
          rawData
        };
      }
      case "twilio/media": {
        var _variant = data2;
        return {
          type: "media",
          body: _variant.body,
          media: _variant.media,
          rawData
        };
      }
      case "twilio/location": {
        var _variant2 = data2;
        return {
          type: "location",
          longitude: _variant2.longitude,
          latitude: _variant2.latitude,
          label: _variant2.label,
          rawData
        };
      }
      case "twilio/quick-reply": {
        var _variant3 = data2;
        return {
          type: "quickReply",
          body: _variant3.body,
          replies: _variant3.actions,
          rawData
        };
      }
      case "twilio/call-to-action": {
        var _variant4 = data2;
        return {
          type: "callToAction",
          body: _variant4.body,
          actions: collectActions(_variant4.actions),
          rawData
        };
      }
      case "twilio/list-picker": {
        var _variant5 = data2;
        return {
          type: "listPicker",
          body: _variant5.body,
          button: _variant5.button,
          items: _variant5.items,
          rawData
        };
      }
      case "twilio/card": {
        var _variant6$media, _variant6$actions;
        var _variant6 = data2;
        return {
          type: "card",
          title: _variant6.title,
          subtitle: _variant6.subtitle,
          media: (_variant6$media = _variant6.media) !== null && _variant6$media !== void 0 ? _variant6$media : [],
          actions: collectActions((_variant6$actions = _variant6.actions) !== null && _variant6$actions !== void 0 ? _variant6$actions : []),
          rawData
        };
      }
      default:
        return {
          type: "other",
          rawData
        };
    }
  };
  var collectVariants = function collectVariants2(variants) {
    var variantsMap = /* @__PURE__ */ new Map();
    for (var _i = 0, _Object$entries = Object.entries(variants); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray__default2["default"](_Object$entries[_i], 2), key = _Object$entries$_i[0], value = _Object$entries$_i[1];
      variantsMap.set(key, parseVariant(key, value));
    }
    return variantsMap;
  };
  var ContentTemplateVariable = /* @__PURE__ */ function() {
    function ContentTemplateVariable2(name, value) {
      _classCallCheck__default2["default"](this, ContentTemplateVariable2);
      this.name = name;
      this.value = value;
    }
    _createClass__default2["default"](ContentTemplateVariable2, [{
      key: "copyWithValue",
      value: function copyWithValue(value) {
        return new ContentTemplateVariable2(this.name, value);
      }
    }]);
    return ContentTemplateVariable2;
  }();
  var ContentTemplate = /* @__PURE__ */ _createClass__default2["default"](
    /**
     * The server-assigned unique identifier for the template.
     */
    /**
     * Friendly name used to describe the content. Not visible to the recipient.
     */
    /**
     * Variables used by this template.
     */
    /**
     * Variants of the content. See {@link ContentData}.
     */
    /**
     * Date of creation.
     */
    /**
     * Date of the last update.
     */
    /**
     * @internal
     */
    function ContentTemplate2(contentTemplateResponse) {
      _classCallCheck__default2["default"](this, ContentTemplate2);
      this.sid = contentTemplateResponse.sid;
      this.friendlyName = contentTemplateResponse.friendly_name;
      this.variables = Object.entries(JSON.parse(contentTemplateResponse.variables)).map(function(_ref) {
        var _ref2 = _slicedToArray__default2["default"](_ref, 2), key = _ref2[0], value = _ref2[1];
        return new ContentTemplateVariable(key, value);
      });
      this.variants = collectVariants(contentTemplateResponse.variants);
      this.dateCreated = new Date(contentTemplateResponse.date_created);
      this.dateUpdated = new Date(contentTemplateResponse.date_updated);
    }
  );
  function ownKeys$4(object, enumerableOnly) {
    var keys6 = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys6.push.apply(keys6, symbols);
    }
    return keys6;
  }
  function _objectSpread$4(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$4(Object(source), true).forEach(function(key) {
        _defineProperty__default2["default"](target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _createSuper$62(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$62();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf__default2["default"](Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf__default2["default"](this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn__default2["default"](this, result);
    };
  }
  function _isNativeReflectConstruct$62() {
    if (typeof Reflect === "undefined" || !Reflect.construct)
      return false;
    if (Reflect.construct.sham)
      return false;
    if (typeof Proxy === "function")
      return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _classPrivateMethodInitSpec(obj, privateSet) {
    _checkPrivateRedeclaration(obj, privateSet);
    privateSet.add(obj);
  }
  function _checkPrivateRedeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) {
      throw new TypeError("Cannot initialize the same private elements twice on an object");
    }
  }
  function _classPrivateMethodGet(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) {
      throw new TypeError("attempted to get private field on non-instance");
    }
    return fn;
  }
  var log$3 = Logger.scope("Message");
  var XHR = (
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    global2["XMLHttpRequest"] || {}
  );
  var _wrapMedia = /* @__PURE__ */ new WeakSet();
  var _assignMedias = /* @__PURE__ */ new WeakSet();
  var Message = /* @__PURE__ */ function(_ReplayEventEmitter) {
    _inherits__default2["default"](Message2, _ReplayEventEmitter);
    var _super = _createSuper$62(Message2);
    function Message2(index2, data2, conversation, links, configuration, services) {
      var _data$text, _data$lastUpdatedBy, _data$type, _data$memberSid, _data$channelMetadata, _data$medias, _data$media;
      var _this;
      _classCallCheck__default2["default"](this, Message2);
      _this = _super.call(this);
      _classPrivateMethodInitSpec(_assertThisInitialized__default2["default"](_this), _assignMedias);
      _classPrivateMethodInitSpec(_assertThisInitialized__default2["default"](_this), _wrapMedia);
      _this.conversation = conversation;
      _this.links = links;
      _this.configuration = configuration;
      _this.services = services;
      _this.state = {
        sid: data2.sid,
        index: index2,
        author: data2.author,
        subject: data2.subject,
        contentSid: data2.contentSid,
        body: (_data$text = data2.text) !== null && _data$text !== void 0 ? _data$text : null,
        timestamp: data2.timestamp ? new Date(data2.timestamp) : null,
        dateUpdated: data2.dateUpdated ? new Date(data2.dateUpdated) : null,
        lastUpdatedBy: (_data$lastUpdatedBy = data2.lastUpdatedBy) !== null && _data$lastUpdatedBy !== void 0 ? _data$lastUpdatedBy : null,
        attributes: parseAttributes(data2.attributes, "Got malformed attributes for the message ".concat(data2.sid), log$3),
        type: (_data$type = data2.type) !== null && _data$type !== void 0 ? _data$type : "text",
        media: null,
        medias: null,
        participantSid: (_data$memberSid = data2.memberSid) !== null && _data$memberSid !== void 0 ? _data$memberSid : null,
        aggregatedDeliveryReceipt: data2.delivery ? new AggregatedDeliveryReceipt(data2.delivery) : null,
        hasChannelMetadata: (_data$channelMetadata = data2.channelMetadata) !== null && _data$channelMetadata !== void 0 ? _data$channelMetadata : false
      };
      _classPrivateMethodGet(_assertThisInitialized__default2["default"](_this), _assignMedias, _assignMedias2).call(_assertThisInitialized__default2["default"](_this), (_data$medias = data2.medias) !== null && _data$medias !== void 0 ? _data$medias : null, (_data$media = data2.media) !== null && _data$media !== void 0 ? _data$media : null);
      return _this;
    }
    _createClass__default2["default"](Message2, [{
      key: "sid",
      get: (
        /**
         * The server-assigned unique identifier for the message.
         */
        function get3() {
          return this.state.sid;
        }
      )
      /**
       * Name of the user that sent the message.
       */
    }, {
      key: "author",
      get: function get3() {
        return this.state.author;
      }
      /**
       * Message subject. Used only in email conversations.
       */
    }, {
      key: "subject",
      get: function get3() {
        return this.state.subject;
      }
      /**
       * Unique identifier of {@link ContentTemplate} for this message.
       */
    }, {
      key: "contentSid",
      get: function get3() {
        return this.state.contentSid;
      }
      /**
       * Body of the message.
       */
    }, {
      key: "body",
      get: function get3() {
        return this.state.body;
      }
      /**
       * Date this message was last updated on.
       */
    }, {
      key: "dateUpdated",
      get: function get3() {
        return this.state.dateUpdated;
      }
      /**
       * Index of this message in the conversation's list of messages.
       *
       * By design, the message indices may have arbitrary gaps between them,
       * that does not necessarily mean they were deleted or otherwise modified - just that
       * messages may have some non-contiguous indices even if they are being sent immediately one after another.
       *
       * Trying to use indices for some calculations is going to be unreliable.
       *
       * To calculate the number of unread messages, it is better to use the Read Horizon API.
       * See {@link Conversation.getUnreadMessagesCount} for details.
       */
    }, {
      key: "index",
      get: function get3() {
        return this.state.index;
      }
      /**
       * Identity of the last user that updated the message.
       */
    }, {
      key: "lastUpdatedBy",
      get: function get3() {
        return this.state.lastUpdatedBy;
      }
      /**
       * Date this message was created on.
       */
    }, {
      key: "dateCreated",
      get: function get3() {
        return this.state.timestamp;
      }
      /**
       * Custom attributes of the message.
       */
    }, {
      key: "attributes",
      get: function get3() {
        return this.state.attributes;
      }
      /**
       * Type of the message.
       */
    }, {
      key: "type",
      get: function get3() {
        return this.state.type;
      }
      /**
       * One of the attached media (if present).
       * @deprecated Use attachedMedia instead. Note that the latter is now an array.
       */
    }, {
      key: "media",
      get: function get3() {
        return this.state.media;
      }
      /**
       * Return all media attachments, except email body/history attachments, without temporary urls.
       */
    }, {
      key: "attachedMedia",
      get: function get3() {
        return this.getMediaByCategories(["media"]);
      }
      /**
       * The server-assigned unique identifier of the authoring participant.
       */
    }, {
      key: "participantSid",
      get: function get3() {
        return this.state.participantSid;
      }
      /**
       * Aggregated information about the message delivery statuses across all participants of a conversation..
       */
    }, {
      key: "aggregatedDeliveryReceipt",
      get: function get3() {
        return this.state.aggregatedDeliveryReceipt;
      }
      /**
       * @deprecated
       * Return a (possibly empty) array of media matching a specific set of categories.
       * Allowed category is so far only 'media'.
       * @param categories Array of categories to match.
       * @returns Array of media descriptors matching given categories.
       */
    }, {
      key: "getMediaByCategory",
      value: function getMediaByCategory(categories) {
        return this.getMediaByCategories(categories);
      }
      /**
       * Return a (possibly empty) array of media matching a specific set of categories.
       * Allowed category is so far only 'media'.
       * @param categories Array of categories to match.
       * @returns Array of media descriptors matching given categories.
       */
    }, {
      key: "getMediaByCategories",
      value: function getMediaByCategories(categories) {
        var _this$state$medias;
        return ((_this$state$medias = this.state.medias) !== null && _this$state$medias !== void 0 ? _this$state$medias : []).filter(function(m) {
          return categories.includes(m.category);
        });
      }
      /**
       * Get a media descriptor for an email body attachment of a provided type.
       * Allowed body types are returned in the Conversation.limits().emailBodiesAllowedContentTypes array.
       * @param type Type of email body to request, defaults to `text/plain`.
       */
    }, {
      key: "getEmailBody",
      value: function getEmailBody() {
        var _this$getMediaByCateg, _this$getMediaByCateg2;
        var type5 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "text/plain";
        return (_this$getMediaByCateg = (_this$getMediaByCateg2 = this.getMediaByCategories(["body"])) === null || _this$getMediaByCateg2 === void 0 ? void 0 : _this$getMediaByCateg2.filter(function(m) {
          return m.contentType == type5;
        }).shift()) !== null && _this$getMediaByCateg !== void 0 ? _this$getMediaByCateg : null;
      }
      /**
       * Get a media descriptor for an email history attachment of a provided type.
       * Allowed body types are returned in the Conversation.limits().emailHistoriesAllowedContentTypes array.
       * @param type Type of email history to request, defaults to `text/plain`.
       */
    }, {
      key: "getEmailHistory",
      value: function getEmailHistory() {
        var _this$getMediaByCateg3, _this$getMediaByCateg4;
        var type5 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "text/plain";
        return (_this$getMediaByCateg3 = (_this$getMediaByCateg4 = this.getMediaByCategories(["history"])) === null || _this$getMediaByCateg4 === void 0 ? void 0 : _this$getMediaByCateg4.filter(function(m) {
          return m.contentType == type5;
        }).shift()) !== null && _this$getMediaByCateg3 !== void 0 ? _this$getMediaByCateg3 : null;
      }
    }, {
      key: "_update",
      value: function _update(data2) {
        var _data$medias2, _this2 = this, _this$state$medias2, _classPrivateMethodGe2, _this$state$media;
        var updateReasons = [];
        if ((data2.text || typeof data2.text === "string") && data2.text !== this.state.body) {
          this.state.body = data2.text;
          updateReasons.push("body");
        }
        if (data2.subject && data2.subject !== this.state.subject) {
          this.state.subject = data2.subject;
          updateReasons.push("subject");
        }
        if (data2.lastUpdatedBy && data2.lastUpdatedBy !== this.state.lastUpdatedBy) {
          this.state.lastUpdatedBy = data2.lastUpdatedBy;
          updateReasons.push("lastUpdatedBy");
        }
        if (data2.author && data2.author !== this.state.author) {
          this.state.author = data2.author;
          updateReasons.push("author");
        }
        if (data2.dateUpdated && new Date(data2.dateUpdated).getTime() !== (this.state.dateUpdated && this.state.dateUpdated.getTime())) {
          this.state.dateUpdated = new Date(data2.dateUpdated);
          updateReasons.push("dateUpdated");
        }
        if (data2.timestamp && new Date(data2.timestamp).getTime() !== (this.state.timestamp && this.state.timestamp.getTime())) {
          this.state.timestamp = new Date(data2.timestamp);
          updateReasons.push("dateCreated");
        }
        var updatedAttributes = parseAttributes(data2.attributes, "Got malformed attributes for the message ".concat(this.sid), log$3);
        if (!isEqual__default["default"](this.state.attributes, updatedAttributes)) {
          this.state.attributes = updatedAttributes;
          updateReasons.push("attributes");
        }
        var updatedAggregatedDelivery = data2.delivery;
        var currentAggregatedDelivery = this.state.aggregatedDeliveryReceipt;
        var isUpdatedAggregateDeliveryValid = !!updatedAggregatedDelivery && !!updatedAggregatedDelivery.total && !!updatedAggregatedDelivery.delivered && !!updatedAggregatedDelivery.failed && !!updatedAggregatedDelivery.read && !!updatedAggregatedDelivery.sent && !!updatedAggregatedDelivery.undelivered;
        if (isUpdatedAggregateDeliveryValid) {
          if (!currentAggregatedDelivery) {
            this.state.aggregatedDeliveryReceipt = new AggregatedDeliveryReceipt(updatedAggregatedDelivery);
            updateReasons.push("deliveryReceipt");
          } else if (!currentAggregatedDelivery._isEquals(updatedAggregatedDelivery)) {
            currentAggregatedDelivery._update(updatedAggregatedDelivery);
            updateReasons.push("deliveryReceipt");
          }
        }
        var input = ((_data$medias2 = data2.medias) !== null && _data$medias2 !== void 0 ? _data$medias2 : []).map(function(value) {
          var _classPrivateMethodGe;
          return (_classPrivateMethodGe = _classPrivateMethodGet(_this2, _wrapMedia, _wrapMedia2).call(_this2, value)) === null || _classPrivateMethodGe === void 0 ? void 0 : _classPrivateMethodGe._state();
        }).filter(function(el) {
          return !(el === null);
        });
        var current = ((_this$state$medias2 = this.state.medias) !== null && _this$state$medias2 !== void 0 ? _this$state$medias2 : []).map(function(value) {
          return value._state();
        }).filter(function(el) {
          return !(el === null);
        });
        if (!isEqual__default["default"](input, current) || !isEqual__default["default"]((_classPrivateMethodGe2 = _classPrivateMethodGet(this, _wrapMedia, _wrapMedia2).call(this, data2.media)) === null || _classPrivateMethodGe2 === void 0 ? void 0 : _classPrivateMethodGe2._state(), (_this$state$media = this.state.media) === null || _this$state$media === void 0 ? void 0 : _this$state$media._state())) {
          var _data$medias3, _data$media2;
          _classPrivateMethodGet(this, _assignMedias, _assignMedias2).call(this, (_data$medias3 = data2.medias) !== null && _data$medias3 !== void 0 ? _data$medias3 : null, (_data$media2 = data2.media) !== null && _data$media2 !== void 0 ? _data$media2 : null);
          updateReasons.push("media");
        }
        if (updateReasons.length > 0) {
          this.emit("updated", {
            message: this,
            updateReasons
          });
        }
      }
      /**
       * Get the participant who is the author of the message.
       */
    }, {
      key: "getParticipant",
      value: function() {
        var _getParticipant = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee() {
          var _this3 = this;
          var participant, errorMessage;
          return _regeneratorRuntime__default2["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  participant = null;
                  if (!this.state.participantSid) {
                    _context.next = 5;
                    break;
                  }
                  _context.next = 4;
                  return this.conversation.getParticipantBySid(this.state.participantSid).catch(function() {
                    log$3.debug('Participant with sid "'.concat(_this3.participantSid, '" not found for message ').concat(_this3.sid));
                    return null;
                  });
                case 4:
                  participant = _context.sent;
                case 5:
                  if (!(!participant && this.state.author)) {
                    _context.next = 9;
                    break;
                  }
                  _context.next = 8;
                  return this.conversation.getParticipantByIdentity(this.state.author).catch(function() {
                    log$3.debug('Participant with identity "'.concat(_this3.author, '" not found for message ').concat(_this3.sid));
                    return null;
                  });
                case 8:
                  participant = _context.sent;
                case 9:
                  if (!participant) {
                    _context.next = 11;
                    break;
                  }
                  return _context.abrupt("return", participant);
                case 11:
                  errorMessage = "Participant with ";
                  if (this.state.participantSid) {
                    errorMessage += "SID '" + this.state.participantSid + "' ";
                  }
                  if (this.state.author) {
                    if (this.state.participantSid) {
                      errorMessage += "or ";
                    }
                    errorMessage += "identity '" + this.state.author + "' ";
                  }
                  if (errorMessage === "Participant with ") {
                    errorMessage = "Participant ";
                  }
                  errorMessage += "was not found";
                  throw new Error(errorMessage);
                case 17:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));
        function getParticipant() {
          return _getParticipant.apply(this, arguments);
        }
        return getParticipant;
      }()
      /**
       * Get the delivery receipts of the message.
       */
    }, {
      key: "getDetailedDeliveryReceipts",
      value: function() {
        var _getDetailedDeliveryReceipts = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee2() {
          var paginator, detailedDeliveryReceipts;
          return _regeneratorRuntime__default2["default"].wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return this._getDetailedDeliveryReceiptsPaginator();
                case 2:
                  paginator = _context2.sent;
                  detailedDeliveryReceipts = paginator.items;
                case 4:
                  if (!paginator.hasNextPage) {
                    _context2.next = 11;
                    break;
                  }
                  _context2.next = 7;
                  return paginator.nextPage();
                case 7:
                  paginator = _context2.sent;
                  detailedDeliveryReceipts = [].concat(_toConsumableArray__default2["default"](detailedDeliveryReceipts), _toConsumableArray__default2["default"](paginator.items));
                  _context2.next = 4;
                  break;
                case 11:
                  return _context2.abrupt("return", detailedDeliveryReceipts);
                case 12:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));
        function getDetailedDeliveryReceipts() {
          return _getDetailedDeliveryReceipts.apply(this, arguments);
        }
        return getDetailedDeliveryReceipts;
      }()
      /**
       * Remove the message.
       */
    }, {
      key: "remove",
      value: function() {
        var _remove = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee3() {
          return _regeneratorRuntime__default2["default"].wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return this.services.commandExecutor.mutateResource("delete", this.links.self);
                case 2:
                  return _context3.abrupt("return", this);
                case 3:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));
        function remove() {
          return _remove.apply(this, arguments);
        }
        return remove;
      }()
      /**
       * Edit the message body.
       * @param body New body of the message.
       */
    }, {
      key: "updateBody",
      value: function() {
        var _updateBody = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee4(body) {
          return _regeneratorRuntime__default2["default"].wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return this.services.commandExecutor.mutateResource("post", this.links.self, {
                    body
                  });
                case 2:
                  return _context4.abrupt("return", this);
                case 3:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));
        function updateBody(_x) {
          return _updateBody.apply(this, arguments);
        }
        return updateBody;
      }()
      /**
       * Edit the message attributes.
       * @param attributes New attributes.
       */
    }, {
      key: "updateAttributes",
      value: function() {
        var _updateAttributes = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee5(attributes) {
          return _regeneratorRuntime__default2["default"].wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return this.services.commandExecutor.mutateResource("post", this.links.self, {
                    attributes: typeof attributes !== "undefined" ? JSON.stringify(attributes) : void 0
                  });
                case 2:
                  return _context5.abrupt("return", this);
                case 3:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, this);
        }));
        function updateAttributes(_x2) {
          return _updateAttributes.apply(this, arguments);
        }
        return updateAttributes;
      }()
      /**
       * @deprecated
       * Get content URLs for all media attachments in the given set using a single operation.
       * @param contentSet Set of media attachments to query content URLs.
       */
    }, {
      key: "attachTemporaryUrlsFor",
      value: function() {
        var _attachTemporaryUrlsFor = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee6(contentSet) {
          var _this4 = this;
          var sids;
          return _regeneratorRuntime__default2["default"].wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  sids = contentSet === null || contentSet === void 0 ? void 0 : contentSet.map(function(m) {
                    return m.sid;
                  });
                  if (!(this.services.mcsClient && sids)) {
                    _context6.next = 7;
                    break;
                  }
                  _context6.next = 4;
                  return this.services.mcsClient.mediaSetGet(sids);
                case 4:
                  return _context6.abrupt("return", _context6.sent.map(function(item) {
                    return new Media(item, _this4.services);
                  }));
                case 7:
                  throw new Error("Media Content Service is unavailable");
                case 8:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6, this);
        }));
        function attachTemporaryUrlsFor(_x3) {
          return _attachTemporaryUrlsFor.apply(this, arguments);
        }
        return attachTemporaryUrlsFor;
      }()
      /**
       * Get content URLs for all media attachments in the given set using a single operation.
       * @param contentSet Set of media attachments to query content URLs.
       */
    }, {
      key: "getTemporaryContentUrlsForMedia",
      value: function getTemporaryContentUrlsForMedia(contentSet) {
        var sids = contentSet.map(function(m) {
          return m.sid;
        });
        return this.getTemporaryContentUrlsForMediaSids(sids);
      }
      /**
       * Get content URLs for all media attachments in the given set of media sids using a single operation.
       * @param mediaSids Set of media sids to query for the content URL.
       */
    }, {
      key: "getTemporaryContentUrlsForMediaSids",
      value: function getTemporaryContentUrlsForMediaSids(mediaSids) {
        var _this5 = this;
        return new mcsClient.CancellablePromise(/* @__PURE__ */ function() {
          var _ref = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee7(resolve2, reject2, onCancel) {
            var mediaGetRequest, urls;
            return _regeneratorRuntime__default2["default"].wrap(function _callee7$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    mediaGetRequest = _this5.services.mcsClient.mediaSetGetContentUrls(mediaSids !== null && mediaSids !== void 0 ? mediaSids : []);
                    if (!(!_this5.services.mcsClient || !mediaSids)) {
                      _context7.next = 4;
                      break;
                    }
                    reject2(new Error("Media Content Service is unavailable"));
                    return _context7.abrupt("return");
                  case 4:
                    onCancel(function() {
                      mediaGetRequest.cancel();
                    });
                    _context7.prev = 5;
                    _context7.next = 8;
                    return mediaGetRequest;
                  case 8:
                    urls = _context7.sent;
                    resolve2(urls);
                    _context7.next = 15;
                    break;
                  case 12:
                    _context7.prev = 12;
                    _context7.t0 = _context7["catch"](5);
                    reject2(_context7.t0);
                  case 15:
                  case "end":
                    return _context7.stop();
                }
              }
            }, _callee7, null, [[5, 12]]);
          }));
          return function(_x4, _x5, _x6) {
            return _ref.apply(this, arguments);
          };
        }());
      }
      /**
       * Get content URLs for all media attached to the message.
       */
    }, {
      key: "getTemporaryContentUrlsForAttachedMedia",
      value: function getTemporaryContentUrlsForAttachedMedia() {
        var _media$map;
        var media = this.attachedMedia;
        var sids = (_media$map = media === null || media === void 0 ? void 0 : media.map(function(m) {
          return m.sid;
        })) !== null && _media$map !== void 0 ? _media$map : [];
        return this.getTemporaryContentUrlsForMediaSids(sids);
      }
    }, {
      key: "_getDetailedDeliveryReceiptsPaginator",
      value: function() {
        var _getDetailedDeliveryReceiptsPaginator2 = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee8(options) {
          var _this6 = this;
          var messagesReceiptsUrl, url, response;
          return _regeneratorRuntime__default2["default"].wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  messagesReceiptsUrl = this.configuration.links.messagesReceipts.replace("%s", this.conversation.sid).replace("%s", this.sid);
                  url = new UriBuilder2(messagesReceiptsUrl).arg("PageToken", options === null || options === void 0 ? void 0 : options.pageToken).arg("PageSize", options === null || options === void 0 ? void 0 : options.pageSize).build();
                  _context8.next = 4;
                  return this.services.network.get(url);
                case 4:
                  response = _context8.sent;
                  return _context8.abrupt("return", new RestPaginator(response.body.delivery_receipts.map(function(x) {
                    return new DetailedDeliveryReceipt(x);
                  }), function(pageToken, pageSize) {
                    return _this6._getDetailedDeliveryReceiptsPaginator({
                      pageToken,
                      pageSize
                    });
                  }, response.body.meta.previous_token, response.body.meta.next_token));
                case 6:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8, this);
        }));
        function _getDetailedDeliveryReceiptsPaginator(_x7) {
          return _getDetailedDeliveryReceiptsPaginator2.apply(this, arguments);
        }
        return _getDetailedDeliveryReceiptsPaginator;
      }()
      /**
       * Get the {@link ContentData} for this message. Resolves to `null` when
       * {@link Message.contentSid} is null.
       */
    }, {
      key: "getContentData",
      value: function getContentData() {
        var _this7 = this;
        return new mcsClient.CancellablePromise(/* @__PURE__ */ function() {
          var _ref2 = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee9(resolve2, reject2, onCancel) {
            var bodies, twilioPrefix, filteredMedias, contentMedia, urlPromise, url, jsonStringPromise, json2, jsonString, dataType;
            return _regeneratorRuntime__default2["default"].wrap(function _callee9$(_context9) {
              while (1) {
                switch (_context9.prev = _context9.next) {
                  case 0:
                    if (!(_this7.state.contentSid === null)) {
                      _context9.next = 3;
                      break;
                    }
                    resolve2(null);
                    return _context9.abrupt("return");
                  case 3:
                    bodies = _this7.getMediaByCategories(["body"]);
                    if (!(bodies === null)) {
                      _context9.next = 7;
                      break;
                    }
                    resolve2(null);
                    return _context9.abrupt("return");
                  case 7:
                    twilioPrefix = "application/x-vnd.com.twilio.rich.";
                    filteredMedias = bodies.filter(function(media) {
                      return media.contentType.startsWith(twilioPrefix);
                    });
                    if (!(filteredMedias.length === 0)) {
                      _context9.next = 12;
                      break;
                    }
                    resolve2(null);
                    return _context9.abrupt("return");
                  case 12:
                    contentMedia = filteredMedias[0];
                    urlPromise = contentMedia.getContentTemporaryUrl();
                    onCancel(function() {
                      urlPromise.cancel();
                    });
                    _context9.prev = 15;
                    _context9.next = 18;
                    return urlPromise;
                  case 18:
                    url = _context9.sent;
                    _context9.next = 25;
                    break;
                  case 21:
                    _context9.prev = 21;
                    _context9.t0 = _context9["catch"](15);
                    reject2(_context9.t0);
                    return _context9.abrupt("return");
                  case 25:
                    if (!(url === null)) {
                      _context9.next = 28;
                      break;
                    }
                    resolve2(null);
                    return _context9.abrupt("return");
                  case 28:
                    jsonStringPromise = new Promise(function(resolve3, reject3) {
                      var _url;
                      var isCancelled = false;
                      var xhr = new XHR();
                      xhr.open("GET", (_url = url) !== null && _url !== void 0 ? _url : "", true);
                      xhr.responseType = "text";
                      xhr.onreadystatechange = function() {
                        if (xhr.readyState !== 4 || isCancelled) {
                          return;
                        }
                        resolve3(xhr.responseText);
                      };
                      xhr.onerror = function() {
                        reject3(xhr.statusText);
                      };
                      onCancel(function() {
                        isCancelled = true;
                        xhr.abort();
                        reject3(new Error("XHR has been aborted"));
                      });
                      xhr.send();
                    });
                    _context9.prev = 29;
                    _context9.next = 32;
                    return jsonStringPromise;
                  case 32:
                    jsonString = _context9.sent;
                    json2 = JSON.parse(jsonString);
                    _context9.next = 40;
                    break;
                  case 36:
                    _context9.prev = 36;
                    _context9.t1 = _context9["catch"](29);
                    reject2(_context9.t1);
                    return _context9.abrupt("return");
                  case 40:
                    dataType = contentMedia.contentType.replace(twilioPrefix, "").replace(".", "/");
                    resolve2(parseVariant(dataType, json2.data));
                  case 42:
                  case "end":
                    return _context9.stop();
                }
              }
            }, _callee9, null, [[15, 21], [29, 36]]);
          }));
          return function(_x8, _x9, _x10) {
            return _ref2.apply(this, arguments);
          };
        }());
      }
      /**
       * Get the {@link ChannelMetadata} for this message. Resolves to `null` if
       * the message doesn't have any channel metadata.
       */
    }, {
      key: "getChannelMetadata",
      value: function() {
        var _getChannelMetadata = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee10() {
          return _regeneratorRuntime__default2["default"].wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  if (this.state.hasChannelMetadata) {
                    _context10.next = 2;
                    break;
                  }
                  return _context10.abrupt("return", null);
                case 2:
                  _context10.next = 4;
                  return this.services.channelMetadataClient.getChannelMetadata(this.conversation.sid, this.sid);
                case 4:
                  return _context10.abrupt("return", _context10.sent);
                case 5:
                case "end":
                  return _context10.stop();
              }
            }
          }, _callee10, this);
        }));
        function getChannelMetadata() {
          return _getChannelMetadata.apply(this, arguments);
        }
        return getChannelMetadata;
      }()
      /**
       * Get recipients of the message.
       */
    }, {
      key: "getMessageRecipients",
      value: function() {
        var _getMessageRecipients = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee11() {
          return _regeneratorRuntime__default2["default"].wrap(function _callee11$(_context11) {
            while (1) {
              switch (_context11.prev = _context11.next) {
                case 0:
                  _context11.next = 2;
                  return this.services.messageRecipientsClient.getRecipientsFromMessage(this.conversation.sid, this.sid);
                case 2:
                  return _context11.abrupt("return", _context11.sent);
                case 3:
                case "end":
                  return _context11.stop();
              }
            }
          }, _callee11, this);
        }));
        function getMessageRecipients() {
          return _getMessageRecipients.apply(this, arguments);
        }
        return getMessageRecipients;
      }()
    }]);
    return Message2;
  }(replayEventEmitter.ReplayEventEmitter);
  function _wrapMedia2(media) {
    var category = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    return media ? category ? new Media(_objectSpread$4(_objectSpread$4({}, media), {}, {
      category
    }), this.services) : new Media(media, this.services) : null;
  }
  function _assignMedias2(medias, media) {
    var _this8 = this;
    this.state.media = _classPrivateMethodGet(this, _wrapMedia, _wrapMedia2).call(this, media);
    this.state.medias = medias ? medias.map(function(m) {
      return _classPrivateMethodGet(_this8, _wrapMedia, _wrapMedia2).call(_this8, m);
    }).filter(function(el) {
      return el !== null;
    }) : media && !medias ? [_classPrivateMethodGet(this, _wrapMedia, _wrapMedia2).call(this, media, "media")].filter(function(el) {
      return el !== null;
    }) : null;
  }
  _defineProperty__default2["default"](Message, "updated", "updated");
  __decorate2([deprecationDecorator.deprecated("getMediaByCategory", "getMediaByCategories"), __metadata2("design:type", Function), __metadata2("design:paramtypes", [Array]), __metadata2("design:returntype", Array)], Message.prototype, "getMediaByCategory", null);
  __decorate2([declarativeTypeValidator2.validateTypes([declarativeTypeValidator2.nonEmptyString, "undefined"]), __metadata2("design:type", Function), __metadata2("design:paramtypes", [Object]), __metadata2("design:returntype", Media)], Message.prototype, "getEmailBody", null);
  __decorate2([declarativeTypeValidator2.validateTypes([declarativeTypeValidator2.nonEmptyString, "undefined"]), __metadata2("design:type", Function), __metadata2("design:paramtypes", [Object]), __metadata2("design:returntype", Media)], Message.prototype, "getEmailHistory", null);
  __decorate2([declarativeTypeValidator2.validateTypesAsync("string"), __metadata2("design:type", Function), __metadata2("design:paramtypes", [String]), __metadata2("design:returntype", Promise)], Message.prototype, "updateBody", null);
  __decorate2([declarativeTypeValidator2.validateTypesAsync(json), __metadata2("design:type", Function), __metadata2("design:paramtypes", [Object]), __metadata2("design:returntype", Promise)], Message.prototype, "updateAttributes", null);
  __decorate2([deprecationDecorator.deprecated("attachTemporaryUrlsFor", "getTemporaryContentUrlsForMedia"), __metadata2("design:type", Function), __metadata2("design:paramtypes", [Array]), __metadata2("design:returntype", Promise)], Message.prototype, "attachTemporaryUrlsFor", null);
  __decorate2([declarativeTypeValidator2.validateTypesAsync(declarativeTypeValidator2.nonEmptyArray("media", Media)), __metadata2("design:type", Function), __metadata2("design:paramtypes", [Array]), __metadata2("design:returntype", mcsClient.CancellablePromise)], Message.prototype, "getTemporaryContentUrlsForMedia", null);
  __decorate2([declarativeTypeValidator2.validateTypesAsync(declarativeTypeValidator2.nonEmptyArray("strings", "string")), __metadata2("design:type", Function), __metadata2("design:paramtypes", [Array]), __metadata2("design:returntype", mcsClient.CancellablePromise)], Message.prototype, "getTemporaryContentUrlsForMediaSids", null);
  function ownKeys$32(object, enumerableOnly) {
    var keys6 = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys6.push.apply(keys6, symbols);
    }
    return keys6;
  }
  function _objectSpread$3(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$32(Object(source), true).forEach(function(key) {
        _defineProperty__default2["default"](target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$32(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _createForOfIteratorHelper$42(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
      if (Array.isArray(o) || (it = _unsupportedIterableToArray$42(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it)
          o = it;
        var i = 0;
        var F = function F2() {
        };
        return { s: F, n: function n() {
          if (i >= o.length)
            return { done: true };
          return { done: false, value: o[i++] };
        }, e: function e(_e) {
          throw _e;
        }, f: F };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return { s: function s() {
      it = it.call(o);
    }, n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    }, e: function e(_e2) {
      didErr = true;
      err = _e2;
    }, f: function f() {
      try {
        if (!normalCompletion && it.return != null)
          it.return();
      } finally {
        if (didErr)
          throw err;
      }
    } };
  }
  function _unsupportedIterableToArray$42(o, minLen) {
    if (!o)
      return;
    if (typeof o === "string")
      return _arrayLikeToArray$42(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor)
      n = o.constructor.name;
    if (n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$42(o, minLen);
  }
  function _arrayLikeToArray$42(arr, len) {
    if (len == null || len > arr.length)
      len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  }
  function _createSuper$52(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$52();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf__default2["default"](Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf__default2["default"](this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn__default2["default"](this, result);
    };
  }
  function _isNativeReflectConstruct$52() {
    if (typeof Reflect === "undefined" || !Reflect.construct)
      return false;
    if (Reflect.construct.sham)
      return false;
    if (typeof Proxy === "function")
      return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  var log$22 = Logger.scope("Messages");
  var Messages = /* @__PURE__ */ function(_ReplayEventEmitter) {
    _inherits__default2["default"](Messages2, _ReplayEventEmitter);
    var _super = _createSuper$52(Messages2);
    function Messages2(conversation, configuration, services) {
      var _this;
      _classCallCheck__default2["default"](this, Messages2);
      _this = _super.call(this);
      _this.conversation = conversation;
      _this.configuration = configuration;
      _this.services = services;
      _this.messagesByIndex = /* @__PURE__ */ new Map();
      _this.messagesListPromise = null;
      return _this;
    }
    _createClass__default2["default"](Messages2, [{
      key: "subscribe",
      value: function() {
        var _subscribe = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee(arg) {
          var _this2 = this;
          var list;
          return _regeneratorRuntime__default2["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!this.messagesListPromise) {
                    _context.next = 2;
                    break;
                  }
                  return _context.abrupt("return", this.messagesListPromise);
                case 2:
                  this.messagesListPromise = typeof arg === "string" ? this.services.syncClient.list({
                    id: arg,
                    mode: "open_existing"
                  }) : Promise.resolve(arg);
                  _context.prev = 3;
                  _context.next = 6;
                  return this.messagesListPromise;
                case 6:
                  list = _context.sent;
                  list.on("itemAdded", function(args) {
                    log$22.debug("".concat(_this2.conversation.sid, " itemAdded: ").concat(args.item.index));
                    var links = {
                      self: "".concat(_this2.conversation._links.messages, "/").concat(args.item.data.sid),
                      conversation: _this2.conversation._links.self,
                      messages_receipts: "".concat(_this2.conversation._links.messages, "/").concat(args.item.data.sid, "/Receipts")
                    };
                    var message = new Message(args.item.index, args.item.data, _this2.conversation, links, _this2.configuration, _this2.services);
                    if (_this2.messagesByIndex.has(message.index)) {
                      log$22.debug("Message arrived, but is already known and ignored", _this2.conversation.sid, message.index);
                      return;
                    }
                    _this2.messagesByIndex.set(message.index, message);
                    message.on("updated", function(args2) {
                      return _this2.emit("messageUpdated", args2);
                    });
                    _this2.emit("messageAdded", message);
                  });
                  list.on("itemRemoved", function(args) {
                    log$22.debug("#{this.conversation.sid} itemRemoved: ".concat(args.index));
                    var index2 = args.index;
                    if (_this2.messagesByIndex.has(index2)) {
                      var message = _this2.messagesByIndex.get(index2);
                      if (!message) {
                        return;
                      }
                      _this2.messagesByIndex.delete(message.index);
                      message.removeAllListeners("updated");
                      _this2.emit("messageRemoved", message);
                    }
                  });
                  list.on("itemUpdated", function(args) {
                    log$22.debug("".concat(_this2.conversation.sid, " itemUpdated: ").concat(args.item.index));
                    var message = _this2.messagesByIndex.get(args.item.index);
                    if (message) {
                      message._update(args.item.data);
                    }
                  });
                  return _context.abrupt("return", list);
                case 13:
                  _context.prev = 13;
                  _context.t0 = _context["catch"](3);
                  this.messagesListPromise = null;
                  if (this.services.syncClient.connectionState !== "disconnected") {
                    log$22.error("Failed to get messages object for conversation", this.conversation.sid, _context.t0);
                  }
                  log$22.debug("ERROR: Failed to get messages object for conversation", this.conversation.sid, _context.t0);
                  throw _context.t0;
                case 19:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this, [[3, 13]]);
        }));
        function subscribe(_x) {
          return _subscribe.apply(this, arguments);
        }
        return subscribe;
      }()
    }, {
      key: "unsubscribe",
      value: function() {
        var _unsubscribe = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee2() {
          var entity;
          return _regeneratorRuntime__default2["default"].wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (this.messagesListPromise) {
                    _context2.next = 2;
                    break;
                  }
                  return _context2.abrupt("return");
                case 2:
                  _context2.next = 4;
                  return this.messagesListPromise;
                case 4:
                  entity = _context2.sent;
                  entity.close();
                  this.messagesListPromise = null;
                case 7:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));
        function unsubscribe() {
          return _unsubscribe.apply(this, arguments);
        }
        return unsubscribe;
      }()
      /**
       * Send a message to the conversation. The message could include text and multiple media attachments.
       * @param message Message to post
       */
    }, {
      key: "sendV2",
      value: function sendV2(message) {
        var _this3 = this;
        log$22.debug("Sending message V2", message.mediaContent, message.attributes, message.emailOptions);
        return new mcsClient.CancellablePromise(/* @__PURE__ */ function() {
          var _ref = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee3(resolve2, reject2, onCancel) {
            var _message$emailOptions;
            var media, requests, _iterator, _step, _step$value, category, mediaContent, _mediaContent$content, _mediaContent$media, request, messagesPostRequest;
            return _regeneratorRuntime__default2["default"].wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    media = [];
                    requests = [];
                    onCancel(function() {
                      requests.forEach(function(request2) {
                        return request2.cancel();
                      });
                    });
                    _iterator = _createForOfIteratorHelper$42(message.mediaContent);
                    _context3.prev = 4;
                    _iterator.s();
                  case 6:
                    if ((_step = _iterator.n()).done) {
                      _context3.next = 25;
                      break;
                    }
                    _step$value = _slicedToArray__default2["default"](_step.value, 2), category = _step$value[0], mediaContent = _step$value[1];
                    _context3.prev = 8;
                    log$22.debug("Adding media to a message as ".concat(mediaContent instanceof FormData ? "FormData" : "SendMediaOptions"), mediaContent);
                    request = mediaContent instanceof FormData ? _this3.services.mcsClient.postFormData(mediaContent, category) : _this3.services.mcsClient.post((_mediaContent$content = mediaContent.contentType) !== null && _mediaContent$content !== void 0 ? _mediaContent$content : "", (_mediaContent$media = mediaContent.media) !== null && _mediaContent$media !== void 0 ? _mediaContent$media : "", category, mediaContent.filename);
                    requests.push(request);
                    _context3.t0 = media;
                    _context3.next = 15;
                    return request;
                  case 15:
                    _context3.t1 = _context3.sent;
                    _context3.t0.push.call(_context3.t0, _context3.t1);
                    _context3.next = 23;
                    break;
                  case 19:
                    _context3.prev = 19;
                    _context3.t2 = _context3["catch"](8);
                    reject2(_context3.t2);
                    return _context3.abrupt("return");
                  case 23:
                    _context3.next = 6;
                    break;
                  case 25:
                    _context3.next = 30;
                    break;
                  case 27:
                    _context3.prev = 27;
                    _context3.t3 = _context3["catch"](4);
                    _iterator.e(_context3.t3);
                  case 30:
                    _context3.prev = 30;
                    _iterator.f();
                    return _context3.finish(30);
                  case 33:
                    messagesPostRequest = _this3.services.commandExecutor.mutateResource("post", _this3.conversation._links.messages, {
                      body: message.text,
                      subject: (_message$emailOptions = message.emailOptions) === null || _message$emailOptions === void 0 ? void 0 : _message$emailOptions.subject,
                      media_sids: media.map(function(m) {
                        return m.sid;
                      }),
                      attributes: typeof message.attributes !== "undefined" ? JSON.stringify(message.attributes) : void 0,
                      content_sid: message.contentSid,
                      content_variables: typeof message.contentVariables !== "undefined" ? JSON.stringify(message.contentVariables.reduce(function(accum, current) {
                        return _objectSpread$3(_objectSpread$3({}, accum), {}, _defineProperty__default2["default"]({}, current.name, current.value));
                      }, {})) : void 0
                    });
                    _context3.prev = 34;
                    _context3.t4 = resolve2;
                    _context3.next = 38;
                    return messagesPostRequest;
                  case 38:
                    _context3.t5 = _context3.sent;
                    (0, _context3.t4)(_context3.t5);
                    _context3.next = 45;
                    break;
                  case 42:
                    _context3.prev = 42;
                    _context3.t6 = _context3["catch"](34);
                    reject2(_context3.t6);
                  case 45:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3, null, [[4, 27, 30, 33], [8, 19], [34, 42]]);
          }));
          return function(_x2, _x3, _x4) {
            return _ref.apply(this, arguments);
          };
        }());
      }
      /**
       * Send Message to the conversation
       * @param message Message to post
       * @param attributes Message attributes
       * @param emailOptions Options that modify E-mail integration behaviors.
       * @returns Returns promise which can fail
       */
    }, {
      key: "send",
      value: function() {
        var _send = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee4(message) {
          var attributes, emailOptions, _args4 = arguments;
          return _regeneratorRuntime__default2["default"].wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  attributes = _args4.length > 1 && _args4[1] !== void 0 ? _args4[1] : {};
                  emailOptions = _args4.length > 2 ? _args4[2] : void 0;
                  log$22.debug("Sending text message", message, attributes, emailOptions);
                  return _context4.abrupt("return", this.services.commandExecutor.mutateResource("post", this.conversation._links.messages, {
                    body: message !== null && message !== void 0 ? message : "",
                    attributes: typeof attributes !== "undefined" ? JSON.stringify(attributes) : void 0,
                    subject: emailOptions === null || emailOptions === void 0 ? void 0 : emailOptions.subject
                  }));
                case 4:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));
        function send(_x5) {
          return _send.apply(this, arguments);
        }
        return send;
      }()
      /**
       * Send Media Message to the conversation
       * @param mediaContent Media content to post
       * @param attributes Message attributes
       * @param emailOptions Email options
       * @returns Returns promise which can fail
       */
    }, {
      key: "sendMedia",
      value: function() {
        var _sendMedia = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee5(mediaContent) {
          var _mediaContent$content2, _mediaContent$media2;
          var attributes, emailOptions, media, _args5 = arguments;
          return _regeneratorRuntime__default2["default"].wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  attributes = _args5.length > 1 && _args5[1] !== void 0 ? _args5[1] : {};
                  emailOptions = _args5.length > 2 ? _args5[2] : void 0;
                  log$22.debug("Sending media message", mediaContent, attributes, emailOptions);
                  log$22.debug("Sending media message as ".concat(mediaContent instanceof FormData ? "FormData" : "SendMediaOptions"), mediaContent, attributes);
                  if (!(mediaContent instanceof FormData)) {
                    _context5.next = 10;
                    break;
                  }
                  _context5.next = 7;
                  return this.services.mcsClient.postFormData(mediaContent);
                case 7:
                  _context5.t0 = _context5.sent;
                  _context5.next = 13;
                  break;
                case 10:
                  _context5.next = 12;
                  return this.services.mcsClient.post((_mediaContent$content2 = mediaContent.contentType) !== null && _mediaContent$content2 !== void 0 ? _mediaContent$content2 : "", (_mediaContent$media2 = mediaContent.media) !== null && _mediaContent$media2 !== void 0 ? _mediaContent$media2 : "", "media", mediaContent.filename);
                case 12:
                  _context5.t0 = _context5.sent;
                case 13:
                  media = _context5.t0;
                  _context5.next = 16;
                  return this.services.commandExecutor.mutateResource("post", this.conversation._links.messages, {
                    media_sids: [media.sid],
                    attributes: typeof attributes !== "undefined" ? JSON.stringify(attributes) : void 0
                  });
                case 16:
                  return _context5.abrupt("return", _context5.sent);
                case 17:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, this);
        }));
        function sendMedia(_x6) {
          return _sendMedia.apply(this, arguments);
        }
        return sendMedia;
      }()
      /**
       * Returns messages from conversation using paginator interface
       * @param pageSize Number of messages to return in single chunk. By default it's 30.
       * @param anchor Most early message id which is already known, or 'end' by default
       * @param direction Pagination order 'backwards' or 'forward', 'forward' by default
       * @returns Last page of messages by default
       */
    }, {
      key: "getMessages",
      value: function() {
        var _getMessages2 = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee6(pageSize, anchor) {
          var direction, _args6 = arguments;
          return _regeneratorRuntime__default2["default"].wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  direction = _args6.length > 2 && _args6[2] !== void 0 ? _args6[2] : "backwards";
                  return _context6.abrupt("return", this._getMessages(pageSize, anchor, direction));
                case 2:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6, this);
        }));
        function getMessages(_x7, _x8) {
          return _getMessages2.apply(this, arguments);
        }
        return getMessages;
      }()
    }, {
      key: "_wrapPaginator",
      value: function _wrapPaginator(order, page, op) {
        var _this4 = this;
        var shouldReverse = order === "desc";
        var nextPage = function nextPage2() {
          return page.nextPage().then(function(page2) {
            return _this4._wrapPaginator(order, page2, op);
          });
        };
        var previousPage = function previousPage2() {
          return page.prevPage().then(function(page2) {
            return _this4._wrapPaginator(order, page2, op);
          });
        };
        return op(page.items).then(function(items) {
          return {
            items: items.sort(function(x, y) {
              return x.index - y.index;
            }),
            hasPrevPage: shouldReverse ? page.hasNextPage : page.hasPrevPage,
            hasNextPage: shouldReverse ? page.hasPrevPage : page.hasNextPage,
            prevPage: shouldReverse ? nextPage : previousPage,
            nextPage: shouldReverse ? previousPage : nextPage
          };
        });
      }
    }, {
      key: "_upsertMessage",
      value: function _upsertMessage(index2, value) {
        var _this5 = this;
        var cachedMessage = this.messagesByIndex.get(index2);
        if (cachedMessage) {
          return cachedMessage;
        }
        var links = {
          self: "".concat(this.conversation._links.messages, "/").concat(value.sid),
          conversation: this.conversation._links.self,
          messages_receipts: "".concat(this.conversation._links.messages, "/").concat(value.sid, "/Receipts")
        };
        var message = new Message(index2, value, this.conversation, links, this.configuration, this.services);
        this.messagesByIndex.set(message.index, message);
        message.on("updated", function(args) {
          return _this5.emit("messageUpdated", args);
        });
        return message;
      }
      /**
       * Returns last messages from conversation
       * @param {Number} [pageSize] Number of messages to return in single chunk. By default it's 30.
       * @param {String} [anchor] Most early message id which is already known, or 'end' by default
       * @param {String} [direction] Pagination order 'backwards' or 'forward', or 'forward' by default
       * @returns {Promise<SyncPaginator<Message>>} last page of messages by default
       * @private
       */
    }, {
      key: "_getMessages",
      value: function() {
        var _getMessages3 = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee7() {
          var _this6 = this;
          var pageSize, anchor, direction, order, list, page, _args7 = arguments;
          return _regeneratorRuntime__default2["default"].wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  pageSize = _args7.length > 0 && _args7[0] !== void 0 ? _args7[0] : 30;
                  anchor = _args7.length > 1 && _args7[1] !== void 0 ? _args7[1] : "end";
                  direction = _args7.length > 2 && _args7[2] !== void 0 ? _args7[2] : "forward";
                  order = direction === "backwards" ? "desc" : "asc";
                  _context7.next = 6;
                  return this.messagesListPromise;
                case 6:
                  list = _context7.sent;
                  _context7.next = 9;
                  return list === null || list === void 0 ? void 0 : list.getItems({
                    from: anchor !== "end" ? anchor : void 0,
                    pageSize,
                    order,
                    limit: pageSize
                    // @todo Limit equals pageSize by default in Sync. This is probably not ideal.
                  });
                case 9:
                  page = _context7.sent;
                  _context7.next = 12;
                  return this._wrapPaginator(order, page, function(items) {
                    return Promise.all(items.map(function(item) {
                      return _this6._upsertMessage(item.index, item.data);
                    }));
                  });
                case 12:
                  return _context7.abrupt("return", _context7.sent);
                case 13:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7, this);
        }));
        function _getMessages() {
          return _getMessages3.apply(this, arguments);
        }
        return _getMessages;
      }()
    }]);
    return Messages2;
  }(replayEventEmitter.ReplayEventEmitter);
  var UnsentMessage = /* @__PURE__ */ function() {
    function UnsentMessage2(messagesEntity) {
      _classCallCheck__default2["default"](this, UnsentMessage2);
      _defineProperty__default2["default"](this, "attributes", {});
      _defineProperty__default2["default"](this, "mediaContent", []);
      _defineProperty__default2["default"](this, "emailOptions", {});
      this.messagesEntity = messagesEntity;
    }
    _createClass__default2["default"](UnsentMessage2, [{
      key: "send",
      value: function send() {
        var _this = this;
        return new mcsClient.CancellablePromise(/* @__PURE__ */ function() {
          var _ref = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee(resolve2, reject2, onCancel) {
            var request, response;
            return _regeneratorRuntime__default2["default"].wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    request = _this.messagesEntity.sendV2(_this);
                    onCancel(function() {
                      return request.cancel();
                    });
                    _context.prev = 2;
                    _context.next = 5;
                    return request;
                  case 5:
                    response = _context.sent;
                    resolve2(parseToNumber(response.index));
                    _context.next = 12;
                    break;
                  case 9:
                    _context.prev = 9;
                    _context.t0 = _context["catch"](2);
                    reject2(_context.t0);
                  case 12:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, null, [[2, 9]]);
          }));
          return function(_x, _x2, _x3) {
            return _ref.apply(this, arguments);
          };
        }());
      }
    }]);
    return UnsentMessage2;
  }();
  var MessageBuilder = /* @__PURE__ */ function() {
    function MessageBuilder2(limits, messagesEntity) {
      _classCallCheck__default2["default"](this, MessageBuilder2);
      this.limits = limits;
      this.message = new UnsentMessage(messagesEntity);
      this.emailBodies = /* @__PURE__ */ new Map();
      this.emailHistories = /* @__PURE__ */ new Map();
    }
    _createClass__default2["default"](MessageBuilder2, [{
      key: "setBody",
      value: function setBody(text) {
        this.message.text = text;
        return this;
      }
      /**
       * Sets the message subject.
       * @param subject Contents of the subject.
       */
    }, {
      key: "setSubject",
      value: function setSubject(subject) {
        this.message.emailOptions.subject = subject;
        return this;
      }
      /**
       * Sets the message attributes.
       * @param attributes Message attributes.
       */
    }, {
      key: "setAttributes",
      value: function setAttributes(attributes) {
        this.message.attributes = attributes;
        return this;
      }
      /**
       * Set the email body with a given content type.
       * @param contentType Format of the body to set (text/plain or text/html).
       * @param body Body payload in the selected format.
       */
    }, {
      key: "setEmailBody",
      value: function setEmailBody(contentType, body) {
        this.emailBodies.set(contentType, body);
        return this;
      }
      /**
       * Set the email history with a given content type.
       * @param contentType Format of the history to set (text/plain or text/html).
       * @param history History payload in the selected format.
       */
    }, {
      key: "setEmailHistory",
      value: function setEmailHistory(contentType, history) {
        this.emailHistories.set(contentType, history);
        return this;
      }
      /**
       * Adds {@link ContentTemplate} SID for the message alongside optional
       * variables. When no variables provided, the default values will be used.
       *
       * Adding the content SID converts the message to a rich message. In this
       * case, other fields are ignored and the message is sent using the content
       * from the the {@link ContentTemplate}.
       *
       * Use {@link Client.getContentTemplates} to request all available
       * {@link ContentTemplate}s.
       *
       * @param contentSid SID of the {@link ContentTemplate}
       * @param variables Custom variables to resolve the template.
       */
    }, {
      key: "setContentTemplate",
      value: function setContentTemplate(contentSid) {
        var contentVariables = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
        this.message.contentSid = contentSid;
        this.message.contentVariables = contentVariables;
        return this;
      }
      /**
       * Adds media to the message.
       * @param payload Media to add.
       */
    }, {
      key: "addMedia",
      value: function addMedia(payload) {
        if (typeof FormData === "undefined" && payload instanceof FormData) {
          throw new Error("Could not add FormData content whilst not in a browser");
        }
        if (!(payload instanceof FormData)) {
          var mediaOptions = payload;
          if (!mediaOptions.contentType || !mediaOptions.media) {
            throw new Error("Media content in SendMediaOptions must contain non-empty contentType and media");
          }
        }
        this.message.mediaContent.push(["media", payload]);
        return this;
      }
      /**
       * Builds the message, making it ready to be sent.
       */
    }, {
      key: "build",
      value: function build() {
        var _this = this;
        this.emailBodies.forEach(function(_, key) {
          if (!_this.limits.emailBodiesAllowedContentTypes.includes(key)) {
            throw new Error("Unsupported email body content type ".concat(key));
          }
        });
        this.emailHistories.forEach(function(_, key) {
          if (!_this.limits.emailHistoriesAllowedContentTypes.includes(key)) {
            throw new Error("Unsupported email history content type ".concat(key));
          }
        });
        if (this.emailBodies.size > this.limits.emailBodiesAllowedContentTypes.length) {
          throw new Error("Too many email bodies attached to the message (".concat(this.emailBodies.size, " > ").concat(this.limits.emailBodiesAllowedContentTypes.length, ")"));
        }
        if (this.emailHistories.size > this.limits.emailHistoriesAllowedContentTypes.length) {
          throw new Error("Too many email histories attached to the message (".concat(this.emailHistories.size, " > ").concat(this.limits.emailHistoriesAllowedContentTypes.length, ")"));
        }
        if (this.message.mediaContent.length > this.limits.mediaAttachmentsCountLimit) {
          throw new Error("Too many media attachments in the message (".concat(this.message.mediaContent.length, " > ").concat(this.limits.mediaAttachmentsCountLimit, ")"));
        }
        this.emailBodies.forEach(function(body) {
          _this.message.mediaContent.push(["body", body]);
        });
        this.emailHistories.forEach(function(history) {
          _this.message.mediaContent.push(["history", history]);
        });
        return this.message;
      }
      /**
       * Prepares a message and sends it to the conversation.
       */
    }, {
      key: "buildAndSend",
      value: function buildAndSend() {
        return this.build().send();
      }
    }]);
    return MessageBuilder2;
  }();
  __decorate2([declarativeTypeValidator2.validateTypes("string"), __metadata2("design:type", Function), __metadata2("design:paramtypes", [String]), __metadata2("design:returntype", MessageBuilder)], MessageBuilder.prototype, "setBody", null);
  __decorate2([declarativeTypeValidator2.validateTypes("string"), __metadata2("design:type", Function), __metadata2("design:paramtypes", [String]), __metadata2("design:returntype", MessageBuilder)], MessageBuilder.prototype, "setSubject", null);
  __decorate2([declarativeTypeValidator2.validateTypes(json), __metadata2("design:type", Function), __metadata2("design:paramtypes", [Object]), __metadata2("design:returntype", MessageBuilder)], MessageBuilder.prototype, "setAttributes", null);
  __decorate2([declarativeTypeValidator2.validateTypes("string", [FormData, sendMediaOptions]), __metadata2("design:type", Function), __metadata2("design:paramtypes", [String, Object]), __metadata2("design:returntype", MessageBuilder)], MessageBuilder.prototype, "setEmailBody", null);
  __decorate2([declarativeTypeValidator2.validateTypes("string", [FormData, sendMediaOptions]), __metadata2("design:type", Function), __metadata2("design:paramtypes", [String, Object]), __metadata2("design:returntype", MessageBuilder)], MessageBuilder.prototype, "setEmailHistory", null);
  __decorate2([declarativeTypeValidator2.validateTypes("string", [declarativeTypeValidator2.array("content variables", ContentTemplateVariable), "undefined"]), __metadata2("design:type", Function), __metadata2("design:paramtypes", [String, Array]), __metadata2("design:returntype", MessageBuilder)], MessageBuilder.prototype, "setContentTemplate", null);
  __decorate2([declarativeTypeValidator2.validateTypes([FormData, sendMediaOptions]), __metadata2("design:type", Function), __metadata2("design:paramtypes", [Object]), __metadata2("design:returntype", MessageBuilder)], MessageBuilder.prototype, "addMedia", null);
  function _createForOfIteratorHelper$32(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
      if (Array.isArray(o) || (it = _unsupportedIterableToArray$32(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it)
          o = it;
        var i = 0;
        var F = function F2() {
        };
        return { s: F, n: function n() {
          if (i >= o.length)
            return { done: true };
          return { done: false, value: o[i++] };
        }, e: function e(_e) {
          throw _e;
        }, f: F };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return { s: function s() {
      it = it.call(o);
    }, n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    }, e: function e(_e2) {
      didErr = true;
      err = _e2;
    }, f: function f() {
      try {
        if (!normalCompletion && it.return != null)
          it.return();
      } finally {
        if (didErr)
          throw err;
      }
    } };
  }
  function _unsupportedIterableToArray$32(o, minLen) {
    if (!o)
      return;
    if (typeof o === "string")
      return _arrayLikeToArray$32(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor)
      n = o.constructor.name;
    if (n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$32(o, minLen);
  }
  function _arrayLikeToArray$32(arr, len) {
    if (len == null || len > arr.length)
      len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  }
  function _createSuper$42(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$42();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf__default2["default"](Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf__default2["default"](this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn__default2["default"](this, result);
    };
  }
  function _isNativeReflectConstruct$42() {
    if (typeof Reflect === "undefined" || !Reflect.construct)
      return false;
    if (Reflect.construct.sham)
      return false;
    if (typeof Proxy === "function")
      return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  var fieldMappings = {
    lastMessage: "lastMessage",
    attributes: "attributes",
    createdBy: "createdBy",
    dateCreated: "dateCreated",
    dateUpdated: "dateUpdated",
    friendlyName: "friendlyName",
    lastConsumedMessageIndex: "lastConsumedMessageIndex",
    notificationLevel: "notificationLevel",
    sid: "sid",
    status: "status",
    uniqueName: "uniqueName",
    state: "state",
    bindings: "bindings"
  };
  var Conversation = /* @__PURE__ */ function(_ReplayEventEmitter) {
    _inherits__default2["default"](Conversation2, _ReplayEventEmitter);
    var _super = _createSuper$42(Conversation2);
    function Conversation2(descriptor, sid, links, configuration, services) {
      var _descriptor$attribute, _descriptor$bindings;
      var _this;
      _classCallCheck__default2["default"](this, Conversation2);
      _this = _super.call(this);
      _this.sid = sid;
      _this._links = links;
      _this._configuration = configuration;
      _this._services = services;
      _this._entityName = descriptor.channel;
      _this._internalState = {
        uniqueName: descriptor.uniqueName || null,
        status: "notParticipating",
        attributes: (_descriptor$attribute = descriptor.attributes) !== null && _descriptor$attribute !== void 0 ? _descriptor$attribute : {},
        createdBy: descriptor.createdBy,
        dateCreated: parseTime(descriptor.dateCreated),
        dateUpdated: parseTime(descriptor.dateUpdated),
        friendlyName: descriptor.friendlyName || null,
        lastReadMessageIndex: Number.isInteger(descriptor.lastConsumedMessageIndex) ? descriptor.lastConsumedMessageIndex : null,
        bindings: (_descriptor$bindings = descriptor.bindings) !== null && _descriptor$bindings !== void 0 ? _descriptor$bindings : {}
      };
      if (descriptor.notificationLevel) {
        _this._internalState.notificationLevel = descriptor.notificationLevel;
      }
      var participantsLinks = {
        participants: _this._links.participants
      };
      _this._participants = /* @__PURE__ */ new Map();
      _this._participantsEntity = new Participants(
        _assertThisInitialized__default2["default"](_this),
        _this._participants,
        // state leak
        participantsLinks,
        _this._services
      );
      _this._participantsEntity.on(Conversation2.participantJoined, function(participant) {
        return (
          // @todo update participants map here??
          _this.emit(Conversation2.participantJoined, participant)
        );
      });
      _this._participantsEntity.on(Conversation2.participantLeft, function(participant) {
        return (
          // @todo update participants map here??
          _this.emit(Conversation2.participantLeft, participant)
        );
      });
      _this._participantsEntity.on(Conversation2.participantUpdated, function(args) {
        return (
          // @todo update participants map here??
          _this.emit(Conversation2.participantUpdated, args)
        );
      });
      _this._messagesEntity = new Messages(_assertThisInitialized__default2["default"](_this), configuration, services);
      _this._messagesEntity.on(Conversation2.messageAdded, function(message) {
        return _this._onMessageAdded(message);
      });
      _this._messagesEntity.on(Conversation2.messageUpdated, function(args) {
        return _this.emit(Conversation2.messageUpdated, args);
      });
      _this._messagesEntity.on(Conversation2.messageRemoved, function(message) {
        return _this.emit(Conversation2.messageRemoved, message);
      });
      return _this;
    }
    _createClass__default2["default"](Conversation2, [{
      key: "uniqueName",
      get: function get3() {
        return this._internalState.uniqueName;
      }
      /**
       * Status of the conversation.
       */
    }, {
      key: "status",
      get: function get3() {
        return this._internalState.status;
      }
      /**
       * Name of the conversation.
       */
    }, {
      key: "friendlyName",
      get: function get3() {
        return this._internalState.friendlyName;
      }
      /**
       * Date this conversation was last updated on.
       */
    }, {
      key: "dateUpdated",
      get: function get3() {
        return this._internalState.dateUpdated;
      }
      /**
       * Date this conversation was created on.
       */
    }, {
      key: "dateCreated",
      get: function get3() {
        return this._internalState.dateCreated;
      }
      /**
       * Identity of the user that created this conversation.
       */
    }, {
      key: "createdBy",
      get: function get3() {
        var _this$_internalState$;
        return (_this$_internalState$ = this._internalState.createdBy) !== null && _this$_internalState$ !== void 0 ? _this$_internalState$ : "";
      }
      /**
       * Custom attributes of the conversation.
       */
    }, {
      key: "attributes",
      get: function get3() {
        return this._internalState.attributes;
      }
      /**
       * Index of the last message the user has read in this conversation.
       */
    }, {
      key: "lastReadMessageIndex",
      get: function get3() {
        return this._internalState.lastReadMessageIndex;
      }
      /**
       * Last message sent to this conversation.
       */
    }, {
      key: "lastMessage",
      get: function get3() {
        var _this$_internalState$2;
        return (_this$_internalState$2 = this._internalState.lastMessage) !== null && _this$_internalState$2 !== void 0 ? _this$_internalState$2 : void 0;
      }
      /**
       * User notification level for this conversation.
       */
    }, {
      key: "notificationLevel",
      get: function get3() {
        var _this$_internalState$3;
        return (_this$_internalState$3 = this._internalState.notificationLevel) !== null && _this$_internalState$3 !== void 0 ? _this$_internalState$3 : "default";
      }
      /**
       * Conversation bindings. An undocumented feature (for now).
       * @internal
       */
    }, {
      key: "bindings",
      get: function get3() {
        return this._internalState.bindings;
      }
      /**
       * Current conversation limits.
       */
    }, {
      key: "limits",
      get: function get3() {
        return this._configuration.limits;
      }
      /**
       * State of the conversation.
       */
    }, {
      key: "state",
      get: function get3() {
        return this._internalState.state;
      }
      /**
       * Source of the conversation update.
       * @internal
       */
    }, {
      key: "_statusSource",
      get: function get3() {
        return this._dataSource;
      }
      /**
       * Preprocess the update object.
       * @param update The update object received from Sync.
       * @param conversationSid The SID of the conversation in question.
       */
    }, {
      key: "add",
      value: (
        /**
         * Add a participant to the conversation by its identity.
         * @param identity Identity of the Client to add.
         * @param attributes Attributes to be attached to the participant.
         * @returns The added participant.
         */
        function() {
          var _add = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee(identity, attributes) {
            return _regeneratorRuntime__default2["default"].wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    return _context.abrupt("return", this._participantsEntity.add(identity, attributes !== null && attributes !== void 0 ? attributes : {}));
                  case 1:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, this);
          }));
          function add(_x, _x2) {
            return _add.apply(this, arguments);
          }
          return add;
        }()
      )
      /**
       * Add a non-chat participant to the conversation.
       * @param proxyAddress Proxy (Twilio) address of the participant.
       * @param address User address of the participant.
       * @param attributes Attributes to be attached to the participant.
       * @param bindingOptions Options for adding email participants - name and
       * CC/To level.
       * @returns The added participant.
       */
    }, {
      key: "addNonChatParticipant",
      value: function() {
        var _addNonChatParticipant = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee2(proxyAddress, address) {
          var attributes, bindingOptions, _args2 = arguments;
          return _regeneratorRuntime__default2["default"].wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  attributes = _args2.length > 2 && _args2[2] !== void 0 ? _args2[2] : {};
                  bindingOptions = _args2.length > 3 && _args2[3] !== void 0 ? _args2[3] : {};
                  return _context2.abrupt("return", this._participantsEntity.addNonChatParticipant(proxyAddress, address, attributes !== null && attributes !== void 0 ? attributes : {}, bindingOptions !== null && bindingOptions !== void 0 ? bindingOptions : {}));
                case 3:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));
        function addNonChatParticipant(_x3, _x4) {
          return _addNonChatParticipant.apply(this, arguments);
        }
        return addNonChatParticipant;
      }()
      /**
       * Advance the conversation's last read message index to the current read
       * horizon. Rejects if the user is not a participant of the conversation. Last
       * read message index is updated only if the new index value is higher than
       * the previous.
       * @param index Message index to advance to.
       * @return Resulting unread messages count in the conversation.
       */
    }, {
      key: "advanceLastReadMessageIndex",
      value: function() {
        var _advanceLastReadMessageIndex = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee3(index2) {
          var _this$lastReadMessage;
          return _regeneratorRuntime__default2["default"].wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return this._subscribeStreams();
                case 2:
                  if (!(index2 < ((_this$lastReadMessage = this.lastReadMessageIndex) !== null && _this$lastReadMessage !== void 0 ? _this$lastReadMessage : 0))) {
                    _context3.next = 6;
                    break;
                  }
                  _context3.next = 5;
                  return this._setLastReadMessageIndex(this.lastReadMessageIndex);
                case 5:
                  return _context3.abrupt("return", _context3.sent);
                case 6:
                  _context3.next = 8;
                  return this._setLastReadMessageIndex(index2);
                case 8:
                  return _context3.abrupt("return", _context3.sent);
                case 9:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));
        function advanceLastReadMessageIndex(_x5) {
          return _advanceLastReadMessageIndex.apply(this, arguments);
        }
        return advanceLastReadMessageIndex;
      }()
      /**
       * Delete the conversation and unsubscribe from its events.
       */
    }, {
      key: "delete",
      value: function() {
        var _delete2 = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee4() {
          return _regeneratorRuntime__default2["default"].wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return this._services.commandExecutor.mutateResource("delete", this._links.self);
                case 2:
                  return _context4.abrupt("return", this);
                case 3:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));
        function _delete() {
          return _delete2.apply(this, arguments);
        }
        return _delete;
      }()
      /**
       * Get the custom attributes of this Conversation.
       */
    }, {
      key: "getAttributes",
      value: function() {
        var _getAttributes = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee5() {
          return _regeneratorRuntime__default2["default"].wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return this._subscribe();
                case 2:
                  return _context5.abrupt("return", this.attributes);
                case 3:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, this);
        }));
        function getAttributes() {
          return _getAttributes.apply(this, arguments);
        }
        return getAttributes;
      }()
      /**
       * Returns messages from the conversation using the paginator interface.
       * @param pageSize Number of messages to return in a single chunk. Default is
       * 30.
       * @param anchor Index of the newest message to fetch. Default is from the
       * end.
       * @param direction Query direction. By default, it queries backwards
       * from newer to older. The `"forward"` value will query in the opposite
       * direction.
       * @return A page of messages.
       */
    }, {
      key: "getMessages",
      value: function() {
        var _getMessages = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee6(pageSize, anchor, direction) {
          return _regeneratorRuntime__default2["default"].wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  _context6.next = 2;
                  return this._subscribeStreams();
                case 2:
                  return _context6.abrupt("return", this._messagesEntity.getMessages(pageSize, anchor, direction));
                case 3:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6, this);
        }));
        function getMessages(_x6, _x7, _x8) {
          return _getMessages.apply(this, arguments);
        }
        return getMessages;
      }()
      /**
       * Get a list of all the participants who are joined to this conversation.
       */
    }, {
      key: "getParticipants",
      value: function() {
        var _getParticipants = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee7() {
          return _regeneratorRuntime__default2["default"].wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  _context7.next = 2;
                  return this._subscribeStreams();
                case 2:
                  return _context7.abrupt("return", this._participantsEntity.getParticipants());
                case 3:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7, this);
        }));
        function getParticipants() {
          return _getParticipants.apply(this, arguments);
        }
        return getParticipants;
      }()
      /**
       * Get conversation participants count.
       *
       * This method is semi-realtime. This means that this data will be eventually
       * correct, but will also be possibly incorrect for a few seconds. The
       * Conversations system does not provide real time events for counter values
       * changes.
       *
       * This is useful for any UI badges, but it is not recommended to build any
       * core application logic based on these counters being accurate in real time.
       */
    }, {
      key: "getParticipantsCount",
      value: function() {
        var _getParticipantsCount = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee8() {
          var _response$body$partic;
          var url, response;
          return _regeneratorRuntime__default2["default"].wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  url = new UriBuilder2(this._configuration.links.conversations).path(this.sid).build();
                  _context8.next = 3;
                  return this._services.network.get(url);
                case 3:
                  response = _context8.sent;
                  return _context8.abrupt("return", (_response$body$partic = response.body.participants_count) !== null && _response$body$partic !== void 0 ? _response$body$partic : 0);
                case 5:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8, this);
        }));
        function getParticipantsCount() {
          return _getParticipantsCount.apply(this, arguments);
        }
        return getParticipantsCount;
      }()
      /**
       * Get a participant by its SID.
       * @param participantSid Participant SID.
       */
    }, {
      key: "getParticipantBySid",
      value: function() {
        var _getParticipantBySid = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee9(participantSid) {
          return _regeneratorRuntime__default2["default"].wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  return _context9.abrupt("return", this._participantsEntity.getParticipantBySid(participantSid));
                case 1:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9, this);
        }));
        function getParticipantBySid(_x9) {
          return _getParticipantBySid.apply(this, arguments);
        }
        return getParticipantBySid;
      }()
      /**
       * Get a participant by its identity.
       * @param identity Participant identity.
       */
    }, {
      key: "getParticipantByIdentity",
      value: function() {
        var _getParticipantByIdentity = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee10() {
          var identity, _args10 = arguments;
          return _regeneratorRuntime__default2["default"].wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  identity = _args10.length > 0 && _args10[0] !== void 0 ? _args10[0] : "";
                  return _context10.abrupt("return", this._participantsEntity.getParticipantByIdentity(identity !== null && identity !== void 0 ? identity : ""));
                case 2:
                case "end":
                  return _context10.stop();
              }
            }
          }, _callee10, this);
        }));
        function getParticipantByIdentity() {
          return _getParticipantByIdentity.apply(this, arguments);
        }
        return getParticipantByIdentity;
      }()
      /**
       * Get the total message count in the conversation.
       *
       * This method is semi-realtime. This means that this data will be eventually
       * correct, but will also be possibly incorrect for a few seconds. The
       * Conversations system does not provide real time events for counter values
       * changes.
       *
       * This is useful for any UI badges, but it is not recommended to build any
       * core application logic based on these counters being accurate in real time.
       */
    }, {
      key: "getMessagesCount",
      value: function() {
        var _getMessagesCount = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee11() {
          var _response$body$messag;
          var url, response;
          return _regeneratorRuntime__default2["default"].wrap(function _callee11$(_context11) {
            while (1) {
              switch (_context11.prev = _context11.next) {
                case 0:
                  url = new UriBuilder2(this._configuration.links.conversations).path(this.sid).build();
                  _context11.next = 3;
                  return this._services.network.get(url);
                case 3:
                  response = _context11.sent;
                  return _context11.abrupt("return", (_response$body$messag = response.body.messages_count) !== null && _response$body$messag !== void 0 ? _response$body$messag : 0);
                case 5:
                case "end":
                  return _context11.stop();
              }
            }
          }, _callee11, this);
        }));
        function getMessagesCount() {
          return _getMessagesCount.apply(this, arguments);
        }
        return getMessagesCount;
      }()
      /**
       * Get count of unread messages for the user if they are a participant of this
       * conversation. Rejects if the user is not a participant of the conversation.
       *
       * Use this method to obtain the number of unread messages together with
       * {@link Conversation.updateLastReadMessageIndex} instead of relying on the
       * message indices which may have gaps. See {@link Message.index} for details.
       *
       * This method is semi-realtime. This means that this data will be eventually
       * correct, but it will also be possibly incorrect for a few seconds. The
       * Conversations system does not provide real time events for counter values
       * changes.
       *
       * This is useful for any UI badges, but it is not recommended to build any
       * core application logic based on these counters being accurate in real time.
       *
       * If the read horizon is not set, this function will return null. This could mean
       * that all messages in the conversation are unread, or that the read horizon system
       * is not being used. How to interpret this `null` value is up to the customer application.
       *
       * @return Number of unread messages based on the current read horizon set for
       * the user or `null` if the read horizon is not set.
       */
    }, {
      key: "getUnreadMessagesCount",
      value: function() {
        var _getUnreadMessagesCount = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee12() {
          var url, response, unreadMessageCount;
          return _regeneratorRuntime__default2["default"].wrap(function _callee12$(_context12) {
            while (1) {
              switch (_context12.prev = _context12.next) {
                case 0:
                  url = new UriBuilder2(this._configuration.links.myConversations).path(this.sid).build();
                  _context12.next = 3;
                  return this._services.network.get(url);
                case 3:
                  response = _context12.sent;
                  if (!(response.body.conversation_sid !== this.sid)) {
                    _context12.next = 6;
                    break;
                  }
                  throw new Error("Conversation was not found in the user conversations list");
                case 6:
                  unreadMessageCount = response.body.unread_messages_count;
                  if (!(typeof unreadMessageCount === "number")) {
                    _context12.next = 9;
                    break;
                  }
                  return _context12.abrupt("return", unreadMessageCount);
                case 9:
                  return _context12.abrupt("return", null);
                case 10:
                case "end":
                  return _context12.stop();
              }
            }
          }, _callee12, this);
        }));
        function getUnreadMessagesCount() {
          return _getUnreadMessagesCount.apply(this, arguments);
        }
        return getUnreadMessagesCount;
      }()
      /**
       * Join the conversation and subscribe to its events.
       */
    }, {
      key: "join",
      value: function() {
        var _join = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee13() {
          return _regeneratorRuntime__default2["default"].wrap(function _callee13$(_context13) {
            while (1) {
              switch (_context13.prev = _context13.next) {
                case 0:
                  _context13.next = 2;
                  return this._services.commandExecutor.mutateResource("post", this._links.participants, {
                    identity: this._configuration.userIdentity
                  });
                case 2:
                  return _context13.abrupt("return", this);
                case 3:
                case "end":
                  return _context13.stop();
              }
            }
          }, _callee13, this);
        }));
        function join4() {
          return _join.apply(this, arguments);
        }
        return join4;
      }()
      /**
       * Leave the conversation.
       */
    }, {
      key: "leave",
      value: function() {
        var _leave = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee14() {
          return _regeneratorRuntime__default2["default"].wrap(function _callee14$(_context14) {
            while (1) {
              switch (_context14.prev = _context14.next) {
                case 0:
                  if (!(this._internalState.status === "joined")) {
                    _context14.next = 3;
                    break;
                  }
                  _context14.next = 3;
                  return this._services.commandExecutor.mutateResource("delete", "".concat(this._links.participants, "/").concat(encodeURIComponent(this._configuration.userIdentity)));
                case 3:
                  return _context14.abrupt("return", this);
                case 4:
                case "end":
                  return _context14.stop();
              }
            }
          }, _callee14, this);
        }));
        function leave() {
          return _leave.apply(this, arguments);
        }
        return leave;
      }()
      /**
       * Remove a participant from the conversation. When a string is passed as the
       * argument, it will assume that the string is an identity or SID.
       * @param participant Identity, SID or the participant object to remove.
       */
    }, {
      key: "removeParticipant",
      value: function() {
        var _removeParticipant = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee15(participant) {
          return _regeneratorRuntime__default2["default"].wrap(function _callee15$(_context15) {
            while (1) {
              switch (_context15.prev = _context15.next) {
                case 0:
                  _context15.next = 2;
                  return this._participantsEntity.remove(typeof participant === "string" ? participant : participant.sid);
                case 2:
                case "end":
                  return _context15.stop();
              }
            }
          }, _callee15, this);
        }));
        function removeParticipant(_x10) {
          return _removeParticipant.apply(this, arguments);
        }
        return removeParticipant;
      }()
      /**
       * Send a message to the conversation.
       * @param message Message body for the text message,
       * `FormData` or {@link SendMediaOptions} for media content. Sending FormData
       * is supported only with the browser engine.
       * @param messageAttributes Attributes for the message.
       * @param emailOptions Email options for the message.
       * @return Index of the new message.
       */
    }, {
      key: "sendMessage",
      value: function() {
        var _sendMessage = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee16(message, messageAttributes, emailOptions) {
          var _parseToNumber2;
          var _parseToNumber, _response, response;
          return _regeneratorRuntime__default2["default"].wrap(function _callee16$(_context16) {
            while (1) {
              switch (_context16.prev = _context16.next) {
                case 0:
                  if (!(typeof message === "string" || message === null)) {
                    _context16.next = 5;
                    break;
                  }
                  _context16.next = 3;
                  return this._messagesEntity.send(message, messageAttributes, emailOptions);
                case 3:
                  _response = _context16.sent;
                  return _context16.abrupt("return", (_parseToNumber = parseToNumber(_response.index)) !== null && _parseToNumber !== void 0 ? _parseToNumber : 0);
                case 5:
                  _context16.next = 7;
                  return this._messagesEntity.sendMedia(message, messageAttributes, emailOptions);
                case 7:
                  response = _context16.sent;
                  return _context16.abrupt("return", (_parseToNumber2 = parseToNumber(response.index)) !== null && _parseToNumber2 !== void 0 ? _parseToNumber2 : 0);
                case 9:
                case "end":
                  return _context16.stop();
              }
            }
          }, _callee16, this);
        }));
        function sendMessage(_x11, _x12, _x13) {
          return _sendMessage.apply(this, arguments);
        }
        return sendMessage;
      }()
      /**
       * New interface to prepare for sending a message.
       * Use this instead of {@link Conversation.sendMessage}.
       * @return A MessageBuilder to help set all message sending options.
       */
    }, {
      key: "prepareMessage",
      value: function prepareMessage() {
        return new MessageBuilder(this.limits, this._messagesEntity);
      }
      /**
       * Set last read message index of the conversation to the index of the last
       * known message.
       * @return Resulting unread messages count in the conversation.
       */
    }, {
      key: "setAllMessagesRead",
      value: function() {
        var _setAllMessagesRead = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee17() {
          var messagesPage;
          return _regeneratorRuntime__default2["default"].wrap(function _callee17$(_context17) {
            while (1) {
              switch (_context17.prev = _context17.next) {
                case 0:
                  _context17.next = 2;
                  return this._subscribeStreams();
                case 2:
                  _context17.next = 4;
                  return this.getMessages(1);
                case 4:
                  messagesPage = _context17.sent;
                  if (!(messagesPage.items.length > 0)) {
                    _context17.next = 7;
                    break;
                  }
                  return _context17.abrupt("return", this.advanceLastReadMessageIndex(messagesPage.items[0].index));
                case 7:
                  return _context17.abrupt("return", 0);
                case 8:
                case "end":
                  return _context17.stop();
              }
            }
          }, _callee17, this);
        }));
        function setAllMessagesRead() {
          return _setAllMessagesRead.apply(this, arguments);
        }
        return setAllMessagesRead;
      }()
      /**
       * Set all messages in the conversation unread.
       * @returns New count of unread messages after this update.
       */
    }, {
      key: "setAllMessagesUnread",
      value: function() {
        var _setAllMessagesUnread = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee18() {
          return _regeneratorRuntime__default2["default"].wrap(function _callee18$(_context18) {
            while (1) {
              switch (_context18.prev = _context18.next) {
                case 0:
                  _context18.next = 2;
                  return this._subscribeStreams();
                case 2:
                  _context18.next = 4;
                  return this._setLastReadMessageIndex(null);
                case 4:
                  return _context18.abrupt("return", _context18.sent);
                case 5:
                case "end":
                  return _context18.stop();
              }
            }
          }, _callee18, this);
        }));
        function setAllMessagesUnread() {
          return _setAllMessagesUnread.apply(this, arguments);
        }
        return setAllMessagesUnread;
      }()
      /**
       * Set user notification level for this conversation.
       * @param notificationLevel New user notification level.
       */
    }, {
      key: "setUserNotificationLevel",
      value: function() {
        var _setUserNotificationLevel = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee19(notificationLevel) {
          return _regeneratorRuntime__default2["default"].wrap(function _callee19$(_context19) {
            while (1) {
              switch (_context19.prev = _context19.next) {
                case 0:
                  _context19.next = 2;
                  return this._services.commandExecutor.mutateResource("post", "".concat(this._configuration.links.myConversations, "/").concat(this.sid), {
                    notification_level: notificationLevel
                  });
                case 2:
                case "end":
                  return _context19.stop();
              }
            }
          }, _callee19, this);
        }));
        function setUserNotificationLevel(_x14) {
          return _setUserNotificationLevel.apply(this, arguments);
        }
        return setUserNotificationLevel;
      }()
      /**
       * Send a notification to the server indicating that this client is currently
       * typing in this conversation. Typing ended notification is sent after a
       * while automatically, but by calling this method again you ensure that
       * typing ended is not received.
       */
    }, {
      key: "typing",
      value: function typing() {
        return this._services.typingIndicator.send(this.sid);
      }
      /**
       * Update the attributes of the conversation.
       * @param attributes New attributes.
       */
    }, {
      key: "updateAttributes",
      value: function() {
        var _updateAttributes = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee20(attributes) {
          return _regeneratorRuntime__default2["default"].wrap(function _callee20$(_context20) {
            while (1) {
              switch (_context20.prev = _context20.next) {
                case 0:
                  _context20.next = 2;
                  return this._services.commandExecutor.mutateResource("post", this._links.self, {
                    attributes: attributes !== void 0 ? JSON.stringify(attributes) : void 0
                  });
                case 2:
                  return _context20.abrupt("return", this);
                case 3:
                case "end":
                  return _context20.stop();
              }
            }
          }, _callee20, this);
        }));
        function updateAttributes(_x15) {
          return _updateAttributes.apply(this, arguments);
        }
        return updateAttributes;
      }()
      /**
       * Update the friendly name of the conversation.
       * @param friendlyName New friendly name.
       */
    }, {
      key: "updateFriendlyName",
      value: function() {
        var _updateFriendlyName = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee21(friendlyName) {
          return _regeneratorRuntime__default2["default"].wrap(function _callee21$(_context21) {
            while (1) {
              switch (_context21.prev = _context21.next) {
                case 0:
                  if (!(this._internalState.friendlyName !== friendlyName)) {
                    _context21.next = 3;
                    break;
                  }
                  _context21.next = 3;
                  return this._services.commandExecutor.mutateResource("post", this._links.self, {
                    friendly_name: friendlyName
                  });
                case 3:
                  return _context21.abrupt("return", this);
                case 4:
                case "end":
                  return _context21.stop();
              }
            }
          }, _callee21, this);
        }));
        function updateFriendlyName(_x16) {
          return _updateFriendlyName.apply(this, arguments);
        }
        return updateFriendlyName;
      }()
      /**
       * Set the last read message index to the current read horizon.
       * @param index Message index to set as last read. If null is provided, then
       * the behavior is identical to {@link Conversation.setAllMessagesUnread}.
       * @returns New count of unread messages after this update.
       */
    }, {
      key: "updateLastReadMessageIndex",
      value: function() {
        var _updateLastReadMessageIndex = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee22(index2) {
          return _regeneratorRuntime__default2["default"].wrap(function _callee22$(_context22) {
            while (1) {
              switch (_context22.prev = _context22.next) {
                case 0:
                  _context22.next = 2;
                  return this._subscribeStreams();
                case 2:
                  return _context22.abrupt("return", this._setLastReadMessageIndex(index2));
                case 3:
                case "end":
                  return _context22.stop();
              }
            }
          }, _callee22, this);
        }));
        function updateLastReadMessageIndex(_x17) {
          return _updateLastReadMessageIndex.apply(this, arguments);
        }
        return updateLastReadMessageIndex;
      }()
      /**
       * Update the unique name of the conversation.
       * @param uniqueName New unique name for the conversation. Setting unique name
       * to null removes it.
       */
    }, {
      key: "updateUniqueName",
      value: function() {
        var _updateUniqueName = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee23(uniqueName) {
          return _regeneratorRuntime__default2["default"].wrap(function _callee23$(_context23) {
            while (1) {
              switch (_context23.prev = _context23.next) {
                case 0:
                  if (!(this._internalState.uniqueName !== uniqueName)) {
                    _context23.next = 4;
                    break;
                  }
                  uniqueName || (uniqueName = "");
                  _context23.next = 4;
                  return this._services.commandExecutor.mutateResource("post", this._links.self, {
                    unique_name: uniqueName
                  });
                case 4:
                  return _context23.abrupt("return", this);
                case 5:
                case "end":
                  return _context23.stop();
              }
            }
          }, _callee23, this);
        }));
        function updateUniqueName(_x18) {
          return _updateUniqueName.apply(this, arguments);
        }
        return updateUniqueName;
      }()
      /**
       * Get recipients of all messages in the conversation.
       * @param options Optional configuration, set pageSize to request a specific pagination page size. Page size specifies a number of messages to include in a single batch. Each message may include multiple recipients.
       */
    }, {
      key: "getMessageRecipients",
      value: function() {
        var _getMessageRecipients = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee24(options) {
          return _regeneratorRuntime__default2["default"].wrap(function _callee24$(_context24) {
            while (1) {
              switch (_context24.prev = _context24.next) {
                case 0:
                  _context24.next = 2;
                  return this._services.messageRecipientsClient.getRecipientsFromConversation(this.sid, options);
                case 2:
                  return _context24.abrupt("return", _context24.sent);
                case 3:
                case "end":
                  return _context24.stop();
              }
            }
          }, _callee24, this);
        }));
        function getMessageRecipients(_x19) {
          return _getMessageRecipients.apply(this, arguments);
        }
        return getMessageRecipients;
      }()
      /**
       * Load and subscribe to this conversation and do not subscribe to its
       * participants and messages. This or _subscribeStreams will need to be called
       * before any events in the conversation will fire.
       * @internal
       */
    }, {
      key: "_subscribe",
      value: function() {
        var _subscribe2 = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee25() {
          var _this2 = this;
          return _regeneratorRuntime__default2["default"].wrap(function _callee25$(_context25) {
            while (1) {
              switch (_context25.prev = _context25.next) {
                case 0:
                  if (!this._entityPromise) {
                    _context25.next = 2;
                    break;
                  }
                  return _context25.abrupt("return", this._entityPromise);
                case 2:
                  this._entityPromise = this._services.syncClient.document({
                    id: this._entityName,
                    mode: "open_existing"
                  });
                  _context25.prev = 3;
                  _context25.next = 6;
                  return this._entityPromise;
                case 6:
                  this._entity = _context25.sent;
                  this._entity.on(twilioSync.SyncDocument.updated, function(args) {
                    return _this2._update(args.data);
                  });
                  this._entity.on(twilioSync.SyncDocument.removed, function() {
                    return _this2.emit(Conversation2.removed, _this2);
                  });
                  this._update(this._entity.data);
                  return _context25.abrupt("return", this._entity);
                case 13:
                  _context25.prev = 13;
                  _context25.t0 = _context25["catch"](3);
                  this._entity = null;
                  this._entityPromise = null;
                  if (this._services.syncClient.connectionState != "disconnected") {
                    Conversation2._logger.error("Failed to get conversation object", _context25.t0);
                  }
                  Conversation2._logger.debug("ERROR: Failed to get conversation object", _context25.t0);
                  throw _context25.t0;
                case 20:
                case "end":
                  return _context25.stop();
              }
            }
          }, _callee25, this, [[3, 13]]);
        }));
        function _subscribe() {
          return _subscribe2.apply(this, arguments);
        }
        return _subscribe;
      }()
      /**
       * Fetch participants and messages of the conversation. This method needs to
       * be called during conversation initialization to catch broken conversations
       * (broken conversations are conversations that have essential Sync entities
       * missing, i.e. the conversation document, the messages list or the
       * participant map). In case of this conversation being broken, the method
       * will throw an exception that will be caught and handled gracefully.
       * @internal
       */
    }, {
      key: "_fetchStreams",
      value: function() {
        var _fetchStreams2 = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee26() {
          var _this$_entity, _this$_entity2;
          var data2;
          return _regeneratorRuntime__default2["default"].wrap(function _callee26$(_context26) {
            while (1) {
              switch (_context26.prev = _context26.next) {
                case 0:
                  _context26.next = 2;
                  return this._subscribe();
                case 2:
                  Conversation2._logger.trace("_streamsAvailable, this.entity.data=", (_this$_entity = this._entity) === null || _this$_entity === void 0 ? void 0 : _this$_entity.data);
                  data2 = (_this$_entity2 = this._entity) === null || _this$_entity2 === void 0 ? void 0 : _this$_entity2.data;
                  _context26.next = 6;
                  return this._services.syncClient.list({
                    id: data2.messages,
                    mode: "open_existing"
                  });
                case 6:
                  this._messagesList = _context26.sent;
                  _context26.next = 9;
                  return this._services.syncClient.map({
                    id: data2.roster,
                    mode: "open_existing"
                  });
                case 9:
                  this._participantsMap = _context26.sent;
                case 10:
                case "end":
                  return _context26.stop();
              }
            }
          }, _callee26, this);
        }));
        function _fetchStreams() {
          return _fetchStreams2.apply(this, arguments);
        }
        return _fetchStreams;
      }()
      /**
       * Load the attributes of this conversation and instantiate its participants
       * and messages. This or _subscribe will need to be called before any events
       * on the conversation will fire. This will need to be called before any
       * events on participants or messages will fire
       * @internal
       */
    }, {
      key: "_subscribeStreams",
      value: function() {
        var _subscribeStreams2 = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee27() {
          var _this$_entity3, _this$_entity4, _this$_messagesList, _this$_participantsMa, data2, messagesObjectName, rosterObjectName;
          return _regeneratorRuntime__default2["default"].wrap(function _callee27$(_context27) {
            while (1) {
              switch (_context27.prev = _context27.next) {
                case 0:
                  _context27.prev = 0;
                  _context27.next = 3;
                  return this._subscribe();
                case 3:
                  Conversation2._logger.trace("_subscribeStreams, this.entity.data=", (_this$_entity3 = this._entity) === null || _this$_entity3 === void 0 ? void 0 : _this$_entity3.data);
                  data2 = (_this$_entity4 = this._entity) === null || _this$_entity4 === void 0 ? void 0 : _this$_entity4.data;
                  messagesObjectName = data2.messages;
                  rosterObjectName = data2.roster;
                  _context27.next = 9;
                  return Promise.all([this._messagesEntity.subscribe((_this$_messagesList = this._messagesList) !== null && _this$_messagesList !== void 0 ? _this$_messagesList : messagesObjectName), this._participantsEntity.subscribe((_this$_participantsMa = this._participantsMap) !== null && _this$_participantsMa !== void 0 ? _this$_participantsMa : rosterObjectName)]);
                case 9:
                  _context27.next = 16;
                  break;
                case 11:
                  _context27.prev = 11;
                  _context27.t0 = _context27["catch"](0);
                  if (this._services.syncClient.connectionState !== "disconnected") {
                    Conversation2._logger.error("Failed to subscribe on conversation objects", this.sid, _context27.t0);
                  }
                  Conversation2._logger.debug("ERROR: Failed to subscribe on conversation objects", this.sid, _context27.t0);
                  throw _context27.t0;
                case 16:
                case "end":
                  return _context27.stop();
              }
            }
          }, _callee27, this, [[0, 11]]);
        }));
        function _subscribeStreams() {
          return _subscribeStreams2.apply(this, arguments);
        }
        return _subscribeStreams;
      }()
      /**
       * Stop listening for and firing events on this conversation.
       * @internal
       */
    }, {
      key: "_unsubscribe",
      value: function() {
        var _unsubscribe2 = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee28() {
          return _regeneratorRuntime__default2["default"].wrap(function _callee28$(_context28) {
            while (1) {
              switch (_context28.prev = _context28.next) {
                case 0:
                  if (this._entity) {
                    this._entity.close();
                    this._entity = null;
                    this._entityPromise = null;
                  }
                  return _context28.abrupt("return", Promise.all([this._participantsEntity.unsubscribe(), this._messagesEntity.unsubscribe()]));
                case 2:
                case "end":
                  return _context28.stop();
              }
            }
          }, _callee28, this);
        }));
        function _unsubscribe() {
          return _unsubscribe2.apply(this, arguments);
        }
        return _unsubscribe;
      }()
      /**
       * Set conversation status.
       * @internal
       */
    }, {
      key: "_setStatus",
      value: function _setStatus(status, source) {
        var _this3 = this;
        this._dataSource = source;
        if (this._internalState.status === status) {
          return;
        }
        this._internalState.status = status;
        if (status === "joined") {
          this._subscribeStreams().catch(function(err) {
            Conversation2._logger.debug("ERROR while setting conversation status " + status, err);
            if (_this3._services.syncClient.connectionState !== "disconnected") {
              throw err;
            }
          });
          return;
        }
        if (this._entityPromise) {
          this._unsubscribe().catch(function(err) {
            Conversation2._logger.debug("ERROR while setting conversation status " + status, err);
            if (_this3._services.syncClient.connectionState !== "disconnected") {
              throw err;
            }
          });
        }
      }
      /**
       * Update the local conversation object with new values.
       * @internal
       */
    }, {
      key: "_update",
      value: function _update(update) {
        var _update$lastMessage, _update$lastMessage2, _this$_internalState$4, _this$_internalState$5, _this$_internalState$6;
        Conversation2._logger.trace("_update", update);
        Conversation2.preprocessUpdate(update, this.sid);
        var updateReasons = /* @__PURE__ */ new Set();
        for (var _i = 0, _Object$keys = Object.keys(update); _i < _Object$keys.length; _i++) {
          var key = _Object$keys[_i];
          var localKey = fieldMappings[key];
          if (!localKey) {
            continue;
          }
          switch (localKey) {
            case fieldMappings.status:
              if (!update.status || update.status === "unknown" || this._internalState.status === update.status) {
                break;
              }
              this._internalState.status = update.status;
              updateReasons.add(localKey);
              break;
            case fieldMappings.attributes:
              if (isEqual__default["default"](this._internalState.attributes, update.attributes)) {
                break;
              }
              this._internalState.attributes = update.attributes;
              updateReasons.add(localKey);
              break;
            case fieldMappings.lastConsumedMessageIndex:
              if (update.lastConsumedMessageIndex === void 0 || update.lastConsumedMessageIndex === this._internalState.lastReadMessageIndex) {
                break;
              }
              this._internalState.lastReadMessageIndex = update.lastConsumedMessageIndex;
              updateReasons.add("lastReadMessageIndex");
              break;
            case fieldMappings.lastMessage:
              if (this._internalState.lastMessage && !update.lastMessage) {
                delete this._internalState.lastMessage;
                updateReasons.add(localKey);
                break;
              }
              this._internalState.lastMessage = this._internalState.lastMessage || {};
              if (((_update$lastMessage = update.lastMessage) === null || _update$lastMessage === void 0 ? void 0 : _update$lastMessage.index) !== void 0 && update.lastMessage.index !== this._internalState.lastMessage.index) {
                this._internalState.lastMessage.index = update.lastMessage.index;
                updateReasons.add(localKey);
              }
              if (((_update$lastMessage2 = update.lastMessage) === null || _update$lastMessage2 === void 0 ? void 0 : _update$lastMessage2.timestamp) !== void 0 && ((_this$_internalState$4 = this._internalState.lastMessage) === null || _this$_internalState$4 === void 0 ? void 0 : (_this$_internalState$5 = _this$_internalState$4.dateCreated) === null || _this$_internalState$5 === void 0 ? void 0 : _this$_internalState$5.getTime()) !== update.lastMessage.timestamp.getTime()) {
                this._internalState.lastMessage.dateCreated = update.lastMessage.timestamp;
                updateReasons.add(localKey);
              }
              if (isEqual__default["default"](this._internalState.lastMessage, {})) {
                delete this._internalState.lastMessage;
              }
              break;
            case fieldMappings.state:
              var state = update.state || void 0;
              if (state !== void 0) {
                state.dateUpdated = new Date(state.dateUpdated);
              }
              if (isEqual__default["default"](this._internalState.state, state)) {
                break;
              }
              this._internalState.state = state;
              updateReasons.add(localKey);
              break;
            case fieldMappings.bindings:
              if (isEqual__default["default"](this._internalState.bindings, update.bindings)) {
                break;
              }
              this._internalState.bindings = update.bindings;
              updateReasons.add(localKey);
              break;
            default:
              var isDate = update[key] instanceof Date;
              var keysMatchAsDates = isDate && ((_this$_internalState$6 = this._internalState[localKey]) === null || _this$_internalState$6 === void 0 ? void 0 : _this$_internalState$6.getTime()) === update[key].getTime();
              var keysMatchAsNonDates = !isDate && this[localKey] === update[key];
              if (keysMatchAsDates || keysMatchAsNonDates) {
                break;
              }
              this._internalState[localKey] = update[key];
              updateReasons.add(localKey);
          }
        }
        if (updateReasons.size > 0) {
          this.emit(Conversation2.updated, {
            conversation: this,
            updateReasons: _toConsumableArray__default2["default"](updateReasons)
          });
        }
      }
      /**
       * Handle onMessageAdded event.
       */
    }, {
      key: "_onMessageAdded",
      value: function _onMessageAdded(message) {
        var _iterator = _createForOfIteratorHelper$32(this._participants.values()), _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done; ) {
            var participant = _step.value;
            if (participant.identity === message.author) {
              participant._endTyping();
              break;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        this.emit(Conversation2.messageAdded, message);
      }
      /**
       * Set last read message index.
       * @param index New index to set.
       */
    }, {
      key: "_setLastReadMessageIndex",
      value: function() {
        var _setLastReadMessageIndex2 = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee29(index2) {
          var result;
          return _regeneratorRuntime__default2["default"].wrap(function _callee29$(_context29) {
            while (1) {
              switch (_context29.prev = _context29.next) {
                case 0:
                  _context29.next = 2;
                  return this._services.commandExecutor.mutateResource("post", "".concat(this._configuration.links.myConversations, "/").concat(this.sid), {
                    last_read_message_index: index2
                  });
                case 2:
                  result = _context29.sent;
                  return _context29.abrupt("return", result.unread_messages_count);
                case 4:
                case "end":
                  return _context29.stop();
              }
            }
          }, _callee29, this);
        }));
        function _setLastReadMessageIndex(_x20) {
          return _setLastReadMessageIndex2.apply(this, arguments);
        }
        return _setLastReadMessageIndex;
      }()
    }], [{
      key: "preprocessUpdate",
      value: function preprocessUpdate(update, conversationSid) {
        try {
          if (typeof update.attributes === "string") {
            update.attributes = JSON.parse(update.attributes);
          } else if (update.attributes) {
            JSON.stringify(update.attributes);
          }
        } catch (e) {
          Conversation2._logger.warn("Retrieved malformed attributes from the server for conversation: " + conversationSid);
          update.attributes = {};
        }
        try {
          if (update.dateCreated) {
            update.dateCreated = new Date(update.dateCreated);
          }
        } catch (e) {
          Conversation2._logger.warn("Retrieved malformed dateCreated from the server for conversation: " + conversationSid);
          delete update.dateCreated;
        }
        try {
          if (update.dateUpdated) {
            update.dateUpdated = new Date(update.dateUpdated);
          }
        } catch (e) {
          Conversation2._logger.warn("Retrieved malformed dateUpdated from the server for conversation: " + conversationSid);
          delete update.dateUpdated;
        }
        try {
          if (update.lastMessage && update.lastMessage.timestamp) {
            update.lastMessage.timestamp = new Date(update.lastMessage.timestamp);
          }
        } catch (e) {
          Conversation2._logger.warn("Retrieved malformed lastMessage.timestamp from the server for conversation: " + conversationSid);
          delete update.lastMessage.timestamp;
        }
      }
    }]);
    return Conversation2;
  }(replayEventEmitter.ReplayEventEmitter);
  _defineProperty__default2["default"](Conversation, "participantJoined", "participantJoined");
  _defineProperty__default2["default"](Conversation, "participantLeft", "participantLeft");
  _defineProperty__default2["default"](Conversation, "participantUpdated", "participantUpdated");
  _defineProperty__default2["default"](Conversation, "messageAdded", "messageAdded");
  _defineProperty__default2["default"](Conversation, "messageRemoved", "messageRemoved");
  _defineProperty__default2["default"](Conversation, "messageUpdated", "messageUpdated");
  _defineProperty__default2["default"](Conversation, "typingEnded", "typingEnded");
  _defineProperty__default2["default"](Conversation, "typingStarted", "typingStarted");
  _defineProperty__default2["default"](Conversation, "updated", "updated");
  _defineProperty__default2["default"](Conversation, "removed", "removed");
  _defineProperty__default2["default"](Conversation, "_logger", Logger.scope("Conversation"));
  __decorate2([declarativeTypeValidator2.validateTypesAsync(declarativeTypeValidator2.nonEmptyString, optionalJson), __metadata2("design:type", Function), __metadata2("design:paramtypes", [String, Object]), __metadata2("design:returntype", Promise)], Conversation.prototype, "add", null);
  __decorate2([declarativeTypeValidator2.validateTypesAsync(declarativeTypeValidator2.nonEmptyString, declarativeTypeValidator2.nonEmptyString, optionalJson, optionalJson), __metadata2("design:type", Function), __metadata2("design:paramtypes", [String, String, Object, Object]), __metadata2("design:returntype", Promise)], Conversation.prototype, "addNonChatParticipant", null);
  __decorate2([declarativeTypeValidator2.validateTypesAsync(declarativeTypeValidator2.nonNegativeInteger), __metadata2("design:type", Function), __metadata2("design:paramtypes", [Number]), __metadata2("design:returntype", Promise)], Conversation.prototype, "advanceLastReadMessageIndex", null);
  __decorate2([declarativeTypeValidator2.validateTypesAsync(["undefined", declarativeTypeValidator2.nonNegativeInteger], ["undefined", declarativeTypeValidator2.nonNegativeInteger], ["undefined", declarativeTypeValidator2.literal("backwards", "forward")]), __metadata2("design:type", Function), __metadata2("design:paramtypes", [Number, Number, String]), __metadata2("design:returntype", Promise)], Conversation.prototype, "getMessages", null);
  __decorate2([declarativeTypeValidator2.validateTypesAsync(declarativeTypeValidator2.nonEmptyString), __metadata2("design:type", Function), __metadata2("design:paramtypes", [String]), __metadata2("design:returntype", Promise)], Conversation.prototype, "getParticipantBySid", null);
  __decorate2([declarativeTypeValidator2.validateTypesAsync(declarativeTypeValidator2.nonEmptyString), __metadata2("design:type", Function), __metadata2("design:paramtypes", [String]), __metadata2("design:returntype", Promise)], Conversation.prototype, "getParticipantByIdentity", null);
  __decorate2([declarativeTypeValidator2.validateTypesAsync([declarativeTypeValidator2.nonEmptyString, Participant]), __metadata2("design:type", Function), __metadata2("design:paramtypes", [Object]), __metadata2("design:returntype", Promise)], Conversation.prototype, "removeParticipant", null);
  __decorate2([declarativeTypeValidator2.validateTypesAsync(["string", FormData, declarativeTypeValidator2.literal(null), declarativeTypeValidator2.objectSchema("media options", {
    contentType: declarativeTypeValidator2.nonEmptyString,
    media: declarativeTypeValidator2.custom(function(value) {
      var isValid = typeof value === "string" && value.length > 0 || value instanceof Uint8Array || value instanceof ArrayBuffer;
      if (typeof Blob === "function") {
        isValid = isValid || value instanceof Blob;
      }
      return [isValid, "a non-empty string, an instance of Buffer or an instance of Blob"];
    })
  })], optionalJson, ["undefined", declarativeTypeValidator2.literal(null), declarativeTypeValidator2.objectSchema("email attributes", {
    subject: [declarativeTypeValidator2.nonEmptyString, "undefined"]
  })]), __metadata2("design:type", Function), __metadata2("design:paramtypes", [Object, Object, Object]), __metadata2("design:returntype", Promise)], Conversation.prototype, "sendMessage", null);
  __decorate2([declarativeTypeValidator2.validateTypesAsync(declarativeTypeValidator2.literal("default", "muted")), __metadata2("design:type", Function), __metadata2("design:paramtypes", [String]), __metadata2("design:returntype", Promise)], Conversation.prototype, "setUserNotificationLevel", null);
  __decorate2([declarativeTypeValidator2.validateTypesAsync(json), __metadata2("design:type", Function), __metadata2("design:paramtypes", [Object]), __metadata2("design:returntype", Promise)], Conversation.prototype, "updateAttributes", null);
  __decorate2([declarativeTypeValidator2.validateTypesAsync("string"), __metadata2("design:type", Function), __metadata2("design:paramtypes", [String]), __metadata2("design:returntype", Promise)], Conversation.prototype, "updateFriendlyName", null);
  __decorate2([declarativeTypeValidator2.validateTypesAsync([declarativeTypeValidator2.literal(null), declarativeTypeValidator2.nonNegativeInteger]), __metadata2("design:type", Function), __metadata2("design:paramtypes", [Number]), __metadata2("design:returntype", Promise)], Conversation.prototype, "updateLastReadMessageIndex", null);
  __decorate2([declarativeTypeValidator2.validateTypesAsync(["string", declarativeTypeValidator2.literal(null)]), __metadata2("design:type", Function), __metadata2("design:paramtypes", [String]), __metadata2("design:returntype", Promise)], Conversation.prototype, "updateUniqueName", null);
  var Deferred = /* @__PURE__ */ function() {
    function Deferred2() {
      var _this = this;
      _classCallCheck__default2["default"](this, Deferred2);
      this._promise = new Promise(function(resolve2, reject2) {
        _this._resolve = resolve2;
        _this._reject = reject2;
      });
    }
    _createClass__default2["default"](Deferred2, [{
      key: "promise",
      get: function get3() {
        return this._promise;
      }
    }, {
      key: "update",
      value: function update(value) {
        this._resolve(value);
      }
    }, {
      key: "set",
      value: function set4(value) {
        this.current = value;
        this._resolve(value);
      }
    }, {
      key: "fail",
      value: function fail(e) {
        this._reject(e);
      }
    }]);
    return Deferred2;
  }();
  function _createForOfIteratorHelper$22(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
      if (Array.isArray(o) || (it = _unsupportedIterableToArray$22(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it)
          o = it;
        var i = 0;
        var F = function F2() {
        };
        return { s: F, n: function n() {
          if (i >= o.length)
            return { done: true };
          return { done: false, value: o[i++] };
        }, e: function e(_e) {
          throw _e;
        }, f: F };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return { s: function s() {
      it = it.call(o);
    }, n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    }, e: function e(_e2) {
      didErr = true;
      err = _e2;
    }, f: function f() {
      try {
        if (!normalCompletion && it.return != null)
          it.return();
      } finally {
        if (didErr)
          throw err;
      }
    } };
  }
  function _unsupportedIterableToArray$22(o, minLen) {
    if (!o)
      return;
    if (typeof o === "string")
      return _arrayLikeToArray$22(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor)
      n = o.constructor.name;
    if (n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$22(o, minLen);
  }
  function _arrayLikeToArray$22(arr, len) {
    if (len == null || len > arr.length)
      len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  }
  function ownKeys$22(object, enumerableOnly) {
    var keys6 = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys6.push.apply(keys6, symbols);
    }
    return keys6;
  }
  function _objectSpread$2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$22(Object(source), true).forEach(function(key) {
        _defineProperty__default2["default"](target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$22(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _createSuper$32(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$32();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf__default2["default"](Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf__default2["default"](this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn__default2["default"](this, result);
    };
  }
  function _isNativeReflectConstruct$32() {
    if (typeof Reflect === "undefined" || !Reflect.construct)
      return false;
    if (Reflect.construct.sham)
      return false;
    if (typeof Proxy === "function")
      return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  var log$12 = Logger.scope("Conversations");
  var Conversations = /* @__PURE__ */ function(_ReplayEventEmitter) {
    _inherits__default2["default"](Conversations2, _ReplayEventEmitter);
    var _super = _createSuper$32(Conversations2);
    function Conversations2(configuration, services) {
      var _this;
      _classCallCheck__default2["default"](this, Conversations2);
      _this = _super.call(this);
      _defineProperty__default2["default"](_assertThisInitialized__default2["default"](_this), "conversations", /* @__PURE__ */ new Map());
      _defineProperty__default2["default"](_assertThisInitialized__default2["default"](_this), "myConversationsRead", new Deferred());
      _defineProperty__default2["default"](_assertThisInitialized__default2["default"](_this), "tombstones", /* @__PURE__ */ new Set());
      _defineProperty__default2["default"](_assertThisInitialized__default2["default"](_this), "myConversationsFetched", false);
      _this.configuration = configuration;
      _this.services = services;
      return _this;
    }
    _createClass__default2["default"](Conversations2, [{
      key: "addConversation",
      value: function() {
        var _addConversation2 = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee(options) {
          var _response$sid, _response$sync_object, _response$sync_object2;
          var attributes, response, conversationSid, conversationDocument, links, existingConversation, conversation;
          return _regeneratorRuntime__default2["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  attributes = typeof (options === null || options === void 0 ? void 0 : options.attributes) !== "undefined" ? options.attributes : {};
                  _context.next = 3;
                  return this.services.commandExecutor.mutateResource("post", this.configuration.links.conversations, {
                    friendly_name: options.friendlyName,
                    unique_name: options.uniqueName,
                    attributes: typeof attributes !== "undefined" ? JSON.stringify(attributes) : void 0
                  });
                case 3:
                  response = _context.sent;
                  conversationSid = (_response$sid = response.sid) !== null && _response$sid !== void 0 ? _response$sid : null;
                  conversationDocument = (_response$sync_object = (_response$sync_object2 = response.sync_objects) === null || _response$sync_object2 === void 0 ? void 0 : _response$sync_object2.conversation) !== null && _response$sync_object !== void 0 ? _response$sync_object : null;
                  links = _objectSpread$2({
                    self: response.url
                  }, response.links);
                  existingConversation = this.conversations.get(conversationSid);
                  if (!existingConversation) {
                    _context.next = 12;
                    break;
                  }
                  _context.next = 11;
                  return existingConversation._subscribe();
                case 11:
                  return _context.abrupt("return", existingConversation);
                case 12:
                  conversation = new Conversation({
                    channel: conversationDocument,
                    entityName: "",
                    uniqueName: "",
                    attributes: null,
                    createdBy: "",
                    friendlyName: "",
                    lastConsumedMessageIndex: 0,
                    dateCreated: null,
                    dateUpdated: null
                  }, conversationSid, links, this.configuration, this.services);
                  this.conversations.set(conversation.sid, conversation);
                  this._registerForEvents(conversation);
                  _context.next = 17;
                  return conversation._subscribe();
                case 17:
                  this.emit("conversationAdded", conversation);
                  return _context.abrupt("return", conversation);
                case 19:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));
        function addConversation(_x) {
          return _addConversation2.apply(this, arguments);
        }
        return addConversation;
      }()
      /**
       * Fetch conversations' list and instantiate all necessary objects
       */
    }, {
      key: "fetchConversations",
      value: function() {
        var _fetchConversations = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee2() {
          var _this2 = this;
          var map3, myConversations, upserts, _iterator, _step, conversation, errorMessage;
          return _regeneratorRuntime__default2["default"].wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.prev = 0;
                  _context2.next = 3;
                  return this._getMap();
                case 3:
                  map3 = _context2.sent;
                  map3.on(twilioSync.SyncMap.itemAdded, function(args) {
                    log$12.debug("itemAdded: ".concat(args.item.key));
                    _this2._upsertConversation("sync", args.item.key, args.item.data);
                  });
                  map3.on(twilioSync.SyncMap.itemRemoved, function(args) {
                    log$12.debug("itemRemoved: ".concat(args.key));
                    var sid = args.key;
                    if (!_this2.myConversationsFetched) {
                      _this2.tombstones.add(sid);
                    }
                    var conversation2 = _this2.conversations.get(sid);
                    if (!conversation2) {
                      return;
                    }
                    if (conversation2.status === "joined") {
                      conversation2._setStatus("notParticipating", "sync");
                      _this2.emit("conversationLeft", conversation2);
                    }
                    _this2.conversations.delete(sid);
                    _this2.emit("conversationRemoved", conversation2);
                    conversation2.emit("removed", conversation2);
                  });
                  map3.on(twilioSync.SyncMap.itemUpdated, function(args) {
                    log$12.debug("itemUpdated: ".concat(args.item.key));
                    _this2._upsertConversation("sync", args.item.key, args.item.data);
                  });
                  _context2.next = 9;
                  return this._fetchMyConversations();
                case 9:
                  myConversations = _context2.sent;
                  upserts = [];
                  _iterator = _createForOfIteratorHelper$22(myConversations);
                  try {
                    for (_iterator.s(); !(_step = _iterator.n()).done; ) {
                      conversation = _step.value;
                      upserts.push(this._upsertConversation("rest", conversation["channel_sid"], conversation));
                    }
                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }
                  this.myConversationsRead.set(true);
                  _context2.next = 16;
                  return Promise.all(upserts);
                case 16:
                  this.myConversationsFetched = true;
                  this.tombstones.clear();
                  log$12.debug("The conversations list has been successfully fetched");
                  return _context2.abrupt("return", this);
                case 22:
                  _context2.prev = 22;
                  _context2.t0 = _context2["catch"](0);
                  errorMessage = "Failed to fetch the conversations list";
                  if (this.services.syncClient.connectionState !== "disconnected") {
                    log$12.error(errorMessage, _context2.t0);
                  }
                  log$12.debug("ERROR: ".concat(errorMessage), _context2.t0);
                  throw _context2.t0;
                case 28:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this, [[0, 22]]);
        }));
        function fetchConversations() {
          return _fetchConversations.apply(this, arguments);
        }
        return fetchConversations;
      }()
    }, {
      key: "getConversations",
      value: function() {
        var _getConversations = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee3() {
          var _this3 = this;
          var conversationsMap, page;
          return _regeneratorRuntime__default2["default"].wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return this._getMap();
                case 2:
                  conversationsMap = _context3.sent;
                  _context3.next = 5;
                  return conversationsMap.getItems();
                case 5:
                  page = _context3.sent;
                  return _context3.abrupt("return", this._wrapPaginator(page, function(items) {
                    return Promise.all(items.map(function(item) {
                      return _this3._upsertConversation("sync", item.key, item.data);
                    }));
                  }));
                case 7:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));
        function getConversations() {
          return _getConversations.apply(this, arguments);
        }
        return getConversations;
      }()
    }, {
      key: "getConversation",
      value: function() {
        var _getConversation = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee4(sid) {
          var _this4 = this;
          var conversationsMap, page, items;
          return _regeneratorRuntime__default2["default"].wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return this._getMap();
                case 2:
                  conversationsMap = _context4.sent;
                  _context4.next = 5;
                  return conversationsMap.getItems({
                    key: sid
                  });
                case 5:
                  page = _context4.sent;
                  items = page.items.map(function(item) {
                    return _this4._upsertConversation("sync", item.key, item.data);
                  });
                  return _context4.abrupt("return", items.length > 0 ? items[0] : null);
                case 8:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));
        function getConversation(_x2) {
          return _getConversation.apply(this, arguments);
        }
        return getConversation;
      }()
    }, {
      key: "getConversationByUniqueName",
      value: function() {
        var _getConversationByUniqueName = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee5(uniqueName) {
          var url, response, body, sid, data2;
          return _regeneratorRuntime__default2["default"].wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  url = new UriBuilder2(this.configuration.links.myConversations).path(uniqueName).build();
                  _context5.next = 3;
                  return this.services.network.get(url);
                case 3:
                  response = _context5.sent;
                  body = response.body;
                  sid = body.conversation_sid;
                  data2 = {
                    entityName: null,
                    lastConsumedMessageIndex: body.last_read_message_index,
                    status: (body === null || body === void 0 ? void 0 : body.status) || "unknown",
                    friendlyName: body.friendly_name,
                    dateUpdated: body.date_updated,
                    dateCreated: body.date_created,
                    uniqueName: body.unique_name,
                    createdBy: body.created_by,
                    attributes: body.attributes,
                    channel: body.sync_objects.conversation,
                    notificationLevel: body === null || body === void 0 ? void 0 : body.notification_level,
                    sid
                  };
                  return _context5.abrupt("return", sid ? this._upsertConversation("sync", sid, data2) : null);
                case 8:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, this);
        }));
        function getConversationByUniqueName(_x3) {
          return _getConversationByUniqueName.apply(this, arguments);
        }
        return getConversationByUniqueName;
      }()
    }, {
      key: "peekConversation",
      value: function() {
        var _peekConversation = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee6(sid) {
          var url, response, body, data2;
          return _regeneratorRuntime__default2["default"].wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  url = new UriBuilder2(this.configuration.links.conversations).path(sid).build();
                  _context6.next = 3;
                  return this.services.network.get(url);
                case 3:
                  response = _context6.sent;
                  body = response.body;
                  data2 = {
                    entityName: null,
                    // lastConsumedMessageIndex: body.last_read_message_index,
                    status: (body === null || body === void 0 ? void 0 : body.status) || "unknown",
                    friendlyName: body.friendly_name,
                    dateUpdated: body.date_updated,
                    dateCreated: body.date_created,
                    uniqueName: body.unique_name,
                    createdBy: body.created_by,
                    attributes: body.attributes,
                    channel: "".concat(sid, ".channel"),
                    // notificationLevel: body?.notification_level,
                    sid
                  };
                  return _context6.abrupt("return", this._upsertConversation("sync", sid, data2));
                case 7:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6, this);
        }));
        function peekConversation(_x4) {
          return _peekConversation.apply(this, arguments);
        }
        return peekConversation;
      }()
    }, {
      key: "_getMap",
      value: function() {
        var _getMap2 = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee7() {
          return _regeneratorRuntime__default2["default"].wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  _context7.next = 2;
                  return this.services.syncClient.map({
                    id: this.configuration.myConversations,
                    mode: "open_existing"
                  });
                case 2:
                  return _context7.abrupt("return", _context7.sent);
                case 3:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7, this);
        }));
        function _getMap() {
          return _getMap2.apply(this, arguments);
        }
        return _getMap;
      }()
    }, {
      key: "_wrapPaginator",
      value: function() {
        var _wrapPaginator2 = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee8(page, op) {
          var _this5 = this;
          var items;
          return _regeneratorRuntime__default2["default"].wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  _context8.next = 2;
                  return op(page.items);
                case 2:
                  items = _context8.sent;
                  return _context8.abrupt("return", {
                    items: items.filter(function(item) {
                      return item !== null;
                    }),
                    hasNextPage: page.hasNextPage,
                    hasPrevPage: page.hasPrevPage,
                    nextPage: function nextPage() {
                      return page.nextPage().then(function(x) {
                        return _this5._wrapPaginator(x, op);
                      });
                    },
                    prevPage: function prevPage() {
                      return page.prevPage().then(function(x) {
                        return _this5._wrapPaginator(x, op);
                      });
                    }
                  });
                case 4:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8);
        }));
        function _wrapPaginator(_x5, _x6) {
          return _wrapPaginator2.apply(this, arguments);
        }
        return _wrapPaginator;
      }()
    }, {
      key: "_updateConversation",
      value: function() {
        var _updateConversation2 = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee9(source, conversation, data2) {
          var areSourcesDifferent, isChannelSourceSync, updateData;
          return _regeneratorRuntime__default2["default"].wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  areSourcesDifferent = conversation._statusSource !== void 0 && source !== conversation._statusSource;
                  isChannelSourceSync = source !== "rest" || conversation._statusSource === "sync";
                  if (!(areSourcesDifferent && isChannelSourceSync && source !== "sync")) {
                    _context9.next = 5;
                    break;
                  }
                  log$12.trace("upsertConversation: conversation is known from sync and came from REST, ignoring", {
                    sid: conversation.sid,
                    data: data2.status,
                    conversation: conversation.status
                  });
                  return _context9.abrupt("return");
                case 5:
                  if (!(data2.status === "joined" && conversation.status !== "joined")) {
                    _context9.next = 15;
                    break;
                  }
                  conversation._setStatus("joined", source);
                  updateData = {};
                  if (typeof data2.notificationLevel !== "undefined") {
                    updateData.notificationLevel = data2.notificationLevel;
                  }
                  if (typeof data2.lastConsumedMessageIndex !== "undefined") {
                    updateData.lastConsumedMessageIndex = data2.lastConsumedMessageIndex;
                  }
                  if (!isEqual__default["default"](updateData, {})) {
                    conversation._update(updateData);
                  }
                  _context9.next = 13;
                  return conversation._subscribe();
                case 13:
                  this.emit("conversationJoined", conversation);
                  return _context9.abrupt("return");
                case 15:
                  if (!(data2.status === "notParticipating" && conversation.status === "joined")) {
                    _context9.next = 22;
                    break;
                  }
                  conversation._setStatus("notParticipating", source);
                  conversation._update(data2);
                  _context9.next = 20;
                  return conversation._subscribe();
                case 20:
                  this.emit("conversationLeft", conversation);
                  return _context9.abrupt("return");
                case 22:
                  if (!(data2.status === "notParticipating")) {
                    _context9.next = 26;
                    break;
                  }
                  _context9.next = 25;
                  return conversation._subscribe();
                case 25:
                  return _context9.abrupt("return");
                case 26:
                  conversation._update(data2);
                case 27:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9, this);
        }));
        function _updateConversation3(_x7, _x8, _x9) {
          return _updateConversation2.apply(this, arguments);
        }
        return _updateConversation3;
      }()
    }, {
      key: "_upsertConversation",
      value: function() {
        var _upsertConversation2 = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee10(source, sid, data2) {
          var conversation, baseLink, links, newConversation;
          return _regeneratorRuntime__default2["default"].wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  log$12.trace("upsertConversation called for ".concat(sid), data2);
                  conversation = this.conversations.get(sid);
                  if (!conversation) {
                    _context10.next = 9;
                    break;
                  }
                  log$12.trace("upsertConversation: the conversation ".concat(conversation.sid, " is known;") + "its status is known from the source ".concat(conversation._statusSource, " ") + "and the update came from the source ".concat(source), conversation);
                  _context10.next = 6;
                  return this._updateConversation(source, conversation, data2);
                case 6:
                  _context10.next = 8;
                  return conversation._subscribe();
                case 8:
                  return _context10.abrupt("return", conversation);
                case 9:
                  if (!(source === "rest" && this.tombstones.has(sid))) {
                    _context10.next = 12;
                    break;
                  }
                  log$12.trace("upsertChannel: the conversation is deleted but reappeared again from REST, ignoring", sid);
                  return _context10.abrupt("return", null);
                case 12:
                  log$12.trace("upsertConversation: creating a local conversation object with sid " + sid, data2);
                  baseLink = "".concat(this.configuration.links.conversations, "/").concat(sid);
                  links = {
                    self: baseLink,
                    messages: "".concat(baseLink, "/Messages"),
                    participants: "".concat(baseLink, "/Participants")
                  };
                  newConversation = new Conversation(data2, sid, links, this.configuration, this.services);
                  this.conversations.set(sid, newConversation);
                  _context10.prev = 17;
                  _context10.next = 20;
                  return newConversation._subscribe();
                case 20:
                  if (!(data2.status === "joined")) {
                    _context10.next = 23;
                    break;
                  }
                  _context10.next = 23;
                  return newConversation._fetchStreams();
                case 23:
                  _context10.next = 32;
                  break;
                case 25:
                  _context10.prev = 25;
                  _context10.t0 = _context10["catch"](17);
                  if (!(_context10.t0.name !== "SyncError")) {
                    _context10.next = 29;
                    break;
                  }
                  throw _context10.t0;
                case 29:
                  log$12.trace("upsertChannel: the conversation is missing some Sync entity(ies), ignoring", sid, _context10.t0);
                  this.conversations.delete(sid);
                  return _context10.abrupt("return", null);
                case 32:
                  this._registerForEvents(newConversation);
                  this.emit("conversationAdded", newConversation);
                  if (data2.status === "joined") {
                    newConversation._setStatus("joined", source);
                    this.emit("conversationJoined", newConversation);
                  }
                  return _context10.abrupt("return", newConversation);
                case 36:
                case "end":
                  return _context10.stop();
              }
            }
          }, _callee10, this, [[17, 25]]);
        }));
        function _upsertConversation(_x10, _x11, _x12) {
          return _upsertConversation2.apply(this, arguments);
        }
        return _upsertConversation;
      }()
    }, {
      key: "_fetchMyConversations",
      value: function() {
        var _fetchMyConversations2 = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee11() {
          var conversations, pageToken, _response$body, url, response, receivedConversations;
          return _regeneratorRuntime__default2["default"].wrap(function _callee11$(_context11) {
            while (1) {
              switch (_context11.prev = _context11.next) {
                case 0:
                  conversations = [];
                  pageToken = null;
                case 2:
                  url = new UriBuilder2(this.configuration.links.myConversations);
                  if (pageToken) {
                    url.arg("PageToken", pageToken);
                  }
                  _context11.next = 6;
                  return this.services.network.get(url.build());
                case 6:
                  response = _context11.sent;
                  receivedConversations = (_response$body = response.body) === null || _response$body === void 0 ? void 0 : _response$body.conversations.map(function(conversationDescriptor) {
                    return {
                      descriptor: conversationDescriptor,
                      channel_sid: conversationDescriptor.conversation_sid,
                      status: conversationDescriptor.status,
                      channel: conversationDescriptor.sync_objects.conversation,
                      messages: conversationDescriptor.sync_objects.messages,
                      roster: "".concat(conversationDescriptor.conversation_sid, ".roster"),
                      lastConsumedMessageIndex: conversationDescriptor.last_read_message_index,
                      notificationLevel: conversationDescriptor.notification_level
                    };
                  });
                  pageToken = response.body.meta.next_token;
                  conversations = [].concat(_toConsumableArray__default2["default"](conversations), _toConsumableArray__default2["default"](receivedConversations));
                case 10:
                  if (pageToken) {
                    _context11.next = 2;
                    break;
                  }
                case 11:
                  return _context11.abrupt("return", conversations);
                case 12:
                case "end":
                  return _context11.stop();
              }
            }
          }, _callee11, this);
        }));
        function _fetchMyConversations() {
          return _fetchMyConversations2.apply(this, arguments);
        }
        return _fetchMyConversations;
      }()
    }, {
      key: "_onConversationRemoved",
      value: function _onConversationRemoved(sid) {
        var conversation = this.conversations.get(sid);
        if (conversation) {
          this.conversations.delete(sid);
          this.emit("conversationRemoved", conversation);
        }
      }
    }, {
      key: "_registerForEvents",
      value: function _registerForEvents(conversation) {
        var _this6 = this;
        conversation.on("removed", function() {
          return _this6._onConversationRemoved(conversation.sid);
        });
        conversation.on("updated", function(args) {
          return _this6.emit("conversationUpdated", args);
        });
        conversation.on("participantJoined", function(participant) {
          return _this6.emit("participantJoined", participant);
        });
        conversation.on("participantLeft", function(participant) {
          return _this6.emit("participantLeft", participant);
        });
        conversation.on("participantUpdated", function(args) {
          return _this6.emit("participantUpdated", args);
        });
        conversation.on("messageAdded", function(message) {
          return _this6.emit("messageAdded", message);
        });
        conversation.on("messageUpdated", function(args) {
          return _this6.emit("messageUpdated", args);
        });
        conversation.on("messageRemoved", function(message) {
          return _this6.emit("messageRemoved", message);
        });
        conversation.on("typingStarted", function(participant) {
          return _this6.emit("typingStarted", participant);
        });
        conversation.on("typingEnded", function(participant) {
          return _this6.emit("typingEnded", participant);
        });
      }
    }]);
    return Conversations2;
  }(replayEventEmitter.ReplayEventEmitter);
  function _createSuper$22(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$22();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf__default2["default"](Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf__default2["default"](this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn__default2["default"](this, result);
    };
  }
  function _isNativeReflectConstruct$22() {
    if (typeof Reflect === "undefined" || !Reflect.construct)
      return false;
    if (Reflect.construct.sham)
      return false;
    if (typeof Proxy === "function")
      return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  var Users = /* @__PURE__ */ function(_ReplayEventEmitter) {
    _inherits__default2["default"](Users2, _ReplayEventEmitter);
    var _super = _createSuper$22(Users2);
    function Users2(myself, configuration, services) {
      var _this;
      _classCallCheck__default2["default"](this, Users2);
      _this = _super.call(this);
      _this.configuration = configuration;
      _this.services = services;
      _this.fifoStack = [];
      _this.myself = myself;
      _this.myself.on("updated", function(args) {
        return _this.emit("userUpdated", args);
      });
      _this.myself.on("userSubscribed", function() {
        return _this.emit("userSubscribed", _this.myself);
      });
      _this.myself.on("userUnsubscribed", function() {
        _this.emit("userUnsubscribed", _this.myself);
        _this.myself._ensureFetched();
      });
      _this.subscribedUsers = /* @__PURE__ */ new Map();
      return _this;
    }
    _createClass__default2["default"](Users2, [{
      key: "handleUnsubscribeUser",
      value: function handleUnsubscribeUser(user) {
        if (this.subscribedUsers.has(user.identity)) {
          this.subscribedUsers.delete(user.identity);
        }
        var foundItemIndex = 0;
        var foundItem = this.fifoStack.find(function(item, index2) {
          if (item == user.identity) {
            foundItemIndex = index2;
            return true;
          }
          return false;
        });
        if (foundItem) {
          this.fifoStack.splice(foundItemIndex, 1);
        }
        this.emit("userUnsubscribed", user);
      }
    }, {
      key: "handleSubscribeUser",
      value: function handleSubscribeUser(user) {
        if (this.subscribedUsers.has(user.identity)) {
          return;
        }
        if (this.fifoStack.length >= this.configuration.userInfosToSubscribe) {
          var _this$subscribedUsers, _this$subscribedUsers2;
          var item = this.fifoStack.shift();
          (_this$subscribedUsers = this.subscribedUsers) === null || _this$subscribedUsers === void 0 ? void 0 : (_this$subscribedUsers2 = _this$subscribedUsers.get(item)) === null || _this$subscribedUsers2 === void 0 ? void 0 : _this$subscribedUsers2.unsubscribe();
        }
        this.fifoStack.push(user.identity);
        this.subscribedUsers.set(user.identity, user);
        this.emit("userSubscribed", user);
      }
      /**
       * Gets user, if it's in subscribed list - then return the user object from it,
       * if not - then subscribes and adds user to the FIFO stack
       * @returns {Promise<User>} Fully initialized user
       */
    }, {
      key: "getUser",
      value: function() {
        var _getUser = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee(identity, entityName) {
          var _entityName, _this2 = this;
          var user, newUser;
          return _regeneratorRuntime__default2["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return this.myself._ensureFetched();
                case 2:
                  if (!(identity == this.myself.identity)) {
                    _context.next = 4;
                    break;
                  }
                  return _context.abrupt("return", this.myself);
                case 4:
                  user = this.subscribedUsers.get(identity);
                  if (!user) {
                    _context.next = 7;
                    break;
                  }
                  return _context.abrupt("return", user);
                case 7:
                  if (!((_entityName = entityName) !== null && _entityName !== void 0)) {
                    _context.next = 11;
                    break;
                  }
                  _context.next = 14;
                  break;
                case 11:
                  _context.next = 13;
                  return this.getSyncUniqueName(identity);
                case 13:
                  entityName = _context.sent;
                case 14:
                  newUser = new User(identity, entityName, this.configuration, this.services);
                  newUser.on("updated", function(args) {
                    return _this2.emit("userUpdated", args);
                  });
                  newUser.on("userSubscribed", function() {
                    return _this2.handleSubscribeUser(newUser);
                  });
                  newUser.on("userUnsubscribed", function() {
                    return _this2.handleUnsubscribeUser(newUser);
                  });
                  _context.next = 20;
                  return newUser._ensureFetched();
                case 20:
                  return _context.abrupt("return", newUser);
                case 21:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));
        function getUser(_x, _x2) {
          return _getUser.apply(this, arguments);
        }
        return getUser;
      }()
      /**
       * @returns {Promise<Array<User>>} returns list of subscribed User objects {@see User}
       */
    }, {
      key: "getSubscribedUsers",
      value: function() {
        var _getSubscribedUsers = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee2() {
          var users;
          return _regeneratorRuntime__default2["default"].wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return this.myself._ensureFetched();
                case 2:
                  users = [this.myself];
                  this.subscribedUsers.forEach(function(user) {
                    return users.push(user);
                  });
                  return _context2.abrupt("return", users);
                case 5:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));
        function getSubscribedUsers() {
          return _getSubscribedUsers.apply(this, arguments);
        }
        return getSubscribedUsers;
      }()
      /**
       * @returns {Promise<string>} User's sync unique name
       */
    }, {
      key: "getSyncUniqueName",
      value: function() {
        var _getSyncUniqueName = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee3(identity) {
          var _response$body$sync_o, _response$body;
          var url, response;
          return _regeneratorRuntime__default2["default"].wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  url = new UriBuilder2(this.configuration.links.users).path(identity).build();
                  _context3.next = 3;
                  return this.services.network.get(url);
                case 3:
                  response = _context3.sent;
                  return _context3.abrupt("return", (_response$body$sync_o = (_response$body = response.body) === null || _response$body === void 0 ? void 0 : _response$body.sync_objects.user_info_map) !== null && _response$body$sync_o !== void 0 ? _response$body$sync_o : "");
                case 5:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));
        function getSyncUniqueName(_x3) {
          return _getSyncUniqueName.apply(this, arguments);
        }
        return getSyncUniqueName;
      }()
    }]);
    return Users2;
  }(replayEventEmitter.ReplayEventEmitter);
  var log2 = Logger.scope("TypingIndicator");
  var TypingIndicator = /* @__PURE__ */ function() {
    function TypingIndicator2(getConversation, config, services) {
      _classCallCheck__default2["default"](this, TypingIndicator2);
      this.configuration = config;
      this.services = services;
      this.getConversation = getConversation;
      this.serviceTypingTimeout = null;
      this.sentUpdates = /* @__PURE__ */ new Map();
    }
    _createClass__default2["default"](TypingIndicator2, [{
      key: "typingTimeout",
      get: function get3() {
        return this.configuration.typingIndicatorTimeoutOverride || this.serviceTypingTimeout || this.configuration.typingIndicatorTimeoutDefault;
      }
      /**
       * Initialize TypingIndicator controller
       * Registers for needed message types and sets listeners
       * @private
       */
    }, {
      key: "initialize",
      value: function initialize() {
        var _this = this;
        this.services.notificationClient.on("message", /* @__PURE__ */ function() {
          var _ref = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee(type5, message) {
            return _regeneratorRuntime__default2["default"].wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    if (!(type5 === NotificationTypes.TYPING_INDICATOR)) {
                      _context.next = 3;
                      break;
                    }
                    _context.next = 3;
                    return _this._handleRemoteTyping(message);
                  case 3:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));
          return function(_x, _x2) {
            return _ref.apply(this, arguments);
          };
        }());
      }
      /**
       * Remote participants typing events handler
       */
    }, {
      key: "_handleRemoteTyping",
      value: function() {
        var _handleRemoteTyping2 = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee2(message) {
          var _this2 = this;
          return _regeneratorRuntime__default2["default"].wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  log2.trace("Got new typing indicator ", message);
                  this.getConversation(message.channel_sid).then(function(conversation) {
                    if (!conversation) {
                      return;
                    }
                    conversation._participants.forEach(function(participant) {
                      if (participant.identity !== message.identity) {
                        return;
                      }
                      var timeout = _this2.configuration.typingIndicatorTimeoutOverride ? _this2.configuration.typingIndicatorTimeoutOverride + 1e3 : message.typing_timeout * 1e3;
                      participant._startTyping(timeout);
                    });
                  }).catch(function(err) {
                    log2.error(err);
                    throw err;
                  });
                case 2:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));
        function _handleRemoteTyping(_x3) {
          return _handleRemoteTyping2.apply(this, arguments);
        }
        return _handleRemoteTyping;
      }()
      /**
       * Send typing event for the given conversation sid
       * @param {String} conversationSid
       */
    }, {
      key: "send",
      value: function send(conversationSid) {
        var lastUpdate = this.sentUpdates.get(conversationSid);
        if (lastUpdate && lastUpdate > Date.now() - this.typingTimeout) {
          return Promise.resolve();
        }
        this.sentUpdates.set(conversationSid, Date.now());
        return this._send(conversationSid);
      }
    }, {
      key: "_send",
      value: function _send(conversationSid) {
        var _this3 = this;
        log2.trace("Sending typing indicator");
        var url = this.configuration.links.typing;
        var headers = {
          "Content-Type": "application/x-www-form-urlencoded"
        };
        var body = "ChannelSid=".concat(conversationSid);
        return this.services.twilsockClient.post(url, headers, body, this.configuration.productId).then(function(response) {
          if (response.body.hasOwnProperty("typing_timeout")) {
            _this3.serviceTypingTimeout = response.body.typing_timeout * 1e3;
          }
        }).catch(function(err) {
          log2.error("Failed to send typing indicator:", err);
          throw err;
        });
      }
    }]);
    return TypingIndicator2;
  }();
  var PushNotification = /* @__PURE__ */ _createClass__default2["default"](
    /**
     * Title of the notification.
     */
    /**
     * Text of the notification.
     */
    /**
     * Sound of the notification.
     */
    /**
     * Number of the badge.
     */
    /**
     * Notification action (`click_action` in FCM terms and `category` in APN terms).
     */
    /**
     * Type of the notification.
     */
    /**
     * Additional data of the conversation.
     */
    /**
     * @internal
     */
    function PushNotification2(data2) {
      _classCallCheck__default2["default"](this, PushNotification2);
      this.title = data2.title || null;
      this.body = data2.body || null;
      this.sound = data2.sound || null;
      this.badge = data2.badge || null;
      this.action = data2.action || null;
      this.type = data2.type || null;
      this.data = data2.data || {};
    }
  );
  var version2 = "2.5.0";
  function ownKeys$12(object, enumerableOnly) {
    var keys6 = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys6.push.apply(keys6, symbols);
    }
    return keys6;
  }
  function _objectSpread$1(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$12(Object(source), true).forEach(function(key) {
        _defineProperty__default2["default"](target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$12(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _createSuper$12(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$12();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf__default2["default"](Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf__default2["default"](this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn__default2["default"](this, result);
    };
  }
  function _isNativeReflectConstruct$12() {
    if (typeof Reflect === "undefined" || !Reflect.construct)
      return false;
    if (Reflect.construct.sham)
      return false;
    if (typeof Proxy === "function")
      return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  var trimSlashes = function trimSlashes2(url) {
    return url.replace(/(^\/+|\/+$)/g, "");
  };
  var isMutationConflictResponse = function isMutationConflictResponse2(response) {
    return response.status.code === 202;
  };
  var ChannelMetadataNotFoundError = /* @__PURE__ */ function(_Error) {
    _inherits__default2["default"](ChannelMetadataNotFoundError2, _Error);
    var _super = _createSuper$12(ChannelMetadataNotFoundError2);
    function ChannelMetadataNotFoundError2(message) {
      _classCallCheck__default2["default"](this, ChannelMetadataNotFoundError2);
      return _super.call(this, message);
    }
    return _createClass__default2["default"](ChannelMetadataNotFoundError2);
  }(/* @__PURE__ */ _wrapNativeSuper__default2["default"](Error));
  var CommandExecutor = /* @__PURE__ */ function() {
    function CommandExecutor2(_serviceUrl, _services, _productId) {
      _classCallCheck__default2["default"](this, CommandExecutor2);
      this._serviceUrl = _serviceUrl;
      this._services = _services;
      this._productId = _productId;
    }
    _createClass__default2["default"](CommandExecutor2, [{
      key: "_preProcessUrl",
      value: function _preProcessUrl(url) {
        var trimmedUrl = trimSlashes(url);
        if (/^https?:\/\//.test(url)) {
          return trimmedUrl;
        }
        return "".concat(trimSlashes(this._serviceUrl), "/").concat(trimmedUrl);
      }
    }, {
      key: "_makeRequest",
      value: function() {
        var _makeRequest2 = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee(method, url, requestBody, headers) {
          var preProcessedUrl, finalHeaders, response, getUrl;
          return _regeneratorRuntime__default2["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  preProcessedUrl = this._preProcessUrl(url);
                  finalHeaders = _objectSpread$1({
                    "Content-Type": "application/json; charset=utf-8"
                  }, headers || {});
                  _context.t0 = method;
                  _context.next = _context.t0 === "get" ? 5 : _context.t0 === "post" ? 11 : _context.t0 === "delete" ? 15 : 19;
                  break;
                case 5:
                  getUrl = preProcessedUrl;
                  if (requestBody) {
                    getUrl += "?" + Object.entries(requestBody).map(function(entry) {
                      return entry.map(encodeURIComponent).join("=");
                    }).join("&");
                  }
                  _context.next = 9;
                  return this._services.transport.get(getUrl, finalHeaders, this._productId);
                case 9:
                  response = _context.sent;
                  return _context.abrupt("break", 19);
                case 11:
                  _context.next = 13;
                  return this._services.transport.post(preProcessedUrl, finalHeaders, JSON.stringify(requestBody), this._productId);
                case 13:
                  response = _context.sent;
                  return _context.abrupt("break", 19);
                case 15:
                  _context.next = 17;
                  return this._services.transport.delete(preProcessedUrl, finalHeaders, {}, this._productId);
                case 17:
                  response = _context.sent;
                  return _context.abrupt("break", 19);
                case 19:
                  if (!(response.status.code < 200 || response.status.code >= 300)) {
                    _context.next = 21;
                    break;
                  }
                  throw new Error("Request responded with a non-success code ".concat(response.status.code));
                case 21:
                  return _context.abrupt("return", response);
                case 22:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));
        function _makeRequest(_x, _x2, _x3, _x4) {
          return _makeRequest2.apply(this, arguments);
        }
        return _makeRequest;
      }()
    }, {
      key: "fetchResource",
      value: function() {
        var _fetchResource = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee3(url, requestBody) {
          var _this = this;
          var maxAttemptsCount, retrier, resolution;
          return _regeneratorRuntime__default2["default"].wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  maxAttemptsCount = 6;
                  retrier = new operationRetrier2.AsyncRetrier({
                    min: 50,
                    max: 1600,
                    maxAttemptsCount
                  });
                  _context3.prev = 2;
                  _context3.next = 5;
                  return retrier.run(/* @__PURE__ */ _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee2() {
                    var response, _e$body, _e$body2;
                    return _regeneratorRuntime__default2["default"].wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.prev = 0;
                            _context2.next = 3;
                            return _this._makeRequest("get", url, requestBody);
                          case 3:
                            response = _context2.sent;
                            return _context2.abrupt("return", {
                              type: "success",
                              data: response.body
                            });
                          case 7:
                            _context2.prev = 7;
                            _context2.t0 = _context2["catch"](0);
                            if (!((_context2.t0 === null || _context2.t0 === void 0 ? void 0 : (_e$body = _context2.t0.body) === null || _e$body === void 0 ? void 0 : _e$body.status) === 404 && (_context2.t0 === null || _context2.t0 === void 0 ? void 0 : (_e$body2 = _context2.t0.body) === null || _e$body2 === void 0 ? void 0 : _e$body2.code) === 50530)) {
                              _context2.next = 11;
                              break;
                            }
                            return _context2.abrupt("return", {
                              type: "noMetadata"
                            });
                          case 11:
                            throw _context2.t0;
                          case 12:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2, null, [[0, 7]]);
                  })));
                case 5:
                  resolution = _context3.sent;
                  _context3.next = 11;
                  break;
                case 8:
                  _context3.prev = 8;
                  _context3.t0 = _context3["catch"](2);
                  throw new Error('Fetch resource from "'.concat(url, '" failed.'));
                case 11:
                  if (!(resolution.type === "noMetadata")) {
                    _context3.next = 13;
                    break;
                  }
                  throw new ChannelMetadataNotFoundError("No metadata found.");
                case 13:
                  return _context3.abrupt("return", resolution.data);
                case 14:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, null, [[2, 8]]);
        }));
        function fetchResource(_x5, _x6) {
          return _fetchResource.apply(this, arguments);
        }
        return fetchResource;
      }()
    }, {
      key: "mutateResource",
      value: function() {
        var _mutateResource = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee4(method, url, requestBody) {
          var result;
          return _regeneratorRuntime__default2["default"].wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return this._makeRequest(method, url, requestBody, {
                    "X-Twilio-Mutation-Id": uuid2.v4()
                  });
                case 2:
                  result = _context4.sent;
                  if (!isMutationConflictResponse(result)) {
                    _context4.next = 7;
                    break;
                  }
                  _context4.next = 6;
                  return this.fetchResource(result.body.resource_url);
                case 6:
                  return _context4.abrupt("return", _context4.sent);
                case 7:
                  return _context4.abrupt("return", result.body);
                case 8:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));
        function mutateResource(_x7, _x8, _x9) {
          return _mutateResource.apply(this, arguments);
        }
        return mutateResource;
      }()
    }]);
    return CommandExecutor2;
  }();
  var ContentClient = /* @__PURE__ */ function() {
    function ContentClient2(_services) {
      var _pageSize = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100;
      var _cacheTtlMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 5e3;
      _classCallCheck__default2["default"](this, ContentClient2);
      _defineProperty__default2["default"](this, "_cachedTemplates", null);
      this._services = _services;
      this._pageSize = _pageSize;
      this._cacheTtlMs = _cacheTtlMs;
    }
    _createClass__default2["default"](ContentClient2, [{
      key: "getContentTemplates",
      value: function() {
        var _getContentTemplates = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee() {
          var _this = this;
          var _yield$this$_fetchCon, _yield$this$_fetchCon2, templatesPage, nextToken, templates, _yield$this$_fetchCon3, _yield$this$_fetchCon4;
          return _regeneratorRuntime__default2["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!(this._cachedTemplates !== null)) {
                    _context.next = 2;
                    break;
                  }
                  return _context.abrupt("return", this._cachedTemplates);
                case 2:
                  _context.next = 4;
                  return this._fetchContentTemplates();
                case 4:
                  _yield$this$_fetchCon = _context.sent;
                  _yield$this$_fetchCon2 = _slicedToArray__default2["default"](_yield$this$_fetchCon, 2);
                  templatesPage = _yield$this$_fetchCon2[0];
                  nextToken = _yield$this$_fetchCon2[1];
                  templates = templatesPage;
                case 9:
                  if (!(nextToken !== null)) {
                    _context.next = 19;
                    break;
                  }
                  _context.next = 12;
                  return this._fetchContentTemplates(nextToken);
                case 12:
                  _yield$this$_fetchCon3 = _context.sent;
                  _yield$this$_fetchCon4 = _slicedToArray__default2["default"](_yield$this$_fetchCon3, 2);
                  templatesPage = _yield$this$_fetchCon4[0];
                  nextToken = _yield$this$_fetchCon4[1];
                  templates = [].concat(_toConsumableArray__default2["default"](templates), _toConsumableArray__default2["default"](templatesPage));
                  _context.next = 9;
                  break;
                case 19:
                  this._cachedTemplates = Object.freeze(templates);
                  setTimeout(function() {
                    _this._cachedTemplates = null;
                  }, this._cacheTtlMs);
                  return _context.abrupt("return", templates);
                case 22:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));
        function getContentTemplates() {
          return _getContentTemplates.apply(this, arguments);
        }
        return getContentTemplates;
      }()
    }, {
      key: "_fetchContentTemplates",
      value: function() {
        var _fetchContentTemplates2 = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee2(pageToken) {
          var contentTemplatesUrl, url, response;
          return _regeneratorRuntime__default2["default"].wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  contentTemplatesUrl = "Client/v2/ContentTemplates";
                  url = new UriBuilder2(contentTemplatesUrl);
                  url.arg("PageSize", this._pageSize);
                  if (pageToken !== void 0) {
                    url.arg("PageToken", pageToken);
                  }
                  _context2.next = 6;
                  return this._services.commandExecutor.fetchResource(url.build());
                case 6:
                  response = _context2.sent;
                  return _context2.abrupt("return", [response.templates.map(function(template) {
                    return new ContentTemplate(template);
                  }), response.meta.next_token]);
                case 8:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));
        function _fetchContentTemplates(_x) {
          return _fetchContentTemplates2.apply(this, arguments);
        }
        return _fetchContentTemplates;
      }()
    }]);
    return ContentClient2;
  }();
  function _createForOfIteratorHelper$12(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
      if (Array.isArray(o) || (it = _unsupportedIterableToArray$12(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it)
          o = it;
        var i = 0;
        var F = function F2() {
        };
        return { s: F, n: function n() {
          if (i >= o.length)
            return { done: true };
          return { done: false, value: o[i++] };
        }, e: function e(_e) {
          throw _e;
        }, f: F };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return { s: function s() {
      it = it.call(o);
    }, n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    }, e: function e(_e2) {
      didErr = true;
      err = _e2;
    }, f: function f() {
      try {
        if (!normalCompletion && it.return != null)
          it.return();
      } finally {
        if (didErr)
          throw err;
      }
    } };
  }
  function _unsupportedIterableToArray$12(o, minLen) {
    if (!o)
      return;
    if (typeof o === "string")
      return _arrayLikeToArray$12(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor)
      n = o.constructor.name;
    if (n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$12(o, minLen);
  }
  function _arrayLikeToArray$12(arr, len) {
    if (len == null || len > arr.length)
      len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  }
  var QuickLRU = /* @__PURE__ */ function(_Symbol$iterator) {
    function QuickLRU2() {
      var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      _classCallCheck__default2["default"](this, QuickLRU2);
      if (!(options.maxSize && options.maxSize > 0)) {
        throw new TypeError("`maxSize` must be a number greater than 0");
      }
      this.maxSize = options.maxSize;
      this.onEviction = options.onEviction;
      this.cache = /* @__PURE__ */ new Map();
      this.oldCache = /* @__PURE__ */ new Map();
      this._size = 0;
    }
    _createClass__default2["default"](QuickLRU2, [{
      key: "_set",
      value: function _set(key, value) {
        this.cache.set(key, value);
        this._size++;
        if (this._size >= this.maxSize) {
          this._size = 0;
          if (typeof this.onEviction === "function") {
            var _iterator = _createForOfIteratorHelper$12(this.oldCache.entries()), _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done; ) {
                var _step$value = _slicedToArray__default2["default"](_step.value, 2), _key = _step$value[0], _value = _step$value[1];
                this.onEviction(_key, _value);
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          }
          this.oldCache = this.cache;
          this.cache = /* @__PURE__ */ new Map();
        }
      }
    }, {
      key: "get",
      value: function get3(key) {
        if (this.cache.has(key)) {
          return this.cache.get(key);
        }
        if (this.oldCache.has(key)) {
          var value = this.oldCache.get(key);
          this.oldCache.delete(key);
          this._set(key, value);
          return value;
        }
      }
    }, {
      key: "set",
      value: function set4(key, value) {
        if (this.cache.has(key)) {
          this.cache.set(key, value);
        } else {
          this._set(key, value);
        }
        return this;
      }
    }, {
      key: "has",
      value: function has3(key) {
        return this.cache.has(key) || this.oldCache.has(key);
      }
    }, {
      key: "peek",
      value: function peek(key) {
        if (this.cache.has(key)) {
          return this.cache.get(key);
        }
        if (this.oldCache.has(key)) {
          return this.oldCache.get(key);
        }
      }
    }, {
      key: "delete",
      value: function _delete(key) {
        var deleted = this.cache.delete(key);
        if (deleted) {
          this._size--;
        }
        return this.oldCache.delete(key) || deleted;
      }
    }, {
      key: "clear",
      value: function clear2() {
        this.cache.clear();
        this.oldCache.clear();
        this._size = 0;
      }
    }, {
      key: "keys",
      value: /* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function keys6() {
        var _iterator2, _step2, _step2$value, key;
        return _regeneratorRuntime__default2["default"].wrap(function keys$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _iterator2 = _createForOfIteratorHelper$12(this);
                _context.prev = 1;
                _iterator2.s();
              case 3:
                if ((_step2 = _iterator2.n()).done) {
                  _context.next = 9;
                  break;
                }
                _step2$value = _slicedToArray__default2["default"](_step2.value, 1), key = _step2$value[0];
                _context.next = 7;
                return key;
              case 7:
                _context.next = 3;
                break;
              case 9:
                _context.next = 14;
                break;
              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](1);
                _iterator2.e(_context.t0);
              case 14:
                _context.prev = 14;
                _iterator2.f();
                return _context.finish(14);
              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, keys6, this, [[1, 11, 14, 17]]);
      })
    }, {
      key: "values",
      value: /* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function values4() {
        var _iterator3, _step3, _step3$value, value;
        return _regeneratorRuntime__default2["default"].wrap(function values$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _iterator3 = _createForOfIteratorHelper$12(this);
                _context2.prev = 1;
                _iterator3.s();
              case 3:
                if ((_step3 = _iterator3.n()).done) {
                  _context2.next = 9;
                  break;
                }
                _step3$value = _slicedToArray__default2["default"](_step3.value, 2), value = _step3$value[1];
                _context2.next = 7;
                return value;
              case 7:
                _context2.next = 3;
                break;
              case 9:
                _context2.next = 14;
                break;
              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](1);
                _iterator3.e(_context2.t0);
              case 14:
                _context2.prev = 14;
                _iterator3.f();
                return _context2.finish(14);
              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, values4, this, [[1, 11, 14, 17]]);
      })
    }, {
      key: _Symbol$iterator,
      value: /* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function value() {
        var _iterator4, _step4, item, _iterator5, _step5, _item, _item2, key;
        return _regeneratorRuntime__default2["default"].wrap(function value$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _iterator4 = _createForOfIteratorHelper$12(this.cache);
                _context3.prev = 1;
                _iterator4.s();
              case 3:
                if ((_step4 = _iterator4.n()).done) {
                  _context3.next = 9;
                  break;
                }
                item = _step4.value;
                _context3.next = 7;
                return item;
              case 7:
                _context3.next = 3;
                break;
              case 9:
                _context3.next = 14;
                break;
              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3["catch"](1);
                _iterator4.e(_context3.t0);
              case 14:
                _context3.prev = 14;
                _iterator4.f();
                return _context3.finish(14);
              case 17:
                _iterator5 = _createForOfIteratorHelper$12(this.oldCache);
                _context3.prev = 18;
                _iterator5.s();
              case 20:
                if ((_step5 = _iterator5.n()).done) {
                  _context3.next = 28;
                  break;
                }
                _item = _step5.value;
                _item2 = _slicedToArray__default2["default"](_item, 1), key = _item2[0];
                if (this.cache.has(key)) {
                  _context3.next = 26;
                  break;
                }
                _context3.next = 26;
                return _item;
              case 26:
                _context3.next = 20;
                break;
              case 28:
                _context3.next = 33;
                break;
              case 30:
                _context3.prev = 30;
                _context3.t1 = _context3["catch"](18);
                _iterator5.e(_context3.t1);
              case 33:
                _context3.prev = 33;
                _iterator5.f();
                return _context3.finish(33);
              case 36:
              case "end":
                return _context3.stop();
            }
          }
        }, value, this, [[1, 11, 14, 17], [18, 30, 33, 36]]);
      })
    }, {
      key: "size",
      get: function get3() {
        var oldCacheSize = 0;
        var _iterator6 = _createForOfIteratorHelper$12(this.oldCache.keys()), _step6;
        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done; ) {
            var key = _step6.value;
            if (!this.cache.has(key)) {
              oldCacheSize++;
            }
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
        return Math.min(this._size + oldCacheSize, this.maxSize);
      }
    }]);
    return QuickLRU2;
  }(Symbol.iterator);
  var quickLru = QuickLRU;
  var ChannelMetadata = /* @__PURE__ */ _createClass__default2["default"](
    /**
     * Communication channel type.
     */
    /**
     * The actual metadata.
     */
    /**
     * @internal
     */
    function ChannelMetadata2(type5, data2) {
      _classCallCheck__default2["default"](this, ChannelMetadata2);
      this.type = type5;
      this.data = data2;
      Object.freeze(data2);
    }
  );
  var ChannelMetadataClient = /* @__PURE__ */ function() {
    function ChannelMetadataClient2(services, configuration) {
      _classCallCheck__default2["default"](this, ChannelMetadataClient2);
      this._services = services;
      this._configuration = configuration;
      this._cache = new quickLru({
        maxSize: configuration.channelMetadataCacheCapacity
      });
    }
    _createClass__default2["default"](ChannelMetadataClient2, [{
      key: "getChannelMetadata",
      value: function() {
        var _getChannelMetadata = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee(conversationSid, messageSid) {
          var key, cachedItem, url, metadataResponse, metadata;
          return _regeneratorRuntime__default2["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  key = "".concat(conversationSid, ",").concat(messageSid);
                  cachedItem = this._cache.get(key);
                  if (!cachedItem) {
                    _context.next = 4;
                    break;
                  }
                  return _context.abrupt("return", cachedItem.item);
                case 4:
                  url = "".concat(this._configuration.links.conversations, "/").concat(conversationSid, "/Messages/").concat(messageSid, "/ChannelMetadata");
                  _context.prev = 5;
                  _context.next = 8;
                  return this._services.commandExecutor.fetchResource(url);
                case 8:
                  metadataResponse = _context.sent;
                  _context.next = 17;
                  break;
                case 11:
                  _context.prev = 11;
                  _context.t0 = _context["catch"](5);
                  if (!(_context.t0 instanceof ChannelMetadataNotFoundError)) {
                    _context.next = 16;
                    break;
                  }
                  this._cache.set(key, {
                    item: null
                  });
                  return _context.abrupt("return", null);
                case 16:
                  throw new Error(_context.t0);
                case 17:
                  metadata = new ChannelMetadata(metadataResponse.type, metadataResponse.data);
                  this._cache.set(key, {
                    item: metadata
                  });
                  return _context.abrupt("return", metadata);
                case 20:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this, [[5, 11]]);
        }));
        function getChannelMetadata(_x, _x2) {
          return _getChannelMetadata.apply(this, arguments);
        }
        return getChannelMetadata;
      }()
    }]);
    return ChannelMetadataClient2;
  }();
  function _createForOfIteratorHelper2(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
      if (Array.isArray(o) || (it = _unsupportedIterableToArray2(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it)
          o = it;
        var i = 0;
        var F = function F2() {
        };
        return { s: F, n: function n() {
          if (i >= o.length)
            return { done: true };
          return { done: false, value: o[i++] };
        }, e: function e(_e) {
          throw _e;
        }, f: F };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return { s: function s() {
      it = it.call(o);
    }, n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    }, e: function e(_e2) {
      didErr = true;
      err = _e2;
    }, f: function f() {
      try {
        if (!normalCompletion && it.return != null)
          it.return();
      } finally {
        if (didErr)
          throw err;
      }
    } };
  }
  function _unsupportedIterableToArray2(o, minLen) {
    if (!o)
      return;
    if (typeof o === "string")
      return _arrayLikeToArray2(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor)
      n = o.constructor.name;
    if (n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray2(o, minLen);
  }
  function _arrayLikeToArray2(arr, len) {
    if (len == null || len > arr.length)
      len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  }
  var EmailRecipientDescriptor = /* @__PURE__ */ _createClass__default2["default"](
    /**
     * Type of recipient.
     */
    /**
     * @internal
     */
    function EmailRecipientDescriptor2(recipient) {
      _classCallCheck__default2["default"](this, EmailRecipientDescriptor2);
      _defineProperty__default2["default"](this, "type", "email");
      this.messageSid = recipient.message_sid;
      this.level = recipient.level;
      this.name = recipient.name;
      this.address = recipient.address;
    }
  );
  var UnknownRecipientDescriptor = /* @__PURE__ */ _createClass__default2["default"](
    /**
     * Type of recipient.
     */
    /**
     * Sid of the message that this recipient belongs to.
     */
    /**
     * Recipient data as a JSON string.
     */
    /**
     * @internal
     */
    function UnknownRecipientDescriptor2(recipient) {
      _classCallCheck__default2["default"](this, UnknownRecipientDescriptor2);
      this.type = recipient.type;
      this.messageSid = recipient.message_sid;
      this.rawData = JSON.stringify(recipient);
    }
  );
  var MessageRecipientsClient = /* @__PURE__ */ function() {
    function MessageRecipientsClient2(services, configuration) {
      _classCallCheck__default2["default"](this, MessageRecipientsClient2);
      this._services = services;
      this._configuration = configuration;
      this._cache = new quickLru({
        maxSize: configuration.messageRecipientsCacheCapacity
      });
    }
    _createClass__default2["default"](MessageRecipientsClient2, [{
      key: "getRecipientsFromMessage",
      value: function() {
        var _getRecipientsFromMessage = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee(conversationSid, messageSid) {
          var _this = this;
          var key, cachedItem, url, recipientsResponse, recipients;
          return _regeneratorRuntime__default2["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  key = "".concat(conversationSid, ",").concat(messageSid);
                  cachedItem = this._cache.get(key);
                  if (!cachedItem) {
                    _context.next = 4;
                    break;
                  }
                  return _context.abrupt("return", cachedItem.item);
                case 4:
                  url = new UriBuilder2(this._configuration.links.conversations).path(conversationSid).path("MessageRecipients").arg("MessageSid", messageSid).build();
                  _context.next = 7;
                  return this._services.commandExecutor.fetchResource(url);
                case 7:
                  recipientsResponse = _context.sent;
                  recipients = recipientsResponse.message_recipients.map(function(recipient) {
                    return _this._wrapResponse(recipient);
                  });
                  if (recipients.length > 0) {
                    this._cache.set(key, {
                      item: recipients
                    });
                  }
                  return _context.abrupt("return", recipients);
                case 11:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));
        function getRecipientsFromMessage(_x, _x2) {
          return _getRecipientsFromMessage.apply(this, arguments);
        }
        return getRecipientsFromMessage;
      }()
    }, {
      key: "getRecipientsFromConversation",
      value: function() {
        var _getRecipientsFromConversation = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee2(conversationSid, paginatorOptions) {
          var _paginatorOptions$pag, _paginatorOptions$pag2, _this2 = this;
          var url, recipientsResponse, allRecipients, _iterator, _step, _this$_cache$get$item, _this$_cache$get, recipient, key, existingMessageRecipients;
          return _regeneratorRuntime__default2["default"].wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  url = new UriBuilder2(this._configuration.links.conversations).path(conversationSid).path("MessageRecipients").arg("PageToken", (_paginatorOptions$pag = paginatorOptions === null || paginatorOptions === void 0 ? void 0 : paginatorOptions.pageToken) !== null && _paginatorOptions$pag !== void 0 ? _paginatorOptions$pag : void 0).arg("PageSize", (_paginatorOptions$pag2 = paginatorOptions === null || paginatorOptions === void 0 ? void 0 : paginatorOptions.pageSize) !== null && _paginatorOptions$pag2 !== void 0 ? _paginatorOptions$pag2 : void 0).build();
                  _context2.next = 3;
                  return this._services.commandExecutor.fetchResource(url);
                case 3:
                  recipientsResponse = _context2.sent;
                  allRecipients = recipientsResponse.message_recipients.map(function(recipient2) {
                    return _this2._wrapResponse(recipient2);
                  });
                  _iterator = _createForOfIteratorHelper2(allRecipients);
                  try {
                    for (_iterator.s(); !(_step = _iterator.n()).done; ) {
                      recipient = _step.value;
                      key = "".concat(conversationSid, ",").concat(recipient.messageSid);
                      existingMessageRecipients = (_this$_cache$get$item = (_this$_cache$get = this._cache.get(key)) === null || _this$_cache$get === void 0 ? void 0 : _this$_cache$get.item) !== null && _this$_cache$get$item !== void 0 ? _this$_cache$get$item : [];
                      this._cache.set(key, {
                        item: [].concat(_toConsumableArray__default2["default"](existingMessageRecipients), [recipient])
                      });
                    }
                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }
                  return _context2.abrupt("return", new RestPaginator(allRecipients, function(pageToken, pageSize) {
                    return _this2.getRecipientsFromConversation(conversationSid, {
                      pageToken,
                      pageSize
                    });
                  }, recipientsResponse.meta.previous_token, recipientsResponse.meta.next_token));
                case 8:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));
        function getRecipientsFromConversation(_x3, _x4) {
          return _getRecipientsFromConversation.apply(this, arguments);
        }
        return getRecipientsFromConversation;
      }()
    }, {
      key: "_wrapResponse",
      value: function _wrapResponse(recipient) {
        switch (recipient.type) {
          case "email":
            return new EmailRecipientDescriptor(recipient);
          default:
            return new UnknownRecipientDescriptor(recipient);
        }
      }
    }]);
    return MessageRecipientsClient2;
  }();
  var _class;
  function ownKeys3(object, enumerableOnly) {
    var keys6 = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys6.push.apply(keys6, symbols);
    }
    return keys6;
  }
  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys3(Object(source), true).forEach(function(key) {
        _defineProperty__default2["default"](target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys3(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _createSuper2(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct2();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf__default2["default"](Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf__default2["default"](this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn__default2["default"](this, result);
    };
  }
  function _isNativeReflectConstruct2() {
    if (typeof Reflect === "undefined" || !Reflect.construct)
      return false;
    if (Reflect.construct.sham)
      return false;
    if (typeof Proxy === "function")
      return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  var Client_1;
  var ClientServices = /* @__PURE__ */ _createClass__default2["default"](function ClientServices2() {
    _classCallCheck__default2["default"](this, ClientServices2);
  });
  exports.Client = Client_1 = (_class = /* @__PURE__ */ function(_ReplayEventEmitter) {
    _inherits__default2["default"](Client2, _ReplayEventEmitter);
    var _super = _createSuper2(Client2);
    function Client2(fpaToken) {
      var _this$_options$logLev, _this$_options$twilso, _this$_options$transp, _this$_options$notifi, _this$_options$syncCl;
      var _this;
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      _classCallCheck__default2["default"](this, Client2);
      _this = _super.call(this);
      _defineProperty__default2["default"](_assertThisInitialized__default2["default"](_this), "version", version2);
      _defineProperty__default2["default"](_assertThisInitialized__default2["default"](_this), "connectionState", "unknown");
      _defineProperty__default2["default"](_assertThisInitialized__default2["default"](_this), "parsePushNotification", Client_1.parsePushNotification);
      _this._fpaToken = fpaToken !== null && fpaToken !== void 0 ? fpaToken : "";
      _this._options = options !== null && options !== void 0 ? options : {};
      if (!_this._options.disableDeepClone) {
        var _options = _objectSpread2(_objectSpread2({}, _this._options), {}, {
          transport: void 0,
          twilsockClient: void 0
        });
        _options = deepClone2(_options);
        _options.transport = _this._options.transport;
        _options.twilsockClient = _this._options.twilsockClient;
        _this._options = _options;
      }
      _this._options.logLevel = (_this$_options$logLev = _this._options.logLevel) !== null && _this$_options$logLev !== void 0 ? _this$_options$logLev : "silent";
      Client_1._logger.setLevel(_this._options.logLevel);
      var productId = _this._options.productId = "ip_messaging";
      _this._options.clientMetadata = _this._options.clientMetadata || {};
      if (!_this._options.clientMetadata.hasOwnProperty("type")) {
        _this._options.clientMetadata.type = "conversations";
      }
      if (!_this._options.clientMetadata.hasOwnProperty("sdk")) {
        _this._options.clientMetadata.sdk = "JS";
        _this._options.clientMetadata.sdkv = version2;
      }
      _this._options.Sync = _this._options.Sync || {};
      if (typeof _this._options.Sync.enableSessionStorage === "undefined") {
        _this._options.Sync.enableSessionStorage = true;
      }
      if (_this._options.region) {
        _this._options.Sync.region = _this._options.region;
      }
      if (!fpaToken) {
        throw new Error("A valid Twilio token should be provided");
      }
      _this._services = new ClientServices();
      _this._myself = new User("", "", null, _this._services);
      var startTwilsock = !_this._options.twilsockClient;
      if (!_this._options.initRegistrations) {
        var initRegistration = new twilsock2.InitRegistration(productId);
        Client_1.populateInitRegistrations(initRegistration);
        _this._options.initRegistrations = [initRegistration];
      }
      _this._services.twilsockClient = _this._options.twilsockClient = (_this$_options$twilso = _this._options.twilsockClient) !== null && _this$_options$twilso !== void 0 ? _this$_options$twilso : new twilsock2.TwilsockClient(fpaToken, productId, _this._options);
      _this._services.twilsockClient.on(Client_1.tokenAboutToExpire, function() {
        return _this.emit(Client_1.tokenAboutToExpire);
      });
      _this._services.twilsockClient.on(Client_1.tokenExpired, function() {
        return _this.emit(Client_1.tokenExpired);
      });
      _this._services.twilsockClient.on(Client_1.connectionError, function(error2) {
        return _this.emit(Client_1.connectionError, error2);
      });
      _this._services.twilsockClient.on("stateChanged", function(state) {
        Client_1._logger.debug("Handling stateChanged for ConversationsClient: new state ".concat(state));
        if (state !== _this.connectionState) {
          _this.connectionState = state;
          _this.emit(Client_1.connectionStateChanged, _this.connectionState);
        }
      });
      _this._services.transport = _this._options.transport = (_this$_options$transp = _this._options.transport) !== null && _this$_options$transp !== void 0 ? _this$_options$transp : _this._options.twilsockClient;
      _this._services.notificationClient = _this._options.notificationsClient = (_this$_options$notifi = _this._options.notificationsClient) !== null && _this$_options$notifi !== void 0 ? _this$_options$notifi : new notifications.Notifications(fpaToken, _this._options);
      _this._services.syncClient = _this._options.syncClient = (_this$_options$syncCl = _this._options.syncClient) !== null && _this$_options$syncCl !== void 0 ? _this$_options$syncCl : new twilioSync.SyncClient(fpaToken, _this._options);
      var configurationOptions = (options === null || options === void 0 ? void 0 : options.Chat) || (options === null || options === void 0 ? void 0 : options.IPMessaging) || options || {};
      var region = configurationOptions.region || (options === null || options === void 0 ? void 0 : options.region);
      var baseUrl = configurationOptions.apiUri || configurationOptions.typingUri || "https://aim.".concat(region || "us1", ".twilio.com");
      _this._services.commandExecutor = new CommandExecutor(baseUrl, {
        transport: _this._options.transport
      }, productId);
      _this._services.contentClient = new ContentClient(_this._services);
      var emitFailed = function emitFailed2(error2) {
        _this._rejectEnsureReady(error2);
        _this.emit(Client_1.stateChanged, "failed");
        _this.emit(Client_1.initFailed, {
          error: error2
        });
      };
      var emitDisconnected = function emitDisconnected2() {
        emitFailed({
          terminal: true,
          message: "Twilsock has disconnected."
        });
      };
      _this._services.twilsockClient.once("connectionError", emitFailed);
      _this._services.twilsockClient.once("disconnected", emitDisconnected);
      _this._services.twilsockClient.once("connected", /* @__PURE__ */ _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee() {
        var startupEvent, connectionError;
        return _regeneratorRuntime__default2["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                Client_1._logger.debug("ConversationsClient started INITIALIZING");
                _this._services.twilsockClient.off("connectionError", emitFailed);
                _this._services.twilsockClient.off("disconnected", emitDisconnected);
                _context.prev = 3;
                startupEvent = "conversations.client.startup";
                _this._services.twilsockClient.addPartialTelemetryEvent(new twilsock2.TelemetryEventDescription(startupEvent, "Conversations client startup", /* @__PURE__ */ new Date()), startupEvent, twilsock2.TelemetryPoint.Start);
                _context.next = 8;
                return _this._initialize();
              case 8:
                _this._services.twilsockClient.addPartialTelemetryEvent(new twilsock2.TelemetryEventDescription("", "", /* @__PURE__ */ new Date()), startupEvent, twilsock2.TelemetryPoint.End);
                _context.next = 17;
                break;
              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](3);
                connectionError = {
                  terminal: true,
                  message: _context.t0.message
                };
                _this._rejectEnsureReady(connectionError);
                _this.emit(Client_1.stateChanged, "failed");
                _this.emit(Client_1.initFailed, {
                  error: connectionError
                });
              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 11]]);
      })));
      _this._ensureReady = new Promise(function(resolve2, reject2) {
        _this._resolveEnsureReady = resolve2;
        _this._rejectEnsureReady = reject2;
      }).catch(function() {
        return void 0;
      });
      if (startTwilsock) {
        _this._services.twilsockClient.connect();
      }
      return _this;
    }
    _createClass__default2["default"](Client2, [{
      key: "user",
      get: function get3() {
        return this._myself;
      }
      /**
       * Client reachability state. Throws an error if accessed before the client
       * initialization was completed.
       */
    }, {
      key: "reachabilityEnabled",
      get: function get3() {
        if (!this._configuration) {
          throw new Error("Reachability information could not yet be accessed as the client has not yet been initialized. Subscribe to the 'stateChanged' event to properly react to the client initialization.");
        }
        return this._configuration.reachabilityEnabled;
      }
      /**
       * @deprecated
       * Current token.
       * @internal
       */
    }, {
      key: "token",
      get: function get3() {
        return this._fpaToken;
      }
      /**
       * @deprecated Call constructor directly.
       *
       * Factory method to create a Conversations client instance.
       *
       * The factory method will automatically trigger connection.
       * Do not use it if you need finer-grained control.
       *
       * Since this method returns an already-initialized client, some of the events
       * will be lost because they happen *before* the initialization. It is
       * recommended that `client.onWithReplay` is used as opposed to `client.on`
       * for subscribing to client events. The `client.onWithReplay` will re-emit
       * the most recent value for a given event if it emitted before the
       * subscription.
       *
       * @param token Access token.
       * @param options Options to customize the client.
       * @returns Returns a fully initialized client.
       */
    }, {
      key: "shutdown",
      value: (
        /**
         * Gracefully shut down the client.
         */
        function() {
          var _shutdown = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee2() {
            return _regeneratorRuntime__default2["default"].wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return this._ensureReady;
                  case 2:
                    _context2.next = 4;
                    return this._services.twilsockClient.disconnect();
                  case 4:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, this);
          }));
          function shutdown() {
            return _shutdown.apply(this, arguments);
          }
          return shutdown;
        }()
      )
      /**
       * Update the token used by the client and re-register with the Conversations services.
       * @param token New access token.
       */
    }, {
      key: "updateToken",
      value: function() {
        var _updateToken = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee3(token) {
          return _regeneratorRuntime__default2["default"].wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return this._ensureReady;
                case 2:
                  Client_1._logger.info("updateToken");
                  if (!(this._fpaToken === token)) {
                    _context3.next = 5;
                    break;
                  }
                  return _context3.abrupt("return", this);
                case 5:
                  _context3.next = 7;
                  return this._services.twilsockClient.updateToken(token);
                case 7:
                  _context3.next = 9;
                  return this._services.notificationClient.updateToken(token);
                case 9:
                  _context3.next = 11;
                  return this._services.mcsClient.updateToken(token);
                case 11:
                  this._fpaToken = token;
                  return _context3.abrupt("return", this);
                case 13:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));
        function updateToken(_x) {
          return _updateToken.apply(this, arguments);
        }
        return updateToken;
      }()
      /**
       * Get a known conversation by its SID.
       * @param conversationSid Conversation sid
       */
    }, {
      key: "getConversationBySid",
      value: function() {
        var _getConversationBySid = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee4(conversationSid) {
          var conversation;
          return _regeneratorRuntime__default2["default"].wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return this._ensureReady;
                case 2:
                  _context4.next = 4;
                  return this._conversationsEntity.myConversationsRead.promise;
                case 4:
                  _context4.next = 6;
                  return this._conversationsEntity.getConversation(conversationSid);
                case 6:
                  conversation = _context4.sent;
                  if (conversation) {
                    _context4.next = 12;
                    break;
                  }
                  _context4.next = 10;
                  return this.peekConversationBySid(conversationSid);
                case 10:
                  conversation = _context4.sent;
                  if (conversation) {
                    deprecationDecorator.deprecationWarning("The method getConversationBySid is deprecated to retrieve conversations you're not part of. Use peekConversationBySid instead.");
                  }
                case 12:
                  if (conversation) {
                    _context4.next = 14;
                    break;
                  }
                  throw new Error("Conversation with SID ".concat(conversationSid, " was not found."));
                case 14:
                  return _context4.abrupt("return", conversation);
                case 15:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));
        function getConversationBySid(_x2) {
          return _getConversationBySid.apply(this, arguments);
        }
        return getConversationBySid;
      }()
      /**
       * Peek a conversation by its SID.
       * @param conversationSid Conversation sid
       * @internal
       */
    }, {
      key: "peekConversationBySid",
      value: function() {
        var _peekConversationBySid = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee5(conversationSid) {
          var conversation;
          return _regeneratorRuntime__default2["default"].wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return this._ensureReady;
                case 2:
                  _context5.next = 4;
                  return this._conversationsEntity.peekConversation(conversationSid);
                case 4:
                  conversation = _context5.sent;
                  if (conversation) {
                    _context5.next = 7;
                    break;
                  }
                  throw new Error("Conversation with SID ".concat(conversationSid, " was not found."));
                case 7:
                  return _context5.abrupt("return", conversation);
                case 8:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, this);
        }));
        function peekConversationBySid(_x3) {
          return _peekConversationBySid.apply(this, arguments);
        }
        return peekConversationBySid;
      }()
      /**
       * Get a known conversation by its unique identifier name.
       * @param uniqueName The unique identifier name of the conversation.
       */
    }, {
      key: "getConversationByUniqueName",
      value: function() {
        var _getConversationByUniqueName = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee6(uniqueName) {
          var conversation;
          return _regeneratorRuntime__default2["default"].wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  _context6.next = 2;
                  return this._ensureReady;
                case 2:
                  _context6.next = 4;
                  return this._conversationsEntity.myConversationsRead.promise;
                case 4:
                  _context6.next = 6;
                  return this._conversationsEntity.getConversationByUniqueName(uniqueName);
                case 6:
                  conversation = _context6.sent;
                  if (conversation) {
                    _context6.next = 9;
                    break;
                  }
                  throw new Error("Conversation with unique name ".concat(uniqueName, " was not found."));
                case 9:
                  return _context6.abrupt("return", conversation);
                case 10:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6, this);
        }));
        function getConversationByUniqueName(_x4) {
          return _getConversationByUniqueName.apply(this, arguments);
        }
        return getConversationByUniqueName;
      }()
      /**
       * Get the current list of all the subscribed conversations.
       */
    }, {
      key: "getSubscribedConversations",
      value: function() {
        var _getSubscribedConversations = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee7() {
          return _regeneratorRuntime__default2["default"].wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  _context7.next = 2;
                  return this._ensureReady;
                case 2:
                  return _context7.abrupt("return", this._conversationsPromise.then(function(conversations) {
                    return conversations.getConversations();
                  }));
                case 3:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7, this);
        }));
        function getSubscribedConversations() {
          return _getSubscribedConversations.apply(this, arguments);
        }
        return getSubscribedConversations;
      }()
      /**
       * Create a conversation on the server and subscribe to its events.
       * The default is a conversation with an empty friendly name.
       * @param options Options for the conversation.
       */
    }, {
      key: "createConversation",
      value: function() {
        var _createConversation = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee8(options) {
          return _regeneratorRuntime__default2["default"].wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  _context8.next = 2;
                  return this._ensureReady;
                case 2:
                  options = options || {};
                  return _context8.abrupt("return", this._conversationsPromise.then(function(conversationsEntity) {
                    return conversationsEntity.addConversation(options);
                  }));
                case 4:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8, this);
        }));
        function createConversation(_x5) {
          return _createConversation.apply(this, arguments);
        }
        return createConversation;
      }()
      /**
       * Register for push notifications.
       * @param channelType Channel type.
       * @param registrationId Push notification ID provided by the FCM/APNS service
       * on the platform.
       */
    }, {
      key: "setPushRegistrationId",
      value: function() {
        var _setPushRegistrationId = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee9(channelType, registrationId) {
          return _regeneratorRuntime__default2["default"].wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  _context9.next = 2;
                  return this._ensureReady;
                case 2:
                  this._subscribeToPushNotifications(channelType);
                  this._services.notificationClient.setPushRegistrationId(channelType, registrationId);
                  _context9.next = 6;
                  return this._services.notificationClient.commitChanges();
                case 6:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9, this);
        }));
        function setPushRegistrationId(_x6, _x7) {
          return _setPushRegistrationId.apply(this, arguments);
        }
        return setPushRegistrationId;
      }()
      /**
       * Unregister from push notifications.
       * @param channelType Channel type.
       * @deprecated Use removePushRegistrations() instead.
       */
    }, {
      key: "unsetPushRegistrationId",
      value: function() {
        var _unsetPushRegistrationId = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee10(channelType) {
          return _regeneratorRuntime__default2["default"].wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  _context10.next = 2;
                  return this._ensureReady;
                case 2:
                  this._unsubscribeFromPushNotifications(channelType);
                  _context10.next = 5;
                  return this._services.notificationClient.commitChanges();
                case 5:
                case "end":
                  return _context10.stop();
              }
            }
          }, _callee10, this);
        }));
        function unsetPushRegistrationId(_x8) {
          return _unsetPushRegistrationId.apply(this, arguments);
        }
        return unsetPushRegistrationId;
      }()
      /**
       * Clear existing registrations directly using provided device token.
       * This is useful to ensure stopped subscriptions without resubscribing.
       *
       * This function goes completely beside the state machine and removes all
       * registrations.
       * Use with caution: if it races with current state machine operations,
       * madness will ensue.
       *
       * @param channelType Channel type.
       * @param registrationId Push notification ID provided by the FCM/APNS service
       * on the platform.
       */
    }, {
      key: "removePushRegistrations",
      value: function() {
        var _removePushRegistrations = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee11(channelType, registrationId) {
          return _regeneratorRuntime__default2["default"].wrap(function _callee11$(_context11) {
            while (1) {
              switch (_context11.prev = _context11.next) {
                case 0:
                  _context11.next = 2;
                  return this._services.notificationClient.removeRegistrations(channelType, registrationId);
                case 2:
                case "end":
                  return _context11.stop();
              }
            }
          }, _callee11, this);
        }));
        function removePushRegistrations(_x9, _x10) {
          return _removePushRegistrations.apply(this, arguments);
        }
        return removePushRegistrations;
      }()
      /**
       * Parse a push notification payload.
       */
    }, {
      key: "handlePushNotification",
      value: (
        /**
         * Handle push notification payload parsing and emit the
         * {@link Client.pushNotification} event on this {@link Client} instance.
         * @param notificationPayload Push notification payload
         */
        function() {
          var _handlePushNotification = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee12(notificationPayload) {
            return _regeneratorRuntime__default2["default"].wrap(function _callee12$(_context12) {
              while (1) {
                switch (_context12.prev = _context12.next) {
                  case 0:
                    _context12.next = 2;
                    return this._ensureReady;
                  case 2:
                    Client_1._logger.debug("handlePushNotification, notificationPayload=", notificationPayload);
                    this.emit("pushNotification", Client_1.parsePushNotification(notificationPayload));
                  case 4:
                  case "end":
                    return _context12.stop();
                }
              }
            }, _callee12, this);
          }));
          function handlePushNotification(_x11) {
            return _handlePushNotification.apply(this, arguments);
          }
          return handlePushNotification;
        }()
      )
      /**
       * Gets a user with the given identity. If it's in the subscribed list, then
       * return the user object from it;
       * if not, then subscribe and add user to the subscribed list.
       * @param identity Identity of the user.
       * @returns A fully initialized user.
       */
    }, {
      key: "getUser",
      value: function() {
        var _getUser = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee13(identity) {
          return _regeneratorRuntime__default2["default"].wrap(function _callee13$(_context13) {
            while (1) {
              switch (_context13.prev = _context13.next) {
                case 0:
                  _context13.next = 2;
                  return this._ensureReady;
                case 2:
                  return _context13.abrupt("return", this._services.users.getUser(identity));
                case 3:
                case "end":
                  return _context13.stop();
              }
            }
          }, _callee13, this);
        }));
        function getUser(_x12) {
          return _getUser.apply(this, arguments);
        }
        return getUser;
      }()
      /**
       * Get a list of subscribed user objects.
       */
    }, {
      key: "getSubscribedUsers",
      value: function() {
        var _getSubscribedUsers = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee14() {
          return _regeneratorRuntime__default2["default"].wrap(function _callee14$(_context14) {
            while (1) {
              switch (_context14.prev = _context14.next) {
                case 0:
                  _context14.next = 2;
                  return this._ensureReady;
                case 2:
                  return _context14.abrupt("return", this._services.users.getSubscribedUsers());
                case 3:
                case "end":
                  return _context14.stop();
              }
            }
          }, _callee14, this);
        }));
        function getSubscribedUsers() {
          return _getSubscribedUsers.apply(this, arguments);
        }
        return getSubscribedUsers;
      }()
      /**
       * Get content URLs for all media attachments in the given set of media sids
       * using a single operation.
       * @param mediaSids Set of media sids to query for the content URL.
       */
    }, {
      key: "getTemporaryContentUrlsForMediaSids",
      value: function getTemporaryContentUrlsForMediaSids(mediaSids) {
        var _this2 = this;
        return new mcsClient.CancellablePromise(/* @__PURE__ */ function() {
          var _ref2 = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee15(resolve2, reject2, onCancel) {
            var request, urls;
            return _regeneratorRuntime__default2["default"].wrap(function _callee15$(_context15) {
              while (1) {
                switch (_context15.prev = _context15.next) {
                  case 0:
                    if (!(!_this2._services.mcsClient || !mediaSids)) {
                      _context15.next = 3;
                      break;
                    }
                    reject2(new Error("Media Content Service is unavailable"));
                    return _context15.abrupt("return");
                  case 3:
                    request = _this2._services.mcsClient.mediaSetGetContentUrls(mediaSids);
                    onCancel(function() {
                      request.cancel();
                    });
                    _context15.prev = 5;
                    _context15.next = 8;
                    return request;
                  case 8:
                    urls = _context15.sent;
                    resolve2(urls);
                    _context15.next = 15;
                    break;
                  case 12:
                    _context15.prev = 12;
                    _context15.t0 = _context15["catch"](5);
                    reject2(_context15.t0);
                  case 15:
                  case "end":
                    return _context15.stop();
                }
              }
            }, _callee15, null, [[5, 12]]);
          }));
          return function(_x13, _x14, _x15) {
            return _ref2.apply(this, arguments);
          };
        }());
      }
      /**
       * Get content URLs for all media attachments in the given set using a single
       * operation.
       * @param contentSet Set of media attachments to query content URLs.
       */
    }, {
      key: "getTemporaryContentUrlsForMedia",
      value: function getTemporaryContentUrlsForMedia(contentSet) {
        var sids = contentSet.map(function(m) {
          return m.sid;
        });
        return this.getTemporaryContentUrlsForMediaSids(sids);
      }
      /**
       * Returns rich content templates belonging to the account. Rich content
       * templates can be created via the Twilio console or the REST API.
       */
    }, {
      key: "getContentTemplates",
      value: function() {
        var _getContentTemplates = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee16() {
          return _regeneratorRuntime__default2["default"].wrap(function _callee16$(_context16) {
            while (1) {
              switch (_context16.prev = _context16.next) {
                case 0:
                  _context16.next = 2;
                  return this._ensureReady;
                case 2:
                  _context16.next = 4;
                  return this._services.contentClient.getContentTemplates();
                case 4:
                  return _context16.abrupt("return", _context16.sent);
                case 5:
                case "end":
                  return _context16.stop();
              }
            }
          }, _callee16, this);
        }));
        function getContentTemplates() {
          return _getContentTemplates.apply(this, arguments);
        }
        return getContentTemplates;
      }()
      /**
       * Initialize the client.
       */
    }, {
      key: "_initialize",
      value: function() {
        var _initialize2 = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee17() {
          var _this3 = this;
          var configurationResponse;
          return _regeneratorRuntime__default2["default"].wrap(function _callee17$(_context17) {
            while (1) {
              switch (_context17.prev = _context17.next) {
                case 0:
                  _context17.next = 2;
                  return this._services.commandExecutor.fetchResource("Client/v2/Configuration");
                case 2:
                  configurationResponse = _context17.sent;
                  this._configuration = new Configuration2(this._options, configurationResponse, Client_1._logger);
                  this._services.channelMetadataClient = new ChannelMetadataClient(this._services, this._configuration);
                  this._services.messageRecipientsClient = new MessageRecipientsClient(this._services, this._configuration);
                  this._myself._resolveInitialization(this._configuration, this._configuration.userIdentity, this._configuration.userInfo, true);
                  this._services.typingIndicator = new TypingIndicator(this.getConversationBySid.bind(this), this._configuration, this._services);
                  this._services.network = new Network(this._configuration, this._services);
                  this._services.users = new Users(this._myself, this._configuration, this._services);
                  this._services.users.on("userSubscribed", function(user) {
                    _this3.emit("userSubscribed", user);
                  });
                  this._services.users.on("userUpdated", function(args) {
                    return _this3.emit("userUpdated", args);
                  });
                  this._services.users.on("userUnsubscribed", function(user) {
                    _this3.emit("userUnsubscribed", user);
                  });
                  this._conversationsEntity = new Conversations(this._configuration, this._services);
                  this._conversationsEntity.on("conversationAdded", function(conversation) {
                    _this3.emit("conversationAdded", conversation);
                  });
                  this._conversationsEntity.on("conversationRemoved", function(conversation) {
                    _this3.emit("conversationRemoved", conversation);
                  });
                  this._conversationsEntity.on("conversationJoined", function(conversation) {
                    _this3.emit("conversationJoined", conversation);
                  });
                  this._conversationsEntity.on("conversationLeft", function(conversation) {
                    _this3.emit("conversationLeft", conversation);
                  });
                  this._conversationsEntity.on("conversationUpdated", function(args) {
                    return _this3.emit("conversationUpdated", args);
                  });
                  this._conversationsEntity.on("participantJoined", function(participant) {
                    _this3.emit("participantJoined", participant);
                  });
                  this._conversationsEntity.on("participantLeft", function(participant) {
                    _this3.emit("participantLeft", participant);
                  });
                  this._conversationsEntity.on("participantUpdated", function(args) {
                    return _this3.emit("participantUpdated", args);
                  });
                  this._conversationsEntity.on("messageAdded", function(message) {
                    return _this3.emit("messageAdded", message);
                  });
                  this._conversationsEntity.on("messageUpdated", function(args) {
                    return _this3.emit("messageUpdated", args);
                  });
                  this._conversationsEntity.on("messageRemoved", function(message) {
                    return _this3.emit("messageRemoved", message);
                  });
                  this._conversationsEntity.on("typingStarted", function(participant) {
                    return _this3.emit("typingStarted", participant);
                  });
                  this._conversationsEntity.on("typingEnded", function(participant) {
                    return _this3.emit("typingEnded", participant);
                  });
                  this._conversationsPromise = this._conversationsEntity.fetchConversations().then(function() {
                    return _this3._conversationsEntity;
                  }).catch(function(error2) {
                    throw error2;
                  });
                  _context17.next = 30;
                  return this._services.users.myself._ensureFetched();
                case 30:
                  Client_1._supportedPushChannels.forEach(function(channelType) {
                    return _this3._subscribeToPushNotifications(channelType);
                  });
                  this._services.typingIndicator.initialize();
                  this._services.mcsClient = new mcsClient.McsClient(this._fpaToken, this._configuration.links.mediaService, this._configuration.links.mediaSetService, _objectSpread2(_objectSpread2({}, this._options), {}, {
                    transport: void 0
                  }));
                  this._resolveEnsureReady();
                  this.emit(Client_1.stateChanged, "initialized");
                  this.emit(Client_1.initialized);
                case 36:
                case "end":
                  return _context17.stop();
              }
            }
          }, _callee17, this);
        }));
        function _initialize() {
          return _initialize2.apply(this, arguments);
        }
        return _initialize;
      }()
      /**
       * Subscribe to push notifications.
       * @param channelType The channel type to subscribe to.
       */
    }, {
      key: "_subscribeToPushNotifications",
      value: function _subscribeToPushNotifications(channelType) {
        var _this4 = this;
        [NotificationTypes.NEW_MESSAGE, NotificationTypes.ADDED_TO_CONVERSATION, NotificationTypes.REMOVED_FROM_CONVERSATION, NotificationTypes.TYPING_INDICATOR, NotificationTypes.CONSUMPTION_UPDATE].forEach(function(messageType) {
          _this4._services.notificationClient.subscribe(channelType, messageType);
        });
      }
      /**
       * Unsubscribe from push notifications.
       * @param channelType The channel type to unsubscribe from.
       */
    }, {
      key: "_unsubscribeFromPushNotifications",
      value: function _unsubscribeFromPushNotifications(channelType) {
        var _this5 = this;
        [NotificationTypes.NEW_MESSAGE, NotificationTypes.ADDED_TO_CONVERSATION, NotificationTypes.REMOVED_FROM_CONVERSATION, NotificationTypes.TYPING_INDICATOR, NotificationTypes.CONSUMPTION_UPDATE].forEach(function(messageType) {
          _this5._services.notificationClient.unsubscribe(channelType, messageType);
        });
      }
    }], [{
      key: "create",
      value: function() {
        var _create = _asyncToGenerator__default2["default"](/* @__PURE__ */ _regeneratorRuntime__default2["default"].mark(function _callee18(token, options) {
          var client;
          return _regeneratorRuntime__default2["default"].wrap(function _callee18$(_context18) {
            while (1) {
              switch (_context18.prev = _context18.next) {
                case 0:
                  if (!(options !== null && options !== void 0 && options.twilsockClient)) {
                    _context18.next = 2;
                    break;
                  }
                  throw new Error("Obsolete usage of ConversationsClient.create() factory method: if you pass twilsock from the outside then you must use ConversationsClient constructor and be prepared to work with uninitialized client.");
                case 2:
                  client = new Client_1(token, options);
                  _context18.next = 5;
                  return client._ensureReady;
                case 5:
                  return _context18.abrupt("return", client);
                case 6:
                case "end":
                  return _context18.stop();
              }
            }
          }, _callee18);
        }));
        function create4(_x16, _x17) {
          return _create.apply(this, arguments);
        }
        return create4;
      }()
      /**
       * Static method for push notification payload parsing. Returns parsed push as
       * a {@link PushNotification} object.
       * @param notificationPayload Push notification payload.
       */
    }, {
      key: "parsePushNotification",
      value: function parsePushNotification(notificationPayload) {
        Client_1._logger.debug("parsePushNotification, notificationPayload=", notificationPayload);
        if (typeof notificationPayload.aps !== "undefined") {
          if (!notificationPayload.twi_message_type) {
            throw new Error("Provided push notification payload does not contain Programmable Chat push notification type");
          }
          var data2 = Client_1._parsePushNotificationChatData(notificationPayload);
          var apsPayload = notificationPayload.aps;
          var body;
          var title = null;
          if (typeof apsPayload.alert === "string") {
            body = apsPayload.alert || null;
          } else {
            var _apsPayload$alert, _apsPayload$alert2;
            body = ((_apsPayload$alert = apsPayload.alert) === null || _apsPayload$alert === void 0 ? void 0 : _apsPayload$alert.body) || null;
            title = ((_apsPayload$alert2 = apsPayload.alert) === null || _apsPayload$alert2 === void 0 ? void 0 : _apsPayload$alert2.title) || null;
          }
          return new PushNotification({
            title,
            body,
            sound: apsPayload.sound || null,
            badge: apsPayload.badge || null,
            action: apsPayload.category || null,
            type: notificationPayload.twi_message_type,
            data: data2
          });
        }
        if (typeof notificationPayload.data !== "undefined") {
          var dataPayload = notificationPayload.data;
          if (!dataPayload.twi_message_type) {
            throw new Error("Provided push notification payload does not contain Programmable Chat push notification type");
          }
          var _data = Client_1._parsePushNotificationChatData(notificationPayload.data);
          return new PushNotification({
            title: dataPayload.twi_title || null,
            body: dataPayload.twi_body || null,
            sound: dataPayload.twi_sound || null,
            badge: null,
            action: dataPayload.twi_action || null,
            type: dataPayload.twi_message_type,
            data: _data
          });
        }
        throw new Error("Provided push notification payload is not Programmable Chat notification");
      }
      /**
       * Static method for parsing push notification chat data.
       * @param data Data to parse
       */
    }, {
      key: "_parsePushNotificationChatData",
      value: function _parsePushNotificationChatData(data2) {
        var result = {};
        for (var key in Client_1._supportedPushDataFields) {
          var value = data2[key];
          if (typeof value === "undefined" || value === null) {
            continue;
          }
          if (key === "message_index" || key === "media_count") {
            var number = parseToNumber(value);
            if (number !== null) {
              result[Client_1._supportedPushDataFields[key]] = number;
            }
            continue;
          }
          if (key === "media") {
            if (typeof value === "string") {
              try {
                result[Client_1._supportedPushDataFields[key]] = JSON.parse(value);
              } catch (_unused) {
                Client_1._logger.debug("Media message notification parsing error");
              }
            }
            continue;
          }
          result[Client_1._supportedPushDataFields[key]] = value;
        }
        return result;
      }
      /**
       * Populate the client with init registrations.
       * @param reg The init registration to populate.
       */
    }, {
      key: "populateInitRegistrations",
      value: function populateInitRegistrations(reg) {
        reg.populateInitRegistrations([NotificationTypes.TYPING_INDICATOR]);
        twilioSync.SyncClient.populateInitRegistrations(reg);
      }
    }]);
    return Client2;
  }(replayEventEmitter.ReplayEventEmitter), _defineProperty__default2["default"](_class, "conversationAdded", "conversationAdded"), _defineProperty__default2["default"](_class, "conversationJoined", "conversationJoined"), _defineProperty__default2["default"](_class, "conversationLeft", "conversationLeft"), _defineProperty__default2["default"](_class, "conversationRemoved", "conversationRemoved"), _defineProperty__default2["default"](_class, "conversationUpdated", "conversationUpdated"), _defineProperty__default2["default"](_class, "participantJoined", "participantJoined"), _defineProperty__default2["default"](_class, "participantLeft", "participantLeft"), _defineProperty__default2["default"](_class, "participantUpdated", "participantUpdated"), _defineProperty__default2["default"](_class, "messageAdded", "messageAdded"), _defineProperty__default2["default"](_class, "messageRemoved", "messageRemoved"), _defineProperty__default2["default"](_class, "messageUpdated", "messageUpdated"), _defineProperty__default2["default"](_class, "tokenAboutToExpire", "tokenAboutToExpire"), _defineProperty__default2["default"](_class, "tokenExpired", "tokenExpired"), _defineProperty__default2["default"](_class, "typingEnded", "typingEnded"), _defineProperty__default2["default"](_class, "typingStarted", "typingStarted"), _defineProperty__default2["default"](_class, "pushNotification", "pushNotification"), _defineProperty__default2["default"](_class, "userSubscribed", "userSubscribed"), _defineProperty__default2["default"](_class, "userUnsubscribed", "userUnsubscribed"), _defineProperty__default2["default"](_class, "userUpdated", "userUpdated"), _defineProperty__default2["default"](_class, "stateChanged", "stateChanged"), _defineProperty__default2["default"](_class, "initialized", "initialized"), _defineProperty__default2["default"](_class, "initFailed", "initFailed"), _defineProperty__default2["default"](_class, "connectionStateChanged", "connectionStateChanged"), _defineProperty__default2["default"](_class, "connectionError", "connectionError"), _defineProperty__default2["default"](_class, "version", version2), _defineProperty__default2["default"](_class, "_logger", Logger.scope("Client")), _defineProperty__default2["default"](_class, "_supportedPushChannels", ["fcm", "apn"]), _defineProperty__default2["default"](_class, "_supportedPushDataFields", {
    conversation_sid: "conversationSid",
    conversation_title: "conversationTitle",
    message_sid: "messageSid",
    message_index: "messageIndex",
    media_count: "mediaCount",
    media: "media"
    // object
  }), _class);
  __decorate2([deprecationDecorator.deprecated("token"), __metadata2("design:type", String), __metadata2("design:paramtypes", [])], exports.Client.prototype, "token", null);
  __decorate2([declarativeTypeValidator2.validateTypesAsync(declarativeTypeValidator2.nonEmptyString), __metadata2("design:type", Function), __metadata2("design:paramtypes", [String]), __metadata2("design:returntype", Promise)], exports.Client.prototype, "updateToken", null);
  __decorate2([declarativeTypeValidator2.validateTypesAsync(declarativeTypeValidator2.nonEmptyString), __metadata2("design:type", Function), __metadata2("design:paramtypes", [String]), __metadata2("design:returntype", Promise)], exports.Client.prototype, "getConversationBySid", null);
  __decorate2([declarativeTypeValidator2.validateTypesAsync(declarativeTypeValidator2.nonEmptyString), __metadata2("design:type", Function), __metadata2("design:paramtypes", [String]), __metadata2("design:returntype", Promise)], exports.Client.prototype, "peekConversationBySid", null);
  __decorate2([declarativeTypeValidator2.validateTypesAsync(declarativeTypeValidator2.nonEmptyString), __metadata2("design:type", Function), __metadata2("design:paramtypes", [String]), __metadata2("design:returntype", Promise)], exports.Client.prototype, "getConversationByUniqueName", null);
  __decorate2([declarativeTypeValidator2.validateTypesAsync(["undefined", declarativeTypeValidator2.objectSchema("conversation options", {
    friendlyName: ["string", "undefined"],
    isPrivate: ["boolean", "undefined"],
    uniqueName: ["string", "undefined"]
  })]), __metadata2("design:type", Function), __metadata2("design:paramtypes", [Object]), __metadata2("design:returntype", Promise)], exports.Client.prototype, "createConversation", null);
  __decorate2([declarativeTypeValidator2.validateTypesAsync(declarativeTypeValidator2.literal("fcm", "apn"), "string"), __metadata2("design:type", Function), __metadata2("design:paramtypes", [String, String]), __metadata2("design:returntype", Promise)], exports.Client.prototype, "setPushRegistrationId", null);
  __decorate2([declarativeTypeValidator2.validateTypesAsync(declarativeTypeValidator2.literal("fcm", "apn")), __metadata2("design:type", Function), __metadata2("design:paramtypes", [String]), __metadata2("design:returntype", Promise)], exports.Client.prototype, "unsetPushRegistrationId", null);
  __decorate2([declarativeTypeValidator2.validateTypesAsync(declarativeTypeValidator2.literal("fcm", "apn"), declarativeTypeValidator2.nonEmptyString), __metadata2("design:type", Function), __metadata2("design:paramtypes", [String, String]), __metadata2("design:returntype", Promise)], exports.Client.prototype, "removePushRegistrations", null);
  __decorate2([declarativeTypeValidator2.validateTypesAsync(declarativeTypeValidator2.pureObject), __metadata2("design:type", Function), __metadata2("design:paramtypes", [Object]), __metadata2("design:returntype", Promise)], exports.Client.prototype, "handlePushNotification", null);
  __decorate2([declarativeTypeValidator2.validateTypesAsync(declarativeTypeValidator2.nonEmptyString), __metadata2("design:type", Function), __metadata2("design:paramtypes", [String]), __metadata2("design:returntype", Promise)], exports.Client.prototype, "getUser", null);
  __decorate2([declarativeTypeValidator2.validateTypesAsync(declarativeTypeValidator2.nonEmptyArray("strings", "string")), __metadata2("design:type", Function), __metadata2("design:paramtypes", [Array]), __metadata2("design:returntype", mcsClient.CancellablePromise)], exports.Client.prototype, "getTemporaryContentUrlsForMediaSids", null);
  __decorate2([declarativeTypeValidator2.validateTypesAsync(declarativeTypeValidator2.nonEmptyArray("media", Media)), __metadata2("design:type", Function), __metadata2("design:paramtypes", [Array]), __metadata2("design:returntype", mcsClient.CancellablePromise)], exports.Client.prototype, "getTemporaryContentUrlsForMedia", null);
  __decorate2([deprecationDecorator.deprecated("Client.create()", "new Client()"), declarativeTypeValidator2.validateTypesAsync("string", ["undefined", declarativeTypeValidator2.pureObject]), __metadata2("design:type", Function), __metadata2("design:paramtypes", [String, Object]), __metadata2("design:returntype", Promise)], exports.Client, "create", null);
  __decorate2([declarativeTypeValidator2.validateTypes(declarativeTypeValidator2.pureObject), __metadata2("design:type", Function), __metadata2("design:paramtypes", [Object]), __metadata2("design:returntype", PushNotification)], exports.Client, "parsePushNotification", null);
  exports.Client = Client_1 = __decorate2([declarativeTypeValidator2.validateConstructorTypes(declarativeTypeValidator2.nonEmptyString, [declarativeTypeValidator2.pureObject, "undefined"]), __metadata2("design:paramtypes", [String, Object])], exports.Client);
  Object.defineProperty(exports, "CancellablePromise", {
    enumerable: true,
    get: function() {
      return mcsClient.CancellablePromise;
    }
  });
  exports.AggregatedDeliveryReceipt = AggregatedDeliveryReceipt;
  exports.ChannelMetadata = ChannelMetadata;
  exports.ContentTemplate = ContentTemplate;
  exports.ContentTemplateVariable = ContentTemplateVariable;
  exports.Conversation = Conversation;
  exports.DetailedDeliveryReceipt = DetailedDeliveryReceipt;
  exports.EmailRecipientDescriptor = EmailRecipientDescriptor;
  exports.Media = Media;
  exports.Message = Message;
  exports.MessageBuilder = MessageBuilder;
  exports.NotificationTypes = NotificationTypes;
  exports.Participant = Participant;
  exports.PushNotification = PushNotification;
  exports.RestPaginator = RestPaginator;
  exports.UnknownRecipientDescriptor = UnknownRecipientDescriptor;
  exports.UnsentMessage = UnsentMessage;
  exports.User = User;
})(browser$a);
const objectWithMessagePropertySchema = Joi.object({
  message: Joi.string().required()
}).unknown(true);
const apiResponseSchema = Joi.object({
  id: Joi.string().optional(),
  session: Joi.string().optional(),
  success: Joi.boolean().allow(null),
  timestamp: Joi.string().isoDate(),
  status: Joi.number().integer().required(),
  data: Joi.any().optional(),
  errors: Joi.array().items(objectWithMessagePropertySchema).optional(),
  warnings: Joi.array().items(objectWithMessagePropertySchema).optional()
});
const isApiResponse = (value) => {
  const { error: error2 } = apiResponseSchema.validate(value);
  return !error2;
};
const isValidIdentityFeedback = (value) => {
  const schema = Joi.object({
    bearer: Joi.string().required(),
    expiration: Joi.string().isoDate().required(),
    identity: Joi.string().required(),
    type: Joi.string().allow("agent", "client").required(),
    username: Joi.string().required()
  }).unknown(true);
  const { error: error2 } = schema.validate(value);
  return !error2;
};
const isValidConversationFeedback = (value) => {
  const schema = Joi.object({
    sid: Joi.string().required()
  }).unknown(true);
  const { error: error2 } = schema.validate(value);
  return !error2;
};
const tdbg = getDebugger("T", "#FFFFFF", "#233659");
const instanceRef = shallowRef(void 0);
const instance = computed(
  () => instanceRef.value
);
const _MalarkeyTwilioAdapter = class _MalarkeyTwilioAdapter {
  constructor(clientConstructor, http, bus, identity, ls, _options) {
    __privateAdd(this, _fetchAndCacheParticipantDisplayName);
    __privateAdd(this, _saveParticipantDisplayNameCache);
    __privateAdd(this, _loadParticipantDisplayNameCache);
    __privateAdd(this, _onIdentityLoggedIn);
    __privateAdd(this, _onIdentityLoggedOut);
    __privateAdd(this, _onServiceWorkerPush);
    __privateAdd(this, _onRosterUpdated);
    /**
     * Handler for Twilio Client's `initialized` event
     */
    __privateAdd(this, _onTwilioInitialized);
    /**
     * Handler for Twilio Client's `initFailed` event
     */
    __privateAdd(this, _onTwilioInitFailed);
    /**
     * Handler for Twilio Client's `connectionError` event
     */
    __privateAdd(this, _onTwilioConnectionError);
    /**
     * Handler for Twilio Client's `connectionStateChanged` event
     */
    __privateAdd(this, _onTwilioConnectionStateChanged);
    /**
     * Handler for Twilio Client's `conversationAdded` event
     */
    __privateAdd(this, _onTwilioConversationAdded);
    /**
     * Handler for Twilio Client's `conversationJoined` event
     */
    __privateAdd(this, _onTwilioConversationJoined);
    /**
     * Handler for Twilio Client's `conversationLeft` event
     */
    __privateAdd(this, _onTwilioConversationLeft);
    /**
     * Handler for Twilio Client's `conversationRemoved` event
     */
    __privateAdd(this, _onTwilioConversationRemoved);
    /**
     * Handler for Twilio Client's `conversationUpdated` event
     */
    __privateAdd(this, _onTwilioConversationUpdated);
    /**
     * Handler for Twilio Client's `messageAdded` event
     */
    __privateAdd(this, _onTwilioMessageAdded);
    /**
     * Handler for Twilio Client's `messageRemoved` event
     */
    __privateAdd(this, _onTwilioMessageRemoved);
    /**
     * Handler for Twilio Client's `messageUpdated` event
     */
    __privateAdd(this, _onTwilioMessageUpdated);
    /**
     * Handler for Twilio Client's `participantJoined` event
     */
    __privateAdd(this, _onTwilioParticipantJoined);
    /**
     * Handler for Twilio Client's `participantLeft` event
     */
    __privateAdd(this, _onTwilioParticipantLeft);
    /**
     * Handler for Twilio Client's `participantUpdated` event
     */
    __privateAdd(this, _onTwilioParticipantUpdated);
    /**
     * Handler for Twilio Client's `pushNotification` event
     */
    __privateAdd(this, _onTwilioPushNotification);
    /**
     * Handler for Twilio Client's `tokenAboutToExpire` event
     */
    __privateAdd(this, _onTwilioTokenAboutToExpire);
    /**
     * Handler for Twilio Client's `tokenExpired` event
     */
    __privateAdd(this, _onTwilioTokenExpired);
    /**
     * Handler for Twilio Client's `typingEnded` event
     * @param participant The participant who has stopped typing.
     */
    __privateAdd(this, _onTwilioTypingEnded);
    /**
     * Handler for Twilio Client's `typingStarted` event
     * @param participant The participant who has started typing.
     */
    __privateAdd(this, _onTwilioTypingStarted);
    /**
     * Handler for Twilio Client's `userSubscribed` event
     * @param user The user who is now visible to the client.
     */
    __privateAdd(this, _onTwilioUserSubscribed);
    /**
     * Handler for Twilio Client's `userUnsubscribed` event
     * @param user The user who is no longer visible to the client.
     */
    __privateAdd(this, _onTwilioUserUnsubscribed);
    /**
     * Handler for Twilio Client's `userUpdated` event
     * @param data
     * @param data.user The user who has been updated.
     * @param data.updateReasons The reasons for the update.
     */
    __privateAdd(this, _onTwilioUserUpdated);
    __privateAdd(this, _getCacheStorage);
    __privateAdd(this, _getRosterFromCache);
    __privateAdd(this, _saveRosterToCache);
    __privateAdd(this, _getRosterFromApi);
    __privateAdd(this, _getConversationsFromSdk);
    __privateAdd(this, _addConversation);
    __privateAdd(this, _removeConversation);
    __privateAdd(this, _updateConversation);
    __privateAdd(this, _conversationToChecksum);
    __privateAdd(this, _onPushFirebaseMessage);
    __privateAdd(this, _onAfterConversationsListUpdated);
    __privateAdd(this, _clientConstructor, void 0);
    __privateAdd(this, _http, void 0);
    __privateAdd(this, _bus, void 0);
    __privateAdd(this, _identity, void 0);
    __privateAdd(this, _ls, void 0);
    // readonly #options: MalarkeyTwilioAdapterOptions;
    __privateAdd(this, _client, shallowRef(void 0));
    __privateAdd(this, _twilioInitialized, ref(null));
    __privateAdd(this, _twilioConnectionState, ref(
      void 0
    ));
    __privateAdd(this, _fcmToken, ref(void 0));
    __privateAdd(this, _typing, ref({}));
    __privateAdd(this, _me, shallowRef(void 0));
    __privateAdd(this, _roster, shallowRef([]));
    __privateAdd(this, _conversations, shallowRef([]));
    __privateAdd(this, _fetchingParticipantDisplayName, /* @__PURE__ */ new Map());
    __privateAdd(this, _participantDisplayNamesCache, /* @__PURE__ */ new Map());
    __privateAdd(this, _rosterUpdateAbortController, void 0);
    __privateSet(this, _clientConstructor, clientConstructor);
    __privateSet(this, _http, http);
    __privateSet(this, _bus, bus);
    __privateSet(this, _identity, identity);
    __privateSet(this, _ls, ls);
    __privateGet(this, _bus).on("identity:login", __privateMethod(this, _onIdentityLoggedIn, onIdentityLoggedIn_fn).bind(this), {
      local: true,
      crossTab: true,
      immediate: true
    });
    __privateGet(this, _bus).on("identity:logout", __privateMethod(this, _onIdentityLoggedOut, onIdentityLoggedOut_fn).bind(this), {
      local: true,
      crossTab: true,
      immediate: true
    });
    __privateGet(this, _bus).on("sw:push", __privateMethod(this, _onServiceWorkerPush, onServiceWorkerPush_fn).bind(this), {
      crossTab: true,
      immediate: true
    });
    __privateGet(this, _bus).on("sw:roster:updated", __privateMethod(this, _onRosterUpdated, onRosterUpdated_fn).bind(this), {
      local: true,
      crossTab: true,
      immediate: true
    });
    __privateGet(this, _bus).on(
      "background:roster:updated",
      __privateMethod(this, _onRosterUpdated, onRosterUpdated_fn).bind(this),
      {
        local: true,
        crossTab: true,
        immediate: true
      }
    );
    __privateGet(this, _bus).on(
      "push:firebase:message",
      __privateMethod(this, _onPushFirebaseMessage, onPushFirebaseMessage_fn).bind(this),
      {
        local: true
      }
    );
    watch(
      () => __privateGet(this, _identity).booted.value,
      (is2) => {
        if (is2) {
          __privateMethod(this, _getRosterFromCache, getRosterFromCache_fn).call(this).then((roster) => {
            if (Array.isArray(roster) && roster.length > 0) {
              __privateGet(this, _roster).value = roster;
              triggerRef(__privateGet(this, _roster));
              __privateGet(this, _bus).emit(
                "twilio:adapter:roster:updated",
                {
                  local: true
                },
                roster
              );
              tdbg("Initial Roster Loaded from Cache");
            }
          });
          if (__privateGet(this, _identity).authenticated.value) {
            tdbg("Existing Session Active. Logging in.");
            const bearer = __privateGet(this, _ls).get("bearer");
            const expiration = __privateGet(this, _ls).get("expiration");
            const identity2 = __privateGet(this, _identity).user.value;
            __privateMethod(this, _onIdentityLoggedIn, onIdentityLoggedIn_fn).call(this, bearer, expiration, identity2);
          } else {
            tdbg("No Existing Session Active.");
          }
        }
      },
      { immediate: true }
    );
    __privateMethod(this, _getRosterFromCache, getRosterFromCache_fn).call(this).then((roster) => {
      if (Array.isArray(roster) && roster.length > 0) {
        __privateGet(this, _roster).value = roster;
        triggerRef(__privateGet(this, _roster));
        __privateGet(this, _bus).emit(
          "twilio:adapter:roster:updated",
          {
            local: true
          },
          roster
        );
        tdbg("Initial Roster Loaded from Cache");
      }
    });
  }
  get initialized() {
    return computed(() => __privateGet(this, _twilioInitialized).value);
  }
  /**
   * Returns the Twilio Conversations Client User object.
   */
  get me() {
    return computed(() => __privateGet(this, _me).value);
  }
  /**
   * Returns the Twilio Conversations Client instance.
   * @type ComputedRef<TwilsockConnectionState | undefined>
   */
  get connectionState() {
    return computed(
      () => __privateGet(this, _twilioConnectionState).value
    );
  }
  /**
   * Returns an array of participant SIDs who are currently typing.
   */
  get typing() {
    return computed(() => {
      const ret = [];
      for (const [key, value] of Object.entries(__privateGet(this, _typing).value)) {
        if (value) {
          ret.push(key);
        }
      }
      return ret;
    });
  }
  /**
   * Returns the roster of users visible to the client.
   */
  get roster() {
    return computed(() => {
      return __privateGet(this, _roster).value;
    });
  }
  /**
   * Returns the conversations the client is currently subscribed to.
   */
  get conversations() {
    return computed(
      () => [...__privateGet(this, _conversations).value].sort(
        (a, b) => {
          let aLastUpdatedAt;
          let bLastUpdatedAt;
          if (a.lastMessage && a.lastMessage.dateCreated) {
            aLastUpdatedAt = DateTime.fromJSDate(a.lastMessage.dateCreated);
          } else if (a.dateUpdated) {
            aLastUpdatedAt = DateTime.fromJSDate(a.dateUpdated);
          } else if (a.dateCreated) {
            aLastUpdatedAt = DateTime.fromJSDate(a.dateCreated);
          } else {
            aLastUpdatedAt = void 0;
          }
          if (b.lastMessage && b.lastMessage.dateCreated) {
            bLastUpdatedAt = DateTime.fromJSDate(b.lastMessage.dateCreated);
          } else if (b.dateUpdated) {
            bLastUpdatedAt = DateTime.fromJSDate(b.dateUpdated);
          } else if (b.dateCreated) {
            bLastUpdatedAt = DateTime.fromJSDate(b.dateCreated);
          } else {
            bLastUpdatedAt = void 0;
          }
          if (aLastUpdatedAt && bLastUpdatedAt) {
            return aLastUpdatedAt < bLastUpdatedAt ? 1 : -1;
          } else if (aLastUpdatedAt) {
            return -1;
          } else if (bLastUpdatedAt) {
            return 1;
          } else {
            return 0;
          }
        }
      )
    );
  }
  /**
   * Returns a map of conversations with their checksums
   */
  get conversationCheckSumMap() {
    return computed(() => {
      const ret = {};
      __privateGet(this, _conversations).value.forEach((c) => {
        ret[c.sid] = __privateMethod(this, _conversationToChecksum, conversationToChecksum_fn).call(this, c);
      });
      return ret;
    });
  }
  async onAuthenticatedForFirebase(token) {
    if (__privateGet(this, _client).value) {
      try {
        await __privateGet(this, _client).value.setPushRegistrationId("fcm", token);
        tdbg("Updated Firebase Token");
      } catch (error2) {
        tdbg(error2);
      }
    }
    __privateGet(this, _fcmToken).value = token;
  }
  async onUnauthenticatedForFirebase(token) {
    if (__privateGet(this, _client).value) {
      try {
        await __privateGet(this, _client).value.removePushRegistrations("fcm", token);
        tdbg("Disassociated Firebase Token");
      } catch (error2) {
        tdbg(error2);
      }
    }
    __privateGet(this, _fcmToken).value = void 0;
  }
  getParticipantDisplayNameFromCache(p) {
    if (!p.identity) {
      return void 0;
    }
    const ret = __privateGet(this, _participantDisplayNamesCache).get(p.identity);
    if (!ret) {
      __privateMethod(this, _fetchAndCacheParticipantDisplayName, fetchAndCacheParticipantDisplayName_fn).call(this, p.identity);
    }
    return ret;
  }
  doRosterUpdate() {
    Promise.all([__privateMethod(this, _getRosterFromApi, getRosterFromApi_fn).call(this)]).then(async ([roster]) => {
      __privateMethod(this, _saveRosterToCache, saveRosterToCache_fn).call(this, roster);
      __privateGet(this, _roster).value = roster;
      __privateGet(this, _bus).emit(
        "twilio:adapter:roster:updated",
        {
          local: true
        },
        roster
      );
      triggerRef(__privateGet(this, _roster));
    }).catch(() => {
    });
  }
  /**
   * Installs the MalarkeyTwilioAdapter on the Vue app instance.
   * @param app The Vue app instance.
   * @param options The options for the adapter.
   */
  static install(app, options) {
    if (app.twilio) {
      return;
    }
    let clientConstructor;
    if (!options.ssr) {
      debug(
        "Loading Twilio Conversations Client Adapter for Browser Environment"
      );
      clientConstructor = browser$a.Client;
    } else {
      debug(
        "Loading Twilio Conversations Client Adapter for Server Environment"
      );
    }
    const adapter = new _MalarkeyTwilioAdapter(
      clientConstructor,
      app.config.globalProperties.$http,
      app.config.globalProperties.$bus,
      app.config.globalProperties.$identity,
      app.config.globalProperties.$ls,
      options
    );
    debug("Twilio Adapter Created");
    app.config.globalProperties.$twilio = adapter;
    app.provide("twilio", adapter);
    debug("Twilio Adapter Provided");
    instanceRef.value = adapter;
    debug("Instance Populated");
    app.twilio = true;
  }
};
_clientConstructor = new WeakMap();
_http = new WeakMap();
_bus = new WeakMap();
_identity = new WeakMap();
_ls = new WeakMap();
_client = new WeakMap();
_twilioInitialized = new WeakMap();
_twilioConnectionState = new WeakMap();
_fcmToken = new WeakMap();
_typing = new WeakMap();
_me = new WeakMap();
_roster = new WeakMap();
_conversations = new WeakMap();
_fetchingParticipantDisplayName = new WeakMap();
_participantDisplayNamesCache = new WeakMap();
_rosterUpdateAbortController = new WeakMap();
_fetchAndCacheParticipantDisplayName = new WeakSet();
fetchAndCacheParticipantDisplayName_fn = async function(identity) {
  if (__privateGet(this, _fetchingParticipantDisplayName).has(identity) || !__privateGet(this, _http)) {
    return;
  }
  const abortController = new AbortController();
  __privateGet(this, _fetchingParticipantDisplayName).set(identity, abortController);
  try {
    const { status, data: data2 } = await __privateGet(this, _http).get(
      `/roster/${identity}/name`,
      {
        signal: abortController.signal
      }
    );
    if (status === 200 && "string" === typeof data2.data) {
      __privateGet(this, _participantDisplayNamesCache).set(identity, data2.data);
      __privateMethod(this, _saveParticipantDisplayNameCache, saveParticipantDisplayNameCache_fn).call(this);
      __privateGet(this, _bus).emit(
        "twilio:adapter:roster:updated",
        {
          local: true
        },
        __privateGet(this, _roster).value
      );
    }
  } catch {
  }
};
_saveParticipantDisplayNameCache = new WeakSet();
saveParticipantDisplayNameCache_fn = async function() {
  const cacheStorage = await __privateMethod(this, _getCacheStorage, getCacheStorage_fn).call(this);
  if (!cacheStorage) {
    return;
  }
  const uri = "/" + ["identity", __privateGet(this, _identity).user.value.id, "display-name-cache"].join(
    "/"
  );
  const obj = {};
  __privateGet(this, _participantDisplayNamesCache).forEach((v, k) => {
    obj[k] = v;
  });
  try {
    await cacheStorage.put(uri, new Response(JSON.stringify(obj)));
  } catch {
  }
};
_loadParticipantDisplayNameCache = new WeakSet();
loadParticipantDisplayNameCache_fn = async function() {
  const cacheStorage = await __privateMethod(this, _getCacheStorage, getCacheStorage_fn).call(this);
  if (!cacheStorage) {
    return;
  }
  const uri = "/" + ["identity", __privateGet(this, _identity).user.value.id, "display-name-cache"].join(
    "/"
  );
  let fromCache;
  try {
    fromCache = await cacheStorage.match(uri);
  } catch {
  }
  if (fromCache && fromCache.ok) {
    const results = await fromCache.json();
    for (const key in results) {
      __privateGet(this, _participantDisplayNamesCache).set(key, results[key]);
    }
  }
};
_onIdentityLoggedIn = new WeakSet();
onIdentityLoggedIn_fn = function(bearer, _expiration, _identity2, _from) {
  __privateMethod(this, _loadParticipantDisplayNameCache, loadParticipantDisplayNameCache_fn).call(this);
  if (!__privateGet(this, _clientConstructor)) {
    tdbg("Skipping Initialization: No Client Constructor");
    return;
  }
  if (__privateGet(this, _client).value) {
    tdbg("already initialized. Updating token.");
    __privateGet(this, _client).value.updateToken(bearer);
  } else {
    tdbg("Initializing with new token.");
    __privateGet(this, _client).value = new (__privateGet(this, _clientConstructor))(bearer);
    triggerRef(__privateGet(this, _client));
    __privateGet(this, _client).value.on(
      "initialized",
      __privateMethod(this, _onTwilioInitialized, onTwilioInitialized_fn).bind(this)
    );
    __privateGet(this, _client).value.on("initFailed", __privateMethod(this, _onTwilioInitFailed, onTwilioInitFailed_fn).bind(this));
    __privateGet(this, _client).value.on(
      "connectionError",
      __privateMethod(this, _onTwilioConnectionError, onTwilioConnectionError_fn).bind(this)
    );
    __privateGet(this, _client).value.on(
      "connectionStateChanged",
      __privateMethod(this, _onTwilioConnectionStateChanged, onTwilioConnectionStateChanged_fn).bind(this)
    );
    __privateGet(this, _client).value.on(
      "conversationAdded",
      __privateMethod(this, _onTwilioConversationAdded, onTwilioConversationAdded_fn).bind(this)
    );
    __privateGet(this, _client).value.on(
      "conversationJoined",
      __privateMethod(this, _onTwilioConversationJoined, onTwilioConversationJoined_fn).bind(this)
    );
    __privateGet(this, _client).value.on(
      "conversationLeft",
      __privateMethod(this, _onTwilioConversationLeft, onTwilioConversationLeft_fn).bind(this)
    );
    __privateGet(this, _client).value.on(
      "conversationRemoved",
      __privateMethod(this, _onTwilioConversationRemoved, onTwilioConversationRemoved_fn).bind(this)
    );
    __privateGet(this, _client).value.on(
      "conversationUpdated",
      __privateMethod(this, _onTwilioConversationUpdated, onTwilioConversationUpdated_fn).bind(this)
    );
    __privateGet(this, _client).value.on(
      "messageAdded",
      __privateMethod(this, _onTwilioMessageAdded, onTwilioMessageAdded_fn).bind(this)
    );
    __privateGet(this, _client).value.on(
      "messageRemoved",
      __privateMethod(this, _onTwilioMessageRemoved, onTwilioMessageRemoved_fn).bind(this)
    );
    __privateGet(this, _client).value.on(
      "messageUpdated",
      __privateMethod(this, _onTwilioMessageUpdated, onTwilioMessageUpdated_fn).bind(this)
    );
    __privateGet(this, _client).value.on(
      "participantJoined",
      __privateMethod(this, _onTwilioParticipantJoined, onTwilioParticipantJoined_fn).bind(this)
    );
    __privateGet(this, _client).value.on(
      "participantLeft",
      __privateMethod(this, _onTwilioParticipantLeft, onTwilioParticipantLeft_fn).bind(this)
    );
    __privateGet(this, _client).value.on(
      "participantUpdated",
      __privateMethod(this, _onTwilioParticipantUpdated, onTwilioParticipantUpdated_fn).bind(this)
    );
    __privateGet(this, _client).value.on(
      "pushNotification",
      __privateMethod(this, _onTwilioPushNotification, onTwilioPushNotification_fn).bind(this)
    );
    __privateGet(this, _client).value.on(
      "tokenAboutToExpire",
      __privateMethod(this, _onTwilioTokenAboutToExpire, onTwilioTokenAboutToExpire_fn).bind(this)
    );
    __privateGet(this, _client).value.on(
      "tokenExpired",
      __privateMethod(this, _onTwilioTokenExpired, onTwilioTokenExpired_fn).bind(this)
    );
    __privateGet(this, _client).value.on(
      "typingEnded",
      __privateMethod(this, _onTwilioTypingEnded, onTwilioTypingEnded_fn).bind(this)
    );
    __privateGet(this, _client).value.on(
      "typingStarted",
      __privateMethod(this, _onTwilioTypingStarted, onTwilioTypingStarted_fn).bind(this)
    );
    __privateGet(this, _client).value.on(
      "userSubscribed",
      __privateMethod(this, _onTwilioUserSubscribed, onTwilioUserSubscribed_fn).bind(this)
    );
    __privateGet(this, _client).value.on(
      "userUnsubscribed",
      __privateMethod(this, _onTwilioUserUnsubscribed, onTwilioUserUnsubscribed_fn).bind(this)
    );
    __privateGet(this, _client).value.on(
      "userUpdated",
      __privateMethod(this, _onTwilioUserUpdated, onTwilioUserUpdated_fn).bind(this)
    );
    if (__privateGet(this, _fcmToken).value) {
      __privateGet(this, _client).value.setPushRegistrationId("fcm", __privateGet(this, _fcmToken).value);
    }
  }
  __privateGet(this, _me).value = __privateGet(this, _client).value.user;
  triggerRef(__privateGet(this, _me));
  __privateMethod(this, _getRosterFromCache, getRosterFromCache_fn).call(this).then((roster) => {
    if (Array.isArray(roster) && roster.length > 0) {
      __privateGet(this, _roster).value = roster;
      triggerRef(__privateGet(this, _roster));
      __privateGet(this, _bus).emit(
        "twilio:adapter:roster:updated",
        {
          local: true
        },
        roster
      );
    }
  });
  Promise.all([__privateMethod(this, _getRosterFromApi, getRosterFromApi_fn).call(this), __privateMethod(this, _getConversationsFromSdk, getConversationsFromSdk_fn).call(this)]).then(async ([roster, conversations]) => {
    console.log({ conversations });
    __privateMethod(this, _saveRosterToCache, saveRosterToCache_fn).call(this, roster);
    __privateGet(this, _roster).value = roster;
    triggerRef(__privateGet(this, _roster));
    __privateGet(this, _bus).emit(
      "twilio:adapter:roster:updated",
      {
        local: true
      },
      roster
    );
    tdbg("Roster Updated");
  }).catch(() => {
  });
};
_onIdentityLoggedOut = new WeakSet();
onIdentityLoggedOut_fn = function() {
  __privateGet(this, _fetchingParticipantDisplayName).forEach((controller) => {
    controller.abort();
  });
  __privateGet(this, _fetchingParticipantDisplayName).clear();
  if (__privateGet(this, _client).value) {
    tdbg("Shutting Down");
    if (__privateGet(this, _fcmToken).value) {
      __privateGet(this, _client).value.removePushRegistrations("fcm", __privateGet(this, _fcmToken).value);
    }
    __privateGet(this, _client).value.shutdown();
    tdbg("Goodbye!");
    __privateGet(this, _client).value = void 0;
    triggerRef(__privateGet(this, _client));
  } else {
    tdbg("Already Shut Down");
  }
  __privateGet(this, _roster).value = [];
  __privateGet(this, _conversations).value = [];
  __privateGet(this, _me).value = void 0;
  triggerRef(__privateGet(this, _me));
  triggerRef(__privateGet(this, _roster));
  __privateMethod(this, _onAfterConversationsListUpdated, onAfterConversationsListUpdated_fn).call(this);
};
_onServiceWorkerPush = new WeakSet();
onServiceWorkerPush_fn = function(event) {
  debug("Service Worker Push Event", event);
};
_onRosterUpdated = new WeakSet();
onRosterUpdated_fn = function() {
  Promise.all([__privateMethod(this, _getRosterFromApi, getRosterFromApi_fn).call(this)]).then(async ([roster]) => {
    __privateMethod(this, _saveRosterToCache, saveRosterToCache_fn).call(this, roster);
    __privateGet(this, _roster).value = roster;
    __privateGet(this, _bus).emit(
      "twilio:adapter:roster:updated",
      {
        local: true
      },
      roster
    );
    triggerRef(__privateGet(this, _roster));
    tdbg("Roster Updated");
  }).catch(() => {
  });
};
_onTwilioInitialized = new WeakSet();
onTwilioInitialized_fn = function() {
  __privateGet(this, _twilioInitialized).value = true;
  __privateGet(this, _bus).emit("twilio:client:initialized", {
    local: true
  });
  tdbg("Initialized");
};
_onTwilioInitFailed = new WeakSet();
onTwilioInitFailed_fn = function({ error: error2 }) {
  __privateGet(this, _twilioInitialized).value = false;
  __privateGet(this, _bus).emit(
    "twilio:client:initFailed",
    {
      local: true
    },
    { error: error2 }
  );
  if (error2) {
    tdbg("Initialization Failed:", error2.message);
  }
  __privateGet(this, _twilioConnectionState).value = void 0;
};
_onTwilioConnectionError = new WeakSet();
onTwilioConnectionError_fn = function(data2) {
  __privateGet(this, _bus).emit(
    "twilio:client:connectionError",
    {
      local: true
    },
    data2
  );
  if (data2.terminal) {
    tdbg("Connection Error:", data2.message);
    if (__privateGet(this, _identity).authenticated.value) {
      __privateGet(this, _identity).logout();
    }
  }
};
_onTwilioConnectionStateChanged = new WeakSet();
onTwilioConnectionStateChanged_fn = function(state) {
  __privateGet(this, _bus).emit(
    "twilio:client:connectionStateChanged",
    {
      local: true
    },
    state
  );
  tdbg("Connection State Changed:", state);
  __privateGet(this, _twilioConnectionState).value = state;
};
_onTwilioConversationAdded = new WeakSet();
onTwilioConversationAdded_fn = function(conversation) {
  __privateGet(this, _bus).emit(
    "twilio:client:conversationAdded",
    {
      local: true
    },
    conversation
  );
  __privateMethod(this, _addConversation, addConversation_fn).call(this, conversation);
  tdbg("Conversation Added:", conversation);
};
_onTwilioConversationJoined = new WeakSet();
onTwilioConversationJoined_fn = function(conversation) {
  __privateGet(this, _bus).emit(
    "twilio:client:conversationJoined",
    {
      local: true
    },
    conversation
  );
  __privateMethod(this, _addConversation, addConversation_fn).call(this, conversation);
  tdbg("Conversation Joined:", conversation);
};
_onTwilioConversationLeft = new WeakSet();
onTwilioConversationLeft_fn = function(conversation) {
  __privateGet(this, _bus).emit(
    "twilio:client:conversationLeft",
    {
      local: true
    },
    conversation
  );
  __privateMethod(this, _removeConversation, removeConversation_fn).call(this, conversation);
  tdbg("Conversation Left:", conversation);
};
_onTwilioConversationRemoved = new WeakSet();
onTwilioConversationRemoved_fn = function(conversation) {
  __privateGet(this, _bus).emit(
    "twilio:client:conversationRemoved",
    {
      local: true
    },
    conversation
  );
  __privateMethod(this, _removeConversation, removeConversation_fn).call(this, conversation);
  tdbg("Conversation Removed:", conversation);
};
_onTwilioConversationUpdated = new WeakSet();
onTwilioConversationUpdated_fn = function(data2) {
  __privateGet(this, _bus).emit(
    "twilio:client:conversationUpdated",
    {
      local: true
    },
    data2
  );
  __privateMethod(this, _updateConversation, updateConversation_fn).call(this, data2.conversation);
  tdbg("Conversation Updated:", data2);
};
_onTwilioMessageAdded = new WeakSet();
onTwilioMessageAdded_fn = function(message) {
  __privateGet(this, _bus).emit(
    "twilio:client:messageAdded",
    {
      local: true
    },
    message
  );
  tdbg("Message Added:", message);
};
_onTwilioMessageRemoved = new WeakSet();
onTwilioMessageRemoved_fn = function(message) {
  __privateGet(this, _bus).emit(
    "twilio:client:messageRemoved",
    {
      local: true
    },
    message
  );
  tdbg("Message Removed:", message);
};
_onTwilioMessageUpdated = new WeakSet();
onTwilioMessageUpdated_fn = function(data2) {
  __privateGet(this, _bus).emit(
    "twilio:client:messageUpdated",
    {
      local: true
    },
    data2
  );
  tdbg("Message Updated:", data2);
};
_onTwilioParticipantJoined = new WeakSet();
onTwilioParticipantJoined_fn = function(participant) {
  __privateGet(this, _bus).emit(
    "twilio:client:participantJoined",
    {
      local: true
    },
    participant
  );
  tdbg("Participant Joined:", participant);
};
_onTwilioParticipantLeft = new WeakSet();
onTwilioParticipantLeft_fn = function(participant) {
  __privateGet(this, _bus).emit(
    "twilio:client:participantLeft",
    {
      local: true
    },
    participant
  );
  tdbg("Participant Left:", participant);
};
_onTwilioParticipantUpdated = new WeakSet();
onTwilioParticipantUpdated_fn = function(data2) {
  __privateGet(this, _bus).emit(
    "twilio:client:participantUpdated",
    {
      local: true
    },
    data2
  );
  tdbg("Participant Updated:", data2);
};
_onTwilioPushNotification = new WeakSet();
onTwilioPushNotification_fn = function(pushNotification) {
  __privateGet(this, _bus).emit(
    "twilio:client:pushNotification",
    {
      local: true
    },
    pushNotification
  );
  tdbg("Push Notification:", pushNotification);
};
_onTwilioTokenAboutToExpire = new WeakSet();
onTwilioTokenAboutToExpire_fn = function() {
  tdbg("Token About to Expire. Making token refreshable.");
  __privateGet(this, _identity).$makeRefreshable();
};
_onTwilioTokenExpired = new WeakSet();
onTwilioTokenExpired_fn = function() {
  tdbg("Token Expired. Logging out.");
  __privateGet(this, _bus).emit("twilio:client:tokenExpired", {
    local: true
  });
  __privateGet(this, _identity).logout();
};
_onTwilioTypingEnded = new WeakSet();
onTwilioTypingEnded_fn = function(participant) {
  __privateGet(this, _bus).emit("twilio:client:typingEnded", { local: true }, participant);
  __privateGet(this, _typing).value[participant.sid] = false;
};
_onTwilioTypingStarted = new WeakSet();
onTwilioTypingStarted_fn = function(participant) {
  __privateGet(this, _bus).emit("twilio:client:typingStarted", { local: true }, participant);
  __privateGet(this, _typing).value[participant.sid] = true;
};
_onTwilioUserSubscribed = new WeakSet();
onTwilioUserSubscribed_fn = function(user) {
  __privateGet(this, _bus).emit("twilio:client:userSubscribed", { local: true }, user);
};
_onTwilioUserUnsubscribed = new WeakSet();
onTwilioUserUnsubscribed_fn = function(user) {
  __privateGet(this, _bus).emit("twilio:client:userUnsubscribed", { local: true }, user);
};
_onTwilioUserUpdated = new WeakSet();
onTwilioUserUpdated_fn = function(data2) {
  __privateGet(this, _bus).emit("twilio:client:userUpdated", { local: true }, data2);
};
_getCacheStorage = new WeakSet();
getCacheStorage_fn = async function() {
  if (!__privateGet(this, _identity) || !__privateGet(this, _identity).authenticated.value) {
    return void 0;
  }
  const cacheName = "m-twilio-rosters";
  let cacheStorage;
  if (window && window.caches) {
    try {
      cacheStorage = await window.caches.open(cacheName);
    } catch {
    }
  }
  return cacheStorage;
};
_getRosterFromCache = new WeakSet();
getRosterFromCache_fn = async function() {
  const cacheStorage = await __privateMethod(this, _getCacheStorage, getCacheStorage_fn).call(this);
  if (!cacheStorage) {
    return [];
  }
  const uri = "/" + ["identity", __privateGet(this, _identity).user.value.id].join("/");
  let fromCache;
  try {
    fromCache = await cacheStorage.match(uri);
  } catch {
  }
  if (fromCache && fromCache.ok) {
    const results = await fromCache.json();
    return results;
  }
  return [];
};
_saveRosterToCache = new WeakSet();
saveRosterToCache_fn = async function(roster) {
  const cacheStorage = await __privateMethod(this, _getCacheStorage, getCacheStorage_fn).call(this);
  if (!cacheStorage) {
    return;
  }
  const uri = "/" + ["identity", __privateGet(this, _identity).user.value.id].join("/");
  try {
    await cacheStorage.put(uri, new Response(JSON.stringify(roster)));
  } catch {
  }
};
_getRosterFromApi = new WeakSet();
getRosterFromApi_fn = async function() {
  if (__privateGet(this, _rosterUpdateAbortController)) {
    __privateGet(this, _rosterUpdateAbortController).abort();
  }
  __privateSet(this, _rosterUpdateAbortController, new AbortController());
  let apiResponse;
  try {
    apiResponse = await __privateGet(this, _http).get(
      "/roster",
      {
        signal: __privateGet(this, _rosterUpdateAbortController).signal
      }
    );
  } catch (error2) {
    return [];
  }
  if (!apiResponse) {
    return [];
  }
  const { status, data: data2 } = apiResponse;
  if (200 === status && data2 && isApiResponse(data2)) {
    const ret = await Promise.all(
      data2.data.map(async (item) => {
        var _a;
        try {
          const u = await ((_a = __privateGet(this, _client).value) == null ? void 0 : _a.getUser(item.identifier)) ?? {};
          return {
            ...item,
            ...u
          };
        } catch (error2) {
          return {
            ...item,
            state: {
              online: null
            }
          };
        }
      })
    );
    return ret.filter((i) => i);
  } else {
    return [];
  }
};
_getConversationsFromSdk = new WeakSet();
getConversationsFromSdk_fn = async function() {
  if (!__privateGet(this, _client).value) {
    return;
  }
  let paginatedConversations = await __privateGet(this, _client).value.getSubscribedConversations();
  paginatedConversations.items.forEach((c) => {
    __privateMethod(this, _addConversation, addConversation_fn).call(this, c);
  });
  while (paginatedConversations.hasNextPage) {
    paginatedConversations = await paginatedConversations.nextPage();
    paginatedConversations.items.forEach((c) => {
      __privateMethod(this, _addConversation, addConversation_fn).call(this, c);
    });
  }
};
_addConversation = new WeakSet();
addConversation_fn = function(conversation) {
  const exists = __privateGet(this, _conversations).value.find(
    (c) => c.sid === conversation.sid
  );
  if (!exists) {
    conversation.touchedAt = DateTime.now();
    conversation.checksum = __privateMethod(this, _conversationToChecksum, conversationToChecksum_fn).call(this, conversation);
    __privateGet(this, _conversations).value.push(conversation);
    __privateMethod(this, _onAfterConversationsListUpdated, onAfterConversationsListUpdated_fn).call(this);
  } else {
    triggerRef(__privateGet(this, _conversations));
  }
};
_removeConversation = new WeakSet();
removeConversation_fn = function(conversation) {
  const idx = __privateGet(this, _conversations).value.findIndex(
    (c) => c.sid === conversation.sid
  );
  if (-1 !== idx) {
    __privateGet(this, _conversations).value.splice(idx, 1);
    __privateMethod(this, _onAfterConversationsListUpdated, onAfterConversationsListUpdated_fn).call(this);
  } else {
    triggerRef(__privateGet(this, _conversations));
  }
};
_updateConversation = new WeakSet();
updateConversation_fn = function(conversation) {
  const idx = __privateGet(this, _conversations).value.findIndex(
    (c) => c.sid === conversation.sid
  );
  if (-1 !== idx) {
    conversation.touchedAt = DateTime.now();
    conversation.checksum = __privateMethod(this, _conversationToChecksum, conversationToChecksum_fn).call(this, conversation);
    __privateGet(this, _conversations).value.splice(
      idx,
      1,
      conversation
    );
    __privateMethod(this, _onAfterConversationsListUpdated, onAfterConversationsListUpdated_fn).call(this);
  } else {
    triggerRef(__privateGet(this, _conversations));
  }
};
_conversationToChecksum = new WeakSet();
conversationToChecksum_fn = function(conversation) {
  return toChecksum(
    [
      conversation.sid,
      conversation.dateUpdated,
      conversation.touchedAt.toISO()
    ].join("|")
  );
};
_onPushFirebaseMessage = new WeakSet();
onPushFirebaseMessage_fn = function(payload) {
  if (__privateGet(this, _client).value) {
    tdbg("Handling Firebase Push Notification");
    __privateGet(this, _client).value.handlePushNotification(payload).catch(() => {
    });
  }
};
_onAfterConversationsListUpdated = new WeakSet();
onAfterConversationsListUpdated_fn = function() {
  triggerRef(__privateGet(this, _conversations));
  nextTick(() => {
    __privateGet(this, _bus).emit(
      "twilio:adapter:conversations:updated",
      {
        local: true
      },
      this.conversations.value
    );
  });
};
let MalarkeyTwilioAdapter = _MalarkeyTwilioAdapter;
const getDisplayNameOfParticipant = (p) => {
  let ret;
  if (instance.value && p) {
    const rosterItem = instance.value.roster.value.find(
      (r) => "undefined" !== typeof r && r.identifier === p.identity
    );
    if (rosterItem) {
      ret = stringOr(
        rosterItem.name || void 0,
        stringOr(
          rosterItem.friendlyName || void 0,
          stringOr(rosterItem.identifier || void 0)
        )
      );
    }
    if ("string" !== typeof ret && "undefined" !== typeof p && "string" === typeof p.identity) {
      ret = instance.value.getParticipantDisplayNameFromCache(p);
    }
  }
  if ("string" !== typeof ret && "undefined" !== typeof p && "string" === typeof p.identity) {
    ret = p.identity;
  }
  return ret;
};
const makeConversationName = (conversation) => {
  const isGroupChat = conversation._participants.size > 2;
  const nonUserParticipants = [...conversation._participants.values()].filter(
    (p) => {
      var _a, _b;
      return p.identity !== ((_b = (_a = instance.value) == null ? void 0 : _a.me.value) == null ? void 0 : _b.identity);
    }
  );
  if (isGroupChat) {
    return toSubjectListString(
      nonUserParticipants.map((p) => getDisplayNameOfParticipant(p)).filter((d) => "string" === typeof d)
    );
  } else {
    return getDisplayNameOfParticipant(nonUserParticipants[0]);
  }
};
export {
  MalarkeyTwilioAdapter as M,
  isValidConversationFeedback as a,
  isValidIdentityFeedback as b,
  instance as c,
  getDisplayNameOfParticipant as g,
  isApiResponse as i,
  makeConversationName as m
};
//# sourceMappingURL=malarkeyTwilioAdapter-1c296255.mjs.map
